/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		72: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "static/js/" + ({}[chunkId]||chunkId) + "." + {"0":"66a2648f","1":"1bcaec10","2":"c18497b2","3":"58e94989","4":"e8fb4259","5":"81c142d8","6":"df61e264","7":"b2d9f0ca","8":"a18fc7a0","9":"a2f1e731","10":"7ba5ae7d","11":"4f890018","12":"424e7f4f","13":"53488ded","14":"912424b3","15":"4f2b35d3","16":"3efe7d8a","17":"5634c3b3","18":"7706a8fb","19":"5526cb28","20":"03cbc47c","21":"0317e3af","22":"6f5c7663","23":"bcef3a1e","24":"eb3634b8","25":"c111dc52","26":"76a7eaa8","27":"37ba4c86","28":"87652a35","29":"9b199cd2","30":"441bccad","31":"5cb94d39","32":"906227a1","33":"bfeaa5d3","34":"d1ff0724","35":"6b03b39f","36":"aa90cbef","37":"01aa7b86","38":"565e3788","39":"78257ca3","40":"80b1aafd","41":"a9c3d301","42":"d68a7ae7","43":"4899bc47","44":"575f875c","45":"8542348b","46":"bf29b97e","47":"0bd3a5e4","48":"d6780695","49":"e410f102","50":"40cc0c7f","51":"e692d3f6","52":"34b06859","53":"68bd8880","54":"16bd1952","55":"dbe009e5","56":"05f2d4a9","57":"f8dba899","58":"674715cc","59":"596f23f0","60":"67a62fe6","61":"401a59a3","62":"e42ab3b7","63":"e75f2cbd","64":"e7572e7d","65":"2684715c","66":"a1d03c4c","67":"03a595d8","68":"cf7d4db6","69":"835f6286","70":"96a9787f","71":"6618ea32"}[chunkId] + ".chunk.js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 338);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(35);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export constants */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return mpdConstant; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return nozzelConstant; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return productConstant; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return tankConstant; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return stockInConstant; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return invoiceConstant; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return userConstant; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return shiftConstant; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return employeeConstant; });
/* unused harmony export employeeAdvanceConstant */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return creditorConstant; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return productRateConstant; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return expenditureCatagoryConstant; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return transactionAccountConstant; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return paymentModeConstant; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return swipeMachineConstant; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return notificationConstant; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return creditDetailConstant; });
var constants = {
    mpdConstant: {
        CREAT_MPD: "CREAT_MPD",
        MPD_CREATED: "MPD_CREATED",
        MPD_CREATION_FAILED: "MPD_CREATION_FAILED",

        MPD_FETCHED_ALL_WITH_PRODUCT: " MPD_FETCHED_ALL_WITH_PRODUCT",
        MPD_FETCHED_FAILED: "MPD_FETCH_FAILED",
        MPD_FETCHED_ALL: "FETCHED_ALL_MPD",
        MPD_STORE_CHANGE: "MPD_STORE_CHANGE"
    },
    nozzelConstant: {
        CREAT_NOZZEL: "CREAT_NOZZEL",
        NOZZEL_CREATED: "NOZZEL_CREATED",
        NOZZEL_CREATION_FAILED: "NOZZEL_CREATION_FAILED",

        NOZZEL_FETCH_FAILED: "NOZZEL_FETCH_FAILED",
        NOZZEL_FETCH_ALL: "NOZZEL_FETCH_ALL",

        NOZZEL_STORE_CHANGE: "NOZZEL_STORE_CHANGE"
    },
    productConstant: {
        CREATE_PRODUCT: "CREATE_PRODUCT",
        PRODUCT_CREATED: "PRODUCT_CREATED",
        PRODUCT_CREATION_FAILED: "PRODUCT_CREATION_FAILED",

        FETCHED_ALL_PRODUCTS: "FETCHED_ALL_PRODUCTS",
        PRODUCTS_FETCH_FAILED: "PRODUCTS_FETCH_FAILED",

        PRODUCTS_STORE_CHANGE: "PRODUCTS_STORE_CHANGE"
    },
    tankConstant: {
        CREATE_TANK: "CREATE_TANK",

        TANK_CREATED: "TANK_CREATED",
        TANK_CREATION_FAILED: "TANK_CREATION_FAILED",

        FETCHED_ALL_TANKS: "FETCHED_ALL_TANKS",
        TANK_FETCH_FAILED: "TANK_FETCH_FAILED",

        TANK_STORE_CHANGE: "TANK_STORE_CHANGE",

        FETCHED_ALL_DIP_TABLE: "  FETCHED_ALL_DIP_TABLE",
        DIP_TABLE_FETCH_FAILED: " DIP_TABLE_FETCH_FAILED"

    },
    stockInConstant: {
        CREATE_STOCKIN: "CREATE_STOCKIN",

        STOCKIN_CREATED: " STOCKIN_CREATED",
        STOCKIN_CREATION_FAILED: "STOCKIN_CREATION_FAILED",

        FETCHED_ALL_STOCKIN: "FETCHED_ALL_ STOCKIN",
        STOCKIN_FETCH_FAILED: "STOCKIN_FETCH_FAILED",

        STOCKIN_STORE_CHANGE: "STOCKIN_STORE_CHANGE"
    },

    userConstant: {
        CREATE_USER: "CREATE_USER",

        USER_CREATED: "USER_CREATED",
        USER_CREATION_FAILED: "USER_CREATION_FAILED",

        FETCHED_ALL_USER: "FETCHED_ALL_USER",
        USER_FETCH_FAILED: "USER_FETCH_FAILED",

        USER_STORE_CHANGE: "USER_STORE_CHANGE"
    },
    shiftConstant: {
        CREATE_SHIFT: "CREATE_SHIFT",

        SHIFT_CREATED: "SHIFT_CREATED",
        SHIFT_CREATION_FAILED: "SHIFT_CREATION_FAILED",

        FETCHED_ALL_SHIFT: "FETCHED_ALL_SHIFT",
        SHIFT_FETCH_FAILED: "SHIFT_FETCH_FAILED",

        SHIFT_STORE_CHANGE: "SHIFT_STORE_CHANGE",

        NEW_SHIFT_STARTED: "NEW_SHIFT_STARTED",
        NEW_SHIFT_FAILED: "NEW_SHIFT_FAILED"
    },
    employeeConstant: {
        CREATE_EMPLOYEE: "CREATE_EMPLOYEE",

        EMPLOYEE_CREATED: "EMPLOYEE_CREATED",
        EMPLOYEE_CREATION_FAILED: "EMPLOYEE_CREATION_FAILED",

        FETCHED_ALL_EMPLOYEE: "FETCHED_ALL_EMPLOYEE",
        EMPLOYEE_FETCH_FAILED: "EMPLOYEE_FETCH_FAILED",

        EMPLOYEE_STORE_CHANGE: "EMPLOYEE_STORE_CHANGE"
    },
    employeeAdvanceConstant: {
        CREATE_EMPLOYEE_ADVANCE: "CREATE_EMPLOYEE_ADVANCE",

        EMPLOYEE_ADVANCE_CREATED: "EMPLOYEE_ADVANCE_CREATED",
        EMPLOYEE_ADVANCE_CREATION_FAILED: "EMPLOYEE_ADVANCE_CREATION_FAILED",

        FETCHED_ALL_EMPLOYEE_ADVANCE: "FETCHED_ALL_EMPLOYEE_ADVANCE",
        EMPLOYEE_ADVANCE_FETCH_FAILED: "EMPLOYEE_ADVANCE_FETCH_FAILED",

        EMPLOYEE_ADVANCE_STORE_CHANGE: "EMPLOYEE_ADVANCE_STORE_CHANGE"
    },

    invoiceConstant: {
        INVOICE_CREATED: "INVOICE_CREATED",
        INVOICE_CREATION_FAILED: "INVOICE_CREATION_FAILED"
    },
    creditorConstant: {
        CREATE_CREDITOR: "CREATE_CREDITOR",

        CREDITOR_CREATED: "CREDITOR_CREATED",
        CREDITOR_CREATION_FAILED: "CREDITOR_CREATION_FAILED",

        FETCHED_ALL_CREDITOR: "FETCHED_ALL_CREDITOR",
        CREDITOR_FETCH_FAILED: "CREDITOR_FETCH_FAILED",

        CREDITOR_STORE_CHANGE: "CREDITOR_STORE_CHANGE",

        UPDATE_CREDITOR: "UPDATE_CREDITOR",
        UPDATE_CREDITOR_CREATION_FAILED: "UPDATE_CREDITOR_CREATION_FAILED"

    },
    productRateConstant: {
        CREATE_PRODUCTRATE: "CREATE_PRODUCTRATE",

        PRODUCTRATE_CREATED: "PRODUCTRATEPRODUCTRATE_CREATED",
        PRODUCTRATE_CREATION_FAILED: "PRODUCTRATE_CREATION_FAILED",

        FETCHED_ALL_PRODUCTRATE: "FETCHED_ALL_PRODUCTRATE",
        PRODUCTRATE_FETCH_FAILED: "PRODUCTRATE_FETCH_FAILED",

        PRODUCTRATE_STORE_CHANGE: "PRODUCTRATE_STORE_CHANGE"
    },

    expenditureCatagoryConstant: {
        CREATE_EXPENDITURECATAGORY: "CREATE_EXPENDITURECATAGORY",

        EXPENDITURECATAGORY_CREATED: "EXPENDITURECATAGORY_CREATED",
        EXPENDITURECATAGORY_CREATION_FAILED: "EXPENDITURECATAGORY_CREATION_FAILED",

        FETCHED_ALL_EXPENDITURECATAGORY: "FETCHED_ALL_EXPENDITURECATAGORY",
        EXPENDITURECATAGORY_FETCH_FAILED: "EXPENDITURECATAGORY_FETCH_FAILED",

        EXPENDITURECATAGORY_STORE_CHANGE: "EXPENDITURECATAGORY_STORE_CHANGE"

    },

    transactionAccountConstant: {
        CREATE_TRANSACTIONACCOUNT: "CREATE_TRANSACTIONACCOUNT",

        TRANSACTIONACCOUNT_CREATED: "TRANSACTIONACCOUNT_CREATED",
        TRANSACTIONACCOUNT_CREATION_FAILED: "TRANSACTIONACCOUNT_CREATION_FAILED",

        FETCHED_ALL_TRANSACTIONACCOUNT: "FETCHED_ALL_TRANSACTIONACCOUNT",
        FETCHED_ALL_TRANSACTION_PAYMENT: "FETCHED_ALL_TRANSACTION_PAYMENT",
        TRANSACTIONACCOUNT_FETCH_FAILED: "TRANSACTIONACCOUNT_FETCH_FAILED",

        TRANSACTIONACCOUNT_STORE_CHANGE: "TRANSACTIONACCOUNT_STORE_CHANGE"
    },

    paymentModeConstant: {
        CREATE_PAYMENTMODE: "CREATE_ PAYMENTMODE",

        PAYMENTMODE_CREATED: " PAYMENTMODE_CREATED",
        PAYMENTMODE_CREATION_FAILED: " PAYMENTMODE_CREATION_FAILED",

        FETCHED_ALL_PAYMENTMODE: "FETCHED_ALL_ PAYMENTMODE",
        PAYMENTMODE_FETCH_FAILED: " PAYMENTMODE_FETCH_FAILED",

        PAYMENTMODE_STORE_CHANGE: " PAYMENTMODE_STORE_CHANGE"
    },
    swipeMachineConstant: {
        CREATE_SWIPEMACHINE: "CREATE_ SWIPEMACHINE",
        SWIPEMACHINE_CREATED: " SWIPEMACHINE_CREATED",
        SWIPEMACHINE_CREATION_FAILED: " SWIPEMACHINE_CREATION_FAILED",
        FETCHED_ALL_SWIPEMACHINE: "FETCHED_ALL_SWIPEMACHINE",
        SWIPEMACHINE_FETCH_FAILED: "SWIPEMACHINE_FETCH_FAILED",
        SWIPEMACHINEE_STORE_CHANGE: "SWIPEMACHINE_STORE_CHANGE"
    },
    notificationConstant: {
        FETCHED_ALL_NOTIFICATION: "FETCHED_ALL_NOTIFICATION",
        NOTIFICATION_FETCH_FAILED: "NOTIFICATION_FETCH_FAILED"
    },
    creditDetailConstant: {
        CREAT_CREDITDETAIL: "CREAT_CREDITDETAIL",
        CREDITDETAIL_CREATED: "CREDITDETAIL_CREATED",
        CREDITDETAIL_CREATION_FAILED: "CREDITDETAIL_CREATION_FAILED",

        CREDITDETAIL_FETCH_FAILED: "CREDITDETAIL_FETCH_FAILED",
        CREDITDETAIL_FETCH_ALL: "CREDITDETAIL_FETCH_ALL",

        CREDITDETAIL_STORE_CHANGE: "CREDITDETAIL_STORE_CHANGE"
    }

};

var mpdConstant = constants.mpdConstant;
var nozzelConstant = constants.nozzelConstant;
var productConstant = constants.productConstant;
var tankConstant = constants.tankConstant;
var stockInConstant = constants.stockInConstant;
var invoiceConstant = constants.invoiceConstant;
var userConstant = constants.userConstant;
var shiftConstant = constants.shiftConstant;
var employeeConstant = constants.employeeConstant;
var employeeAdvanceConstant = constants.employeeAdvance;
var creditorConstant = constants.creditorConstant;
var productRateConstant = constants.productRateConstant;
var expenditureCatagoryConstant = constants.expenditureCatagoryConstant;
var transactionAccountConstant = constants.transactionAccountConstant;
var paymentModeConstant = constants.paymentModeConstant;
var swipeMachineConstant = constants.swipeMachineConstant;
var notificationConstant = constants.notificationConstant;
var creditDetailConstant = constants.creditDetailConstant;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyFunction = __webpack_require__(13);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  (function () {
    var printWarning = function printWarning(format) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var argIndex = 0;
      var message = 'Warning: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    };

    warning = function warning(condition, format) {
      if (format === undefined) {
        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
      }

      if (format.indexOf('Failed Composite propType: ') === 0) {
        return; // Ignore CompositeComponent proptype check.
      }

      if (!condition) {
        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
          args[_key2 - 2] = arguments[_key2];
        }

        printWarning.apply(undefined, [format].concat(args));
      }
    };
  })();
}

module.exports = warning;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_flux__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_flux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_flux__);


/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_flux__["Dispatcher"]());

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_auth_store_jsx__ = __webpack_require__(39);


function getJsonData(url) {
    return new Promise(function (resolve, reject) {
        var token = __WEBPACK_IMPORTED_MODULE_0__store_auth_store_jsx__["a" /* default */].getFormatedToken();
        fetch(url, {
            method: "GET",
            headers: {
                auth: token
            }
        }).then(function (res) {
            var contentType = res.headers.get("content-type");
            if (contentType && contentType.indexOf("application/json") !== -1) {
                contentType = "application/json; charset=utf-8";
            }

            if (res.ok) {
                switch (contentType) {
                    case "application/json; charset=utf-8":
                        res.json().then(function (data) {
                            return resolve(data);
                        });
                        break;
                    default:
                        res.text().then(function (data) {
                            return resolve(data);
                        });
                }
            } else {
                switch (contentType) {
                    case "application/json; charset=utf-8":
                        res.json().then(function (data) {
                            return reject(data);
                        });
                        break;
                    default:
                        res.text().then(function (data) {
                            return reject(data);
                        });
                }
            }
        });
    });
}

function postJson(url, data) {
    return new Promise(function (resolve, reject) {
        var token = __WEBPACK_IMPORTED_MODULE_0__store_auth_store_jsx__["a" /* default */].getFormatedToken();
        fetch(url, { method: "POST", headers: { "Content-Type": "application/json", auth: token }, body: JSON.stringify(data) }).then(function (res) {
            var contentType = res.headers.get("content-type");
            if (contentType && contentType.indexOf("application/json") !== -1) {
                contentType = "application/json; charset=utf-8";
            }

            if (res.ok) {
                switch (contentType) {
                    case "application/json; charset=utf-8":
                        res.json().then(function (data) {
                            return resolve(data);
                        });
                        break;
                    case "application/pdf":
                        res.blob().then(function (data) {
                            return resolve(data);
                        });
                        break;
                    default:
                        res.text().then(function (data) {
                            return resolve(data);
                        });
                }
            } else {
                switch (contentType) {
                    case "application/json; charset=utf-8":
                        res.json().then(function (data) {
                            return reject(data);
                        });
                        break;
                    default:
                        res.text().then(function (data) {
                            return reject(data);
                        });
                }
            }
        });
    });
}

function post(url, data) {
    return new Promise(function (resolve, reject) {
        var token = __WEBPACK_IMPORTED_MODULE_0__store_auth_store_jsx__["a" /* default */].getFormatedToken();
        fetch(url, { method: "POST", headers: { "content-type": "application/x-www-form-urlencoded", auth: token }, body: objectToKeyValue(data) }).then(function (res) {
            var contentType = res.headers.get("content-type");
            if (contentType && contentType.indexOf("application/json") !== -1) {
                contentType = "application/json; charset=utf-8";
            }

            if (res.ok) {
                switch (contentType) {
                    case "application/json; charset=utf-8":
                        res.json().then(function (data) {
                            return resolve(data);
                        });
                        break;
                    default:
                        res.text().then(function (data) {
                            return resolve(data);
                        });
                }
            } else {
                switch (contentType) {
                    case "application/json; charset=utf-8":
                        res.json().then(function (data) {
                            return reject(data);
                        });
                        break;
                    default:
                        res.text().then(function (data) {
                            return reject(data);
                        });
                }
            }
        });
    });
}

function objectToKeyValue(obj) {
    var str = "";

    for (var prop in obj) {
        if (obj[prop] !== null && obj[prop] !== undefined) {
            str += prop + "=" + obj[prop].toString() + "&";
        }
    }
    return str.substring(0, str.lastIndexOf("&"));
}

function putJson(url, data) {
    return new Promise(function (resolve, reject) {
        var token = __WEBPACK_IMPORTED_MODULE_0__store_auth_store_jsx__["a" /* default */].getFormatedToken();
        fetch(url, { method: "PUT", headers: { "Content-Type": "application/json", auth: token }, body: JSON.stringify(data) }).then(function (res) {
            var contentType = res.headers.get("content-type");
            if (contentType && contentType.indexOf("application/json") !== -1) {
                contentType = "application/json; charset=utf-8";
            }

            if (res.ok) {
                switch (contentType) {
                    case "application/json; charset=utf-8":
                        res.json().then(function (data) {
                            return resolve(data);
                        });
                        break;
                    default:
                        res.text().then(function (data) {
                            return resolve(data);
                        });
                }
            } else {
                switch (contentType) {
                    case "application/json; charset=utf-8":
                        res.json().then(function (data) {
                            return reject(data);
                        });
                        break;
                    default:
                        res.text().then(function (data) {
                            return reject(data);
                        });
                }
            }
        });
    });
}

function deleteData(url) {
    return new Promise(function (resolve, reject) {
        var token = __WEBPACK_IMPORTED_MODULE_0__store_auth_store_jsx__["a" /* default */].getFormatedToken();

        fetch(url, {
            method: "DELETE",
            headers: {
                auth: token
            }
        }).then(function (res) {
            var contentType = res.headers.get("content-type");
            if (contentType && contentType.indexOf("application/json") !== -1) {
                contentType = "application/json; charset=utf-8";
            }

            if (res.ok) {
                switch (contentType) {
                    case "application/json; charset=utf-8":
                        res.json().then(function (data) {
                            return resolve(data);
                        });
                        break;
                    default:
                        res.text().then(function (data) {
                            return resolve(data);
                        });
                }
            } else {
                switch (contentType) {
                    case "application/json; charset=utf-8":
                        res.json().then(function (data) {
                            return reject(data);
                        });
                        break;
                    default:
                        res.text().then(function (data) {
                            return reject(data);
                        });
                }
            }
        });
    });
}

function deletePostData(url, data) {
    return new Promise(function (resolve, reject) {
        var token = __WEBPACK_IMPORTED_MODULE_0__store_auth_store_jsx__["a" /* default */].getFormatedToken();
        fetch(url, { method: "DELETE", headers: { "content-type": "application/x-www-form-urlencoded", auth: token }, body: objectToKeyValue(data) }).then(function (res) {

            var contentType = res.headers.get("content-type");
            if (contentType && contentType.indexOf("application/json") !== -1) {
                contentType = "application/json; charset=utf-8";
            }

            if (res.ok) {
                switch (contentType) {
                    case "application/json; charset=utf-8":
                        res.json().then(function (data) {
                            return resolve(data);
                        });
                        break;
                    default:
                        res.text().then(function (data) {
                            return resolve(data);
                        });
                }
            } else {
                switch (contentType) {
                    case "application/json; charset=utf-8":
                        res.json().then(function (data) {
                            return reject(data);
                        });
                        break;
                    default:
                        res.text().then(function (data) {
                            return reject(data);
                        });
                }
            }
        });
    });
}

var rq = {
    getJsonData: getJsonData,
    postJson: postJson,
    post: post,
    putJson: putJson,
    deleteData: deleteData,
    deletePostData: deletePostData
};

/* harmony default export */ __webpack_exports__["a"] = (rq);

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(4);

var DOMProperty = __webpack_require__(32);
var ReactDOMComponentFlags = __webpack_require__(111);

var invariant = __webpack_require__(1);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var Flags = ReactDOMComponentFlags;

var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);

/**
 * Check if a given node should be cached.
 */
function shouldPrecacheNode(node, nodeID) {
  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
}

/**
 * Drill down (through composites and empty components) until we get a host or
 * host text component.
 *
 * This is pretty polymorphic but unavoidable with the current structure we have
 * for `_renderedChildren`.
 */
function getRenderedHostOrTextFromComponent(component) {
  var rendered;
  while (rendered = component._renderedComponent) {
    component = rendered;
  }
  return component;
}

/**
 * Populate `_hostNode` on the rendered host/text component with the given
 * DOM node. The passed `inst` can be a composite.
 */
function precacheNode(inst, node) {
  var hostInst = getRenderedHostOrTextFromComponent(inst);
  hostInst._hostNode = node;
  node[internalInstanceKey] = hostInst;
}

function uncacheNode(inst) {
  var node = inst._hostNode;
  if (node) {
    delete node[internalInstanceKey];
    inst._hostNode = null;
  }
}

/**
 * Populate `_hostNode` on each child of `inst`, assuming that the children
 * match up with the DOM (element) children of `node`.
 *
 * We cache entire levels at once to avoid an n^2 problem where we access the
 * children of a node sequentially and have to walk from the start to our target
 * node every time.
 *
 * Since we update `_renderedChildren` and the actual DOM at (slightly)
 * different times, we could race here and see a newer `_renderedChildren` than
 * the DOM nodes we see. To avoid this, ReactMultiChild calls
 * `prepareToManageChildren` before we change `_renderedChildren`, at which
 * time the container's child nodes are always cached (until it unmounts).
 */
function precacheChildNodes(inst, node) {
  if (inst._flags & Flags.hasCachedChildNodes) {
    return;
  }
  var children = inst._renderedChildren;
  var childNode = node.firstChild;
  outer: for (var name in children) {
    if (!children.hasOwnProperty(name)) {
      continue;
    }
    var childInst = children[name];
    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
    if (childID === 0) {
      // We're currently unmounting this child in ReactMultiChild; skip it.
      continue;
    }
    // We assume the child nodes are in the same order as the child instances.
    for (; childNode !== null; childNode = childNode.nextSibling) {
      if (shouldPrecacheNode(childNode, childID)) {
        precacheNode(childInst, childNode);
        continue outer;
      }
    }
    // We reached the end of the DOM children without finding an ID match.
     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
  }
  inst._flags |= Flags.hasCachedChildNodes;
}

/**
 * Given a DOM node, return the closest ReactDOMComponent or
 * ReactDOMTextComponent instance ancestor.
 */
function getClosestInstanceFromNode(node) {
  if (node[internalInstanceKey]) {
    return node[internalInstanceKey];
  }

  // Walk up the tree until we find an ancestor whose instance we have cached.
  var parents = [];
  while (!node[internalInstanceKey]) {
    parents.push(node);
    if (node.parentNode) {
      node = node.parentNode;
    } else {
      // Top of the tree. This node must not be part of a React tree (or is
      // unmounted, potentially).
      return null;
    }
  }

  var closest;
  var inst;
  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
    closest = inst;
    if (parents.length) {
      precacheChildNodes(inst, node);
    }
  }

  return closest;
}

/**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */
function getInstanceFromNode(node) {
  var inst = getClosestInstanceFromNode(node);
  if (inst != null && inst._hostNode === node) {
    return inst;
  } else {
    return null;
  }
}

/**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */
function getNodeFromInstance(inst) {
  // Without this first invariant, passing a non-DOM-component triggers the next
  // invariant for a missing parent, which is super confusing.
  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  if (inst._hostNode) {
    return inst._hostNode;
  }

  // Walk up the tree until we find an ancestor whose DOM node we have cached.
  var parents = [];
  while (!inst._hostNode) {
    parents.push(inst);
    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
    inst = inst._hostParent;
  }

  // Now parents contains each ancestor that does *not* have a cached native
  // node, and `inst` is the deepest ancestor that does.
  for (; parents.length; inst = parents.pop()) {
    precacheChildNodes(inst, inst._hostNode);
  }

  return inst._hostNode;
}

var ReactDOMComponentTree = {
  getClosestInstanceFromNode: getClosestInstanceFromNode,
  getInstanceFromNode: getInstanceFromNode,
  getNodeFromInstance: getNodeFromInstance,
  precacheChildNodes: precacheChildNodes,
  precacheNode: precacheNode,
  uncacheNode: uncacheNode
};

module.exports = ReactDOMComponentTree;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = routerWarning;
exports._resetWarned = _resetWarned;

var _warning = __webpack_require__(153);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var warned = {};

function routerWarning(falseToWarn, message) {
  // Only issue deprecation warnings once.
  if (message.indexOf('deprecated') !== -1) {
    if (warned[message]) {
      return;
    }

    warned[message] = true;
  }

  message = '[react-router] ' + message;

  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
}

function _resetWarned() {
  warned = {};
}

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 11 */
/***/ (function(module, exports) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function(type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener))
      return 1;
    else if (evlistener)
      return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function(emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// Trust the developer to only use ReactInstrumentation with a __DEV__ check

var debugTool = null;

if (false) {
  var ReactDebugTool = require('./ReactDebugTool');
  debugTool = ReactDebugTool;
}

module.exports = { debugTool: debugTool };

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(4),
    _assign = __webpack_require__(7);

var CallbackQueue = __webpack_require__(109);
var PooledClass = __webpack_require__(24);
var ReactFeatureFlags = __webpack_require__(114);
var ReactReconciler = __webpack_require__(33);
var Transaction = __webpack_require__(51);

var invariant = __webpack_require__(1);

var dirtyComponents = [];
var updateBatchNumber = 0;
var asapCallbackQueue = CallbackQueue.getPooled();
var asapEnqueued = false;

var batchingStrategy = null;

function ensureInjected() {
  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
}

var NESTED_UPDATES = {
  initialize: function () {
    this.dirtyComponentsLength = dirtyComponents.length;
  },
  close: function () {
    if (this.dirtyComponentsLength !== dirtyComponents.length) {
      // Additional updates were enqueued by componentDidUpdate handlers or
      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
      // these new updates so that if A's componentDidUpdate calls setState on
      // B, B will update before the callback A's updater provided when calling
      // setState.
      dirtyComponents.splice(0, this.dirtyComponentsLength);
      flushBatchedUpdates();
    } else {
      dirtyComponents.length = 0;
    }
  }
};

var UPDATE_QUEUEING = {
  initialize: function () {
    this.callbackQueue.reset();
  },
  close: function () {
    this.callbackQueue.notifyAll();
  }
};

var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];

function ReactUpdatesFlushTransaction() {
  this.reinitializeTransaction();
  this.dirtyComponentsLength = null;
  this.callbackQueue = CallbackQueue.getPooled();
  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */true);
}

_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  destructor: function () {
    this.dirtyComponentsLength = null;
    CallbackQueue.release(this.callbackQueue);
    this.callbackQueue = null;
    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
    this.reconcileTransaction = null;
  },

  perform: function (method, scope, a) {
    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
    // with this transaction's wrappers around it.
    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
  }
});

PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);

function batchedUpdates(callback, a, b, c, d, e) {
  ensureInjected();
  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
}

/**
 * Array comparator for ReactComponents by mount ordering.
 *
 * @param {ReactComponent} c1 first component you're comparing
 * @param {ReactComponent} c2 second component you're comparing
 * @return {number} Return value usable by Array.prototype.sort().
 */
function mountOrderComparator(c1, c2) {
  return c1._mountOrder - c2._mountOrder;
}

function runBatchedUpdates(transaction) {
  var len = transaction.dirtyComponentsLength;
  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;

  // Since reconciling a component higher in the owner hierarchy usually (not
  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
  // them before their children by sorting the array.
  dirtyComponents.sort(mountOrderComparator);

  // Any updates enqueued while reconciling must be performed after this entire
  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
  // C, B could update twice in a single batch if C's render enqueues an update
  // to B (since B would have already updated, we should skip it, and the only
  // way we can know to do so is by checking the batch counter).
  updateBatchNumber++;

  for (var i = 0; i < len; i++) {
    // If a component is unmounted before pending changes apply, it will still
    // be here, but we assume that it has cleared its _pendingCallbacks and
    // that performUpdateIfNecessary is a noop.
    var component = dirtyComponents[i];

    // If performUpdateIfNecessary happens to enqueue any new updates, we
    // shouldn't execute the callbacks until the next render happens, so
    // stash the callbacks first
    var callbacks = component._pendingCallbacks;
    component._pendingCallbacks = null;

    var markerName;
    if (ReactFeatureFlags.logTopLevelRenders) {
      var namedComponent = component;
      // Duck type TopLevelWrapper. This is probably always true.
      if (component._currentElement.type.isReactTopLevelWrapper) {
        namedComponent = component._renderedComponent;
      }
      markerName = 'React update: ' + namedComponent.getName();
      console.time(markerName);
    }

    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);

    if (markerName) {
      console.timeEnd(markerName);
    }

    if (callbacks) {
      for (var j = 0; j < callbacks.length; j++) {
        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
      }
    }
  }
}

var flushBatchedUpdates = function () {
  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
  // array and perform any updates enqueued by mount-ready handlers (i.e.,
  // componentDidUpdate) but we need to check here too in order to catch
  // updates enqueued by setState callbacks and asap calls.
  while (dirtyComponents.length || asapEnqueued) {
    if (dirtyComponents.length) {
      var transaction = ReactUpdatesFlushTransaction.getPooled();
      transaction.perform(runBatchedUpdates, null, transaction);
      ReactUpdatesFlushTransaction.release(transaction);
    }

    if (asapEnqueued) {
      asapEnqueued = false;
      var queue = asapCallbackQueue;
      asapCallbackQueue = CallbackQueue.getPooled();
      queue.notifyAll();
      CallbackQueue.release(queue);
    }
  }
};

/**
 * Mark a component as needing a rerender, adding an optional callback to a
 * list of functions which will be executed once the rerender occurs.
 */
function enqueueUpdate(component) {
  ensureInjected();

  // Various parts of our code (such as ReactCompositeComponent's
  // _renderValidatedComponent) assume that calls to render aren't nested;
  // verify that that's the case. (This is called by each top-level update
  // function, like setState, forceUpdate, etc.; creation and
  // destruction of top-level components is guarded in ReactMount.)

  if (!batchingStrategy.isBatchingUpdates) {
    batchingStrategy.batchedUpdates(enqueueUpdate, component);
    return;
  }

  dirtyComponents.push(component);
  if (component._updateBatchNumber == null) {
    component._updateBatchNumber = updateBatchNumber + 1;
  }
}

/**
 * Enqueue a callback to be run at the end of the current batching cycle. Throws
 * if no updates are currently being performed.
 */
function asap(callback, context) {
  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
  asapCallbackQueue.enqueue(callback, context);
  asapEnqueued = true;
}

var ReactUpdatesInjection = {
  injectReconcileTransaction: function (ReconcileTransaction) {
    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
  },

  injectBatchingStrategy: function (_batchingStrategy) {
    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
    batchingStrategy = _batchingStrategy;
  }
};

var ReactUpdates = {
  /**
   * React references `ReactReconcileTransaction` using this property in order
   * to allow dependency injection.
   *
   * @internal
   */
  ReactReconcileTransaction: null,

  batchedUpdates: batchedUpdates,
  enqueueUpdate: enqueueUpdate,
  flushBatchedUpdates: flushBatchedUpdates,
  injection: ReactUpdatesInjection,
  asap: asap
};

module.exports = ReactUpdates;

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var Spinner = function (_React$Component) {
    _inherits(Spinner, _React$Component);

    function Spinner() {
        _classCallCheck(this, Spinner);

        return _possibleConstructorReturn(this, (Spinner.__proto__ || Object.getPrototypeOf(Spinner)).apply(this, arguments));
    }

    _createClass(Spinner, [{
        key: "render",
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "spinner" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-cog fa-spin loader" })
            );
        }
    }]);

    return Spinner;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Spinner);

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_motion__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_motion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_motion__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var QuestionBox = function (_Component) {
    _inherits(QuestionBox, _Component);

    function QuestionBox() {
        _classCallCheck(this, QuestionBox);

        var _this = _possibleConstructorReturn(this, (QuestionBox.__proto__ || Object.getPrototypeOf(QuestionBox)).call(this));

        _this.state = {
            visible: true,
            click: ""
        };
        _this.handleYes = _this.handleYes.bind(_this);
        _this.handleNo = _this.handleNo.bind(_this);
        _this.yesBtn = null;

        return _this;
    }

    _createClass(QuestionBox, [{
        key: "componentWillMount",
        value: function componentWillMount() {
            this.internalValidate(this.props);
        }
    }, {
        key: "internalValidate",
        value: function internalValidate(props) {
            if (!props.questionMsg) {
                throw new Error("Question Box need to have a questionMsg prop that should contain quetion string");
            }
            if (!props.yesCallBack) {
                throw new Error("Question Box need to have a yesCallBack prop .");
            }

            if (!props.noCallBack) {
                throw new Error("Question Box need to have a noCallBack prop .");
            }
        }
    }, {
        key: "handleYes",
        value: function handleYes() {
            //this.props.yesCallBack();
            this.setState({ visible: false, click: "yes" });
        }
    }, {
        key: "handleNo",
        value: function handleNo() {
            //this.props.noCallBack();
            this.setState({ visible: false, click: "no" });
        }
    }, {
        key: "handleRest",
        value: function handleRest() {

            if (this.state.click === "yes") {
                this.props.yesCallBack();
                return;
            }

            if (this.state.click === "no") {
                this.props.noCallBack();
            }
        }
    }, {
        key: "componentDidMount",
        value: function componentDidMount() {
            this.yesBtn.focus();
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_motion__["Motion"],
                { defaultStyle: { x: 0 }, style: { x: this.state.visible ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_motion__["spring"])(1, __WEBPACK_IMPORTED_MODULE_1_react_motion__["presets"].stiff) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_motion__["spring"])(0, { stiffness: 210, damping: 20, precision: 1 }) }, onRest: this.handleRest.bind(this) },
                function (_ref) {
                    var x = _ref.x;


                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { id: "questionBoxContainer" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "div",
                            { id: "questionBox", style: { opacity: x, transform: "scale(" + x + ")" } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "bar" }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "div",
                                { className: "questionMsg" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-question-circle-o questionIcon", "aria-hidden": "true" }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "p",
                                    { className: "msg" },
                                    _this2.props.questionMsg
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "div",
                                { className: "pp" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "button",
                                    { className: "btn btnOk", onClick: _this2.handleYes, ref: function ref(yesBtn) {
                                            return _this2.yesBtn = yesBtn;
                                        } },
                                    "Yes"
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "button",
                                    { className: "btn btnOk", onClick: _this2.handleNo },
                                    "No"
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "audio",
                            { autoPlay: "autoplay" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("source", { src: "/chord.wav", type: "audio/wav" })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "overlay", onClick: _this2.handleNo })
                    );
                }
            );
        }
    }]);

    return QuestionBox;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (QuestionBox);

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(7);

var PooledClass = __webpack_require__(24);

var emptyFunction = __webpack_require__(13);
var warning = __webpack_require__(3);

var didWarnForAddedNewProperty = false;
var isProxySupported = typeof Proxy === 'function';

var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var EventInterface = {
  type: null,
  target: null,
  // currentTarget is set when dispatching; no use in copying it here
  currentTarget: emptyFunction.thatReturnsNull,
  eventPhase: null,
  bubbles: null,
  cancelable: null,
  timeStamp: function (event) {
    return event.timeStamp || Date.now();
  },
  defaultPrevented: null,
  isTrusted: null
};

/**
 * Synthetic events are dispatched by event plugins, typically in response to a
 * top-level event delegation handler.
 *
 * These systems should generally use pooling to reduce the frequency of garbage
 * collection. The system should check `isPersistent` to determine whether the
 * event should be released into the pool after being dispatched. Users that
 * need a persisted event should invoke `persist`.
 *
 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
 * normalizing browser quirks. Subclasses do not necessarily have to implement a
 * DOM interface; custom application-specific events can also subclass this.
 *
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {*} targetInst Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @param {DOMEventTarget} nativeEventTarget Target node.
 */
function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
  if (false) {
    // these have a getter/setter for warnings
    delete this.nativeEvent;
    delete this.preventDefault;
    delete this.stopPropagation;
  }

  this.dispatchConfig = dispatchConfig;
  this._targetInst = targetInst;
  this.nativeEvent = nativeEvent;

  var Interface = this.constructor.Interface;
  for (var propName in Interface) {
    if (!Interface.hasOwnProperty(propName)) {
      continue;
    }
    if (false) {
      delete this[propName]; // this has a getter/setter for warnings
    }
    var normalize = Interface[propName];
    if (normalize) {
      this[propName] = normalize(nativeEvent);
    } else {
      if (propName === 'target') {
        this.target = nativeEventTarget;
      } else {
        this[propName] = nativeEvent[propName];
      }
    }
  }

  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
  if (defaultPrevented) {
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  } else {
    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
  }
  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
  return this;
}

_assign(SyntheticEvent.prototype, {
  preventDefault: function () {
    this.defaultPrevented = true;
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.preventDefault) {
      event.preventDefault();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.returnValue !== 'unknown') {
      event.returnValue = false;
    }
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  },

  stopPropagation: function () {
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.stopPropagation) {
      event.stopPropagation();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.cancelBubble !== 'unknown') {
      // The ChangeEventPlugin registers a "propertychange" event for
      // IE. This event does not support bubbling or cancelling, and
      // any references to cancelBubble throw "Member not found".  A
      // typeof check of "unknown" circumvents this issue (and is also
      // IE specific).
      event.cancelBubble = true;
    }

    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
  },

  /**
   * We release all dispatched `SyntheticEvent`s after each event loop, adding
   * them back into the pool. This allows a way to hold onto a reference that
   * won't be added back into the pool.
   */
  persist: function () {
    this.isPersistent = emptyFunction.thatReturnsTrue;
  },

  /**
   * Checks if this event should be released back into the pool.
   *
   * @return {boolean} True if this should not be released, false otherwise.
   */
  isPersistent: emptyFunction.thatReturnsFalse,

  /**
   * `PooledClass` looks for `destructor` on each instance it releases.
   */
  destructor: function () {
    var Interface = this.constructor.Interface;
    for (var propName in Interface) {
      if (false) {
        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
      } else {
        this[propName] = null;
      }
    }
    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
      this[shouldBeReleasedProperties[i]] = null;
    }
    if (false) {
      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
    }
  }
});

SyntheticEvent.Interface = EventInterface;

if (false) {
  if (isProxySupported) {
    /*eslint-disable no-func-assign */
    SyntheticEvent = new Proxy(SyntheticEvent, {
      construct: function (target, args) {
        return this.apply(target, Object.create(target.prototype), args);
      },
      apply: function (constructor, that, args) {
        return new Proxy(constructor.apply(that, args), {
          set: function (target, prop, value) {
            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
              didWarnForAddedNewProperty = true;
            }
            target[prop] = value;
            return true;
          }
        });
      }
    });
    /*eslint-enable no-func-assign */
  }
}
/**
 * Helper to reduce boilerplate when creating subclasses.
 *
 * @param {function} Class
 * @param {?object} Interface
 */
SyntheticEvent.augmentClass = function (Class, Interface) {
  var Super = this;

  var E = function () {};
  E.prototype = Super.prototype;
  var prototype = new E();

  _assign(prototype, Class.prototype);
  Class.prototype = prototype;
  Class.prototype.constructor = Class;

  Class.Interface = _assign({}, Super.Interface, Interface);
  Class.augmentClass = Super.augmentClass;

  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
};

PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);

module.exports = SyntheticEvent;

/**
  * Helper to nullify syntheticEvent instance properties when destructing
  *
  * @param {object} SyntheticEvent
  * @param {String} propName
  * @return {object} defineProperty object
  */
function getPooledWarningPropertyDefinition(propName, getVal) {
  var isFunction = typeof getVal === 'function';
  return {
    configurable: true,
    set: set,
    get: get
  };

  function set(val) {
    var action = isFunction ? 'setting the method' : 'setting the property';
    warn(action, 'This is effectively a no-op');
    return val;
  }

  function get() {
    var action = isFunction ? 'accessing the method' : 'accessing the property';
    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
    warn(action, result);
    return getVal;
  }

  function warn(action, result) {
    var warningCondition = false;
     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
  }
}

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_motion__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_motion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_motion__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var MessageBox = function (_Component) {
    _inherits(MessageBox, _Component);

    function MessageBox(props) {
        _classCallCheck(this, MessageBox);

        var _this = _possibleConstructorReturn(this, (MessageBox.__proto__ || Object.getPrototypeOf(MessageBox)).call(this, props));

        _this.timeToDelete = "";
        _this.handler = null;
        _this.visible = false;

        _this.handleRest = _this.handleRest.bind(_this);
        //console.log("I am called ", this.visible);
        return _this;
    }

    _createClass(MessageBox, [{
        key: "handleRest",
        value: function handleRest() {
            if (this.timeToDelete === "") {
                this.handler = setTimeout(this.callMe.bind(this), 6000);
            }
            if (this.timeToDelete === "yes") {
                this.props.context.messageBox = null;
                this.visible = false;
                this.timeToDelete = "";
                this.props.context.forceUpdate();

                //this.setState({ visible: false });
            }
        }
    }, {
        key: "callMe",
        value: function callMe() {
            this.timeToDelete = "yes";
            this.visible = true;
            this.setState({});
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            //this.visible = false;
            clearTimeout(this.handler);
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            //console.log("render called", this.visible);
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_motion__["Motion"],
                { defaultStyle: { x: -1 }, style: { x: this.visible ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_motion__["spring"])(-1, __WEBPACK_IMPORTED_MODULE_1_react_motion__["presets"].stiff) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_motion__["spring"])(0, __WEBPACK_IMPORTED_MODULE_1_react_motion__["presets"].stiff) }, onRest: this.handleRest },
                function (_ref) {
                    var x = _ref.x;

                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { id: "messageBox", style: { transform: "translateX(" + x * 500 + "px)", backgroundColor: _this2.props.status ? "#6a967e" : "#de6a74" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "p",
                            null,
                            _this2.props.message
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "audio",
                            { autoPlay: "autoplay" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("source", { src: _this2.props.status ? '/success.wav' : '/chord.wav', type: "audio/wav" })
                        )
                    );
                }
            );
        }
    }], [{
        key: "showMessage",
        value: function showMessage(message, status, context) {
            //console.log("-------", message, context);
            if (!message || !context || typeof status !== "boolean") throw new Error("plz provide a message string status as boolean and component (this) as context");

            var messageBox = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MessageBox, { message: message, status: status, context: context });
            //console.log(messageBox);
            return messageBox;
        }
    }]);

    return MessageBox;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (MessageBox);

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.isReactChildren = isReactChildren;
exports.createRouteFromReactElement = createRouteFromReactElement;
exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
exports.createRoutes = createRoutes;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isValidChild(object) {
  return object == null || _react2.default.isValidElement(object);
}

function isReactChildren(object) {
  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
}

function createRoute(defaultProps, props) {
  return _extends({}, defaultProps, props);
}

function createRouteFromReactElement(element) {
  var type = element.type;
  var route = createRoute(type.defaultProps, element.props);

  if (route.children) {
    var childRoutes = createRoutesFromReactChildren(route.children, route);

    if (childRoutes.length) route.childRoutes = childRoutes;

    delete route.children;
  }

  return route;
}

/**
 * Creates and returns a routes object from the given ReactChildren. JSX
 * provides a convenient way to visualize how routes in the hierarchy are
 * nested.
 *
 *   import { Route, createRoutesFromReactChildren } from 'react-router'
 *
 *   const routes = createRoutesFromReactChildren(
 *     <Route component={App}>
 *       <Route path="home" component={Dashboard}/>
 *       <Route path="news" component={NewsFeed}/>
 *     </Route>
 *   )
 *
 * Note: This method is automatically used when you provide <Route> children
 * to a <Router> component.
 */
function createRoutesFromReactChildren(children, parentRoute) {
  var routes = [];

  _react2.default.Children.forEach(children, function (element) {
    if (_react2.default.isValidElement(element)) {
      // Component classes may have a static create* method.
      if (element.type.createRouteFromReactElement) {
        var route = element.type.createRouteFromReactElement(element, parentRoute);

        if (route) routes.push(route);
      } else {
        routes.push(createRouteFromReactElement(element));
      }
    }
  });

  return routes;
}

/**
 * Creates and returns an array of routes from the given object which
 * may be a JSX route, a plain object route, or an array of either.
 */
function createRoutes(routes) {
  if (isReactChildren(routes)) {
    routes = createRoutesFromReactChildren(routes);
  } else if (routes && !Array.isArray(routes)) {
    routes = [routes];
  }

  return routes;
}

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.extractPath = extractPath;
exports.parsePath = parsePath;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(15);

var _warning2 = _interopRequireDefault(_warning);

function extractPath(string) {
  var match = string.match(/^https?:\/\/[^\/]*/);

  if (match == null) return string;

  return string.substring(match[0].length);
}

function parsePath(path) {
  var pathname = extractPath(path);
  var search = '';
  var hash = '';

   false ? _warning2['default'](path === pathname, 'A path must be pathname + search + hash only, not a fully qualified URL like "%s"', path) : undefined;

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substring(hashIndex);
    pathname = pathname.substring(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substring(searchIndex);
    pathname = pathname.substring(0, searchIndex);
  }

  if (pathname === '') pathname = '/';

  return {
    pathname: pathname,
    search: search,
    hash: hash
  };
}

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(4);

var invariant = __webpack_require__(1);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
exports.falsy = falsy;

var _react = __webpack_require__(0);

var func = _react.PropTypes.func;
var object = _react.PropTypes.object;
var arrayOf = _react.PropTypes.arrayOf;
var oneOfType = _react.PropTypes.oneOfType;
var element = _react.PropTypes.element;
var shape = _react.PropTypes.shape;
var string = _react.PropTypes.string;
function falsy(props, propName, componentName) {
  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
}

var history = exports.history = shape({
  listen: func.isRequired,
  push: func.isRequired,
  replace: func.isRequired,
  go: func.isRequired,
  goBack: func.isRequired,
  goForward: func.isRequired
});

var component = exports.component = oneOfType([func, string]);
var components = exports.components = oneOfType([component, object]);
var route = exports.route = oneOfType([object, element]);
var routes = exports.routes = oneOfType([route, arrayOf(route)]);

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = currencyFormat;
/* harmony export (immutable) */ __webpack_exports__["i"] = cFormat;
/* unused harmony export dateTimeFormat */
/* harmony export (immutable) */ __webpack_exports__["j"] = dateToYY_MM_DD;
/* harmony export (immutable) */ __webpack_exports__["b"] = getDateRench;
/* harmony export (immutable) */ __webpack_exports__["h"] = toExactFixted;
/* harmony export (immutable) */ __webpack_exports__["a"] = DD_MM_YY;
/* harmony export (immutable) */ __webpack_exports__["f"] = daysInMonth;
/* harmony export (immutable) */ __webpack_exports__["d"] = extractDataFromTable;
/* unused harmony export getDoubleLine */
/* harmony export (immutable) */ __webpack_exports__["e"] = print;
/* harmony export (immutable) */ __webpack_exports__["k"] = dateDiff;
/* harmony export (immutable) */ __webpack_exports__["g"] = matchDate;
/* harmony export (immutable) */ __webpack_exports__["l"] = inWords;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rq_js__ = __webpack_require__(6);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();


function currencyFormat(numberString) {
    if (numberString === null || numberString === undefined) {
        return "0.00";
    }
    var addMinus = "";
    if (numberString < 0) {
        addMinus = "-";
        numberString = numberString * -1;
    }
    numberString = numberString === 0 ? 0 : numberString;
    numberString = numberString.toString();
    var pattern = [3, 2, 2];

    var arr = numberString.split(".");
    var number = arr[0];

    var decimal = arr[1] || "00";
    number = number.split("");
    var i = 0;
    var text = "";
    while (number.length !== 0) {
        var result = number.splice(-pattern[i]);
        text = number.length > 0 ? "," + result.join("") + text : result.join("") + text;
        i = i === 2 ? 0 : ++i;
    }
    if (decimal.length === 1) {
        decimal = decimal.toString() + "0";
    }
    return addMinus + text + "." + decimal.substring(0, 2);
}

function cFormat(numberString) {
    numberString = numberString || "";
    numberString = numberString.toString();
    var pattern = [3, 2, 2];
    var number = numberString;
    number = number.split("");
    var i = 0;
    var text = "";
    while (number.length !== 0) {
        var result = number.splice(-pattern[i]);
        text = number.length > 0 ? "," + result.join("") + text : result.join("") + text;
        i = i === 2 ? 0 : ++i;
    }
    return text;
}

function dateTimeFormat(localDateTime) {
    return localDateTime.split("T").join(" ");
}

function dateToYY_MM_DD(dt) {

    return dt.getFullYear() + "-" + (dt.getMonth() < 9 ? "0" + (dt.getMonth() + 1) : dt.getMonth() + 1) + "-" + (dt.getDate() < 10 ? "0" + dt.getDate() : dt.getDate());
}

function getDateRench(num) {
    var x = new Date();
    var y = new Date();
    y.setDate(y.getDate() - num);
    return [dateToYY_MM_DD(y), dateToYY_MM_DD(x)];
}
function toExactFixted(number) {
    var toPoint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    if (number === undefined || number === null) {
        return "0." + new Array(toPoint + 1).join("0");
    }
    number = number.toString();

    var arr = number.split(".");
    if (toPoint === 0) return arr[0];
    var d = "";
    var len = 0;

    if (arr[1] >= 0) {
        len = arr[1].length;
    }

    var value = toPoint - len;
    if (value > 0) {
        for (var i = 0; i < value; i++) {
            d += "0";
        }
        d = (arr[1] || "") + d;
    } else if (value === 0) {
        d = arr[1] + "";
    } else if (value < 0) {
        d = arr[1].substring(0, toPoint);
    }
    return arr[0] + "." + d;
}

function DD_MM_YY(dt) {
    if (Date.parse(dt)) {
        var d = new Date(dt);
        var month = d.getMonth() + 1;
        var day = d.getDate();
        day = day < 10 ? "0" + day : day;
        month = month < 10 ? "0" + month : month;
        return day + "-" + month + "-" + d.getFullYear();
    } else {
        return null;
    }
}

function daysInMonth(month, year) {
    return new Date(year, month, 0).getDate();
}

function extractDataFromTable(tableId) {
    var arr = [];
    var table = document.getElementById(tableId);
    for (var i = 0; i < table.rows.length; i++) {
        arr[i] = [];
        for (var z = 0; z < table.rows[i].cells.length; z++) {
            var cName = table.rows[i].cells[z].className;
            var align = "";
            switch (cName) {
                case "currency":
                    {
                        align = "right";
                        break;
                    }
                case "alignRight":
                    {
                        align = "right";
                        break;
                    }
                case "center":
                    {
                        align = "center";
                        break;
                    }
                default:
                    {
                        align = "left";
                        break;
                    }

            }
            arr[i][z] = { text: cName === "currency" ? "\u20B9" + table.rows[i].cells[z].innerText.trim() : table.rows[i].cells[z].innerText.trim(), alignment: align };
        }
    }
    // console.log(arr);
    var widths = [];
    if (arr.length > 0) {
        for (var _i = 0; _i < arr[0].length; _i++) {
            widths.push("*");
        }
    }
    return { data: arr, widths: widths };
}

function getDoubleLine() {
    return {
        canvas: [{
            type: 'line',
            x1: 0, y1: 7,
            x2: 520, y2: 7,
            lineWidth: 1
        }, {
            type: 'line',
            x1: 0, y1: 10,
            x2: 520, y2: 10,
            lineWidth: 2
        }]
    };
}

function print(data, cb) {
    __WEBPACK_IMPORTED_MODULE_0__rq_js__["a" /* default */].postJson("/api/v1/print", data).then(function (file) {
        //print(file);
        //var link = document.createElement('a');

        //window.print();
        //link.setAttribute('download', "manas.pdf");
        //link.setAttribute("target", "_blank");
        //document.body.appendChild(link);
        //link.click();
        //document.body.removeChild(link);
        //document.print();
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);
        if (cb) cb();
    }).catch(function (err) {
        throw err;
    });
}

function dateDiff(to, from) {
    var diff = Math.abs(new Date(to) - new Date(from));
    var oneDay = 24 * 60 * 60 * 1000;

    return diff / oneDay;
}

function matchDate(dt1, dt2) {
    if (dt1 && dt2) return dt1.getTime() === dt2.getTime();else return false;
}

function inWords(amount) {
    amount = parseFloat(amount);
    if (!amount) return "";
    //const currency = currencyFormat(amount);

    var _amount$toString$spli = amount.toString().split("."),
        _amount$toString$spli2 = _slicedToArray(_amount$toString$spli, 2),
        rupees = _amount$toString$spli2[0],
        paisa = _amount$toString$spli2[1];
    //const rupeesArr = rupees.split(",");


    paisa = paisa ? paisa : "";

    //console.log(rupees, paisa);

    function numberToWord(number) {
        number = parseInt(number, 10);
        switch (number) {
            case 1:
                return "One";
            case 2:
                return "Two";
            case 3:
                return "Three";
            case 4:
                return "Four";
            case 5:
                return "Five";
            case 6:
                return "Six";
            case 7:
                return "Seven";
            case 8:
                return "Eight";
            case 9:
                return "Nine";
            default:
                return "";
        }
    }

    function sndNumberToWord(number) {
        number = parseInt(number, 10);
        switch (number) {
            case 2:
                return "Twenty";
            case 3:
                return "Thirty";
            case 4:
                return "Fourty";
            case 5:
                return "Fifty";
            case 6:
                return "Sixty";
            case 7:
                return "Seventy";
            case 8:
                return "Eighty";
            case 9:
                return "Ninty";
            default:
                return "";

        }
    }

    function checkNums(num) {
        //  num = ;
        // console.log(parseInt(num, 10));
        if (parseInt(num, 10) === 0) return "";

        switch (num.length) {
            case 1:
                return numberToWord(num[0]);
            case 2:
                {

                    var numx = parseInt(num, 10);
                    if (numx >= 10 && numx <= 20) return handleTenToTwentyOne(numx);
                    return (sndNumberToWord(num[0]) + " " + numberToWord(num[1])).trim();
                }
            case 3:
                {
                    //const numx = parseInt(num.substring(1, 2), 10);

                    return ((numberToWord(num[0]) ? numberToWord(num[0]) + " Hundred" : "") + " " + checkNums(num.substring(1, 3))).trim();
                }
            case 4:
                {

                    return ((checkNums(num[0]) ? checkNums(num[0]) + " Thousand" : "") + " " + checkNums(num.substring(1, 4))).trim();
                }
            case 5:
                {
                    return ((checkNums(num.substring(0, 2)) ? " " + checkNums(num.substring(0, 2)) + " Thousand" : "") + " " + checkNums(num.substring(2, 5))).trim();
                }
            case 6:
                {
                    return ((checkNums(num.substring(0, 1)) ? " " + checkNums(num.substring(0, 1)) + " Lakh" : "") + " " + checkNums(num.substring(1, 6))).trim();
                }
            case 7:
                {
                    return ((checkNums(num.substring(0, 2)) ? " " + checkNums(num.substring(0, 2)) + " Lakh" : "") + " " + checkNums(num.substring(2, 7))).trim();
                }
            case 8:
                {
                    return ((checkNums(num.substring(0, 1)) ? " " + checkNums(num.substring(0, 1)) + " Crore" : "") + " " + checkNums(num.substring(1, 8))).trim();
                }
            default:
                {
                    return (checkNums(num.substring(0, num.length - 7)) + " Corer " + checkNums(num.substring(num.length - 7, num.length))).trim();
                }
        }
    }

    function handleTenToTwentyOne(num) {
        switch (num) {
            case 10:
                return "Ten";
            case 11:
                return "Eleven";
            case 12:
                return "Tweleve";
            case 13:
                return "Thirteen";
            case 14:
                return "Fourteen";
            case 15:
                return "Fifteen";
            case 16:
                return "Sixteen";
            case 17:
                return "Seventeen";
            case 18:
                return "Eighteen";
            case 19:
                return "Ninteen";
            case 20:
                return "Twenty";
        }
    }

    var inrupeesWords = "";
    var paisaWords = "";

    inrupeesWords = checkNums(rupees);

    if (paisa.length > 0) {
        var _p = void 0;
        if (paisa.length >= 2) _p = paisa.substring(0, 2);else _p = paisa + "0";

        paisaWords = checkNums(_p);
    }

    //console.log("ruppes", inrupeesWords === "");
    var final = ((inrupeesWords ? inrupeesWords + " Rupees" : "") + (paisaWords ? " and " + paisaWords + " Paisa" : "")).trim();

    return final ? final + " Only" : "";
}

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }

var _Motion = __webpack_require__(295);

exports.Motion = _interopRequire(_Motion);

var _StaggeredMotion = __webpack_require__(296);

exports.StaggeredMotion = _interopRequire(_StaggeredMotion);

var _TransitionMotion = __webpack_require__(297);

exports.TransitionMotion = _interopRequire(_TransitionMotion);

var _spring = __webpack_require__(300);

exports.spring = _interopRequire(_spring);

var _presets = __webpack_require__(129);

exports.presets = _interopRequire(_presets);

var _stripStyle = __webpack_require__(54);

exports.stripStyle = _interopRequire(_stripStyle);

// deprecated, dummy warning function

var _reorderKeys = __webpack_require__(299);

exports.reorderKeys = _interopRequire(_reorderKeys);

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rq_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var AutoComplete = function (_Component) {
    _inherits(AutoComplete, _Component);

    function AutoComplete(props) {
        _classCallCheck(this, AutoComplete);

        var _this = _possibleConstructorReturn(this, (AutoComplete.__proto__ || Object.getPrototypeOf(AutoComplete)).call(this, props));

        _this.state = {
            data: []
        };
        _this.selectedIndex = -1;
        _this.showOverlay = false;
        _this.spinner = false;
        _this.showClear = false;

        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleKeyDown = _this.handleKeyDown.bind(_this);
        _this.hideOverlay = _this.hideOverlay.bind(_this);
        _this.onSelect = _this.onSelect.bind(_this);
        _this.handleBlur = _this.handleBlur.bind(_this);
        _this.clearData = _this.clearData.bind(_this);
        return _this;
    }

    _createClass(AutoComplete, [{
        key: "componentWillMount",
        value: function componentWillMount() {
            this.internalValidate(this.props);
        }
    }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.reset) {
                this.selectedIndex = -1;
                this.refs.search.value = "";
                this.selectedIndex = -1;
                this.showOverlay = false;
                this.spinner = false;
                this.setState({ data: [] });
            }
        }
    }, {
        key: "handleChange",
        value: function handleChange(e) {
            var _this2 = this;

            this.selectedIndex = -1;
            this.showClear = false;
            //this.onSelect(null);
            // temporarly commenting this 

            var searchText = this.refs.search.value;
            //const $that = this;

            // HERE WE CAN SET THE MINIMUM NUMBER OF CHARACTER THAT IS REQUIRED TO MAKE fetch CALL

            if (searchText.length > 0) {
                var dataSrcType = _typeof(this.props.dataSrc);
                if (dataSrcType === "string") {

                    this.spinner = true;
                    this.forceUpdate();

                    __WEBPACK_IMPORTED_MODULE_1__rq_js__["a" /* default */].getJsonData(this.props.dataSrc + "?q=" + searchText.toLowerCase()).then(function (data) {
                        // this.state.data = data;
                        _this2.selected = -1;
                        //need to change the selected index to -1
                        _this2.showOverlay = _this2.state.data.length > 0 ? true : false;
                        _this2.spinner = false;
                        _this2.setState({ data: data });
                    }).catch(function (err) {
                        throw err;
                    });
                } else {
                    var filterData = this.props.dataSrc.filter(function (e, i) {
                        if (e[_this2.props.dataTobind].toLowerCase().indexOf(searchText.toLowerCase()) >= 0 && i <= 5) return true;else return false;
                    });

                    //this.state.data = filterData;
                    this.selected = -1;
                    //need to change the selected index to -1
                    this.showOverlay = filterData.length > 0 ? true : false;
                    this.spinner = false;
                    this.setState({ data: filterData });
                }
            } else {
                // this.state.data = [];
                this.setState({ data: [] });
            }
            if (!this.refs.search.value) {
                this.onSelect();
                this.showClear = false;
                this.forceUpdate();
            }
        }
    }, {
        key: "handleKeyDown",
        value: function handleKeyDown(e) {
            if (e.keyCode === 40 && this.state.data.length > 0) {
                e.preventDefault();
                this.selectedIndex = this.selectedIndex < this.state.data.length - 1 ? ++this.selectedIndex : 0;
                this.refs.search.value = this.state.data[this.selectedIndex][this.props.dataTobind];

                this.forceUpdate();
            }

            if (e.keyCode === 38 && this.state.data.length > 0) {
                e.preventDefault();
                this.selectedIndex = this.selectedIndex > 0 ? --this.selectedIndex : this.state.data.length - 1;
                this.refs.search.value = this.state.data[this.selectedIndex][this.props.dataTobind];
                this.forceUpdate();
            }

            if (e.keyCode === 13) {
                if (this.selectedIndex >= 0) {
                    this.onSelect(this.state.data[this.selectedIndex]);
                    //this.state.data = [];
                    this.selectedIndex = -1;
                    this.showOverlay = false;
                    this.setState({ data: [] });
                }
            }
        }
    }, {
        key: "decorate",
        value: function decorate(text, searchText) {
            var arr = text.split(searchText);
            return { __html: arr.join('<i class="highlight">' + searchText + '</i>') };
        }
    }, {
        key: "hideOverlay",
        value: function hideOverlay() {
            this.showOverlay = false;
            //this.state.data = [];
            this.selectedIndex = -1;
            this.setState({ data: [] });
        }
    }, {
        key: "onSelect",
        value: function onSelect(selectedData) {

            //console.log("onSelect fired");
            this.showClear = true;
            this.props.onSelect(selectedData);
            this.hideOverlay();
        }
    }, {
        key: "handleMouseUp",
        value: function handleMouseUp(i) {
            //this.refs.search.value = this.state.data[i][this.props.dataTobind];
            this.selectedIndex = i;
            //this.setState(this.state);
            this.forceUpdate();
        }
    }, {
        key: "handleBlur",
        value: function handleBlur(event) {
            // console.log(event);
            //console.log(this.selectedIndex);

            if (this.selectedIndex !== -1) {
                this.refs.search.value = this.state.data[this.selectedIndex][this.props.dataTobind];
                // this.props.onSelect(this.state.data[this.selectedIndex]);
                this.onSelect(this.state.data[this.selectedIndex]);
                this.refs.search.focus();
            } else {
                //this.state.data = [];
                if (this.props.onBlur) this.props.onBlur();
                this.setState({ data: [] });
            }

            event.stopPropagation();
        }
    }, {
        key: "clear",
        value: function clear() {
            this.onSelect();
            this.refs.search.value = "";
            this.refs.search.focus();
            this.showClear = false;
            this.forceUpdate();
        }
    }, {
        key: "render",
        value: function render() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: this.props.class ? this.props.class + " autoHolder" : "autoHolder" },
                this.spinner ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-cog fa-spin loader  fa-3x", "aria-hidden": "true", style: this.props.spinnerStyle || {} }) : false,
                this.showClear ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-times-circle", onClick: this.clear.bind(this), style: Object.assign({ position: "absolute", cursor: "pointer", right: "15px", top: "5px", color: "#b7b7b7", fontSize: "1.5em" }, this.props.clearStyle || {}), "aria-hidden": "true" }) : null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                    type: "text",
                    tabIndex: this.props.tabIndex,
                    placeholder: this.props.placeholder,
                    onChange: this.handleChange,
                    className: "formControl inputBox",
                    ref: "search",
                    onKeyDown: this.handleKeyDown,
                    width: this.props.width,
                    style: this.props.inputStyle ? this.props.inputStyle : {},
                    onBlur: this.handleBlur
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "ul",
                    { style: this.props.listStyle ? this.props.listStyle : {} },
                    this.state.data.map(function (data, i) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", { style: _this3.props.liStyle ? _this3.props.liStyle : {},
                            className: _this3.selectedIndex === i ? "selected" : "",
                            key: data[_this3.props.keyToBind],
                            dangerouslySetInnerHTML: _this3.decorate(data[_this3.props.dataTobind], _this3.refs.search.value),
                            onMouseEnter: _this3.handleMouseUp.bind(_this3, i),
                            onClick: _this3.handleBlur
                        });
                    })
                ),
                this.showOverlay ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "tOverlay", onClick: this.hideOverlay }) : null
            );
        }
    }, {
        key: "clearData",
        value: function clearData() {
            this.setState({ data: [] });
        }
    }, {
        key: "componentDidMount",
        value: function componentDidMount() {
            //document.addEventListener('click', this.clearData);
            window.addEventListener('click', this.clearData);
            // ReactDOM.findDOMNode("document").addEventListener("click", () => {
            //     console.log("hiiii");
            // });
            // this is to check if a rex prop is supplied so that it could be foused;
            if (typeof this.props.rex === "function") {
                this.props.rex(this.refs.search);
            }
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            window.removeEventListener('click', this.clearData);
        }
    }, {
        key: "internalValidate",
        value: function internalValidate(props) {
            if (!props.placeholder) {
                throw new Error("plz provide a placeholder attribute to AutoComplete component");
            }
            if (!props.dataSrc) {
                throw new Error("plz provide a dataSrc attribute to AutoComplete component where ajax call will be made");
            }
            if (!props.dataSrc) {
                throw new Error("plz provide a tabIndex attribute");
            }
        }
    }]);

    return AutoComplete;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AutoComplete);

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.PropTypes = exports.RoutingContext = exports.RouterContext = exports.createRoutes = exports.useRoutes = exports.RouteContext = exports.Lifecycle = exports.History = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;

var _RouteUtils = __webpack_require__(22);

Object.defineProperty(exports, 'createRoutes', {
  enumerable: true,
  get: function get() {
    return _RouteUtils.createRoutes;
  }
});

var _PropTypes2 = __webpack_require__(87);

Object.defineProperty(exports, 'locationShape', {
  enumerable: true,
  get: function get() {
    return _PropTypes2.locationShape;
  }
});
Object.defineProperty(exports, 'routerShape', {
  enumerable: true,
  get: function get() {
    return _PropTypes2.routerShape;
  }
});

var _PatternUtils = __webpack_require__(34);

Object.defineProperty(exports, 'formatPattern', {
  enumerable: true,
  get: function get() {
    return _PatternUtils.formatPattern;
  }
});

var _Router2 = __webpack_require__(308);

var _Router3 = _interopRequireDefault(_Router2);

var _Link2 = __webpack_require__(130);

var _Link3 = _interopRequireDefault(_Link2);

var _IndexLink2 = __webpack_require__(302);

var _IndexLink3 = _interopRequireDefault(_IndexLink2);

var _withRouter2 = __webpack_require__(321);

var _withRouter3 = _interopRequireDefault(_withRouter2);

var _IndexRedirect2 = __webpack_require__(303);

var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);

var _IndexRoute2 = __webpack_require__(304);

var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);

var _Redirect2 = __webpack_require__(131);

var _Redirect3 = _interopRequireDefault(_Redirect2);

var _Route2 = __webpack_require__(306);

var _Route3 = _interopRequireDefault(_Route2);

var _History2 = __webpack_require__(301);

var _History3 = _interopRequireDefault(_History2);

var _Lifecycle2 = __webpack_require__(305);

var _Lifecycle3 = _interopRequireDefault(_Lifecycle2);

var _RouteContext2 = __webpack_require__(307);

var _RouteContext3 = _interopRequireDefault(_RouteContext2);

var _useRoutes2 = __webpack_require__(320);

var _useRoutes3 = _interopRequireDefault(_useRoutes2);

var _RouterContext2 = __webpack_require__(55);

var _RouterContext3 = _interopRequireDefault(_RouterContext2);

var _RoutingContext2 = __webpack_require__(309);

var _RoutingContext3 = _interopRequireDefault(_RoutingContext2);

var _PropTypes3 = _interopRequireDefault(_PropTypes2);

var _match2 = __webpack_require__(318);

var _match3 = _interopRequireDefault(_match2);

var _useRouterHistory2 = __webpack_require__(136);

var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);

var _applyRouterMiddleware2 = __webpack_require__(311);

var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);

var _browserHistory2 = __webpack_require__(312);

var _browserHistory3 = _interopRequireDefault(_browserHistory2);

var _hashHistory2 = __webpack_require__(316);

var _hashHistory3 = _interopRequireDefault(_hashHistory2);

var _createMemoryHistory2 = __webpack_require__(133);

var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Router = _Router3.default; /* components */

exports.Link = _Link3.default;
exports.IndexLink = _IndexLink3.default;
exports.withRouter = _withRouter3.default;

/* components (configuration) */

exports.IndexRedirect = _IndexRedirect3.default;
exports.IndexRoute = _IndexRoute3.default;
exports.Redirect = _Redirect3.default;
exports.Route = _Route3.default;

/* mixins */

exports.History = _History3.default;
exports.Lifecycle = _Lifecycle3.default;
exports.RouteContext = _RouteContext3.default;

/* utils */

exports.useRoutes = _useRoutes3.default;
exports.RouterContext = _RouterContext3.default;
exports.RoutingContext = _RoutingContext3.default;
exports.PropTypes = _PropTypes3.default;
exports.match = _match3.default;
exports.useRouterHistory = _useRouterHistory3.default;
exports.applyRouterMiddleware = _applyRouterMiddleware3.default;

/* histories */

exports.browserHistory = _browserHistory3.default;
exports.hashHistory = _hashHistory3.default;
exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Indicates that navigation was caused by a call to history.push.
 */


exports.__esModule = true;
var PUSH = 'PUSH';

exports.PUSH = PUSH;
/**
 * Indicates that navigation was caused by a call to history.replace.
 */
var REPLACE = 'REPLACE';

exports.REPLACE = REPLACE;
/**
 * Indicates that navigation was caused by some other action such
 * as using a browser's back/forward buttons and/or manually manipulating
 * the URL in a browser's location bar. This is the default.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
 * for more information.
 */
var POP = 'POP';

exports.POP = POP;
exports['default'] = {
  PUSH: PUSH,
  REPLACE: REPLACE,
  POP: POP
};

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMNamespaces = __webpack_require__(68);
var setInnerHTML = __webpack_require__(53);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(76);
var setTextContent = __webpack_require__(127);

var ELEMENT_NODE_TYPE = 1;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

/**
 * In IE (8-11) and Edge, appending nodes with no children is dramatically
 * faster than appending a full subtree, so we essentially queue up the
 * .appendChild calls here and apply them so each node is added to its parent
 * before any children are added.
 *
 * In other browsers, doing so is slower or neutral compared to the other order
 * (in Firefox, twice as slow) so we only do this inversion in IE.
 *
 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
 */
var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);

function insertTreeChildren(tree) {
  if (!enableLazy) {
    return;
  }
  var node = tree.node;
  var children = tree.children;
  if (children.length) {
    for (var i = 0; i < children.length; i++) {
      insertTreeBefore(node, children[i], null);
    }
  } else if (tree.html != null) {
    setInnerHTML(node, tree.html);
  } else if (tree.text != null) {
    setTextContent(node, tree.text);
  }
}

var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
  // DocumentFragments aren't actually part of the DOM after insertion so
  // appending children won't update the DOM. We need to ensure the fragment
  // is properly populated first, breaking out of our lazy approach for just
  // this level. Also, some <object> plugins (like Flash Player) will read
  // <param> nodes immediately upon insertion into the DOM, so <object>
  // must also be populated prior to insertion into the DOM.
  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
    insertTreeChildren(tree);
    parentNode.insertBefore(tree.node, referenceNode);
  } else {
    parentNode.insertBefore(tree.node, referenceNode);
    insertTreeChildren(tree);
  }
});

function replaceChildWithTree(oldNode, newTree) {
  oldNode.parentNode.replaceChild(newTree.node, oldNode);
  insertTreeChildren(newTree);
}

function queueChild(parentTree, childTree) {
  if (enableLazy) {
    parentTree.children.push(childTree);
  } else {
    parentTree.node.appendChild(childTree.node);
  }
}

function queueHTML(tree, html) {
  if (enableLazy) {
    tree.html = html;
  } else {
    setInnerHTML(tree.node, html);
  }
}

function queueText(tree, text) {
  if (enableLazy) {
    tree.text = text;
  } else {
    setTextContent(tree.node, text);
  }
}

function toString() {
  return this.node.nodeName;
}

function DOMLazyTree(node) {
  return {
    node: node,
    children: [],
    html: null,
    text: null,
    toString: toString
  };
}

DOMLazyTree.insertTreeBefore = insertTreeBefore;
DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
DOMLazyTree.queueChild = queueChild;
DOMLazyTree.queueHTML = queueHTML;
DOMLazyTree.queueText = queueText;

module.exports = DOMLazyTree;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(4);

var invariant = __webpack_require__(1);

function checkMask(value, bitmask) {
  return (value & bitmask) === bitmask;
}

var DOMPropertyInjection = {
  /**
   * Mapping from normalized, camelcased property names to a configuration that
   * specifies how the associated DOM property should be accessed or rendered.
   */
  MUST_USE_PROPERTY: 0x1,
  HAS_BOOLEAN_VALUE: 0x4,
  HAS_NUMERIC_VALUE: 0x8,
  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,

  /**
   * Inject some specialized knowledge about the DOM. This takes a config object
   * with the following properties:
   *
   * isCustomAttribute: function that given an attribute name will return true
   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
   * attributes where it's impossible to enumerate all of the possible
   * attribute names,
   *
   * Properties: object mapping DOM property name to one of the
   * DOMPropertyInjection constants or null. If your attribute isn't in here,
   * it won't get written to the DOM.
   *
   * DOMAttributeNames: object mapping React attribute name to the DOM
   * attribute name. Attribute names not specified use the **lowercase**
   * normalized name.
   *
   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
   * attribute namespace URL. (Attribute names not specified use no namespace.)
   *
   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
   * Property names not specified use the normalized name.
   *
   * DOMMutationMethods: Properties that require special mutation methods. If
   * `value` is undefined, the mutation method should unset the property.
   *
   * @param {object} domPropertyConfig the config as described above.
   */
  injectDOMPropertyConfig: function (domPropertyConfig) {
    var Injection = DOMPropertyInjection;
    var Properties = domPropertyConfig.Properties || {};
    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};

    if (domPropertyConfig.isCustomAttribute) {
      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
    }

    for (var propName in Properties) {
      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;

      var lowerCased = propName.toLowerCase();
      var propConfig = Properties[propName];

      var propertyInfo = {
        attributeName: lowerCased,
        attributeNamespace: null,
        propertyName: propName,
        mutationMethod: null,

        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
      };
      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;

      if (false) {
        DOMProperty.getPossibleStandardName[lowerCased] = propName;
      }

      if (DOMAttributeNames.hasOwnProperty(propName)) {
        var attributeName = DOMAttributeNames[propName];
        propertyInfo.attributeName = attributeName;
        if (false) {
          DOMProperty.getPossibleStandardName[attributeName] = propName;
        }
      }

      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
      }

      if (DOMPropertyNames.hasOwnProperty(propName)) {
        propertyInfo.propertyName = DOMPropertyNames[propName];
      }

      if (DOMMutationMethods.hasOwnProperty(propName)) {
        propertyInfo.mutationMethod = DOMMutationMethods[propName];
      }

      DOMProperty.properties[propName] = propertyInfo;
    }
  }
};

/* eslint-disable max-len */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
/* eslint-enable max-len */

/**
 * DOMProperty exports lookup objects that can be used like functions:
 *
 *   > DOMProperty.isValid['id']
 *   true
 *   > DOMProperty.isValid['foobar']
 *   undefined
 *
 * Although this may be confusing, it performs better in general.
 *
 * @see http://jsperf.com/key-exists
 * @see http://jsperf.com/key-missing
 */
var DOMProperty = {
  ID_ATTRIBUTE_NAME: 'data-reactid',
  ROOT_ATTRIBUTE_NAME: 'data-reactroot',

  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',

  /**
   * Map from property "standard name" to an object with info about how to set
   * the property in the DOM. Each object contains:
   *
   * attributeName:
   *   Used when rendering markup or with `*Attribute()`.
   * attributeNamespace
   * propertyName:
   *   Used on DOM node instances. (This includes properties that mutate due to
   *   external factors.)
   * mutationMethod:
   *   If non-null, used instead of the property or `setAttribute()` after
   *   initial render.
   * mustUseProperty:
   *   Whether the property must be accessed and mutated as an object property.
   * hasBooleanValue:
   *   Whether the property should be removed when set to a falsey value.
   * hasNumericValue:
   *   Whether the property must be numeric or parse as a numeric and should be
   *   removed when set to a falsey value.
   * hasPositiveNumericValue:
   *   Whether the property must be positive numeric or parse as a positive
   *   numeric and should be removed when set to a falsey value.
   * hasOverloadedBooleanValue:
   *   Whether the property can be used as a flag as well as with a value.
   *   Removed when strictly equal to false; present without a value when
   *   strictly equal to true; present with a value otherwise.
   */
  properties: {},

  /**
   * Mapping from lowercase property names to the properly cased version, used
   * to warn in the case of missing properties. Available only in __DEV__.
   *
   * autofocus is predefined, because adding it to the property whitelist
   * causes unintended side effects.
   *
   * @type {Object}
   */
  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,

  /**
   * All of the isCustomAttribute() functions that have been injected.
   */
  _isCustomAttributeFunctions: [],

  /**
   * Checks whether a property name is a custom attribute.
   * @method
   */
  isCustomAttribute: function (attributeName) {
    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
      if (isCustomAttributeFn(attributeName)) {
        return true;
      }
    }
    return false;
  },

  injection: DOMPropertyInjection
};

module.exports = DOMProperty;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactRef = __webpack_require__(268);
var ReactInstrumentation = __webpack_require__(14);

var warning = __webpack_require__(3);

/**
 * Helper to call ReactRef.attachRefs with this composite component, split out
 * to avoid allocations in the transaction mount-ready queue.
 */
function attachRefs() {
  ReactRef.attachRefs(this, this._currentElement);
}

var ReactReconciler = {
  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} the containing host component instance
   * @param {?object} info about the host container
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
  {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
      }
    }
    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
      }
    }
    return markup;
  },

  /**
   * Returns a value that can be passed to
   * ReactComponentEnvironment.replaceNodeWithMarkup.
   */
  getHostNode: function (internalInstance) {
    return internalInstance.getHostNode();
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (internalInstance, safely) {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
      }
    }
    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
    internalInstance.unmountComponent(safely);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Update a component using a new element.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @internal
   */
  receiveComponent: function (internalInstance, nextElement, transaction, context) {
    var prevElement = internalInstance._currentElement;

    if (nextElement === prevElement && context === internalInstance._context) {
      // Since elements are immutable after the owner is rendered,
      // we can do a cheap identity compare here to determine if this is a
      // superfluous reconcile. It's possible for state to be mutable but such
      // change should trigger an update of the owner which would recreate
      // the element. We explicitly check for the existence of an owner since
      // it's possible for an element created outside a composite to be
      // deeply mutated and reused.

      // TODO: Bailing out early is just a perf optimization right?
      // TODO: Removing the return statement should affect correctness?
      return;
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
      }
    }

    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);

    if (refsChanged) {
      ReactRef.detachRefs(internalInstance, prevElement);
    }

    internalInstance.receiveComponent(nextElement, transaction, context);

    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Flush any dirty changes in a component.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
      // The component's enqueued batch number should always be the current
      // batch or the following one.
       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
      return;
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
      }
    }
    internalInstance.performUpdateIfNecessary(transaction);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  }
};

module.exports = ReactReconciler;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.compilePattern = compilePattern;
exports.matchPattern = matchPattern;
exports.getParamNames = getParamNames;
exports.getParams = getParams;
exports.formatPattern = formatPattern;

var _invariant = __webpack_require__(10);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function _compilePattern(pattern) {
  var regexpSource = '';
  var paramNames = [];
  var tokens = [];

  var match = void 0,
      lastIndex = 0,
      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)/g;
  while (match = matcher.exec(pattern)) {
    if (match.index !== lastIndex) {
      tokens.push(pattern.slice(lastIndex, match.index));
      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
    }

    if (match[1]) {
      regexpSource += '([^/]+)';
      paramNames.push(match[1]);
    } else if (match[0] === '**') {
      regexpSource += '(.*)';
      paramNames.push('splat');
    } else if (match[0] === '*') {
      regexpSource += '(.*?)';
      paramNames.push('splat');
    } else if (match[0] === '(') {
      regexpSource += '(?:';
    } else if (match[0] === ')') {
      regexpSource += ')?';
    }

    tokens.push(match[0]);

    lastIndex = matcher.lastIndex;
  }

  if (lastIndex !== pattern.length) {
    tokens.push(pattern.slice(lastIndex, pattern.length));
    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
  }

  return {
    pattern: pattern,
    regexpSource: regexpSource,
    paramNames: paramNames,
    tokens: tokens
  };
}

var CompiledPatternsCache = Object.create(null);

function compilePattern(pattern) {
  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);

  return CompiledPatternsCache[pattern];
}

/**
 * Attempts to match a pattern on the given pathname. Patterns may use
 * the following special characters:
 *
 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
 *                  captured string is considered a "param"
 * - ()             Wraps a segment of the URL that is optional
 * - *              Consumes (non-greedy) all characters up to the next
 *                  character in the pattern, or to the end of the URL if
 *                  there is none
 * - **             Consumes (greedy) all characters up to the next character
 *                  in the pattern, or to the end of the URL if there is none
 *
 *  The function calls callback(error, matched) when finished.
 * The return value is an object with the following properties:
 *
 * - remainingPathname
 * - paramNames
 * - paramValues
 */
function matchPattern(pattern, pathname) {
  // Ensure pattern starts with leading slash for consistency with pathname.
  if (pattern.charAt(0) !== '/') {
    pattern = '/' + pattern;
  }

  var _compilePattern2 = compilePattern(pattern);

  var regexpSource = _compilePattern2.regexpSource;
  var paramNames = _compilePattern2.paramNames;
  var tokens = _compilePattern2.tokens;


  if (pattern.charAt(pattern.length - 1) !== '/') {
    regexpSource += '/?'; // Allow optional path separator at end.
  }

  // Special-case patterns like '*' for catch-all routes.
  if (tokens[tokens.length - 1] === '*') {
    regexpSource += '$';
  }

  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
  if (match == null) {
    return null;
  }

  var matchedPath = match[0];
  var remainingPathname = pathname.substr(matchedPath.length);

  if (remainingPathname) {
    // Require that the match ends at a path separator, if we didn't match
    // the full path, so any remaining pathname is a new path segment.
    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
      return null;
    }

    // If there is a remaining pathname, treat the path separator as part of
    // the remaining pathname for properly continuing the match.
    remainingPathname = '/' + remainingPathname;
  }

  return {
    remainingPathname: remainingPathname,
    paramNames: paramNames,
    paramValues: match.slice(1).map(function (v) {
      return v && decodeURIComponent(v);
    })
  };
}

function getParamNames(pattern) {
  return compilePattern(pattern).paramNames;
}

function getParams(pattern, pathname) {
  var match = matchPattern(pattern, pathname);
  if (!match) {
    return null;
  }

  var paramNames = match.paramNames;
  var paramValues = match.paramValues;

  var params = {};

  paramNames.forEach(function (paramName, index) {
    params[paramName] = paramValues[index];
  });

  return params;
}

/**
 * Returns a version of the given pattern with params interpolated. Throws
 * if there is a dynamic segment of the pattern for which there is no param.
 */
function formatPattern(pattern, params) {
  params = params || {};

  var _compilePattern3 = compilePattern(pattern);

  var tokens = _compilePattern3.tokens;

  var parenCount = 0,
      pathname = '',
      splatIndex = 0;

  var token = void 0,
      paramName = void 0,
      paramValue = void 0;
  for (var i = 0, len = tokens.length; i < len; ++i) {
    token = tokens[i];

    if (token === '*' || token === '**') {
      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;

      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;

      if (paramValue != null) pathname += encodeURI(paramValue);
    } else if (token === '(') {
      parenCount += 1;
    } else if (token === ')') {
      parenCount -= 1;
    } else if (token.charAt(0) === ':') {
      paramName = token.substring(1);
      paramValue = params[paramName];

      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;

      if (paramValue != null) pathname += encodeURIComponent(paramValue);
    } else {
      pathname += token;
    }
  }

  return pathname.replace(/\/+/g, '/');
}

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(7);

var ReactBaseClasses = __webpack_require__(137);
var ReactChildren = __webpack_require__(324);
var ReactDOMFactories = __webpack_require__(325);
var ReactElement = __webpack_require__(36);
var ReactPropTypes = __webpack_require__(326);
var ReactVersion = __webpack_require__(327);

var createReactClass = __webpack_require__(328);
var onlyChild = __webpack_require__(332);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(7);

var ReactCurrentOwner = __webpack_require__(20);

var warning = __webpack_require__(3);
var canDefineProperty = __webpack_require__(141);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(139);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var SelectMenu = function (_React$Component) {
    _inherits(SelectMenu, _React$Component);

    function SelectMenu() {
        _classCallCheck(this, SelectMenu);

        var _this = _possibleConstructorReturn(this, (SelectMenu.__proto__ || Object.getPrototypeOf(SelectMenu)).call(this));

        _this.selectedIndex = -1;
        _this.state = {
            menuVisible: false,
            selected: false
        };
        _this.handleKeyDown = _this.handleKeyDown.bind(_this);
        _this.handleBlur = _this.handleBlur.bind(_this);
        _this.onOverlayClick = _this.onOverlayClick.bind(_this);
        // console.log("constructor fired$$$");
        return _this;
    }

    _createClass(SelectMenu, [{
        key: "showMenu",
        value: function showMenu() {
            var menuVisible = !this.state.menuVisible;
            this.setState({ menuVisible: menuVisible });
        }
    }, {
        key: "handleSelect",
        value: function handleSelect(data, i) {
            if (data) {
                var selected = data[this.props.vl];
                this.selectedIndex = i;
                if (this.props.onSelect) this.props.onSelect(data);
                //this.state.menuVisible = false;
                this.refs.selectDiv.focus();
                this.setState({ selected: selected, menuVisible: false });
            }
        }
    }, {
        key: "handleKeyDown",
        value: function handleKeyDown(e) {
            if (e.keyCode === 40) {
                //this is for down arrow
                this.selectedIndex = this.selectedIndex < this.props.data.length - 1 ? ++this.selectedIndex : 0;
                this.handleSelect(this.props.data[this.selectedIndex], this.selectedIndex);
                e.preventDefault();
            }
            if (e.keyCode === 38) {
                //this is up arrow
                this.selectedIndex = this.selectedIndex <= 0 ? this.props.data.length - 1 : --this.selectedIndex;
                this.handleSelect(this.props.data[this.selectedIndex], this.selectedIndex);
                e.preventDefault();
            }
        }
    }, {
        key: "handleBlur",
        value: function handleBlur() {
            // console.log("handleBlur fired", this.selectedIndex);
            if (typeof this.props.onBlur === "function") {
                // console.log(this.state.menuVisible);
                if (this.selectedIndex === -1) {
                    this.props.onBlur();
                }
            }
        }
    }, {
        key: "onOverlayClick",
        value: function onOverlayClick() {
            //console.log("overlay clicked selectedIndex", this.selectedIndex);
            this.setState({ menuVisible: false });
        }
    }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            //console.log("component will receive props fired", this.props, nextProps);
            if (nextProps.reset) {
                this.selectedIndex = -1;
                this.state = {
                    menuVisible: false,
                    selected: false
                };
            }
        }
    }, {
        key: "propValidate",
        value: function propValidate() {
            if (this.props.onSelect !== "function") throw new Error("selectMenu must have a onSelect prop that must be a function");
            if (!this.props.ky || !this.props.vl) throw new Error("selectMenu must have ky prop and vl prop for key and value respectivly");
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            // console.log("select menu render called");
            var myLi = this.props.data.map(function (data, i) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "li",
                    { onClick: _this2.handleSelect.bind(_this2, data, i), key: data[_this2.props.ky] },
                    data[_this2.props.vl]
                );
            });
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "selectMenuHolder" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { onKeyDown: this.handleKeyDown, tabIndex: this.props.tabIndex, ref: "selectDiv", onClick: this.showMenu.bind(this),
                        className: "selectMenu formControl", onBlur: this.handleBlur, style: this.props.style },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "p",
                        null,
                        this.state.selected ? this.state.selected : this.props.defaultValue ? this.props.defaultValue : this.props.text || "Select",
                        " ",
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-caret-down",
                            style: { float: "right", fontSize: "16px", lineHeight: "24px" }
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "ul",
                    { style: Object.assign({}, this.props.listStyle, { display: this.state.menuVisible ? "block" : "none" }) },
                    myLi
                ),
                this.state.menuVisible ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { onClick: this.onOverlayClick, className: "tOverlay" }) : null
            );
        }
    }, {
        key: "componentDidMount",
        value: function componentDidMount() {
            // this is to check if a rex prop is supplied so that it could be foused;
            if (typeof this.props.rex === "function") {
                this.props.rex(this.refs.selectDiv);
            }
        }
    }]);

    return SelectMenu;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (SelectMenu);

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var Tip = function (_Component) {
    _inherits(Tip, _Component);

    function Tip() {
        _classCallCheck(this, Tip);

        return _possibleConstructorReturn(this, (Tip.__proto__ || Object.getPrototypeOf(Tip)).apply(this, arguments));
    }

    _createClass(Tip, [{
        key: "render",
        value: function render() {

            return this.props.showOn ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { id: "tipBox", style: this.props.tipStyle ? this.props.tipStyle : {} },
                this.props.msg
            ) : null;
        }
    }]);

    return Tip;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Tip);

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_events__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dispatcher__ = __webpack_require__(5);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var AuthStore = function (_EventEmitter) {
    _inherits(AuthStore, _EventEmitter);

    function AuthStore() {
        _classCallCheck(this, AuthStore);

        var _this = _possibleConstructorReturn(this, (AuthStore.__proto__ || Object.getPrototypeOf(AuthStore)).call(this));

        _this.token = null;

        return _this;
    }

    _createClass(AuthStore, [{
        key: "getToken",
        value: function getToken() {
            if (!this.token) {
                try {
                    this.token = JSON.parse(window.localStorage.getItem("token"));
                } catch (e) {
                    this.token = null;
                }
            }
            return this.token;
        }
    }, {
        key: "setToken",
        value: function setToken(token) {
            this.token = token;
            window.localStorage.setItem("token", JSON.stringify(this.token));
        }
    }, {
        key: "deleteToken",
        value: function deleteToken() {
            this.token = null;
            window.localStorage.removeItem("token");
        }
    }, {
        key: "getFormatedToken",
        value: function getFormatedToken() {
            var t = this.getToken();
            var token = "";
            if (t) {
                token = t.token;
                token = "Bearer " + token;
            }
            return token;
        }
    }, {
        key: "handleAction",
        value: function handleAction(action) {
            switch (action.type) {
                case "loginSuccess":
                    {
                        this.setToken(action.tokenData);
                        this.emit("loginSuccess", action.tokenData.user);
                        break;
                    }
                case "loginFailed":
                    {
                        this.emit("loginFailed");
                        break;
                    }

                case "passwordRecovered":
                    {
                        this.emit("passwordRecovered");
                        break;
                    }
                case "passwordRecoveryFailed":
                    {
                        this.emit("passwordRecoveryFailed");
                        break;
                    }
                default:
                    break;
            }
        }
    }]);

    return AuthStore;
}(__WEBPACK_IMPORTED_MODULE_0_events__["EventEmitter"]);

var authStore = new AuthStore();
__WEBPACK_IMPORTED_MODULE_1__dispatcher__["a" /* default */].register(authStore.handleAction.bind(authStore));

/* harmony default export */ __webpack_exports__["a"] = (authStore);

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(4);

var EventPluginRegistry = __webpack_require__(69);
var EventPluginUtils = __webpack_require__(70);
var ReactErrorUtils = __webpack_require__(74);

var accumulateInto = __webpack_require__(120);
var forEachAccumulated = __webpack_require__(121);
var invariant = __webpack_require__(1);

/**
 * Internal store for event listeners
 */
var listenerBank = {};

/**
 * Internal queue of events that have accumulated their dispatches and are
 * waiting to have their dispatches executed.
 */
var eventQueue = null;

/**
 * Dispatches an event and releases it back into the pool, unless persistent.
 *
 * @param {?object} event Synthetic event to be dispatched.
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @private
 */
var executeDispatchesAndRelease = function (event, simulated) {
  if (event) {
    EventPluginUtils.executeDispatchesInOrder(event, simulated);

    if (!event.isPersistent()) {
      event.constructor.release(event);
    }
  }
};
var executeDispatchesAndReleaseSimulated = function (e) {
  return executeDispatchesAndRelease(e, true);
};
var executeDispatchesAndReleaseTopLevel = function (e) {
  return executeDispatchesAndRelease(e, false);
};

var getDictionaryKey = function (inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
};

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

function shouldPreventMouseEvent(name, type, props) {
  switch (name) {
    case 'onClick':
    case 'onClickCapture':
    case 'onDoubleClick':
    case 'onDoubleClickCapture':
    case 'onMouseDown':
    case 'onMouseDownCapture':
    case 'onMouseMove':
    case 'onMouseMoveCapture':
    case 'onMouseUp':
    case 'onMouseUpCapture':
      return !!(props.disabled && isInteractive(type));
    default:
      return false;
  }
}

/**
 * This is a unified interface for event plugins to be installed and configured.
 *
 * Event plugins can implement the following properties:
 *
 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
 *     Required. When a top-level event is fired, this method is expected to
 *     extract synthetic events that will in turn be queued and dispatched.
 *
 *   `eventTypes` {object}
 *     Optional, plugins that fire events must publish a mapping of registration
 *     names that are used to register listeners. Values of this mapping must
 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
 *
 *   `executeDispatch` {function(object, function, string)}
 *     Optional, allows plugins to override how an event gets dispatched. By
 *     default, the listener is simply invoked.
 *
 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
 *
 * @public
 */
var EventPluginHub = {
  /**
   * Methods for injecting dependencies.
   */
  injection: {
    /**
     * @param {array} InjectedEventPluginOrder
     * @public
     */
    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,

    /**
     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
     */
    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
  },

  /**
   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {function} listener The callback to store.
   */
  putListener: function (inst, registrationName, listener) {
    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;

    var key = getDictionaryKey(inst);
    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
    bankForRegistrationName[key] = listener;

    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.didPutListener) {
      PluginModule.didPutListener(inst, registrationName, listener);
    }
  },

  /**
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @return {?function} The stored callback.
   */
  getListener: function (inst, registrationName) {
    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
    // live here; needs to be moved to a better place soon
    var bankForRegistrationName = listenerBank[registrationName];
    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
      return null;
    }
    var key = getDictionaryKey(inst);
    return bankForRegistrationName && bankForRegistrationName[key];
  },

  /**
   * Deletes a listener from the registration bank.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   */
  deleteListener: function (inst, registrationName) {
    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.willDeleteListener) {
      PluginModule.willDeleteListener(inst, registrationName);
    }

    var bankForRegistrationName = listenerBank[registrationName];
    // TODO: This should never be null -- when is it?
    if (bankForRegistrationName) {
      var key = getDictionaryKey(inst);
      delete bankForRegistrationName[key];
    }
  },

  /**
   * Deletes all listeners for the DOM element with the supplied ID.
   *
   * @param {object} inst The instance, which is the source of events.
   */
  deleteAllListeners: function (inst) {
    var key = getDictionaryKey(inst);
    for (var registrationName in listenerBank) {
      if (!listenerBank.hasOwnProperty(registrationName)) {
        continue;
      }

      if (!listenerBank[registrationName][key]) {
        continue;
      }

      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
      if (PluginModule && PluginModule.willDeleteListener) {
        PluginModule.willDeleteListener(inst, registrationName);
      }

      delete listenerBank[registrationName][key];
    }
  },

  /**
   * Allows registered plugins an opportunity to extract events from top-level
   * native browser events.
   *
   * @return {*} An accumulation of synthetic events.
   * @internal
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events;
    var plugins = EventPluginRegistry.plugins;
    for (var i = 0; i < plugins.length; i++) {
      // Not every plugin in the ordering may be loaded at runtime.
      var possiblePlugin = plugins[i];
      if (possiblePlugin) {
        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
        if (extractedEvents) {
          events = accumulateInto(events, extractedEvents);
        }
      }
    }
    return events;
  },

  /**
   * Enqueues a synthetic event that should be dispatched when
   * `processEventQueue` is invoked.
   *
   * @param {*} events An accumulation of synthetic events.
   * @internal
   */
  enqueueEvents: function (events) {
    if (events) {
      eventQueue = accumulateInto(eventQueue, events);
    }
  },

  /**
   * Dispatches all synthetic events on the event queue.
   *
   * @internal
   */
  processEventQueue: function (simulated) {
    // Set `eventQueue` to null before processing it so that we can tell if more
    // events get enqueued while processing.
    var processingEventQueue = eventQueue;
    eventQueue = null;
    if (simulated) {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
    } else {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
    }
    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
    // This would be a good time to rethrow if any of the event handlers threw.
    ReactErrorUtils.rethrowCaughtError();
  },

  /**
   * These are needed for tests only. Do not use!
   */
  __purge: function () {
    listenerBank = {};
  },

  __getListenerBank: function () {
    return listenerBank;
  }
};

module.exports = EventPluginHub;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(40);
var EventPluginUtils = __webpack_require__(70);

var accumulateInto = __webpack_require__(120);
var forEachAccumulated = __webpack_require__(121);
var warning = __webpack_require__(3);

var getListener = EventPluginHub.getListener;

/**
 * Some event types have a notion of different registration names for different
 * "phases" of propagation. This finds listeners by a given phase.
 */
function listenerAtPhase(inst, event, propagationPhase) {
  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
  return getListener(inst, registrationName);
}

/**
 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
 * here, allows us to not have to bind or create functions for each event.
 * Mutating the event's members allows us to not have to create a wrapping
 * "dispatch" object that pairs the event with the listener.
 */
function accumulateDirectionalDispatches(inst, phase, event) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
  }
  var listener = listenerAtPhase(inst, event, phase);
  if (listener) {
    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
  }
}

/**
 * Collect dispatches (must be entirely collected before dispatching - see unit
 * tests). Lazily allocate the array to conserve memory.  We must loop through
 * each event and perform the traversal for each one. We cannot perform a
 * single traversal for the entire collection of events because each event may
 * have a different target.
 */
function accumulateTwoPhaseDispatchesSingle(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
 */
function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    var targetInst = event._targetInst;
    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Accumulates without regard to direction, does not look for phased
 * registration names. Same as `accumulateDirectDispatchesSingle` but without
 * requiring that the `dispatchMarker` be the same as the dispatched ID.
 */
function accumulateDispatches(inst, ignoredDirection, event) {
  if (event && event.dispatchConfig.registrationName) {
    var registrationName = event.dispatchConfig.registrationName;
    var listener = getListener(inst, registrationName);
    if (listener) {
      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
    }
  }
}

/**
 * Accumulates dispatches on an `SyntheticEvent`, but only for the
 * `dispatchMarker`.
 * @param {SyntheticEvent} event
 */
function accumulateDirectDispatchesSingle(event) {
  if (event && event.dispatchConfig.registrationName) {
    accumulateDispatches(event._targetInst, null, event);
  }
}

function accumulateTwoPhaseDispatches(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
}

function accumulateTwoPhaseDispatchesSkipTarget(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
}

function accumulateEnterLeaveDispatches(leave, enter, from, to) {
  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
}

function accumulateDirectDispatches(events) {
  forEachAccumulated(events, accumulateDirectDispatchesSingle);
}

/**
 * A small set of propagation patterns, each of which will accept a small amount
 * of information, and generate a set of "dispatch ready event objects" - which
 * are sets of events that have already been annotated with a set of dispatched
 * listener functions/ids. The API is designed this way to discourage these
 * propagation strategies from actually executing the dispatches, since we
 * always want to collect the entire set of dispatches before executing event a
 * single one.
 *
 * @constructor EventPropagators
 */
var EventPropagators = {
  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
  accumulateDirectDispatches: accumulateDirectDispatches,
  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
};

module.exports = EventPropagators;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 */

// TODO: Replace this with ES6: var ReactInstanceMap = new Map();

var ReactInstanceMap = {
  /**
   * This API should be called `delete` but we'd have to make sure to always
   * transform these to strings for IE support. When this transform is fully
   * supported we can rename it.
   */
  remove: function (key) {
    key._reactInternalInstance = undefined;
  },

  get: function (key) {
    return key._reactInternalInstance;
  },

  has: function (key) {
    return key._reactInternalInstance !== undefined;
  },

  set: function (key, value) {
    key._reactInternalInstance = value;
  }
};

module.exports = ReactInstanceMap;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(19);

var getEventTarget = __webpack_require__(79);

/**
 * @interface UIEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var UIEventInterface = {
  view: function (event) {
    if (event.view) {
      return event.view;
    }

    var target = getEventTarget(event);
    if (target.window === target) {
      // target is a window object
      return target;
    }

    var doc = target.ownerDocument;
    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
    if (doc) {
      return doc.defaultView || doc.parentWindow;
    } else {
      return window;
    }
  },
  detail: function (event) {
    return event.detail || 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);

module.exports = SyntheticUIEvent;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
exports.canUseDOM = canUseDOM;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(15);

var _warning2 = _interopRequireDefault(_warning);

var _queryString = __webpack_require__(230);

var _runTransitionHook = __webpack_require__(65);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _PathUtils = __webpack_require__(23);

var _deprecate = __webpack_require__(64);

var _deprecate2 = _interopRequireDefault(_deprecate);

var SEARCH_BASE_KEY = '$searchBase';

function defaultStringifyQuery(query) {
  return _queryString.stringify(query).replace(/%20/g, '+');
}

var defaultParseQueryString = _queryString.parse;

function isNestedObject(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p) && typeof object[p] === 'object' && !Array.isArray(object[p]) && object[p] !== null) return true;
  }return false;
}

/**
 * Returns a new createHistory function that may be used to create
 * history objects that know how to handle URL queries.
 */
function useQueries(createHistory) {
  return function () {
    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var history = createHistory(options);

    var stringifyQuery = options.stringifyQuery;
    var parseQueryString = options.parseQueryString;

    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;

    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;

    function addQuery(location) {
      if (location.query == null) {
        var search = location.search;

        location.query = parseQueryString(search.substring(1));
        location[SEARCH_BASE_KEY] = { search: search, searchBase: '' };
      }

      // TODO: Instead of all the book-keeping here, this should just strip the
      // stringified query from the search.

      return location;
    }

    function appendQuery(location, query) {
      var _extends2;

      var searchBaseSpec = location[SEARCH_BASE_KEY];
      var queryString = query ? stringifyQuery(query) : '';
      if (!searchBaseSpec && !queryString) {
        return location;
      }

       false ? _warning2['default'](stringifyQuery !== defaultStringifyQuery || !isNestedObject(query), 'useQueries does not stringify nested query objects by default; ' + 'use a custom stringifyQuery function') : undefined;

      if (typeof location === 'string') location = _PathUtils.parsePath(location);

      var searchBase = undefined;
      if (searchBaseSpec && location.search === searchBaseSpec.search) {
        searchBase = searchBaseSpec.searchBase;
      } else {
        searchBase = location.search || '';
      }

      var search = searchBase;
      if (queryString) {
        search += (search ? '&' : '?') + queryString;
      }

      return _extends({}, location, (_extends2 = {
        search: search
      }, _extends2[SEARCH_BASE_KEY] = { search: search, searchBase: searchBase }, _extends2));
    }

    // Override all read methods with query-aware versions.
    function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        _runTransitionHook2['default'](hook, addQuery(location), callback);
      });
    }

    function listen(listener) {
      return history.listen(function (location) {
        listener(addQuery(location));
      });
    }

    // Override all write methods with query-aware versions.
    function push(location) {
      history.push(appendQuery(location, location.query));
    }

    function replace(location) {
      history.replace(appendQuery(location, location.query));
    }

    function createPath(location, query) {
       false ? _warning2['default'](!query, 'the query argument to createPath is deprecated; use a location descriptor instead') : undefined;

      return history.createPath(appendQuery(location, query || location.query));
    }

    function createHref(location, query) {
       false ? _warning2['default'](!query, 'the query argument to createHref is deprecated; use a location descriptor instead') : undefined;

      return history.createHref(appendQuery(location, query || location.query));
    }

    function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var fullLocation = history.createLocation.apply(history, [appendQuery(location, location.query)].concat(args));
      if (location.query) {
        fullLocation.query = location.query;
      }
      return addQuery(fullLocation);
    }

    // deprecated
    function pushState(state, path, query) {
      if (typeof path === 'string') path = _PathUtils.parsePath(path);

      push(_extends({ state: state }, path, { query: query }));
    }

    // deprecated
    function replaceState(state, path, query) {
      if (typeof path === 'string') path = _PathUtils.parsePath(path);

      replace(_extends({ state: state }, path, { query: query }));
    }

    return _extends({}, history, {
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation,

      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
    });
  };
}

exports['default'] = useQueries;
module.exports = exports['default'];

/***/ }),
/* 48 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(7);

var EventPluginRegistry = __webpack_require__(69);
var ReactEventEmitterMixin = __webpack_require__(260);
var ViewportMetrics = __webpack_require__(119);

var getVendorPrefixedEventName = __webpack_require__(292);
var isEventSupported = __webpack_require__(80);

/**
 * Summary of `ReactBrowserEventEmitter` event handling:
 *
 *  - Top-level delegation is used to trap most native browser events. This
 *    may only occur in the main thread and is the responsibility of
 *    ReactEventListener, which is injected and can therefore support pluggable
 *    event sources. This is the only work that occurs in the main thread.
 *
 *  - We normalize and de-duplicate events to account for browser quirks. This
 *    may be done in the worker thread.
 *
 *  - Forward these native events (with the associated top-level type used to
 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
 *    to extract any synthetic events.
 *
 *  - The `EventPluginHub` will then process each event by annotating them with
 *    "dispatches", a sequence of listeners and IDs that care about that event.
 *
 *  - The `EventPluginHub` then dispatches the events.
 *
 * Overview of React and the event system:
 *
 * +------------+    .
 * |    DOM     |    .
 * +------------+    .
 *       |           .
 *       v           .
 * +------------+    .
 * | ReactEvent |    .
 * |  Listener  |    .
 * +------------+    .                         +-----------+
 *       |           .               +--------+|SimpleEvent|
 *       |           .               |         |Plugin     |
 * +-----|------+    .               v         +-----------+
 * |     |      |    .    +--------------+                    +------------+
 * |     +-----------.--->|EventPluginHub|                    |    Event   |
 * |            |    .    |              |     +-----------+  | Propagators|
 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
 * |            |    .    |              |     +-----------+  |  utilities |
 * |     +-----------.--->|              |                    +------------+
 * |     |      |    .    +--------------+
 * +-----|------+    .                ^        +-----------+
 *       |           .                |        |Enter/Leave|
 *       +           .                +-------+|Plugin     |
 * +-------------+   .                         +-----------+
 * | application |   .
 * |-------------|   .
 * |             |   .
 * |             |   .
 * +-------------+   .
 *                   .
 *    React Core     .  General Purpose Event Plugin System
 */

var hasEventPageXY;
var alreadyListeningTo = {};
var isMonitoringScrollValue = false;
var reactTopListenersCounter = 0;

// For events like 'submit' which don't consistently bubble (which we trap at a
// lower node than `document`), binding at `document` would cause duplicate
// events so we don't include them here
var topEventMapping = {
  topAbort: 'abort',
  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
  topBlur: 'blur',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topChange: 'change',
  topClick: 'click',
  topCompositionEnd: 'compositionend',
  topCompositionStart: 'compositionstart',
  topCompositionUpdate: 'compositionupdate',
  topContextMenu: 'contextmenu',
  topCopy: 'copy',
  topCut: 'cut',
  topDoubleClick: 'dblclick',
  topDrag: 'drag',
  topDragEnd: 'dragend',
  topDragEnter: 'dragenter',
  topDragExit: 'dragexit',
  topDragLeave: 'dragleave',
  topDragOver: 'dragover',
  topDragStart: 'dragstart',
  topDrop: 'drop',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topFocus: 'focus',
  topInput: 'input',
  topKeyDown: 'keydown',
  topKeyPress: 'keypress',
  topKeyUp: 'keyup',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topMouseDown: 'mousedown',
  topMouseMove: 'mousemove',
  topMouseOut: 'mouseout',
  topMouseOver: 'mouseover',
  topMouseUp: 'mouseup',
  topPaste: 'paste',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topScroll: 'scroll',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topSelectionChange: 'selectionchange',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTextInput: 'textInput',
  topTimeUpdate: 'timeupdate',
  topTouchCancel: 'touchcancel',
  topTouchEnd: 'touchend',
  topTouchMove: 'touchmove',
  topTouchStart: 'touchstart',
  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting',
  topWheel: 'wheel'
};

/**
 * To ensure no conflicts with other potential React instances on the page
 */
var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);

function getListeningForDocument(mountAt) {
  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
  // directly.
  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
    mountAt[topListenersIDKey] = reactTopListenersCounter++;
    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
  }
  return alreadyListeningTo[mountAt[topListenersIDKey]];
}

/**
 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
 * example:
 *
 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
 *
 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
 *
 * @internal
 */
var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
  /**
   * Injectable event backend
   */
  ReactEventListener: null,

  injection: {
    /**
     * @param {object} ReactEventListener
     */
    injectReactEventListener: function (ReactEventListener) {
      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
    }
  },

  /**
   * Sets whether or not any created callbacks should be enabled.
   *
   * @param {boolean} enabled True if callbacks should be enabled.
   */
  setEnabled: function (enabled) {
    if (ReactBrowserEventEmitter.ReactEventListener) {
      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
    }
  },

  /**
   * @return {boolean} True if callbacks are enabled.
   */
  isEnabled: function () {
    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
  },

  /**
   * We listen for bubbled touch events on the document object.
   *
   * Firefox v8.01 (and possibly others) exhibited strange behavior when
   * mounting `onmousemove` events at some node that was not the document
   * element. The symptoms were that if your mouse is not moving over something
   * contained within that mount point (for example on the background) the
   * top-level listeners for `onmousemove` won't be called. However, if you
   * register the `mousemove` on the document object, then it will of course
   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
   * top-level listeners to the document object only, at least for these
   * movement types of events and possibly all events.
   *
   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
   *
   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
   * they bubble to document.
   *
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {object} contentDocumentHandle Document which owns the container
   */
  listenTo: function (registrationName, contentDocumentHandle) {
    var mountAt = contentDocumentHandle;
    var isListening = getListeningForDocument(mountAt);
    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];

    for (var i = 0; i < dependencies.length; i++) {
      var dependency = dependencies[i];
      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
        if (dependency === 'topWheel') {
          if (isEventSupported('wheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
          } else if (isEventSupported('mousewheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
          } else {
            // Firefox needs to capture a different mouse scroll event.
            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
          }
        } else if (dependency === 'topScroll') {
          if (isEventSupported('scroll', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
          } else {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
          }
        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
          if (isEventSupported('focus', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
          } else if (isEventSupported('focusin')) {
            // IE has `focusin` and `focusout` events which bubble.
            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
          }

          // to make sure blur and focus event listeners are only attached once
          isListening.topBlur = true;
          isListening.topFocus = true;
        } else if (topEventMapping.hasOwnProperty(dependency)) {
          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
        }

        isListening[dependency] = true;
      }
    }
  },

  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
  },

  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
  },

  /**
   * Protect against document.createEvent() returning null
   * Some popup blocker extensions appear to do this:
   * https://github.com/facebook/react/issues/6887
   */
  supportsEventPageXY: function () {
    if (!document.createEvent) {
      return false;
    }
    var ev = document.createEvent('MouseEvent');
    return ev != null && 'pageX' in ev;
  },

  /**
   * Listens to window scroll and resize events. We cache scroll values so that
   * application code can access them without triggering reflows.
   *
   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
   * pageX/pageY isn't supported (legacy browsers).
   *
   * NOTE: Scroll events do not bubble.
   *
   * @see http://www.quirksmode.org/dom/events/scroll.html
   */
  ensureScrollValueMonitoring: function () {
    if (hasEventPageXY === undefined) {
      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
    }
    if (!hasEventPageXY && !isMonitoringScrollValue) {
      var refresh = ViewportMetrics.refreshScrollValues;
      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
      isMonitoringScrollValue = true;
    }
  }
});

module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(43);
var ViewportMetrics = __webpack_require__(119);

var getEventModifierState = __webpack_require__(78);

/**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var MouseEventInterface = {
  screenX: null,
  screenY: null,
  clientX: null,
  clientY: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  getModifierState: getEventModifierState,
  button: function (event) {
    // Webkit, Firefox, IE9+
    // which:  1 2 3
    // button: 0 1 2 (standard)
    var button = event.button;
    if ('which' in event) {
      return button;
    }
    // IE<9
    // which:  undefined
    // button: 0 0 0
    // button: 1 4 2 (onmouseup)
    return button === 2 ? 2 : button === 4 ? 1 : 0;
  },
  buttons: null,
  relatedTarget: function (event) {
    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
  },
  // "Proprietary" Interface.
  pageX: function (event) {
    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
  },
  pageY: function (event) {
    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);

module.exports = SyntheticMouseEvent;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(4);

var invariant = __webpack_require__(1);

var OBSERVED_ERROR = {};

/**
 * `Transaction` creates a black box that is able to wrap any method such that
 * certain invariants are maintained before and after the method is invoked
 * (Even if an exception is thrown while invoking the wrapped method). Whoever
 * instantiates a transaction can provide enforcers of the invariants at
 * creation time. The `Transaction` class itself will supply one additional
 * automatic invariant for you - the invariant that any transaction instance
 * should not be run while it is already being run. You would typically create a
 * single instance of a `Transaction` for reuse multiple times, that potentially
 * is used to wrap several different methods. Wrappers are extremely simple -
 * they only require implementing two methods.
 *
 * <pre>
 *                       wrappers (injected at creation time)
 *                                      +        +
 *                                      |        |
 *                    +-----------------|--------|--------------+
 *                    |                 v        |              |
 *                    |      +---------------+   |              |
 *                    |   +--|    wrapper1   |---|----+         |
 *                    |   |  +---------------+   v    |         |
 *                    |   |          +-------------+  |         |
 *                    |   |     +----|   wrapper2  |--------+   |
 *                    |   |     |    +-------------+  |     |   |
 *                    |   |     |                     |     |   |
 *                    |   v     v                     v     v   | wrapper
 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | +---+ +---+   +---------+   +---+ +---+ |
 *                    |  initialize                    close    |
 *                    +-----------------------------------------+
 * </pre>
 *
 * Use cases:
 * - Preserving the input selection ranges before/after reconciliation.
 *   Restoring selection even in the event of an unexpected error.
 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
 *   while guaranteeing that afterwards, the event system is reactivated.
 * - Flushing a queue of collected DOM mutations to the main UI thread after a
 *   reconciliation takes place in a worker thread.
 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
 *   content.
 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
 * - (Future use case): Layout calculations before and after DOM updates.
 *
 * Transactional plugin API:
 * - A module that has an `initialize` method that returns any precomputation.
 * - and a `close` method that accepts the precomputation. `close` is invoked
 *   when the wrapped process is completed, or has failed.
 *
 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
 * that implement `initialize` and `close`.
 * @return {Transaction} Single transaction for reuse in thread.
 *
 * @class Transaction
 */
var TransactionImpl = {
  /**
   * Sets up this instance so that it is prepared for collecting metrics. Does
   * so such that this setup method may be used on an instance that is already
   * initialized, in a way that does not consume additional memory upon reuse.
   * That can be useful if you decide to make your subclass of this mixin a
   * "PooledClass".
   */
  reinitializeTransaction: function () {
    this.transactionWrappers = this.getTransactionWrappers();
    if (this.wrapperInitData) {
      this.wrapperInitData.length = 0;
    } else {
      this.wrapperInitData = [];
    }
    this._isInTransaction = false;
  },

  _isInTransaction: false,

  /**
   * @abstract
   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
   */
  getTransactionWrappers: null,

  isInTransaction: function () {
    return !!this._isInTransaction;
  },

  /* eslint-disable space-before-function-paren */

  /**
   * Executes the function within a safety window. Use this for the top level
   * methods that result in large amounts of computation/mutations that would
   * need to be safety checked. The optional arguments helps prevent the need
   * to bind in many cases.
   *
   * @param {function} method Member of scope to call.
   * @param {Object} scope Scope to invoke from.
   * @param {Object?=} a Argument to pass to the method.
   * @param {Object?=} b Argument to pass to the method.
   * @param {Object?=} c Argument to pass to the method.
   * @param {Object?=} d Argument to pass to the method.
   * @param {Object?=} e Argument to pass to the method.
   * @param {Object?=} f Argument to pass to the method.
   *
   * @return {*} Return value from `method`.
   */
  perform: function (method, scope, a, b, c, d, e, f) {
    /* eslint-enable space-before-function-paren */
    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
    var errorThrown;
    var ret;
    try {
      this._isInTransaction = true;
      // Catching errors makes debugging more difficult, so we start with
      // errorThrown set to true before setting it to false after calling
      // close -- if it's still set to true in the finally block, it means
      // one of these calls threw.
      errorThrown = true;
      this.initializeAll(0);
      ret = method.call(scope, a, b, c, d, e, f);
      errorThrown = false;
    } finally {
      try {
        if (errorThrown) {
          // If `method` throws, prefer to show that stack trace over any thrown
          // by invoking `closeAll`.
          try {
            this.closeAll(0);
          } catch (err) {}
        } else {
          // Since `method` didn't throw, we don't want to silence the exception
          // here.
          this.closeAll(0);
        }
      } finally {
        this._isInTransaction = false;
      }
    }
    return ret;
  },

  initializeAll: function (startIndex) {
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      try {
        // Catching errors makes debugging more difficult, so we start with the
        // OBSERVED_ERROR state before overwriting it with the real return value
        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
        // block, it means wrapper.initialize threw.
        this.wrapperInitData[i] = OBSERVED_ERROR;
        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
      } finally {
        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
          // The initializer for wrapper i threw an error; initialize the
          // remaining wrappers but silence any exceptions from them to ensure
          // that the first error is the one to bubble up.
          try {
            this.initializeAll(i + 1);
          } catch (err) {}
        }
      }
    }
  },

  /**
   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
   * them the respective return values of `this.transactionWrappers.init[i]`
   * (`close`rs that correspond to initializers that failed will not be
   * invoked).
   */
  closeAll: function (startIndex) {
    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      var initData = this.wrapperInitData[i];
      var errorThrown;
      try {
        // Catching errors makes debugging more difficult, so we start with
        // errorThrown set to true before setting it to false after calling
        // close -- if it's still set to true in the finally block, it means
        // wrapper.close threw.
        errorThrown = true;
        if (initData !== OBSERVED_ERROR && wrapper.close) {
          wrapper.close.call(this, initData);
        }
        errorThrown = false;
      } finally {
        if (errorThrown) {
          // The closer for wrapper i threw an error; close the remaining
          // wrappers but silence any exceptions from them to ensure that the
          // first error is the one to bubble up.
          try {
            this.closeAll(i + 1);
          } catch (e) {}
        }
      }
    }
    this.wrapperInitData.length = 0;
  }
};

module.exports = TransactionImpl;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * Based on the escape-html library, which is used under the MIT License below:
 *
 * Copyright (c) 2012-2013 TJ Holowaychuk
 * Copyright (c) 2015 Andreas Lubbe
 * Copyright (c) 2015 Tiancheng "Timothy" Gu
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 */



// code copied and modified from escape-html
/**
 * Module variables.
 * @private
 */

var matchHtmlRegExp = /["'&<>]/;

/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */

function escapeHtml(string) {
  var str = '' + string;
  var match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  var escape;
  var html = '';
  var index = 0;
  var lastIndex = 0;

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34:
        // "
        escape = '&quot;';
        break;
      case 38:
        // &
        escape = '&amp;';
        break;
      case 39:
        // '
        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
        break;
      case 60:
        // <
        escape = '&lt;';
        break;
      case 62:
        // >
        escape = '&gt;';
        break;
      default:
        continue;
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += escape;
  }

  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}
// end code copied and modified from escape-html

/**
 * Escapes text to prevent scripting attacks.
 *
 * @param {*} text Text value to escape.
 * @return {string} An escaped string.
 */
function escapeTextContentForBrowser(text) {
  if (typeof text === 'boolean' || typeof text === 'number') {
    // this shortcircuit helps perf for types that we know will never have
    // special characters, especially given that this function is used often
    // for numeric dom ids.
    return '' + text;
  }
  return escapeHtml(text);
}

module.exports = escapeTextContentForBrowser;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(12);
var DOMNamespaces = __webpack_require__(68);

var WHITESPACE_TEST = /^[ \r\n\t\f]/;
var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;

var createMicrosoftUnsafeLocalFunction = __webpack_require__(76);

// SVG temp container for IE lacking innerHTML
var reusableSVGContainer;

/**
 * Set the innerHTML property of a node, ensuring that whitespace is preserved
 * even in IE8.
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */
var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
  // IE does not have innerHTML for SVG nodes, so instead we inject the
  // new markup in a temp node and then move the child nodes across into
  // the target node
  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
    var svgNode = reusableSVGContainer.firstChild;
    while (svgNode.firstChild) {
      node.appendChild(svgNode.firstChild);
    }
  } else {
    node.innerHTML = html;
  }
});

if (ExecutionEnvironment.canUseDOM) {
  // IE8: When updating a just created node with innerHTML only leading
  // whitespace is removed. When updating an existing node with innerHTML
  // whitespace in root TextNodes is also collapsed.
  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html

  // Feature detection; only IE8 is known to behave improperly like this.
  var testElement = document.createElement('div');
  testElement.innerHTML = ' ';
  if (testElement.innerHTML === '') {
    setInnerHTML = function (node, html) {
      // Magic theory: IE8 supposedly differentiates between added and updated
      // nodes when processing innerHTML, innerHTML on updated nodes suffers
      // from worse whitespace behavior. Re-adding a node like this triggers
      // the initial and more favorable whitespace behavior.
      // TODO: What to do on a detached node?
      if (node.parentNode) {
        node.parentNode.replaceChild(node, node);
      }

      // We also implement a workaround for non-visible tags disappearing into
      // thin air on IE8, this only happens if there is no visible text
      // in-front of the non-visible tags. Piggyback on the whitespace fix
      // and simply check if any non-visible tags appear in the source.
      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
        // Recover leading whitespace by temporarily prepending any character.
        // \uFEFF has the potential advantage of being zero-width/invisible.
        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
        // in hopes that this is preserved even if "\uFEFF" is transformed to
        // the actual Unicode character (by Babel, for example).
        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
        node.innerHTML = String.fromCharCode(0xfeff) + html;

        // deleteData leaves an empty `TextNode` which offsets the index of all
        // children. Definitely want to avoid this.
        var textNode = node.firstChild;
        if (textNode.data.length === 1) {
          node.removeChild(textNode);
        } else {
          textNode.deleteData(0, 1);
        }
      } else {
        node.innerHTML = html;
      }
    };
  }
  testElement = null;
}

module.exports = setInnerHTML;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}



exports.__esModule = true;
exports['default'] = stripStyle;

function stripStyle(style) {
  var ret = {};
  for (var key in style) {
    if (!Object.prototype.hasOwnProperty.call(style, key)) {
      continue;
    }
    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
  }
  return ret;
}

module.exports = exports['default'];

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(10);

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _deprecateObjectProperties = __webpack_require__(56);

var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);

var _getRouteParams = __webpack_require__(315);

var _getRouteParams2 = _interopRequireDefault(_getRouteParams);

var _RouteUtils = __webpack_require__(22);

var _routerWarning = __webpack_require__(9);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _React$PropTypes = _react2.default.PropTypes;
var array = _React$PropTypes.array;
var func = _React$PropTypes.func;
var object = _React$PropTypes.object;

/**
 * A <RouterContext> renders the component tree for a given router state
 * and sets the history object and the current location in context.
 */

var RouterContext = _react2.default.createClass({
  displayName: 'RouterContext',


  propTypes: {
    history: object,
    router: object.isRequired,
    location: object.isRequired,
    routes: array.isRequired,
    params: object.isRequired,
    components: array.isRequired,
    createElement: func.isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      createElement: _react2.default.createElement
    };
  },


  childContextTypes: {
    history: object,
    location: object.isRequired,
    router: object.isRequired
  },

  getChildContext: function getChildContext() {
    var _props = this.props;
    var router = _props.router;
    var history = _props.history;
    var location = _props.location;

    if (!router) {
       false ? (0, _routerWarning2.default)(false, '`<RouterContext>` expects a `router` rather than a `history`') : void 0;

      router = _extends({}, history, {
        setRouteLeaveHook: history.listenBeforeLeavingRoute
      });
      delete router.listenBeforeLeavingRoute;
    }

    if (false) {
      location = (0, _deprecateObjectProperties2.default)(location, '`context.location` is deprecated, please use a route component\'s `props.location` instead. http://tiny.cc/router-accessinglocation');
    }

    return { history: history, location: location, router: router };
  },
  createElement: function createElement(component, props) {
    return component == null ? null : this.props.createElement(component, props);
  },
  render: function render() {
    var _this = this;

    var _props2 = this.props;
    var history = _props2.history;
    var location = _props2.location;
    var routes = _props2.routes;
    var params = _props2.params;
    var components = _props2.components;

    var element = null;

    if (components) {
      element = components.reduceRight(function (element, components, index) {
        if (components == null) return element; // Don't create new children; use the grandchildren.

        var route = routes[index];
        var routeParams = (0, _getRouteParams2.default)(route, params);
        var props = {
          history: history,
          location: location,
          params: params,
          route: route,
          routeParams: routeParams,
          routes: routes
        };

        if ((0, _RouteUtils.isReactChildren)(element)) {
          props.children = element;
        } else if (element) {
          for (var prop in element) {
            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
          }
        }

        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
          var elements = {};

          for (var key in components) {
            if (Object.prototype.hasOwnProperty.call(components, key)) {
              // Pass through the key as a prop to createElement to allow
              // custom createElement functions to know which named component
              // they're rendering, for e.g. matching up to fetched data.
              elements[key] = _this.createElement(components[key], _extends({
                key: key }, props));
            }
          }

          return elements;
        }

        return _this.createElement(components, props);
      }, element);
    }

    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;

    return element;
  }
});

exports.default = RouterContext;
module.exports = exports['default'];

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.canUseMembrane = undefined;

var _routerWarning = __webpack_require__(9);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var canUseMembrane = exports.canUseMembrane = false;

// No-op by default.
var deprecateObjectProperties = function deprecateObjectProperties(object) {
  return object;
};

if (false) {
  try {
    if (Object.defineProperty({}, 'x', {
      get: function get() {
        return true;
      }
    }).x) {
      exports.canUseMembrane = canUseMembrane = true;
    }
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

  if (canUseMembrane) {
    deprecateObjectProperties = function deprecateObjectProperties(object, message) {
      // Wrap the deprecated object in a membrane to warn on property access.
      var membrane = {};

      var _loop = function _loop(prop) {
        if (!Object.prototype.hasOwnProperty.call(object, prop)) {
          return 'continue';
        }

        if (typeof object[prop] === 'function') {
          // Can't use fat arrow here because of use of arguments below.
          membrane[prop] = function () {
            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
            return object[prop].apply(object, arguments);
          };
          return 'continue';
        }

        // These properties are non-enumerable to prevent React dev tools from
        // seeing them and causing spurious warnings when accessing them. In
        // principle this could be done with a proxy, but support for the
        // ownKeys trap on proxies is not universal, even among browsers that
        // otherwise support proxies.
        Object.defineProperty(membrane, prop, {
          get: function get() {
            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
            return object[prop];
          }
        });
      };

      for (var prop in object) {
        var _ret = _loop(prop);

        if (_ret === 'continue') continue;
      }

      return membrane;
    };
  }
}

exports.default = deprecateObjectProperties;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(228)();
}


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var invariant = __webpack_require__(10);

var hasOwnProperty = Object.prototype.hasOwnProperty;
var splice = Array.prototype.splice;

var assign = Object.assign || /* istanbul ignore next */ function assign(target, source) {
  getAllKeys(source).forEach(function(key) {
    if (hasOwnProperty.call(source, key)) {
      target[key] = source[key];
    }
  });
  return target;
};

var getAllKeys = typeof Object.getOwnPropertySymbols === 'function' ?
  function(obj) { return Object.keys(obj).concat(Object.getOwnPropertySymbols(obj)) } :
  /* istanbul ignore next */ function(obj) { return Object.keys(obj) };

/* istanbul ignore next */
function copy(object) {
  if (object instanceof Array) {
    return assign(object.constructor(object.length), object)
  } else if (object && typeof object === 'object') {
    var prototype = object.constructor && object.constructor.prototype
    return assign(Object.create(prototype || null), object);
  } else {
    return object;
  }
}

function newContext() {
  var commands = assign({}, defaultCommands);
  update.extend = function(directive, fn) {
    commands[directive] = fn;
  };
  update.isEquals = function(a, b) { return a === b; };

  return update;

  function update(object, spec) {
    if (!(Array.isArray(object) && Array.isArray(spec))) {
      invariant(
        !Array.isArray(spec),
        'update(): You provided an invalid spec to update(). The spec may ' +
        'not contain an array except as the value of $set, $push, $unshift, ' +
        '$splice or any custom command allowing an array value.'
      );
    }

    invariant(
      typeof spec === 'object' && spec !== null,
      'update(): You provided an invalid spec to update(). The spec and ' +
      'every included key path must be plain objects containing one of the ' +
      'following commands: %s.',
      Object.keys(commands).join(', ')
    );

    var nextObject = object;
    var index, key;
    getAllKeys(spec).forEach(function(key) {
      if (hasOwnProperty.call(commands, key)) {
        var objectWasNextObject = object === nextObject;
        nextObject = commands[key](spec[key], nextObject, spec, object);
        if (objectWasNextObject && update.isEquals(nextObject, object)) {
          nextObject = object;
        }
      } else {
        var nextValueForKey = update(object[key], spec[key]);
        if (!update.isEquals(nextValueForKey, nextObject[key])) {
          if (nextObject === object) {
            nextObject = copy(object);
          }
          nextObject[key] = nextValueForKey;
        }
      }
    })
    return nextObject;
  }

}

var defaultCommands = {
  $push: function(value, nextObject, spec) {
    invariantPushAndUnshift(nextObject, spec, '$push');
    return value.length ? nextObject.concat(value) : nextObject;
  },
  $unshift: function(value, nextObject, spec) {
    invariantPushAndUnshift(nextObject, spec, '$unshift');
    return value.length ? value.concat(nextObject) : nextObject;
  },
  $splice: function(value, nextObject, spec, originalObject) {
    invariantSplices(nextObject, spec);
    value.forEach(function(args) {
      invariantSplice(args);
      if (nextObject === originalObject && args.length) nextObject = copy(originalObject);
      splice.apply(nextObject, args);
    });
    return nextObject;
  },
  $set: function(value, nextObject, spec) {
    invariantSet(spec);
    return value;
  },
  $unset: function(value, nextObject, spec, originalObject) {
    invariant(
      Array.isArray(value),
      'update(): expected spec of $unset to be an array; got %s. ' +
      'Did you forget to wrap the key(s) in an array?',
      value
    );
    value.forEach(function(key) {
      if (Object.hasOwnProperty.call(nextObject, key)) {
        if (nextObject === originalObject) nextObject = copy(originalObject);
        delete nextObject[key];
      }
    });
    return nextObject;
  },
  $merge: function(value, nextObject, spec, originalObject) {
    invariantMerge(nextObject, value);
    getAllKeys(value).forEach(function(key) {
      if (value[key] !== nextObject[key]) {
        if (nextObject === originalObject) nextObject = copy(originalObject);
        nextObject[key] = value[key];
      }
    });
    return nextObject;
  },
  $apply: function(value, original) {
    invariantApply(value);
    return value(original);
  }
};

module.exports = newContext();
module.exports.newContext = newContext;

// invariants

function invariantPushAndUnshift(value, spec, command) {
  invariant(
    Array.isArray(value),
    'update(): expected target of %s to be an array; got %s.',
    command,
    value
  );
  var specValue = spec[command];
  invariant(
    Array.isArray(specValue),
    'update(): expected spec of %s to be an array; got %s. ' +
    'Did you forget to wrap your parameter in an array?',
    command,
    specValue
  );
}

function invariantSplices(value, spec) {
  invariant(
    Array.isArray(value),
    'Expected $splice target to be an array; got %s',
    value
  );
  invariantSplice(spec['$splice']);
}

function invariantSplice(value) {
  invariant(
    Array.isArray(value),
    'update(): expected spec of $splice to be an array of arrays; got %s. ' +
    'Did you forget to wrap your parameters in an array?',
    value
  );
}

function invariantApply(fn) {
  invariant(
    typeof fn === 'function',
    'update(): expected spec of $apply to be a function; got %s.',
    fn
  );
}

function invariantSet(spec) {
  invariant(
    Object.keys(spec).length === 1,
    'Cannot have more than one key in an object with $set'
  );
}

function invariantMerge(target, specValue) {
  invariant(
    specValue && typeof specValue === 'object',
    'update(): $merge expects a spec of type \'object\'; got %s',
    specValue
  );
  invariant(
    target && typeof target === 'object',
    'update(): $merge expects a target of type \'object\'; got %s',
    target
  );
}


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_events__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dispatcher__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_constants__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var ProductStore = function (_EventEmitter) {
    _inherits(ProductStore, _EventEmitter);

    function ProductStore() {
        _classCallCheck(this, ProductStore);

        var _this = _possibleConstructorReturn(this, (ProductStore.__proto__ || Object.getPrototypeOf(ProductStore)).call(this));

        _this.products = [];
        return _this;
    }

    _createClass(ProductStore, [{
        key: "getAll",
        value: function getAll() {
            return this.products;
        }
    }, {
        key: "handleAction",
        value: function handleAction(action) {
            switch (action.type) {
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["b" /* productConstant */].PRODUCT_CREATED:
                    {
                        var product = action.product;

                        this.products.push(product);
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["b" /* productConstant */].PRODUCT_CREATED, "product " + product.productName + " created successfully.");
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["b" /* productConstant */].PRODUCTS_STORE_CHANGE);
                        break;
                    }
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["b" /* productConstant */].PRODUCT_CREATION_FAILED:
                    {
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["b" /* productConstant */].PRODUCT_CREATION_FAILED, action.msg);
                        break;
                    }
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["b" /* productConstant */].FETCHED_ALL_PRODUCTS:
                    {
                        this.products = action.data;
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["b" /* productConstant */].PRODUCTS_STORE_CHANGE);
                        break;
                    }
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["b" /* productConstant */].PRODUCTS_FETCH_FAILED:
                    {
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["b" /* productConstant */].PRODUCTS_FETCH_FAILED, action.msg);
                        break;
                    }
                default:
                    break;
            }
        }
    }]);

    return ProductStore;
}(__WEBPACK_IMPORTED_MODULE_0_events__["EventEmitter"]);

var productStore = new ProductStore();
__WEBPACK_IMPORTED_MODULE_1__dispatcher__["a" /* default */].register(productStore.handleAction.bind(productStore));
//window.productStore = productStore;
//window.dispatcher = dispatcher;
/* harmony default export */ __webpack_exports__["a"] = (productStore);

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(231)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function() {
  root.requestAnimationFrame = raf
  root.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(90)))

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_events__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dispatcher__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_constants__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var TankStore = function (_EventEmitter) {
    _inherits(TankStore, _EventEmitter);

    function TankStore() {
        _classCallCheck(this, TankStore);

        var _this = _possibleConstructorReturn(this, (TankStore.__proto__ || Object.getPrototypeOf(TankStore)).call(this));

        _this.tanks = [];
        _this.dipTable = [];
        return _this;
    }

    _createClass(TankStore, [{
        key: "getAll",
        value: function getAll() {
            return this.tanks;
        }
    }, {
        key: "getAllDip",
        value: function getAllDip() {
            return this.dipTable;
        }
    }, {
        key: "handleAction",
        value: function handleAction(action) {
            switch (action.type) {
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["k" /* tankConstant */].TANK_CREATED:
                    {
                        this.tanks.push(action.tank);
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["k" /* tankConstant */].TANK_CREATED, action.msg);
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["k" /* tankConstant */].TANK_STORE_CHANGE);
                        break;
                    }
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["k" /* tankConstant */].TANK_CREATION_FAILED:
                    {
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["k" /* tankConstant */].TANK_CREATION_FAILED, action.msg);
                        break;
                    }
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["k" /* tankConstant */].FETCHED_ALL_TANKS:
                    {
                        //console.log("inside tank store ", action.data);
                        this.tanks = action.data;
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["k" /* tankConstant */].TANK_STORE_CHANGE);
                        break;
                    }
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["k" /* tankConstant */].TANK_FETCH_FAILED:
                    {
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["k" /* tankConstant */].TANK_FETCH_FAILED, action.msg);
                        break;
                    }
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["k" /* tankConstant */].FETCHED_ALL_DIP_TABLE:
                    {

                        this.dipTable = action.data;
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["k" /* tankConstant */].FETCHED_ALL_DIP_TABLE, action.msg);
                        break;
                    }
                default:
                    break;
            }
        }
    }]);

    return TankStore;
}(__WEBPACK_IMPORTED_MODULE_0_events__["EventEmitter"]);

var tankStore = new TankStore();
__WEBPACK_IMPORTED_MODULE_1__dispatcher__["a" /* default */].register(tankStore.handleAction.bind(tankStore));
/* harmony default export */ __webpack_exports__["a"] = (tankStore);

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.addEventListener = addEventListener;
exports.removeEventListener = removeEventListener;
exports.getHashPath = getHashPath;
exports.replaceHashPath = replaceHashPath;
exports.getWindowPath = getWindowPath;
exports.go = go;
exports.getUserConfirmation = getUserConfirmation;
exports.supportsHistory = supportsHistory;
exports.supportsGoWithoutReloadUsingHash = supportsGoWithoutReloadUsingHash;

function addEventListener(node, event, listener) {
  if (node.addEventListener) {
    node.addEventListener(event, listener, false);
  } else {
    node.attachEvent('on' + event, listener);
  }
}

function removeEventListener(node, event, listener) {
  if (node.removeEventListener) {
    node.removeEventListener(event, listener, false);
  } else {
    node.detachEvent('on' + event, listener);
  }
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  return window.location.href.split('#')[1] || '';
}

function replaceHashPath(path) {
  window.location.replace(window.location.pathname + window.location.search + '#' + path);
}

function getWindowPath() {
  return window.location.pathname + window.location.search + window.location.hash;
}

function go(n) {
  if (n) window.history.go(n);
}

function getUserConfirmation(message, callback) {
  callback(window.confirm(message));
}

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/rackt/react-router/issues/586
 */

function supportsHistory() {
  var ua = navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) {
    return false;
  }
  return window.history && 'pushState' in window.history;
}

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  var ua = navigator.userAgent;
  return ua.indexOf('Firefox') === -1;
}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(15);

var _warning2 = _interopRequireDefault(_warning);

function deprecate(fn, message) {
  return function () {
     false ? _warning2['default'](false, '[history] ' + message) : undefined;
    return fn.apply(this, arguments);
  };
}

exports['default'] = deprecate;
module.exports = exports['default'];

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(15);

var _warning2 = _interopRequireDefault(_warning);

function runTransitionHook(hook, location, callback) {
  var result = hook(location, callback);

  if (hook.length < 2) {
    // Assume the hook runs synchronously and automatically
    // call the callback with the return value.
    callback(result);
  } else {
     false ? _warning2['default'](result === undefined, 'You should not "return" in a transition hook with a callback argument; call the callback instead') : undefined;
  }
}

exports['default'] = runTransitionHook;
module.exports = exports['default'];

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.7.1
(function() {
  var getNanoSeconds, hrtime, loadTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - loadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    loadTime = getNanoSeconds();
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)))

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMLazyTree = __webpack_require__(31);
var Danger = __webpack_require__(237);
var ReactDOMComponentTree = __webpack_require__(8);
var ReactInstrumentation = __webpack_require__(14);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(76);
var setInnerHTML = __webpack_require__(53);
var setTextContent = __webpack_require__(127);

function getNodeAfter(parentNode, node) {
  // Special case for text components, which return [open, close] comments
  // from getHostNode.
  if (Array.isArray(node)) {
    node = node[1];
  }
  return node ? node.nextSibling : parentNode.firstChild;
}

/**
 * Inserts `childNode` as a child of `parentNode` at the `index`.
 *
 * @param {DOMElement} parentNode Parent node in which to insert.
 * @param {DOMElement} childNode Child node to insert.
 * @param {number} index Index at which to insert the child.
 * @internal
 */
var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
  // We rely exclusively on `insertBefore(node, null)` instead of also using
  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
  // we are careful to use `null`.)
  parentNode.insertBefore(childNode, referenceNode);
});

function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
}

function moveChild(parentNode, childNode, referenceNode) {
  if (Array.isArray(childNode)) {
    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
  } else {
    insertChildAt(parentNode, childNode, referenceNode);
  }
}

function removeChild(parentNode, childNode) {
  if (Array.isArray(childNode)) {
    var closingComment = childNode[1];
    childNode = childNode[0];
    removeDelimitedText(parentNode, childNode, closingComment);
    parentNode.removeChild(closingComment);
  }
  parentNode.removeChild(childNode);
}

function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
  var node = openingComment;
  while (true) {
    var nextNode = node.nextSibling;
    insertChildAt(parentNode, node, referenceNode);
    if (node === closingComment) {
      break;
    }
    node = nextNode;
  }
}

function removeDelimitedText(parentNode, startNode, closingComment) {
  while (true) {
    var node = startNode.nextSibling;
    if (node === closingComment) {
      // The closing comment is removed by ReactMultiChild.
      break;
    } else {
      parentNode.removeChild(node);
    }
  }
}

function replaceDelimitedText(openingComment, closingComment, stringText) {
  var parentNode = openingComment.parentNode;
  var nodeAfterComment = openingComment.nextSibling;
  if (nodeAfterComment === closingComment) {
    // There are no text nodes between the opening and closing comments; insert
    // a new one if stringText isn't empty.
    if (stringText) {
      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
    }
  } else {
    if (stringText) {
      // Set the text content of the first node after the opening comment, and
      // remove all following nodes up until the closing comment.
      setTextContent(nodeAfterComment, stringText);
      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
    } else {
      removeDelimitedText(parentNode, openingComment, closingComment);
    }
  }

  if (false) {
    ReactInstrumentation.debugTool.onHostOperation({
      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
      type: 'replace text',
      payload: stringText
    });
  }
}

var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
if (false) {
  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
    if (prevInstance._debugID !== 0) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: prevInstance._debugID,
        type: 'replace with',
        payload: markup.toString()
      });
    } else {
      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
      if (nextInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: nextInstance._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  };
}

/**
 * Operations for updating with DOM children.
 */
var DOMChildrenOperations = {
  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,

  replaceDelimitedText: replaceDelimitedText,

  /**
   * Updates a component's children by processing a series of updates. The
   * update configurations are each expected to have a `parentNode` property.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  processUpdates: function (parentNode, updates) {
    if (false) {
      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
    }

    for (var k = 0; k < updates.length; k++) {
      var update = updates[k];
      switch (update.type) {
        case 'INSERT_MARKUP':
          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'insert child',
              payload: {
                toIndex: update.toIndex,
                content: update.content.toString()
              }
            });
          }
          break;
        case 'MOVE_EXISTING':
          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'move child',
              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
            });
          }
          break;
        case 'SET_MARKUP':
          setInnerHTML(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace children',
              payload: update.content.toString()
            });
          }
          break;
        case 'TEXT_CONTENT':
          setTextContent(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace text',
              payload: update.content.toString()
            });
          }
          break;
        case 'REMOVE_NODE':
          removeChild(parentNode, update.fromNode);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'remove child',
              payload: { fromIndex: update.fromIndex }
            });
          }
          break;
      }
    }
  }
};

module.exports = DOMChildrenOperations;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMNamespaces = {
  html: 'http://www.w3.org/1999/xhtml',
  mathml: 'http://www.w3.org/1998/Math/MathML',
  svg: 'http://www.w3.org/2000/svg'
};

module.exports = DOMNamespaces;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(4);

var invariant = __webpack_require__(1);

/**
 * Injectable ordering of event plugins.
 */
var eventPluginOrder = null;

/**
 * Injectable mapping from names to event plugin modules.
 */
var namesToPlugins = {};

/**
 * Recomputes the plugin list using the injected plugins and plugin ordering.
 *
 * @private
 */
function recomputePluginOrdering() {
  if (!eventPluginOrder) {
    // Wait until an `eventPluginOrder` is injected.
    return;
  }
  for (var pluginName in namesToPlugins) {
    var pluginModule = namesToPlugins[pluginName];
    var pluginIndex = eventPluginOrder.indexOf(pluginName);
    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
    if (EventPluginRegistry.plugins[pluginIndex]) {
      continue;
    }
    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
    var publishedEvents = pluginModule.eventTypes;
    for (var eventName in publishedEvents) {
      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
    }
  }
}

/**
 * Publishes an event so that it can be dispatched by the supplied plugin.
 *
 * @param {object} dispatchConfig Dispatch configuration for the event.
 * @param {object} PluginModule Plugin publishing the event.
 * @return {boolean} True if the event was successfully published.
 * @private
 */
function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;

  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
  if (phasedRegistrationNames) {
    for (var phaseName in phasedRegistrationNames) {
      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
        var phasedRegistrationName = phasedRegistrationNames[phaseName];
        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
      }
    }
    return true;
  } else if (dispatchConfig.registrationName) {
    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
    return true;
  }
  return false;
}

/**
 * Publishes a registration name that is used to identify dispatched events and
 * can be used with `EventPluginHub.putListener` to register listeners.
 *
 * @param {string} registrationName Registration name to add.
 * @param {object} PluginModule Plugin publishing the event.
 * @private
 */
function publishRegistrationName(registrationName, pluginModule, eventName) {
  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;

  if (false) {
    var lowerCasedName = registrationName.toLowerCase();
    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;

    if (registrationName === 'onDoubleClick') {
      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
    }
  }
}

/**
 * Registers plugins so that they can extract and dispatch events.
 *
 * @see {EventPluginHub}
 */
var EventPluginRegistry = {
  /**
   * Ordered list of injected plugins.
   */
  plugins: [],

  /**
   * Mapping from event name to dispatch config
   */
  eventNameDispatchConfigs: {},

  /**
   * Mapping from registration name to plugin module
   */
  registrationNameModules: {},

  /**
   * Mapping from registration name to event name
   */
  registrationNameDependencies: {},

  /**
   * Mapping from lowercase registration names to the properly cased version,
   * used to warn in the case of missing event handlers. Available
   * only in __DEV__.
   * @type {Object}
   */
  possibleRegistrationNames:  false ? {} : null,
  // Trust the developer to only use possibleRegistrationNames in __DEV__

  /**
   * Injects an ordering of plugins (by plugin name). This allows the ordering
   * to be decoupled from injection of the actual plugins so that ordering is
   * always deterministic regardless of packaging, on-the-fly injection, etc.
   *
   * @param {array} InjectedEventPluginOrder
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginOrder}
   */
  injectEventPluginOrder: function (injectedEventPluginOrder) {
    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
    // Clone the ordering so it cannot be dynamically mutated.
    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
    recomputePluginOrdering();
  },

  /**
   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
   * in the ordering injected by `injectEventPluginOrder`.
   *
   * Plugins can be injected as part of page initialization or on-the-fly.
   *
   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginsByName}
   */
  injectEventPluginsByName: function (injectedNamesToPlugins) {
    var isOrderingDirty = false;
    for (var pluginName in injectedNamesToPlugins) {
      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
        continue;
      }
      var pluginModule = injectedNamesToPlugins[pluginName];
      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
        namesToPlugins[pluginName] = pluginModule;
        isOrderingDirty = true;
      }
    }
    if (isOrderingDirty) {
      recomputePluginOrdering();
    }
  },

  /**
   * Looks up the plugin for the supplied event.
   *
   * @param {object} event A synthetic event.
   * @return {?object} The plugin that created the supplied event.
   * @internal
   */
  getPluginModuleForEvent: function (event) {
    var dispatchConfig = event.dispatchConfig;
    if (dispatchConfig.registrationName) {
      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
    }
    if (dispatchConfig.phasedRegistrationNames !== undefined) {
      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
      // that it is not undefined.
      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;

      for (var phase in phasedRegistrationNames) {
        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
          continue;
        }
        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
        if (pluginModule) {
          return pluginModule;
        }
      }
    }
    return null;
  },

  /**
   * Exposed for unit testing.
   * @private
   */
  _resetEventPlugins: function () {
    eventPluginOrder = null;
    for (var pluginName in namesToPlugins) {
      if (namesToPlugins.hasOwnProperty(pluginName)) {
        delete namesToPlugins[pluginName];
      }
    }
    EventPluginRegistry.plugins.length = 0;

    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
    for (var eventName in eventNameDispatchConfigs) {
      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
        delete eventNameDispatchConfigs[eventName];
      }
    }

    var registrationNameModules = EventPluginRegistry.registrationNameModules;
    for (var registrationName in registrationNameModules) {
      if (registrationNameModules.hasOwnProperty(registrationName)) {
        delete registrationNameModules[registrationName];
      }
    }

    if (false) {
      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
      for (var lowerCasedName in possibleRegistrationNames) {
        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
          delete possibleRegistrationNames[lowerCasedName];
        }
      }
    }
  }
};

module.exports = EventPluginRegistry;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(4);

var ReactErrorUtils = __webpack_require__(74);

var invariant = __webpack_require__(1);
var warning = __webpack_require__(3);

/**
 * Injected dependencies:
 */

/**
 * - `ComponentTree`: [required] Module that can convert between React instances
 *   and actual node references.
 */
var ComponentTree;
var TreeTraversal;
var injection = {
  injectComponentTree: function (Injected) {
    ComponentTree = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
    }
  },
  injectTreeTraversal: function (Injected) {
    TreeTraversal = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
    }
  }
};

function isEndish(topLevelType) {
  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
}

function isMoveish(topLevelType) {
  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
}
function isStartish(topLevelType) {
  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
}

var validateEventDispatches;
if (false) {
  validateEventDispatches = function (event) {
    var dispatchListeners = event._dispatchListeners;
    var dispatchInstances = event._dispatchInstances;

    var listenersIsArr = Array.isArray(dispatchListeners);
    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;

    var instancesIsArr = Array.isArray(dispatchInstances);
    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;

    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
  };
}

/**
 * Dispatch the event to the listener.
 * @param {SyntheticEvent} event SyntheticEvent to handle
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @param {function} listener Application-level callback
 * @param {*} inst Internal component instance
 */
function executeDispatch(event, simulated, listener, inst) {
  var type = event.type || 'unknown-event';
  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
  if (simulated) {
    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
  } else {
    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
  }
  event.currentTarget = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches.
 */
function executeDispatchesInOrder(event, simulated) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
    }
  } else if (dispatchListeners) {
    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
  }
  event._dispatchListeners = null;
  event._dispatchInstances = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches, but stops
 * at the first dispatch execution returning true, and returns that id.
 *
 * @return {?string} id of the first dispatch execution who's listener returns
 * true, or null if no listener returned true.
 */
function executeDispatchesInOrderStopAtTrueImpl(event) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      if (dispatchListeners[i](event, dispatchInstances[i])) {
        return dispatchInstances[i];
      }
    }
  } else if (dispatchListeners) {
    if (dispatchListeners(event, dispatchInstances)) {
      return dispatchInstances;
    }
  }
  return null;
}

/**
 * @see executeDispatchesInOrderStopAtTrueImpl
 */
function executeDispatchesInOrderStopAtTrue(event) {
  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
  event._dispatchInstances = null;
  event._dispatchListeners = null;
  return ret;
}

/**
 * Execution of a "direct" dispatch - there must be at most one dispatch
 * accumulated on the event or it is considered an error. It doesn't really make
 * sense for an event with multiple dispatches (bubbled) to keep track of the
 * return values at each dispatch execution, but it does tend to make sense when
 * dealing with "direct" dispatches.
 *
 * @return {*} The return value of executing the single dispatch.
 */
function executeDirectDispatch(event) {
  if (false) {
    validateEventDispatches(event);
  }
  var dispatchListener = event._dispatchListeners;
  var dispatchInstance = event._dispatchInstances;
  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
  var res = dispatchListener ? dispatchListener(event) : null;
  event.currentTarget = null;
  event._dispatchListeners = null;
  event._dispatchInstances = null;
  return res;
}

/**
 * @param {SyntheticEvent} event
 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
 */
function hasDispatches(event) {
  return !!event._dispatchListeners;
}

/**
 * General utilities that are useful in creating custom Event Plugins.
 */
var EventPluginUtils = {
  isEndish: isEndish,
  isMoveish: isMoveish,
  isStartish: isStartish,

  executeDirectDispatch: executeDirectDispatch,
  executeDispatchesInOrder: executeDispatchesInOrder,
  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
  hasDispatches: hasDispatches,

  getInstanceFromNode: function (node) {
    return ComponentTree.getInstanceFromNode(node);
  },
  getNodeFromInstance: function (node) {
    return ComponentTree.getNodeFromInstance(node);
  },
  isAncestor: function (a, b) {
    return TreeTraversal.isAncestor(a, b);
  },
  getLowestCommonAncestor: function (a, b) {
    return TreeTraversal.getLowestCommonAncestor(a, b);
  },
  getParentInstance: function (inst) {
    return TreeTraversal.getParentInstance(inst);
  },
  traverseTwoPhase: function (target, fn, arg) {
    return TreeTraversal.traverseTwoPhase(target, fn, arg);
  },
  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
  },

  injection: injection
};

module.exports = EventPluginUtils;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(4);

var ReactPropTypesSecret = __webpack_require__(266);
var propTypesFactory = __webpack_require__(106);

var React = __webpack_require__(35);
var PropTypes = propTypesFactory(React.isValidElement);

var invariant = __webpack_require__(1);
var warning = __webpack_require__(3);

var hasReadOnlyValue = {
  button: true,
  checkbox: true,
  image: true,
  hidden: true,
  radio: true,
  reset: true,
  submit: true
};

function _assertSingleLink(inputProps) {
  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
}
function _assertValueLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
}

function _assertCheckedLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
}

var propTypes = {
  value: function (props, propName, componentName) {
    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  checked: function (props, propName, componentName) {
    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  onChange: PropTypes.func
};

var loggedTypeFailures = {};
function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Provide a linked `value` attribute for controlled forms. You should not use
 * this outside of the ReactDOM controlled form components.
 */
var LinkedValueUtils = {
  checkPropTypes: function (tagName, props, owner) {
    for (var propName in propTypes) {
      if (propTypes.hasOwnProperty(propName)) {
        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
      }
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var addendum = getDeclarationErrorAddendum(owner);
         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
      }
    }
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current value of the input either from value prop or link.
   */
  getValue: function (inputProps) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.value;
    }
    return inputProps.value;
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current checked status of the input either from checked prop
   *             or link.
   */
  getChecked: function (inputProps) {
    if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.value;
    }
    return inputProps.checked;
  },

  /**
   * @param {object} inputProps Props for form component
   * @param {SyntheticEvent} event change event to handle
   */
  executeOnChange: function (inputProps, event) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.requestChange(event.target.value);
    } else if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.requestChange(event.target.checked);
    } else if (inputProps.onChange) {
      return inputProps.onChange.call(undefined, event);
    }
  }
};

module.exports = LinkedValueUtils;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(4);

var invariant = __webpack_require__(1);

var injected = false;

var ReactComponentEnvironment = {
  /**
   * Optionally injectable hook for swapping out mount images in the middle of
   * the tree.
   */
  replaceNodeWithMarkup: null,

  /**
   * Optionally injectable hook for processing a queue of child updates. Will
   * later move into MultiChildComponents.
   */
  processChildrenUpdates: null,

  injection: {
    injectEnvironment: function (environment) {
      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
      injected = true;
    }
  }
};

module.exports = ReactComponentEnvironment;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var caughtError = null;

/**
 * Call a function while guarding against errors that happens within it.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} a First argument
 * @param {*} b Second argument
 */
function invokeGuardedCallback(name, func, a) {
  try {
    func(a);
  } catch (x) {
    if (caughtError === null) {
      caughtError = x;
    }
  }
}

var ReactErrorUtils = {
  invokeGuardedCallback: invokeGuardedCallback,

  /**
   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
   * handler are sure to be rethrown by rethrowCaughtError.
   */
  invokeGuardedCallbackWithCatch: invokeGuardedCallback,

  /**
   * During execution of guarded functions we will capture the first error which
   * we will rethrow to be handled by the top level error handler.
   */
  rethrowCaughtError: function () {
    if (caughtError) {
      var error = caughtError;
      caughtError = null;
      throw error;
    }
  }
};

if (false) {
  /**
   * To help development we can get better devtools integration by simulating a
   * real browser event.
   */
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
    var fakeNode = document.createElement('react');
    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
      var boundFunc = func.bind(null, a);
      var evtType = 'react-' + name;
      fakeNode.addEventListener(evtType, boundFunc, false);
      var evt = document.createEvent('Event');
      evt.initEvent(evtType, false, false);
      fakeNode.dispatchEvent(evt);
      fakeNode.removeEventListener(evtType, boundFunc, false);
    };
  }
}

module.exports = ReactErrorUtils;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(4);

var ReactCurrentOwner = __webpack_require__(20);
var ReactInstanceMap = __webpack_require__(42);
var ReactInstrumentation = __webpack_require__(14);
var ReactUpdates = __webpack_require__(16);

var invariant = __webpack_require__(1);
var warning = __webpack_require__(3);

function enqueueUpdate(internalInstance) {
  ReactUpdates.enqueueUpdate(internalInstance);
}

function formatUnexpectedArgument(arg) {
  var type = typeof arg;
  if (type !== 'object') {
    return type;
  }
  var displayName = arg.constructor && arg.constructor.name || type;
  var keys = Object.keys(arg);
  if (keys.length > 0 && keys.length < 20) {
    return displayName + ' (keys: ' + keys.join(', ') + ')';
  }
  return displayName;
}

function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
  var internalInstance = ReactInstanceMap.get(publicInstance);
  if (!internalInstance) {
    if (false) {
      var ctor = publicInstance.constructor;
      // Only warn when we have a callerName. Otherwise we should be silent.
      // We're probably calling from enqueueCallback. We don't want to warn
      // there because we already warned for the corresponding lifecycle method.
      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
    }
    return null;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
  }

  return internalInstance;
}

/**
 * ReactUpdateQueue allows for state updates to be scheduled into a later
 * reconciliation step.
 */
var ReactUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    if (false) {
      var owner = ReactCurrentOwner.current;
      if (owner !== null) {
        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
        owner._warnedAboutRefsInRender = true;
      }
    }
    var internalInstance = ReactInstanceMap.get(publicInstance);
    if (internalInstance) {
      // During componentWillMount and render this will still be null but after
      // that will always render to something. At least for now. So we can use
      // this hack.
      return !!internalInstance._renderedComponent;
    } else {
      return false;
    }
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @param {string} callerName Name of the calling function in the public API.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback, callerName) {
    ReactUpdateQueue.validateCallback(callback, callerName);
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);

    // Previously we would throw an error if we didn't have an internal
    // instance. Since we want to make it a no-op instead, we mirror the same
    // behavior we have in other enqueue* methods.
    // We also need to ignore callbacks in componentWillMount. See
    // enqueueUpdates.
    if (!internalInstance) {
      return null;
    }

    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    // TODO: The callback here is ignored when setState is called from
    // componentWillMount. Either fix it or disallow doing so completely in
    // favor of getInitialState. Alternatively, we can disallow
    // componentWillMount during server-side rendering.
    enqueueUpdate(internalInstance);
  },

  enqueueCallbackInternal: function (internalInstance, callback) {
    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    enqueueUpdate(internalInstance);
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingForceUpdate = true;

    enqueueUpdate(internalInstance);
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState, callback) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingStateQueue = [completeState];
    internalInstance._pendingReplaceState = true;

    // Future-proof 15.5
    if (callback !== undefined && callback !== null) {
      ReactUpdateQueue.validateCallback(callback, 'replaceState');
      if (internalInstance._pendingCallbacks) {
        internalInstance._pendingCallbacks.push(callback);
      } else {
        internalInstance._pendingCallbacks = [callback];
      }
    }

    enqueueUpdate(internalInstance);
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    if (false) {
      ReactInstrumentation.debugTool.onSetState();
      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
    }

    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');

    if (!internalInstance) {
      return;
    }

    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
    queue.push(partialState);

    enqueueUpdate(internalInstance);
  },

  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
    internalInstance._pendingElement = nextElement;
    // TODO: introduce _pendingContext instead of setting it directly.
    internalInstance._context = nextContext;
    enqueueUpdate(internalInstance);
  },

  validateCallback: function (callback, callerName) {
    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
  }
};

module.exports = ReactUpdateQueue;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* globals MSApp */



/**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */

var createMicrosoftUnsafeLocalFunction = function (func) {
  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
    return function (arg0, arg1, arg2, arg3) {
      MSApp.execUnsafeLocalFunction(function () {
        return func(arg0, arg1, arg2, arg3);
      });
    };
  } else {
    return func;
  }
};

module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */

function getEventCharCode(nativeEvent) {
  var charCode;
  var keyCode = nativeEvent.keyCode;

  if ('charCode' in nativeEvent) {
    charCode = nativeEvent.charCode;

    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
    if (charCode === 0 && keyCode === 13) {
      charCode = 13;
    }
  } else {
    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
    charCode = keyCode;
  }

  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
  // Must not discard the (non-)printable Enter-key.
  if (charCode >= 32 || charCode === 13) {
    return charCode;
  }

  return 0;
}

module.exports = getEventCharCode;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */

var modifierKeyToProp = {
  Alt: 'altKey',
  Control: 'ctrlKey',
  Meta: 'metaKey',
  Shift: 'shiftKey'
};

// IE8 does not implement getModifierState so we simply map it to the only
// modifier keys exposed by the event itself, does not support Lock-keys.
// Currently, all major browsers except Chrome seems to support Lock-keys.
function modifierStateGetter(keyArg) {
  var syntheticEvent = this;
  var nativeEvent = syntheticEvent.nativeEvent;
  if (nativeEvent.getModifierState) {
    return nativeEvent.getModifierState(keyArg);
  }
  var keyProp = modifierKeyToProp[keyArg];
  return keyProp ? !!nativeEvent[keyProp] : false;
}

function getEventModifierState(nativeEvent) {
  return modifierStateGetter;
}

module.exports = getEventModifierState;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */

function getEventTarget(nativeEvent) {
  var target = nativeEvent.target || nativeEvent.srcElement || window;

  // Normalize SVG <use> element events #4963
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
  // @see http://www.quirksmode.org/js/events_properties.html
  return target.nodeType === 3 ? target.parentNode : target;
}

module.exports = getEventTarget;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(12);

var useHasFeature;
if (ExecutionEnvironment.canUseDOM) {
  useHasFeature = document.implementation && document.implementation.hasFeature &&
  // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  document.implementation.hasFeature('', '') !== true;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function isEventSupported(eventNameSuffix, capture) {
  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = eventName in document;

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

module.exports = isEventSupported;

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Given a `prevElement` and `nextElement`, determines if the existing
 * instance should be updated as opposed to being destroyed or replaced by a new
 * instance. Both arguments are elements. This ensures that this logic can
 * operate on stateless trees without any backing instance.
 *
 * @param {?object} prevElement
 * @param {?object} nextElement
 * @return {boolean} True if the existing instance should be updated.
 * @protected
 */

function shouldUpdateReactComponent(prevElement, nextElement) {
  var prevEmpty = prevElement === null || prevElement === false;
  var nextEmpty = nextElement === null || nextElement === false;
  if (prevEmpty || nextEmpty) {
    return prevEmpty === nextEmpty;
  }

  var prevType = typeof prevElement;
  var nextType = typeof nextElement;
  if (prevType === 'string' || prevType === 'number') {
    return nextType === 'string' || nextType === 'number';
  } else {
    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
  }
}

module.exports = shouldUpdateReactComponent;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(7);

var emptyFunction = __webpack_require__(13);
var warning = __webpack_require__(3);

var validateDOMNesting = emptyFunction;

if (false) {
  // This validation code was written based on the HTML5 parsing spec:
  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  //
  // Note: this does not catch all invalid nesting, nor does it try to (as it's
  // not clear what practical benefit doing so provides); instead, we warn only
  // for cases where the parser will give a parse tree differing from what React
  // intended. For example, <b><div></div></b> is invalid but we don't warn
  // because it still parses correctly; we do warn for other cases like nested
  // <p> tags where the beginning of the second element implicitly closes the
  // first, causing a confusing mess.

  // https://html.spec.whatwg.org/multipage/syntax.html#special
  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',

  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
  // TODO: Distinguish by namespace here -- for <title>, including it here
  // errs on the side of fewer warnings
  'foreignObject', 'desc', 'title'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
  var buttonScopeTags = inScopeTags.concat(['button']);

  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];

  var emptyAncestorInfo = {
    current: null,

    formTag: null,
    aTagInScope: null,
    buttonTagInScope: null,
    nobrTagInScope: null,
    pTagInButtonScope: null,

    listItemTagAutoclosing: null,
    dlItemTagAutoclosing: null
  };

  var updatedAncestorInfo = function (oldInfo, tag, instance) {
    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
    var info = { tag: tag, instance: instance };

    if (inScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.aTagInScope = null;
      ancestorInfo.buttonTagInScope = null;
      ancestorInfo.nobrTagInScope = null;
    }
    if (buttonScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.pTagInButtonScope = null;
    }

    // See rules for 'li', 'dd', 'dt' start tags in
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
      ancestorInfo.listItemTagAutoclosing = null;
      ancestorInfo.dlItemTagAutoclosing = null;
    }

    ancestorInfo.current = info;

    if (tag === 'form') {
      ancestorInfo.formTag = info;
    }
    if (tag === 'a') {
      ancestorInfo.aTagInScope = info;
    }
    if (tag === 'button') {
      ancestorInfo.buttonTagInScope = info;
    }
    if (tag === 'nobr') {
      ancestorInfo.nobrTagInScope = info;
    }
    if (tag === 'p') {
      ancestorInfo.pTagInButtonScope = info;
    }
    if (tag === 'li') {
      ancestorInfo.listItemTagAutoclosing = info;
    }
    if (tag === 'dd' || tag === 'dt') {
      ancestorInfo.dlItemTagAutoclosing = info;
    }

    return ancestorInfo;
  };

  /**
   * Returns whether
   */
  var isTagValidWithParent = function (tag, parentTag) {
    // First, let's check if we're in an unusual parsing mode...
    switch (parentTag) {
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
      case 'select':
        return tag === 'option' || tag === 'optgroup' || tag === '#text';
      case 'optgroup':
        return tag === 'option' || tag === '#text';
      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
      // but
      case 'option':
        return tag === '#text';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
      // No special behavior since these rules fall back to "in body" mode for
      // all except special table nodes which cause bad parsing behavior anyway.

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
      case 'tr':
        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
      case 'tbody':
      case 'thead':
      case 'tfoot':
        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
      case 'colgroup':
        return tag === 'col' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
      case 'table':
        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
      case 'head':
        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
      case 'html':
        return tag === 'head' || tag === 'body';
      case '#document':
        return tag === 'html';
    }

    // Probably in the "in body" parsing mode, so we outlaw only tag combos
    // where the parsing rules cause implicit opens or closes to be added.
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    switch (tag) {
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

      case 'rp':
      case 'rt':
        return impliedEndTags.indexOf(parentTag) === -1;

      case 'body':
      case 'caption':
      case 'col':
      case 'colgroup':
      case 'frame':
      case 'head':
      case 'html':
      case 'tbody':
      case 'td':
      case 'tfoot':
      case 'th':
      case 'thead':
      case 'tr':
        // These tags are only valid with a few parents that have special child
        // parsing rules -- if we're down here, then none of those matched and
        // so we allow it only if we don't know what the parent is, as all other
        // cases are invalid.
        return parentTag == null;
    }

    return true;
  };

  /**
   * Returns whether
   */
  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
    switch (tag) {
      case 'address':
      case 'article':
      case 'aside':
      case 'blockquote':
      case 'center':
      case 'details':
      case 'dialog':
      case 'dir':
      case 'div':
      case 'dl':
      case 'fieldset':
      case 'figcaption':
      case 'figure':
      case 'footer':
      case 'header':
      case 'hgroup':
      case 'main':
      case 'menu':
      case 'nav':
      case 'ol':
      case 'p':
      case 'section':
      case 'summary':
      case 'ul':
      case 'pre':
      case 'listing':
      case 'table':
      case 'hr':
      case 'xmp':
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return ancestorInfo.pTagInButtonScope;

      case 'form':
        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

      case 'li':
        return ancestorInfo.listItemTagAutoclosing;

      case 'dd':
      case 'dt':
        return ancestorInfo.dlItemTagAutoclosing;

      case 'button':
        return ancestorInfo.buttonTagInScope;

      case 'a':
        // Spec says something about storing a list of markers, but it sounds
        // equivalent to this check.
        return ancestorInfo.aTagInScope;

      case 'nobr':
        return ancestorInfo.nobrTagInScope;
    }

    return null;
  };

  /**
   * Given a ReactCompositeComponent instance, return a list of its recursive
   * owners, starting at the root and ending with the instance itself.
   */
  var findOwnerStack = function (instance) {
    if (!instance) {
      return [];
    }

    var stack = [];
    do {
      stack.push(instance);
    } while (instance = instance._currentElement._owner);
    stack.reverse();
    return stack;
  };

  var didWarn = {};

  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;

    if (childText != null) {
      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
      childTag = '#text';
    }

    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
    var problematic = invalidParent || invalidAncestor;

    if (problematic) {
      var ancestorTag = problematic.tag;
      var ancestorInstance = problematic.instance;

      var childOwner = childInstance && childInstance._currentElement._owner;
      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;

      var childOwners = findOwnerStack(childOwner);
      var ancestorOwners = findOwnerStack(ancestorOwner);

      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
      var i;

      var deepestCommon = -1;
      for (i = 0; i < minStackLen; i++) {
        if (childOwners[i] === ancestorOwners[i]) {
          deepestCommon = i;
        } else {
          break;
        }
      }

      var UNKNOWN = '(unknown)';
      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ownerInfo = [].concat(
      // If the parent and child instances have a common owner ancestor, start
      // with that -- otherwise we just start with the parent's owners.
      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
      // If we're warning about an invalid (non-parent) ancestry, add '...'
      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');

      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
      if (didWarn[warnKey]) {
        return;
      }
      didWarn[warnKey] = true;

      var tagDisplayName = childTag;
      var whitespaceInfo = '';
      if (childTag === '#text') {
        if (/\S/.test(childText)) {
          tagDisplayName = 'Text nodes';
        } else {
          tagDisplayName = 'Whitespace text nodes';
          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
        }
      } else {
        tagDisplayName = '<' + childTag + '>';
      }

      if (invalidParent) {
        var info = '';
        if (ancestorTag === 'table' && childTag === 'tr') {
          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
        }
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
      } else {
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
      }
    }
  };

  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;

  // For testing
  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;
    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
  };
}

module.exports = validateDOMNesting;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// currently used to initiate the velocity style object to 0


exports.__esModule = true;
exports['default'] = mapToZero;

function mapToZero(obj) {
  var ret = {};
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      ret[key] = 0;
    }
  }
  return ret;
}

module.exports = exports['default'];

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// usage assumption: currentStyle values have already been rendered but it says
// nothing of whether currentStyle is stale (see unreadPropStyle)


exports.__esModule = true;
exports['default'] = shouldStopAnimation;

function shouldStopAnimation(currentStyle, style, currentVelocity) {
  for (var key in style) {
    if (!Object.prototype.hasOwnProperty.call(style, key)) {
      continue;
    }

    if (currentVelocity[key] !== 0) {
      return false;
    }

    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
    // stepper will have already taken care of rounding precision errors, so
    // won't have such thing as 0.9999 !=== 1
    if (currentStyle[key] !== styleValue) {
      return false;
    }
  }

  return true;
}

module.exports = exports['default'];

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// stepper is used a lot. Saves allocation to return the same array wrapper.
// This is fine and danger-free against mutations because the callsite
// immediately destructures it and gets the numbers inside without passing the


exports.__esModule = true;
exports["default"] = stepper;

var reusedTuple = [0, 0];

function stepper(secondPerFrame, x, v, destX, k, b, precision) {
  // Spring stiffness, in kg / s^2

  // for animations, destX is really spring length (spring at rest). initial
  // position is considered as the stretched/compressed position of a spring
  var Fspring = -k * (x - destX);

  // Damping, in kg / s
  var Fdamper = -b * v;

  // usually we put mass here, but for animation purposes, specifying mass is a
  // bit redundant. you could simply adjust k and b accordingly
  // let a = (Fspring + Fdamper) / mass;
  var a = Fspring + Fdamper;

  var newV = v + a * secondPerFrame;
  var newX = x + newV * secondPerFrame;

  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
    reusedTuple[0] = destX;
    reusedTuple[1] = 0;
    return reusedTuple;
  }

  reusedTuple[0] = newX;
  reusedTuple[1] = newV;
  return reusedTuple;
}

module.exports = exports["default"];
// array reference around.

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.loopAsync = loopAsync;
exports.mapAsync = mapAsync;
function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var sync = false,
      hasNext = false,
      doneArgs = void 0;

  function done() {
    isDone = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      doneArgs = [].concat(Array.prototype.slice.call(arguments));
      return;
    }

    callback.apply(this, arguments);
  }

  function next() {
    if (isDone) {
      return;
    }

    hasNext = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      return;
    }

    sync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work.call(this, currentTurn++, next, done);
    }

    sync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(this, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  }

  next();
}

function mapAsync(array, work, callback) {
  var length = array.length;
  var values = [];

  if (length === 0) return callback(null, values);

  var isDone = false,
      doneCount = 0;

  function done(index, error, value) {
    if (isDone) return;

    if (error) {
      isDone = true;
      callback(error);
    } else {
      values[index] = value;

      isDone = ++doneCount === length;

      if (isDone) callback(null, values);
    }
  }

  array.forEach(function (item, index) {
    work(item, index, function (error, value) {
      done(index, error, value);
    });
  });
}

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.router = exports.routes = exports.route = exports.components = exports.component = exports.location = exports.history = exports.falsy = exports.locationShape = exports.routerShape = undefined;

var _react = __webpack_require__(0);

var _deprecateObjectProperties = __webpack_require__(56);

var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);

var _InternalPropTypes = __webpack_require__(25);

var InternalPropTypes = _interopRequireWildcard(_InternalPropTypes);

var _routerWarning = __webpack_require__(9);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var func = _react.PropTypes.func;
var object = _react.PropTypes.object;
var shape = _react.PropTypes.shape;
var string = _react.PropTypes.string;
var routerShape = exports.routerShape = shape({
  push: func.isRequired,
  replace: func.isRequired,
  go: func.isRequired,
  goBack: func.isRequired,
  goForward: func.isRequired,
  setRouteLeaveHook: func.isRequired,
  isActive: func.isRequired
});

var locationShape = exports.locationShape = shape({
  pathname: string.isRequired,
  search: string.isRequired,
  state: object,
  action: string.isRequired,
  key: string
});

// Deprecated stuff below:

var falsy = exports.falsy = InternalPropTypes.falsy;
var history = exports.history = InternalPropTypes.history;
var location = exports.location = locationShape;
var component = exports.component = InternalPropTypes.component;
var components = exports.components = InternalPropTypes.components;
var route = exports.route = InternalPropTypes.route;
var routes = exports.routes = InternalPropTypes.routes;
var router = exports.router = routerShape;

if (false) {
  (function () {
    var deprecatePropType = function deprecatePropType(propType, message) {
      return function () {
        process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
        return propType.apply(undefined, arguments);
      };
    };

    var deprecateInternalPropType = function deprecateInternalPropType(propType) {
      return deprecatePropType(propType, 'This prop type is not intended for external use, and was previously exported by mistake. These internal prop types are deprecated for external use, and will be removed in a later version.');
    };

    var deprecateRenamedPropType = function deprecateRenamedPropType(propType, name) {
      return deprecatePropType(propType, 'The `' + name + '` prop type is now exported as `' + name + 'Shape` to avoid name conflicts. This export is deprecated and will be removed in a later version.');
    };

    exports.falsy = falsy = deprecateInternalPropType(falsy);
    exports.history = history = deprecateInternalPropType(history);
    exports.component = component = deprecateInternalPropType(component);
    exports.components = components = deprecateInternalPropType(components);
    exports.route = route = deprecateInternalPropType(route);
    exports.routes = routes = deprecateInternalPropType(routes);

    exports.location = location = deprecateRenamedPropType(location, 'location');
    exports.router = router = deprecateRenamedPropType(router, 'router');
  })();
}

var defaultExport = {
  falsy: falsy,
  history: history,
  location: location,
  component: component,
  components: components,
  route: route,
  // For some reason, routes was never here.
  router: router
};

if (false) {
  defaultExport = (0, _deprecateObjectProperties2.default)(defaultExport, 'The default export from `react-router/lib/PropTypes` is deprecated. Please use the named exports instead.');
}

exports.default = defaultExport;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = createTransitionManager;

var _routerWarning = __webpack_require__(9);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

var _computeChangedRoutes2 = __webpack_require__(313);

var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);

var _TransitionUtils = __webpack_require__(310);

var _isActive2 = __webpack_require__(317);

var _isActive3 = _interopRequireDefault(_isActive2);

var _getComponents = __webpack_require__(314);

var _getComponents2 = _interopRequireDefault(_getComponents);

var _matchRoutes = __webpack_require__(319);

var _matchRoutes2 = _interopRequireDefault(_matchRoutes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hasAnyProperties(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
  }return false;
}

function createTransitionManager(history, routes) {
  var state = {};

  // Signature should be (location, indexOnly), but needs to support (path,
  // query, indexOnly)
  function isActive(location) {
    var indexOnlyOrDeprecatedQuery = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
    var deprecatedIndexOnly = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];

    var indexOnly = void 0;
    if (indexOnlyOrDeprecatedQuery && indexOnlyOrDeprecatedQuery !== true || deprecatedIndexOnly !== null) {
       false ? (0, _routerWarning2.default)(false, '`isActive(pathname, query, indexOnly) is deprecated; use `isActive(location, indexOnly)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
      location = { pathname: location, query: indexOnlyOrDeprecatedQuery };
      indexOnly = deprecatedIndexOnly || false;
    } else {
      location = history.createLocation(location);
      indexOnly = indexOnlyOrDeprecatedQuery;
    }

    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
  }

  var partialNextState = void 0;

  function match(location, callback) {
    if (partialNextState && partialNextState.location === location) {
      // Continue from where we left off.
      finishMatch(partialNextState, callback);
    } else {
      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
        if (error) {
          callback(error);
        } else if (nextState) {
          finishMatch(_extends({}, nextState, { location: location }), callback);
        } else {
          callback();
        }
      });
    }
  }

  function finishMatch(nextState, callback) {
    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState);

    var leaveRoutes = _computeChangedRoutes.leaveRoutes;
    var changeRoutes = _computeChangedRoutes.changeRoutes;
    var enterRoutes = _computeChangedRoutes.enterRoutes;


    (0, _TransitionUtils.runLeaveHooks)(leaveRoutes, state);

    // Tear down confirmation hooks for left routes
    leaveRoutes.filter(function (route) {
      return enterRoutes.indexOf(route) === -1;
    }).forEach(removeListenBeforeHooksForRoute);

    // change and enter hooks are run in series
    (0, _TransitionUtils.runChangeHooks)(changeRoutes, state, nextState, function (error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      (0, _TransitionUtils.runEnterHooks)(enterRoutes, nextState, finishEnterHooks);
    });

    function finishEnterHooks(error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      // TODO: Fetch components after state is updated.
      (0, _getComponents2.default)(nextState, function (error, components) {
        if (error) {
          callback(error);
        } else {
          // TODO: Make match a pure function and have some other API
          // for "match and update state".
          callback(null, null, state = _extends({}, nextState, { components: components }));
        }
      });
    }

    function handleErrorOrRedirect(error, redirectInfo) {
      if (error) callback(error);else callback(null, redirectInfo);
    }
  }

  var RouteGuid = 1;

  function getRouteID(route) {
    var create = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];

    return route.__id__ || create && (route.__id__ = RouteGuid++);
  }

  var RouteHooks = Object.create(null);

  function getRouteHooksForRoutes(routes) {
    return routes.reduce(function (hooks, route) {
      hooks.push.apply(hooks, RouteHooks[getRouteID(route)]);
      return hooks;
    }, []);
  }

  function transitionHook(location, callback) {
    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
      if (nextState == null) {
        // TODO: We didn't actually match anything, but hang
        // onto error/nextState so we don't have to matchRoutes
        // again in the listen callback.
        callback();
        return;
      }

      // Cache some state here so we don't have to
      // matchRoutes() again in the listen callback.
      partialNextState = _extends({}, nextState, { location: location });

      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);

      var result = void 0;
      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
        // Passing the location arg here indicates to
        // the user that this is a transition hook.
        result = hooks[i](location);
      }

      callback(result);
    });
  }

  /* istanbul ignore next: untestable with Karma */
  function beforeUnloadHook() {
    // Synchronously check to see if any route hooks want
    // to prevent the current window/tab from closing.
    if (state.routes) {
      var hooks = getRouteHooksForRoutes(state.routes);

      var message = void 0;
      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
        // Passing no args indicates to the user that this is a
        // beforeunload hook. We don't know the next location.
        message = hooks[i]();
      }

      return message;
    }
  }

  var unlistenBefore = void 0,
      unlistenBeforeUnload = void 0;

  function removeListenBeforeHooksForRoute(route) {
    var routeID = getRouteID(route, false);
    if (!routeID) {
      return;
    }

    delete RouteHooks[routeID];

    if (!hasAnyProperties(RouteHooks)) {
      // teardown transition & beforeunload hooks
      if (unlistenBefore) {
        unlistenBefore();
        unlistenBefore = null;
      }

      if (unlistenBeforeUnload) {
        unlistenBeforeUnload();
        unlistenBeforeUnload = null;
      }
    }
  }

  /**
   * Registers the given hook function to run before leaving the given route.
   *
   * During a normal transition, the hook function receives the next location
   * as its only argument and can return either a prompt message (string) to show the user,
   * to make sure they want to leave the page; or `false`, to prevent the transition.
   * Any other return value will have no effect.
   *
   * During the beforeunload event (in browsers) the hook receives no arguments.
   * In this case it must return a prompt message to prevent the transition.
   *
   * Returns a function that may be used to unbind the listener.
   */
  function listenBeforeLeavingRoute(route, hook) {
    // TODO: Warn if they register for a route that isn't currently
    // active. They're probably doing something wrong, like re-creating
    // route objects on every location change.
    var routeID = getRouteID(route);
    var hooks = RouteHooks[routeID];

    if (!hooks) {
      var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);

      RouteHooks[routeID] = [hook];

      if (thereWereNoRouteHooks) {
        // setup transition & beforeunload hooks
        unlistenBefore = history.listenBefore(transitionHook);

        if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
      }
    } else {
      if (hooks.indexOf(hook) === -1) {
         false ? (0, _routerWarning2.default)(false, 'adding multiple leave hooks for the same route is deprecated; manage multiple confirmations in your own code instead') : void 0;

        hooks.push(hook);
      }
    }

    return function () {
      var hooks = RouteHooks[routeID];

      if (hooks) {
        var newHooks = hooks.filter(function (item) {
          return item !== hook;
        });

        if (newHooks.length === 0) {
          removeListenBeforeHooksForRoute(route);
        } else {
          RouteHooks[routeID] = newHooks;
        }
      }
    };
  }

  /**
   * This is the API for stateful environments. As the location
   * changes, we update state and call the listener. We can also
   * gracefully handle errors and redirects.
   */
  function listen(listener) {
    // TODO: Only use a single history listener. Otherwise we'll
    // end up with multiple concurrent calls to match.
    return history.listen(function (location) {
      if (state.location === location) {
        listener(null, state);
      } else {
        match(location, function (error, redirectLocation, nextState) {
          if (error) {
            listener(error);
          } else if (redirectLocation) {
            history.replace(redirectLocation);
          } else if (nextState) {
            listener(null, nextState);
          } else {
             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
          }
        });
      }
    });
  }

  return {
    isActive: isActive,
    match: match,
    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
    listen: listen
  };
}

//export default useRoutes

module.exports = exports['default'];

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(245);


/***/ }),
/* 90 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utility_util_methods__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utility_spinner__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utility_rq_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutability_helper__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutability_helper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutability_helper__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




//import MessageBox from "../utility/message-box";



var CurrencyEntry = function (_React$Component) {
    _inherits(CurrencyEntry, _React$Component);

    function CurrencyEntry() {
        _classCallCheck(this, CurrencyEntry);

        var _this = _possibleConstructorReturn(this, (CurrencyEntry.__proto__ || Object.getPrototypeOf(CurrencyEntry)).call(this));

        _this.state = {
            currencyData: null,
            showSpinner: false

        };
        _this.messageBox = null;
        _this.focusSet = false;
        return _this;
    }

    _createClass(CurrencyEntry, [{
        key: "calculateIn",
        value: function calculateIn(currency, index, e) {
            if (parseInt(e.target.value, 10) > 0) {
                var currencyData = __WEBPACK_IMPORTED_MODULE_4_immutability_helper___default()(this.state.currencyData, _defineProperty({}, index, { in: { $set: parseInt(e.target.value, 10) } }));
                this.setState({ currencyData: currencyData });
            } else {
                var _currencyData = __WEBPACK_IMPORTED_MODULE_4_immutability_helper___default()(this.state.currencyData, _defineProperty({}, index, { in: { $set: 0 } }));
                this.setState({ currencyData: _currencyData });
            }
        }
    }, {
        key: "calculateOut",
        value: function calculateOut(currency, index, e) {
            var out = parseInt(e.target.value, 10) > 0 ? parseInt(e.target.value, 10) : 0;
            if (out > 0 && out <= currency.available) {
                var currencyData = __WEBPACK_IMPORTED_MODULE_4_immutability_helper___default()(this.state.currencyData, _defineProperty({}, index, { out: { $set: parseInt(e.target.value, 10) } }));
                this.setState({ currencyData: currencyData });
            } else {
                var _currencyData2 = __WEBPACK_IMPORTED_MODULE_4_immutability_helper___default()(this.state.currencyData, _defineProperty({}, index, { out: { $set: 0 } }));
                e.target.value = "";
                this.setState({ currencyData: _currencyData2 });
            }
        }
    }, {
        key: "getTotal",
        value: function getTotal(type) {
            var total = 0;
            for (var i = 0; i < this.state.currencyData.length; i++) {
                total += this.state.currencyData[i].denominationName * this.state.currencyData[i][type];
            }
            return total;
        }
    }, {
        key: "componentWillMount",
        value: function componentWillMount() {
            if (typeof this.props.onSave !== "function") throw new Error("Currency Entry need a onSave call back");
            if (typeof this.props.visible !== "boolean") throw new Error("Currency Entry form needs a visible property that must be a boolean");
            if (typeof this.props.onCancel !== "function") throw new Error("Currency Entry form needs a visible property that must be a boolean");
        }
    }, {
        key: "onSaveClick",
        value: function onSaveClick() {
            // this.props.onSave(this.state.availableCurrencies, this.getAvailableTotal(), this.state.curencies, this.getTotal("in"), this.getTotal("out"));
            this.props.onSave(this.state.currencyData, this.getTotal("in"), this.getTotal("out"));
        }
    }, {
        key: "onCancel",
        value: function onCancel() {
            this.props.onCancel();
        }
    }, {
        key: "handleEnter",
        value: function handleEnter(e) {
            if (e.keyCode === 13) {
                e.preventDefault();
                this.onSaveClick();
            }
        }
    }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            if (nextProps.reset) {
                this.setState({
                    currencyData: null,
                    showSpinner: false
                });
                return;
            }

            // console.log(">>>>>>>>>>>", nextProps);
            if (nextProps.visible) {
                this.setFocus = undefined;
                this.setState({ showSpinner: true });
                // make rq call to get available currency Data

                __WEBPACK_IMPORTED_MODULE_3__utility_rq_js__["a" /* default */].getJsonData(nextProps.url || "/api/v1/availablecurrency").then(function (data) {
                    //console.log(this.refs.tableIn);
                    _this2.setState({ currencyData: data, showSpinner: false });
                }).catch(function (err) {
                    alert("fethching currency availability failed");
                    _this2.props.onFailed ? _this2.props.onFailed() : "";
                    _this2.setState({ showSpinner: false });
                    throw err;
                });
            }
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
            // console.log("update fired", this.setFocus);
            if (this.setFocus === undefined) {
                if (this.refs.tableIn) {
                    if (this.props.focus === "in") {
                        this.refs.tableIn.children[0].children[0].children[1].children[0].focus();
                        this.setFocus = true;
                    } else if (this.props.focus === "out") {
                        this.refs.tableOut.children[0].children[0].children[1].children[0].focus();
                        this.setFocus = true;
                    }
                }
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _this3 = this;

            //console.log("avalabe currencies", this.props.visible);
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                null,
                this.state.currencyData ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "currencyForm", style: { display: this.props.visible ? "block" : "none" }, onKeyDown: this.handleEnter.bind(this) },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { className: "cBox", style: { float: "left" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "p",
                            { className: "cLabel" },
                            "Available"
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "table",
                            { className: "cTable" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "tbody",
                                null,
                                this.state.currencyData.map(function (currency, i) {

                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "tr",
                                        { key: i },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "td",
                                            null,
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                "span",
                                                { style: { background: "#c18fb7" }, className: "cCurrency" },
                                                currency.denominationName > 500 ? currency.denominationName.toString()[0] + "K" : currency.denominationName
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "td",
                                            null,
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { type: "text", className: "cInput", value: currency.available, disabled: true })
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "td",
                                            { className: "rCurrency" },
                                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utility_util_methods__["i" /* cFormat */])(currency.available * currency.denominationName)
                                        )
                                    );
                                }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "tr",
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { width: "50px" }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "td",
                                        { style: {} },
                                        "TOTAL"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "td",
                                        { className: "cTotal" },
                                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utility_util_methods__["i" /* cFormat */])(this.getTotal.bind(this, "available")())
                                    )
                                )
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { className: "cBox", style: { float: "left" }, ref: "cashInDiv" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "p",
                            { className: "cLabel" },
                            "Cash In ",
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-arrow-down cArrow" })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "table",
                            { className: "cTable", ref: "tableIn" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "tbody",
                                null,
                                this.state.currencyData.map(function (currency, i) {
                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "tr",
                                        { key: i },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "td",
                                            null,
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                "span",
                                                { style: { background: "#c18fb7" }, className: "cCurrency" },
                                                currency.denominationName > 500 ? currency.denominationName.toString()[0] + "K" : currency.denominationName
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "td",
                                            null,
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { type: "text", className: "cInput", value: currency.in > 0 ? currency.in : "", onChange: _this3.calculateIn.bind(_this3, currency, i), disabled: currency.out > 0 ? true : false })
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "td",
                                            { className: "rCurrency" },
                                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utility_util_methods__["i" /* cFormat */])(currency.in * currency.denominationName)
                                        )
                                    );
                                }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "tr",
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { width: "50px" }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "td",
                                        { style: {} },
                                        "TOTAL"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "td",
                                        { className: "cTotal" },
                                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utility_util_methods__["i" /* cFormat */])(this.getTotal.bind(this, "in")())
                                    )
                                )
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { className: "cBox", style: { float: "right", borderRight: "none" }, ref: "cashOutDiv" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "p",
                            { className: "cLabel" },
                            "Cash Out ",
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-arrow-up cArrow" })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "table",
                            { className: "cTable", ref: "tableOut" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "tbody",
                                null,
                                this.state.currencyData.map(function (currency, i) {
                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "tr",
                                        { key: i },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "td",
                                            null,
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                "span",
                                                { style: { background: "#c18fb7" }, className: "cCurrency" },
                                                currency.denominationName > 500 ? currency.denominationName.toString()[0] + "K" : currency.denominationName
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "td",
                                            null,
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { type: "text", className: "cInput", value: currency.out > 0 ? currency.out : "", disabled: currency.in > 0 ? true : false, onChange: _this3.calculateOut.bind(_this3, currency, i) })
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "td",
                                            { className: "rCurrency" },
                                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utility_util_methods__["i" /* cFormat */])(currency.out * currency.denominationName)
                                        )
                                    );
                                }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "tr",
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { width: "50px" }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "td",
                                        { style: {} },
                                        "TOTAL"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "td",
                                        { className: "cTotal" },
                                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utility_util_methods__["i" /* cFormat */])(this.getTotal.bind(this, "out")())
                                    )
                                )
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { clear: "both" } }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "button",
                        {
                            onClick: this.onSaveClick.bind(this),
                            className: "btn btnOk btnRight", style: { marginRight: "25px" } },
                        "Save"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "button",
                        {
                            onClick: this.onCancel.bind(this),
                            className: "btn btnOk btnRight", style: { marginRight: "25px" } },
                        "Cancel"
                    )
                ) : null,
                this.state.showSpinner ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__utility_spinner__["a" /* default */], null) : null
            );
        }
    }]);

    return CurrencyEntry;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (CurrencyEntry);

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_events__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dispatcher__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_constants__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var ShiftStore = function (_EventEmitter) {
    _inherits(ShiftStore, _EventEmitter);

    function ShiftStore() {
        _classCallCheck(this, ShiftStore);

        var _this = _possibleConstructorReturn(this, (ShiftStore.__proto__ || Object.getPrototypeOf(ShiftStore)).call(this));

        _this.shifts = [];
        return _this;
    }

    _createClass(ShiftStore, [{
        key: "getAll",
        value: function getAll() {
            return this.shifts;
        }
    }, {
        key: "handleAction",
        value: function handleAction(action) {
            switch (action.type) {
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["c" /* shiftConstant */].SHIFT_CREATED:
                    {
                        //console.log(this);
                        var shift = action.shift;

                        this.shifts.push(shift);
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["c" /* shiftConstant */].SHIFT_CREATED, "SHIFT " + shift.shiftName + " created successfully.");
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["c" /* shiftConstant */].SHIFT_STORE_CHANGE);
                        break;
                    }
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["c" /* shiftConstant */].SHIFT_CREATION_FAILED:
                    {
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["c" /* shiftConstant */].SHIFT_CREATION_FAILED, action.msg);
                        break;
                    }
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["c" /* shiftConstant */].FETCHED_ALL_SHIFT:
                    {
                        //console.log("inside shift store fetch all", action.data);
                        this.shifts = action.data;
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["c" /* shiftConstant */].SHIFT_STORE_CHANGE);
                        break;
                    }
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["c" /* shiftConstant */].SHIFT_FETCH_FAILED:
                    {
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["c" /* shiftConstant */].SHIFT_FETCH_FAILED, action.msg);
                        break;
                    }
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["c" /* shiftConstant */].NEW_SHIFT_STARTED:
                    {
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["c" /* shiftConstant */].NEW_SHIFT_STARTED, action.msg);
                        break;
                    }
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["c" /* shiftConstant */].NEW_SHIFT_FAILED:
                    {
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["c" /* shiftConstant */].NEW_SHIFT_FAILED, action.msg);
                        break;
                    }
                default:
                    break;
            }
        }
    }]);

    return ShiftStore;
}(__WEBPACK_IMPORTED_MODULE_0_events__["EventEmitter"]);

var shiftStore = new ShiftStore();
__WEBPACK_IMPORTED_MODULE_1__dispatcher__["a" /* default */].register(shiftStore.handleAction.bind(shiftStore));
/* harmony default export */ __webpack_exports__["a"] = (shiftStore);

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAllNotification;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dispatcher__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_utility_rq_js__ = __webpack_require__(6);




function getAllNotification() {
    __WEBPACK_IMPORTED_MODULE_2__components_utility_rq_js__["a" /* default */].getJsonData("/api/v1/getnotification").then(function (data) {
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["p" /* notificationConstant */].FETCHED_ALL_NOTIFICATION, data: data });
    }).catch(function (data) {
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["p" /* notificationConstant */], msg: "Fetching notification failed" });
    });
}

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_creditor_js__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_creditor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__models_creditor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utility_tip__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utility_auto_complete__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utility_question_box__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utility_message_box__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_creditor_store__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_creditor_action__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utility_rq_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_auth_store__ = __webpack_require__(39);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var _class = function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class() {
        _classCallCheck(this, _class);

        var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this));

        _this.state = {
            propError: {},
            creditorData: false

        };
        _this.creditor = new __WEBPACK_IMPORTED_MODULE_1__models_creditor_js___default.a({});
        _this.questionBox = null;
        _this.messageBox = null;
        _this.onUpdate = _this.onUpdate.bind(_this);
        _this.onUpDateFailed = _this.onUpDateFailed.bind(_this);
        _this.selectCreditorData = null;
        _this.user = __WEBPACK_IMPORTED_MODULE_10__store_auth_store__["a" /* default */].getToken().user;

        return _this;
    }

    _createClass(_class, [{
        key: "validet",
        value: function validet(propToCheck, model, value) {
            this[model][propToCheck] = value;
            if (this[model].getErrors()[propToCheck]) {
                this.state.propError[propToCheck] = true;
            } else {
                delete this.state.propError[propToCheck];
            }
            this.setState(this.state);
        }
    }, {
        key: "handleKeyUp",
        value: function handleKeyUp(propToCheck, model, e) {
            this.validet(propToCheck, model, e.target.value);
        }
    }, {
        key: "askQuestion",
        value: function askQuestion(msg, yesCallBack, noCallBack) {
            this.questionBox = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__utility_question_box__["a" /* default */], { questionMsg: msg, yesCallBack: yesCallBack, noCallBack: noCallBack });
            this.setState(this.state);
        }
    }, {
        key: "createCreditor",
        value: function createCreditor() {
            var _this2 = this;

            if (!this.creditor.hasError()) {
                this.askQuestion("Do you want to update data of " + this.creditor.firmName + " ?", function () {
                    __WEBPACK_IMPORTED_MODULE_8__actions_creditor_action__["a" /* upDateCreditor */]({ creditor: _this2.creditor, comment: _this2.refs.comment.value, oldCreditor: _this2.oldCreditorData });
                    _this2.questionBox = null;
                    _this2.forceUpdate();
                }, function () {
                    _this2.questionBox = null;
                    _this2.forceUpdate();
                });
            } else {
                this.state.propError = Object.assign({}, this.creditor.getErrors());
                this.setState(this.state);
            }
        }
    }, {
        key: "onUpdate",
        value: function onUpdate(msg) {
            this.messageBox = __WEBPACK_IMPORTED_MODULE_5__utility_message_box__["a" /* default */].showMessage(msg, true, this);
            this.refs.firmName.value = "";
            this.refs.proprietorName.value = "";
            this.refs.contactNo.value = "";
            this.refs.panNumber.value = "";
            this.refs.address.value = "";
            this.refs.maxLimit.value = "";
            this.refs.email.value = "";
            this.searchBox.value = "";
            this.state.creditorData = false;
            this.creditor = new __WEBPACK_IMPORTED_MODULE_1__models_creditor_js___default.a({});
            this.refs.firmName.focus();
            this.forceUpdate();
        }
    }, {
        key: "onUpDateFailed",
        value: function onUpDateFailed(msg) {
            this.messageBox = __WEBPACK_IMPORTED_MODULE_5__utility_message_box__["a" /* default */].showMessage(msg, false, this);
            this.forceUpdate();
        }
    }, {
        key: "componentWillMount",
        value: function componentWillMount() {
            __WEBPACK_IMPORTED_MODULE_7__store_creditor_store__["a" /* default */].on(__WEBPACK_IMPORTED_MODULE_6__constants_constants__["a" /* creditorConstant */].UPDATE_CREDITOR, this.onUpdate);
            __WEBPACK_IMPORTED_MODULE_7__store_creditor_store__["a" /* default */].on(__WEBPACK_IMPORTED_MODULE_6__constants_constants__["a" /* creditorConstant */].UPDATE_CREDITOR_CREATION_FAILED, this.onUpDateFailed);
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            __WEBPACK_IMPORTED_MODULE_7__store_creditor_store__["a" /* default */].removeListener(__WEBPACK_IMPORTED_MODULE_6__constants_constants__["a" /* creditorConstant */].UPDATE_CREDITOR, this.onUpdate);
            __WEBPACK_IMPORTED_MODULE_7__store_creditor_store__["a" /* default */].removeListener(__WEBPACK_IMPORTED_MODULE_6__constants_constants__["a" /* creditorConstant */].UPDATE_CREDITOR_CREATION_FAILED, this.onUpDateFailed);
        }
    }, {
        key: "onCreditorSelect",
        value: function onCreditorSelect(creditor) {
            var _this3 = this;

            if (creditor) {
                __WEBPACK_IMPORTED_MODULE_9__utility_rq_js__["a" /* default */].getJsonData("/api/v1/creditor/" + creditor.creditorId).then(function (data) {
                    _this3.creditor = new __WEBPACK_IMPORTED_MODULE_1__models_creditor_js___default.a(data[0]);
                    _this3.oldCreditorData = new __WEBPACK_IMPORTED_MODULE_1__models_creditor_js___default.a(data[0]);

                    _this3.state.creditorData = true;
                    _this3.setState(_this3.state);
                }).catch(function (data) {
                    console.log("filed to get data");
                });
            } else {
                this.state.creditorData = false;
                this.creditor = new __WEBPACK_IMPORTED_MODULE_1__models_creditor_js___default.a({});
                this.setState(this.state);
            }
            this.setState(this.state);
        }
    }, {
        key: "handleAddNewCreditor",
        value: function handleAddNewCreditor(e) {
            if (e.target.checked) {
                this.validet("hasSmallCreditor", "creditor", 1);
            } else {
                this.validet("hasSmallCreditor", "creditor", 0);
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "midholder", ref: "holder" },
                this.questionBox,
                this.messageBox,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "p",
                    { className: "formMsg" },
                    "Creditor Edit "
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "table",
                    { className: "formTable" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "tbody",
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "tr",
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "td",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "p",
                                    { className: "label" },
                                    "Select a Firm Name"
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__utility_auto_complete__["a" /* default */], {
                                    placeholder: "Enter a Firm Name",
                                    dataSrc: "/api/v1/creditorauto",
                                    dataTobind: "shortName",
                                    keyToBind: "creditorId",
                                    tabIndex: "1",
                                    onSelect: this.onCreditorSelect.bind(this),
                                    rex: function rex(searchBox) {
                                        _this4.searchBox = searchBox;
                                        //this.searchBox.onfocus = this.onSelectEmployeeFocus.bind(this);
                                    }
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null)
                        )
                    )
                ),
                this.state.creditorData ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "table",
                    { className: "formTable" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "tbody",
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "tr",
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "td",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__utility_tip__["a" /* default */], {
                                    showOn: this.state.propError.firmName,
                                    msg: this.creditor.getErrors().firmName
                                }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "p",
                                    { className: "label" },
                                    "Firm Name"
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                                    tabIndex: "2",
                                    type: "text",
                                    className: "formControl inputBox",
                                    placeholder: "Firm Name",
                                    onBlur: this.handleKeyUp.bind(this, "firmName", "creditor"),
                                    onKeyUp: this.handleKeyUp.bind(this, "firmName", "creditor"),
                                    ref: "firmName",
                                    defaultValue: this.creditor.firmName
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "td",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__utility_tip__["a" /* default */], {
                                    showOn: this.state.propError.proprietorName,
                                    pointerStyle: {},
                                    msg: this.creditor.getErrors().proprietorName
                                }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "p",
                                    { className: "label" },
                                    "Proprietor  Name"
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                                    tabIndex: "3",
                                    type: "text",
                                    className: "formControl inputBox",
                                    placeholder: "Proprietor Name",
                                    onBlur: this.handleKeyUp.bind(this, "proprietorName", "creditor"),
                                    onKeyUp: this.handleKeyUp.bind(this, "proprietorName", "creditor"),
                                    ref: "proprietorName",
                                    defaultValue: this.creditor.proprietorName

                                })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "tr",
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "td",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__utility_tip__["a" /* default */], {
                                    showOn: this.state.propError.shortName,
                                    pointerStyle: {},
                                    msg: this.creditor.getErrors().shortName
                                }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "p",
                                    { className: "label" },
                                    "Short Name"
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                                    tabIndex: "4",
                                    type: "text",
                                    className: "formControl inputBox",
                                    placeholder: "Short Name",
                                    onBlur: this.handleKeyUp.bind(this, "shortName", "creditor"),
                                    onKeyUp: this.handleKeyUp.bind(this, "shortName", "creditor"),
                                    ref: "shortName",
                                    defaultValue: this.creditor.shortName
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "td",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__utility_tip__["a" /* default */], {
                                    showOn: this.state.propError.email,
                                    pointerStyle: {},
                                    msg: this.creditor.getErrors().email
                                }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "p",
                                    { className: "label" },
                                    "Email"
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                                    tabIndex: "5",
                                    type: "text",
                                    className: "formControl inputBox",
                                    placeholder: "Email",
                                    onBlur: this.handleKeyUp.bind(this, "email", "creditor"),
                                    onKeyUp: this.handleKeyUp.bind(this, "email", "creditor"),
                                    ref: "email",
                                    defaultValue: this.creditor.email
                                })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "tr",
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "td",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__utility_tip__["a" /* default */], {
                                    showOn: this.state.propError.contactNo,
                                    pointerStyle: {},
                                    msg: this.creditor.getErrors().contactNo
                                }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "p",
                                    { className: "label" },
                                    "Contact Number "
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                                    tabIndex: "6",
                                    type: "number",
                                    className: "formControl inputBox",
                                    placeholder: "Contact Number",
                                    onBlur: this.handleKeyUp.bind(this, "contactNo", "creditor"),
                                    onKeyUp: this.handleKeyUp.bind(this, "contactNo", "creditor"),
                                    ref: "contactNo",
                                    defaultValue: this.creditor.contactNo
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "td",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__utility_tip__["a" /* default */], {
                                    showOn: this.state.propError.panNumber,
                                    pointerStyle: {},
                                    msg: this.creditor.getErrors().panNumber
                                }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "p",
                                    { className: "label" },
                                    "PanCard Number"
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                                    tabIndex: "7",
                                    type: "text",
                                    className: "formControl inputBox",
                                    placeholder: "PanCard Number",
                                    onBlur: this.handleKeyUp.bind(this, "panNumber", "creditor"),
                                    onKeyUp: this.handleKeyUp.bind(this, "panNumber", "creditor"),
                                    ref: "panNumber",
                                    defaultValue: this.creditor.panNumber
                                })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "tr",
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "td",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__utility_tip__["a" /* default */], {
                                    showOn: this.state.propError.maxLimit,
                                    pointerStyle: {},
                                    msg: this.creditor.getErrors().maxLimit
                                }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "p",
                                    { className: "label" },
                                    "Maximum Limit Amount "
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                                    tabIndex: "8",
                                    type: "text",
                                    className: "formControl inputBox",
                                    placeholder: "Maximum Limit Amount ",
                                    onBlur: this.handleKeyUp.bind(this, "maxLimit", "creditor"),
                                    onKeyUp: this.handleKeyUp.bind(this, "maxLimit", "creditor"),
                                    ref: "maxLimit",
                                    defaultValue: this.creditor.maxLimit
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "td",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "p",
                                    { className: "label" },
                                    "Comment (reason of edit)"
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                                    tabIndex: "9",
                                    type: "text",
                                    className: "formControl inputBox",
                                    ref: "comment"
                                })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "tr",
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "div",
                                { style: { display: "flex" } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "td",
                                    { style: { lineHeight: "3" } },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__utility_tip__["a" /* default */], {
                                        showOn: this.state.propError.address,
                                        msg: this.creditor.getErrors().address
                                    }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "p",
                                        { className: "label" },
                                        "Address"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("textarea", {
                                        rows: "4",
                                        cols: "38",
                                        tabIndex: "10",
                                        type: "text",
                                        className: "formControl ",
                                        placeholder: "Address",
                                        onBlur: this.handleKeyUp.bind(this, "address", "creditor"),
                                        onKeyUp: this.handleKeyUp.bind(this, "address", "creditor"),
                                        ref: "address",
                                        defaultValue: this.creditor.address
                                    })
                                ),
                                this.user.isAdmin ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "td",
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "p",
                                        { className: "label", style: { marginTop: " 14px", marginBottom: "19" } },
                                        "Added a New Creditor"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "label",
                                        { style: { cursor: "pointer" } },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { type: "checkbox", defaultChecked: this.creditor.hasSmallCreditor === 1 ? "on" : false, onChange: this.handleAddNewCreditor.bind(this) }),
                                        " has Small Creditor"
                                    )
                                ) : false
                            )
                        )
                    )
                ) : null,
                this.state.creditorData ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "button",
                    { tabIndex: "11", className: "btn btnOk btnRight", onClick: this.createCreditor.bind(this) },
                    "Edit Creditor"
                ) : null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "clear" })
            );
        }
    }]);

    return _class;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["default"] = (_class);

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utility_tip__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_employee__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_employee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__models_employee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utility_question_box__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utility_message_box__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utility_auto_complete__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utility_rq_js__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var CreateEmployee = function (_React$Component) {
    _inherits(CreateEmployee, _React$Component);

    function CreateEmployee() {
        _classCallCheck(this, CreateEmployee);

        var _this = _possibleConstructorReturn(this, (CreateEmployee.__proto__ || Object.getPrototypeOf(CreateEmployee)).call(this));

        _this.state = {
            propError: {},
            employeeData: false,
            loader: false
        };
        _this.employee = new __WEBPACK_IMPORTED_MODULE_2__models_employee___default.a({});
        _this.questionBox = null;
        _this.messageBox = null;
        _this.onCreated = _this.onCreated.bind(_this);
        _this.onFailed = _this.onFailed.bind(_this);
        return _this;
    }

    _createClass(CreateEmployee, [{
        key: "validate",
        value: function validate(propToCheck, model, value) {
            this[model][propToCheck] = value;
            var propError = Object.assign({}, this.state.propError);
            if (this[model].getErrors()[propToCheck]) {
                propError[propToCheck] = true;
            } else {
                delete propError[propToCheck];
            }
            // this.setState({propError});
            return propError;
        }
    }, {
        key: "handleKeyUp",
        value: function handleKeyUp(propToCheck, model, e) {
            var propError = this.validate(propToCheck, model, e.target.value);
            this.setState({ propError: propError });
        }
    }, {
        key: "askQuestion",
        value: function askQuestion(msg, yesCallBack, noCallBack) {
            this.questionBox = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__utility_question_box__["a" /* default */], { questionMsg: msg, yesCallBack: yesCallBack, noCallBack: noCallBack });
            this.forceUpdate();
        }
    }, {
        key: "editEmployee",
        value: function editEmployee() {
            var _this2 = this;

            var propError = Object.assign({}, this.employee.getErrors());
            if (!this.employee.hasError() && this.refs.comment.value) {
                propError.commment = false;
                this.setState({ propError: propError });
                this.askQuestion("Do you want to Edit employee " + this.employee.employeeName + " ?", function () {
                    __WEBPACK_IMPORTED_MODULE_6__utility_rq_js__["a" /* default */].putJson("/api/v1/employee", { employeeData: _this2.employee, comment: _this2.refs.comment.value }).then(function () {
                        _this2.onCreated("Employee Update successfully");
                    }).catch(function (err) {
                        throw err;
                    });
                    _this2.questionBox = null;
                    _this2.forceUpdate();
                }, function () {
                    _this2.questionBox = null;
                    _this2.forceUpdate();
                });
            } else {
                propError.commment = true;
                this.setState({ propError: propError });
            }
        }
    }, {
        key: "onCreated",
        value: function onCreated(msg) {
            this.messageBox = __WEBPACK_IMPORTED_MODULE_4__utility_message_box__["a" /* default */].showMessage(msg, true, this);
            this.searchBox.value = "";
            this.refs.contactNo.value = "";
            this.refs.address.value = "";
            this.employee = new __WEBPACK_IMPORTED_MODULE_2__models_employee___default.a({});
            this.searchBox.focus();
            this.setState({ employeeData: false });
        }
    }, {
        key: "onFailed",
        value: function onFailed(msg) {
            this.messageBox = __WEBPACK_IMPORTED_MODULE_4__utility_message_box__["a" /* default */].showMessage(msg, false, this);
            this.forceUpdate();
        }
    }, {
        key: "onEmployeeSelect",
        value: function onEmployeeSelect(employee) {
            var _this3 = this;

            if (this.searchBox.value) this.setState({ loader: true });else this.setState({ loader: false });

            if (employee) {
                this.selectedEmployee = employee;
                var propError = Object.assign({}, this.state.propError);
                propError.employeeName = false;
                this.setState({ propError: propError, loader: true });

                __WEBPACK_IMPORTED_MODULE_6__utility_rq_js__["a" /* default */].getJsonData("/api/v1/employee/" + employee.employeeId).then(function (data) {
                    _this3.employee = new __WEBPACK_IMPORTED_MODULE_2__models_employee___default.a(data[0]);
                    _this3.setState({ propError: propError, loader: false, employeeData: true });
                }).catch(function (err) {
                    throw err;
                });
            } else {
                this.employee = new __WEBPACK_IMPORTED_MODULE_2__models_employee___default.a({});
                this.setState({ employeeData: false });
            }
        }
    }, {
        key: "componentDidMount",
        value: function componentDidMount() {
            this.searchBox.focus();
        }
    }, {
        key: "render",
        value: function render() {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "smallholder" },
                this.questionBox,
                this.messageBox,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "p",
                    { className: "formMsg" },
                    "Edit Employee"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "table",
                    { className: "formTable" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "tbody",
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "tr",
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "td",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "p",
                                    { className: "label" },
                                    "Select a Employee"
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__utility_tip__["a" /* default */], {
                                    showOn: this.state.propError.employeeName,
                                    pointerStyle: {},
                                    msg: "Please select employees Name"
                                }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__utility_auto_complete__["a" /* default */], {
                                    placeholder: "select an employee",
                                    dataSrc: "/api/v1/employee/auto",
                                    dataTobind: "employeeName",
                                    keyToBind: "employeeId",
                                    tabIndex: "1",
                                    onSelect: this.onEmployeeSelect.bind(this),
                                    rex: function rex(searchBox) {
                                        _this4.searchBox = searchBox;
                                        //this.searchBox.onfocus = this.onSelectEmployeeFocus.bind(this);
                                    }

                                })
                            )
                        )
                    )
                ),
                this.state.loader ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { style: { fontSize: "20px", position: "absolute", top: "65%", left: "40%" } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-spinner fa-spin", "aria-hidden": "true" })
                ) : null,
                this.state.employeeData ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "table",
                        { className: "formTable" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "tbody",
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "tr",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "td",
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__utility_tip__["a" /* default */], {
                                        showOn: this.state.propError.contactNo,
                                        pointerStyle: {},
                                        msg: this.employee.getErrors().contactNo
                                    }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "p",
                                        { className: "label" },
                                        "Contact Number"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                                        tabIndex: "2",
                                        type: "number",
                                        className: "formControl inputBox",
                                        placeholder: "Contact Number",
                                        onBlur: this.handleKeyUp.bind(this, "contactNo", "employee"),
                                        onKeyUp: this.handleKeyUp.bind(this, "contactNo", "employee"),
                                        ref: "contactNo",
                                        defaultValue: this.employee.contactNo
                                    })
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "tr",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "td",
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__utility_tip__["a" /* default */], {
                                        showOn: this.state.propError.address,
                                        pointerStyle: {},
                                        msg: this.employee.getErrors().address
                                    }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "p",
                                        { className: "label" },
                                        "Empoyee address"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("textarea", {
                                        rows: "3",
                                        cols: "38",
                                        tabIndex: "3",
                                        type: "text",
                                        className: "formControl",
                                        placeholder: "Empoyee address",
                                        onBlur: this.handleKeyUp.bind(this, "address", "employee"),
                                        onKeyUp: this.handleKeyUp.bind(this, "address", "employee"),
                                        ref: "address",
                                        defaultValue: this.employee.address
                                    })
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "tr",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "td",
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__utility_tip__["a" /* default */], {
                                        showOn: this.state.propError.commment,
                                        msg: "Why you want to Edit"
                                    }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "p",
                                        { className: "label" },
                                        "Why you want to Edit"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("textarea", {
                                        rows: "4",
                                        cols: "38",
                                        tabIndex: "4",
                                        type: "text",
                                        className: "formControl ",
                                        placeholder: "comment",
                                        ref: "comment"
                                    })
                                )
                            )
                        )
                    )
                ) : null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "button",
                    { tabIndex: "5", className: "btn btnOk btnRight", onClick: this.editEmployee.bind(this) },
                    "Edit Employee"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "clear" })
            );
        }
    }]);

    return CreateEmployee;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["default"] = (CreateEmployee);

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_events__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dispatcher__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_constants__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var NotificationStore = function (_EventEmitter) {
    _inherits(NotificationStore, _EventEmitter);

    function NotificationStore() {
        _classCallCheck(this, NotificationStore);

        var _this = _possibleConstructorReturn(this, (NotificationStore.__proto__ || Object.getPrototypeOf(NotificationStore)).call(this));

        _this.notifications = [];
        // console.log("notification-----------", notificationConstant);
        return _this;
    }

    _createClass(NotificationStore, [{
        key: "getAll",
        value: function getAll() {
            return this.notifications;
        }
    }, {
        key: "getNoOfNotification",
        value: function getNoOfNotification() {
            return this.notifications.length;
        }
    }, {
        key: "handleAction",
        value: function handleAction(action) {
            switch (action.type) {
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["p" /* notificationConstant */].FETCHED_ALL_NOTIFICATION:
                    {
                        this.notifications = action.data;
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["p" /* notificationConstant */].FETCHED_ALL_NOTIFICATION);
                        break;
                    }
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["p" /* notificationConstant */].NOTIFICATION_FETCH_FAILED:
                    {
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["p" /* notificationConstant */].NOTIFICATION_FETCH_FAILED, "Failed to get notification");
                        break;
                    }
                default:
                    break;
            }
        }
    }]);

    return NotificationStore;
}(__WEBPACK_IMPORTED_MODULE_0_events__["EventEmitter"]);

var notificationStore = new NotificationStore();
__WEBPACK_IMPORTED_MODULE_1__dispatcher__["a" /* default */].register(notificationStore.handleAction.bind(notificationStore));
//window.mpdStore = mpdStore;
//window.dispatcher = dispatcher;
/* harmony default export */ __webpack_exports__["a"] = (notificationStore);

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(13);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*eslint-disable no-empty */


exports.__esModule = true;
exports.saveState = saveState;
exports.readState = readState;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(15);

var _warning2 = _interopRequireDefault(_warning);

var KeyPrefix = '@@History/';
var QuotaExceededErrors = ['QuotaExceededError', 'QUOTA_EXCEEDED_ERR'];

var SecurityError = 'SecurityError';

function createKey(key) {
  return KeyPrefix + key;
}

function saveState(key, state) {
  try {
    if (state == null) {
      window.sessionStorage.removeItem(createKey(key));
    } else {
      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
    }
  } catch (error) {
    if (error.name === SecurityError) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available due to security settings') : undefined;

      return;
    }

    if (QuotaExceededErrors.indexOf(error.name) >= 0 && window.sessionStorage.length === 0) {
      // Safari "private mode" throws QuotaExceededError.
       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : undefined;

      return;
    }

    throw error;
  }
}

function readState(key) {
  var json = undefined;
  try {
    json = window.sessionStorage.getItem(createKey(key));
  } catch (error) {
    if (error.name === SecurityError) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? _warning2['default'](false, '[history] Unable to read state; sessionStorage is not available due to security settings') : undefined;

      return null;
    }
  }

  if (json) {
    try {
      return JSON.parse(json);
    } catch (error) {
      // Ignore invalid JSON.
    }
  }

  return null;
}

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _invariant = __webpack_require__(10);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(46);

var _DOMUtils = __webpack_require__(63);

var _createHistory = __webpack_require__(103);

var _createHistory2 = _interopRequireDefault(_createHistory);

function createDOMHistory(options) {
  var history = _createHistory2['default'](_extends({
    getUserConfirmation: _DOMUtils.getUserConfirmation
  }, options, {
    go: _DOMUtils.go
  }));

  function listen(listener) {
    !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'DOM history needs a DOM') : _invariant2['default'](false) : undefined;

    return history.listen(listener);
  }

  return _extends({}, history, {
    listen: listen
  });
}

exports['default'] = createDOMHistory;
module.exports = exports['default'];

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(15);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(10);

var _invariant2 = _interopRequireDefault(_invariant);

var _Actions = __webpack_require__(30);

var _PathUtils = __webpack_require__(23);

var _ExecutionEnvironment = __webpack_require__(46);

var _DOMUtils = __webpack_require__(63);

var _DOMStateStorage = __webpack_require__(100);

var _createDOMHistory = __webpack_require__(101);

var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);

function isAbsolutePath(path) {
  return typeof path === 'string' && path.charAt(0) === '/';
}

function ensureSlash() {
  var path = _DOMUtils.getHashPath();

  if (isAbsolutePath(path)) return true;

  _DOMUtils.replaceHashPath('/' + path);

  return false;
}

function addQueryStringValueToPath(path, key, value) {
  return path + (path.indexOf('?') === -1 ? '?' : '&') + (key + '=' + value);
}

function stripQueryStringValueFromPath(path, key) {
  return path.replace(new RegExp('[?&]?' + key + '=[a-zA-Z0-9]+'), '');
}

function getQueryStringValueFromPath(path, key) {
  var match = path.match(new RegExp('\\?.*?\\b' + key + '=(.+?)\\b'));
  return match && match[1];
}

var DefaultQueryKey = '_k';

function createHashHistory() {
  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Hash history needs a DOM') : _invariant2['default'](false) : undefined;

  var queryKey = options.queryKey;

  if (queryKey === undefined || !!queryKey) queryKey = typeof queryKey === 'string' ? queryKey : DefaultQueryKey;

  function getCurrentLocation() {
    var path = _DOMUtils.getHashPath();

    var key = undefined,
        state = undefined;
    if (queryKey) {
      key = getQueryStringValueFromPath(path, queryKey);
      path = stripQueryStringValueFromPath(path, queryKey);

      if (key) {
        state = _DOMStateStorage.readState(key);
      } else {
        state = null;
        key = history.createKey();
        _DOMUtils.replaceHashPath(addQueryStringValueToPath(path, queryKey, key));
      }
    } else {
      key = state = null;
    }

    var location = _PathUtils.parsePath(path);

    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
  }

  function startHashChangeListener(_ref) {
    var transitionTo = _ref.transitionTo;

    function hashChangeListener() {
      if (!ensureSlash()) return; // Always make sure hashes are preceeded with a /.

      transitionTo(getCurrentLocation());
    }

    ensureSlash();
    _DOMUtils.addEventListener(window, 'hashchange', hashChangeListener);

    return function () {
      _DOMUtils.removeEventListener(window, 'hashchange', hashChangeListener);
    };
  }

  function finishTransition(location) {
    var basename = location.basename;
    var pathname = location.pathname;
    var search = location.search;
    var state = location.state;
    var action = location.action;
    var key = location.key;

    if (action === _Actions.POP) return; // Nothing to do.

    var path = (basename || '') + pathname + search;

    if (queryKey) {
      path = addQueryStringValueToPath(path, queryKey, key);
      _DOMStateStorage.saveState(key, state);
    } else {
      // Drop key and state.
      location.key = location.state = null;
    }

    var currentHash = _DOMUtils.getHashPath();

    if (action === _Actions.PUSH) {
      if (currentHash !== path) {
        window.location.hash = path;
      } else {
         false ? _warning2['default'](false, 'You cannot PUSH the same path using hash history') : undefined;
      }
    } else if (currentHash !== path) {
      // REPLACE
      _DOMUtils.replaceHashPath(path);
    }
  }

  var history = _createDOMHistory2['default'](_extends({}, options, {
    getCurrentLocation: getCurrentLocation,
    finishTransition: finishTransition,
    saveState: _DOMStateStorage.saveState
  }));

  var listenerCount = 0,
      stopHashChangeListener = undefined;

  function listenBefore(listener) {
    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);

    var unlisten = history.listenBefore(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopHashChangeListener();
    };
  }

  function listen(listener) {
    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);

    var unlisten = history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopHashChangeListener();
    };
  }

  function push(location) {
     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;

    history.push(location);
  }

  function replace(location) {
     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;

    history.replace(location);
  }

  var goIsSupportedWithoutReload = _DOMUtils.supportsGoWithoutReloadUsingHash();

  function go(n) {
     false ? _warning2['default'](goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : undefined;

    history.go(n);
  }

  function createHref(path) {
    return '#' + history.createHref(path);
  }

  // deprecated
  function registerTransitionHook(hook) {
    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);

    history.registerTransitionHook(hook);
  }

  // deprecated
  function unregisterTransitionHook(hook) {
    history.unregisterTransitionHook(hook);

    if (--listenerCount === 0) stopHashChangeListener();
  }

  // deprecated
  function pushState(state, path) {
     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;

    history.pushState(state, path);
  }

  // deprecated
  function replaceState(state, path) {
     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;

    history.replaceState(state, path);
  }

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen,
    push: push,
    replace: replace,
    go: go,
    createHref: createHref,

    registerTransitionHook: registerTransitionHook, // deprecated - warning is in createHistory
    unregisterTransitionHook: unregisterTransitionHook, // deprecated - warning is in createHistory
    pushState: pushState, // deprecated - warning is in createHistory
    replaceState: replaceState // deprecated - warning is in createHistory
  });
}

exports['default'] = createHashHistory;
module.exports = exports['default'];

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(15);

var _warning2 = _interopRequireDefault(_warning);

var _deepEqual = __webpack_require__(200);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _PathUtils = __webpack_require__(23);

var _AsyncUtils = __webpack_require__(220);

var _Actions = __webpack_require__(30);

var _createLocation2 = __webpack_require__(222);

var _createLocation3 = _interopRequireDefault(_createLocation2);

var _runTransitionHook = __webpack_require__(65);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _deprecate = __webpack_require__(64);

var _deprecate2 = _interopRequireDefault(_deprecate);

function createRandomKey(length) {
  return Math.random().toString(36).substr(2, length);
}

function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search &&
  //a.action === b.action && // Different action !== location change.
  a.key === b.key && _deepEqual2['default'](a.state, b.state);
}

var DefaultKeyLength = 6;

function createHistory() {
  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
  var getCurrentLocation = options.getCurrentLocation;
  var finishTransition = options.finishTransition;
  var saveState = options.saveState;
  var go = options.go;
  var getUserConfirmation = options.getUserConfirmation;
  var keyLength = options.keyLength;

  if (typeof keyLength !== 'number') keyLength = DefaultKeyLength;

  var transitionHooks = [];

  function listenBefore(hook) {
    transitionHooks.push(hook);

    return function () {
      transitionHooks = transitionHooks.filter(function (item) {
        return item !== hook;
      });
    };
  }

  var allKeys = [];
  var changeListeners = [];
  var location = undefined;

  function getCurrent() {
    if (pendingLocation && pendingLocation.action === _Actions.POP) {
      return allKeys.indexOf(pendingLocation.key);
    } else if (location) {
      return allKeys.indexOf(location.key);
    } else {
      return -1;
    }
  }

  function updateLocation(newLocation) {
    var current = getCurrent();

    location = newLocation;

    if (location.action === _Actions.PUSH) {
      allKeys = [].concat(allKeys.slice(0, current + 1), [location.key]);
    } else if (location.action === _Actions.REPLACE) {
      allKeys[current] = location.key;
    }

    changeListeners.forEach(function (listener) {
      listener(location);
    });
  }

  function listen(listener) {
    changeListeners.push(listener);

    if (location) {
      listener(location);
    } else {
      var _location = getCurrentLocation();
      allKeys = [_location.key];
      updateLocation(_location);
    }

    return function () {
      changeListeners = changeListeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function confirmTransitionTo(location, callback) {
    _AsyncUtils.loopAsync(transitionHooks.length, function (index, next, done) {
      _runTransitionHook2['default'](transitionHooks[index], location, function (result) {
        if (result != null) {
          done(result);
        } else {
          next();
        }
      });
    }, function (message) {
      if (getUserConfirmation && typeof message === 'string') {
        getUserConfirmation(message, function (ok) {
          callback(ok !== false);
        });
      } else {
        callback(message !== false);
      }
    });
  }

  var pendingLocation = undefined;

  function transitionTo(nextLocation) {
    if (location && locationsAreEqual(location, nextLocation)) return; // Nothing to do.

    pendingLocation = nextLocation;

    confirmTransitionTo(nextLocation, function (ok) {
      if (pendingLocation !== nextLocation) return; // Transition was interrupted.

      if (ok) {
        // treat PUSH to current path like REPLACE to be consistent with browsers
        if (nextLocation.action === _Actions.PUSH) {
          var prevPath = createPath(location);
          var nextPath = createPath(nextLocation);

          if (nextPath === prevPath && _deepEqual2['default'](location.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
        }

        if (finishTransition(nextLocation) !== false) updateLocation(nextLocation);
      } else if (location && nextLocation.action === _Actions.POP) {
        var prevIndex = allKeys.indexOf(location.key);
        var nextIndex = allKeys.indexOf(nextLocation.key);

        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL.
      }
    });
  }

  function push(location) {
    transitionTo(createLocation(location, _Actions.PUSH, createKey()));
  }

  function replace(location) {
    transitionTo(createLocation(location, _Actions.REPLACE, createKey()));
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function createKey() {
    return createRandomKey(keyLength);
  }

  function createPath(location) {
    if (location == null || typeof location === 'string') return location;

    var pathname = location.pathname;
    var search = location.search;
    var hash = location.hash;

    var result = pathname;

    if (search) result += search;

    if (hash) result += hash;

    return result;
  }

  function createHref(location) {
    return createPath(location);
  }

  function createLocation(location, action) {
    var key = arguments.length <= 2 || arguments[2] === undefined ? createKey() : arguments[2];

    if (typeof action === 'object') {
       false ? _warning2['default'](false, 'The state (2nd) argument to history.createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;

      if (typeof location === 'string') location = _PathUtils.parsePath(location);

      location = _extends({}, location, { state: action });

      action = key;
      key = arguments[3] || createKey();
    }

    return _createLocation3['default'](location, action, key);
  }

  // deprecated
  function setState(state) {
    if (location) {
      updateLocationState(location, state);
      updateLocation(location);
    } else {
      updateLocationState(getCurrentLocation(), state);
    }
  }

  function updateLocationState(location, state) {
    location.state = _extends({}, location.state, state);
    saveState(location.key, location.state);
  }

  // deprecated
  function registerTransitionHook(hook) {
    if (transitionHooks.indexOf(hook) === -1) transitionHooks.push(hook);
  }

  // deprecated
  function unregisterTransitionHook(hook) {
    transitionHooks = transitionHooks.filter(function (item) {
      return item !== hook;
    });
  }

  // deprecated
  function pushState(state, path) {
    if (typeof path === 'string') path = _PathUtils.parsePath(path);

    push(_extends({ state: state }, path));
  }

  // deprecated
  function replaceState(state, path) {
    if (typeof path === 'string') path = _PathUtils.parsePath(path);

    replace(_extends({ state: state }, path));
  }

  return {
    listenBefore: listenBefore,
    listen: listen,
    transitionTo: transitionTo,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    createKey: createKey,
    createPath: createPath,
    createHref: createHref,
    createLocation: createLocation,

    setState: _deprecate2['default'](setState, 'setState is deprecated; use location.key to save state instead'),
    registerTransitionHook: _deprecate2['default'](registerTransitionHook, 'registerTransitionHook is deprecated; use listenBefore instead'),
    unregisterTransitionHook: _deprecate2['default'](unregisterTransitionHook, 'unregisterTransitionHook is deprecated; use the callback returned from listenBefore instead'),
    pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
    replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
  };
}

exports['default'] = createHistory;
module.exports = exports['default'];

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(15);

var _warning2 = _interopRequireDefault(_warning);

var _ExecutionEnvironment = __webpack_require__(46);

var _PathUtils = __webpack_require__(23);

var _runTransitionHook = __webpack_require__(65);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _deprecate = __webpack_require__(64);

var _deprecate2 = _interopRequireDefault(_deprecate);

function useBasename(createHistory) {
  return function () {
    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var history = createHistory(options);

    var basename = options.basename;

    var checkedBaseHref = false;

    function checkBaseHref() {
      if (checkedBaseHref) {
        return;
      }

      // Automatically use the value of <base href> in HTML
      // documents as basename if it's not explicitly given.
      if (basename == null && _ExecutionEnvironment.canUseDOM) {
        var base = document.getElementsByTagName('base')[0];
        var baseHref = base && base.getAttribute('href');

        if (baseHref != null) {
          basename = baseHref;

           false ? _warning2['default'](false, 'Automatically setting basename using <base href> is deprecated and will ' + 'be removed in the next major release. The semantics of <base href> are ' + 'subtly different from basename. Please pass the basename explicitly in ' + 'the options to createHistory') : undefined;
        }
      }

      checkedBaseHref = true;
    }

    function addBasename(location) {
      checkBaseHref();

      if (basename && location.basename == null) {
        if (location.pathname.indexOf(basename) === 0) {
          location.pathname = location.pathname.substring(basename.length);
          location.basename = basename;

          if (location.pathname === '') location.pathname = '/';
        } else {
          location.basename = '';
        }
      }

      return location;
    }

    function prependBasename(location) {
      checkBaseHref();

      if (!basename) return location;

      if (typeof location === 'string') location = _PathUtils.parsePath(location);

      var pname = location.pathname;
      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
      var pathname = normalizedBasename + normalizedPathname;

      return _extends({}, location, {
        pathname: pathname
      });
    }

    // Override all read methods with basename-aware versions.
    function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        _runTransitionHook2['default'](hook, addBasename(location), callback);
      });
    }

    function listen(listener) {
      return history.listen(function (location) {
        listener(addBasename(location));
      });
    }

    // Override all write methods with basename-aware versions.
    function push(location) {
      history.push(prependBasename(location));
    }

    function replace(location) {
      history.replace(prependBasename(location));
    }

    function createPath(location) {
      return history.createPath(prependBasename(location));
    }

    function createHref(location) {
      return history.createHref(prependBasename(location));
    }

    function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
    }

    // deprecated
    function pushState(state, path) {
      if (typeof path === 'string') path = _PathUtils.parsePath(path);

      push(_extends({ state: state }, path));
    }

    // deprecated
    function replaceState(state, path) {
      if (typeof path === 'string') path = _PathUtils.parsePath(path);

      replace(_extends({ state: state }, path));
    }

    return _extends({}, history, {
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation,

      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
    });
  };
}

exports['default'] = useBasename;
module.exports = exports['default'];

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(168);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('not a function');
  }
  this._45 = 0;
  this._81 = 0;
  this._65 = null;
  this._54 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._10 = null;
Promise._97 = null;
Promise._61 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
};
function handle(self, deferred) {
  while (self._81 === 3) {
    self = self._65;
  }
  if (Promise._10) {
    Promise._10(self);
  }
  if (self._81 === 0) {
    if (self._45 === 0) {
      self._45 = 1;
      self._54 = deferred;
      return;
    }
    if (self._45 === 1) {
      self._45 = 2;
      self._54 = [self._54, deferred];
      return;
    }
    self._54.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._81 === 1) {
        resolve(deferred.promise, self._65);
      } else {
        reject(deferred.promise, self._65);
      }
      return;
    }
    var ret = tryCallOne(cb, self._65);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._81 = 3;
      self._65 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._81 = 1;
  self._65 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._81 = 2;
  self._65 = newValue;
  if (Promise._97) {
    Promise._97(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._45 === 1) {
    handle(self, self._54);
    self._54 = null;
  }
  if (self._45 === 2) {
    for (var i = 0; i < self._54.length; i++) {
      handle(self, self._54[i]);
    }
    self._54 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  })
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(229);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * CSS properties which accept numbers but are not in units of "px".
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

/**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */
function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */
var shorthandPropertyExpansions = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true
  },
  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true
  },
  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true
  },
  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true
  },
  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true
  },
  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true
  },
  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true
  },
  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true
  },
  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true
  }
};

var CSSProperty = {
  isUnitlessNumber: isUnitlessNumber,
  shorthandPropertyExpansions: shorthandPropertyExpansions
};

module.exports = CSSProperty;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(4);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PooledClass = __webpack_require__(24);

var invariant = __webpack_require__(1);

/**
 * A specialized pseudo-event module to help keep track of components waiting to
 * be notified when their DOM representations are available for use.
 *
 * This implements `PooledClass`, so you should never need to instantiate this.
 * Instead, use `CallbackQueue.getPooled()`.
 *
 * @class ReactMountReady
 * @implements PooledClass
 * @internal
 */

var CallbackQueue = function () {
  function CallbackQueue(arg) {
    _classCallCheck(this, CallbackQueue);

    this._callbacks = null;
    this._contexts = null;
    this._arg = arg;
  }

  /**
   * Enqueues a callback to be invoked when `notifyAll` is invoked.
   *
   * @param {function} callback Invoked when `notifyAll` is invoked.
   * @param {?object} context Context to call `callback` with.
   * @internal
   */


  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
    this._callbacks = this._callbacks || [];
    this._callbacks.push(callback);
    this._contexts = this._contexts || [];
    this._contexts.push(context);
  };

  /**
   * Invokes all enqueued callbacks and clears the queue. This is invoked after
   * the DOM representation of a component has been created or updated.
   *
   * @internal
   */


  CallbackQueue.prototype.notifyAll = function notifyAll() {
    var callbacks = this._callbacks;
    var contexts = this._contexts;
    var arg = this._arg;
    if (callbacks && contexts) {
      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
      this._callbacks = null;
      this._contexts = null;
      for (var i = 0; i < callbacks.length; i++) {
        callbacks[i].call(contexts[i], arg);
      }
      callbacks.length = 0;
      contexts.length = 0;
    }
  };

  CallbackQueue.prototype.checkpoint = function checkpoint() {
    return this._callbacks ? this._callbacks.length : 0;
  };

  CallbackQueue.prototype.rollback = function rollback(len) {
    if (this._callbacks && this._contexts) {
      this._callbacks.length = len;
      this._contexts.length = len;
    }
  };

  /**
   * Resets the internal queue.
   *
   * @internal
   */


  CallbackQueue.prototype.reset = function reset() {
    this._callbacks = null;
    this._contexts = null;
  };

  /**
   * `PooledClass` looks for this.
   */


  CallbackQueue.prototype.destructor = function destructor() {
    this.reset();
  };

  return CallbackQueue;
}();

module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(32);
var ReactDOMComponentTree = __webpack_require__(8);
var ReactInstrumentation = __webpack_require__(14);

var quoteAttributeValueForBrowser = __webpack_require__(293);
var warning = __webpack_require__(3);

var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
var illegalAttributeNameCache = {};
var validatedAttributeNameCache = {};

function isAttributeNameSafe(attributeName) {
  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
    return true;
  }
  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
    return false;
  }
  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
    validatedAttributeNameCache[attributeName] = true;
    return true;
  }
  illegalAttributeNameCache[attributeName] = true;
   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
  return false;
}

function shouldIgnoreValue(propertyInfo, value) {
  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
}

/**
 * Operations for dealing with DOM properties.
 */
var DOMPropertyOperations = {
  /**
   * Creates markup for the ID property.
   *
   * @param {string} id Unescaped ID.
   * @return {string} Markup string.
   */
  createMarkupForID: function (id) {
    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
  },

  setAttributeForID: function (node, id) {
    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
  },

  createMarkupForRoot: function () {
    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
  },

  setAttributeForRoot: function (node) {
    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
  },

  /**
   * Creates markup for a property.
   *
   * @param {string} name
   * @param {*} value
   * @return {?string} Markup string, or null if the property was invalid.
   */
  createMarkupForProperty: function (name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      if (shouldIgnoreValue(propertyInfo, value)) {
        return '';
      }
      var attributeName = propertyInfo.attributeName;
      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
        return attributeName + '=""';
      }
      return attributeName + '=' + quoteAttributeValueForBrowser(value);
    } else if (DOMProperty.isCustomAttribute(name)) {
      if (value == null) {
        return '';
      }
      return name + '=' + quoteAttributeValueForBrowser(value);
    }
    return null;
  },

  /**
   * Creates markup for a custom property.
   *
   * @param {string} name
   * @param {*} value
   * @return {string} Markup string, or empty string if the property was invalid.
   */
  createMarkupForCustomAttribute: function (name, value) {
    if (!isAttributeNameSafe(name) || value == null) {
      return '';
    }
    return name + '=' + quoteAttributeValueForBrowser(value);
  },

  /**
   * Sets the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   * @param {*} value
   */
  setValueForProperty: function (node, name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, value);
      } else if (shouldIgnoreValue(propertyInfo, value)) {
        this.deleteValueForProperty(node, name);
        return;
      } else if (propertyInfo.mustUseProperty) {
        // Contrary to `setAttribute`, object properties are properly
        // `toString`ed by IE8/9.
        node[propertyInfo.propertyName] = value;
      } else {
        var attributeName = propertyInfo.attributeName;
        var namespace = propertyInfo.attributeNamespace;
        // `setAttribute` with objects becomes only `[object]` in IE8/9,
        // ('' + value) makes it output the correct toString()-value.
        if (namespace) {
          node.setAttributeNS(namespace, attributeName, '' + value);
        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
          node.setAttribute(attributeName, '');
        } else {
          node.setAttribute(attributeName, '' + value);
        }
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      DOMPropertyOperations.setValueForAttribute(node, name, value);
      return;
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  setValueForAttribute: function (node, name, value) {
    if (!isAttributeNameSafe(name)) {
      return;
    }
    if (value == null) {
      node.removeAttribute(name);
    } else {
      node.setAttribute(name, '' + value);
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  /**
   * Deletes an attributes from a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForAttribute: function (node, name) {
    node.removeAttribute(name);
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  },

  /**
   * Deletes the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForProperty: function (node, name) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, undefined);
      } else if (propertyInfo.mustUseProperty) {
        var propName = propertyInfo.propertyName;
        if (propertyInfo.hasBooleanValue) {
          node[propName] = false;
        } else {
          node[propName] = '';
        }
      } else {
        node.removeAttribute(propertyInfo.attributeName);
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      node.removeAttribute(name);
    }

    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  }
};

module.exports = DOMPropertyOperations;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentFlags = {
  hasCachedChildNodes: 1 << 0
};

module.exports = ReactDOMComponentFlags;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(7);

var LinkedValueUtils = __webpack_require__(72);
var ReactDOMComponentTree = __webpack_require__(8);
var ReactUpdates = __webpack_require__(16);

var warning = __webpack_require__(3);

var didWarnValueLink = false;
var didWarnValueDefaultValue = false;

function updateOptionsIfPendingUpdateAndMounted() {
  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
    this._wrapperState.pendingUpdate = false;

    var props = this._currentElement.props;
    var value = LinkedValueUtils.getValue(props);

    if (value != null) {
      updateOptions(this, Boolean(props.multiple), value);
    }
  }
}

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

var valuePropNames = ['value', 'defaultValue'];

/**
 * Validation function for `value` and `defaultValue`.
 * @private
 */
function checkSelectPropTypes(inst, props) {
  var owner = inst._currentElement._owner;
  LinkedValueUtils.checkPropTypes('select', props, owner);

  if (props.valueLink !== undefined && !didWarnValueLink) {
     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
    didWarnValueLink = true;
  }

  for (var i = 0; i < valuePropNames.length; i++) {
    var propName = valuePropNames[i];
    if (props[propName] == null) {
      continue;
    }
    var isArray = Array.isArray(props[propName]);
    if (props.multiple && !isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    } else if (!props.multiple && isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    }
  }
}

/**
 * @param {ReactDOMComponent} inst
 * @param {boolean} multiple
 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
 * @private
 */
function updateOptions(inst, multiple, propValue) {
  var selectedValue, i;
  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;

  if (multiple) {
    selectedValue = {};
    for (i = 0; i < propValue.length; i++) {
      selectedValue['' + propValue[i]] = true;
    }
    for (i = 0; i < options.length; i++) {
      var selected = selectedValue.hasOwnProperty(options[i].value);
      if (options[i].selected !== selected) {
        options[i].selected = selected;
      }
    }
  } else {
    // Do not set `select.value` as exact behavior isn't consistent across all
    // browsers for all cases.
    selectedValue = '' + propValue;
    for (i = 0; i < options.length; i++) {
      if (options[i].value === selectedValue) {
        options[i].selected = true;
        return;
      }
    }
    if (options.length) {
      options[0].selected = true;
    }
  }
}

/**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */
var ReactDOMSelect = {
  getHostProps: function (inst, props) {
    return _assign({}, props, {
      onChange: inst._wrapperState.onChange,
      value: undefined
    });
  },

  mountWrapper: function (inst, props) {
    if (false) {
      checkSelectPropTypes(inst, props);
    }

    var value = LinkedValueUtils.getValue(props);
    inst._wrapperState = {
      pendingUpdate: false,
      initialValue: value != null ? value : props.defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      wasMultiple: Boolean(props.multiple)
    };

    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
      didWarnValueDefaultValue = true;
    }
  },

  getSelectValueContext: function (inst) {
    // ReactDOMOption looks at this initial value so the initial generated
    // markup has correct `selected` attributes
    return inst._wrapperState.initialValue;
  },

  postUpdateWrapper: function (inst) {
    var props = inst._currentElement.props;

    // After the initial mount, we control selected-ness manually so don't pass
    // this value down
    inst._wrapperState.initialValue = undefined;

    var wasMultiple = inst._wrapperState.wasMultiple;
    inst._wrapperState.wasMultiple = Boolean(props.multiple);

    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      inst._wrapperState.pendingUpdate = false;
      updateOptions(inst, Boolean(props.multiple), value);
    } else if (wasMultiple !== Boolean(props.multiple)) {
      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
      if (props.defaultValue != null) {
        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
      } else {
        // Revert the select back to its default unselected state.
        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
      }
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  if (this._rootNodeID) {
    this._wrapperState.pendingUpdate = true;
  }
  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
  return returnValue;
}

module.exports = ReactDOMSelect;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyComponentFactory;

var ReactEmptyComponentInjection = {
  injectEmptyComponentFactory: function (factory) {
    emptyComponentFactory = factory;
  }
};

var ReactEmptyComponent = {
  create: function (instantiate) {
    return emptyComponentFactory(instantiate);
  }
};

ReactEmptyComponent.injection = ReactEmptyComponentInjection;

module.exports = ReactEmptyComponent;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactFeatureFlags = {
  // When true, call console.time() before and .timeEnd() after each top-level
  // render (both initial renders and updates). Useful when looking at prod-mode
  // timeline profiles in Chrome, for example.
  logTopLevelRenders: false
};

module.exports = ReactFeatureFlags;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(4);

var invariant = __webpack_require__(1);

var genericComponentClass = null;
var textComponentClass = null;

var ReactHostComponentInjection = {
  // This accepts a class that receives the tag string. This is a catch all
  // that can render any kind of tag.
  injectGenericComponentClass: function (componentClass) {
    genericComponentClass = componentClass;
  },
  // This accepts a text component class that takes the text string to be
  // rendered as props.
  injectTextComponentClass: function (componentClass) {
    textComponentClass = componentClass;
  }
};

/**
 * Get a host internal component class for a specific tag.
 *
 * @param {ReactElement} element The element to create.
 * @return {function} The internal class constructor function.
 */
function createInternalComponent(element) {
  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
  return new genericComponentClass(element);
}

/**
 * @param {ReactText} text
 * @return {ReactComponent}
 */
function createInstanceForText(text) {
  return new textComponentClass(text);
}

/**
 * @param {ReactComponent} component
 * @return {boolean}
 */
function isTextComponent(component) {
  return component instanceof textComponentClass;
}

var ReactHostComponent = {
  createInternalComponent: createInternalComponent,
  createInstanceForText: createInstanceForText,
  isTextComponent: isTextComponent,
  injection: ReactHostComponentInjection
};

module.exports = ReactHostComponent;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMSelection = __webpack_require__(253);

var containsNode = __webpack_require__(208);
var focusNode = __webpack_require__(98);
var getActiveElement = __webpack_require__(99);

function isInDocument(node) {
  return containsNode(document.documentElement, node);
}

/**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */
var ReactInputSelection = {
  hasSelectionCapabilities: function (elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
  },

  getSelectionInformation: function () {
    var focusedElem = getActiveElement();
    return {
      focusedElem: focusedElem,
      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
    };
  },

  /**
   * @restoreSelection: If any selection information was potentially lost,
   * restore it. This is useful when performing operations that could remove dom
   * nodes and place them back in, resulting in focus being lost.
   */
  restoreSelection: function (priorSelectionInformation) {
    var curFocusedElem = getActiveElement();
    var priorFocusedElem = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
      }
      focusNode(priorFocusedElem);
    }
  },

  /**
   * @getSelection: Gets the selection bounds of a focused textarea, input or
   * contentEditable node.
   * -@input: Look up selection bounds of this input
   * -@return {start: selectionStart, end: selectionEnd}
   */
  getSelection: function (input) {
    var selection;

    if ('selectionStart' in input) {
      // Modern browser with input or textarea.
      selection = {
        start: input.selectionStart,
        end: input.selectionEnd
      };
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      // IE8 input.
      var range = document.selection.createRange();
      // There can only be one selection per document in IE, so it must
      // be in our element.
      if (range.parentElement() === input) {
        selection = {
          start: -range.moveStart('character', -input.value.length),
          end: -range.moveEnd('character', -input.value.length)
        };
      }
    } else {
      // Content editable or old IE textarea.
      selection = ReactDOMSelection.getOffsets(input);
    }

    return selection || { start: 0, end: 0 };
  },

  /**
   * @setSelection: Sets the selection bounds of a textarea or input and focuses
   * the input.
   * -@input     Set selection bounds of this input or textarea
   * -@offsets   Object of same form that is returned from get*
   */
  setSelection: function (input, offsets) {
    var start = offsets.start;
    var end = offsets.end;
    if (end === undefined) {
      end = start;
    }

    if ('selectionStart' in input) {
      input.selectionStart = start;
      input.selectionEnd = Math.min(end, input.value.length);
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveStart('character', start);
      range.moveEnd('character', end - start);
      range.select();
    } else {
      ReactDOMSelection.setOffsets(input, offsets);
    }
  }
};

module.exports = ReactInputSelection;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(4);

var DOMLazyTree = __webpack_require__(31);
var DOMProperty = __webpack_require__(32);
var React = __webpack_require__(35);
var ReactBrowserEventEmitter = __webpack_require__(49);
var ReactCurrentOwner = __webpack_require__(20);
var ReactDOMComponentTree = __webpack_require__(8);
var ReactDOMContainerInfo = __webpack_require__(247);
var ReactDOMFeatureFlags = __webpack_require__(249);
var ReactFeatureFlags = __webpack_require__(114);
var ReactInstanceMap = __webpack_require__(42);
var ReactInstrumentation = __webpack_require__(14);
var ReactMarkupChecksum = __webpack_require__(263);
var ReactReconciler = __webpack_require__(33);
var ReactUpdateQueue = __webpack_require__(75);
var ReactUpdates = __webpack_require__(16);

var emptyObject = __webpack_require__(45);
var instantiateReactComponent = __webpack_require__(125);
var invariant = __webpack_require__(1);
var setInnerHTML = __webpack_require__(53);
var shouldUpdateReactComponent = __webpack_require__(81);
var warning = __webpack_require__(3);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;

var ELEMENT_NODE_TYPE = 1;
var DOC_NODE_TYPE = 9;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

var instancesByReactRootID = {};

/**
 * Finds the index of the first character
 * that's not common between the two given strings.
 *
 * @return {number} the index of the character where the strings diverge
 */
function firstDifferenceIndex(string1, string2) {
  var minLen = Math.min(string1.length, string2.length);
  for (var i = 0; i < minLen; i++) {
    if (string1.charAt(i) !== string2.charAt(i)) {
      return i;
    }
  }
  return string1.length === string2.length ? -1 : minLen;
}

/**
 * @param {DOMElement|DOMDocument} container DOM element that may contain
 * a React component
 * @return {?*} DOM element that may have the reactRoot ID, or null.
 */
function getReactRootElementInContainer(container) {
  if (!container) {
    return null;
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    return container.documentElement;
  } else {
    return container.firstChild;
  }
}

function internalGetID(node) {
  // If node is something like a window, document, or text node, none of
  // which support attributes or a .getAttribute method, gracefully return
  // the empty string, as if the attribute were missing.
  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
}

/**
 * Mounts this component and inserts it into the DOM.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {ReactReconcileTransaction} transaction
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
  var markerName;
  if (ReactFeatureFlags.logTopLevelRenders) {
    var wrappedElement = wrapperInstance._currentElement.props.child;
    var type = wrappedElement.type;
    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
    console.time(markerName);
  }

  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
  );

  if (markerName) {
    console.timeEnd(markerName);
  }

  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
}

/**
 * Batched mount.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */
  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
  ReactUpdates.ReactReconcileTransaction.release(transaction);
}

/**
 * Unmounts a component and removes it from the DOM.
 *
 * @param {ReactComponent} instance React component instance.
 * @param {DOMElement} container DOM element to unmount from.
 * @final
 * @internal
 * @see {ReactMount.unmountComponentAtNode}
 */
function unmountComponentFromNode(instance, container, safely) {
  if (false) {
    ReactInstrumentation.debugTool.onBeginFlush();
  }
  ReactReconciler.unmountComponent(instance, safely);
  if (false) {
    ReactInstrumentation.debugTool.onEndFlush();
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    container = container.documentElement;
  }

  // http://jsperf.com/emptying-a-node
  while (container.lastChild) {
    container.removeChild(container.lastChild);
  }
}

/**
 * True if the supplied DOM node has a direct React-rendered child that is
 * not a React root element. Useful for warning in `render`,
 * `unmountComponentAtNode`, etc.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM element contains a direct child that was
 * rendered by React but is not a root element.
 * @internal
 */
function hasNonRootReactChild(container) {
  var rootEl = getReactRootElementInContainer(container);
  if (rootEl) {
    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
    return !!(inst && inst._hostParent);
  }
}

/**
 * True if the supplied DOM node is a React DOM element and
 * it has been rendered by another copy of React.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM has been rendered by another copy of React
 * @internal
 */
function nodeIsRenderedByOtherInstance(container) {
  var rootEl = getReactRootElementInContainer(container);
  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
}

/**
 * True if the supplied DOM node is a valid node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid DOM node.
 * @internal
 */
function isValidContainer(node) {
  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
}

/**
 * True if the supplied DOM node is a valid React node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid React DOM node.
 * @internal
 */
function isReactNode(node) {
  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
}

function getHostRootInstanceInContainer(container) {
  var rootEl = getReactRootElementInContainer(container);
  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
}

function getTopLevelWrapperInContainer(container) {
  var root = getHostRootInstanceInContainer(container);
  return root ? root._hostContainerInfo._topLevelWrapper : null;
}

/**
 * Temporary (?) hack so that we can store all top-level pending updates on
 * composites instead of having to worry about different types of components
 * here.
 */
var topLevelRootCounter = 1;
var TopLevelWrapper = function () {
  this.rootID = topLevelRootCounter++;
};
TopLevelWrapper.prototype.isReactComponent = {};
if (false) {
  TopLevelWrapper.displayName = 'TopLevelWrapper';
}
TopLevelWrapper.prototype.render = function () {
  return this.props.child;
};
TopLevelWrapper.isReactTopLevelWrapper = true;

/**
 * Mounting is the process of initializing a React component by creating its
 * representative DOM elements and inserting them into a supplied `container`.
 * Any prior content inside `container` is destroyed in the process.
 *
 *   ReactMount.render(
 *     component,
 *     document.getElementById('container')
 *   );
 *
 *   <div id="container">                   <-- Supplied `container`.
 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
 *       // ...                                 component.
 *     </div>
 *   </div>
 *
 * Inside of `container`, the first element rendered is the "reactRoot".
 */
var ReactMount = {
  TopLevelWrapper: TopLevelWrapper,

  /**
   * Used by devtools. The keys are not important.
   */
  _instancesByReactRootID: instancesByReactRootID,

  /**
   * This is a hook provided to support rendering React components while
   * ensuring that the apparent scroll position of its `container` does not
   * change.
   *
   * @param {DOMElement} container The `container` being rendered into.
   * @param {function} renderCallback This must be called once to do the render.
   */
  scrollMonitor: function (container, renderCallback) {
    renderCallback();
  },

  /**
   * Take a component that's already mounted into the DOM and replace its props
   * @param {ReactComponent} prevComponent component instance already in the DOM
   * @param {ReactElement} nextElement component instance to render
   * @param {DOMElement} container container to render into
   * @param {?function} callback function triggered on completion
   */
  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
    ReactMount.scrollMonitor(container, function () {
      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
      if (callback) {
        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
      }
    });

    return prevComponent;
  },

  /**
   * Render a new component into the DOM. Hooked by hooks!
   *
   * @param {ReactElement} nextElement element to render
   * @param {DOMElement} container container to render into
   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
   * @return {ReactComponent} nextComponent
   */
  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case.
     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;

    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
    var componentInstance = instantiateReactComponent(nextElement, false);

    // The initial render is synchronous but any updates that happen during
    // rendering, in componentWillMount or componentDidMount, will be batched
    // according to the current batching strategy.

    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);

    var wrapperID = componentInstance._instance.rootID;
    instancesByReactRootID[wrapperID] = componentInstance;

    return componentInstance;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
  },

  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;

     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;

    var nextWrappedElement = React.createElement(TopLevelWrapper, {
      child: nextElement
    });

    var nextContext;
    if (parentComponent) {
      var parentInst = ReactInstanceMap.get(parentComponent);
      nextContext = parentInst._processChildContext(parentInst._context);
    } else {
      nextContext = emptyObject;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);

    if (prevComponent) {
      var prevWrappedElement = prevComponent._currentElement;
      var prevElement = prevWrappedElement.props.child;
      if (shouldUpdateReactComponent(prevElement, nextElement)) {
        var publicInst = prevComponent._renderedComponent.getPublicInstance();
        var updatedCallback = callback && function () {
          callback.call(publicInst);
        };
        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
        return publicInst;
      } else {
        ReactMount.unmountComponentAtNode(container);
      }
    }

    var reactRootElement = getReactRootElementInContainer(container);
    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
    var containerHasNonRootReactChild = hasNonRootReactChild(container);

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;

      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
        var rootElementSibling = reactRootElement;
        while (rootElementSibling) {
          if (internalGetID(rootElementSibling)) {
            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
            break;
          }
          rootElementSibling = rootElementSibling.nextSibling;
        }
      }
    }

    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
    if (callback) {
      callback.call(component);
    }
    return component;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  render: function (nextElement, container, callback) {
    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
  },

  /**
   * Unmounts and destroys the React component rendered in the `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
   *
   * @param {DOMElement} container DOM element containing a React component.
   * @return {boolean} True if a component was found in and unmounted from
   *                   `container`
   */
  unmountComponentAtNode: function (container) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case. (Strictly speaking, unmounting won't cause a
    // render but we still don't expect to be in a render call here.)
     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);
    if (!prevComponent) {
      // Check if the node being unmounted was rendered by React, but isn't a
      // root node.
      var containerHasNonRootReactChild = hasNonRootReactChild(container);

      // Check if the container itself is a React root node.
      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
      }

      return false;
    }
    delete instancesByReactRootID[prevComponent._instance.rootID];
    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
    return true;
  },

  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;

    if (shouldReuseMarkup) {
      var rootElement = getReactRootElementInContainer(container);
      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
        ReactDOMComponentTree.precacheNode(instance, rootElement);
        return;
      } else {
        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);

        var rootMarkup = rootElement.outerHTML;
        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);

        var normalizedMarkup = markup;
        if (false) {
          // because rootMarkup is retrieved from the DOM, various normalizations
          // will have occurred which will not be present in `markup`. Here,
          // insert markup into a <div> or <iframe> depending on the container
          // type to perform the same normalizations before comparing.
          var normalizer;
          if (container.nodeType === ELEMENT_NODE_TYPE) {
            normalizer = document.createElement('div');
            normalizer.innerHTML = markup;
            normalizedMarkup = normalizer.innerHTML;
          } else {
            normalizer = document.createElement('iframe');
            document.body.appendChild(normalizer);
            normalizer.contentDocument.write(markup);
            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
            document.body.removeChild(normalizer);
          }
        }

        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);

        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;

        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
        }
      }
    }

    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;

    if (transaction.useCreateElement) {
      while (container.lastChild) {
        container.removeChild(container.lastChild);
      }
      DOMLazyTree.insertTreeBefore(container, markup, null);
    } else {
      setInnerHTML(container, markup);
      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
    }

    if (false) {
      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
      if (hostNode._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: hostNode._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  }
};

module.exports = ReactMount;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(4);

var React = __webpack_require__(35);

var invariant = __webpack_require__(1);

var ReactNodeTypes = {
  HOST: 0,
  COMPOSITE: 1,
  EMPTY: 2,

  getType: function (node) {
    if (node === null || node === false) {
      return ReactNodeTypes.EMPTY;
    } else if (React.isValidElement(node)) {
      if (typeof node.type === 'function') {
        return ReactNodeTypes.COMPOSITE;
      } else {
        return ReactNodeTypes.HOST;
      }
    }
     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
  }
};

module.exports = ReactNodeTypes;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ViewportMetrics = {
  currentScrollLeft: 0,

  currentScrollTop: 0,

  refreshScrollValues: function (scrollPosition) {
    ViewportMetrics.currentScrollLeft = scrollPosition.x;
    ViewportMetrics.currentScrollTop = scrollPosition.y;
  }
};

module.exports = ViewportMetrics;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(4);

var invariant = __webpack_require__(1);

/**
 * Accumulates items that must not be null or undefined into the first one. This
 * is used to conserve memory by avoiding array allocations, and thus sacrifices
 * API cleanness. Since `current` can be null before being passed in and not
 * null after this function, make sure to assign it back to `current`:
 *
 * `a = accumulateInto(a, b);`
 *
 * This API should be sparingly used. Try `accumulate` for something cleaner.
 *
 * @return {*|array<*>} An accumulation of items.
 */

function accumulateInto(current, next) {
  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;

  if (current == null) {
    return next;
  }

  // Both are not empty. Warning: Never call x.concat(y) when you are not
  // certain that x is an Array (x could be a string with concat method).
  if (Array.isArray(current)) {
    if (Array.isArray(next)) {
      current.push.apply(current, next);
      return current;
    }
    current.push(next);
    return current;
  }

  if (Array.isArray(next)) {
    // A bit too dangerous to mutate `next`.
    return [current].concat(next);
  }

  return [current, next];
}

module.exports = accumulateInto;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * @param {array} arr an "accumulation" of items which is either an Array or
 * a single item. Useful when paired with the `accumulate` module. This is a
 * simple utility that allows us to reason about a collection of items, but
 * handling the case when there is exactly one item (and we do not need to
 * allocate an array).
 */

function forEachAccumulated(arr, cb, scope) {
  if (Array.isArray(arr)) {
    arr.forEach(cb, scope);
  } else if (arr) {
    cb.call(scope, arr);
  }
}

module.exports = forEachAccumulated;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactNodeTypes = __webpack_require__(118);

function getHostComponentFromComposite(inst) {
  var type;

  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
    inst = inst._renderedComponent;
  }

  if (type === ReactNodeTypes.HOST) {
    return inst._renderedComponent;
  } else if (type === ReactNodeTypes.EMPTY) {
    return null;
  }
}

module.exports = getHostComponentFromComposite;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(12);

var contentKey = null;

/**
 * Gets the key used to access text content on a DOM node.
 *
 * @return {?string} Key used to access text content.
 * @internal
 */
function getTextContentAccessor() {
  if (!contentKey && ExecutionEnvironment.canUseDOM) {
    // Prefer textContent to innerText because many browsers support both but
    // SVG <text> elements don't support innerText even when <div> does.
    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
  }
  return contentKey;
}

module.exports = getTextContentAccessor;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentTree = __webpack_require__(8);

function isCheckable(elem) {
  var type = elem.type;
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
}

function getTracker(inst) {
  return inst._wrapperState.valueTracker;
}

function attachTracker(inst, tracker) {
  inst._wrapperState.valueTracker = tracker;
}

function detachTracker(inst) {
  delete inst._wrapperState.valueTracker;
}

function getValueFromNode(node) {
  var value;
  if (node) {
    value = isCheckable(node) ? '' + node.checked : node.value;
  }
  return value;
}

var inputValueTracking = {
  // exposed for testing
  _getTrackerFromNode: function (node) {
    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
  },


  track: function (inst) {
    if (getTracker(inst)) {
      return;
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var valueField = isCheckable(node) ? 'checked' : 'value';
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);

    var currentValue = '' + node[valueField];

    // if someone has already defined a value or Safari, then bail
    // and don't track value will cause over reporting of changes,
    // but it's better then a hard failure
    // (needed for certain tests that spyOn input values and Safari)
    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
      return;
    }

    Object.defineProperty(node, valueField, {
      enumerable: descriptor.enumerable,
      configurable: true,
      get: function () {
        return descriptor.get.call(this);
      },
      set: function (value) {
        currentValue = '' + value;
        descriptor.set.call(this, value);
      }
    });

    attachTracker(inst, {
      getValue: function () {
        return currentValue;
      },
      setValue: function (value) {
        currentValue = '' + value;
      },
      stopTracking: function () {
        detachTracker(inst);
        delete node[valueField];
      }
    });
  },

  updateValueIfChanged: function (inst) {
    if (!inst) {
      return false;
    }
    var tracker = getTracker(inst);

    if (!tracker) {
      inputValueTracking.track(inst);
      return true;
    }

    var lastValue = tracker.getValue();
    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));

    if (nextValue !== lastValue) {
      tracker.setValue(nextValue);
      return true;
    }

    return false;
  },
  stopTracking: function (inst) {
    var tracker = getTracker(inst);
    if (tracker) {
      tracker.stopTracking();
    }
  }
};

module.exports = inputValueTracking;

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(4),
    _assign = __webpack_require__(7);

var ReactCompositeComponent = __webpack_require__(244);
var ReactEmptyComponent = __webpack_require__(113);
var ReactHostComponent = __webpack_require__(115);

var getNextDebugID = __webpack_require__(330);
var invariant = __webpack_require__(1);
var warning = __webpack_require__(3);

// To avoid a cyclic dependency, we create the final class in this module
var ReactCompositeComponentWrapper = function (element) {
  this.construct(element);
};

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Check if the type reference is a known internal type. I.e. not a user
 * provided composite type.
 *
 * @param {function} type
 * @return {boolean} Returns true if this is a valid internal type.
 */
function isInternalComponentType(type) {
  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
}

/**
 * Given a ReactNode, create an instance that will actually be mounted.
 *
 * @param {ReactNode} node
 * @param {boolean} shouldHaveDebugID
 * @return {object} A new instance of the element's constructor.
 * @protected
 */
function instantiateReactComponent(node, shouldHaveDebugID) {
  var instance;

  if (node === null || node === false) {
    instance = ReactEmptyComponent.create(instantiateReactComponent);
  } else if (typeof node === 'object') {
    var element = node;
    var type = element.type;
    if (typeof type !== 'function' && typeof type !== 'string') {
      var info = '';
      if (false) {
        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
        }
      }
      info += getDeclarationErrorAddendum(element._owner);
       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
    }

    // Special case string values
    if (typeof element.type === 'string') {
      instance = ReactHostComponent.createInternalComponent(element);
    } else if (isInternalComponentType(element.type)) {
      // This is temporarily available for custom components that are not string
      // representations. I.e. ART. Once those are updated to use the string
      // representation, we can drop this code path.
      instance = new element.type(element);

      // We renamed this. Allow the old name for compat. :(
      if (!instance.getHostNode) {
        instance.getHostNode = instance.getNativeNode;
      }
    } else {
      instance = new ReactCompositeComponentWrapper(element);
    }
  } else if (typeof node === 'string' || typeof node === 'number') {
    instance = ReactHostComponent.createInstanceForText(node);
  } else {
     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
  }

  // These two fields are used by the DOM and ART diffing algorithms
  // respectively. Instead of using expandos on components, we should be
  // storing the state needed by the diffing algorithms elsewhere.
  instance._mountIndex = 0;
  instance._mountImage = null;

  if (false) {
    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
  }

  // Internal instances should fully constructed at this point, so they should
  // not get any new fields added to them at this point.
  if (false) {
    if (Object.preventExtensions) {
      Object.preventExtensions(instance);
    }
  }

  return instance;
}

_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
  _instantiateReactComponent: instantiateReactComponent
});

module.exports = instantiateReactComponent;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */

var supportedInputTypes = {
  color: true,
  date: true,
  datetime: true,
  'datetime-local': true,
  email: true,
  month: true,
  number: true,
  password: true,
  range: true,
  search: true,
  tel: true,
  text: true,
  time: true,
  url: true,
  week: true
};

function isTextInputElement(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();

  if (nodeName === 'input') {
    return !!supportedInputTypes[elem.type];
  }

  if (nodeName === 'textarea') {
    return true;
  }

  return false;
}

module.exports = isTextInputElement;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(12);
var escapeTextContentForBrowser = __webpack_require__(52);
var setInnerHTML = __webpack_require__(53);

/**
 * Set the textContent property of a node, ensuring that whitespace is preserved
 * even in IE8. innerText is a poor substitute for textContent and, among many
 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
 * as it should.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */
var setTextContent = function (node, text) {
  if (text) {
    var firstChild = node.firstChild;

    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
      firstChild.nodeValue = text;
      return;
    }
  }
  node.textContent = text;
};

if (ExecutionEnvironment.canUseDOM) {
  if (!('textContent' in document.documentElement)) {
    setTextContent = function (node, text) {
      if (node.nodeType === 3) {
        node.nodeValue = text;
        return;
      }
      setInnerHTML(node, escapeTextContentForBrowser(text));
    };
  }
}

module.exports = setTextContent;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(4);

var ReactCurrentOwner = __webpack_require__(20);
var REACT_ELEMENT_TYPE = __webpack_require__(259);

var getIteratorFn = __webpack_require__(290);
var invariant = __webpack_require__(1);
var KeyEscapeUtils = __webpack_require__(71);
var warning = __webpack_require__(3);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = {
  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
  gentle: { stiffness: 120, damping: 14 },
  wobbly: { stiffness: 180, damping: 12 },
  stiff: { stiffness: 210, damping: 20 }
};
module.exports = exports["default"];

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _routerWarning = __webpack_require__(9);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

var _invariant = __webpack_require__(10);

var _invariant2 = _interopRequireDefault(_invariant);

var _PropTypes = __webpack_require__(87);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var _React$PropTypes = _react2.default.PropTypes;
var bool = _React$PropTypes.bool;
var object = _React$PropTypes.object;
var string = _React$PropTypes.string;
var func = _React$PropTypes.func;
var oneOfType = _React$PropTypes.oneOfType;


function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
function isEmptyObject(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
  }return true;
}

function createLocationDescriptor(to, _ref) {
  var query = _ref.query;
  var hash = _ref.hash;
  var state = _ref.state;

  if (query || hash || state) {
    return { pathname: to, query: query, hash: hash, state: state };
  }

  return to;
}

/**
 * A <Link> is used to create an <a> element that links to a route.
 * When that route is active, the link gets the value of its
 * activeClassName prop.
 *
 * For example, assuming you have the following route:
 *
 *   <Route path="/posts/:postID" component={Post} />
 *
 * You could use the following component to link to that route:
 *
 *   <Link to={`/posts/${post.id}`} />
 *
 * Links may pass along location state and/or query string parameters
 * in the state/query props, respectively.
 *
 *   <Link ... query={{ show: true }} state={{ the: 'state' }} />
 */
var Link = _react2.default.createClass({
  displayName: 'Link',


  contextTypes: {
    router: _PropTypes.routerShape
  },

  propTypes: {
    to: oneOfType([string, object]),
    query: object,
    hash: string,
    state: object,
    activeStyle: object,
    activeClassName: string,
    onlyActiveOnIndex: bool.isRequired,
    onClick: func,
    target: string
  },

  getDefaultProps: function getDefaultProps() {
    return {
      onlyActiveOnIndex: false,
      style: {}
    };
  },
  handleClick: function handleClick(event) {
    if (this.props.onClick) this.props.onClick(event);

    if (event.defaultPrevented) return;

    !this.context.router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;

    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;

    // If target prop is set (e.g. to "_blank"), let browser handle link.
    /* istanbul ignore if: untestable with Karma */
    if (this.props.target) return;

    event.preventDefault();

    var _props = this.props;
    var to = _props.to;
    var query = _props.query;
    var hash = _props.hash;
    var state = _props.state;

    var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });

    this.context.router.push(location);
  },
  render: function render() {
    var _props2 = this.props;
    var to = _props2.to;
    var query = _props2.query;
    var hash = _props2.hash;
    var state = _props2.state;
    var activeClassName = _props2.activeClassName;
    var activeStyle = _props2.activeStyle;
    var onlyActiveOnIndex = _props2.onlyActiveOnIndex;

    var props = _objectWithoutProperties(_props2, ['to', 'query', 'hash', 'state', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);

     false ? (0, _routerWarning2.default)(!(query || hash || state), 'the `query`, `hash`, and `state` props on `<Link>` are deprecated, use `<Link to={{ pathname, query, hash, state }}/>. http://tiny.cc/router-isActivedeprecated') : void 0;

    // Ignore if rendered outside the context of router, simplifies unit testing.
    var router = this.context.router;


    if (router) {
      // If user does not specify a `to` prop, return an empty anchor tag.
      if (to == null) {
        return _react2.default.createElement('a', props);
      }

      var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
      props.href = router.createHref(location);

      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
        if (router.isActive(location, onlyActiveOnIndex)) {
          if (activeClassName) {
            if (props.className) {
              props.className += ' ' + activeClassName;
            } else {
              props.className = activeClassName;
            }
          }

          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
        }
      }
    }

    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
  }
});

exports.default = Link;
module.exports = exports['default'];

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _invariant = __webpack_require__(10);

var _invariant2 = _interopRequireDefault(_invariant);

var _RouteUtils = __webpack_require__(22);

var _PatternUtils = __webpack_require__(34);

var _InternalPropTypes = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _React$PropTypes = _react2.default.PropTypes;
var string = _React$PropTypes.string;
var object = _React$PropTypes.object;

/**
 * A <Redirect> is used to declare another URL path a client should
 * be sent to when they request a given URL.
 *
 * Redirects are placed alongside routes in the route configuration
 * and are traversed in the same manner.
 */

var Redirect = _react2.default.createClass({
  displayName: 'Redirect',


  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element) {
      var route = (0, _RouteUtils.createRouteFromReactElement)(element);

      if (route.from) route.path = route.from;

      route.onEnter = function (nextState, replace) {
        var location = nextState.location;
        var params = nextState.params;


        var pathname = void 0;
        if (route.to.charAt(0) === '/') {
          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
        } else if (!route.to) {
          pathname = location.pathname;
        } else {
          var routeIndex = nextState.routes.indexOf(route);
          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
        }

        replace({
          pathname: pathname,
          query: route.query || location.query,
          state: route.state || location.state
        });
      };

      return route;
    },
    getRoutePattern: function getRoutePattern(routes, routeIndex) {
      var parentPattern = '';

      for (var i = routeIndex; i >= 0; i--) {
        var route = routes[i];
        var pattern = route.path || '';

        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;

        if (pattern.indexOf('/') === 0) break;
      }

      return '/' + parentPattern;
    }
  },

  propTypes: {
    path: string,
    from: string, // Alias for path
    to: string.isRequired,
    query: object,
    state: object,
    onEnter: _InternalPropTypes.falsy,
    children: _InternalPropTypes.falsy
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
  }
});

exports.default = Redirect;
module.exports = exports['default'];

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.createRouterObject = createRouterObject;
exports.createRoutingHistory = createRoutingHistory;

var _deprecateObjectProperties = __webpack_require__(56);

var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createRouterObject(history, transitionManager) {
  return _extends({}, history, {
    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
    isActive: transitionManager.isActive
  });
}

// deprecated
function createRoutingHistory(history, transitionManager) {
  history = _extends({}, history, transitionManager);

  if (false) {
    history = (0, _deprecateObjectProperties2.default)(history, '`props.history` and `context.history` are deprecated. Please use `context.router`. http://tiny.cc/router-contextchanges');
  }

  return history;
}

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = createMemoryHistory;

var _useQueries = __webpack_require__(47);

var _useQueries2 = _interopRequireDefault(_useQueries);

var _useBasename = __webpack_require__(104);

var _useBasename2 = _interopRequireDefault(_useBasename);

var _createMemoryHistory = __webpack_require__(223);

var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createMemoryHistory(options) {
  // signatures and type checking differ between `useRoutes` and
  // `createMemoryHistory`, have to create `memoryHistory` first because
  // `useQueries` doesn't understand the signature
  var memoryHistory = (0, _createMemoryHistory2.default)(options);
  var createHistory = function createHistory() {
    return memoryHistory;
  };
  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
  history.__v2_compatible__ = true;
  return history;
}
module.exports = exports['default'];

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (createHistory) {
  var history = void 0;
  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
  return history;
};

var _useRouterHistory = __webpack_require__(136);

var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

module.exports = exports['default'];

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = makeStateWithLocation;

var _deprecateObjectProperties = __webpack_require__(56);

var _routerWarning = __webpack_require__(9);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function makeStateWithLocation(state, location) {
  if (false) {
    var stateWithLocation = _extends({}, state);

    // I don't use deprecateObjectProperties here because I want to keep the
    // same code path between development and production, in that we just
    // assign extra properties to the copy of the state object in both cases.

    var _loop = function _loop(prop) {
      if (!Object.prototype.hasOwnProperty.call(location, prop)) {
        return 'continue';
      }

      Object.defineProperty(stateWithLocation, prop, {
        get: function get() {
          process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, 'Accessing location properties directly from the first argument to `getComponent`, `getComponents`, `getChildRoutes`, and `getIndexRoute` is deprecated. That argument is now the router state (`nextState` or `partialNextState`) rather than the location. To access the location, use `nextState.location` or `partialNextState.location`.') : void 0;
          return location[prop];
        }
      });
    };

    for (var prop in location) {
      var _ret = _loop(prop);

      if (_ret === 'continue') continue;
    }

    return stateWithLocation;
  }

  return _extends({}, state, location);
}
module.exports = exports['default'];

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = useRouterHistory;

var _useQueries = __webpack_require__(47);

var _useQueries2 = _interopRequireDefault(_useQueries);

var _useBasename = __webpack_require__(104);

var _useBasename2 = _interopRequireDefault(_useBasename);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useRouterHistory(createHistory) {
  return function (options) {
    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
    history.__v2_compatible__ = true;
    return history;
  };
}
module.exports = exports['default'];

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(44),
    _assign = __webpack_require__(7);

var ReactNoopUpdateQueue = __webpack_require__(140);

var canDefineProperty = __webpack_require__(141);
var emptyObject = __webpack_require__(45);
var invariant = __webpack_require__(1);
var lowPriorityWarning = __webpack_require__(331);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(44);

var ReactCurrentOwner = __webpack_require__(20);

var invariant = __webpack_require__(1);
var warning = __webpack_require__(3);

function isNative(fn) {
  // Based on isNative() from Lodash
  var funcToString = Function.prototype.toString;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var reIsNative = RegExp('^' + funcToString
  // Take an example native function source for comparison
  .call(hasOwnProperty
  // Strip regex characters so we can use it for regex
  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
  // Remove hasOwnProperty from the template to make it generic
  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  try {
    var source = funcToString.call(fn);
    return reIsNative.test(source);
  } catch (err) {
    return false;
  }
}

var canUseCollections =
// Array.from
typeof Array.from === 'function' &&
// Map
typeof Map === 'function' && isNative(Map) &&
// Map.prototype.keys
Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
// Set
typeof Set === 'function' && isNative(Set) &&
// Set.prototype.keys
Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);

var setItem;
var getItem;
var removeItem;
var getItemIDs;
var addRoot;
var removeRoot;
var getRootIDs;

if (canUseCollections) {
  var itemMap = new Map();
  var rootIDSet = new Set();

  setItem = function (id, item) {
    itemMap.set(id, item);
  };
  getItem = function (id) {
    return itemMap.get(id);
  };
  removeItem = function (id) {
    itemMap['delete'](id);
  };
  getItemIDs = function () {
    return Array.from(itemMap.keys());
  };

  addRoot = function (id) {
    rootIDSet.add(id);
  };
  removeRoot = function (id) {
    rootIDSet['delete'](id);
  };
  getRootIDs = function () {
    return Array.from(rootIDSet.keys());
  };
} else {
  var itemByKey = {};
  var rootByKey = {};

  // Use non-numeric keys to prevent V8 performance issues:
  // https://github.com/facebook/react/pull/7232
  var getKeyFromID = function (id) {
    return '.' + id;
  };
  var getIDFromKey = function (key) {
    return parseInt(key.substr(1), 10);
  };

  setItem = function (id, item) {
    var key = getKeyFromID(id);
    itemByKey[key] = item;
  };
  getItem = function (id) {
    var key = getKeyFromID(id);
    return itemByKey[key];
  };
  removeItem = function (id) {
    var key = getKeyFromID(id);
    delete itemByKey[key];
  };
  getItemIDs = function () {
    return Object.keys(itemByKey).map(getIDFromKey);
  };

  addRoot = function (id) {
    var key = getKeyFromID(id);
    rootByKey[key] = true;
  };
  removeRoot = function (id) {
    var key = getKeyFromID(id);
    delete rootByKey[key];
  };
  getRootIDs = function () {
    return Object.keys(rootByKey).map(getIDFromKey);
  };
}

var unmountedIDs = [];

function purgeDeep(id) {
  var item = getItem(id);
  if (item) {
    var childIDs = item.childIDs;

    removeItem(id);
    childIDs.forEach(purgeDeep);
  }
}

function describeComponentFrame(name, source, ownerName) {
  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
}

function getDisplayName(element) {
  if (element == null) {
    return '#empty';
  } else if (typeof element === 'string' || typeof element === 'number') {
    return '#text';
  } else if (typeof element.type === 'string') {
    return element.type;
  } else {
    return element.type.displayName || element.type.name || 'Unknown';
  }
}

function describeID(id) {
  var name = ReactComponentTreeHook.getDisplayName(id);
  var element = ReactComponentTreeHook.getElement(id);
  var ownerID = ReactComponentTreeHook.getOwnerID(id);
  var ownerName;
  if (ownerID) {
    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
  }
   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
  return describeComponentFrame(name, element && element._source, ownerName);
}

var ReactComponentTreeHook = {
  onSetChildren: function (id, nextChildIDs) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.childIDs = nextChildIDs;

    for (var i = 0; i < nextChildIDs.length; i++) {
      var nextChildID = nextChildIDs[i];
      var nextChild = getItem(nextChildID);
      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
      if (nextChild.parentID == null) {
        nextChild.parentID = id;
        // TODO: This shouldn't be necessary but mounting a new root during in
        // componentWillMount currently causes not-yet-mounted components to
        // be purged from our tree data so their parent id is missing.
      }
      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
    }
  },
  onBeforeMountComponent: function (id, element, parentID) {
    var item = {
      element: element,
      parentID: parentID,
      text: null,
      childIDs: [],
      isMounted: false,
      updateCount: 0
    };
    setItem(id, item);
  },
  onBeforeUpdateComponent: function (id, element) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.element = element;
  },
  onMountComponent: function (id) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.isMounted = true;
    var isRoot = item.parentID === 0;
    if (isRoot) {
      addRoot(id);
    }
  },
  onUpdateComponent: function (id) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.updateCount++;
  },
  onUnmountComponent: function (id) {
    var item = getItem(id);
    if (item) {
      // We need to check if it exists.
      // `item` might not exist if it is inside an error boundary, and a sibling
      // error boundary child threw while mounting. Then this instance never
      // got a chance to mount, but it still gets an unmounting event during
      // the error boundary cleanup.
      item.isMounted = false;
      var isRoot = item.parentID === 0;
      if (isRoot) {
        removeRoot(id);
      }
    }
    unmountedIDs.push(id);
  },
  purgeUnmountedComponents: function () {
    if (ReactComponentTreeHook._preventPurging) {
      // Should only be used for testing.
      return;
    }

    for (var i = 0; i < unmountedIDs.length; i++) {
      var id = unmountedIDs[i];
      purgeDeep(id);
    }
    unmountedIDs.length = 0;
  },
  isMounted: function (id) {
    var item = getItem(id);
    return item ? item.isMounted : false;
  },
  getCurrentStackAddendum: function (topElement) {
    var info = '';
    if (topElement) {
      var name = getDisplayName(topElement);
      var owner = topElement._owner;
      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
    }

    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    info += ReactComponentTreeHook.getStackAddendumByID(id);
    return info;
  },
  getStackAddendumByID: function (id) {
    var info = '';
    while (id) {
      info += describeID(id);
      id = ReactComponentTreeHook.getParentID(id);
    }
    return info;
  },
  getChildIDs: function (id) {
    var item = getItem(id);
    return item ? item.childIDs : [];
  },
  getDisplayName: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element) {
      return null;
    }
    return getDisplayName(element);
  },
  getElement: function (id) {
    var item = getItem(id);
    return item ? item.element : null;
  },
  getOwnerID: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element || !element._owner) {
      return null;
    }
    return element._owner._debugID;
  },
  getParentID: function (id) {
    var item = getItem(id);
    return item ? item.parentID : null;
  },
  getSource: function (id) {
    var item = getItem(id);
    var element = item ? item.element : null;
    var source = element != null ? element._source : null;
    return source;
  },
  getText: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (typeof element === 'string') {
      return element;
    } else if (typeof element === 'number') {
      return '' + element;
    } else {
      return null;
    }
  },
  getUpdateCount: function (id) {
    var item = getItem(id);
    return item ? item.updateCount : 0;
  },


  getRootIDs: getRootIDs,
  getRegisteredIDs: getItemIDs,

  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
    if (typeof console.reactStack !== 'function') {
      return;
    }

    var stack = [];
    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    try {
      if (isCreatingElement) {
        stack.push({
          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
          fileName: currentSource ? currentSource.fileName : null,
          lineNumber: currentSource ? currentSource.lineNumber : null
        });
      }

      while (id) {
        var element = ReactComponentTreeHook.getElement(id);
        var parentID = ReactComponentTreeHook.getParentID(id);
        var ownerID = ReactComponentTreeHook.getOwnerID(id);
        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
        var source = element && element._source;
        stack.push({
          name: ownerName,
          fileName: source ? source.fileName : null,
          lineNumber: source ? source.lineNumber : null
        });
        id = parentID;
      }
    } catch (err) {
      // Internal state is messed up.
      // Stop building the stack (it's just a nice to have).
    }

    console.reactStack(stack);
  },
  popNonStandardWarningStack: function () {
    if (typeof console.reactStackEnd !== 'function') {
      return;
    }
    console.reactStackEnd();
  }
};

module.exports = ReactComponentTreeHook;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var warning = __webpack_require__(3);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jsx_routes__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_reset_css__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_reset_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_reset_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_font_awesome_css_font_awesome_min_css__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_font_awesome_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style_font_awesome_css_font_awesome_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_main_style_css__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_main_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__style_main_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__registerServiceWorker__ = __webpack_require__(198);










//import './index.css';
window.myAppContainer = document.getElementById("mainContainer");
__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Router"], { routes: __WEBPACK_IMPORTED_MODULE_3__jsx_routes__["a" /* default */], history: __WEBPACK_IMPORTED_MODULE_2_react_router__["browserHistory"] }), window.myAppContainer);
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__registerServiceWorker__["a" /* unregister */])();

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(226).enable();
  window.Promise = __webpack_require__(225);
}

// fetch() polyfill for making API calls.
__webpack_require__(337);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(7);


/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_events__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dispatcher__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_constants__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var TransactionAccountStore = function (_EventEmitter) {
    _inherits(TransactionAccountStore, _EventEmitter);

    function TransactionAccountStore() {
        _classCallCheck(this, TransactionAccountStore);

        var _this = _possibleConstructorReturn(this, (TransactionAccountStore.__proto__ || Object.getPrototypeOf(TransactionAccountStore)).call(this));

        _this.trAccounts = [];
        _this.trAccountsPaymentMode = {};
        return _this;
    }

    _createClass(TransactionAccountStore, [{
        key: "getAll",
        value: function getAll() {
            return this.trAccounts;
        }
    }, {
        key: "getAllTrAccPayMode",
        value: function getAllTrAccPayMode() {
            return this.trAccountsPaymentMode;
        }
    }, {
        key: "handleAction",
        value: function handleAction(action) {
            switch (action.type) {
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["d" /* transactionAccountConstant */].TRANSACTIONACCOUNT_CREATED:
                    {
                        var trAccount = action.trAccount;

                        this.trAccounts.push(trAccount);

                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["d" /* transactionAccountConstant */].TRANSACTIONACCOUNT_CREATED, "Transaction Account created successfully.");
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["d" /* transactionAccountConstant */].TRANSACTIONACCOUNT_STORE_CHANGE);
                        break;
                    }
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["d" /* transactionAccountConstant */].TRANSACTIONACCOUNT_CREATION_FAILED:
                    {
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["d" /* transactionAccountConstant */].TRANSACTIONACCOUNT_CREATION_FAILED, action.msg);
                        break;
                    }
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["d" /* transactionAccountConstant */].FETCHED_ALL_TRANSACTIONACCOUNT:
                    {
                        //console.log("inside transactionAccount store fetch all");
                        this.trAccounts = action.data;
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["d" /* transactionAccountConstant */].TRANSACTIONACCOUNT_STORE_CHANGE);
                        break;
                    }
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["d" /* transactionAccountConstant */].FETCHED_ALL_TRANSACTION_PAYMENT:
                    {
                        this.trAccountsPaymentMode = action.data;
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["d" /* transactionAccountConstant */].TRANSACTIONACCOUNT_STORE_CHANGE);
                        break;
                    }
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["d" /* transactionAccountConstant */].TRANSACTIONACCOUNT_FETCH_FAILED:
                    {
                        //console.log("inside transactionAccount store fatld");
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["d" /* transactionAccountConstant */].TRANSACTIONACCOUNT_FETCH_FAILED, action.msg);
                        break;
                    }
                default:
                    break;
            }
        }
    }]);

    return TransactionAccountStore;
}(__WEBPACK_IMPORTED_MODULE_0_events__["EventEmitter"]);

var transactionAccountStore = new TransactionAccountStore();
__WEBPACK_IMPORTED_MODULE_1__dispatcher__["a" /* default */].register(transactionAccountStore.handleAction.bind(transactionAccountStore));
//window.mpdStore = mpdStore;
//window.dispatcher = dispatcher;
/* harmony default export */ __webpack_exports__["a"] = (transactionAccountStore);

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_events__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dispatcher__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_constants__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var PaymentModeStore = function (_EventEmitter) {
    _inherits(PaymentModeStore, _EventEmitter);

    function PaymentModeStore() {
        _classCallCheck(this, PaymentModeStore);

        var _this = _possibleConstructorReturn(this, (PaymentModeStore.__proto__ || Object.getPrototypeOf(PaymentModeStore)).call(this));

        _this.payModes = [];
        return _this;
    }

    _createClass(PaymentModeStore, [{
        key: "getAll",
        value: function getAll() {
            return this.payModes;
        }
    }, {
        key: "handleAction",
        value: function handleAction(action) {
            switch (action.type) {
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["e" /* paymentModeConstant */].PAYMENTMODE_CREATED:
                    {
                        //console.log(this);
                        var payMode = action.payMode;

                        this.payModes.push(payMode);
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["e" /* paymentModeConstant */].PAYMENTMODE_CREATED, "Payment Mode " + payMode.payModeName + " created successfully.");
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["e" /* paymentModeConstant */].PAYMENTMODE_STORE_CHANGE);
                        break;
                    }
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["e" /* paymentModeConstant */].PAYMENTMODE_CREATION_FAILED:
                    {
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["e" /* paymentModeConstant */].PAYMENTMODE_CREATION_FAILED, action.msg);
                        break;
                    }
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["e" /* paymentModeConstant */].FETCHED_ALL_PAYMENTMODE:
                    {
                        //console.log("inside payment store fetch all", action.data);
                        this.payModes = action.data;
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["e" /* paymentModeConstant */].PAYMENTMODE_STORE_CHANGE);
                        break;
                    }
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["e" /* paymentModeConstant */].PAYMENTMODE_FETCH_FAILED:
                    {
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["e" /* paymentModeConstant */].PAYMENTMODE_FETCH_FAILED, action.msg);
                        break;
                    }
                default:
                    break;
            }
        }
    }]);

    return PaymentModeStore;
}(__WEBPACK_IMPORTED_MODULE_0_events__["EventEmitter"]);

var paymentModeStore = new PaymentModeStore();
__WEBPACK_IMPORTED_MODULE_1__dispatcher__["a" /* default */].register(paymentModeStore.handleAction.bind(paymentModeStore));
/* harmony default export */ __webpack_exports__["a"] = (paymentModeStore);

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_events__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dispatcher__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_constants__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var MpdStore = function (_EventEmitter) {
    _inherits(MpdStore, _EventEmitter);

    function MpdStore() {
        _classCallCheck(this, MpdStore);

        var _this = _possibleConstructorReturn(this, (MpdStore.__proto__ || Object.getPrototypeOf(MpdStore)).call(this));

        _this.mpds = [];
        _this.mpdWithProduct = [];
        return _this;
    }

    _createClass(MpdStore, [{
        key: "getAll",
        value: function getAll() {
            return this.mpds;
        }
    }, {
        key: "getMpdsWithProduct",
        value: function getMpdsWithProduct() {
            return this.mpdWithProduct;
        }
    }, {
        key: "handleAction",
        value: function handleAction(action) {
            switch (action.type) {
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["h" /* mpdConstant */].MPD_CREATED:
                    {
                        var mpd = action.mpd;

                        this.mpds.push(mpd);
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["h" /* mpdConstant */].MPD_CREATED, "MPD " + mpd.mpdName + " created successfully.");
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["h" /* mpdConstant */].MPD_STORE_CHANGE);
                        break;
                    }
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["h" /* mpdConstant */].MPD_CREATION_FAILED:
                    {
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["h" /* mpdConstant */].MPD_CREATION_FAILED, action.msg);
                        break;
                    }
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["h" /* mpdConstant */].MPD_FETCHED_ALL:
                    {
                        //console.log("inside mpd store fetch all");
                        this.mpds = action.data;
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["h" /* mpdConstant */].MPD_STORE_CHANGE);
                        break;
                    }
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["h" /* mpdConstant */].MPD_FETCHED_ALL_WITH_PRODUCT:
                    {
                        // console.log("aaaaaaaaaaaa", action.data);
                        this.mpdWithProduct = action.data;
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["h" /* mpdConstant */].MPD_FETCHED_ALL_WITH_PRODUCT);
                        break;
                    }
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["h" /* mpdConstant */].FETCH_FAILED:
                    {
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["h" /* mpdConstant */].FETCH_FAILED, action.msg);
                        break;
                    }
                default:
                    break;
            }
        }
    }]);

    return MpdStore;
}(__WEBPACK_IMPORTED_MODULE_0_events__["EventEmitter"]);

var mpdStore = new MpdStore();
window.mpdStore = mpdStore;
__WEBPACK_IMPORTED_MODULE_1__dispatcher__["a" /* default */].register(mpdStore.handleAction.bind(mpdStore));
//window.mpdStore = mpdStore;
//window.dispatcher = dispatcher;
/* harmony default export */ __webpack_exports__["a"] = (mpdStore);

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_events__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dispatcher__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_constants__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var SwipeMachineStore = function (_EventEmitter) {
    _inherits(SwipeMachineStore, _EventEmitter);

    function SwipeMachineStore() {
        _classCallCheck(this, SwipeMachineStore);

        var _this = _possibleConstructorReturn(this, (SwipeMachineStore.__proto__ || Object.getPrototypeOf(SwipeMachineStore)).call(this));

        _this.swipes = [];
        return _this;
    }

    _createClass(SwipeMachineStore, [{
        key: "getAll",
        value: function getAll() {
            return this.swipes;
        }
    }, {
        key: "handleAction",
        value: function handleAction(action) {
            switch (action.type) {
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["f" /* swipeMachineConstant */].SWIPEMACHINE_CREATED:
                    {
                        this.swipes.push(action.swipe);
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["f" /* swipeMachineConstant */].SWIPEMACHINE_CREATED, action.msg);
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["f" /* swipeMachineConstant */].SWIPEMACHINEE_STORE_CHANGE);
                        break;
                    }
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["f" /* swipeMachineConstant */].SWIPEMACHINE_CREATION_FAILED:
                    {
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["f" /* swipeMachineConstant */].SWIPEMACHINE_CREATION_FAILED, action.msg);
                        break;
                    }
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["f" /* swipeMachineConstant */].FETCHED_ALL_SWIPEMACHINE:
                    {
                        this.swipes = action.data;
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["f" /* swipeMachineConstant */].SWIPEMACHINEE_STORE_CHANGE);
                        break;
                    }
                default:
                    break;

            }
        }
    }]);

    return SwipeMachineStore;
}(__WEBPACK_IMPORTED_MODULE_0_events__["EventEmitter"]);

var swipeMachineStore = new SwipeMachineStore();
__WEBPACK_IMPORTED_MODULE_1__dispatcher__["a" /* default */].register(swipeMachineStore.handleAction.bind(swipeMachineStore));

/* harmony default export */ __webpack_exports__["a"] = (swipeMachineStore);

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_events__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dispatcher__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_constants__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var ExpenditureCatagoryStore = function (_EventEmitter) {
    _inherits(ExpenditureCatagoryStore, _EventEmitter);

    function ExpenditureCatagoryStore() {
        _classCallCheck(this, ExpenditureCatagoryStore);

        var _this = _possibleConstructorReturn(this, (ExpenditureCatagoryStore.__proto__ || Object.getPrototypeOf(ExpenditureCatagoryStore)).call(this));

        _this.exCats = [];
        return _this;
    }

    _createClass(ExpenditureCatagoryStore, [{
        key: "getAll",
        value: function getAll() {
            return this.exCats;
        }
    }, {
        key: "handleAction",
        value: function handleAction(action) {
            switch (action.type) {
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["g" /* expenditureCatagoryConstant */].EXPENDITURECATAGORY_CREATED:
                    {
                        //console.log(this);
                        var exCat = action.exCat;

                        this.exCats.push(exCat);
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["g" /* expenditureCatagoryConstant */].EXPENDITURECATAGORY_CREATED, "Expenditure Catagory " + exCat.exCatName + " created successfully.");
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["g" /* expenditureCatagoryConstant */].EXPENDITURECATAGORY_STORE_CHANGE);
                        break;
                    }
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["g" /* expenditureCatagoryConstant */].EXPENDITURECATAGORY_CREATION_FAILED:
                    {
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["g" /* expenditureCatagoryConstant */].EXPENDITURECATAGORY_CREATION_FAILED, action.msg);
                        break;
                    }
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["g" /* expenditureCatagoryConstant */].FETCHED_ALL_EXPENDITURECATAGORY:
                    {
                        //console.log("inside exCat store fetch all >>>>>>>>>>>>");
                        this.exCats = action.data;
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["g" /* expenditureCatagoryConstant */].EXPENDITURECATAGORY_STORE_CHANGE);
                        break;
                    }
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["g" /* expenditureCatagoryConstant */].EXPENDITURECATAGORY_FETCH_FAILED:
                    {
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["g" /* expenditureCatagoryConstant */].EXPENDITURECATAGORY_FETCH_FAILED, action.msg);
                        break;
                    }
                default:
                    break;
            }
        }
    }]);

    return ExpenditureCatagoryStore;
}(__WEBPACK_IMPORTED_MODULE_0_events__["EventEmitter"]);

var expenditureCatagoryStore = new ExpenditureCatagoryStore();
__WEBPACK_IMPORTED_MODULE_1__dispatcher__["a" /* default */].register(expenditureCatagoryStore.handleAction.bind(expenditureCatagoryStore));
/* harmony default export */ __webpack_exports__["a"] = (expenditureCatagoryStore);

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = createMpd;
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchAllMpdsWithProduct;
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchAllMpd;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dispatcher__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_utility_rq_js__ = __webpack_require__(6);




function createMpd(mpd) {
    __WEBPACK_IMPORTED_MODULE_2__components_utility_rq_js__["a" /* default */].post("/api/v1/mpds", mpd).then(function (data) {
        mpd.mpdId = data[0].lastId;
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["h" /* mpdConstant */].MPD_CREATED, mpd: mpd });
    }).catch(function (data) {
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["h" /* mpdConstant */].MPD_CREATION_FAILED, msg: "creating MPD " + mpd.mpdName + " failed ! " + data.responseText });
    });
}

function fetchAllMpdsWithProduct() {
    __WEBPACK_IMPORTED_MODULE_2__components_utility_rq_js__["a" /* default */].getJsonData("/api/v1/mpdswithproduct").then(function (data) {
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["h" /* mpdConstant */].MPD_FETCHED_ALL_WITH_PRODUCT, data: data });
    }).catch(function (data) {
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["h" /* mpdConstant */].MPD_FETCHED_FAILED, msg: "Fething MPDs failed ! " + data.responseText });
    });
}

function fetchAllMpd() {
    __WEBPACK_IMPORTED_MODULE_2__components_utility_rq_js__["a" /* default */].getJsonData("/api/v1/mpds").then(function (data) {
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["h" /* mpdConstant */].MPD_FETCHED_ALL, data: data });
    }).catch(function (data) {
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["h" /* mpdConstant */].MPD_FETCHED_FAILED, msg: "Fething MPDs failed ! " + data.responseText });
    });
}

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = createShift;
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchAllShift;
/* harmony export (immutable) */ __webpack_exports__["a"] = startNewShift;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dispatcher__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_utility_rq_js__ = __webpack_require__(6);




function createShift(shift) {
    __WEBPACK_IMPORTED_MODULE_2__components_utility_rq_js__["a" /* default */].postJson("/api/v1/shift", shift).then(function (data) {
        shift.shiftId = data[0].lastId;
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["c" /* shiftConstant */].SHIFT_CREATED, shift: shift });
    }).catch(function (err) {
        if (err.msg) __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["c" /* shiftConstant */].SHIFT_CREATION_FAILED, msg: err.msg });else __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["c" /* shiftConstant */].SHIFT_CREATION_FAILED, msg: "creating shift " + shift.shiftName + " failed ! " });
    });
}

function fetchAllShift() {
    __WEBPACK_IMPORTED_MODULE_2__components_utility_rq_js__["a" /* default */].getJsonData("/api/v1/shift").then(function (data) {
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["c" /* shiftConstant */].FETCHED_ALL_SHIFT, data: data });
    }).catch(function () {
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["c" /* shiftConstant */].SHIFT_FETCH_FAILED, msg: "Fetching shift failed ! " });
    });
}

function startNewShift(newShiftData) {
    __WEBPACK_IMPORTED_MODULE_2__components_utility_rq_js__["a" /* default */].postJson("/api/v1/startnewshift", newShiftData).then(function () {
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["c" /* shiftConstant */].NEW_SHIFT_STARTED, msg: "Starting new shift" });
    }).catch(function (err) {
        if (err.msg) __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["c" /* shiftConstant */].NEW_SHIFT_FAILED, msg: err.msg });else __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["c" /* shiftConstant */].NEW_SHIFT_FAILED, msg: "Starting new shift failed ! " });
    });
}

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = creatTrAccount;
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchAllTrAccount;
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchAllTrAccountPayMode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dispatcher__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_utility_rq_js__ = __webpack_require__(6);



function creatTrAccount(trAccount) {
    __WEBPACK_IMPORTED_MODULE_2__components_utility_rq_js__["a" /* default */].post("/api/v1/transactionAcc", trAccount).then(function (data) {
        trAccount.trAccId = data[0].lastId;
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["d" /* transactionAccountConstant */].TRANSACTIONACCOUNT_CREATED, trAccount: trAccount });
    }).catch(function (data) {
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["d" /* transactionAccountConstant */].TRANSACTIONACCOUNT_CREATION_FAILED, msg: "creating Transaction Account " + trAccount.trAccountName + " failed ! " + data.responseText });
    });
}

function fetchAllTrAccount() {
    __WEBPACK_IMPORTED_MODULE_2__components_utility_rq_js__["a" /* default */].getJsonData("/api/v1/transactionAcc").then(function (data) {
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["d" /* transactionAccountConstant */].FETCHED_ALL_TRANSACTIONACCOUNT, data: data });
    }).catch(function (data) {
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["d" /* transactionAccountConstant */].TRANSACTIONACCOUNT_FETCH_FAILED, msg: "Fething Transaction Account failed ! " + data.responseText });
    });
}

function fetchAllTrAccountPayMode() {
    __WEBPACK_IMPORTED_MODULE_2__components_utility_rq_js__["a" /* default */].getJsonData("/api/v1/transaction-acc-detail").then(function (data) {
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["d" /* transactionAccountConstant */].FETCHED_ALL_TRANSACTION_PAYMENT, data: data });
    }).catch(function () {
        alert("FALI TR Paymode");
    });
}

/***/ }),
/* 152 */
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _errs = Symbol();
var _name = Symbol();
var _email = Symbol();
var _phoneNo = Symbol();
var _isAdmin = Symbol();
var _address = Symbol();
var _documentPath = Symbol();
var _enable = Symbol();
var _userId = Symbol();

var User = function () {
    function User(_ref) {
        var name = _ref.name,
            email = _ref.email,
            isAdmin = _ref.isAdmin,
            userId = _ref.userId,
            enable = _ref.enable,
            phoneNo = _ref.phoneNo,
            address = _ref.address,
            documentPath = _ref.documentPath;

        _classCallCheck(this, User);

        this[_errs] = {};
        Object.defineProperties(this, {

            userId: {
                enumerable: true,
                configurable: true,
                set: function set(value) {
                    // value = (value === "true");
                    this[_userId] = value || null;
                },
                get: function get() {
                    return this[_userId];
                }
            },
            name: {
                enumerable: true,
                configurable: true,
                set: function set(value) {
                    if (typeof value === "string" && value.length >= 1 && value !== " " && value.length <= 45) {
                        this[_name] = value.toUpperCase();
                        delete this[_errs].name;
                    } else {
                        this[_errs].name = "Name canot be empty";
                    }
                },
                get: function get() {
                    return this[_name];
                }
            },
            email: {
                enumerable: true,
                configurable: true,
                set: function set(value) {
                    //var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    var re = /\S+@\S+\.\S+/;
                    var success = re.test(value);
                    if (success && value.length < 45) {
                        this[_email] = value;
                        delete this[_errs].email;
                    } else {
                        this[_errs].email = "Must be a valid email within 45 character";
                    }
                },
                get: function get() {
                    return this[_email];
                }
            },
            phoneNo: {
                enumerable: true,
                configurable: true,
                set: function set(value) {
                    if (typeof value === "string" && value.length >= 10) {
                        this[_phoneNo] = value;
                        delete this[_errs].phoneNo;
                    } else {
                        this[_errs].phoneNo = "Phone number must be 10 or more characters each must be comma separated";
                    }
                },
                get: function get() {

                    //console.log(this[_phoneNo]);
                    return this[_phoneNo];
                }
            },

            isAdmin: {
                enumerable: true,
                configurable: true,
                set: function set(value) {
                    // value = (value === "true");
                    this[_isAdmin] = value || 0;
                },
                get: function get() {
                    return this[_isAdmin];
                }
            },
            enable: {
                enumerable: true,
                configurable: true,
                set: function set(value) {
                    // value = (value === "true");
                    this[_enable] = value || 0;
                },
                get: function get() {
                    return this[_enable];
                }
            },

            address: {
                enumerable: true,
                configurable: true,
                set: function set(value) {
                    if (typeof value === "string" && value.length >= 2 && value.length <= 100) {
                        this[_address] = value;
                        delete this[_errs].address;
                    } else {
                        this[_errs].address = "Address must be string between 2 to 100 character";
                    }
                },
                get: function get() {
                    return this[_address];
                }
            },

            documentPath: {
                enumerable: true,
                configurable: true,
                set: function set() {
                    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

                    this[_documentPath] = value;
                },
                get: function get() {
                    return this[_documentPath];
                }
            }
        });
        this.name = name;
        this.email = email;
        this.phoneNo = phoneNo;
        this.isAdmin = isAdmin;
        this.address = address;
        this.enable = enable;
        this.userId = userId;
        this.documentPath = documentPath || null;
    }

    _createClass(User, [{
        key: "hasError",
        value: function hasError() {
            return Object.keys(this[_errs]).length > 0;
        }
    }, {
        key: "getErrors",
        value: function getErrors() {
            return this[_errs];
        }
    }], [{
        key: "validateEmail",
        value: function validateEmail(email) {
            //var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var re = /\S+@\S+\.\S+/;
            return re.test(email);
        }
    }, {
        key: "validatePassword",
        value: function validatePassword(password) {
            return typeof password === "string" && password.length > 4 && password.length < 16;
        }
    }]);

    return User;
}();

module.exports = User;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = createCreditor;
/* harmony export (immutable) */ __webpack_exports__["a"] = upDateCreditor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dispatcher__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_utility_rq_js__ = __webpack_require__(6);




function createCreditor(creditor) {
    __WEBPACK_IMPORTED_MODULE_2__components_utility_rq_js__["a" /* default */].postJson("/api/v1/creditor", creditor).then(function (data) {
        creditor.creditorId = data[0].lastId;
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["a" /* creditorConstant */].CREDITOR_CREATED, creditor: creditor });
    }).catch(function (data) {
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["a" /* creditorConstant */].CREDITOR_CREATION_FAILED, msg: "creating creditor " + creditor.propritorName + " failed ! " + data.responseText });
    });
}
function upDateCreditor(data) {
    __WEBPACK_IMPORTED_MODULE_2__components_utility_rq_js__["a" /* default */].putJson("/api/v1/creditor", data).then(function (data) {
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["a" /* creditorConstant */].UPDATE_CREDITOR, data: data });
    }).catch(function (err) {
        // console.log("i am in rq fail", data);
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["a" /* creditorConstant */].UPDATE_CREDITOR_CREATION_FAILED, msg: err.msg });
    });
}

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createExCatagory;
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchAllExCat;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dispatcher__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_utility_rq_js__ = __webpack_require__(6);




function createExCatagory(exCat) {
    __WEBPACK_IMPORTED_MODULE_2__components_utility_rq_js__["a" /* default */].postJson("/api/v1/expCategory", exCat).then(function (data) {
        exCat.exCatId = data[0].lastId;
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["g" /* expenditureCatagoryConstant */].EXPENDITURECATAGORY_CREATED, exCat: exCat });
    }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["g" /* expenditureCatagoryConstant */].EXPENDITURECATAGORY_CREATION_FAILED, msg: "creating  " + exCat.exCatName + " failed !" });
    });
}

function fetchAllExCat() {
    __WEBPACK_IMPORTED_MODULE_2__components_utility_rq_js__["a" /* default */].getJsonData("/api/v1/expCategory").then(function (data) {
        //console.log("inside exCat Action fetch all >>>>>>>>>>>>rq");
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["g" /* expenditureCatagoryConstant */].FETCHED_ALL_EXPENDITURECATAGORY, data: data });
    }).catch(function () {
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["g" /* expenditureCatagoryConstant */].EXPENDITURECATAGORY_FETCH_FAILED, msg: "Fetching shift failed ! " });
    });
}

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createPaymentMode;
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchAllPaymentMode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dispatcher__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_utility_rq_js__ = __webpack_require__(6);




function createPaymentMode(payMode) {
    __WEBPACK_IMPORTED_MODULE_2__components_utility_rq_js__["a" /* default */].post("/api/v1/paymentmode", payMode).then(function (data) {
        payMode.payModeId = data[0].lastId;
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["e" /* paymentModeConstant */].PAYMENTMODE_CREATED, payMode: payMode });
    }).catch(function (data) {
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["e" /* paymentModeConstant */].PAYMENTMODE_CREATION_FAILED, msg: "creating payment Mode failed ! " + data.responseText });
    });
}

function fetchAllPaymentMode() {
    __WEBPACK_IMPORTED_MODULE_2__components_utility_rq_js__["a" /* default */].getJsonData("/api/v1/paymentmode").then(function (data) {
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["e" /* paymentModeConstant */].FETCHED_ALL_PAYMENTMODE, data: data });
    }).catch(function (data) {
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["e" /* paymentModeConstant */].PAYMENTMODE_FETCH_FAILED, msg: "Fetching shift failed ! " });
    });
}

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createProduct;
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchAllProduct;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dispatcher__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_utility_rq_js__ = __webpack_require__(6);




function createProduct(product) {
    __WEBPACK_IMPORTED_MODULE_2__components_utility_rq_js__["a" /* default */].post("/api/v1/products", product).then(function (data) {
        product.productId = data[0].lastId;
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["b" /* productConstant */].PRODUCT_CREATED, product: product });
    }).catch(function (data) {
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["b" /* productConstant */].PRODUCT_CREATION_FAILED, msg: "creating product " + product.productName + " failed ! " + data.responseText });
    });
}

function fetchAllProduct() {
    __WEBPACK_IMPORTED_MODULE_2__components_utility_rq_js__["a" /* default */].getJsonData("/api/v1/products").then(function (data) {
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["b" /* productConstant */].FETCHED_ALL_PRODUCTS, data: data });
    }).catch(function (data) {
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["b" /* productConstant */].PRODUCTS_FETCH_FAILED, msg: "Fetching product failed ! " + data.responseText });
    });
}

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cratedStockIn;
/* harmony export (immutable) */ __webpack_exports__["b"] = cratedBackWardStockIn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dispatcher__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_utility_rq_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_constants__ = __webpack_require__(2);




function cratedStockIn(stockIn) {
    __WEBPACK_IMPORTED_MODULE_1__components_utility_rq_js__["a" /* default */].postJson("/api/v1/stockIn", stockIn).then(function (data) {
        stockIn.stockInId = data[0].lastId;
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_2__constants_constants__["j" /* stockInConstant */].STOCKIN_CREATED, stockIn: stockIn });
    }).catch(function (data) {
        if (data.status === 400) {
            __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_2__constants_constants__["j" /* stockInConstant */].STOCKIN_CREATION_FAILED, msg: JSON.parse(data.responseText) });
        } else {
            __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_2__constants_constants__["j" /* stockInConstant */].STOCKIN_CREATION_FAILED, msg: " StockIn  failed" });
        }
    });
}
function cratedBackWardStockIn(stockIn) {
    __WEBPACK_IMPORTED_MODULE_1__components_utility_rq_js__["a" /* default */].postJson("/api/v1/backward-stockIn", stockIn).then(function (data) {
        stockIn.stockInId = data[0].lastId;
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_2__constants_constants__["j" /* stockInConstant */].STOCKIN_CREATED, stockIn: stockIn });
    }).catch(function (data) {
        if (data.status === 400) {
            __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_2__constants_constants__["j" /* stockInConstant */].STOCKIN_CREATION_FAILED, msg: JSON.parse(data.responseText) });
        } else {
            __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_2__constants_constants__["j" /* stockInConstant */].STOCKIN_CREATION_FAILED, msg: " StockIn  failed" });
        }
    });
}

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSwipeMachine;
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchAllSwipes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dispatcher__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_utility_rq_js__ = __webpack_require__(6);




function createSwipeMachine(swipe) {
    __WEBPACK_IMPORTED_MODULE_2__components_utility_rq_js__["a" /* default */].post("/api/v1/swipemachine", swipe).then(function (data) {
        swipe.swipeId = data[0].lastId;
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["f" /* swipeMachineConstant */].SWIPEMACHINE_CREATED, swipe: swipe, msg: "swipe  created successfully." });
    }).catch(function (data) {
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["f" /* swipeMachineConstant */].SWIPEMACHINE_CREATION_FAILED, msg: "creating swipe failed ! " + data.responseText });
    });
}

function fetchAllSwipes() {
    __WEBPACK_IMPORTED_MODULE_2__components_utility_rq_js__["a" /* default */].getJsonData("/api/v1/swipemachines").then(function (data) {
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["f" /* swipeMachineConstant */].FETCHED_ALL_SWIPEMACHINE, data: data });
    }).catch(function (data) {
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["f" /* swipeMachineConstant */].SWIPEMACHINE_FETCH_FAILED, msg: "Fething swipe Machine failed ! " + data.responseText });
    });
}

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTank;
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchAllTanks;
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchAllDipTable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dispatcher__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_utility_rq_js__ = __webpack_require__(6);




function createTank(tank) {
    __WEBPACK_IMPORTED_MODULE_2__components_utility_rq_js__["a" /* default */].post("/api/v1/tanks", tank).then(function (data) {
        tank.tankId = data[0].lastId;
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["k" /* tankConstant */].TANK_CREATED, tank: tank, msg: "Tank " + tank.tankName + " created successfully." });
    }).catch(function (data) {
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["k" /* tankConstant */].TANK_CREATION_FAILED, msg: data.msg || "creating tank " + tank.tankName + " failed ! " + data.responseText });
    });
}

function fetchAllTanks() {
    __WEBPACK_IMPORTED_MODULE_2__components_utility_rq_js__["a" /* default */].getJsonData("/api/v1/tanks").then(function (data) {
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["k" /* tankConstant */].FETCHED_ALL_TANKS, data: data, msg: "all tanks fetched successfully." });
    }).catch(function (data) {
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["k" /* tankConstant */].TANK_FETCH_FAILED, msg: "Fetching tanks failed ! " + data.responseText });
    });
}
function fetchAllDipTable() {
    __WEBPACK_IMPORTED_MODULE_2__components_utility_rq_js__["a" /* default */].getJsonData("/api/v1/dip-table").then(function (data) {
        //console.log("inside action dip ", data);
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["k" /* tankConstant */].FETCHED_ALL_DIP_TABLE, data: data, msg: "all dip table fetched successfully." });
    }).catch(function (data) {
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["k" /* tankConstant */].DIP_TABLE_FETCH_FAILED, msg: "Fetching dip table failed !" });
    });
}

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createUser;
/* harmony export (immutable) */ __webpack_exports__["b"] = updatePassword;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dispatcher__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_utility_rq__ = __webpack_require__(6);




function createUser(user) {
    __WEBPACK_IMPORTED_MODULE_2__components_utility_rq__["a" /* default */].post("/api/v1/user", user).then(function () {
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["i" /* userConstant */].USER_CREATED, user: user, msg: "User " + user.name + " created successfully." });
    }).catch(function (data) {
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["i" /* userConstant */].USER_CREATION_FAILED, msg: "creating user " + user.userName + " failed ! " + data.responseText });
    });
}

function updatePassword(data) {
    __WEBPACK_IMPORTED_MODULE_2__components_utility_rq__["a" /* default */].post("/update-password", data).then(function () {
        alert("passworded updated");
        window.location = "/login";
    }).catch(function (err) {
        alert(err);
    });
}

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var NoPermission = function (_React$Component) {
    _inherits(NoPermission, _React$Component);

    function NoPermission() {
        _classCallCheck(this, NoPermission);

        return _possibleConstructorReturn(this, (NoPermission.__proto__ || Object.getPrototypeOf(NoPermission)).apply(this, arguments));
    }

    _createClass(NoPermission, [{
        key: "render",
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { style: { display: "flex", marginTop: "100px", backgrondColor: "red", flexDirection: "column", alignItems: "center" } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-exclamation-triangle", style: { color: "red", fontSize: "5em" } }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "p",
                        { style: { fontSize: "3em", color: "gray" } },
                        "Not found"
                    )
                )
            );
        }
    }]);

    return NoPermission;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (NoPermission);

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_events__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dispatcher__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_constants__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var CreditorStore = function (_EventEmitter) {
    _inherits(CreditorStore, _EventEmitter);

    function CreditorStore() {
        _classCallCheck(this, CreditorStore);

        var _this = _possibleConstructorReturn(this, (CreditorStore.__proto__ || Object.getPrototypeOf(CreditorStore)).call(this));

        _this.creditors = [];
        return _this;
    }

    _createClass(CreditorStore, [{
        key: "getAll",
        value: function getAll() {
            return this.creditor;
        }
    }, {
        key: "handleAction",
        value: function handleAction(action) {
            switch (action.type) {
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["a" /* creditorConstant */].CREDITOR_CREATED:
                    {
                        var creditor = action.creditor;

                        this.creditors.push(creditor);
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["a" /* creditorConstant */].CREDITOR_CREATED, "creditor  created successfully.");
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["a" /* creditorConstant */].CREDITOR_STORE_CHANGE);
                        break;
                    }
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["a" /* creditorConstant */].CREDITOR_CREATION_FAILED:
                    {
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["a" /* creditorConstant */].CREDITOR_CREATION_FAILED, action.msg);
                        break;
                    }
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["a" /* creditorConstant */].FETCHED_ALL_CREDITOR:
                    {

                        this.creditors = action.data;
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["a" /* creditorConstant */].CREDITOR_STORE_CHANGE);
                        break;
                    }
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["a" /* creditorConstant */].CREDITOR_FETCH_FAILED:
                    {
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["a" /* creditorConstant */].CREDITOR_FETCH_FAILED, action.msg);
                        break;
                    }
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["a" /* creditorConstant */].UPDATE_CREDITOR:
                    {
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["a" /* creditorConstant */].UPDATE_CREDITOR, action.data.msg);
                        break;
                    }
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["a" /* creditorConstant */].UPDATE_CREDITOR_CREATION_FAILED:
                    {
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["a" /* creditorConstant */].UPDATE_CREDITOR_CREATION_FAILED, action.msg);
                        break;
                    }
                default:
                    break;
            }
        }
    }]);

    return CreditorStore;
}(__WEBPACK_IMPORTED_MODULE_0_events__["EventEmitter"]);

var creditorStore = new CreditorStore();
__WEBPACK_IMPORTED_MODULE_1__dispatcher__["a" /* default */].register(creditorStore.handleAction.bind(creditorStore));
/* harmony default export */ __webpack_exports__["a"] = (creditorStore);

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_events__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dispatcher__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_constants__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var NozzelStore = function (_EventEmitter) {
    _inherits(NozzelStore, _EventEmitter);

    function NozzelStore() {
        _classCallCheck(this, NozzelStore);

        var _this = _possibleConstructorReturn(this, (NozzelStore.__proto__ || Object.getPrototypeOf(NozzelStore)).call(this));

        _this.nozzels = [];
        return _this;
    }

    _createClass(NozzelStore, [{
        key: "getAll",
        value: function getAll() {
            return this.nozzels;
        }
    }, {
        key: "handleAction",
        value: function handleAction(action) {
            switch (action.type) {
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["l" /* nozzelConstant */].NOZZEL_CREATED:
                    {
                        var nozzel = action.nozzel;

                        this.nozzels.push(nozzel);
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["l" /* nozzelConstant */].NOZZEL_CREATED, "Nozzel " + nozzel.nozzelName + " created successfully.");
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["l" /* nozzelConstant */].NOZZEL_STORE_CHANGE);
                        break;
                    }
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["l" /* nozzelConstant */].NOZZEL_CREATION_FAILED:
                    {
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["l" /* nozzelConstant */].NOZZEL_CREATION_FAILED, action.msg);
                        break;
                    }
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["l" /* nozzelConstant */].NOZZEL_FETCH_ALL:
                    {
                        console.log("inside mpd store fetch all");
                        this.nozzels = action.data;
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["l" /* nozzelConstant */].NOZZEL_STORE_CHANGE);
                        break;
                    }
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["l" /* nozzelConstant */].NOZZEL_FETCH_FAILED:
                    {
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["l" /* nozzelConstant */].NOZZEL_FETCH_FAILED, action.msg);
                        break;
                    }
                default:
                    break;
            }
        }
    }]);

    return NozzelStore;
}(__WEBPACK_IMPORTED_MODULE_0_events__["EventEmitter"]);

var nozzelStore = new NozzelStore();
__WEBPACK_IMPORTED_MODULE_1__dispatcher__["a" /* default */].register(nozzelStore.handleAction.bind(nozzelStore));
//window.nozzelStore = nozzelStore;
//window.dispatcher = dispatcher;
/* harmony default export */ __webpack_exports__["a"] = (nozzelStore);

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_events__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dispatcher__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_constants__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var StockInStore = function (_EventEmitter) {
    _inherits(StockInStore, _EventEmitter);

    function StockInStore() {
        _classCallCheck(this, StockInStore);

        return _possibleConstructorReturn(this, (StockInStore.__proto__ || Object.getPrototypeOf(StockInStore)).apply(this, arguments));
    }

    _createClass(StockInStore, [{
        key: "handleAction",
        value: function handleAction(action) {
            switch (action.type) {
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["j" /* stockInConstant */].STOCKIN_CREATED:
                    {
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["j" /* stockInConstant */].STOCKIN_CREATED, "stockIn created successfully.");
                        break;
                    }
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["j" /* stockInConstant */].STOCKIN_CREATION_FAILED:
                    {
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["j" /* stockInConstant */].STOCKIN_CREATION_FAILED, action.msg);
                        break;
                    }
                default:
                    break;
            }
        }
    }]);

    return StockInStore;
}(__WEBPACK_IMPORTED_MODULE_0_events__["EventEmitter"]);

var stockInStore = new StockInStore();
__WEBPACK_IMPORTED_MODULE_1__dispatcher__["a" /* default */].register(stockInStore.handleAction.bind(stockInStore));
//window.mpdStore = mpdStore;
//window.dispatcher = dispatcher;
/* harmony default export */ __webpack_exports__["a"] = (stockInStore);

/***/ }),
/* 166 */
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _errs = Symbol();
var _firmName = Symbol();
var _address = Symbol();
var _contactNo = Symbol();
var _maxLimit = Symbol();
var _creditorId = Symbol();
var _proprietorName = Symbol();
var _email = Symbol();
var _panNumber = Symbol();
var _shortName = Symbol();
var _hasSmallCreditor = Symbol();
var _disabled = Symbol();

var Creditor = function () {
    function Creditor(_ref) {
        var firmName = _ref.firmName,
            proprietorName = _ref.proprietorName,
            email = _ref.email,
            panNumber = _ref.panNumber,
            address = _ref.address,
            contactNo = _ref.contactNo,
            maxLimit = _ref.maxLimit,
            creditorId = _ref.creditorId,
            shortName = _ref.shortName,
            hasSmallCreditor = _ref.hasSmallCreditor,
            _ref$disabled = _ref.disabled,
            disabled = _ref$disabled === undefined ? false : _ref$disabled;

        _classCallCheck(this, Creditor);

        this[_errs] = {};

        Object.defineProperties(this, {
            firmName: {
                enumerable: true,
                configurable: true,
                set: function set(value) {
                    if (typeof value === "string" && value.length >= 2 && value.length <= 45) {
                        this[_firmName] = value.toUpperCase();
                        delete this[_errs].firmName;
                    } else {
                        this[_errs].firmName = "firm name  must be between 2 to 45 characters";
                    }
                },

                get: function get() {
                    return this[_firmName];
                }
            },
            shortName: {
                enumerable: true,
                configurable: true,
                set: function set(value) {
                    if (typeof value === "string" && value.length >= 2 && value.length <= 50) {
                        this[_shortName] = value.toUpperCase();
                        delete this[_errs].shortName;
                    } else {
                        this[_errs].shortName = "Short name  must be between 2 to 50 characters";
                    }
                },

                get: function get() {
                    return this[_shortName];
                }
            },

            proprietorName: {
                enumerable: true,
                configurable: true,
                set: function set(value) {
                    if (typeof value === "string" && value.length >= 2 && value.length <= 45) {
                        this[_proprietorName] = value.toUpperCase();
                        delete this[_errs].proprietorName;
                    } else {
                        this[_errs].proprietorName = "proprietorName  must be between 2 to 45 characters";
                    }
                },
                get: function get() {
                    return this[_proprietorName];
                }
            },
            email: {
                enumerable: true,
                configurable: true,
                set: function set(value) {
                    var re = /\S+@\S+\.\S+/;
                    // var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    var success = re.test(value);
                    if (success && value.length < 45) {
                        this[_email] = value;
                        delete this[_errs].email;
                    } else {
                        this[_errs].email = "Must be a valid email within 45 character";
                    }
                },
                get: function get() {
                    return this[_email];
                }
            },

            address: {
                enumerable: true,
                configurable: true,
                set: function set(value) {
                    if (typeof value === "string" && value.length >= 2 && value.length <= 70) {
                        this[_address] = value.toUpperCase();
                        delete this[_errs].address;
                    } else {
                        this[_errs].address = "address must be between 2 to 70 characters";
                    }
                },
                get: function get() {
                    return this[_address];
                }
            },
            contactNo: {
                enumerable: true,
                configurable: true,
                set: function set(value) {

                    if (typeof value === "string" && value.length >= 10 && value.length <= 20) {
                        this[_contactNo] = value;
                        delete this[_errs].contactNo;
                    } else {
                        // this[_errs].contactNo = "Contact number must be between 10 to 20 characters";

                        // makeing contact no optional
                    }
                },
                get: function get() {
                    return this[_contactNo];
                }
            },
            panNumber: {
                enumerable: true,
                configurable: true,
                set: function set(value) {
                    // pan number length not checked bcoz lack of time
                    this[_panNumber] = value || null;
                },
                get: function get() {
                    return this[_panNumber];
                }
            },
            maxLimit: {
                enumerable: true,
                configurable: true,
                set: function set(value) {
                    var x = parseInt(value, 10);
                    if (x) {
                        this[_maxLimit] = x;
                        delete this[_errs].maxLimit;
                    } else {
                        this[_errs].maxLimit = "maximum limit amount  must be a valid integer";
                    }
                },
                get: function get() {
                    return this[_maxLimit];
                }
            },
            creditorId: {
                enumerable: true,
                configurable: true,
                set: function set(value) {
                    this[_creditorId] = value;
                },
                get: function get() {
                    return this[_creditorId];
                }
            },
            hasSmallCreditor: {
                enumerable: true,
                configurable: true,
                set: function set(value) {
                    this[_hasSmallCreditor] = value;
                },
                get: function get() {
                    return this[_hasSmallCreditor];
                }
            },
            disabled: {
                enumerable: true,
                configurable: true,
                set: function set(value) {
                    this[_disabled] = value;
                },
                get: function get() {
                    return this[_disabled];
                }
            }
        });
        this.hasSmallCreditor = hasSmallCreditor;
        this.firmName = firmName;
        this.shortName = shortName;
        this.proprietorName = proprietorName;
        this.email = email;
        this.panNumber = panNumber;
        this.address = address;
        this.contactNo = contactNo;
        this.maxLimit = maxLimit;
        this.creditorId = creditorId;
        this.disabled = disabled;
    }

    _createClass(Creditor, [{
        key: "hasError",
        value: function hasError() {
            return Object.keys(this[_errs]).length > 0;
        }
    }, {
        key: "getErrors",
        value: function getErrors() {
            return this[_errs];
        }
    }]);

    return Creditor;
}();

module.exports = Creditor;

/***/ }),
/* 167 */
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _employeeName = Symbol();
var _contactNo = Symbol();
var _address = Symbol();
var _imagePath = Symbol();
var _documentPath = Symbol();
var _employeeId = Symbol();
var _payRate = Symbol();
var _joinDate = Symbol();
var _errs = Symbol();

var Employee = function () {
    function Employee(_ref) {
        var employeeName = _ref.employeeName,
            contactNo = _ref.contactNo,
            address = _ref.address,
            imagePath = _ref.imagePath,
            documentPath = _ref.documentPath,
            employeeId = _ref.employeeId,
            payRate = _ref.payRate,
            joinDate = _ref.joinDate;

        _classCallCheck(this, Employee);

        this[_errs] = {};

        Object.defineProperties(this, {
            employeeName: {
                enumerable: true,
                configurable: true,
                set: function set(value) {
                    if (typeof value === "string" && value.length >= 2 && value.length <= 45) {
                        this[_employeeName] = value.toLowerCase();
                        delete this[_errs].employeeName;
                    } else {
                        this[_errs].employeeName = "Employee name  must be between 2 to 45 characters";
                    }
                },
                get: function get() {
                    return this[_employeeName];
                }
            },

            contactNo: {
                enumerable: true,
                configurable: true,
                set: function set(value) {

                    if (typeof value === "string" && value.length >= 10 && value.length <= 20) {

                        this[_contactNo] = value;
                        delete this[_errs].contactNo;
                    } else {
                        this[_errs].contactNo = "Contact number must be between 10 to 20 characters";
                    }
                },
                get: function get() {
                    return this[_contactNo];
                }
            },

            address: {
                enumerable: true,
                configurable: true,
                set: function set(value) {
                    if (typeof value === "string" && value.length >= 2 && value.length <= 200) {
                        this[_address] = value.toLowerCase();
                        delete this[_errs].address;
                    } else {
                        this[_errs].address = "address number must be between 2 to 200 characters";
                    }
                },
                get: function get() {
                    return this[_address];
                }
            },

            imagePath: {
                enumerable: true,
                configurable: true,
                set: function set(value) {
                    this[_imagePath] = value || null;
                },
                get: function get() {
                    return this[_imagePath];
                }
            },

            documentPath: {
                enumerable: true,
                configurable: true,
                set: function set(value) {
                    this[_documentPath] = value || null;
                },
                get: function get() {
                    return this[_documentPath];
                }
            },

            employeeId: {
                enumerable: true,
                configurable: true,
                set: function set() {
                    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

                    this[_employeeId] = value;
                },
                get: function get() {
                    return this[_employeeId];
                }
            },
            payRate: {
                enumerable: true,
                configurable: true,
                set: function set(value) {
                    if (!isNaN(value) && parseFloat(value) && value > 0) {
                        this[_payRate] = parseFloat(value);
                        delete this[_errs].payRate;
                    } else {
                        this[_errs].payRate = "please enter a valid payrate";
                    }
                },
                get: function get() {
                    return this[_payRate];
                }
            },
            joinDate: {
                enumerable: true,
                configurable: true,
                set: function set(value) {
                    var pattern = /^([0-9]{4})-([0-9]{2})-([0-9]{2})$/;
                    if (pattern.test(value) && Date.parse(value)) {
                        this[_joinDate] = value;
                        delete this[_errs].joinDate;
                    } else {
                        this[_errs].joinDate = "please enter a valid join date YYYY-MM-DD format";
                    }
                },
                get: function get() {
                    return this[_joinDate];
                }
            }

        });

        this.employeeName = employeeName;
        this.contactNo = contactNo;
        this.address = address;
        this.imagePath = imagePath;
        this.documentPath = documentPath;
        this.employeeId = employeeId;
        this.payRate = payRate;
        this.joinDate = joinDate;
    }

    _createClass(Employee, [{
        key: "hasError",
        value: function hasError() {
            return Object.keys(this[_errs]).length > 0;
        }
    }, {
        key: "getErrors",
        value: function getErrors() {
            return this[_errs];
        }
    }]);

    return Employee;
}();

module.exports = Employee;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(90)))

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = login;
/* harmony export (immutable) */ __webpack_exports__["b"] = recoverPassword;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dispatcher__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_utility_rq__ = __webpack_require__(6);



function login(email, password) {
    var data = {
        email: email,
        password: password
    };
    __WEBPACK_IMPORTED_MODULE_1__components_utility_rq__["a" /* default */].post("/login", data).then(function (data) {
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: "loginSuccess", tokenData: data });
    }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: "loginFailed" });
        throw err;
    });
}
/**
 * 
 * @param {string email} email 
 * 
 */
function recoverPassword(email) {

    __WEBPACK_IMPORTED_MODULE_1__components_utility_rq__["a" /* default */].putJson("/passwordrecovery", { email: email }).then(function () {
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: "passwordRecovered" });
    }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: "passwordRecoveryFailed" });
        throw err;
    });
}

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createInvoice;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dispatcher__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_utility_rq_js__ = __webpack_require__(6);



function createInvoice(invoiceData) {
    __WEBPACK_IMPORTED_MODULE_2__components_utility_rq_js__["a" /* default */].postJson("/api/v1/invoice", invoiceData).then(function (data) {
        var invoice = invoiceData.invoice;

        invoice.invoiceId = data[0].id;
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["q" /* invoiceConstant */].INVOICE_CREATED, invoice: invoice });
    }).catch(function (err) {
        console.log("err...............", err);
        __WEBPACK_IMPORTED_MODULE_0__dispatcher__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__constants_constants__["q" /* invoiceConstant */].INVOICE_CREATION_FAILED, msg: "creating invoice " + invoiceData.invoice.invoiceNumber + " failed !" });
    });
}

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_notification_store__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_router__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var AdminNotifaction = function (_React$Component) {
    _inherits(AdminNotifaction, _React$Component);

    function AdminNotifaction() {
        _classCallCheck(this, AdminNotifaction);

        var _this = _possibleConstructorReturn(this, (AdminNotifaction.__proto__ || Object.getPrototypeOf(AdminNotifaction)).call(this));

        _this.state = {
            notificationData: __WEBPACK_IMPORTED_MODULE_1__store_notification_store__["a" /* default */].getAll()

        };
        _this.onNotificationFetched = _this.onNotificationFetched.bind(_this);
        return _this;
    }

    _createClass(AdminNotifaction, [{
        key: "onNotificationFetched",
        value: function onNotificationFetched() {
            this.setState({ notificationData: __WEBPACK_IMPORTED_MODULE_1__store_notification_store__["a" /* default */].getAll() });
        }
    }, {
        key: "componentWillMount",
        value: function componentWillMount() {
            __WEBPACK_IMPORTED_MODULE_1__store_notification_store__["a" /* default */].on(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["p" /* notificationConstant */].FETCHED_ALL_NOTIFICATION, this.onNotificationFetched);
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            __WEBPACK_IMPORTED_MODULE_1__store_notification_store__["a" /* default */].removeListener(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["p" /* notificationConstant */].FETCHED_ALL_NOTIFICATION, this.onNotificationFetched);
        }
    }, {
        key: "onOverlayClick",
        value: function onOverlayClick() {
            this.props.hide();
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "notificationBox", style: { display: this.state.notificationData.length > 0 ? "" : "none" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: {
                        position: "fixed",
                        background: "transparent",
                        width: "100%", height: "100%",
                        top: "35px", left: 0, zIndex: -1
                    },
                    onClick: this.onOverlayClick.bind(this) }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "pointer", style: { borderBottomColor: "#c7c7c7", top: "-11px", right: "28px" } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "pointer", style: { borderBottomColor: "white", top: "-10px", right: "28px" } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { style: {
                            overflowY: "auto",
                            maxHeight: "450px",
                            maxWidth: "400px",
                            display: "flex",
                            padding: " 0 20px",
                            flexDirection: "column",
                            alignItems: "center"
                        } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "ul",
                        null,
                        this.state.notificationData.map(function (notification, i) {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "li",
                                { key: i, onClick: function onClick() {
                                        _this2.props.hide();
                                    } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_3_react_router__["Link"],
                                    { to: "/permission/" + notification.rowId + "/" + notification.tableName },
                                    notification.msg.toLowerCase()
                                )
                            );
                        })
                    )
                )
            );
        }
    }]);

    return AdminNotifaction;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (AdminNotifaction);

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utility_tip__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utility_question_box__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utility_message_box__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_product_store__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_utility_select_menu__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_tank_store__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_backward_stockin__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_backward_stockin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__models_backward_stockin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_stockin_action__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_stockin_store__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utility_rq_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utility_spinner__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store_shift_store__ = __webpack_require__(92);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var CreateBackwardStockIn = function (_React$Component) {
    _inherits(CreateBackwardStockIn, _React$Component);

    function CreateBackwardStockIn() {
        _classCallCheck(this, CreateBackwardStockIn);

        var _this = _possibleConstructorReturn(this, (CreateBackwardStockIn.__proto__ || Object.getPrototypeOf(CreateBackwardStockIn)).call(this));

        _this.state = {
            selectMode: "maanualDip",
            productList: __WEBPACK_IMPORTED_MODULE_4__store_product_store__["a" /* default */].getAll(),
            tankList: __WEBPACK_IMPORTED_MODULE_6__store_tank_store__["a" /* default */].getAll(),
            shiftList: __WEBPACK_IMPORTED_MODULE_13__store_shift_store__["a" /* default */].getAll(),
            propError: {},
            selectedEmployees: [],
            doNotTakeAttendance: true,
            pendingInvoices: [],
            invoice: null,
            showSpinner: false
        };
        _this.handleShiftStoreChange = _this.handleShiftStoreChange.bind(_this);
        _this.onInvoiceSelect = _this.onInvoiceSelect.bind(_this);
        _this.onStockInDateTime = _this.onStockInDateTime.bind(_this);
        _this.askQuestion = _this.askQuestion.bind(_this);
        _this.handleFailed = _this.handleFailed.bind(_this);
        _this.onCreated = _this.onCreated.bind(_this);
        _this.handleProductStoreChange = _this.handleProductStoreChange.bind(_this);
        _this.invoiceMenuReset = false;
        _this.tankMenuReset = false;
        _this.shiftMenuReset = false;
        _this.stockIn = new __WEBPACK_IMPORTED_MODULE_7__models_backward_stockin___default.a({});
        _this.questionBox = null;
        _this.messageBox = null;
        _this.radioChange = _this.radioChange.bind(_this);
        return _this;
    }

    _createClass(CreateBackwardStockIn, [{
        key: "validate",
        value: function validate(propToCheck, model, value) {
            this[model][propToCheck] = value;
            var propError = Object.assign({}, this.state.propError);
            if (this[model].getErrors()[propToCheck]) {
                propError[propToCheck] = true;
            } else {
                delete propError[propToCheck];
            }
            this.setState({ propError: propError });
            //return propError;
        }
    }, {
        key: "onBlur",
        value: function onBlur(propToCheck, model) {
            var propError = Object.assign({}, this.state.propError);
            if (this[model].getErrors()[propToCheck]) {
                propError[propToCheck] = true;
            } else {
                delete propError[propToCheck];
            }
            this.setState({ propError: propError });
        }
    }, {
        key: "onKeyUp",
        value: function onKeyUp(propToCheck, model, e) {
            this.validate(propToCheck, model, e.target.value);
        }
    }, {
        key: "askQuestion",
        value: function askQuestion(msg, yesCallBack, noCallBack) {
            this.questionBox = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__utility_question_box__["a" /* default */], { questionMsg: msg, yesCallBack: yesCallBack, noCallBack: noCallBack });
            this.forceUpdate();
        }
    }, {
        key: "handleCreateStockIn",
        value: function handleCreateStockIn() {
            var _this2 = this;

            this.stockIn.checkAtg(this.stockIn.startDipVolume, this.stockIn.endDipVolume, this.stockIn.isAtg);
            this.stockIn.checkDip(this.stockIn.startDip, this.stockIn.endDip);
            this.stockIn.checkReding(this.stockIn.beforeReading, this.stockIn.afterReading);

            if (!this.stockIn.hasError()) {
                this.askQuestion("Do you watnt to create StockIn ?", function () {
                    _this2.setState({ showSpinner: true });
                    __WEBPACK_IMPORTED_MODULE_8__actions_stockin_action__["b" /* cratedBackWardStockIn */](_this2.stockIn);
                    _this2.questionBox = null;
                    _this2.forceUpdate();
                }, function () {
                    _this2.questionBox = null;
                    _this2.forceUpdate();
                });
            } else {
                var propError = Object.assign({}, this.stockIn.getErrors());
                this.setState({ propError: propError });
            }
        }
    }, {
        key: "onProductSelect",
        value: function onProductSelect(product) {
            var _this3 = this;

            this.setState({ pendingInvoices: [] });
            if (product) {
                this.validate("productId", "stockIn", product.productId);
                var tankList = __WEBPACK_IMPORTED_MODULE_6__store_tank_store__["a" /* default */].getAll().filter(function (tank) {
                    return product.productId === tank.productId;
                });

                // making a rq call on product select to get pending invoices by productid
                __WEBPACK_IMPORTED_MODULE_11__utility_rq_js__["a" /* default */].getJsonData("/api/v1/stockins/pending/" + product.productId).then(function (data) {

                    _this3.setState({ pendingInvoices: data });
                }).catch(function (err) {
                    throw err;
                });
                this.invoiceMenuReset = true;
                this.tankMenuReset = true;
                this.setState({ tankList: tankList, invoice: null });
            }
        }
    }, {
        key: "onTankSelect",
        value: function onTankSelect(tank) {
            this.tankMenuReset = false;
            this.validate("tankId", "stockIn", tank.tankId);
        }
    }, {
        key: "onShiftSelect",
        value: function onShiftSelect(shift) {
            // console.log(shift);
            if (shift) {
                this.selectedShift = shift;
                this.validate("shiftId", "stockIn", shift.shiftId);
                // var propError = Object.assign({}, this.state.propError);
                // propError.selectedShift = false;
                // this.setState({ propError });
            }
        }
    }, {
        key: "onInvoiceSelect",
        value: function onInvoiceSelect(invoice) {
            if (invoice) {
                this.invoiceMenuReset = false;
                this.stockIn.remaining = invoice.avilabel;
                this.stockIn.invoiceDetailId = invoice.invoiceDetailId;
                var propError = Object.assign({}, this.state.propError);
                propError.remaining = false;
                propError.invoiceDetailId = false;
            }
            this.setState({ invoice: invoice, propError: propError });
        }
    }, {
        key: "onStockInDateTime",
        value: function onStockInDateTime(e) {
            if (e) {
                var dateTime = e.target.value.replace("T", " ");
                this.validate("stockInDateTime", "stockIn", dateTime);
            }
        }
    }, {
        key: "handleKeyUp",
        value: function handleKeyUp(propToCheck, model, e) {
            this.validate(propToCheck, model, e.target.value);
        }
    }, {
        key: "handleFailed",
        value: function handleFailed(msg) {
            this.messageBox = __WEBPACK_IMPORTED_MODULE_3__utility_message_box__["a" /* default */].showMessage(msg, false, this);
            this.setState({ showSpinner: false });
        }
    }, {
        key: "onCreated",
        value: function onCreated(msg) {
            this.messageBox = __WEBPACK_IMPORTED_MODULE_3__utility_message_box__["a" /* default */].showMessage(msg, true, this);
            this.refs.stockInDateTime.value = "";
            this.refs.startDip.value = "";
            this.refs.endDip.value = "";

            if (this.refs.startDipVolume) this.refs.startDipVolume.value = "";

            if (this.refs.startDipVolume) this.refs.endDipVolume.value = "";

            this.refs.shiftDate.value = "";
            this.refs.afterReading.value = "";
            this.refs.beforeReading.value = "";
            this.productMenuReset = true;
            this.invoiceMenuReset = true;
            this.shiftMenuReset = true;
            this.tankMenuReset = true;
            this.stockIn = new __WEBPACK_IMPORTED_MODULE_7__models_backward_stockin___default.a({});
            this.setState({ invoice: null, pendingInvoices: [], showSpinner: false });
        }
    }, {
        key: "handleProductStoreChange",
        value: function handleProductStoreChange() {
            this.state.productList = __WEBPACK_IMPORTED_MODULE_4__store_product_store__["a" /* default */].getAll();
            this.setState(this.state);
        }
    }, {
        key: "handleShiftStoreChange",
        value: function handleShiftStoreChange() {
            this.setState({ shiftList: __WEBPACK_IMPORTED_MODULE_13__store_shift_store__["a" /* default */].getAll() });
        }
    }, {
        key: "componentWillMount",
        value: function componentWillMount() {
            __WEBPACK_IMPORTED_MODULE_9__store_stockin_store__["a" /* default */].on(__WEBPACK_IMPORTED_MODULE_10__constants_constants__["j" /* stockInConstant */].STOCKIN_CREATED, this.onCreated);
            __WEBPACK_IMPORTED_MODULE_9__store_stockin_store__["a" /* default */].on(__WEBPACK_IMPORTED_MODULE_10__constants_constants__["j" /* stockInConstant */].STOCKIN_CREATION_FAILED, this.handleFailed);

            __WEBPACK_IMPORTED_MODULE_4__store_product_store__["a" /* default */].on(__WEBPACK_IMPORTED_MODULE_10__constants_constants__["b" /* productConstant */].PRODUCTS_STORE_CHANGE, this.handleProductStoreChange);
            __WEBPACK_IMPORTED_MODULE_13__store_shift_store__["a" /* default */].on(__WEBPACK_IMPORTED_MODULE_10__constants_constants__["c" /* shiftConstant */].SHIFT_STORE_CHANGE, this.handleShiftStoreChange);
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            __WEBPACK_IMPORTED_MODULE_9__store_stockin_store__["a" /* default */].removeListener(__WEBPACK_IMPORTED_MODULE_10__constants_constants__["j" /* stockInConstant */].STOCKIN_CREATED, this.onCreated);
            __WEBPACK_IMPORTED_MODULE_9__store_stockin_store__["a" /* default */].removeListener(__WEBPACK_IMPORTED_MODULE_10__constants_constants__["j" /* stockInConstant */].STOCKIN_CREATION_FAILED, this.handleFailed);

            __WEBPACK_IMPORTED_MODULE_4__store_product_store__["a" /* default */].removeListener(__WEBPACK_IMPORTED_MODULE_10__constants_constants__["b" /* productConstant */].PRODUCTS_STORE_CHANGE, this.handleProductStoreChange);
            __WEBPACK_IMPORTED_MODULE_13__store_shift_store__["a" /* default */].removeListener(__WEBPACK_IMPORTED_MODULE_10__constants_constants__["c" /* shiftConstant */].SHIFT_STORE_CHANGE, this.handleShiftStoreChange);
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
            this.productMenuReset = false;
            this.invoiceMenuReset = false;
            this.tankMenuReset = false;
            this.shiftMenuReset = false;
        }
    }, {
        key: "componentDidMount",
        value: function componentDidMount() {
            this.refs.stockInDateTime.focus();
        }
    }, {
        key: "radioChange",
        value: function radioChange(e) {
            // console.log(e.target.value);
            var isAtg = e.target.value === "atgDip" ? true : false;
            // this.validate("startDipVolume", "stockIn", null);
            // this.validate("endDipVolume", "stockIn", null);
            this.stockIn.startDipVolume = null;
            this.stockIn.endDipVolume = null;
            this.stockIn.isAtg = isAtg;
            this.setState({ selectMode: e.target.value });
        }
    }, {
        key: "render",
        value: function render() {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "midholder" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "p",
                        { className: "formMsg" },
                        "Create Backward StockIn"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { style: { display: "inline-block", margin: "10px 0 0 20px" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "label",
                            { style: { cursor: "pointer" } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { type: "radio", value: "maanualDip", checked: this.state.selectMode === "maanualDip", onChange: this.radioChange }),
                            " Manual Dip"
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "label",
                            { style: { cursor: "pointer" } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { type: "radio", value: "atgDip", checked: this.state.selectMode === "atgDip", onChange: this.radioChange }),
                            " Atg Dip"
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "table",
                        { className: "formTable" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "tbody",
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "tr",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "td",
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__utility_tip__["a" /* default */], {
                                        showOn: this.state.propError.stockInDateTime,
                                        pointerStyle: {},
                                        msg: this.stockIn.getErrors().stockInDateTime
                                    }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "p",
                                        { className: "label" },
                                        "Enter stock in date time"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                                        type: "datetime-local",
                                        className: "formControl inputBox",
                                        ref: "stockInDateTime",
                                        onKeyUp: this.onStockInDateTime,
                                        tabIndex: "1"
                                    })
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "td",
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__utility_tip__["a" /* default */], {
                                        showOn: this.state.propError.productId,
                                        pointerStyle: {},
                                        msg: "Select Product"
                                    }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "p",
                                        { className: "label" },
                                        "Select Product"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_utility_select_menu__["a" /* default */], {
                                        data: this.state.productList,
                                        onSelect: this.onProductSelect.bind(this),
                                        text: "Select a product",
                                        tabIndex: "2",
                                        ky: "productId",
                                        vl: "productName",
                                        reset: this.productMenuReset

                                    })
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "tr",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "td",
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "p",
                                        { className: "label" },
                                        "Select a shift"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__utility_tip__["a" /* default */], {
                                        showOn: this.state.propError.shiftId,
                                        pointerStyle: {},
                                        msg: "Please select a shift"
                                    }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_utility_select_menu__["a" /* default */], {
                                        data: this.state.shiftList,
                                        onSelect: this.onShiftSelect.bind(this),
                                        text: "Select a shift",
                                        tabIndex: "3",
                                        ky: "shiftId",
                                        vl: "shiftName",
                                        reset: this.shiftMenuReset,
                                        rex: function rex(selectMenu) {
                                            _this4.selectMenu = selectMenu;
                                        }
                                    })
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "td",
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "p",
                                        { className: "label" },
                                        "Shift  date "
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__utility_tip__["a" /* default */], {
                                        showOn: this.state.propError.shiftDate,
                                        pointerStyle: {},
                                        msg: "Please enter a valid shift date "
                                    }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                                        tabIndex: "4",
                                        type: "date",
                                        className: "formControl inputBox",
                                        ref: "shiftDate",
                                        onKeyUp: this.handleKeyUp.bind(this, "shiftDate", "stockIn"),
                                        onBlur: this.handleKeyUp.bind(this, "shiftDate", "stockIn")

                                    })
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "tr",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "td",
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__utility_tip__["a" /* default */], {
                                        showOn: this.state.propError.invoiceDetailId,
                                        pointerStyle: {},
                                        msg: "Select Invoice"
                                    }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "p",
                                        { className: "label" },
                                        "Select Invoice"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_utility_select_menu__["a" /* default */], {
                                        data: this.state.pendingInvoices,
                                        onSelect: this.onInvoiceSelect.bind(this),
                                        text: "Select a invoice",
                                        tabIndex: "5",
                                        ky: "invoiceDetailId",
                                        vl: "invoiceNumber",

                                        reset: this.invoiceMenuReset
                                    })
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "td",
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__utility_tip__["a" /* default */], {
                                        showOn: this.state.propError.tankId,
                                        pointerStyle: {},
                                        msg: "Select Tank"
                                    }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "p",
                                        { className: "label" },
                                        "Select Tank"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_utility_select_menu__["a" /* default */], {
                                        data: this.state.tankList,
                                        onSelect: this.onTankSelect.bind(this),
                                        text: "Select a tank",
                                        tabIndex: "6",
                                        ky: "tankId",
                                        vl: "tankName",
                                        reset: this.tankMenuReset
                                    })
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "tr",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "td",
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__utility_tip__["a" /* default */], {
                                        showOn: this.state.propError.startDip,
                                        pointerStyle: {},
                                        msg: this.stockIn.getErrors().startDip
                                    }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "p",
                                        { className: "label" },
                                        "Start Dip"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                                        type: "number",
                                        ref: "startDip",
                                        className: "formControl inputBox",
                                        placeholder: "Start Dip",
                                        tabIndex: "7",
                                        onKeyUp: this.handleKeyUp.bind(this, "startDip", "stockIn"),
                                        onBlur: this.handleKeyUp.bind(this, "startDip", "stockIn")
                                    })
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "td",
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__utility_tip__["a" /* default */], {
                                        showOn: this.state.propError.endDip,
                                        pointerStyle: {},
                                        msg: this.stockIn.getErrors().endDip
                                    }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "p",
                                        { className: "label" },
                                        "End Dip"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                                        type: "number",
                                        ref: "endDip",
                                        placeholder: "End Dip",
                                        tabIndex: "8",
                                        className: "formControl inputBox",
                                        onKeyUp: this.handleKeyUp.bind(this, "endDip", "stockIn"),
                                        onBlur: this.handleKeyUp.bind(this, "endDip", "stockIn")
                                    })
                                )
                            ),
                            this.state.selectMode === "atgDip" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "tr",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "td",
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__utility_tip__["a" /* default */], {
                                        showOn: this.state.propError.startDipVolume,
                                        pointerStyle: {},
                                        msg: this.stockIn.getErrors().startDipVolume
                                    }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "p",
                                        { className: "label" },
                                        "Start Dip Volume"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                                        type: "number",
                                        ref: "startDipVolume",
                                        className: "formControl inputBox",
                                        placeholder: "Start Dip Volume",
                                        tabIndex: "9",
                                        onKeyUp: this.handleKeyUp.bind(this, "startDipVolume", "stockIn"),
                                        onBlur: this.handleKeyUp.bind(this, "startDipVolume", "stockIn")
                                    })
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "td",
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__utility_tip__["a" /* default */], {
                                        showOn: this.state.propError.endDipVolume,
                                        pointerStyle: {},
                                        msg: this.stockIn.getErrors().endDipVolume
                                    }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "p",
                                        { className: "label" },
                                        "End Dip Volume"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                                        type: "number",
                                        ref: "endDipVolume",
                                        placeholder: "End Dip Volume",
                                        tabIndex: "10",
                                        className: "formControl inputBox",
                                        onKeyUp: this.handleKeyUp.bind(this, "endDipVolume", "stockIn"),
                                        onBlur: this.handleKeyUp.bind(this, "endDipVolume", "stockIn")
                                    })
                                )
                            ) : false,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "tr",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "td",
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__utility_tip__["a" /* default */], {
                                        showOn: this.state.propError.beforeReading,
                                        pointerStyle: {},
                                        msg: this.stockIn.getErrors().beforeReading
                                    }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "p",
                                        { className: "label" },
                                        "Enter Before Reading Sum"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                                        type: "number",
                                        ref: "beforeReading",
                                        className: "formControl inputBox",
                                        placeholder: "Enter Before Reading Sum",
                                        tabIndex: "11",
                                        onKeyUp: this.handleKeyUp.bind(this, "beforeReading", "stockIn"),
                                        onBlur: this.handleKeyUp.bind(this, "beforeReading", "stockIn")
                                    })
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "td",
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__utility_tip__["a" /* default */], {
                                        showOn: this.state.propError.afterReading,
                                        pointerStyle: {},
                                        msg: this.stockIn.getErrors().afterReading
                                    }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "p",
                                        { className: "label" },
                                        "Enter after Reading Sum"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                                        type: "number",
                                        ref: "afterReading",
                                        placeholder: "Enter After Reading Sum",
                                        tabIndex: "12",
                                        className: "formControl inputBox",
                                        onKeyUp: this.handleKeyUp.bind(this, "afterReading", "stockIn"),
                                        onBlur: this.handleKeyUp.bind(this, "afterReading", "stockIn")
                                    })
                                )
                            ),
                            this.state.invoice ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "tr",
                                {
                                    style: {
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "start"
                                    }
                                },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "td",
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "p",
                                        { className: "label" },
                                        "Ordered Quantity"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "p",
                                        { className: "val" },
                                        this.state.invoice.orederQuantity / 1000,
                                        " KL"
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "td",
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "p",
                                        { className: "label" },
                                        "Shortage Quantity"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "p",
                                        { className: "val" },
                                        this.state.invoice.shortageQuantity,
                                        " Ltrs"
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "td",
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "p",
                                        { className: "label" },
                                        "Remaining Quantity"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "p",
                                        { className: "val" },
                                        this.state.invoice.avilabel / 1000,
                                        " KL"
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "td",
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "div",
                                        { style: {
                                                position: "absolute",
                                                left: "-7px",
                                                bottom: "-5px",
                                                width: "400px"
                                            } },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__utility_tip__["a" /* default */], {
                                            showOn: this.state.propError.quantity,
                                            pointerStyle: {},
                                            msg: this.stockIn.getErrors().quantity
                                        })
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "p",
                                        { className: "label" },
                                        "Stock in Quantity KL"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { type: "text",
                                        ref: "quantity",
                                        tabIndex: "13",
                                        onKeyUp: this.handleKeyUp.bind(this, "quantity", "stockIn"),
                                        style: { marginTop: "5px", textAlign: "center", width: "90px", padding: "5px", display: "block" }
                                    })
                                )
                            ) : null
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "button",
                        {
                            className: "btn btnOk btnRight",
                            tabIndex: "14",
                            onClick: this.handleCreateStockIn.bind(this),
                            style: { marginRight: "50px", display: "flex", alignSelf: "flex-end" }
                        },
                        "Submit"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "clear" })
                ),
                this.state.showSpinner ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__utility_spinner__["a" /* default */], null) : null,
                this.questionBox,
                this.messageBox
            );
        }
    }]);

    return CreateBackwardStockIn;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["default"] = (CreateBackwardStockIn);

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_user_action__ = __webpack_require__(161);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var ChangePassword = function (_React$Component) {
    _inherits(ChangePassword, _React$Component);

    function ChangePassword() {
        _classCallCheck(this, ChangePassword);

        var _this = _possibleConstructorReturn(this, (ChangePassword.__proto__ || Object.getPrototypeOf(ChangePassword)).call(this));

        _this.state = {
            errMsg: ""
        };
        return _this;
    }

    _createClass(ChangePassword, [{
        key: "handleSubmit",
        value: function handleSubmit() {

            var password1 = this.refs.newPassword1.value;
            var password2 = this.refs.newPassword2.value;
            if (!(password1.length < 5 || password1.length > 16)) {
                if (password1 === password2) {
                    if (this.props.pageProps.location.query.autoGen && this.props.pageProps.location.query.id) {
                        //write down the code here                    
                        __WEBPACK_IMPORTED_MODULE_1__actions_user_action__["b" /* updatePassword */]({ password: password1, userPic: null, userId: this.props.pageProps.location.query.id, autoGen: this.props.pageProps.location.query.autoGen });
                    } else {
                        var errMsg = "missing token and id";
                        this.setState({ errMsg: errMsg });
                    }
                } else {
                    var _errMsg = "passwords don't match";
                    this.setState({ errMsg: _errMsg });
                }
            } else {
                var _errMsg2 = "password must be 5 to 15 characters";
                this.setState({ errMsg: _errMsg2 });
            }
        }
    }, {
        key: "componentDidMount",
        value: function componentDidMount() {
            this.refs.newPassword1.focus();
        }
    }, {
        key: "render",
        value: function render() {
            //window.x = this.props;
            //console.log(this.props);
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "smallholder" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "table",
                    { className: "formTable" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "tbody",
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "tr",
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "td",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                                    type: "password",
                                    className: "formControl inputBox",
                                    placeholder: "New Password",
                                    ref: "newPassword1",
                                    tabIndex: "1"
                                })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "tr",
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "td",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "p",
                                    { id: "tipBox" },
                                    this.state.errMsg
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                                    type: "password",
                                    className: "formControl inputBox",
                                    placeholder: "Re-enter New Password",
                                    ref: "newPassword2",
                                    tabIndex: "2"
                                })
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "button",
                    {
                        tabIndex: "3",
                        className: "btn btnOk btnRight",
                        onClick: this.handleSubmit.bind(this)
                    },
                    "Submit"
                )
            );
        }
    }]);

    return ChangePassword;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (ChangePassword);

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_motion__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_motion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_motion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utility_tip__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_invoice__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_invoice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__models_invoice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utility_select_menu__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_product_store__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_invoice_detail__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_invoice_detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__models_invoice_detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utility_question_box__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_invoice_action__ = __webpack_require__(170);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










//import { invoiceConstant } from "../../constants/constants";


var CreateInvoice = function (_Component) {
    _inherits(CreateInvoice, _Component);

    function CreateInvoice() {
        _classCallCheck(this, CreateInvoice);

        var _this = _possibleConstructorReturn(this, (CreateInvoice.__proto__ || Object.getPrototypeOf(CreateInvoice)).call(this));

        _this.state = {
            greenLeft: 0,
            yellowLeft: 0,
            propError: {},
            productList: __WEBPACK_IMPORTED_MODULE_5__store_product_store__["a" /* default */].getAll(),
            slideInvoice: false

        };

        _this.invoice = new __WEBPACK_IMPORTED_MODULE_3__models_invoice___default.a({});
        _this.invoiceDetail = new __WEBPACK_IMPORTED_MODULE_6__models_invoice_detail___default.a({});

        _this.cancel = _this.cancel.bind(_this);
        _this.onBlur = _this.onBlur.bind(_this);
        _this.onKeyUp = _this.onKeyUp.bind(_this);
        _this.invoiceBox = null;
        _this.invoiceDetailBox = null;
        _this.invoiceDetailList = [];
        _this.questionBox = null;
        _this.productIdMenuReset = false;

        return _this;
    }

    _createClass(CreateInvoice, [{
        key: "cancel",
        value: function cancel() {
            this.props.hide();
        }
    }, {
        key: "validate",
        value: function validate(propToCheck, model, value) {
            this[model][propToCheck] = value;
            var propError = Object.assign({}, this.state.propError);
            if (this[model].getErrors()[propToCheck]) {
                propError[propToCheck] = true;
            } else {
                delete propError[propToCheck];
            }
            this.setState({ propError: propError });
            //return propError;
        }
    }, {
        key: "onBlur",
        value: function onBlur(propToCheck, model) {
            var propError = Object.assign({}, this.state.propError);
            if (this[model].getErrors()[propToCheck]) {
                propError[propToCheck] = true;
            } else {
                delete propError[propToCheck];
            }
            this.setState({ propError: propError });
        }
    }, {
        key: "onKeyUp",
        value: function onKeyUp(propToCheck, model, e) {
            this.validate(propToCheck, model, e.target.value);
        }
    }, {
        key: "onProductSelect",
        value: function onProductSelect(product) {
            this.selectedProduct = product;
            this.invoiceDetail.productName = product.productName;
            this.validate("productId", "invoiceDetail", product.productId);
        }
    }, {
        key: "addProduct",
        value: function addProduct() {
            if (!this.invoiceDetail.hasError()) {
                this.invoiceDetailList.push(this.invoiceDetail);
                this.invoiceDetail = new __WEBPACK_IMPORTED_MODULE_6__models_invoice_detail___default.a({});
                this.resetInvoiceDetail();
                this.productIdMenuReset = true;
                this.forceUpdate();
            } else {
                var propError = Object.assign({}, this.invoiceDetail.getErrors());
                this.setState({ propError: propError });
            }
        }
    }, {
        key: "resetInvoiceDetail",
        value: function resetInvoiceDetail() {

            this.quantity.value = "";
            this.shortageQuantity.value = "";
            this.density.value = "";
            this.selectProduct.focus();
        }
    }, {
        key: "slideInvoice",
        value: function slideInvoice() {
            if (!this.invoice.hasError()) {
                // this.state.slideInvoice = true;
                this.selectProduct.focus();
                this.setState({ slideInvoice: true });
            } else {
                var propError = Object.assign({}, this.invoice.getErrors());
                this.setState({ propError: propError });
            }
        }
    }, {
        key: "showSlider",
        value: function showSlider() {
            if (this.state.slideInvoice) {
                this.setState({ invoiceSmallSlider: true });
            }
        }
    }, {
        key: "invoiceSmallSliderClick",
        value: function invoiceSmallSliderClick() {
            var slideInvoice = !this.state.slideInvoice;
            this.setState({ invoiceSmallSlider: false, slideInvoice: slideInvoice });
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
            this.productIdMenuReset = false;
        }
    }, {
        key: "componentDidMount",
        value: function componentDidMount() {
            this.invoiceNumber.focus();
        }
    }, {
        key: "askQuestion",
        value: function askQuestion(msg, yesCallBack, noCallBack) {
            this.questionBox = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__utility_question_box__["a" /* default */], { questionMsg: msg, yesCallBack: yesCallBack, noCallBack: noCallBack });
            this.setState(this.state);
        }
    }, {
        key: "handleSubmit",
        value: function handleSubmit() {
            var _this2 = this;

            var propError = {};
            this.askQuestion("Do you want to create invoice " + this.invoice.invoiceNumber + " ?", function () {
                _this2.props.showSpinner();
                __WEBPACK_IMPORTED_MODULE_8__actions_invoice_action__["a" /* createInvoice */]({ invoice: _this2.invoice, invoiceDetails: _this2.invoiceDetailList });
                _this2.questionBox = null;

                _this2.setState({ propError: propError });
            }, function () {
                _this2.questionBox = null;
                _this2.setState({ propError: propError });
            });
        }
    }, {
        key: "render",
        value: function render() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                null,
                this.questionBox,
                this.messageBox,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_motion__["Motion"],
                    { defaultStyle: { a: 0 }, style: { a: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_motion__["spring"])(1, __WEBPACK_IMPORTED_MODULE_1_react_motion__["presets"].stiff) } },
                    function (_ref) {
                        var a = _ref.a;

                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "div",
                            { className: "flyHolder boxShadow", style: { transform: "scale(" + a + ")" } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_react_motion__["Motion"],
                                { defaultStyle: { x: 0 }, style: { x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_motion__["spring"])(_this3.state.slideInvoice ? -100 : 0) }, onRest: _this3.showSlider.bind(_this3) },
                                function (_ref2) {
                                    var x = _ref2.x;


                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "div",
                                        { className: "flatBox", style: { backgroundColor: "white", zIndex: 1003, left: x + "%" }, ref: function ref(x) {
                                                _this3.invoiceBox = x;
                                            } },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { height: "50px", background: "#23b9fd", width: "100%" } }),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "div",
                                            { style: { position: "absolute", top: "80px", marginRight: "auto", marginLeft: "auto" } },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                "div",
                                                { style: { display: "flex", justifyContent: "center" } },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    "div",
                                                    { style: { paddingRight: "10px" } },
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "table",
                                                        { className: "formTable" },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            "tbody",
                                                            null,
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                                "tr",
                                                                null,
                                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                                    "td",
                                                                    null,
                                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                                        "p",
                                                                        { className: "whitePara" },
                                                                        "Invoce Number"
                                                                    ),
                                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__utility_tip__["a" /* default */], {
                                                                        showOn: _this3.state.propError.invoiceNumber,
                                                                        pointerStyle: {},
                                                                        msg: _this3.invoice.getErrors().invoiceNumber
                                                                    }),
                                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                                                                        type: "text",
                                                                        className: "formControl inputBox",
                                                                        onBlur: _this3.onKeyUp.bind(_this3, "invoiceNumber", "invoice"),
                                                                        onKeyUp: _this3.onKeyUp.bind(_this3, "invoiceNumber", "invoice"),
                                                                        tabIndex: "101",
                                                                        ref: function ref(x) {
                                                                            _this3.invoiceNumber = x;
                                                                        }
                                                                    })
                                                                )
                                                            ),
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                                "tr",
                                                                null,
                                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                                    "td",
                                                                    null,
                                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                                        "p",
                                                                        { className: "whitePara" },
                                                                        "Invoce Date"
                                                                    ),
                                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__utility_tip__["a" /* default */], {
                                                                        showOn: _this3.state.propError.invoiceDateTime,
                                                                        pointerStyle: {},
                                                                        msg: _this3.invoice.getErrors().invoiceDateTime
                                                                    }),
                                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                                                                        type: "datetime-local",
                                                                        className: "formControl inputBox",
                                                                        ref: "invoiceDateTime",
                                                                        onBlur: _this3.onBlur.bind(_this3, "invoiceDateTime", "invoice"),
                                                                        onKeyUp: _this3.onKeyUp.bind(_this3, "invoiceDateTime", "invoice"),
                                                                        onClick: _this3.onKeyUp.bind(_this3, "invoiceDateTime", "invoice"),
                                                                        tabIndex: "102"

                                                                    })
                                                                )
                                                            ),
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                                "tr",
                                                                null,
                                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                                    "td",
                                                                    null,
                                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                                        "p",
                                                                        { className: "whitePara" },
                                                                        "Receive Date"
                                                                    ),
                                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__utility_tip__["a" /* default */], {
                                                                        showOn: _this3.state.propError.receiveDateTime,
                                                                        pointerStyle: {},
                                                                        msg: _this3.invoice.getErrors().receiveDateTime

                                                                    }),
                                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                                                                        type: "datetime-local",
                                                                        className: "formControl inputBox",
                                                                        ref: "receiveDateTime",
                                                                        onBlur: _this3.onBlur.bind(_this3, "receiveDateTime", "invoice"),
                                                                        onKeyUp: _this3.onKeyUp.bind(_this3, "receiveDateTime", "invoice"),
                                                                        onClick: _this3.onKeyUp.bind(_this3, "receiveDateTime", "invoice"),
                                                                        tabIndex: "103"
                                                                    })
                                                                )
                                                            ),
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                                "tr",
                                                                null,
                                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                                    "td",
                                                                    null,
                                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                                        "p",
                                                                        { className: "whitePara" },
                                                                        "Invoice Amount"
                                                                    ),
                                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__utility_tip__["a" /* default */], {
                                                                        showOn: _this3.state.propError.invoiceAmount,
                                                                        pointerStyle: {},
                                                                        msg: _this3.invoice.getErrors().invoiceAmount
                                                                    }),
                                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                                                                        type: "number",
                                                                        className: "formControl inputBox",
                                                                        ref: "invoiceAmount",
                                                                        onBlur: _this3.onBlur.bind(_this3, "invoiceAmount", "invoice"),
                                                                        onKeyUp: _this3.onKeyUp.bind(_this3, "invoiceAmount", "invoice"),
                                                                        tabIndex: "104"
                                                                    })
                                                                )
                                                            )
                                                        )
                                                    )
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    "div",
                                                    null,
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "table",
                                                        { className: "formTable" },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            "tbody",
                                                            null,
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                                "tr",
                                                                null,
                                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                                    "td",
                                                                    null,
                                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                                        "p",
                                                                        { className: "whitePara" },
                                                                        "Transport Name"
                                                                    ),
                                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                                                                        type: "text", className: "formControl inputBox",
                                                                        ref: "transportName",
                                                                        onKeyUp: _this3.onKeyUp.bind(_this3, "transportName", "invoice"),
                                                                        onBlur: _this3.onBlur.bind(_this3, "transportName", "invoice"),
                                                                        tabIndex: "105"
                                                                    })
                                                                )
                                                            ),
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                                "tr",
                                                                null,
                                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                                    "td",
                                                                    null,
                                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                                        "p",
                                                                        { className: "whitePara" },
                                                                        "Lorry Number"
                                                                    ),
                                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__utility_tip__["a" /* default */], {
                                                                        showOn: _this3.state.propError.truckNumber,
                                                                        pointerStyle: {},
                                                                        msg: _this3.invoice.getErrors().truckNumber
                                                                    }),
                                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { type: "text", className: "formControl inputBox", ref: "lorryNumber",
                                                                        onBlur: _this3.onBlur.bind(_this3, "truckNumber", "invoice"),
                                                                        onKeyUp: _this3.onKeyUp.bind(_this3, "truckNumber", "invoice"),
                                                                        tabIndex: "106"
                                                                    })
                                                                )
                                                            ),
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                                "tr",
                                                                null,
                                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                                    "td",
                                                                    null,
                                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                                        "p",
                                                                        { className: "whitePara" },
                                                                        "Driver Contact No"
                                                                    ),
                                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                                                                        type: "text",
                                                                        className: "formControl inputBox",
                                                                        ref: "truckDriverPhone",
                                                                        onKeyUp: _this3.onKeyUp.bind(_this3, "truckDriverPhone", "invoice"),
                                                                        onBlur: _this3.onBlur.bind(_this3, "truckDriverPhone", "invoice"),
                                                                        tabIndex: "107"
                                                                    })
                                                                )
                                                            ),
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                                "tr",
                                                                null,
                                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                                    "td",
                                                                    null,
                                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                                        "p",
                                                                        { className: "whitePara" },
                                                                        "Comment"
                                                                    ),
                                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { type: "text", className: "formControl inputBox", ref: "comment", onKeyUp: _this3.onKeyUp.bind(_this3, "comment", "invoice"),
                                                                        onBlur: _this3.onBlur.bind(_this3, "comment", "invoice"),
                                                                        tabIndex: "108"
                                                                    })
                                                                )
                                                            )
                                                        )
                                                    )
                                                )
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { tabIndex: "109", className: "fa fa-chevron-circle-left", "aria-hidden": "true", onKeyDown: function onKeyDown(e) {
                                                if (e.keyCode === 13) _this3.slideInvoice();
                                            }, onClick: _this3.slideInvoice.bind(_this3), style: { position: "absolute", color: "#23b9fd", right: "90px", bottom: "10px", fontSize: "4em", cursor: "pointer" } })
                                    );
                                }
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "div",
                                { className: "flatBox", style: { background: "white", zIndex: 1002, left: 0 }, ref: function ref(x) {
                                        _this3.invoiceDetailBox = x;
                                    } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { height: "50px", background: "#23b9fd", width: "100%" } }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "div",
                                    { style: { position: "absolute", top: "45%", left: "50%", transform: "translate(-50%,-70%)" } },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "div",
                                        { style: { display: "flex", justifyContent: "center", marginTop: "20px" } },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "div",
                                            { style: { paddingRight: "10px" } },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                "table",
                                                { className: "formTable" },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    "tbody",
                                                    null,
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "tr",
                                                        null,
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            "td",
                                                            null,
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                                "p",
                                                                { className: "whitePara" },
                                                                "Select a product"
                                                            ),
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__utility_tip__["a" /* default */], {
                                                                showOn: _this3.state.propError.productId,
                                                                pointerStyle: {},
                                                                msg: "Please select a product"
                                                            }),
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__utility_select_menu__["a" /* default */], {
                                                                data: _this3.state.productList,
                                                                onSelect: _this3.onProductSelect.bind(_this3),
                                                                tabIndex: "110",
                                                                text: "Select a product",
                                                                onBlur: _this3.validate.bind(_this3, "productId", "invoiceDetail"),
                                                                ky: "productId",
                                                                vl: "productName",
                                                                reset: _this3.productIdMenuReset,
                                                                rex: function rex(x) {
                                                                    _this3.selectProduct = x;
                                                                }
                                                            })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "tr",
                                                        null,
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            "td",
                                                            null,
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                                "p",
                                                                { className: "whitePara" },
                                                                "Quantity in KL"
                                                            ),
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__utility_tip__["a" /* default */], {
                                                                showOn: _this3.state.propError.quantity,
                                                                pointerStyle: {},
                                                                msg: "Please enter quantity in K.L"
                                                            }),
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                                                                type: "number",
                                                                className: "formControl inputBox",
                                                                onBlur: _this3.onBlur.bind(_this3, "quantity", "invoiceDetail"),
                                                                onKeyUp: _this3.onKeyUp.bind(_this3, "quantity", "invoiceDetail"),
                                                                ref: function ref(x) {
                                                                    _this3.quantity = x;
                                                                },
                                                                tabIndex: "111"
                                                            })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "tr",
                                                        null,
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            "td",
                                                            null,
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                                "p",
                                                                { className: "whitePara" },
                                                                "Shortage Quantity in Ltrs."
                                                            ),
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__utility_tip__["a" /* default */], {
                                                                showOn: _this3.state.propError.shortageQuantity,
                                                                pointerStyle: {},
                                                                msg: "Please enter shortage quantity in Ltrs."
                                                            }),
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                                                                type: "number",
                                                                className: "formControl inputBox",
                                                                onBlur: _this3.onBlur.bind(_this3, "shortageQuantity", "invoiceDetail"),
                                                                onKeyUp: _this3.onKeyUp.bind(_this3, "shortageQuantity", "invoiceDetail"),
                                                                ref: function ref(x) {
                                                                    _this3.shortageQuantity = x;
                                                                },
                                                                tabIndex: "112"
                                                            })
                                                        )
                                                    )
                                                )
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "div",
                                            null,
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                "table",
                                                { className: "formTable" },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    "tbody",
                                                    null,
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "tr",
                                                        null,
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            "td",
                                                            null,
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                                "p",
                                                                { className: "whitePara" },
                                                                "Density"
                                                            ),
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__utility_tip__["a" /* default */], {
                                                                showOn: _this3.state.propError.density,
                                                                pointerStyle: {},
                                                                msg: "Please enter base density"
                                                            }),
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                                                                type: "text",
                                                                className: "formControl inputBox",
                                                                onBlur: _this3.onBlur.bind(_this3, "density", "invoiceDetail"),
                                                                onChange: _this3.onKeyUp.bind(_this3, "density", "invoiceDetail"),
                                                                ref: function ref(x) {
                                                                    _this3.density = x;
                                                                },
                                                                tabIndex: "115"
                                                            })
                                                        )
                                                    )
                                                )
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                "button",
                                                { tabIndex: "117", style: { margin: "5px 0 12px 0", display: _this3.invoiceDetailList.length >= 1 ? "block" : "none" }, onClick: _this3.handleSubmit.bind(_this3), className: "circleBtn btnRight" },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-check", "aria-hidden": "true" })
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                "button",
                                                { tabIndex: "116", style: { margin: "5px 10px 12px 0" }, onClick: _this3.addProduct.bind(_this3), className: "circleBtn btnRight" },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-plus", "aria-hidden": "true" })
                                            )
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "div",
                                    { style: { maxHeight: "150px", minHeight: "150px", overflowY: "scroll", position: "absolute", bottom: "10px", left: "5%", width: "90%" } },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "table",
                                        { width: "100%", className: "flatTable" },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "thead",
                                            null,
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                "tr",
                                                null,
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    "th",
                                                    null,
                                                    "Product"
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    "th",
                                                    null,
                                                    "Quantity K.L"
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    "th",
                                                    null,
                                                    "Shortage Quantity Ltrs."
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    "th",
                                                    null,
                                                    "Density"
                                                )
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "tbody",
                                            null,
                                            _this3.invoiceDetailList.map(function (e, i) {
                                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    "tr",
                                                    { key: i },
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "td",
                                                        null,
                                                        e.productName
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "td",
                                                        null,
                                                        e.quantity
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "td",
                                                        null,
                                                        e.shortageQuantity
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "td",
                                                        null,
                                                        e.density
                                                    )
                                                );
                                            })
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-arrow-circle-o-right",
                                    onClick: _this3.invoiceSmallSliderClick.bind(_this3),
                                    style: { position: "absolute", color: "#ffffff", top: "12px", left: "15px", fontSize: "2em", cursor: "pointer" } })
                            )
                        );
                    }
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "overlay", onClick: this.cancel }),
                this.spinner
            );
        }
    }]);

    return CreateInvoice;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (CreateInvoice);

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utility_auto_complete__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_utility_message_box__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutability_helper__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutability_helper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutability_helper__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var EmployeeShortage = function (_React$Component) {
    _inherits(EmployeeShortage, _React$Component);

    function EmployeeShortage() {
        _classCallCheck(this, EmployeeShortage);

        var _this = _possibleConstructorReturn(this, (EmployeeShortage.__proto__ || Object.getPrototypeOf(EmployeeShortage)).call(this));

        _this.state = {
            onSelectEmployeeList: [],
            totalShortage: 0
        };
        _this.messageBox = null;
        return _this;
    }

    _createClass(EmployeeShortage, [{
        key: "onEmployeeSelect",
        value: function onEmployeeSelect(emp) {
            var _this2 = this;

            if (emp) {
                emp.amount = 0;
                var exist;
                this.state.onSelectEmployeeList.forEach(function (employee) {
                    if (employee.employeeId === emp.employeeId) {
                        exist = true;
                        _this2.searchBox.value = "";
                    }
                });
                if (!exist) {
                    this.state.onSelectEmployeeList.push(emp);
                    this.searchBox.value = "";
                    this.setState(this.state);
                }
            }
        }
    }, {
        key: "getTotal",
        value: function getTotal() {
            var totalAmount = 0;
            this.state.onSelectEmployeeList.forEach(function (employee) {
                totalAmount += employee.amount;
            });
            this.state.totalShortage = totalAmount;
            return totalAmount;
        }
    }, {
        key: "updateShortage",
        value: function updateShortage(i, e) {
            // this.state.onSelectEmployeeList[i].amount 
            var amount = parseFloat(e.target.value) ? parseFloat(e.target.value) : 0;
            // console.log("--", this.state.onSelectEmployeeList);
            var onSelectEmployeeList = __WEBPACK_IMPORTED_MODULE_3_immutability_helper___default()(this.state.onSelectEmployeeList, _defineProperty({}, i, { amount: { $set: amount } }));
            //  this.state.totalShortage = this.getTotal();
            this.setState({ onSelectEmployeeList: onSelectEmployeeList });
            // this.setState({ onSelectEmployeeList });
            //console.log(e.target.value);
            //console.log(onSelectEmployeeList);
        }
    }, {
        key: "DeleteMe",
        value: function DeleteMe(i) {
            // console.log(this.state.onSelectEmployeeList.length);
            this.state.onSelectEmployeeList.splice(i, 1);
            //this.state.totalShortage = this.getTotal();
            this.setState({});
            // console.log(this.state.onSelectEmployeeList);
        }
    }, {
        key: "onCancle",
        value: function onCancle() {
            this.props.onCancle();
            this.setState(this.state);
        }
    }, {
        key: "onSave",
        value: function onSave() {
            //console.log("______");
            if (this.props.shortageAmount !== undefined) {
                if (this.state.totalShortage === this.props.shortageAmount) {
                    this.props.onSave(this.state.onSelectEmployeeList);
                } else {
                    this.messageBox = __WEBPACK_IMPORTED_MODULE_2__components_utility_message_box__["a" /* default */].showMessage("Total shortage amount must be " + this.props.shortageAmount, false, this);
                }
            } else {
                this.messageBox = __WEBPACK_IMPORTED_MODULE_2__components_utility_message_box__["a" /* default */].showMessage("please enter last collection amount first", false, this);
            }
            this.setState(this.state);
        }
    }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            //console.log("component will receive props fired", this.props, nextProps);
            // console.log("willreceive prop fired", nextProps);
            if (nextProps.reset) {
                this.state = {
                    onSelectEmployeeList: [],
                    totalShortage: 0
                };
            }
        }
    }, {
        key: "componentDidMount",
        value: function componentDidMount() {
            this.searchBox.focus();
        }
    }, {
        key: "render",
        value: function render() {
            var _this3 = this;

            //console.log("rend", this.state.onSelectEmployeeList);
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { style: { display: this.props.display ? "block" : "none" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "overlay", onClick: this.onCancle.bind(this) }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { id: "employeeShortage" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "h2",
                        { style: { textAlign: "center", color: "gray", marginTop: "20px" } },
                        " Total Shortage Amount ",
                        this.props.shortageAmount
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "p",
                        { className: "formMsg" },
                        "Employee Shortage"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { style: { marginLeft: "40px" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "p",
                            { className: "label" },
                            "Select a Employee"
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__utility_auto_complete__["a" /* default */], {
                            placeholder: "select an employee",
                            dataSrc: "api/v1/employee/auto",
                            dataTobind: "employeeName",
                            keyToBind: "employeeId",
                            tabIndex: "1",
                            onSelect: this.onEmployeeSelect.bind(this),
                            clearStyle: { right: "90px" },
                            rex: function rex(searchBox) {
                                _this3.searchBox = searchBox;
                                //this.searchBox.onfocus = this.onSelectEmployeeFocus.bind(this);
                            }
                        }),
                        this.state.onSelectEmployeeList.length >= 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "table",
                            { className: "clear borderless", style: { minWidth: "340px" } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "thead",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "tr",
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "th",
                                        null,
                                        "Name"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "th",
                                        null,
                                        "Amount"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null)
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "tbody",
                                null,
                                this.state.onSelectEmployeeList.map(function (e, i) {
                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "tr",
                                        { key: e.employeeId, style: { textAlign: "center" } },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "td",
                                            null,
                                            e.employeeName
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "td",
                                            null,
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                                                type: "text",
                                                onChange: _this3.updateShortage.bind(_this3, i),
                                                style: { color: "gray", textAlign: "center", outline: "none", border: "none", borderBottom: "1px solid lightgray" } })
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "td",
                                            { onClick: _this3.DeleteMe.bind(_this3, i) },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { style: { color: "gray", fontSize: "16px", cursor: "pointer" }, className: "fa fa-trash", "aria-hidden": "true" })
                                        )
                                    );
                                }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "tr",
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "td",
                                        { style: { color: "#bf1f1f" } },
                                        "Total"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "td",
                                        { className: "center", style: { color: "#bf1f1f" } },
                                        this.getTotal()
                                    )
                                )
                            )
                        ) : null
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "button",
                            { className: "btn btnOk btnRight", style: { marginRight: "20px" }, onClick: this.onSave.bind(this) },
                            "Save"
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "button",
                            { className: "btn btnOk btnRight", style: { marginRight: "10px" }, onClick: this.onCancle.bind(this) },
                            "Cancle"
                        )
                    ),
                    this.messageBox
                )
            );
        }
    }]);

    return EmployeeShortage;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (EmployeeShortage);

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utility_select_menu__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utility_spinner__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_sign_7_png__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_sign_7_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_sign_7_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utility_util_methods__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utility_xrand__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utility_xrand___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__utility_xrand__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utility_rq_js__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// import "../../../style/cash-memo.css";






var InstantCashMemo = function (_React$Component) {
    _inherits(InstantCashMemo, _React$Component);

    function InstantCashMemo(props) {
        _classCallCheck(this, InstantCashMemo);

        var _this = _possibleConstructorReturn(this, (InstantCashMemo.__proto__ || Object.getPrototypeOf(InstantCashMemo)).call(this, props));

        _this.state = {
            productList: [],
            selectedProduct: null,
            selectedDate: null,
            selectedProductSellingPrice: 0,
            showSpinner: false,
            includeCreditVehicles: false,
            finalQuantityToGenerateSlip: 0,
            additionalQuantity: "",
            finalDataToGenerate: []
        };
        //  console.log(this.state);
        _this.creditVehicleData = [];
        _this.totalCreditQuantity = 0;
        _this.handleDateSelect = _this.handleDateSelect.bind(_this);
        _this.onProductSelect = _this.onProductSelect.bind(_this);
        _this.onPriceChange = _this.onPriceChange.bind(_this);
        _this.handleCheckboxChange = _this.handleCheckboxChange.bind(_this);
        _this.handleQuantityChange = _this.handleQuantityChange.bind(_this);
        _this.q = 0;
        return _this;
    }

    _createClass(InstantCashMemo, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_6__utility_rq_js__["a" /* default */].getJsonData("/api/v1/products").then(function (data) {
                _this2.setState({ productList: data });
            }).catch(function () {
                alert("failed to get products");
            });
        }
    }, {
        key: "resetData",
        value: function resetData() {
            this.totalCreditQuantity = 0;
            this.creditVehicleData = [];
            this.setState({ additionalQuantity: "", includeCreditVehicles: false, finalDataToGenerate: [] });
        }
    }, {
        key: "handleDateSelect",
        value: function handleDateSelect(e) {
            var _this3 = this;

            if (this.state.selectedProduct === null) {
                alert("Please select product first");
                e.target.value = "";
            } else {
                var dt = e.target.value;
                this.resetData();
                __WEBPACK_IMPORTED_MODULE_6__utility_rq_js__["a" /* default */].getJsonData("/api/v1/products-rate-by-shiftDate/" + e.target.value).then(function (data) {
                    //  const selectedProduct = { ...this.state.selectedProduct };

                    data.forEach(function (product) {

                        if (_this3.state.selectedProduct.productId === product.productId) {

                            _this3.setState({ selectedProductSellingPrice: product.sellingPrice, selectedDate: dt });
                        }
                    });
                }).catch(function (err) {
                    console.log("got error in prodduct price");
                });
            }
        }
    }, {
        key: "onProductSelect",
        value: function onProductSelect(product) {
            var _this4 = this;

            if (product) {
                this.setState({ selectedProduct: product }, function () {
                    if (_this4.state.selectedDate) {
                        _this4.handleDateSelect({ target: { value: _this4.state.selectedDate } });
                    }
                });
            }
        }
    }, {
        key: "onPriceChange",
        value: function onPriceChange(e) {
            this.setState({ selectedProductSellingPrice: e.target.value });
        }
    }, {
        key: "handleCheckboxChange",
        value: function handleCheckboxChange() {
            var _this5 = this;

            this.resetData();
            if (this.state.includeCreditVehicles === false) {
                this.setState({ showSpinner: true, includeCreditVehicles: true, finalDataToGenerate: [] });

                __WEBPACK_IMPORTED_MODULE_6__utility_rq_js__["a" /* default */].getJsonData("/api/v1/credit-report-between-dates?from=" + this.state.selectedDate + "&to=" + this.state.selectedDate + "&id=false").then(function (creditVehicleData) {

                    // need this map because the api provides all prodcut data including ms and hs
                    for (var i = 0; i < creditVehicleData.length; i++) {
                        var data = creditVehicleData[i];
                        if (data.productName === _this5.state.selectedProduct.productName) {
                            _this5.totalCreditQuantity += data.quantity;
                            _this5.creditVehicleData.push({
                                customerName: data.firmName,
                                date: data.shiftDate,
                                slNo: i,
                                price: _this5.state.selectedProductSellingPrice,
                                productName: _this5.state.selectedProduct.productName,
                                vehicleNumber: data.vehicle,
                                quantity: data.quantity,
                                amount: data.amount
                            });
                        }
                    }

                    _this5.totalCreditQuantity = parseFloat(_this5.totalCreditQuantity.toFixed(2));

                    _this5.setState({ showSpinner: false, finalQuantityToGenerateSlip: _this5.totalCreditQuantity, additionalQuantity: "" });

                    console.log(_this5.creditVehicleData);
                }).catch(function (err) {
                    console.log(err);
                    alert("erro occured in fetching credit vehicle data");
                    _this5.setState({ showSpinner: false });
                });
            } else {
                this.totalCreditQuantity = 0;
                this.setState({ includeCreditVehicles: false, finalDataToGenerate: [] });
            }
        }
    }, {
        key: "handleQuantityChange",
        value: function handleQuantityChange(e) {
            var value = e.target.value;
            if (value) {

                //  console.log(parseFloat(value));
                //    console.log(this.creditVehicleData);
                this.setState({ additionalQuantity: value, finalQuantityToGenerateSlip: parseFloat(this.totalCreditQuantity) + parseFloat(value) });
            } else {
                this.setState({ additionalQuantity: "", finalQuantityToGenerateSlip: parseFloat(this.totalCreditQuantity) + 0 });
            }
        }
    }, {
        key: "generateRandomDataForHS",
        value: function generateRandomDataForHS(toAmount) {

            var randomData = [];
            var incrementingAmount = 0;
            var xrand = new __WEBPACK_IMPORTED_MODULE_5__utility_xrand___default.a(0, 193);
            var xrand2 = new __WEBPACK_IMPORTED_MODULE_5__utility_xrand___default.a(0, 193);
            var qt = 0;
            while (incrementingAmount < toAmount) {

                var x = this.getRandomInt(200, 20000);
                console.log(x, toAmount, incrementingAmount, toAmount - incrementingAmount);
                if (x > toAmount - incrementingAmount) {

                    x = toAmount - incrementingAmount;
                    console.log("inside if x ", x);
                    incrementingAmount += x;
                    console.log("incrementAmount ", incrementingAmount);
                } else {
                    console.log("inside else x", x);
                    incrementingAmount += x;
                    console.log("incrementAmount ", incrementingAmount);
                }

                var index = xrand.generate() || xrand2.generate();

                var obj = Object.assign({}, fakeDataHS[index]);
                var qnt = x / this.state.selectedProductSellingPrice;

                console.log(x, qnt);
                qt += qnt;
                obj.date = this.state.selectedDate;
                obj.price = this.state.selectedProductSellingPrice;
                obj.quantity = qnt;
                obj.amount = x;

                // obj = Object.assign(
                //     obj, {
                //     date: this.state.selectedDate,
                //     price: this.state.selectedProductSellingPrice,
                //     quantity: (x / this.state.selectedProductSellingPrice),
                //     amount: x
                // });
                randomData.push(obj);
            }

            var totalQt = 0;
            var totalAmount = 0;

            for (var i = 0; i < randomData.length; i++) {
                totalQt += randomData[i].quantity;
                totalAmount += randomData[i].amount;
            }
            console.log("Total Quantity", totalQt, qt, totalAmount, randomData.length);

            return randomData;
        }
    }, {
        key: "getRandomInt",
        value: function getRandomInt(min, max) {
            min = Math.ceil(min);
            max = Math.floor(max);
            return Math.floor(Math.random() * (max - min) + min); // The maximum is exclusive and the minimum is inclusive
        }
    }, {
        key: "generateCashMemo",
        value: function generateCashMemo() {
            if (this.state.additionalQuantity > 0) {
                // if there is additional quantity nedd to insert some fake data


                if (this.state.selectedProduct.productName === "HS") {
                    var quantiy = parseFloat(this.state.additionalQuantity);

                    var randomData = this.generateRandomDataForHS(quantiy * this.state.selectedProductSellingPrice);

                    var finalData = [].concat(_toConsumableArray(this.creditVehicleData), _toConsumableArray(randomData));

                    this.setState({ finalDataToGenerate: finalData });
                }
            } else {
                this.setState({ finalDataToGenerate: this.creditVehicleData });
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _this6 = this;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { id: "formHolder" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "h2",
                        null,
                        "Instant Cash Memo Generation"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "table",
                        { className: "formTable" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "tbody",
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "tr",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "td",
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "p",
                                        { className: "label" },
                                        "Select Product"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__utility_select_menu__["a" /* default */], {
                                        data: this.state.productList,
                                        onSelect: this.onProductSelect,
                                        tabIndex: "2",
                                        text: "Select a product"
                                        // onBlur={this.validate.bind(this, "productId", "creditDetail")}
                                        , ky: "productId",
                                        vl: "productName",
                                        reset: this.producdMenuReset,
                                        rex: function rex(element) {
                                            _this6.procductSelect = element;
                                        }
                                    })
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "td",
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "p",
                                        { className: "label" },
                                        "Select Date"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                                        tabIndex: "3",
                                        type: "date",
                                        className: "formControl inputBox",
                                        onChange: this.handleDateSelect,
                                        ref: "slipDate"

                                    })
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "td",
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "p",
                                        { className: "label" },
                                        "Product Price"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                                        tabIndex: "6",
                                        type: "text",
                                        className: "formControl inputBox",
                                        placeholder: "Enter Price"
                                        // onKeyUp={this.handleQuantity.bind(this)}
                                        , value: this.state.selectedProductSellingPrice,
                                        ref: "quantity",
                                        style: { width: "320px" },
                                        onChange: this.onPriceChange
                                    })
                                ),
                                this.state.selectedProduct && this.state.selectedDate && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "td",
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "p",
                                        { className: "label" },
                                        "Include Credit Vehicles"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                                        type: "checkbox",
                                        checked: this.state.includeCreditVehicles,
                                        onChange: this.handleCheckboxChange
                                    })
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "tr",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "td",
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "p",
                                        { className: "label", style: { color: this.totalCreditQuantity > 0 ? "red" : "none" } },
                                        this.creditVehicleData.length > 0 ? "Found " + this.totalCreditQuantity.toFixed(2) + " liters " + this.state.selectedProduct.productName + " in credit, Enter  Additional Quantity " : "Found 0 credit data Enter total quantity"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                                        tabIndex: "6",
                                        type: "text",
                                        className: "formControl inputBox",
                                        placeholder: "Enter Qunatiy Max 6000 liters"
                                        // onKeyUp={this.handleQuantity.bind(this)}
                                        , value: this.state.additionalQuantity,
                                        onChange: this.handleQuantityChange,
                                        ref: "quantity",
                                        style: { width: "320px" }
                                    })
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "td",
                                    { style: { display: "flex", flexDirection: "column" } },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "button",
                                        {
                                            tabIndex: "11",
                                            className: "btn btnOk btnRight",
                                            onClick: function onClick() {
                                                return _this6.generateCashMemo();
                                            },
                                            ref: "save",
                                            style: { textTransform: "uppercase" }
                                        },
                                        "Click to generate ",
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "span",
                                            { style: { color: "red", fontWeight: "bold" } },
                                            ((parseFloat(this.state.additionalQuantity) || 0) + (parseFloat(this.totalCreditQuantity) || 0)).toFixed(2)
                                        ),
                                        " ltrs of ",
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "span",
                                            { style: { color: "red", fontWeight: "bold" } },
                                            this.state.selectedProduct ? this.state.selectedProduct.productName : ""
                                        ),
                                        " Cash Memo"
                                    )
                                )
                            )
                        )
                    ),
                    this.state.showSpinner ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__utility_spinner__["a" /* default */], null) : null
                ),
                this.state.finalDataToGenerate.length > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "h2",
                    { className: "total" },
                    "Total Quantity ",
                    ((parseFloat(this.state.additionalQuantity) || 0) + (parseFloat(this.totalCreditQuantity) || 0)).toFixed(2),
                    " liters of ",
                    this.state.selectedProduct.productName
                ) : null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "cashMemocontainer" },
                    this.state.finalDataToGenerate.map(function (data, index) {
                        _this6.q += data.quantity;
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "div",
                            { className: "memo", key: index },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "div",
                                { className: "header" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "h2",
                                    { className: "title" },
                                    "Tunga Filling Station"
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "p",
                                    { className: "address" },
                                    "Bankadhara Chhak, Talcher"
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "p",
                                    { className: "dealer" },
                                    "Dealer: BPCL"
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "p",
                                    { className: "tin" },
                                    "TIN: 21083505292"
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "div",
                                { className: "date" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "p",
                                    null,
                                    "Date:",
                                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utility_util_methods__["a" /* DD_MM_YY */])(data.date)
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "p",
                                    null,
                                    "SL No: ",
                                    index + 1
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "div",
                                { className: "info" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "p",
                                    null,
                                    "Customer Name:"
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "p",
                                    { className: "cName" },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "span",
                                        { className: "bold", style: { fontSize: data.customerName.length > 15 ? "10pt" : "12pt" } },
                                        data.customerName.length > 20 ? data.customerName.substring(0, 20) + "..." : data.customerName
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "p",
                                    null,
                                    "Vechile No:",
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "span",
                                        { className: "bold" },
                                        data.vehicleNumber
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "p",
                                    null,
                                    "Product: ",
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "span",
                                        { className: "bold" },
                                        data.productName
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "p",
                                    null,
                                    "Price/Liter: ",
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "span",
                                        { className: "bold" },
                                        "Rs. ",
                                        data.price
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "p",
                                    null,
                                    "Quantity: ",
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "span",
                                        { className: "bold" },
                                        data.quantity.toFixed(2),
                                        " liter"
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "p",
                                    null,
                                    "Amount: ",
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "span",
                                        { className: "bold" },
                                        "Rs. ",
                                        data.amount.toFixed(2)
                                    )
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "div",
                                { className: "sign" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "p",
                                    null,
                                    "Signature of the authorised Person"
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_3__style_sign_7_png___default.a })
                            )
                        );
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "h2",
                        { className: "totalGenerated" },
                        "Total",
                        this.q.toFixed(2)
                    )
                )
            );
        }
    }]);

    return InstantCashMemo;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["default"] = (InstantCashMemo);


var fakeDataHS = [{ vehicleNumber: 'OD35C3331', customerName: 'A Sahoo' }, { vehicleNumber: 'OD35C7117', customerName: 'Manoj Das' }, { vehicleNumber: 'OR04F3245', customerName: 'Rashmi' }, { vehicleNumber: 'OD35D7617', customerName: 'Gagan' }, { vehicleNumber: 'OD35C2015', customerName: 'K. Behera' }, { vehicleNumber: 'OD35C5383', customerName: 'R. Das' }, { vehicleNumber: 'OD35B8899', customerName: 'P Pradhan' }, { vehicleNumber: 'OD35B8441', customerName: 'Ramesh Sahoo' }, { vehicleNumber: 'OD35D8441', customerName: 'Vipin Das' }, { vehicleNumber: 'OD35D1499', customerName: 'Rahul Ray' }, { vehicleNumber: 'OD19F9633', customerName: 'K. Behera' }, { vehicleNumber: 'OD35B6399', customerName: 'Dipip Jena' }, { vehicleNumber: 'OD35B8611', customerName: 'Raman Sahoo' }, { vehicleNumber: 'OD35D8611', customerName: 'Jagidish Behera' }, { vehicleNumber: 'OD35D7042', customerName: 'K kalpa' }, { vehicleNumber: 'OD35B5427', customerName: 'T Rao' }, { vehicleNumber: 'OD35C4326', customerName: 'J. Sahoo' }, { vehicleNumber: 'OD19G0017', customerName: 'Rama Nayak' }, { vehicleNumber: 'OD35D0599', customerName: 'A Sahoo' }, { vehicleNumber: 'OD35B9979', customerName: 'S Jena' }, { vehicleNumber: 'OD35D0412', customerName: 'Raja' }, { vehicleNumber: 'OD19M3017', customerName: 'Pintu Sahu' }, { vehicleNumber: 'OD35D8379', customerName: 'Mantu' }, { vehicleNumber: 'OR04E4111', customerName: 'Ranu Jena' }, { vehicleNumber: 'OR19G7047', customerName: 'Manas Das' }, { vehicleNumber: 'OD35C1888', customerName: 'Manoj Das' }, { vehicleNumber: 'OD35E3339', customerName: 'R Tripathy' }, { vehicleNumber: 'OD35C9888', customerName: 'Rashmi Jena' }, { vehicleNumber: 'OD35C8383', customerName: 'T Tripathi' }, { vehicleNumber: 'OD35C4888', customerName: 'Mantu' }, { vehicleNumber: 'OD35C4453', customerName: 'R Jena' }, { vehicleNumber: 'OD35B9748', customerName: 'Rama Nayak' }, { vehicleNumber: 'OD35C8379', customerName: 'Abinash' }, { vehicleNumber: 'OD35C6362', customerName: 'Kalu' }, { vehicleNumber: 'OD35C7926', customerName: 'Patia Pradhan' }, { vehicleNumber: 'OD35D3133', customerName: 'Deepak Pradhan' }, { vehicleNumber: 'OD35D2225', customerName: 'Ramesh Sahoo' }, { vehicleNumber: 'OR11J5039', customerName: 'Kalia Malla' }, { vehicleNumber: 'OD35B2723', customerName: 'Mantu Nanda' }, { vehicleNumber: 'OD35C2723', customerName: 'Santohs Das' }, { vehicleNumber: 'OD35D2399', customerName: 'Kalia Debta' }, { vehicleNumber: 'OD35D8121', customerName: 'Ramesh Jena' }, { vehicleNumber: 'OR19K9978', customerName: 'Mantu ' }, { vehicleNumber: 'OD19J2723', customerName: 'Kalinga Sahoo' }, { vehicleNumber: 'OD35C3123', customerName: 'Radhakant Ratha' }, { vehicleNumber: 'OD19B0017', customerName: 'Probodh Jena' }, { vehicleNumber: 'OD35B0627', customerName: 'Bira Sahoo' }, { vehicleNumber: 'OD35A7127', customerName: 'Abinash Kara' }, { vehicleNumber: 'OD35C2127', customerName: 'K Sahu' }, { vehicleNumber: 'OD35C3339', customerName: 'R Pradhan' }, { vehicleNumber: 'OD35B9089', customerName: 'T Jena' }, { vehicleNumber: 'OD35D2516', customerName: 'M Jena' }, { vehicleNumber: 'OD35B7888', customerName: 'Lalit Pradhan' }, { vehicleNumber: 'OD35D2666', customerName: 'T Sahu' }, { vehicleNumber: 'OD35B6888', customerName: 'K Nanda' }, { vehicleNumber: 'OD29D7786', customerName: 'J Behera' }, { vehicleNumber: 'OD35B8612', customerName: 'Maharga Jena' }, { vehicleNumber: 'OD35A7566', customerName: 'P Behera' }, { vehicleNumber: 'OD19H6866', customerName: 'S Sahu' }, { vehicleNumber: 'OD35-5167', customerName: 'K Nanda' }, { vehicleNumber: 'OD06C6866', customerName: 'Bapi Jena' }, { vehicleNumber: 'OD35B8768', customerName: 'Bapin Bhukta' }, { vehicleNumber: 'OR19G9437', customerName: 'Kamakhya Behera' }, { vehicleNumber: 'OD35D2015', customerName: 'P Dehury' }, { vehicleNumber: 'OD35D3993', customerName: 'J Nanda' }, { vehicleNumber: 'OD35E1724', customerName: 'K Dehury' }, { vehicleNumber: 'OR19G7247', customerName: 'S Sharma' }, { vehicleNumber: 'OD35D1724', customerName: 'Kalia' }, { vehicleNumber: 'OD35A7758', customerName: 'S Mishrqa' }, { vehicleNumber: 'OD35D2489', customerName: 'P Tripathi' }, { vehicleNumber: 'OD19E7429', customerName: 'J Jena' }, { vehicleNumber: 'OD35C2666', customerName: 'Abhi das' }, { vehicleNumber: 'OD35C2015', customerName: 'gandu khanduala' }, { vehicleNumber: 'OD35C5311', customerName: 'munga sahoo' }, { vehicleNumber: 'OD35C6777', customerName: 'bamuru kumar' }, { vehicleNumber: 'OD35B5777', customerName: 'rabi behera' }, { vehicleNumber: 'OD35C3927', customerName: 'murali behera' }, { vehicleNumber: 'OD35C4777', customerName: 'jhumara tunga' }, { vehicleNumber: 'OD35B3017', customerName: 'panu jena' }, { vehicleNumber: 'OD19M3737', customerName: 'samir pradhan' }, { vehicleNumber: 'OD35E3737', customerName: 'amara sahoo' }, { vehicleNumber: 'OD35D2399', customerName: 'bapi gochhayat' }, { vehicleNumber: 'OD35C0606', customerName: 'baikuntha jena' }, { vehicleNumber: 'OD35B8899', customerName: 'KK Jena' }, { vehicleNumber: 'OD35D2225', customerName: 'Biplab Sahu' }, { vehicleNumber: 'OD35C3331', customerName: 'Ramakanta' }, { vehicleNumber: 'OD35B6399', customerName: 'Lalit ' }, { vehicleNumber: 'OD35C4326', customerName: 'Nilu' }, { vehicleNumber: 'OD19N3737', customerName: 'Rabin' }, { vehicleNumber: 'OD35D8441', customerName: 'Bikina Bhutia' }, { vehicleNumber: 'OD35B8441', customerName: 'Anada Sahu' }, { vehicleNumber: 'OD35D7042', customerName: 'P Nanda' }, { vehicleNumber: 'OR19K9978', customerName: 'Ramesh Kanta' }, { vehicleNumber: 'OD35C9950', customerName: 'Abinash Kara' }, { vehicleNumber: 'OD35B8868', customerName: 'Rama Jena' }, { vehicleNumber: 'OD35A7068', customerName: 'Pabitra ' }, { vehicleNumber: 'OD35C5100', customerName: 'Priyansu' }, { vehicleNumber: 'OD35B8611', customerName: 'Kamakhya' }, { vehicleNumber: 'OD35C1888', customerName: 'Lipu ' }, { vehicleNumber: 'OD35C9888', customerName: 'Abhay Kumar' }, { vehicleNumber: 'OD35D8611', customerName: 'Rakesh ' }, { vehicleNumber: 'OD35D8121', customerName: 'Aru Jena' }, { vehicleNumber: 'OD29D7786', customerName: 'K Kumar' }, { vehicleNumber: 'OD19M3017', customerName: 'D Dehury' }, { vehicleNumber: 'OD35C5101', customerName: 'K Prasad' }, { vehicleNumber: 'OD35B8612', customerName: 'J Tripathy' }, { vehicleNumber: 'OD19G0017', customerName: 'L Behera' }, { vehicleNumber: 'OD19E7429', customerName: 'R Pradhan' }, { vehicleNumber: 'OD35D0599', customerName: 'K Jena' }, { vehicleNumber: 'OD35B9748', customerName: 'B Jena' }, { vehicleNumber: 'OD19E3737', customerName: 'K Das' }, { vehicleNumber: 'OD35B9979', customerName: 'J Sahoo' }, { vehicleNumber: 'OD35C6537', customerName: 'Samir pradhan' }, { vehicleNumber: 'OR04E4111', customerName: 'Deepak Pradhan' }, { vehicleNumber: 'OD19G3737', customerName: 'Ramesh Sahoo' }, { vehicleNumber: 'OD35D5152', customerName: 'Kalia Malla' }, { vehicleNumber: 'OD35C6362', customerName: 'Mantu Nanda' }, { vehicleNumber: 'OD35D0412', customerName: 'Santohs Das' }, { vehicleNumber: 'OD35C3927', customerName: 'Kalia Debta' }, { vehicleNumber: 'OD19L6654', customerName: 'Ramesh Jena' }, { vehicleNumber: 'OD35D3993', customerName: 'Mantu ' }, { vehicleNumber: 'OD35D2015', customerName: 'Kalinga Sahoo' }, { vehicleNumber: 'OD19B0017', customerName: 'Radhakant Ratha' }, { vehicleNumber: 'OD35C2015', customerName: 'Probodh Jena' }, { vehicleNumber: 'OD35C4888', customerName: 'Bira Sahoo' }, { vehicleNumber: 'OR19K9978', customerName: 'Abinash Kara' }, { vehicleNumber: 'OD35D3133', customerName: 'K Sahu' }, { vehicleNumber: 'OD35C7117', customerName: 'R Pradhan' }, { vehicleNumber: 'OD35D7617', customerName: 'T Jena' }, { vehicleNumber: 'OD35D3995', customerName: 'M Jena' }, { vehicleNumber: 'OD35D3849', customerName: 'Lalit Pradhan' }, { vehicleNumber: 'OD35A7758', customerName: 'T Sahu' }, { vehicleNumber: 'OD35C5311', customerName: 'K Nanda' }, { vehicleNumber: 'OD35D7178', customerName: 'J Behera' }, { vehicleNumber: 'OD35C2666', customerName: 'Maharga Jena' }, { vehicleNumber: 'OD19H6866', customerName: 'P Behera' }, { vehicleNumber: 'OD35D2666', customerName: 'S Sahu' }, { vehicleNumber: 'OR04F3245', customerName: 'Manoj Das' }, { vehicleNumber: 'OD06C6866', customerName: 'Rashmi' }, { vehicleNumber: 'OD35D8441', customerName: 'Gagan' }, { vehicleNumber: 'OD35B8441', customerName: 'K. Behera' }, { vehicleNumber: 'OD35C3339', customerName: 'R. Das' }, { vehicleNumber: 'OD35C7926', customerName: 'P Pradhan' }, { vehicleNumber: 'OD19F9633', customerName: 'Ramesh Sahoo' }, { vehicleNumber: 'OD19J2723', customerName: 'Vipin Das' }, { vehicleNumber: 'OD35C2723', customerName: 'Rahul Ray' }, { vehicleNumber: 'OD29D7786', customerName: 'K. Behera' }, { vehicleNumber: 'OD19G3737', customerName: 'Dipip Jena' }, { vehicleNumber: 'OD19E7429', customerName: 'Raman Sahoo' }, { vehicleNumber: 'OD35D8611', customerName: 'Jagidish Behera' }, { vehicleNumber: 'OD35B8611', customerName: 'K Das' }, { vehicleNumber: 'OR19K9978', customerName: 'J Tripathy' }, { vehicleNumber: 'OD35E3737', customerName: 'M Behera' }, { vehicleNumber: 'OD35C3331', customerName: 'L Das' }, { vehicleNumber: 'OD35C0606', customerName: 'J Nanda' }, { vehicleNumber: 'OD19M3737', customerName: 'Kabi Das' }, { vehicleNumber: 'OD35B2723', customerName: 'T Dehury' }, { vehicleNumber: 'OD19N3737', customerName: 'Jitu Pradhan' }, { vehicleNumber: 'OD35B3017', customerName: 'Jitu ' }, { vehicleNumber: 'OR19G9437', customerName: 'Pranothos Ray' }, { vehicleNumber: 'OD35B9979', customerName: 'Rameswar Behera' }, { vehicleNumber: 'OD35B8868', customerName: 'Kamkya Das' }, { vehicleNumber: 'OD35D0412', customerName: 'Binod Das' }, { vehicleNumber: 'OD35D1373', customerName: 'Ajay Das' }, { vehicleNumber: 'OD35A7068', customerName: 'Sanjay Das' }, { vehicleNumber: 'OR19G7247', customerName: 'Arkhita Jena' }, { vehicleNumber: 'OD35C8383', customerName: 'Abhi Das' }, { vehicleNumber: 'OD35C8379', customerName: 'Jagidish Behera' }, { vehicleNumber: 'OD35B9089', customerName: 'Mantu Setha' }, { vehicleNumber: 'OD35D2489', customerName: 'Abhay Das' }, { vehicleNumber: 'OD19M3017', customerName: 'Bibhuti Tripathi' }, { vehicleNumber: 'OR19H2572', customerName: 'Rakesh Nanda' }, { vehicleNumber: 'OD35C9968', customerName: 'Prabin Jena' }, { vehicleNumber: 'OD35A7127', customerName: 'Prasuram Barik' }, { vehicleNumber: 'OD35C4453', customerName: 'Ananda Das' }, { vehicleNumber: 'OD35C3927', customerName: 'Kalia Debta' }, { vehicleNumber: 'OD35B8612', customerName: 'Ramesh Jena' }, { vehicleNumber: 'OD35D3849', customerName: 'Mantu ' }, { vehicleNumber: 'OD35D3995', customerName: 'Kalinga Sahoo' }, { vehicleNumber: 'OD19B0017', customerName: 'Radhakant Ratha' }, { vehicleNumber: 'OD5D7617', customerName: 'Probodh Jena' }, { vehicleNumber: 'OD35D7172', customerName: 'Bira Sahoo' }, { vehicleNumber: 'OD19M4453', customerName: 'Abinash Kara' }, { vehicleNumber: 'OD35D3243', customerName: 'K Sahu' }, { vehicleNumber: 'OD35C5101', customerName: 'R Pradhan' }, { vehicleNumber: 'OD35B5427', customerName: 'T Jena' }, { vehicleNumber: 'OD19E3737', customerName: 'M Jena' }, { vehicleNumber: 'OD35B8121', customerName: 'Lalit Pradhan' }, { vehicleNumber: 'OD35D8121', customerName: 'T Sahu' }, { vehicleNumber: 'OD35B8899', customerName: 'KK Das' }, { vehicleNumber: 'OD35D3993', customerName: 'Abhay Jena' }, { vehicleNumber: 'OD35D3133', customerName: 'Rakesh Khandual' }, { vehicleNumber: 'OD35C2015', customerName: 'Bablu Behera' }, { vehicleNumber: 'OD35D2015', customerName: 'Sibananda' }, { vehicleNumber: 'OD35C2727', customerName: 'Litan Bhutia' }, { vehicleNumber: 'OD35C5100', customerName: 'Gauranga Das' }];

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_utility_tip__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utility_rq__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_utility_spinner__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_utility_message_box__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_utility_util_methods__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_utility_question_box__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_utility_select_menu__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_product_store__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants_constants__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var CreateInspectionEntry = function (_React$Component) {
    _inherits(CreateInspectionEntry, _React$Component);

    function CreateInspectionEntry() {
        _classCallCheck(this, CreateInspectionEntry);

        var _this = _possibleConstructorReturn(this, (CreateInspectionEntry.__proto__ || Object.getPrototypeOf(CreateInspectionEntry)).call(this));

        _this.state = {
            propError: {},
            productList: __WEBPACK_IMPORTED_MODULE_8__store_product_store__["a" /* default */].getAll(),
            showSpinner: false,
            nozels: [],
            productData: []

        };
        _this.selectNozel = {};
        _this.inspectionDate = null;
        _this.totalStock = null;
        _this.messageBox = null;
        _this.questionBox = null;
        _this.saveInspection = _this.saveInspection.bind(_this);
        _this.handleProductStoreChange = _this.handleProductStoreChange.bind(_this);
        _this.producdMenuReset = false;
        _this.selectedProduct = null;
        _this.handeleNozelNumber = _this.handeleNozelNumber.bind(_this);
        return _this;
    }

    _createClass(CreateInspectionEntry, [{
        key: "askQuestion",
        value: function askQuestion(msg, yesCallBack, noCallBack) {
            this.questionBox = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_utility_question_box__["a" /* default */], { questionMsg: msg, yesCallBack: yesCallBack, noCallBack: noCallBack });
            this.setState(this.state);
        }
    }, {
        key: "saveInspection",
        value: function saveInspection(data) {
            var _this2 = this;

            this.askQuestion("Do you watnt to save this Inspection   ?", function () {
                var jsonData = {};
                jsonData.readingSum = _this2.readingSum;
                jsonData.totalStock = _this2.refs.totalStock.value;
                jsonData.totalBeforeStock = _this2.totalBeforeStock;

                _this2.setState({ showSpinner: true });
                __WEBPACK_IMPORTED_MODULE_2__utility_rq__["a" /* default */].postJson("/api/v1/mis/dsr-inpection/create", { date: _this2.refs.inspectionDate.value, jsonData: jsonData, productId: _this2.selectedProduct.productId }).then(function (data) {
                    _this2.messageBox = __WEBPACK_IMPORTED_MODULE_4__components_utility_message_box__["a" /* default */].showMessage("Last inspection createing successfully", true, _this2);
                    _this2.producdMenuReset = true;
                    _this2.refs.inspectionDate.value = "";
                    _this2.selectedProduct = null;
                    _this2.refs.totalBeforeStock.value = "";
                    _this2.refs.readingSum.value = "";
                    _this2.refs.totalStock.value = "";

                    _this2.setState({ showSpinner: false });
                }).catch(function (err) {
                    if (err.msg) {
                        _this2.messageBox = __WEBPACK_IMPORTED_MODULE_4__components_utility_message_box__["a" /* default */].showMessage(err.msg, false, _this2);
                    } else {
                        _this2.messageBox = __WEBPACK_IMPORTED_MODULE_4__components_utility_message_box__["a" /* default */].showMessage("Last inspection createing  failed !!!", false, _this2);
                    }
                    _this2.setState({ showSpinner: false });
                });

                _this2.questionBox = null;
                _this2.forceUpdate();
            }, function () {

                _this2.questionBox = null;
                _this2.forceUpdate();
            });
        }
    }, {
        key: "onsubmit",
        value: function onsubmit() {
            var propError = {};
            if (this.refs.inspectionDate.value) {
                delete propError.inspectionDate;
            } else propError.inspectionDate = true;

            if (this.refs.totalStock.value) {
                delete propError.totalStock;
            } else propError.totalStock = true;

            if (this.selectedProduct) {
                delete propError.productId;
            } else propError.productId = true;

            if (this.refs.totalBeforeStock.value) {
                delete propError.totalBeforeStock;
            } else propError.totalBeforeStock = true;

            if (this.refs.readingSum.value) {
                delete propError.readingSum;
            } else propError.readingSum = true;

            if (Object.keys(propError).length > 0) {
                this.setState({ propError: propError, productData: [] });
            } else {
                this.state.propError = propError;
                this.saveInspection();
            }
        }
    }, {
        key: "handeleInspectionDate",
        value: function handeleInspectionDate(e) {
            this.inspectionDate = e.target.value;
        }
    }, {
        key: "handeltotalStock",
        value: function handeltotalStock(e) {
            this.totalStock = e.target.value;
        }
    }, {
        key: "handeltotalBeforeStock",
        value: function handeltotalBeforeStock(e) {
            this.totalBeforeStock = e.target.value;
        }
    }, {
        key: "handeleNozelNumber",
        value: function handeleNozelNumber(e) {
            //console.log(nozel, e.target.value
            this.readingSum = e.target.value;
        }
    }, {
        key: "onProductSelect",
        value: function onProductSelect(product) {
            if (product) {
                this.selectedProduct = product;
                var propError = Object.assign({}, this.state.propError);
                delete propError.productId;
                this.setState({ propError: propError });
            }
        }
    }, {
        key: "handleProductStoreChange",
        value: function handleProductStoreChange() {
            this.setState({ productList: __WEBPACK_IMPORTED_MODULE_8__store_product_store__["a" /* default */].getAll() });
        }
    }, {
        key: "componentWillMount",
        value: function componentWillMount() {
            __WEBPACK_IMPORTED_MODULE_8__store_product_store__["a" /* default */].on(__WEBPACK_IMPORTED_MODULE_9__constants_constants__["b" /* productConstant */].PRODUCTS_STORE_CHANGE, this.handleProductStoreChange);
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            __WEBPACK_IMPORTED_MODULE_8__store_product_store__["a" /* default */].removeListener(__WEBPACK_IMPORTED_MODULE_9__constants_constants__["b" /* productConstant */].PRODUCTS_STORE_CHANGE, this.handleProductStoreChange);
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
            this.producdMenuReset = false;
        }
    }, {
        key: "render",
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { style: { display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "smallholder" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "p",
                        { className: "formMsg" },
                        "Create Last inspection Entry"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "table",
                        { className: "formTable" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "tbody",
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "tr",
                                { style: { display: "flex", justifyContent: "center" } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "td",
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_utility_tip__["a" /* default */], {
                                        showOn: this.state.propError.productId,
                                        pointerStyle: {},
                                        msg: "Select a product "
                                    }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_utility_select_menu__["a" /* default */], {
                                        data: this.state.productList,
                                        onSelect: this.onProductSelect.bind(this),
                                        tabIndex: "1",
                                        text: "Select a product",
                                        ky: "productId",
                                        vl: "productName",
                                        reset: this.producdMenuReset
                                    })
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "tr",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "td",
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_utility_tip__["a" /* default */], {
                                        showOn: this.state.propError.readingSum,
                                        pointerStyle: {},
                                        msg: "Enter Reading Sum "
                                    }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "p",
                                        { className: "label" },
                                        "Enter inspection Reading Sum"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                                        tabIndex: "2",
                                        type: "number",
                                        className: "formControl inputBox",
                                        placeholder: "Enter inspection Reading Sum",
                                        onChange: this.handeleNozelNumber.bind(this),
                                        ref: "readingSum"

                                    })
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "tr",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "td",
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_utility_tip__["a" /* default */], {
                                        showOn: this.state.propError.inspectionDate,
                                        pointerStyle: {},
                                        msg: "Enter inspection date"
                                    }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "p",
                                        { className: "label" },
                                        "inspection Date"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                                        tabIndex: "15",
                                        type: "date",
                                        className: "formControl inputBox",
                                        placeholder: "Enter inspection Date",
                                        onChange: this.handeleInspectionDate.bind(this),
                                        ref: "inspectionDate"

                                    })
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "tr",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "td",
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_utility_tip__["a" /* default */], {
                                        showOn: this.state.propError.totalStock,
                                        pointerStyle: {},
                                        msg: "Enter Total Stock"
                                    }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "p",
                                        { className: "label" },
                                        "Enter Total Stock"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                                        tabIndex: "16",
                                        type: "number",
                                        className: "formControl inputBox",
                                        placeholder: "Enter Total Stock",
                                        onChange: this.handeltotalStock.bind(this),
                                        ref: "totalStock"

                                    })
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "tr",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "td",
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_utility_tip__["a" /* default */], {
                                        showOn: this.state.propError.totalBeforeStock,
                                        pointerStyle: {},
                                        msg: "Enter stock In quantity"
                                    }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "p",
                                        { className: "label" },
                                        "Enter stock In quantity Before inspection Time (day of insepction)"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                                        tabIndex: "16",
                                        type: "number",
                                        className: "formControl inputBox",
                                        placeholder: "Enter stock In quantity",
                                        onChange: this.handeltotalBeforeStock.bind(this),
                                        ref: "totalBeforeStock"

                                    })
                                )
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "button",
                        {
                            tabIndex: "17",
                            className: "btn btnOk btnRight",
                            onClick: this.onsubmit.bind(this)
                        },
                        "Submit"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "clear" })
                ),
                this.messageBox,
                this.questionBox,
                this.state.showSpinner ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_utility_spinner__["a" /* default */], null) : null
            );
        }
    }]);

    return CreateInspectionEntry;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["default"] = (CreateInspectionEntry);

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utility_advance_tip__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_auth_action__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_auth_store__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_user_js__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_user_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__models_user_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utility_spinner__ = __webpack_require__(17);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var Login = function (_React$Component) {
    _inherits(Login, _React$Component);

    function Login() {
        _classCallCheck(this, Login);

        var _this = _possibleConstructorReturn(this, (Login.__proto__ || Object.getPrototypeOf(Login)).call(this));

        _this.state = {
            loginFailed: false,
            passwordForget: false,
            invalidPasswordRecovery: false,
            invalidEmail: false,
            errorMsg: ""
        };
        _this.afterLogIn = _this.afterLogIn.bind(_this);
        _this.onlogInFailed = _this.onlogInFailed.bind(_this);
        _this.onPasswordRecovered = _this.onPasswordRecovered.bind(_this);
        _this.onPasswordRecoveryFailed = _this.onPasswordRecoveryFailed.bind(_this);
        _this.spinner = null;
        _this.handleLogin = _this.handleLogin.bind(_this);
        return _this;
    }

    _createClass(Login, [{
        key: "handleLogin",
        value: function handleLogin() {
            // this.state.loginFailed = true;
            // this.setState(this.state);
            var email = this.refs.email.value;
            var password = this.refs.password.value;
            if (__WEBPACK_IMPORTED_MODULE_5__models_user_js___default.a.validateEmail(email) && __WEBPACK_IMPORTED_MODULE_5__models_user_js___default.a.validatePassword(password)) {
                __WEBPACK_IMPORTED_MODULE_3__actions_auth_action__["a" /* login */](email, password);
                this.spinner = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__utility_spinner__["a" /* default */], null);
                this.forceUpdate();
            } else {
                this.setState({ loginFailed: true });
            }
        }
    }, {
        key: "cancelTip",
        value: function cancelTip() {
            this.setState({ loginFailed: false });
        }
    }, {
        key: "onPasswordForget",
        value: function onPasswordForget() {
            this.setState({ passwordForget: true });
        }
    }, {
        key: "recoverPassword",
        value: function recoverPassword() {
            //alert("hello");
            if (__WEBPACK_IMPORTED_MODULE_5__models_user_js___default.a.validateEmail(this.refs.recoveryEmail.value)) {
                __WEBPACK_IMPORTED_MODULE_3__actions_auth_action__["b" /* recoverPassword */](this.refs.recoveryEmail.value);
                this.spinner = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__utility_spinner__["a" /* default */], null);
                this.forceUpdate();
            } else {
                this.setState({ invalidPasswordRecovery: true });
            }
        }
    }, {
        key: "reset",
        value: function reset() {
            this.setState({
                loginFailed: false,
                passwordForget: false,
                invalidPasswordRecovery: false
            });
        }
    }, {
        key: "onlogInFailed",
        value: function onlogInFailed() {
            this.spinner = null;
            this.setState({ loginFailed: true });
        }
    }, {
        key: "afterLogIn",
        value: function afterLogIn() {
            var location = this.props.pageProps.location;
            if (location.state && location.state.nextPathname) {
                __WEBPACK_IMPORTED_MODULE_2_react_router__["browserHistory"].push(location.state.nextPathname);
            } else {
                __WEBPACK_IMPORTED_MODULE_2_react_router__["browserHistory"].push("/");
            }
        }
    }, {
        key: "onPasswordRecovered",
        value: function onPasswordRecovered() {
            alert("a password recovery email has been send to your mail address");
            window.location.reload();
            //console.log("ok");
        }
    }, {
        key: "onPasswordRecoveryFailed",
        value: function onPasswordRecoveryFailed() {
            this.spinner = null;
            this.setState({ invalidPasswordRecovery: true });
        }
    }, {
        key: "componentWillMount",
        value: function componentWillMount() {
            __WEBPACK_IMPORTED_MODULE_4__store_auth_store__["a" /* default */].on("loginSuccess", this.afterLogIn);
            __WEBPACK_IMPORTED_MODULE_4__store_auth_store__["a" /* default */].on("loginFailed", this.onlogInFailed);
            __WEBPACK_IMPORTED_MODULE_4__store_auth_store__["a" /* default */].on("passwordRecovered", this.onPasswordRecovered);
            __WEBPACK_IMPORTED_MODULE_4__store_auth_store__["a" /* default */].on("passwordRecoveryFailed", this.onPasswordRecoveryFailed);
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            //console.log("component unmmout fired");
            __WEBPACK_IMPORTED_MODULE_4__store_auth_store__["a" /* default */].removeListener("loginSuccess", this.afterLogIn);
            __WEBPACK_IMPORTED_MODULE_4__store_auth_store__["a" /* default */].removeListener("loginFailed", this.onlogInFailed);
            __WEBPACK_IMPORTED_MODULE_4__store_auth_store__["a" /* default */].removeListener("passwordRecovered", this.onPasswordRecovered);
            __WEBPACK_IMPORTED_MODULE_4__store_auth_store__["a" /* default */].removeListener("passwordRecoveryFailed", this.onPasswordRecoveryFailed);
        }
    }, {
        key: "recoveryEmailOnKeyUp",
        value: function recoveryEmailOnKeyUp(e) {
            // this is to hide the tip this is not a registered emailid
            if (e.target.value === "") {
                this.setState({ invalidPasswordRecovery: false });
            }
        }
    }, {
        key: "handlePassword",
        value: function handlePassword(event) {
            if (event.keyCode === 13) {
                this.handleLogin();
            }
        }
    }, {
        key: "render",
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "smallholder" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "p",
                    { className: "formMsg" },
                    !this.state.passwordForget ? "Login" : "Password recovery"
                ),
                !this.state.passwordForget ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "table",
                        { className: "formTable" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "tbody",
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "tr",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "td",
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                                        type: "text",
                                        className: "formControl inputBox",
                                        placeholder: "Email address",
                                        ref: "email"
                                    })
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "tr",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "td",
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                                        type: "password",
                                        className: "formControl inputBox",
                                        placeholder: "Password",
                                        ref: "password",
                                        onKeyUp: this.handlePassword.bind(this)
                                    })
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "tr",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "td",
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_1__utility_advance_tip__["a" /* default */],
                                        {
                                            showOn: this.state.loginFailed,
                                            tipStyle: { left: "1px", top: "-20px", width: "250px", background: "#3c4d67", fontSize: "14px", textAlign: "left", lineHeight: "1.5em", height: "50px" },
                                            pointerStyle: {},
                                            pointerClass: "tUpLeft",
                                            closeBtnStyle: { position: "absolute", right: "8px" },
                                            cancelTip: this.cancelTip.bind(this)
                                        },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "p",
                                            { style: { color: "white" } },
                                            "Invalid email address or password !!!"
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "p",
                                            { onClick: this.onPasswordForget.bind(this), style: { color: "white", fontSize: "13px", textDecoration: "underline", cursor: "pointer" } },
                                            "Did you forget password ?"
                                        )
                                    )
                                )
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "button",
                        {
                            className: "btn btnOk btnRight",
                            onClick: this.handleLogin
                        },
                        "Login"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "clear" })
                ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "table",
                        { className: "formTable" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "tbody",
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "tr",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "td",
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                                        type: "text",
                                        className: "formControl inputBox",
                                        placeholder: "Enter your Email address",
                                        ref: "recoveryEmail",
                                        onKeyUp: this.recoveryEmailOnKeyUp.bind(this)

                                    }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_1__utility_advance_tip__["a" /* default */],
                                        {
                                            showOn: this.state.invalidPasswordRecovery,
                                            tipStyle: { left: "0", top: "40px", width: "250px", fontSize: "14px", textAlign: "left", lineHeight: "1.5em" }
                                        },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "p",
                                            null,
                                            "This is not a registered email address !!!"
                                        )
                                    )
                                )
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "button",
                        {
                            className: "btn btnOk btnRight",
                            onClick: this.recoverPassword.bind(this)
                        },
                        "Submit"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "button",
                        {
                            className: "btn btnOk btnRight",
                            onClick: this.reset.bind(this),
                            style: { marginRight: "10px" }
                        },
                        "Cancel"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "clear" })
                ),
                this.spinner
            );
        }
    }]);

    return Login;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Login);

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_utility_select_menu__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utility_rq__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_utility_message_box__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_utility_question_box__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utility_auto_complete__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utility_spinner__ = __webpack_require__(17);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var CreateMsgEventName = function (_React$Component) {
    _inherits(CreateMsgEventName, _React$Component);

    function CreateMsgEventName(props) {
        _classCallCheck(this, CreateMsgEventName);

        var _this = _possibleConstructorReturn(this, (CreateMsgEventName.__proto__ || Object.getPrototypeOf(CreateMsgEventName)).call(this, props));

        _this.messageBox = null;
        _this.questionBox = null;

        return _this;
    }

    _createClass(CreateMsgEventName, [{
        key: "askQuestion",
        value: function askQuestion(msg, yesCallBack, noCallBack) {
            this.questionBox = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_utility_question_box__["a" /* default */], { questionMsg: msg, yesCallBack: yesCallBack, noCallBack: noCallBack });
            this.setState(this.state);
        }
    }, {
        key: "handleSubmit",
        value: function handleSubmit() {
            var _this2 = this;

            var myMsg = this.refs.msg.value;
            if (myMsg) {
                this.askQuestion("Do you watnt to create Event " + myMsg + " ?", function () {
                    __WEBPACK_IMPORTED_MODULE_2__utility_rq__["a" /* default */].post("/api/v1/mis/create-event-category", { eventCategoryName: myMsg }).then(function () {
                        _this2.refs.msg.value = "";
                        _this2.messageBox = __WEBPACK_IMPORTED_MODULE_3__components_utility_message_box__["a" /* default */].showMessage("Event Name created successfully", true, _this2);
                        _this2.setState({});
                    }).catch(function (err) {
                        console.log(err);
                    });
                    _this2.questionBox = null;
                    _this2.forceUpdate();
                }, function () {
                    _this2.questionBox = null;
                    _this2.forceUpdate();
                });
            } else {
                this.messageBox = __WEBPACK_IMPORTED_MODULE_3__components_utility_message_box__["a" /* default */].showMessage("Enter a event name", false, this);
                this.setState({});
            }
        }
    }, {
        key: "render",
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "smallholder" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "p",
                    { className: "formMsg" },
                    "Create Event Name"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "table",
                    { className: "formTable" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "tbody",
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "tr",
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "td",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "p",
                                    { className: "label" },
                                    "Enter Event name"
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                                    tabIndex: "1",
                                    type: "text",
                                    className: "formControl inputBox",
                                    placeholder: "Enter Event name",
                                    ref: "msg"

                                })
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "button",
                    {
                        tabIndex: "2",
                        className: "btn btnOk btnRight",
                        onClick: this.handleSubmit.bind(this)
                    },
                    "Submit"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "clear" }),
                this.questionBox,
                this.messageBox
            );
        }
    }]);

    return CreateMsgEventName;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var ReciveCategory = function (_React$Component2) {
    _inherits(ReciveCategory, _React$Component2);

    function ReciveCategory(props) {
        _classCallCheck(this, ReciveCategory);

        var _this3 = _possibleConstructorReturn(this, (ReciveCategory.__proto__ || Object.getPrototypeOf(ReciveCategory)).call(this, props));

        _this3.messageBox = null;
        _this3.questionBox = null;
        return _this3;
    }

    _createClass(ReciveCategory, [{
        key: "askQuestion",
        value: function askQuestion(msg, yesCallBack, noCallBack) {
            this.questionBox = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_utility_question_box__["a" /* default */], { questionMsg: msg, yesCallBack: yesCallBack, noCallBack: noCallBack });
            this.setState(this.state);
        }
    }, {
        key: "handleSubmit",
        value: function handleSubmit() {
            var _this4 = this;

            var receiveCategoryName = this.refs.categoryName.value;
            var tablename = this.refs.tableName.value;
            var pkFieldName = this.refs.primaryName.value;
            var routePath = this.refs.routePath.value;
            var displayName = this.refs.displayName.value;
            if (receiveCategoryName && tablename && pkFieldName && routePath && displayName) {
                this.askQuestion("Do you watnt to create Receive Category ?", function () {
                    __WEBPACK_IMPORTED_MODULE_2__utility_rq__["a" /* default */].postJson("/api/v1/mis/create-msg-receive-category", { receiveCategoryName: receiveCategoryName, tablename: tablename, pkFieldName: pkFieldName, routePath: routePath, displayName: displayName }).then(function () {
                        _this4.refs.tableName.value = "";
                        _this4.refs.primaryName.value = "";
                        _this4.refs.categoryName.value = "";
                        _this4.refs.displayName.value = "";
                        _this4.refs.routePath.value = "";
                        _this4.messageBox = __WEBPACK_IMPORTED_MODULE_3__components_utility_message_box__["a" /* default */].showMessage("Receive Category created successfully", true, _this4);
                        _this4.setState({});
                    }).catch(function (err) {
                        console.log(err);
                    });
                    _this4.questionBox = null;
                    _this4.forceUpdate();
                }, function () {
                    _this4.questionBox = null;
                    _this4.forceUpdate();
                });
            } else {
                this.messageBox = __WEBPACK_IMPORTED_MODULE_3__components_utility_message_box__["a" /* default */].showMessage("Enter a " + (!receiveCategoryName ? "Categor" : !tablename ? "Table" : !pkFieldName ? "PrimaryKey" : !displayName ? "Display" : "Route Path") + " name", false, this);
                this.setState({});
            }
        }
    }, {
        key: "render",
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "smallholder" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "p",
                    { className: "formMsg" },
                    "Receive Category"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "table",
                    { className: "formTable" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "tbody",
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "tr",
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "td",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "p",
                                    { className: "label" },
                                    "Receive Category Name"
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                                    tabIndex: "1",
                                    type: "text",
                                    className: "formControl inputBox",
                                    placeholder: "Enter Category Name",
                                    ref: "categoryName"
                                })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "tr",
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "td",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "p",
                                    { className: "label" },
                                    "Enter Table Name"
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                                    tabIndex: "1",
                                    type: "text",
                                    className: "formControl inputBox",
                                    placeholder: "Enter Table Name",
                                    ref: "tableName"
                                })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "tr",
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "td",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "p",
                                    { className: "label" },
                                    "Primary Key  Name"
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                                    tabIndex: "1",
                                    type: "text",
                                    className: "formControl inputBox",
                                    placeholder: "Primary Key  Name",
                                    ref: "primaryName"
                                })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "tr",
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "td",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "p",
                                    { className: "label" },
                                    "Display  Name"
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                                    tabIndex: "1",
                                    type: "text",
                                    className: "formControl inputBox",
                                    placeholder: "Display  Name",
                                    ref: "displayName"
                                })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "tr",
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "td",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "p",
                                    { className: "label" },
                                    "Auto Complete Route Path"
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                                    tabIndex: "1",
                                    type: "text",
                                    className: "formControl inputBox",
                                    placeholder: "Enter Auto Complete Route Path",
                                    ref: "routePath"
                                })
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "button",
                    {
                        tabIndex: "2",
                        className: "btn btnOk btnRight",
                        onClick: this.handleSubmit.bind(this)
                    },
                    "Submit"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "clear" }),
                this.questionBox,
                this.messageBox
            );
        }
    }]);

    return ReciveCategory;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var CreateMessage = function (_React$Component3) {
    _inherits(CreateMessage, _React$Component3);

    function CreateMessage(props) {
        _classCallCheck(this, CreateMessage);

        var _this5 = _possibleConstructorReturn(this, (CreateMessage.__proto__ || Object.getPrototypeOf(CreateMessage)).call(this, props));

        _this5.selectReceiveCategory = function (category) {
            if (category) {
                _this5.selectedCategory = category;
                _this5.setState({});
            }
        };

        _this5.onEventSelect = function (event) {
            if (event) {
                _this5.selectEvent = event;
            } else {
                _this5.selectEvent = null;
            }
        };

        _this5.onSelectData = function (data) {
            if (data) {
                var exist = false;
                _this5.state.selectedList.forEach(function (e) {

                    if (e[_this5.selectedCategory.pkFeildName] === data[_this5.selectedCategory.pkFeildName]) {
                        exist = true;
                        _this5.searchBox.value = "";
                    }
                });

                if (!exist) {
                    var selectedList = _this5.state.selectedList.concat([data]);
                    _this5.searchBox.value = "";
                    _this5.setState({ selectedList: selectedList });
                }
            }
        };

        _this5.state = {
            ReceiveCategoryList: [],
            eventList: [],
            selectedList: [],
            showSpinner: false
        };
        _this5.msgRecCategoryReset = false;
        _this5.eventCategoryReset = false;
        _this5.selectEvent = null;
        _this5.selectedCategory = null;
        _this5.messageBox = null;
        _this5.questionBox = null;
        return _this5;
    }

    _createClass(CreateMessage, [{
        key: "askQuestion",
        value: function askQuestion(msg, yesCallBack, noCallBack) {
            this.questionBox = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_utility_question_box__["a" /* default */], { questionMsg: msg, yesCallBack: yesCallBack, noCallBack: noCallBack });
            this.setState(this.state);
        }
    }, {
        key: "handleSubmit",
        value: function handleSubmit() {
            var _this6 = this;

            if (this.selectEvent && this.selectedCategory && this.state.selectedList.length > 0) {
                this.askQuestion("Do you watnt to create Message ?", function () {
                    _this6.setState({ showSpinner: true });
                    __WEBPACK_IMPORTED_MODULE_2__utility_rq__["a" /* default */].postJson("/api/v1/mis/create-msg", { eventCategoryId: _this6.selectEvent.eventCategoryId, msgRecCategoryData: _this6.selectedCategory, selectedList: _this6.state.selectedList }).then(function () {
                        _this6.msgRecCategoryReset = true;
                        _this6.eventCategoryReset = true;
                        _this6.selectEvent = null;
                        _this6.selectedCategory = null;
                        _this6.messageBox = __WEBPACK_IMPORTED_MODULE_3__components_utility_message_box__["a" /* default */].showMessage("Created Message  successfully", true, _this6);
                        _this6.setState({ selectedList: [], showSpinner: false });
                    }).catch(function (err) {
                        console.log(err);
                    });
                    _this6.questionBox = null;
                    _this6.forceUpdate();
                }, function () {
                    _this6.questionBox = null;
                    _this6.forceUpdate();
                });
            } else {
                // ${!this.selectEvent ? "Select A Receive Category" : !this.selectedCategory ? "Select A Event Category  Name" : 
                this.messageBox = __WEBPACK_IMPORTED_MODULE_3__components_utility_message_box__["a" /* default */].showMessage("" + (!this.selectedCategory ? "Select A Receive Category" : !this.selectEvent ? "Select A Event Category  Name" : "Select a " + this.selectedCategory.displayName), false, this);
                this.setState({});
            }
        }
    }, {
        key: "removeEmployee",
        value: function removeEmployee(i) {
            if (i >= 0) {
                this.state.selectedList.splice(i, 1);
                this.setState(this.state);
            }
        }
    }, {
        key: "componentWillMount",
        value: function componentWillMount() {
            var _this7 = this;

            __WEBPACK_IMPORTED_MODULE_2__utility_rq__["a" /* default */].getJsonData("/api/v1/mis/get-categoty-event").then(function (data) {
                _this7.setState({ ReceiveCategoryList: data[1], eventList: data[0] });
            }).then(function () {});
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
            this.msgRecCategoryReset = false;
            this.eventCategoryReset = false;
        }
    }, {
        key: "render",
        value: function render() {
            var _this8 = this;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "smallholder" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "p",
                    { className: "formMsg" },
                    "Create Message"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "table",
                    { className: "formTable" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "tbody",
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "tr",
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "td",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "p",
                                    { className: "label" },
                                    "select a Receive Category"
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_utility_select_menu__["a" /* default */], {
                                    data: this.state.ReceiveCategoryList,
                                    onSelect: this.selectReceiveCategory,
                                    tabIndex: "2",
                                    text: "select a  Receive Category",

                                    ky: "msgRecCategoryId",
                                    vl: "msgRecCategoryName",
                                    reset: this.msgRecCategoryReset
                                })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "tr",
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "td",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "p",
                                    { className: "label" },
                                    "Select Event Category  Name"
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_utility_select_menu__["a" /* default */], {
                                    data: this.state.eventList,
                                    onSelect: this.onEventSelect,
                                    tabIndex: "2",
                                    text: "Select Event Category  Name",
                                    ky: "eventCategoryId",
                                    vl: "eventCategoryName",
                                    reset: this.eventCategoryReset
                                })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "tr",
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "td",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "p",
                                    { className: "label" },
                                    "Auto Complete"
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__utility_auto_complete__["a" /* default */], {
                                    placeholder: "select a " + (this.selectedCategory ? this.selectedCategory.displayName : "Name"),
                                    dataSrc: this.selectedCategory ? this.selectedCategory.routePath : "api/vi",
                                    dataTobind: this.selectedCategory ? this.selectedCategory.displayName : "  ",
                                    keyToBind: this.selectedCategory ? this.selectedCategory.pkFeildName : "  ",
                                    tabIndex: "4",
                                    onSelect: this.onSelectData.bind(this),

                                    rex: function rex(searchBox) {
                                        _this8.searchBox = searchBox;
                                        //this.searchBox.onfocus = this.onSelectEmployeeFocus.bind(this);
                                    }

                                }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "ul",
                                    null,
                                    this.state.selectedList.map(function (e, i) {
                                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "li",
                                            { key: e[_this8.selectedCategory.pkFeildName], className: "studentList" },
                                            e[_this8.selectedCategory.displayName],
                                            " ",
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-times", style: { cursor: "pointer" }, onClick: _this8.removeEmployee.bind(_this8, i) })
                                        );
                                    })
                                )
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "button",
                    {
                        tabIndex: "2",
                        className: "btn btnOk btnRight",
                        onClick: this.handleSubmit.bind(this)
                    },
                    "Submit"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "clear" }),
                this.questionBox,
                this.messageBox,
                this.state.showSpinner ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__utility_spinner__["a" /* default */], null) : null
            );
        }
    }]);

    return CreateMessage;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var MsgSubscription = function (_Component) {
    _inherits(MsgSubscription, _Component);

    function MsgSubscription() {
        _classCallCheck(this, MsgSubscription);

        return _possibleConstructorReturn(this, (MsgSubscription.__proto__ || Object.getPrototypeOf(MsgSubscription)).apply(this, arguments));
    }

    _createClass(MsgSubscription, [{
        key: "render",
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CreateMsgEventName, null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ReciveCategory, null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CreateMessage, null)
            );
        }
    }]);

    return MsgSubscription;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["default"] = (MsgSubscription);

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_auth_store__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_router__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var UserCard = function (_React$Component) {
    _inherits(UserCard, _React$Component);

    function UserCard() {
        _classCallCheck(this, UserCard);

        var _this = _possibleConstructorReturn(this, (UserCard.__proto__ || Object.getPrototypeOf(UserCard)).call(this));
        //console.log("-------- card constructor fired");


        _this.state = {
            user: __WEBPACK_IMPORTED_MODULE_1__store_auth_store__["a" /* default */].getToken().user
        };
        return _this;
    }

    _createClass(UserCard, [{
        key: "handleSingOut",
        value: function handleSingOut() {
            //alert("all is well");
            __WEBPACK_IMPORTED_MODULE_1__store_auth_store__["a" /* default */].deleteToken();
            __WEBPACK_IMPORTED_MODULE_2_react_router__["browserHistory"].push("/login");
        }
    }, {
        key: "render",
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "userCard" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "pointer", style: { borderBottomColor: "#c7c7c7", top: "-11px", right: "10px" } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "pointer", style: { borderBottomColor: "white", top: "-10px", right: "10px" } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { style: { display: "flex", margin: "20px" } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-user", "aria-hidden": "true", style: {
                            color: "white",
                            lineHeight: "88px",
                            display: "inline-block",
                            width: "96px", height: "96px",
                            background: "#6c5484",
                            fontSize: "5em",
                            textAlign: "center",
                            borderRadius: "50%"
                        } }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { style: { position: "relative", height: "96px", width: "144px", marginLeft: "20px" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "h2",
                            { style: { fontSize: ".9em" } },
                            this.state.user.userName
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "p",
                            { style: { fontSize: ".7em", color: "gray", marginTop: "5px" } },
                            this.state.user.emailId
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "button",
                            { className: "btn btnOk", style: { marginBottom: 0, position: "absolute", left: 0, bottom: 0 } },
                            "My Account"
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "footerBar" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "button",
                        { onClick: this.handleSingOut.bind(this), className: "btn btnGray btnRight", style: { marginRight: "10px" } },
                        "Sign Out"
                    )
                )
            );
        }
    }]);

    return UserCard;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (UserCard);

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fragments_create_invoice__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fragments_user_card__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fragments_admin_notifaction__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_transaction_account_store__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_swipe_machine_store__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_invoice_store__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_shift_store__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_mpd_store__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_tank_store__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_nozzel_store__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_expenditure_catagory_store__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store_payment_mode_store__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utility_message_box__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utility_question_box__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utility_spinner__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__actions_product_action__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__actions_tank_action__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__actions_mpd_action__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__actions_shift_action__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__actions_notification_action__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__store_notification_store__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__actions_expenditure_catagory_action__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__actions_transaction_account_action__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__actions_swipe_machine_action__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react_motion__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react_motion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_react_motion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__actions_payment_mode_action__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__utility_auto_complete__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__utility_util_methods__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__utility_rq_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__fragments_currency_entry__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__store_auth_store__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__utility_net_detect__ = __webpack_require__(191);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





































//import CurrentCredit from "../fragments/current-credit";


var Master1 = function (_Component) {
    _inherits(Master1, _Component);

    function Master1() {
        _classCallCheck(this, Master1);

        var _this = _possibleConstructorReturn(this, (Master1.__proto__ || Object.getPrototypeOf(Master1)).call(this));

        _this.stockIn = null;
        _this.state = {
            spinner: false,
            lastShiftData: {},
            creditData: [],
            productDetail: [],
            shiftDetail: null,
            tankDetail: [],
            showRightPannel: false,
            showCurrencyForm: false,

            gotCreditData: false,
            gotTankData: false

        };

        _this.questionBox = null;
        _this.messageBox = null;
        // this.onCreated = this.onCreated.bind(this);
        // this.onFailed = this.onFailed.bind(this);
        _this.currencyFormReset = false;
        _this.hideSpinner = _this.hideSpinner.bind(_this);
        _this.showSpinner = _this.showSpinner.bind(_this);

        return _this;
    }

    _createClass(Master1, [{
        key: "showSpinner",
        value: function showSpinner() {
            this.setState({ spinner: true });
        }
    }, {
        key: "hideSpinner",
        value: function hideSpinner() {
            this.setState({ spinner: false });
        }
    }, {
        key: "cancelAllCards",
        value: function cancelAllCards() {
            this.adminNotification = null;
            this.userCard = null;
            this.stockIn = null;
        }

        // onFailed(msg) {
        //     this.messageBox = MessageBox.showMessage(msg, false, this);
        //     this.hideSpinner();
        //     this.setState(this.state);
        // }
        // onCreated(msg) {
        //     this.messageBox = MessageBox.showMessage(msg, true, this);
        //     this.hideSpinner();
        // }


    }, {
        key: "onNotificationFetched",
        value: function onNotificationFetched() {
            this.forceUpdate();
        }
    }, {
        key: "onMouseEnter",
        value: function onMouseEnter(subMenuName) {
            this.adminNotification = null;
            //hiding the notifiaction box        
            this.setState({ submenus: _defineProperty({}, subMenuName, true) });
        }
    }, {
        key: "onCurrencySave",
        value: function onCurrencySave(currencyData, cashInTotal, cashOutTotal) {
            var _this2 = this;

            if (cashInTotal === cashOutTotal && (cashInTotal || cashOutTotal)) {
                var myCashData = {
                    exchangeId: 1,
                    cashInTotal: cashInTotal,
                    cashOutTotal: cashOutTotal,
                    currencyData: currencyData,
                    comment: ""
                };
                this.setState({ spinner: true });
                __WEBPACK_IMPORTED_MODULE_31__utility_rq_js__["a" /* default */].postJson("/api/v1/cash-exchange", myCashData).then(function () {
                    _this2.messageBox = __WEBPACK_IMPORTED_MODULE_15__utility_message_box__["a" /* default */].showMessage("Cash Exchange Successfull", true, _this2);
                    _this2.currencyFormReset = true;
                    _this2.setState({ showCurrencyForm: false, spinner: false });
                }).catch(function () {
                    _this2.messageBox = __WEBPACK_IMPORTED_MODULE_15__utility_message_box__["a" /* default */].showMessage("Cash Exchange Failed", false, _this2);
                    _this2.forceUpdate();
                });
            } else {
                this.messageBox = __WEBPACK_IMPORTED_MODULE_15__utility_message_box__["a" /* default */].showMessage("Cash In and Cash Out must be same amount", false, this);
                this.forceUpdate();
            }
        }
    }, {
        key: "onCurrencyCancel",
        value: function onCurrencyCancel() {
            this.setState({ showCurrencyForm: false });
        }
    }, {
        key: "loadPannelData",
        value: function loadPannelData() {
            var _this3 = this;

            __WEBPACK_IMPORTED_MODULE_31__utility_rq_js__["a" /* default */].getJsonData("/api/v1/mis/last-running-shift").then(function (data) {
                _this3.setState({ lastShiftData: data[0], tankDetail: [], shiftDetail: null });
            }).catch(function (err) {
                console.error(err);
            });

            __WEBPACK_IMPORTED_MODULE_31__utility_rq_js__["a" /* default */].getJsonData("/api/v1/shiftdetail").then(function (data) {
                _this3.setState({ lastShiftData: {}, shiftDetail: data[0] });
            }).catch(function (err) {
                console.error(err);
            });

            __WEBPACK_IMPORTED_MODULE_31__utility_rq_js__["a" /* default */].getJsonData("/api/v1/tank/current-shift-tank-detail").then(function (data) {
                //console.log(data);
                _this3.setState({ tankDetail: data, gotTankData: true });
            }).catch(function (err) {
                console.error(err);
            });

            __WEBPACK_IMPORTED_MODULE_31__utility_rq_js__["a" /* default */].getJsonData("/api/v1/current-shift-product-rate").then(function (data) {
                _this3.setState({ productDetail: data[0], gotShiftData: true });
            }).catch(function (err) {
                console.error(err);
            });

            // rq.getJsonData("/api/v1/credit-report-by-shift").then((data) => {
            //     this.setState({ creditData: data, gotCreditData: true });
            // }).catch((err) => {
            //     throw err;
            // });
        }
    }, {
        key: "handleAvailableCashClick",
        value: function handleAvailableCashClick() {
            //this.setState({ avilableCashSpinner: true });
            this.setState({ showCurrencyForm: true });
        }
    }, {
        key: "currencyFailed",
        value: function currencyFailed() {
            this.setState({ showCurrencyForm: false });
        }
    }, {
        key: "askQuestion",
        value: function askQuestion(msg, yesCallBack, noCallBack) {
            this.questionBox = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__utility_question_box__["a" /* default */], { questionMsg: msg, yesCallBack: yesCallBack, noCallBack: noCallBack });
            this.setState(this.state);
        }
    }, {
        key: "toggleRightPannel",
        value: function toggleRightPannel() {
            //console.log("called");
            if (!this.state.showRightPannel) {
                this.loadPannelData();
            }
            this.setState({ showRightPannel: !this.state.showRightPannel, gotCreditData: false, gotTankData: false });
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
            this.currencyFormReset = false;
        }
    }, {
        key: "componentWillMount",
        value: function componentWillMount() {
            this.loadPannelData();
        }
    }, {
        key: "render",
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                null,
                this.messageBox,
                this.questionBox,
                this.state.spinner ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__utility_spinner__["a" /* default */], null) : null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Header, null),
                this.props.children,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { id: "slideBox", style: { transition: "all .2s ease-in", width: "400px", alignItems: "end", position: "fixed", right: this.state.showRightPannel ? 0 : "-402px", top: "45px" } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { onClick: this.toggleRightPannel.bind(this), className: "rightArrow fa boxShadow " + (this.state.showRightPannel ? "fa-arrow-right" : "fa-arrow-left") }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { onClick: this.toggleRightPannel.bind(this), className: "rightArrow fa boxShadow " + (this.state.showRightPannel ? "fa-arrow-right" : "fa-arrow-left") }),
                    this.state.shiftDetail ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { style: { display: "flex", backgroundColor: "rgb(247, 57, 136)", marginBottom: "15px", color: "#ffffff", position: "relative" }, className: "boxShadow" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "table",
                            { className: "homePageTable", style: { width: "250px", margin: "5px auto 5px auto" } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "tbody",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "tr",
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "td",
                                        null,
                                        "Shift Date :"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "td",
                                        null,
                                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__utility_util_methods__["a" /* DD_MM_YY */])(this.state.shiftDetail.shiftDate)
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "tr",
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "td",
                                        null,
                                        "Current Shift :"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "td",
                                        null,
                                        this.state.shiftDetail.shiftName
                                    )
                                ),
                                this.state.productDetail.length > 0 ? this.state.productDetail.map(function (product, i) {
                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "tr",
                                        { key: i },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "td",
                                            null,
                                            product.productName,
                                            ":"
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "td",
                                            null,
                                            "\u20B9 ",
                                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__utility_util_methods__["h" /* toExactFixted */])(product.sellingPrice, 2)
                                        )
                                    );
                                }) : null
                            )
                        )
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { style: { display: "flex", flexDirection: "column", height: "200px", justifyContent: "center", alignItems: "center", backgroundColor: "rgb(247, 57, 136)", marginBottom: "15px", color: "#ffffff", position: "relative" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "h2",
                            { style: { fontSize: "1.2em" } },
                            "No shift is running !!!"
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "p",
                            null,
                            "Last Shift Date ",
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "span",
                                null,
                                " ",
                                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__utility_util_methods__["a" /* DD_MM_YY */])(this.state.lastShiftData.shiftDate)
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "p",
                            null,
                            "Shift Name ",
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "span",
                                null,
                                this.state.lastShiftData.shiftName
                            )
                        )
                    ),
                    this.state.tankDetail.length > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { style: { display: "flex", overflow: "auto", backgroundColor: "rgb(247, 57, 136)", marginBottom: "15px", color: "#ffffff", position: "relative" }, className: "boxShadow" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "table",
                            { className: "homePageTable", id: "centerTd" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "tbody",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "tr",
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "th",
                                        null,
                                        "Tank Name"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "th",
                                        null,
                                        "Product"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "th",
                                        null,
                                        "O-dip"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "th",
                                        null,
                                        "Volume"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "th",
                                        null,
                                        "Stock In"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "th",
                                        null,
                                        "Available"
                                    )
                                ),
                                this.state.tankDetail.map(function (tank, i) {
                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "tr",
                                        { key: i },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "td",
                                            null,
                                            tank.tankName
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "td",
                                            null,
                                            tank.productName
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "td",
                                            null,
                                            tank.dip
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "td",
                                            null,
                                            tank.volume
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "td",
                                            null,
                                            tank.stockInAmount
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "td",
                                            null,
                                            tank.avilable
                                        )
                                    );
                                })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-spin fa-spinner", style: { position: "absolute", top: "40px", left: "200px", fontSize: "2em", display: !this.state.gotTankData ? "inline-block" : "none" } })
                    ) : null,
                    this.state.creditData.length > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { id: "creditHolder", style: { position: "relative", display: "flex", maxHeight: "200px", overflow: "auto", backgroundColor: "rgb(247, 57, 136)", marginBottom: "15px", color: "#ffffff" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "table",
                            { className: "homePageTable", id: "centerTd" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "tbody",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "tr",
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "th",
                                        null,
                                        "Creditor Name"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "th",
                                        null,
                                        "Product"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "th",
                                        null,
                                        "Quantity"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "th",
                                        null,
                                        "Amount"
                                    )
                                ),
                                this.state.creditData.map(function (e, i) {
                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "tr",
                                        { key: i },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "td",
                                            null,
                                            e.firmName
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "td",
                                            null,
                                            e.productName
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "td",
                                            null,
                                            e.quantitys
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "td",
                                            null,
                                            e.amount
                                        )
                                    );
                                })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-spin fa-spinner", style: { position: "absolute", top: "100px", left: "200px", fontSize: "2em", display: !this.state.gotTankData ? "inline-block" : "none" } })
                    ) : null
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { style: { transition: "all .3s ease-in", position: "fixed", right: "10px", transform: this.state.showCurrencyForm ? "scale(0)" : "scale(1)" }, className: "boxShadow availableCash", onClick: this.handleAvailableCashClick.bind(this) },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-inr" })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__fragments_currency_entry__["a" /* default */], {
                    visible: this.state.showCurrencyForm,
                    onSave: this.onCurrencySave.bind(this),
                    onCancel: this.onCurrencyCancel.bind(this),
                    reset: this.currencyFormReset,
                    onFailed: this.currencyFailed.bind(this)
                })
            );
        }
    }]);

    return Master1;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var Header = function (_React$Component) {
    _inherits(Header, _React$Component);

    function Header() {
        _classCallCheck(this, Header);

        var _this4 = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this));

        _this4.createInvoice = null;
        _this4.adminNotification = null;
        _this4.userCard = null;
        _this4.stockIn = null;

        _this4.state = {
            allLinks: [
            //---------- cash sub menu --------
            { linkName: " create new currency", linkAddress: "/page/create-currency" }, { linkName: "  exchange  entry", linkAddress: "/page/exchange" },
            // --------- Employee sub menu --------------
            { linkName: " create new employee", linkAddress: "/page/create-employee" }, { linkName: " employee advance payment", linkAddress: "/page/employee-advance" }, { linkName: " collect cash from employee", linkAddress: "/page/employee-cash-collection" }, { linkName: " employee edit", linkAddress: "/edit-page/employee" }, { linkName: " employee advance between two day", linkAddress: "/report/employee-advance-between-two-day" }, { linkName: "  current shift employe advance", linkAddress: "/report/current-shift-employee-advance" }, { linkName: " salary payment by date", linkAddress: "/report/salary-payment-by-date" }, { linkName: "  employee attendance shortage report", linkAddress: "/report/employee-attendance-shortage" }, { linkName: "  employee salary report", linkAddress: "/report/employee-salary-detail" },
            // ............. Credito sub menu .......
            { linkName: "  create new creditor", linkAddress: "/page/create-creditor" }, { linkName: " credit entry", linkAddress: "/page/credit-entry" }, { linkName: " credit payment entry", linkAddress: "/page/creditor-payment-entry" }, { linkName: "  creditor edit", linkAddress: "/edit-page/creditor" }, { linkName: " current shift  credit report", linkAddress: "/report/current-shift-credit-report" }, { linkName: "  credit detail between two day", linkAddress: "/report/credit-detail-between-two-day" }, { linkName: " credit payment between two day", linkAddress: "/report/credit-payment-between-two-day" }, { linkName: " credit unbilled report of  all parties", linkAddress: "/report/credit-report-unbilled" }, { linkName: "    credit billed report of  all parties", linkAddress: "/report/credit-report-billed" }, { linkName: "  credit billed report by creditor", linkAddress: "/report/credit-report-billed-by-id" }, { linkName: "   payment report by creditor name", linkAddress: "/report/credit-payment-by-credit-id" }, { linkName: "   current shift detail credit report", linkAddress: "/report/current-shift-detail-credit-report" }, { linkName: " sell report", linkAddress: "/report/sell" }, { linkName: "   date wise sell report", linkAddress: "/report/sell-day" }, { linkName: "   reading report", linkAddress: "/report/reading-report" }, { linkName: "   credit report with aggreagation", linkAddress: "/report/credit-report-by-shift-with-aggreagation" }, { linkName: "   credit statement of all parties", linkAddress: "/report/credit-statement" }, { linkName: "  credit account details", linkAddress: "/report/credit-account-details" }, { linkName: "    current shift cash collection", linkAddress: "/report/current-shift-cash-collection" },

            //----------------------- expenditure sub menu -------------------

            { linkName: "       Expenditure Detail Entry", linkAddress: "/page/expenditure-detail" }, { linkName: "      Current Shift Expenditure  report", linkAddress: "/report/current-shift-expenditure" }, { linkName: "    Expenditure between two day", linkAddress: "/report/expenditure-between-two-day" }, { linkName: "      Expenditure With Aggreagation", linkAddress: "/report/expenditure-between-two-day-with-aggreagation" }, { linkName: "   Reading Report", linkAddress: "/report/reading-report" }, { linkName: "   Reading Report", linkAddress: "/report/reading-report" }, { linkName: "   Reading Report", linkAddress: "/report/reading-report" }, { linkName: "   Reading Report", linkAddress: "/report/reading-report" }, { linkName: "   Reading Report", linkAddress: "/report/reading-report" }, { linkName: "   Reading Report", linkAddress: "/report/reading-report" }],
            spinner: false,
            submenus: {
                cash: false,
                employee: false,
                creditor: false,
                product: false,
                expenditure: false,
                shift: false,
                admin: false
            },
            lastShiftData: {},
            creditData: [],
            productDetail: [],
            shiftDetail: null,
            tankDetail: [],
            showRightPannel: false,
            showCurrencyForm: false,
            searchMode: false,

            gotCreditData: false,
            gotTankData: false

        };
        _this4.hideSpinner = _this4.hideSpinner.bind(_this4);
        _this4.showSpinner = _this4.showSpinner.bind(_this4);
        _this4.createInvoiceCancel = _this4.createInvoiceCancel.bind(_this4);
        _this4.questionBox = null;
        _this4.messageBox = null;
        _this4.onCreated = _this4.onCreated.bind(_this4);
        _this4.onFailed = _this4.onFailed.bind(_this4);
        _this4.onNotificationFetched = _this4.onNotificationFetched.bind(_this4);
        _this4.seleteLink = _this4.seleteLink.bind(_this4);
        _this4.handleSearch = _this4.handleSearch.bind(_this4);
        _this4.currencyFormReset = false;
        _this4.user = __WEBPACK_IMPORTED_MODULE_33__store_auth_store__["a" /* default */].getToken().user;
        _this4.styles = {
            menuHeader: {
                margin: "0 0 0 -15px",
                color: "#23b9fd",
                fontSize: "16px"
            }
        };
        return _this4;
    }

    _createClass(Header, [{
        key: "showSpinner",
        value: function showSpinner() {
            this.setState({ spinner: true });
        }
    }, {
        key: "hideSpinner",
        value: function hideSpinner() {
            this.setState({ spinner: false });
        }
    }, {
        key: "cancelAllCards",
        value: function cancelAllCards() {
            this.adminNotification = null;
            this.userCard = null;
            this.stockIn = null;
        }
    }, {
        key: "handleCreateInvoive",
        value: function handleCreateInvoive() {
            this.createInvoice = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__fragments_create_invoice__["a" /* default */], {
                hide: this.createInvoiceCancel,
                showSpinner: this.showSpinner,
                hideSpinner: this.hideSpinner
            });
            this.forceUpdate();
        }
    }, {
        key: "cancelAdminNotification",
        value: function cancelAdminNotification() {
            this.adminNotification = null;
            this.forceUpdate();
        }
    }, {
        key: "handleAdminNotification",
        value: function handleAdminNotification() {
            __WEBPACK_IMPORTED_MODULE_22__actions_notification_action__["a" /* getAllNotification */]();
            if (this.adminNotification) {
                this.adminNotification = null;
            } else {
                this.cancelAllCards();
                this.adminNotification = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__fragments_admin_notifaction__["a" /* default */], { hide: this.cancelAdminNotification.bind(this) });
            }
            this.forceUpdate();
        }
    }, {
        key: "createInvoiceCancel",
        value: function createInvoiceCancel() {
            this.createInvoice = null;
            this.forceUpdate();
        }
    }, {
        key: "handleUserCard",
        value: function handleUserCard() {
            if (this.userCard) {
                this.userCard = null;
            } else {
                this.cancelAllCards();
                this.userCard = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__fragments_user_card__["a" /* default */], null);
            }

            this.forceUpdate();
        }
    }, {
        key: "onCreated",
        value: function onCreated(msg) {
            this.messageBox = __WEBPACK_IMPORTED_MODULE_15__utility_message_box__["a" /* default */].showMessage(msg, true, this);
            this.hideSpinner();
            this.createInvoiceCancel();
        }
    }, {
        key: "onFailed",
        value: function onFailed(msg) {
            this.messageBox = __WEBPACK_IMPORTED_MODULE_15__utility_message_box__["a" /* default */].showMessage(msg, false, this);
            this.hideSpinner();
            this.setState(this.state);
        }
    }, {
        key: "onNotificationFetched",
        value: function onNotificationFetched() {
            this.forceUpdate();
        }
    }, {
        key: "onMouseEnter",
        value: function onMouseEnter(subMenuName) {
            this.adminNotification = null;
            //hiding the notifiaction box        
            this.setState({ submenus: _defineProperty({}, subMenuName, true) });
        }
    }, {
        key: "onMouseLeave",
        value: function onMouseLeave(subMenuName) {
            this.setState({ submenus: _defineProperty({}, subMenuName, false) });
        }
    }, {
        key: "toggleSubmenu",
        value: function toggleSubmenu(subMenuName) {
            this.setState({ submenus: _defineProperty({}, subMenuName, !this.state.submenus[subMenuName]) });
        }
    }, {
        key: "hideSubMenu",
        value: function hideSubMenu(subMenuName) {
            this.setState({ submenus: _defineProperty({}, subMenuName, false) });
        }
    }, {
        key: "seleteLink",
        value: function seleteLink(linkData) {
            if (linkData) {
                __WEBPACK_IMPORTED_MODULE_2_react_router__["browserHistory"].push(linkData.linkAddress);
                this.searchBox.value = "";
            }
        }
    }, {
        key: "askQuestion",
        value: function askQuestion(msg, yesCallBack, noCallBack) {
            this.questionBox = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__utility_question_box__["a" /* default */], { questionMsg: msg, yesCallBack: yesCallBack, noCallBack: noCallBack });
            this.setState(this.state);
        }
    }, {
        key: "handleUndoShift",
        value: function handleUndoShift() {
            var _this5 = this;

            this.askQuestion("Do you watnt to undo last shift   ?", function () {
                __WEBPACK_IMPORTED_MODULE_31__utility_rq_js__["a" /* default */].getJsonData("/api/v1/mis/undo-last-shift").then(function () {
                    _this5.messageBox = __WEBPACK_IMPORTED_MODULE_15__utility_message_box__["a" /* default */].showMessage("last shift is undo successfully", true, _this5);
                    _this5.forceUpdate();
                }).catch(function (err) {
                    if (err.msg) {
                        _this5.messageBox = __WEBPACK_IMPORTED_MODULE_15__utility_message_box__["a" /* default */].showMessage(err.msg, false, _this5);
                        _this5.forceUpdate();
                    } else throw err;
                });
                _this5.questionBox = null;
                _this5.forceUpdate();
            }, function () {

                _this5.questionBox = null;
                _this5.forceUpdate();
            });
        }
    }, {
        key: "handleSearch",
        value: function handleSearch() {
            this.searchBox.focus();
            this.setState({ searchMode: !this.state.searchMode });
        }
    }, {
        key: "onSearchMouseLeave",
        value: function onSearchMouseLeave() {
            this.setState({ searchMode: false });
        }
    }, {
        key: "componentWillMount",
        value: function componentWillMount() {
            // fetching all necessary stores here  instead of home
            __WEBPACK_IMPORTED_MODULE_18__actions_product_action__["b" /* fetchAllProduct */]();
            __WEBPACK_IMPORTED_MODULE_19__actions_tank_action__["b" /* fetchAllTanks */]();
            __WEBPACK_IMPORTED_MODULE_19__actions_tank_action__["c" /* fetchAllDipTable */]();
            __WEBPACK_IMPORTED_MODULE_20__actions_mpd_action__["c" /* fetchAllMpd */]();
            __WEBPACK_IMPORTED_MODULE_20__actions_mpd_action__["a" /* fetchAllMpdsWithProduct */]();
            __WEBPACK_IMPORTED_MODULE_21__actions_shift_action__["c" /* fetchAllShift */]();
            __WEBPACK_IMPORTED_MODULE_22__actions_notification_action__["a" /* getAllNotification */]();
            __WEBPACK_IMPORTED_MODULE_24__actions_expenditure_catagory_action__["b" /* fetchAllExCat */]();
            __WEBPACK_IMPORTED_MODULE_25__actions_transaction_account_action__["c" /* fetchAllTrAccount */]();
            __WEBPACK_IMPORTED_MODULE_25__actions_transaction_account_action__["a" /* fetchAllTrAccountPayMode */]();
            __WEBPACK_IMPORTED_MODULE_26__actions_swipe_machine_action__["b" /* fetchAllSwipes */]();
            __WEBPACK_IMPORTED_MODULE_28__actions_payment_mode_action__["b" /* fetchAllPaymentMode */]();

            __WEBPACK_IMPORTED_MODULE_7__store_invoice_store__["a" /* default */].on(__WEBPACK_IMPORTED_MODULE_14__constants_constants__["q" /* invoiceConstant */].INVOICE_CREATED, this.onCreated);
            __WEBPACK_IMPORTED_MODULE_7__store_invoice_store__["a" /* default */].on(__WEBPACK_IMPORTED_MODULE_14__constants_constants__["q" /* invoiceConstant */].INVOICE_CREATION_FAILED, this.onFailed);
            __WEBPACK_IMPORTED_MODULE_23__store_notification_store__["a" /* default */].on(__WEBPACK_IMPORTED_MODULE_14__constants_constants__["p" /* notificationConstant */].FETCHED_ALL_NOTIFICATION, this.onNotificationFetched);
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            __WEBPACK_IMPORTED_MODULE_7__store_invoice_store__["a" /* default */].removeListener(__WEBPACK_IMPORTED_MODULE_14__constants_constants__["q" /* invoiceConstant */].INVOCE_CREATED, this.onCreated);
            __WEBPACK_IMPORTED_MODULE_7__store_invoice_store__["a" /* default */].removeListener(__WEBPACK_IMPORTED_MODULE_14__constants_constants__["q" /* invoiceConstant */].INVOICE_CREATION_FAILED, this.onFailed);
            __WEBPACK_IMPORTED_MODULE_23__store_notification_store__["a" /* default */].removeListener(__WEBPACK_IMPORTED_MODULE_14__constants_constants__["p" /* notificationConstant */].FETCHED_ALL_NOTIFICATION, this.onNotificationFetched);
            //removeListener
        }
    }, {
        key: "render",
        value: function render() {
            var _this6 = this;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                null,
                this.createInvoice,
                this.messageBox,
                this.questionBox,
                this.state.spinner ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__utility_spinner__["a" /* default */], null) : null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { id: "headerBar" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { className: "leftMenuBar" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "ul",
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "li",
                                null,
                                " "
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "li",
                                { onMouseEnter: this.onMouseEnter.bind(this, "cash"), onClick: this.toggleSubmenu.bind(this, "swipe"), onMouseLeave: this.onMouseLeave.bind(this, "swipe") },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "i",
                                    { className: "IconName", "aria-hidden": "true", title: "Cash" },
                                    "SWIPE"
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_27_react_motion__["Motion"],
                                    { defaultStyle: { x: 0 }, style: { x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27_react_motion__["spring"])(this.state.submenus.cash ? 1 : 0, { stiffness: 150, damping: 15, precision: 1 }) } },
                                    function (_ref) {
                                        var x = _ref.x;

                                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "div",
                                            { className: "menuHolder",
                                                style: {
                                                    width: "850px",
                                                    height: x * 200 + "px",
                                                    opacity: "" + x

                                                } },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                "div",
                                                { style: { display: "flex", flex: 1 } },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    "ul",
                                                    { className: "submenu" },
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "swipe") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/report/swipe-ungrouped" },
                                                            "Swipe UnGroup report",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "swipe") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/report/swipe-grouped" },
                                                            "Swipe Group report",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    )
                                                )
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { height: "20px", background: "#23b9fd", alignSelf: "bottom", margin: "0 -20px" } })
                                        );
                                    }
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "li",
                                { onMouseEnter: this.onMouseEnter.bind(this, "employee"), onClick: this.toggleSubmenu.bind(this, "employee"), onMouseLeave: this.onMouseLeave.bind(this, "employee") },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "i",
                                    { className: "IconName", "aria-hidden": "true", title: "Employees" },
                                    "EMPLOYEE"
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_27_react_motion__["Motion"],
                                    { defaultStyle: { x: 0 }, style: { x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27_react_motion__["spring"])(this.state.submenus.employee ? 1 : 0, { stiffness: 150, damping: 15, precision: 1 }) } },
                                    function (_ref2) {
                                        var x = _ref2.x;


                                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "div",
                                            { className: "menuHolder", style: {
                                                    width: "850px",
                                                    height: x * 300 + "px",
                                                    opacity: "" + x

                                                } },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                "div",
                                                { style: { display: "flex", flex: 1 } },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    "ul",
                                                    { className: "submenu" },
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "p",
                                                        { style: _this6.styles.menuHeader },
                                                        " New"
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "employee") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/page/create-employee" },
                                                            "Create new e   mployee",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "employee") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/page/employee-advance" },
                                                            "Make Advance Payment",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "employee") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/report/salary-payment-by-date" },
                                                            "Salary Payment by Date",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "p",
                                                        { style: _this6.styles.menuHeader },
                                                        "Edit"
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "employee") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/edit-page/employee" },
                                                            "Employee Edit",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    )
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    "ul",
                                                    { className: "submenu" },
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "p",
                                                        { style: _this6.styles.menuHeader },
                                                        "Report"
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "employee") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/report/employee-advance-between-two-day" },
                                                            "Employee Advance between two day",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "employee") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/report/current-shift-employee-advance" },
                                                            "Current Shift Employee Advance",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "employee") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/report/employee-attendance-shortage" },
                                                            "Employee Attendance Shortage Report",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "employee") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/report/employee-salary-detail" },
                                                            "Employee Salary Report",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    )
                                                )
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { height: "20px", background: "#23b9fd", alignSelf: "bottom", margin: "0 -20px" } })
                                        );
                                    }
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "li",
                                { onMouseEnter: this.onMouseEnter.bind(this, "creditor"), onClick: this.toggleSubmenu.bind(this, "creditor"), onMouseLeave: this.onMouseLeave.bind(this, "creditor") },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "i",
                                    { className: "IconName", "aria-hidden": "true", title: "Creditor" },
                                    "CREDIT"
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_27_react_motion__["Motion"],
                                    { defaultStyle: { x: 0 }, style: { x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27_react_motion__["spring"])(this.state.submenus.creditor ? 1 : 0, { stiffness: 150, damping: 15, precision: 1 }) } },
                                    function (_ref3) {
                                        var x = _ref3.x;

                                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "div",
                                            { className: "menuHolder",
                                                style: {
                                                    width: "880px",
                                                    height: x * 500 + "px",
                                                    opacity: "" + x

                                                } },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                "div",
                                                { style: { display: "flex", flex: 1 } },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    "ul",
                                                    { className: "submenu" },
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "p",
                                                        { style: _this6.styles.menuHeader },
                                                        " New"
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "creditor") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/page/create-creditor" },
                                                            "Create new Creditor",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "creditor") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/page/credit-entry" },
                                                            "Credit Entry",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "creditor") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/page/creditor-payment-entry" },
                                                            "Credit Payment Entry",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "p",
                                                        { style: _this6.styles.menuHeader },
                                                        "Edit"
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "creditor") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/edit-page/creditor" },
                                                            "Creditor Edit",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "p",
                                                        { style: _this6.styles.menuHeader },
                                                        "Credit  Payment Report"
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "creditor") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/report/credit-payment-between-two-day" },
                                                            "Credit Payment Between Two dates",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "creditor") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/report/credit-payment-by-credit-id" },
                                                            "Credit Payment Report by Creditor",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    )
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    "ul",
                                                    { className: "submenu" },
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "p",
                                                        { style: _this6.styles.menuHeader },
                                                        "Current Shift Report "
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "creditor") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/report/current-shift-detail-credit-report" },
                                                            "Current Shift Credit Report",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "p",
                                                        { style: _this6.styles.menuHeader },
                                                        "Billed Report"
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "creditor") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/report/credit-report-unbilled" },
                                                            "Credit Unbilled Report of  all parties",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "creditor") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/report/credit-report-billed" },
                                                            "Credit Billed Report of  all parties",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "creditor") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/report/credit-report-billed-by-id" },
                                                            "Credit Billed Report by Creditor",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "p",
                                                        { style: _this6.styles.menuHeader },
                                                        "Small Creditor"
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "creditor") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/report/small-creditor-account-statement" },
                                                            "Small Creditor Account statement",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "creditor") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/report/all-small-creditor-statement" },
                                                            "All small creditor statement",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "creditor") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/report/all-small-creditor-report-between-two-dates" },
                                                            "All small creditor report between two dates",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    )
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    "ul",
                                                    { className: "submenu" },
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "p",
                                                        { style: _this6.styles.menuHeader },
                                                        "Credit Report"
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "creditor") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/report/credit-detail-between-two-day" },
                                                            "Credit Between Two Dates",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "creditor") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/report/credit-account-details" },
                                                            "Credit Account Details by Croditor",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "creditor") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/report/showall-creditors" },
                                                            "Show All Creditors",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    )
                                                )
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { height: "20px", background: "#23b9fd", alignSelf: "bottom", margin: "0 -20px" } })
                                        );
                                    }
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "li",
                                { onMouseEnter: this.onMouseEnter.bind(this, "product"), onClick: this.toggleSubmenu.bind(this, "product"), onMouseLeave: this.onMouseLeave.bind(this, "product") },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "i",
                                    { className: "IconName", "aria-hidden": "true", title: "product" },
                                    "PRODUCT"
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_27_react_motion__["Motion"],
                                    { defaultStyle: { x: 0 }, style: { x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27_react_motion__["spring"])(this.state.submenus.product ? 1 : 0, { stiffness: 150, damping: 15, precision: 1 }) } },
                                    function (_ref4) {
                                        var x = _ref4.x;

                                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "div",
                                            { className: "menuHolder",
                                                style: {
                                                    width: "850px",
                                                    height: x * 350 + "px",
                                                    opacity: "" + x

                                                } },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                "div",
                                                { style: { display: "flex", flex: 1 } },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    "ul",
                                                    { className: "submenu" },
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "p",
                                                        { style: _this6.styles.menuHeader },
                                                        "Sell Report"
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "product") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/report/sell" },
                                                            "Date wise sell Report",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "product") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/report/sell-day" },
                                                            "Date wise sell Report (product)",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "product") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/report/reading-report" },
                                                            "Reading Report (Per Day)",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "p",
                                                        { style: _this6.styles.menuHeader },
                                                        "Product"
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "product") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/report/product-rate-between-two-day" },
                                                            "Product rate Report  Between Two Day",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    )
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    "ul",
                                                    { className: "submenu" },
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "p",
                                                        { style: _this6.styles.menuHeader },
                                                        "Invoice"
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "product") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            "a",
                                                            { onClick: _this6.handleCreateInvoive.bind(_this6) },
                                                            "Create Invoice",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "p",
                                                        { style: _this6.styles.menuHeader },
                                                        "Invoice Report "
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "product") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/report/invoice-report-between-two-day" },
                                                            "Invoice report  Between Two Day",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "product") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/report/invoice-shortage-report-between-two-day" },
                                                            "Invoice Shortage report  Between Two Day",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    )
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    "ul",
                                                    { className: "submenu" },
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "p",
                                                        { style: _this6.styles.menuHeader },
                                                        "Dsr"
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "product") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/page/last-inspection-entry" },
                                                            "Last Inspection Entry",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "product") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/report/dsr" },
                                                            "Dsr Report",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "product") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/page/instant-cash-memo" },
                                                            "Instant Cash Memo",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    )
                                                )
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { height: "20px", background: "#23b9fd", alignSelf: "bottom", margin: "0 -20px" } })
                                        );
                                    }
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "li",
                                { onMouseEnter: this.onMouseEnter.bind(this, "expenditure"), onClick: this.toggleSubmenu.bind(this, "expenditure"), onMouseLeave: this.onMouseLeave.bind(this, "expenditure") },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "i",
                                    { className: "IconName", "aria-hidden": "true", title: "expenditure" },
                                    "EXPENDITURE"
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_27_react_motion__["Motion"],
                                    { defaultStyle: { x: 0 }, style: { x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27_react_motion__["spring"])(this.state.submenus.expenditure ? 1 : 0, { stiffness: 150, damping: 15, precision: 1 }) } },
                                    function (_ref5) {
                                        var x = _ref5.x;

                                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "div",
                                            { className: "menuHolder",
                                                style: {
                                                    width: "850px",
                                                    height: x * 230 + "px",
                                                    opacity: "" + x

                                                } },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                "div",
                                                { style: { display: "flex", flex: 1 } },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    "ul",
                                                    { className: "submenu" },
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "p",
                                                        { style: _this6.styles.menuHeader },
                                                        " New"
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "expenditure") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/page/expenditure-detail" },
                                                            "Expenditure Entry",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    )
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    "ul",
                                                    { className: "submenu" },
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "p",
                                                        { style: _this6.styles.menuHeader },
                                                        "Report"
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "expenditure") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/report/current-shift-expenditure" },
                                                            "Current Shift Expenditure  Report",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "expenditure") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/report/expenditure-between-two-day" },
                                                            "Expenditure Between two day",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "expenditure") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/report/expenditure-between-two-day-with-aggreagation" },
                                                            "Expenditure Between two day (grouped)",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    )
                                                )
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { height: "20px", background: "#23b9fd", alignSelf: "bottom", margin: "0 -20px" } })
                                        );
                                    }
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "li",
                                { onMouseEnter: this.onMouseEnter.bind(this, "shift"), onClick: this.toggleSubmenu.bind(this, "shift"), onMouseLeave: this.onMouseLeave.bind(this, "shift") },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "i",
                                    { className: "IconName", "aria-hidden": "true", title: "shift" },
                                    "SHIFT"
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_27_react_motion__["Motion"],
                                    { defaultStyle: { x: 0 }, style: { x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27_react_motion__["spring"])(this.state.submenus.shift ? 1 : 0, { stiffness: 150, damping: 15, precision: 1 }) } },
                                    function (_ref6) {
                                        var x = _ref6.x;

                                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "div",
                                            { className: "menuHolder",
                                                style: {
                                                    width: "850px",
                                                    height: x * 350 + "px",
                                                    opacity: "" + x

                                                } },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                "div",
                                                { style: { display: "flex", flex: 1 } },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    "ul",
                                                    { className: "submenu" },
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "p",
                                                        { style: _this6.styles.menuHeader },
                                                        " New"
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "shift") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/page/start-shift" },
                                                            "Start New Shift",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "shift") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/closeshift" },
                                                            "Close Shift",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "shift") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/page/employee-cash-collection" },
                                                            "Cash  Collect",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "shift") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/page/exchange" },
                                                            "Exchange  Entry",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "shift") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/page/stock-in" },
                                                            "Create Stock In",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    )
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    "ul",
                                                    { className: "submenu" },
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "p",
                                                        { style: _this6.styles.menuHeader },
                                                        "Report"
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "shift") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/report/current-shift-cash-transaction" },
                                                            "Current Shift Cash Transaction",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "shift") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/report/close-shift-report-between-two-day" },
                                                            "Close Shift Report between two Day",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "cash") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/report/current-shift-cash-collection" },
                                                            "Current Shift Cash Collection",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    )
                                                )
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { height: "20px", background: "#23b9fd", alignSelf: "bottom", margin: "0 -20px" } })
                                        );
                                    }
                                )
                            ),
                            this.user.isAdmin ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "li",
                                { onMouseEnter: this.onMouseEnter.bind(this, "admin"), onClick: this.toggleSubmenu.bind(this, "admin"), onMouseLeave: this.onMouseLeave.bind(this, "admin") },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "i",
                                    { className: "IconName", "aria-hidden": "true", title: "admin" },
                                    "ADMIN"
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_27_react_motion__["Motion"],
                                    { defaultStyle: { x: 0 }, style: { x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27_react_motion__["spring"])(this.state.submenus.admin ? 1 : 0, { stiffness: 150, damping: 15, precision: 1 }) } },
                                    function (_ref7) {
                                        var x = _ref7.x;

                                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "div",
                                            { className: "menuHolder",
                                                style: {
                                                    width: "850px",
                                                    height: x * 430 + "px",
                                                    opacity: "" + x

                                                } },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                "div",
                                                { style: { display: "flex", flex: 1 } },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    "ul",
                                                    { className: "submenu" },
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "admin") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/page/create-tank" },
                                                            "Create new Tank",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "admin") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/page/create-mpd" },
                                                            "Create new Mpd",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "admin") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/page/create-nozzel" },
                                                            "Create new Nozzel",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "admin") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/page/create-product" },
                                                            "Create new Product",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "admin") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/page/create-shift" },
                                                            "Create new Shift",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "admin") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/page/product-rate" },
                                                            "Create rate",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "admin") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/page/create-currency" },
                                                            "Create new currency",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    )
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    "ul",
                                                    { className: "submenu" },
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "admin") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/page/create-swipe" },
                                                            "Create new Swipe Machines",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "admin") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/page/create-expenditure" },
                                                            "Create new Expenditure",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "admin") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/page/create-transaction-account" },
                                                            "Create Transaction Account",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "admin") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/page/create-paymode" },
                                                            "Create new Payment Mode",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "admin") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/page/create-link-tr-paymode" },
                                                            "TransactionAccount  link  to Payment Mode",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "admin") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/page/create-user" },
                                                            "Create User",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "admin") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/page/send-msg" },
                                                            "Send Message",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "admin") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/page/msg-subscription" },
                                                            "Message Subscription",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "admin") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/report/msg-subscription-report" },
                                                            "Message Subscription",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    )
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    "ul",
                                                    { className: "submenu" },
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "p",
                                                        { style: _this6.styles.menuHeader },
                                                        "Edit"
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "admin") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/page/user-edit" },
                                                            "Edit User",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "admin") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/page/mpd-nozzel-edit" },
                                                            "Edit MPd-Nozzel",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "admin") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/report/employee-pay-rate" },
                                                            "UpDate Employee pay Rate",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "p",
                                                        { style: _this6.styles.menuHeader },
                                                        "Report"
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "admin") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/report/get-interest-report" },
                                                            "Intrest Report",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "p",
                                                        { style: _this6.styles.menuHeader },
                                                        "Shift"
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "admin") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            "a",
                                                            { onClick: _this6.handleUndoShift.bind(_this6) },
                                                            "Undo Shift",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        "li",
                                                        { onClick: _this6.hideSubMenu.bind(_this6, "admin") },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
                                                            { to: "/page/backward-stockin" },
                                                            "BackWard StockIn",
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "line" })
                                                        )
                                                    )
                                                )
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { height: "20px", background: "#23b9fd", alignSelf: "bottom", margin: "0 -20px" } })
                                        );
                                    }
                                )
                            ) : null
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { className: "rightMenuBar" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "div",
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "ul",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "li",
                                    { onBlur: this.onSearchMouseLeave.bind(this) },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-search", style: { Zindex: 1, fontSize: "20px", color: "white", marginTop: "8px" }, onClick: this.handleSearch, "aria-hidden": "true" }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "div",
                                        { className: "searchBar", style: { display: "inline-block", marginTop: "9px" } },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__utility_auto_complete__["a" /* default */], {
                                            "class": "mainSearch",
                                            placeholder: "Search",
                                            dataSrc: this.state.allLinks,
                                            dataTobind: "linkName",
                                            keyToBind: "linkAddress",
                                            onSelect: this.seleteLink,
                                            tabIndex: "1",
                                            clearStyle: { display: "none", top: "5px", color: "white", fontSize: "14px" },
                                            listStyle: { fontSize: "16px" },
                                            inputStyle: { marginLeft: "20px", textTransform: "lowercase", fontSize: "16px", background: " rgb(35, 185, 253)", transition: "width 0.3s ease-in", transformOrigin: "center right", border: "none", padding: "0px", outline: "none", borderBottom: "2px solid #4291b5", borderRadius: "0", width: this.state.searchMode ? "300px" : "0" },
                                            rex: function rex(searchBox) {
                                                _this6.searchBox = searchBox;
                                                //this.searchBox.onfocus = this.onSelectEmployeeFocus.bind(this);
                                            }
                                        })
                                    )
                                ),
                                this.user.isAdmin ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "li",
                                    { onClick: this.handleAdminNotification.bind(this) },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "i",
                                        { className: "fa fa-bell-o barIcon", "aria-hidden": "true" },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "span",
                                            { className: "notificationNo" },
                                            __WEBPACK_IMPORTED_MODULE_23__store_notification_store__["a" /* default */].getNoOfNotification()
                                        )
                                    )
                                ) : null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "li",
                                    { onClick: this.handleUserCard.bind(this) },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-user barIcon", "aria-hidden": "true", title: "Logout" })
                                )
                            )
                        )
                    ),
                    this.userCard,
                    this.stockIn,
                    this.adminNotification
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__utility_net_detect__["a" /* default */], null)
            );
        }
    }]);

    return Header;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Master1);

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_fragments_employee_shortage__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utility_auto_complete__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fragments_currency_entry__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_utility_message_box__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utility_question_box__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utility_util_methods__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utility_rq_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_tank_store__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_immutability_helper__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_immutability_helper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_immutability_helper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utility_spinner__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_router__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_router__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


//import Spinner from "../../components/utility/spinner";














var CloseShift = function (_React$Component) {
  _inherits(CloseShift, _React$Component);

  function CloseShift() {
    _classCallCheck(this, CloseShift);

    var _this = _possibleConstructorReturn(this, (CloseShift.__proto__ || Object.getPrototypeOf(CloseShift)).call(this));

    _this.handleComment = function (e) {
      var comment = e.target.value;
      _this.setState({ comment: comment });
    };

    _this.state = {
      isAtg: true,
      showSpinner: false,
      currentShift: null,
      tankList: __WEBPACK_IMPORTED_MODULE_8__store_tank_store__["a" /* default */].getAll(),
      mpds: {},
      products: {},
      credits: {},
      showShortageForm: true,
      showCurrencyForm: false,
      currencyFormReset: false,
      showCloseShiftBtn: false,
      comment: null
    };

    _this.messageBox = null;
    _this.questionBox = null;
    _this.handleTankStoreChange = _this.handleTankStoreChange.bind(_this);
    return _this;
  }

  _createClass(CloseShift, [{
    key: "setConsumption",
    value: function setConsumption(nozzel) {
      nozzel.consumption = parseFloat((nozzel.closeReading - nozzel.openReading - nozzel.testing).toFixed(3));
      // console.log(nozzel);
      //console.log(nozzel.consumption);
    }
  }, {
    key: "calculateTotal",
    value: function calculateTotal(mpdId, productName) {
      var _this2 = this;

      this.state.mpds[mpdId].products[productName].totalQuantity = 0;
      this.state.mpds[mpdId].products[productName].totalPrice = 0;

      this.state.mpds[mpdId].nozzels.forEach(function (nozzel) {
        if (nozzel.productName === productName) {
          _this2.state.mpds[mpdId].products[productName].totalQuantity += parseFloat(((nozzel.closeReading || nozzel.openReading) - nozzel.openReading - nozzel.testing).toFixed(3));
          //console.log("total quantity ", nozzel, this.state.mpds[mpdId].products[productName].totalQuantity);
          _this2.state.mpds[mpdId].products[productName].totalPrice += parseFloat((((nozzel.closeReading || nozzel.openReading) - nozzel.openReading - nozzel.testing) * _this2.state.products[nozzel.productId].sellingPrice).toFixed(2));
          //console.log("total price ", this.state.mpds[mpdId].products[productName].totalPrice);
        }
      });
    }
  }, {
    key: "onCloseReadingKeyUp",
    value: function onCloseReadingKeyUp(mpdId, nozzelIndex, nozelId, e) {
      var closeReading = 0;
      if (e) {
        closeReading = parseFloat(e.target.value);
      }
      if (closeReading >= 0) {
        this.state.mpds[mpdId].nozzels[nozzelIndex].closeReading = closeReading;
        this.setConsumption(this.state.mpds[mpdId].nozzels[nozzelIndex]);
        this.calculateTotal(mpdId, this.state.mpds[mpdId].nozzels[nozzelIndex].productName);
        //console.log(this.state.mpds);
      } else {
        this.state.mpds[mpdId].nozzels[nozzelIndex].closeReading = 0;
        //this.setState(this.state);
      }

      this.setState(this.state);
      // if (ok) {
      //     this.setState(this.state);
      // }
    }
  }, {
    key: "onTesting",
    value: function onTesting(mpdId, nozzelIndex, e) {
      //console.log(e.target.value, isNaN(e.target.value));
      if (parseFloat(e.target.value)) {
        //console.log(e.target.value);
        this.state.mpds[mpdId].nozzels[nozzelIndex].testing = parseFloat(e.target.value);
        this.setConsumption(this.state.mpds[mpdId].nozzels[nozzelIndex]);
        this.calculateTotal(mpdId, this.state.mpds[mpdId].nozzels[nozzelIndex].productName);
        //console.log(this.state.mpds);
        this.setState(this.state);
      } else {
        //console.log("--------");
        this.state.mpds[mpdId].nozzels[nozzelIndex].testing = 0;
        this.setConsumption(this.state.mpds[mpdId].nozzels[nozzelIndex]);
        this.calculateTotal(mpdId, this.state.mpds[mpdId].nozzels[nozzelIndex].productName);
        this.setState(this.state);
      }
    }
  }, {
    key: "reset",
    value: function reset(mpdId) {
      this.state.mpds[mpdId].lastCashCollection = {};
      this.state.mpds[mpdId].resetEmployeeAuto = true;
      this.state.mpds[mpdId].employeeShortageList = [];
      this.state.mpds[mpdId].shortageAmount = 0;
      //console.log("reset...", this.state.mpds[mpdId]);
    }
  }, {
    key: "calculateTotalSwpipe",
    value: function calculateTotalSwpipe(mpdId) {
      var totalAmount = 0;

      this.state.mpds[mpdId].swipeMachines.forEach(function (swipeMachine) {
        totalAmount += swipeMachine.amount ? swipeMachine.amount : 0;
      });
      return totalAmount;
    }
  }, {
    key: "updateSwipeAmount",
    value: function updateSwipeAmount(index, mpdId, e) {
      //console.log(this.state.mpds[mpdId]);
      this.reset(mpdId);
      var swipeAmount = parseFloat(e.target.value) ? parseFloat(e.target.value) : 0;
      this.state.mpds[mpdId].swipeMachines[index].amount = swipeAmount;
      this.setState(this.state);
    }
  }, {
    key: "handleTankStoreChange",
    value: function handleTankStoreChange() {
      this.setState({ tankList: __WEBPACK_IMPORTED_MODULE_8__store_tank_store__["a" /* default */].getAll() });
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this3 = this;

      this.questionBox = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__utility_question_box__["a" /* default */], {
        questionMsg: "Have you entered all expenditure and stock in data ?",
        yesCallBack: function yesCallBack() {
          _this3.questionBox = null;
          _this3.setState({});
        },
        noCallBack: function noCallBack() {
          __WEBPACK_IMPORTED_MODULE_12_react_router__["browserHistory"].push("/");
        }
      });
      __WEBPACK_IMPORTED_MODULE_8__store_tank_store__["a" /* default */].on(__WEBPACK_IMPORTED_MODULE_9__constants_constants__["k" /* tankConstant */].TANK_STORE_CHANGE, this.handleTankStoreChange);
      this.makeAjax("/api/v1/shiftdetail", function (data) {
        _this3.state.currentShift = data[0];
        // console.log("fetched current shift");
        _this3.setState(_this3.state);
      }, function () {
        alert("getting shift detail failed");
      });

      this.makeAjax("/api/v1/closeshiftdata", function (data) {
        data[0].forEach(function (nozzel) {
          nozzel.testing = 0;
          nozzel.consumption = 0;
          if (!_this3.state.mpds[nozzel.mpdId]) {
            _this3.state.mpds[nozzel.mpdId] = {
              mpdName: nozzel.mpdName,
              nozzels: [],
              products: {},
              lastCashCollection: {}
            };
            _this3.state.mpds[nozzel.mpdId].products[nozzel.productName] = {
              totalQuantity: 0,
              totalPrice: 0
            };

            _this3.state.mpds[nozzel.mpdId].nozzels.push(nozzel);
          } else {
            _this3.state.mpds[nozzel.mpdId].products[nozzel.productName] = {
              totalQuantity: 0,
              totalPrice: 0
            };

            _this3.state.mpds[nozzel.mpdId].nozzels.push(nozzel);
          }
        });

        data[1].forEach(function (product) {
          _this3.state.products[product.productId] = product;
        });

        data[2].forEach(function (creditData) {
          if (!_this3.state.credits[creditData.mpdId]) {
            _this3.state.credits[creditData.mpdId] = {};
            _this3.state.credits[creditData.mpdId][creditData.productName] = creditData;
          } else {
            _this3.state.credits[creditData.mpdId][creditData.productName] = creditData;
          }
        });

        data[3].forEach(function (cashCollection) {
          _this3.state.mpds[cashCollection.mpdId].cashCollection = cashCollection;
        });

        // this.state.swipeData = data[4];
        // ading swipemachines to each mpds
        Object.keys(_this3.state.mpds).forEach(function (mpdId) {
          _this3.state.mpds[mpdId].swipeMachines = JSON.parse(JSON.stringify(data[4]));
          _this3.state.mpds[mpdId].employeeShortageList = [];
        });

        //window.pp = this.state;
        //console.log(this.state);
        // console.log("fetched all data");
        _this3.state.showCloseShiftBtn = true;
        //this.setState(this.state);
        _this3.getTempData();
      }, function () {
        _this3.messageBox = __WEBPACK_IMPORTED_MODULE_4__components_utility_message_box__["a" /* default */].showMessage("No shift is running !!!", false, _this3);
        _this3.forceUpdate();
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      __WEBPACK_IMPORTED_MODULE_8__store_tank_store__["a" /* default */].removeListener(__WEBPACK_IMPORTED_MODULE_9__constants_constants__["k" /* tankConstant */].TANK_STORE_CHANGE, this.handleTankStoreChange);
    }
  }, {
    key: "getProductBackground",
    value: function getProductBackground(productName) {
      var backgroundColor = "";
      switch (productName) {
        case "HS":
          backgroundColor = "#046c9e";
          break;
        case "MS":
          backgroundColor = "#5f7929";
          break;
        default:
          break;
      }
      return backgroundColor;
    }
  }, {
    key: "onShortageSave",
    value: function onShortageSave(mpdId, epmloyeeShortage) {
      // console.log(epmloyeeShortage);
      this.state.mpds[mpdId].employeeShortageList = epmloyeeShortage;
      this.state.mpds[mpdId].showShortageForm = false;
      this.setState(this.state);
    }
  }, {
    key: "onShortageCancle",
    value: function onShortageCancle(mpdId) {
      // console.log("........",mpdId);
      this.state.mpds[mpdId].showShortageForm = false;
      this.setState(this.state);
    }
  }, {
    key: "onEmployeeSelect",
    value: function onEmployeeSelect(mpdId, employee) {
      if (employee) {
        this.state.mpds[mpdId].lastCashCollection.employeeId = employee.employeeId;
        this.state.mpds[mpdId].lastCashCollection.employeeName = employee.employeeName;
      }
    }
  }, {
    key: "onCurrencySave",
    value: function onCurrencySave(mpdId, currencyData, cashInTotal, cashOutTotal) {
      var netCashIn = cashInTotal - cashOutTotal;
      if (netCashIn >= 0) {
        this.state.mpds[mpdId].lastCashCollection.amount = netCashIn;
        // This is done for deep cloning currencyData
        this.state.mpds[mpdId].lastCashCollection.currencyData = JSON.parse(JSON.stringify(currencyData));

        this.state.mpds[mpdId].lastCashCollection.cashInTotal = cashInTotal;
        this.state.mpds[mpdId].lastCashCollection.cashOutTotal = cashOutTotal;

        var amountTobeCollected = this.getTotalCashTobeCollected.bind(this, mpdId)();
        if (amountTobeCollected - netCashIn > 10) {
          this.state.mpds[mpdId].shortageAmount = parseInt(amountTobeCollected - netCashIn, 10);
          this.state.mpds[mpdId].showShortageForm = true;
        }
        this.state.mpds[mpdId].showCurrencyForm = false;
      } else {
        this.messageBox = __WEBPACK_IMPORTED_MODULE_4__components_utility_message_box__["a" /* default */].showMessage("Total amount should be positive !", false, this);
      }
      this.setState(this.state);
    }
  }, {
    key: "onCurrencyCancel",
    value: function onCurrencyCancel(mpdId) {
      this.state.mpds[mpdId].showCurrencyForm = false;
      this.setState(this.state);
    }
  }, {
    key: "onAmountClicked",
    value: function onAmountClicked(mpdId) {
      this.state.mpds[mpdId].showCurrencyForm = true;
      this.setState(this.state);
    }
  }, {
    key: "onShortageClick",
    value: function onShortageClick(mpdId) {
      //if(this.state.mpds[mpdId])
      this.state.mpds[mpdId].showShortageForm = true;
      this.setState(this.state);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this4 = this;

      Object.keys(this.state.mpds).forEach(function (mpdId) {
        _this4.state.mpds[mpdId].resetEmployeeAuto = false;
      });
      //console.log(">>>>", this.state);
    }
  }, {
    key: "validateCreditData",
    value: function validateCreditData(mpd, mpdId) {
      //console.log(mpd);
      //console.log("state--", this.state);
      var nozzels = Object.keys(mpd.nozzels);
      var productCosumption = {};

      for (var i = 0; i < nozzels.length; i++) {
        var x = productCosumption.hasOwnProperty(mpd.nozzels[i]["productName"]);
        var productName = "";
        if (!x) {
          productName = mpd.nozzels[i]["productName"];
          productCosumption[productName] = mpd.nozzels[i].consumption;
        } else {
          productName = mpd.nozzels[i]["productName"];
          productCosumption[productName] += mpd.nozzels[i].consumption;
        }
      }
      var products = Object.keys(productCosumption);

      for (var k = 0; k < products.length; k++) {
        //console.log("crdet quatity", this.state.credits[mpdId][products[k]].quantity);
        // console.log("consumption ", productCosumption[products[k]]);
        var success = false;
        if (this.state.credits[mpdId][products[k]].quantity <= productCosumption[products[k]]) {
          //console.log("success credit", this.state.credits[mpdId][products[k]].quantity, "consumption", productCosumption[products[k]]);
          success = true;
        } else {
          //console.log("failed credit", this.state.credits[mpdId][products[k]].quantity, "consumption", productCosumption[products[k]]);

          // close shift validation

          this.messageBox = __WEBPACK_IMPORTED_MODULE_4__components_utility_message_box__["a" /* default */].showMessage("Cosumption of " + products[k] + " in  " + mpd.mpdName + " should not be less than credit quantity", false, this);
          success = false;
          //success = true;
          break;
          //success = true;
        }
      }

      return success;
    }
  }, {
    key: "validateTotalSwipe",
    value: function validateTotalSwipe(mpd, mpdId) {
      var TotalSale = parseFloat(this.getTotalSaleinRupees(mpdId));
      var TotalCreditSale = parseFloat(this.getTotalCreditSaleinRupees(mpdId));
      var TotalCashCollection = parseFloat(mpd.cashCollection.cashCollection);
      var TotalSwipe = this.calculateTotalSwpipe(mpdId);
      var success = false;
      if (TotalSwipe <= (TotalSale - TotalCreditSale - TotalCashCollection).toFixed(2)) {
        success = true;
      } else {
        // close shift validation
        this.messageBox = __WEBPACK_IMPORTED_MODULE_4__components_utility_message_box__["a" /* default */].showMessage("Total swipe of " + mpd.mpdName + " must not be greater than (Total sale -Total credit)- total cash", false, this);
        success = false;
        // success = true;
      }
      return success;
    }
  }, {
    key: "validateCashCollected",
    value: function validateCashCollected(mpd, mpdId) {
      var TotalSale = parseFloat(this.getTotalSaleinRupees(mpdId));
      var TotalCreditSale = parseFloat(this.getTotalCreditSaleinRupees(mpdId));
      var TotalCashCollection = mpd.cashCollection.cashCollection;
      var success = false;
      if (TotalCashCollection <= (TotalSale - TotalCreditSale).toFixed(2)) {
        success = true;
      } else {
        // close shift validation
        this.messageBox = __WEBPACK_IMPORTED_MODULE_4__components_utility_message_box__["a" /* default */].showMessage("Total cash collection of " + mpd.mpdName + " must not be greater than (Total sale - Total credit)", false, this);
        success = false;
        //success = true;
      }

      return success;
    }
  }, {
    key: "validateMpdData",
    value: function validateMpdData(mpd) {
      //console.log(mpd);
      /**
       * @param {object} mpd
       * @return {boolean} success or failure
       */

      var nozzels = Object.keys(mpd.nozzels);
      var success = false;
      for (var i = 0; i < nozzels.length; i++) {
        if (mpd.nozzels[i].closeReading >= 0) {
          if (mpd.nozzels[i].closeReading >= mpd.nozzels[i].openReading) {
            if (mpd.nozzels[i].testing >= 0) {
              if (mpd.nozzels[i].testing <= mpd.nozzels[i].closeReading - mpd.nozzels[i].openReading) {
                success = true;
              } else {
                this.messageBox = __WEBPACK_IMPORTED_MODULE_4__components_utility_message_box__["a" /* default */].showMessage("Tesing of " + mpd.nozzels[i].mpdName + " nozzel: " + mpd.nozzels[i].nozelName + "-" + mpd.nozzels[i].productName + " must be less than total consuption", false, this);
                success = false;
                break;
              }
            } else {
              this.messageBox = __WEBPACK_IMPORTED_MODULE_4__components_utility_message_box__["a" /* default */].showMessage("Tesing of " + mpd.nozzels[i].mpdName + " nozzel: " + mpd.nozzels[i].nozelName + "-" + mpd.nozzels[i].productName + " must be greaterthan or equal to 0", false, this);
              success = false;
              break;
            }
          } else {
            this.messageBox = __WEBPACK_IMPORTED_MODULE_4__components_utility_message_box__["a" /* default */].showMessage("Close reading of " + mpd.nozzels[i].mpdName + " nozzel: " + mpd.nozzels[i].nozelName + "-" + mpd.nozzels[i].productName + " must be greater than open reading", false, this);
            success = false;
            break;
          }
        } else {
          this.messageBox = __WEBPACK_IMPORTED_MODULE_4__components_utility_message_box__["a" /* default */].showMessage("Please enter close reading of " + mpd.nozzels[i].mpdName + " nozzel: " + mpd.nozzels[i].nozelName + "-" + mpd.nozzels[i].productName, false, this);
          success = false;
          break;
        }
      }

      return success;
    }
  }, {
    key: "validateTotalShortage",
    value: function validateTotalShortage(mpd, mpdId) {
      // console.log(mpd);
      //console.log(this.state);

      var totalSale = parseFloat(this.getTotalSaleinRupees(mpdId));
      var totalCreditSale = parseFloat(this.getTotalCreditSaleinRupees(mpdId));
      var totalSwpipe = parseFloat(this.calculateTotalSwpipe(mpdId));
      var cashCollection = mpd.cashCollection.cashCollection;
      var totalEmployeeShortage = parseFloat(this.getTotalEmployeeShortage(mpdId));
      var totalAmountToCollect = parseFloat((totalSale - totalCreditSale - (cashCollection + totalSwpipe)).toFixed(2));
      var success = false;

      if (totalAmountToCollect > 0) {
        if (mpd.lastCashCollection.amount > 0) {
          if (mpd.lastCashCollection.employeeId > 0) {
            if (totalAmountToCollect - mpd.lastCashCollection.amount > 10) {
              if (parseInt(totalAmountToCollect - mpd.lastCashCollection.amount, 10) === totalEmployeeShortage) {
                success = true;
              } else {
                success = false;
                this.messageBox = __WEBPACK_IMPORTED_MODULE_4__components_utility_message_box__["a" /* default */].showMessage("Total Shortage amount must be " + parseInt(totalAmountToCollect - mpd.lastCashCollection.amount, 10) + " in " + mpd.mpdName, false, this);
              }
            } else {
              success = true;
            }
          } else {
            success = false;
            this.messageBox = __WEBPACK_IMPORTED_MODULE_4__components_utility_message_box__["a" /* default */].showMessage("Please select a employee from whom last collection made", false, this);
          }
        } else {
          success = false;
          this.messageBox = __WEBPACK_IMPORTED_MODULE_4__components_utility_message_box__["a" /* default */].showMessage("Please enter last cash collection amount", false, this);
        }
      } else {
        //cash to be collected is less than 0 What to Do ??
        //console.log("amount to collect is negative");
        success = true;
      }

      return success;
      // console.log(totalAmountToCollect);
    }
  }, {
    key: "closeShift",
    value: function closeShift() {
      var _this5 = this;

      this.askQuestion("Do you watnt close shift  " + this.state.currentShift.shiftName + " ?", function () {
        var ok = Object.keys(_this5.state.mpds).every(function (mpdId) {
          if (_this5.validateMpdData(_this5.state.mpds[mpdId]) && _this5.validateCreditData(_this5.state.mpds[mpdId], mpdId) && _this5.validateCashCollected(_this5.state.mpds[mpdId], mpdId) && _this5.validateTotalSwipe(_this5.state.mpds[mpdId], mpdId) && _this5.validateTotalShortage(_this5.state.mpds[mpdId], mpdId)) return true;else return false;
        });

        if (_this5.validateTankDip()) {
          if (ok) {
            _this5.setState({ showSpinner: true });
            // time to send data to server
            // console.log("---", this.state);
            __WEBPACK_IMPORTED_MODULE_7__utility_rq_js__["a" /* default */].postJson("/api/v1/closeshift", _this5.state).then(function (closeShiftData) {
              _this5.messageBox = __WEBPACK_IMPORTED_MODULE_4__components_utility_message_box__["a" /* default */].showMessage("shift close successfully", true, _this5);
              //this.clearData();
              window.localStorage.removeItem("storeData");
              _this5.setState({ showSpinner: false }, function () {
                _this5.askQuestion("Do you want to start a new shift", function () {
                  __WEBPACK_IMPORTED_MODULE_12_react_router__["browserHistory"].push("/page/start-shift");
                }, function () {});
              });

              // setTimeout(() => {
              //     browserHistory.push("/page/start-shift");
              // }, 000);
            }).catch(function () {
              _this5.messageBox = __WEBPACK_IMPORTED_MODULE_4__components_utility_message_box__["a" /* default */].showMessage("shift close faild", false, _this5);
              _this5.setState({ showSpinner: false });
            });
          } else {
            // alert("An error in frontend");
          }
        } else {
          _this5.messageBox = __WEBPACK_IMPORTED_MODULE_4__components_utility_message_box__["a" /* default */].showMessage("plase enter All dip value", false, _this5);
          _this5.forceUpdate();
        }
        _this5.questionBox = null;
        _this5.forceUpdate();
      }, function () {
        //this.messageBox = MessageBox.showMessage("How are you ", true, this);
        _this5.questionBox = null;
        _this5.forceUpdate();
      });
    }
  }, {
    key: "askQuestion",
    value: function askQuestion(msg, yesCallBack, noCallBack) {
      this.questionBox = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__utility_question_box__["a" /* default */], {
        questionMsg: msg,
        yesCallBack: yesCallBack,
        noCallBack: noCallBack
      });
      this.setState(this.state);
    }
  }, {
    key: "storeData",
    value: function storeData() {
      window.localStorage.setItem("storeData", JSON.stringify(this.state));
      this.messageBox = __WEBPACK_IMPORTED_MODULE_4__components_utility_message_box__["a" /* default */].showMessage("Data save temporarily", true, this);
      this.forceUpdate();
    }
  }, {
    key: "clearData",
    value: function clearData() {
      window.localStorage.removeItem("storeData");
      this.messageBox = __WEBPACK_IMPORTED_MODULE_4__components_utility_message_box__["a" /* default */].showMessage("Temporary data cleared", true, this);
      this.forceUpdate();
    }
  }, {
    key: "getTempData",
    value: function getTempData() {
      var _this6 = this;

      var tempData = JSON.parse(window.localStorage.getItem("storeData"));

      if (tempData) {
        // update nozzel data
        // [1 2 3]
        var mpds = Object.keys(tempData.mpds);

        this.state.comment = tempData.comment;

        //console.log("oo------------", this.state.mpds);
        mpds.forEach(function (mpd, index) {
          // [{},{}]
          var products = Object.keys(tempData.mpds[mpd].products);
          // console.log("-----------", products);
          tempData.mpds[mpd].nozzels.forEach(function (nozzel, index) {
            _this6.state.mpds[mpd].nozzels[index] = Object.assign({}, _this6.state.mpds[mpd].nozzels[index], nozzel);
          });

          products.forEach(function (product) {
            _this6.state.mpds[mpd].products[product] = Object.assign({}, _this6.state.mpds[mpd].products[product], tempData.mpds[mpd].products[product]);
          });

          tempData.mpds[mpd].swipeMachines.forEach(function (swipeMachine, index) {
            _this6.state.mpds[mpd].swipeMachines[index] = Object.assign({}, _this6.state.mpds[mpd].swipeMachines[index], tempData.mpds[mpd].swipeMachines[index]);
          });

          _this6.state.mpds[mpd].lastCashCollection = Object.assign({}, _this6.state.mpds[mpd].lastCashCollection, tempData.mpds[mpd].lastCashCollection);
          _this6.state.mpds[mpd].employeeShortageList = Object.assign([], _this6.state.mpds[mpd].employeeShortageList, tempData.mpds[mpd].employeeShortageList);

          _this6.state.tankList = Object.assign([], _this6.state.tankList, tempData.tankList);
        });
        //console.log("xxxx", this.state);
        //console.log("condole---", newMpds);
        // this.setState({ mpds: newMpds });

        // console.log("going to call render again");
        // mpds.forEach((mpd, index) => {
        //     setTimeout(() => {
        //         this.onCloseReadingKeyUp(mpd, );
        //     }, 5000);

        // })

        // setTimeout(() => {
        //     this.onCloseReadingKeyUp(1, 1, 2);
        // }, 5000);
      }
      //window.xx = this.state;
      //this.setState(this.state);
    }
  }, {
    key: "render",
    value: function render() {
      var _this7 = this;

      //console.log("render called", this.state);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "closeShiftPage" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            onClick: this.clearData.bind(this),
            className: "boxShadow availableCash",
            style: {
              lineHeight: "50px",
              position: "fixed",
              bottom: 80,
              right: 15,
              background: "#ca2c47"
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-trash-o", "aria-hidden": "true" })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            onClick: this.storeData.bind(this),
            className: "boxShadow availableCash",
            style: {
              lineHeight: "50px",
              position: "fixed",
              bottom: 155,
              right: 15,
              background: "#309030"
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-floppy-o" })
        ),
        this.state.showSpinner ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__utility_spinner__["a" /* default */], null) : null,
        this.state.currentShift ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h2",
          { style: { textAlign: "center", fontSize: "22px" } },
          " ",
          "Shift Date: ",
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utility_util_methods__["a" /* DD_MM_YY */])(this.state.currentShift.shiftDate),
          " Shift :",
          " ",
          this.state.currentShift.shiftName
        ) : "",
        Object.keys(this.state.mpds).map(function (mpdId) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { key: mpdId },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h2",
              { className: "mpd" },
              _this7.state.mpds[mpdId].mpdName
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: { paddingLeft: "10px" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "table",
                { className: "shiftClose" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "thead",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
                    _this7.state.mpds[mpdId].nozzels.map(function (nozzel) {
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "th",
                        {
                          style: {
                            backgroundColor: _this7.getProductBackground(nozzel.productName)
                          },
                          key: nozzel.nozelId
                        },
                        nozzel.nozelName,
                        " - ",
                        nozzel.productName
                      );
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "td",
                      null,
                      "Open reading"
                    ),
                    _this7.state.mpds[mpdId].nozzels.map(function (nozzel) {
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "td",
                        { className: "center", key: nozzel.nozelId },
                        nozzel.openReading
                      );
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "td",
                      null,
                      "Close reading"
                    ),
                    _this7.state.mpds[mpdId].nozzels.map(function (nozzel, nozzelIndex) {
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "td",
                        { className: "center", key: nozzel.nozelId },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                          defaultValue: nozzel.closeReading,
                          onKeyUp: _this7.onCloseReadingKeyUp.bind(_this7, mpdId, nozzelIndex, nozzel.nozelId),
                          type: "text",
                          ref: nozzel.nozelId,
                          className: "closeReading"
                        })
                      );
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "td",
                      null,
                      "Testing"
                    ),
                    _this7.state.mpds[mpdId].nozzels.map(function (nozzel, nozzelIndex) {
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "td",
                        { className: "center", key: nozzel.nozelId },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                          onKeyUp: _this7.onTesting.bind(_this7, mpdId, nozzelIndex),
                          type: "text",
                          className: "closeReading",
                          defaultValue: nozzel.testing
                        })
                      );
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "td",
                      null,
                      "Consumption"
                    ),
                    _this7.state.mpds[mpdId].nozzels.map(function (nozzel) {
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "td",
                        { className: "center", key: nozzel.nozelId },
                        nozzel.closeReading >= 0 ? nozzel.consumption : ""
                      );
                    })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "table",
                { className: "shiftClose" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "thead",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
                    Object.keys(_this7.state.mpds[mpdId].products).map(function (productName) {
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "th",
                        {
                          key: productName,
                          style: {
                            backgroundColor: _this7.getProductBackground(productName)
                          }
                        },
                        productName
                      );
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "th",
                      { style: { background: "red" } },
                      "Total Sale"
                    ),
                    Object.keys(_this7.state.mpds[mpdId].products).map(function (productName) {
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "th",
                        {
                          key: productName,
                          style: {
                            backgroundColor: _this7.getProductBackground(productName)
                          }
                        },
                        productName,
                        " credit"
                      );
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "th",
                      { style: { background: "red" } },
                      "Total Credit Sale"
                    ),
                    Object.keys(_this7.state.mpds[mpdId].products).map(function (productName) {
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "th",
                        {
                          key: productName,
                          style: {
                            backgroundColor: _this7.getProductBackground(productName)
                          }
                        },
                        productName,
                        " cash"
                      );
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "th",
                      { style: { background: "red" } },
                      "Total Cash Sale"
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "td",
                      null,
                      "In-Qty."
                    ),
                    Object.keys(_this7.state.mpds[mpdId].products).map(function (productName) {
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "td",
                        { key: productName, className: "center" },
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utility_util_methods__["h" /* toExactFixted */])(_this7.state.mpds[mpdId].products[productName].totalQuantity, 3)
                      );
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "td",
                      { className: "center" },
                      _this7.getTotalSaleQuanity.bind(_this7, mpdId)()
                    ),
                    Object.keys(_this7.state.mpds[mpdId].products).map(function (productName) {
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "td",
                        { key: productName, className: "center" },
                        " ",
                        _this7.state.credits[mpdId][productName] ? _this7.state.credits[mpdId][productName].quantity : 0
                      );
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "td",
                      { className: "center" },
                      _this7.getTotalCreditSaleQuanity.bind(_this7, mpdId)()
                    ),
                    Object.keys(_this7.state.mpds[mpdId].products).map(function (productName) {
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "td",
                        { key: productName, className: "center" },
                        (_this7.state.mpds[mpdId].products[productName].totalQuantity - (_this7.state.credits[mpdId][productName] ? _this7.state.credits[mpdId][productName].quantity : 0)).toFixed(3)
                      );
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "td",
                      { className: "center" },
                      _this7.getTotalCashSaleQuanity.bind(_this7, mpdId)()
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "td",
                      null,
                      "In Rs."
                    ),
                    Object.keys(_this7.state.mpds[mpdId].products).map(function (productName) {
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "td",
                        { key: productName, className: "center currency" },
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utility_util_methods__["c" /* currencyFormat */])(_this7.state.mpds[mpdId].products[productName].totalPrice)
                      );
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "td",
                      { className: "center currency" },
                      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utility_util_methods__["c" /* currencyFormat */])(_this7.getTotalSaleinRupees.bind(_this7, mpdId)())
                    ),
                    Object.keys(_this7.state.mpds[mpdId].products).map(function (productName) {
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "td",
                        { key: productName, className: "center currency" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          "span",
                          null,
                          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utility_util_methods__["c" /* currencyFormat */])(_this7.state.credits[mpdId][productName] ? _this7.state.credits[mpdId][productName].quantity * _this7.state.products[_this7.state.credits[mpdId][productName].productId].sellingPrice : 0)
                        )
                      );
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "td",
                      { className: "center currency" },
                      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utility_util_methods__["c" /* currencyFormat */])(_this7.getTotalCreditSaleinRupees.bind(_this7, mpdId)())
                    ),
                    Object.keys(_this7.state.mpds[mpdId].products).map(function (productName) {
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "td",
                        { key: productName, className: "center currency" },
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utility_util_methods__["c" /* currencyFormat */])((_this7.state.mpds[mpdId].products[productName].totalPrice - (_this7.state.credits[mpdId][productName] ? _this7.state.credits[mpdId][productName].quantity * _this7.state.products[_this7.state.credits[mpdId][productName].productId].sellingPrice : 0)).toFixed(2))
                      );
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "td",
                      { className: "center currency" },
                      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utility_util_methods__["c" /* currencyFormat */])(_this7.getTotalCashSaleinRupees.bind(_this7, mpdId)())
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "table",
                { className: "shiftClose" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "thead",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "th",
                      null,
                      "Swipe Machines"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "th",
                      null,
                      "Swipe Amount"
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "tbody",
                  null,
                  _this7.state.mpds[mpdId].swipeMachines.map(function (swipeMachine, index) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "tr",
                      { key: swipeMachine.swipeId },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "td",
                        null,
                        swipeMachine.swipeMachineName.toUpperCase()
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "td",
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                          type: "text",
                          className: "closeReading",
                          onKeyUp: _this7.updateSwipeAmount.bind(_this7, index, mpdId),
                          defaultValue: swipeMachine.amount
                        })
                      )
                    );
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "td",
                      null,
                      "Total"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "td",
                      { className: "center" },
                      _this7.calculateTotalSwpipe(mpdId)
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "table",
                { className: "shiftClose" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "thead",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "th",
                      null,
                      "Cash Collected"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "th",
                      null,
                      "Cash to be collected"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "th",
                      null,
                      "Collection from"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "th",
                      null,
                      "Amount"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "th",
                      null,
                      "Shortage Amount"
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "td",
                      { className: "center currency" },
                      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utility_util_methods__["c" /* currencyFormat */])(_this7.state.mpds[mpdId].cashCollection.cashCollection)
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "td",
                      { className: "center currency" },
                      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utility_util_methods__["c" /* currencyFormat */])(_this7.getTotalCashTobeCollected.bind(_this7, mpdId)())
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "td",
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__utility_auto_complete__["a" /* default */], {
                        placeholder: "select an employee",
                        dataSrc: "api/v1/employee/auto",
                        dataTobind: "employeeName",
                        keyToBind: "employeeId",
                        tabIndex: "2",
                        onSelect: _this7.onEmployeeSelect.bind(_this7, mpdId),
                        reset: _this7.state.mpds[mpdId].resetEmployeeAuto,
                        rex: function rex(searchBox) {
                          _this7.searchBox = searchBox;
                          searchBox.value = _this7.state.mpds[mpdId].lastCashCollection.employeeName || "";
                        },
                        inputStyle: {
                          color: "red",
                          textAlign: "center",
                          fontSize: "14px",
                          width: "150px"
                        },
                        listStyle: { width: "168px" }
                      })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "td",
                      {
                        className: "center currency",
                        onClick: _this7.onAmountClicked.bind(_this7, mpdId)
                      },
                      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utility_util_methods__["c" /* currencyFormat */])(_this7.state.mpds[mpdId].lastCashCollection.amount)
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "td",
                      {
                        className: "center currency",
                        onClick: _this7.onShortageClick.bind(_this7, mpdId)
                      },
                      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utility_util_methods__["c" /* currencyFormat */])(_this7.getTotalEmployeeShortage.bind(_this7, mpdId)())
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_fragments_employee_shortage__["a" /* default */], {
                shortageAmount: _this7.state.mpds[mpdId].shortageAmount,
                display: _this7.state.mpds[mpdId].showShortageForm,
                onSave: _this7.onShortageSave.bind(_this7, mpdId),
                onCancle: _this7.onShortageCancle.bind(_this7, mpdId),
                reset: _this7.state.mpds[mpdId].resetEmployeeAuto
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__fragments_currency_entry__["a" /* default */], {
                visible: _this7.state.mpds[mpdId].showCurrencyForm ? true : false,
                onSave: _this7.onCurrencySave.bind(_this7, mpdId),
                onCancel: _this7.onCurrencyCancel.bind(_this7, mpdId),
                reset: _this7.state.mpds[mpdId].resetEmployeeAuto,
                prevCurrencies: _this7.state.mpds[mpdId].lastCashCollection.currencyData
              })
            )
          );
        }),
        this.messageBox,
        this.questionBox,
        this.state.showCloseShiftBtn ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h2",
              { className: "mpd" },
              "All Tanks Dip"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                {
                  style: { display: "inline-block", margin: "10px 0 0 20px" }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "label",
                  { style: { cursor: "pointer" } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                    type: "checkbox",
                    onChange: function onChange(e) {
                      _this7.setState({ isAtg: e.target.checked });
                    },
                    checked: this.state.isAtg
                  }),
                  " ",
                  "volume by ATG"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "table",
                { className: "formTable", style: { margin: 0 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "tbody",
                  null,
                  this.state.tankList.map(function (tank, index) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "tr",
                      { key: tank.tankId },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "td",
                        {
                          style: {
                            background: "#a5a5a5",
                            color: "white",
                            paddingTop: "5px",
                            paddingBottom: "5px",
                            paddingLeft: "10px",
                            paddingRight: "10px",
                            position: "relative",
                            whiteSpace: "nowrap",
                            border: "none"
                          }
                        },
                        tank.tankName
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "td",
                        { style: { color: "#a5a5a5" } },
                        tank.productName
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "td",
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                          type: "number",
                          className: "formControl inputBox",
                          style: { width: "200px" },
                          onChange: _this7.handleDip.bind(_this7, index, tank),
                          defaultValue: tank.dip,
                          placeholder: _this7.state.isAtg ? "Enter Fuel Height" : "Enter Dip"
                        })
                      ),
                      _this7.state.isAtg ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "td",
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                          type: "number",
                          className: "formControl inputBox",
                          placeholder: "Enter Volume in Ltrs",
                          onChange: _this7.handleVolume.bind(_this7, index, tank),
                          defaultValue: tank.volumeInLtrs,
                          style: { width: "200px" }
                        })
                      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "td",
                        {
                          style: {
                            color: "#927878",
                            width: "100px",
                            textAlign: "right"
                          }
                        },
                        tank.volumeInLtrs
                      ),
                      tank.volumeInLtrs ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "td",
                        { style: { color: "#927878" } },
                        "Ltrs"
                      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null)
                    );
                  })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "p",
                { style: { color: "#927878" } },
                "Shift Comment"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("textarea", {
                rows: "3",
                cols: "76",
                type: "text",
                className: "formControl ",
                placeholder: "Enter Shift Comment",
                onChange: this.handleComment,
                defaultValue: this.state.comment
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "button",
                {
                  className: "btn btnOk btnRight",
                  style: { marginTop: "50px" },
                  onClick: this.closeShift.bind(this)
                },
                "Close Shift"
              )
            )
          )
        ) : null
      );
    }
  }, {
    key: "handleVolume",
    value: function handleVolume(index, tank, e) {
      var inpValue = parseFloat(e.target.value);
      if (this.state.isAtg) {
        var tankList = __WEBPACK_IMPORTED_MODULE_10_immutability_helper___default()(this.state.tankList, _defineProperty({}, index, { volumeInLtrs: { $set: inpValue } }));
        tankList.isAtg = this.state.isAtg;
        this.setState({ tankList: tankList });
      }
    }
  }, {
    key: "validateTankDip",
    value: function validateTankDip() {
      var allTankDip = this.state.tankList.every(function (tank) {
        return tank.volumeInLtrs > 0;
      });
      return allTankDip;
    }
  }, {
    key: "handleDip",
    value: function handleDip(index, tank, e) {
      var _this8 = this;

      var inpValue = parseFloat(e.target.value);
      if (!this.state.isAtg) {
        if (inpValue > 0) {
          __WEBPACK_IMPORTED_MODULE_7__utility_rq_js__["a" /* default */].getJsonData("/api/v1/dip-volume/" + tank.tankId + "/" + inpValue).then(function (data) {
            if (data.length > 0) {
              var tankList = __WEBPACK_IMPORTED_MODULE_10_immutability_helper___default()(_this8.state.tankList, _defineProperty({}, index, {
                dip: { $set: inpValue },
                volumeInLtrs: { $set: data[0].volumeInLtrs }
              }));
              tankList.isAtg = _this8.state.isAtg;
              _this8.setState({ tankList: tankList });
              //  console.log(tankList);
            } else {
              var _tankList = __WEBPACK_IMPORTED_MODULE_10_immutability_helper___default()(_this8.state.tankList, _defineProperty({}, index, { dip: { $set: inpValue }, volumeInLtrs: { $set: 0 } }));
              _tankList.isAtg = _this8.state.isAtg;
              _this8.setState({ tankList: _tankList });
            }
          }).catch(function () {});
        } else {
          var tankList = __WEBPACK_IMPORTED_MODULE_10_immutability_helper___default()(this.state.tankList, _defineProperty({}, index, { dip: { $set: 0 }, volumeInLtrs: { $set: 0 } }));
          tankList.isAtg = this.state.isAtg;
          this.setState({ tankList: tankList });
        }
      } else {
        var _tankList2 = __WEBPACK_IMPORTED_MODULE_10_immutability_helper___default()(this.state.tankList, _defineProperty({}, index, { dip: { $set: inpValue } }));
        _tankList2.isAtg = this.state.isAtg;
        this.setState({ tankList: _tankList2 });
      }
      console.log(this.state.tankList);
    }
  }, {
    key: "getTotalSaleQuanity",
    value: function getTotalSaleQuanity(mpdId) {
      var _this9 = this;

      var totalQuanity = 0;
      Object.keys(this.state.mpds[mpdId].products).forEach(function (productName) {
        totalQuanity += _this9.state.mpds[mpdId].products[productName].totalQuantity;
      });
      return totalQuanity.toFixed(3);
    }
  }, {
    key: "getTotalCreditSaleQuanity",
    value: function getTotalCreditSaleQuanity(mpdId) {
      var _this10 = this;

      var totalQuanity = 0;
      Object.keys(this.state.mpds[mpdId].products).forEach(function (productName) {
        totalQuanity += _this10.state.credits[mpdId][productName] ? _this10.state.credits[mpdId][productName].quantity : 0;
      });
      return totalQuanity.toFixed(3);
    }
  }, {
    key: "getTotalCashSaleQuanity",
    value: function getTotalCashSaleQuanity(mpdId) {
      var _this11 = this;

      var totalQuanity = 0;
      Object.keys(this.state.mpds[mpdId].products).forEach(function (productName) {
        totalQuanity += _this11.state.mpds[mpdId].products[productName].totalQuantity - (_this11.state.credits[mpdId][productName] ? _this11.state.credits[mpdId][productName].quantity : 0);
      });
      return totalQuanity.toFixed(3);
    }
  }, {
    key: "getTotalSaleinRupees",
    value: function getTotalSaleinRupees(mpdId) {
      var _this12 = this;

      var totalQuanity = 0;
      Object.keys(this.state.mpds[mpdId].products).forEach(function (productName) {
        totalQuanity += _this12.state.mpds[mpdId].products[productName].totalPrice;
      });
      return totalQuanity.toFixed(2);
    }
  }, {
    key: "getTotalCreditSaleinRupees",
    value: function getTotalCreditSaleinRupees(mpdId) {
      var _this13 = this;

      var totalQuanity = 0;
      Object.keys(this.state.mpds[mpdId].products).forEach(function (productName) {
        totalQuanity += _this13.state.credits[mpdId][productName] ? _this13.state.credits[mpdId][productName].quantity * _this13.state.products[_this13.state.credits[mpdId][productName].productId].sellingPrice : 0;
      });
      return totalQuanity.toFixed(2);
    }
  }, {
    key: "getTotalCashSaleinRupees",
    value: function getTotalCashSaleinRupees(mpdId) {
      var _this14 = this;

      var totalQuanity = 0;
      Object.keys(this.state.mpds[mpdId].products).forEach(function (productName) {
        totalQuanity += _this14.state.mpds[mpdId].products[productName].totalPrice - (_this14.state.credits[mpdId][productName] ? _this14.state.credits[mpdId][productName].quantity * _this14.state.products[_this14.state.credits[mpdId][productName].productId].sellingPrice : 0);
      });
      return totalQuanity.toFixed(2);
    }
  }, {
    key: "getTotalCashTobeCollected",
    value: function getTotalCashTobeCollected(mpdId) {
      var _this15 = this;

      var totalCashSale = 0;
      Object.keys(this.state.mpds[mpdId].products).forEach(function (productName) {
        totalCashSale += _this15.state.mpds[mpdId].products[productName].totalPrice - (_this15.state.credits[mpdId][productName] ? _this15.state.credits[mpdId][productName].quantity * _this15.state.products[_this15.state.credits[mpdId][productName].productId].sellingPrice : 0);
      });
      return (totalCashSale - (this.state.mpds[mpdId].cashCollection.cashCollection + this.calculateTotalSwpipe(mpdId))).toFixed(2);
    }
  }, {
    key: "makeAjax",
    value: function makeAjax(url, successCb, errCb) {
      __WEBPACK_IMPORTED_MODULE_7__utility_rq_js__["a" /* default */].getJsonData(url).then(function (data) {
        successCb(data);
      }).catch(function () {
        errCb();
      });
    }
  }, {
    key: "toDecimal3",
    value: function toDecimal3(number) {
      number = number.toString().split(".");
      if (number[1]) {
        number[1] = number[1].substring(0, 3);
      }

      return parseFloat(number[0] + "." + number[1]);
    }
  }, {
    key: "getTotalEmployeeShortage",
    value: function getTotalEmployeeShortage(mpdId) {
      // console.log("..........",this.state.mpds[mpdId].employeeShortageList);
      var totalShortage = 0;
      if (this.state.mpds[mpdId].employeeShortageList) {
        this.state.mpds[mpdId].employeeShortageList.forEach(function (employeeShortage) {
          totalShortage += employeeShortage.amount;
        });
      }
      return totalShortage;
    }
  }]);

  return CloseShift;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (CloseShift);

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fragments_edit_creditor_edit__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fragments_edit_employee_edit__ = __webpack_require__(95);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var EditPage = function (_Component) {
    _inherits(EditPage, _Component);

    function EditPage() {
        _classCallCheck(this, EditPage);

        return _possibleConstructorReturn(this, (EditPage.__proto__ || Object.getPrototypeOf(EditPage)).apply(this, arguments));
    }

    _createClass(EditPage, [{
        key: "render",
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "page" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__fragments_edit_creditor_edit__["default"], null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__fragments_edit_employee_edit__["default"], null)
            );
        }
    }]);

    return EditPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (EditPage);

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var Home = function (_Component) {
    _inherits(Home, _Component);

    function Home() {
        _classCallCheck(this, Home);

        return _possibleConstructorReturn(this, (Home.__proto__ || Object.getPrototypeOf(Home)).apply(this, arguments));
    }

    _createClass(Home, [{
        key: "render",
        value: function render() {

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "page " })
            );
        }
    }]);

    return Home;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Home);

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fragments_login__ = __webpack_require__(178);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var LoginPage = function (_React$Component) {
    _inherits(LoginPage, _React$Component);

    function LoginPage() {
        _classCallCheck(this, LoginPage);

        return _possibleConstructorReturn(this, (LoginPage.__proto__ || Object.getPrototypeOf(LoginPage)).apply(this, arguments));
    }

    _createClass(LoginPage, [{
        key: "render",
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: "headerBar" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { style: {
                            "display": "flex",
                            "justifyContent": "center",
                            "paddingTop": "180px"
                        } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__fragments_login__["a" /* default */], { pageProps: this.props })
                )
            );
        }
    }]);

    return LoginPage;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (LoginPage);

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_motion__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_motion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_motion__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Page = function (_React$Component) {
    _inherits(Page, _React$Component);

    function Page() {
        _classCallCheck(this, Page);

        var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this));

        _this.state = {
            open: 1,
            end: 0
        };
        return _this;
    }

    _createClass(Page, [{
        key: "getStyle",
        value: function getStyle() {
            return this.style;
        }
    }, {
        key: "onRest",
        value: function onRest() {
            // eslint-disable-next-line
            this.state.open += 1;
            // eslint-disable-next-line
            this.state.end += 1;
            // console.log("rest called........", this.state.open, this.state.end);
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            // console.log("page render called");
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "page" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_motion__["Motion"],
                    { defaultStyle: { x: 0 }, style: { x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_motion__["spring"])(this.state.open) }, onRest: this.onRest.bind(this) },
                    function (_ref) {
                        var x = _ref.x;

                        //console.log(x - this.state.end);
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "div",
                            { style: {
                                    opacity: x - _this2.state.end
                                } },
                            _this2.props.children
                        );
                    }
                )
            );
        }
    }]);

    return Page;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Page);

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fragments_change_password__ = __webpack_require__(173);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var passwordUpdate = function (_React$Component) {
    _inherits(passwordUpdate, _React$Component);

    function passwordUpdate() {
        _classCallCheck(this, passwordUpdate);

        return _possibleConstructorReturn(this, (passwordUpdate.__proto__ || Object.getPrototypeOf(passwordUpdate)).apply(this, arguments));
    }

    _createClass(passwordUpdate, [{
        key: "render",
        value: function render() {

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: "headerBar" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { style: {
                            "display": "flex",
                            "justifyContent": "center",
                            "paddingTop": "180px"
                        } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__fragments_change_password__["a" /* default */], { pageProps: this.props })
                )
            );
        }
    }]);

    return passwordUpdate;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (passwordUpdate);

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utility_spinner__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utility_question_box__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_notification_action__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utility_rq_js__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Permission = function (_React$Component) {
    _inherits(Permission, _React$Component);

    function Permission() {
        _classCallCheck(this, Permission);

        var _this = _possibleConstructorReturn(this, (Permission.__proto__ || Object.getPrototypeOf(Permission)).call(this));

        _this.state = {
            spinner: true,
            fields: [],
            records: {
                actualRow: [],
                permissionRows: []
            }
        };

        _this.questionBox = null;
        _this.myData = null;
        return _this;
    }

    _createClass(Permission, [{
        key: "getData",
        value: function getData(rowId, tableName) {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_4__utility_rq_js__["a" /* default */].getJsonData("/api/v1/getpermissiondata/" + tableName + "-" + rowId).then(function (data) {
                if (data.permissionRows.length > 0) {
                    switch (data.permissionRows[0].permission) {
                        case 1:
                            {
                                // delete block                    
                                _this2.myData = data;
                                _this2.setState({ fields: Object.keys(data.actualRow[0]), spinner: false, records: data });
                                break;
                            }
                        case 2:
                            {
                                // edite block
                                if (data.permissionRows.length > 0) {
                                    _this2.myData = data;
                                    _this2.setState({ fields: Object.keys(JSON.parse(data.permissionRows[0].reportData)), spinner: false, records: data });
                                }
                                break;
                            }
                        case 3:
                            {
                                //insert or create block
                                _this2.myData = data;
                                _this2.setState({ spinner: false, records: data });
                                break;
                            }
                        default:
                            {
                                break;
                            }
                    }
                }
            }).catch(function (err) {
                alert("faild get data ");
            });
        }
    }, {
        key: "componentWillMount",
        value: function componentWillMount() {
            //console.log("component will mount");
            this.getData(this.props.params.rowId, this.props.params.tableName);
        }
    }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            this.getData(nextProps.params.rowId, nextProps.params.tableName);
        }
    }, {
        key: "askQuestion",
        value: function askQuestion(msg, yesCallBack, noCallBack) {
            this.questionBox = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__utility_question_box__["a" /* default */], { questionMsg: msg, yesCallBack: yesCallBack, noCallBack: noCallBack });
            this.setState(this.state);
        }
    }, {
        key: "onAccept",
        value: function onAccept(permissionData) {
            var _this3 = this;

            this.askQuestion("Do you want to accept it ?", function () {
                _this3.questionBox = null;
                _this3.setState({ spinner: true });
                __WEBPACK_IMPORTED_MODULE_4__utility_rq_js__["a" /* default */].post("/api/v1/acceptpermission", permissionData).then(function () {
                    _this3.questionBox = null;
                    _this3.setState({ spinner: false, records: { permissionRows: [] } });

                    // making ajax call to notification to updata notification number
                    __WEBPACK_IMPORTED_MODULE_3__actions_notification_action__["a" /* getAllNotification */]();
                }).catch(function () {
                    alert("accept failed");
                });
            }, function () {
                _this3.questionBox = null;
                _this3.forceUpdate();
            });
        }
    }, {
        key: "onReject",
        value: function onReject(notificationId) {
            var _this4 = this;

            this.askQuestion("Do you want to reject it ?", function () {
                _this4.setState({ spinner: true });
                __WEBPACK_IMPORTED_MODULE_4__utility_rq_js__["a" /* default */].post("/api/v1/rejectpermission", { notificationId: notificationId }).then(function () {
                    _this4.questionBox = null;
                    _this4.setState({ spinner: false, records: { permissionRows: [] } });

                    // making ajax call to notification to updata notification 
                    __WEBPACK_IMPORTED_MODULE_3__actions_notification_action__["a" /* getAllNotification */]();
                }).catch(function () {});
            }, function () {
                _this4.questionBox = null;
                _this4.forceUpdate();
            });
        }
    }, {
        key: "render",
        value: function render() {
            var _this5 = this;

            var reportData = this.state.records.permissionRows.length > 0 ? JSON.parse(this.state.records.permissionRows[0].reportData) : null;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                null,
                this.myData ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "normalPage" },
                    this.state.spinner ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__utility_spinner__["a" /* default */], null) : null,
                    this.questionBox,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "h2",
                        { style: { textAlign: "center", fontSize: "1.5em", color: "#969696", textTransform: "lowercase" } },
                        this.state.records.length > 0 ? this.state.records.permissionRows[0].msg : null
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
                    this.state.records.permissionRows.length > 0 && this.state.records.permissionRows[0].permission === 2 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "p",
                            { style: { marginBottom: "5px", color: "#0069ff", fontSize: "1.1em" } },
                            "Current Data:"
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "table",
                            { className: "simple" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "thead",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "tr",
                                    null,
                                    this.state.fields.map(function (column, i) {
                                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "th",
                                            { key: i },
                                            column.replace(/([A-Z])/g, " $1").replace(/^./, function (str) {
                                                return str.toUpperCase();
                                            })
                                        );
                                    }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "th",
                                        null,
                                        "Time Stamp"
                                    )
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "tbody",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "tr",
                                    null,
                                    this.state.fields.map(function (field, i) {
                                        console.log(field, _this5.state.records.actualRow[0][field] === reportData[field]);
                                        console.log(field, _this5.state.records.actualRow[0][field]);
                                        console.log(field, reportData[field]);
                                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "td",
                                            { style: { textAlign: "center" }, key: i, className: _this5.state.records.actualRow[0][field] !== reportData[field] ? "highlighted" : "" },
                                            _this5.state.records.actualRow[0][field]
                                        );
                                    }),
                                    this.state.records.actualRow.length > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "td",
                                        null,
                                        this.state.records.actualRow[0].timestamp
                                    ) : null
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "p",
                            { style: { marginBottom: "5px", color: "#0069ff", fontSize: "1.1em" } },
                            "Modification Requests:"
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "table",
                            { className: "simple" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "thead",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "tr",
                                    null,
                                    this.state.fields.map(function (column, i) {
                                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "th",
                                            { key: i },
                                            column.replace(/([A-Z])/g, " $1").replace(/^./, function (str) {
                                                return str.toUpperCase();
                                            })
                                        );
                                    }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "th",
                                        null,
                                        "Comment"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "th",
                                        null,
                                        "user"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "th",
                                        null,
                                        "Time Stamp"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "th",
                                        null,
                                        "accept"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "th",
                                        null,
                                        "reject"
                                    )
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "tbody",
                                null,
                                this.state.records.permissionRows.length > 0 ? this.state.records.permissionRows.map(function (permission, i) {
                                    // let reportData = JSON.parse(permission.reportData);
                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "tr",
                                        { key: i },
                                        _this5.state.fields.map(function (field, z) {
                                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                "td",
                                                _defineProperty({ style: { textAlign: "center" }, key: i, className: _this5.state.records.actualRow[0][field] !== reportData[field] ? "highlighted" : "" }, "key", z),
                                                reportData[field]
                                            );
                                        }),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "td",
                                            null,
                                            permission.comment
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "td",
                                            null,
                                            permission.userName
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "td",
                                            null,
                                            permission.timestamp
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "td",
                                            { style: { textAlign: "center" } },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-check ", "aria-hidden": "true", onClick: _this5.onAccept.bind(_this5, permission, i), style: { fontSize: "1.5em", cursor: "pointer", color: "green" } })
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "td",
                                            { style: { textAlign: "center" } },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-times", "aria-hidden": "true", onClick: _this5.onReject.bind(_this5, permission.notificationId, i), style: { fontSize: "1.5em", color: "red", cursor: "pointer" } })
                                        )
                                    );
                                }) : null
                            )
                        )
                    ) : null,
                    this.state.records.permissionRows.length > 0 && this.state.records.permissionRows[0].permission === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "p",
                            { style: { marginBottom: "5px", color: "#0069ff", fontSize: "1.1em" } },
                            "Current Data:"
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "table",
                            { className: "simple" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "thead",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "tr",
                                    null,
                                    this.state.fields.map(function (column, i) {
                                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "th",
                                            { key: i },
                                            column.replace(/([A-Z])/g, " $1").replace(/^./, function (str) {
                                                return str.toUpperCase();
                                            })
                                        );
                                    })
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "tbody",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "tr",
                                    null,
                                    this.state.fields.map(function (field, i) {
                                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "td",
                                            { key: i },
                                            _this5.state.records.actualRow[0][field]
                                        );
                                    })
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "p",
                            { style: { marginBottom: "5px", color: "#0069ff", fontSize: "1.1em" } },
                            "Delete Requests:"
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "table",
                            { className: "simple" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "thead",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "tr",
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "th",
                                        null,
                                        "Comment"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "th",
                                        null,
                                        "user"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "th",
                                        null,
                                        "Time Stamp"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "th",
                                        null,
                                        "accept"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "th",
                                        null,
                                        "reject"
                                    )
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "tbody",
                                null,
                                this.state.records.permissionRows.length > 0 ? this.state.records.permissionRows.map(function (permission, i) {

                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "tr",
                                        { key: i },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "td",
                                            null,
                                            permission.comment
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "td",
                                            null,
                                            permission.userName
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "td",
                                            null,
                                            permission.timestamp
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "td",
                                            { style: { textAlign: "center" } },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-check ", "aria-hidden": "true", onClick: _this5.onAccept.bind(_this5, permission, i), style: { fontSize: "1.5em", cursor: "pointer", color: "green" } })
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "td",
                                            { style: { textAlign: "center" } },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-times", "aria-hidden": "true", onClick: _this5.onReject.bind(_this5, permission.notificationId, i), style: { fontSize: "1.5em", color: "red", cursor: "pointer" } })
                                        )
                                    );
                                }) : null
                            )
                        )
                    ) : null
                ) : null
            );
        }
    }]);

    return Permission;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Permission);

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_motion__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_motion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_motion__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Report = function (_React$Component) {
    _inherits(Report, _React$Component);

    function Report() {
        _classCallCheck(this, Report);

        var _this = _possibleConstructorReturn(this, (Report.__proto__ || Object.getPrototypeOf(Report)).call(this));

        _this.state = {
            open: 1,
            end: 0
        };
        return _this;
    }

    _createClass(Report, [{
        key: "getStyle",
        value: function getStyle() {
            return this.style;
        }
    }, {
        key: "onRest",
        value: function onRest() {
            // eslint-disable-next-line
            this.state.open += 1;
            // eslint-disable-next-line
            this.state.end += 1;
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "reportPage" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_motion__["Motion"],
                    { defaultStyle: { x: 0 }, style: { x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_motion__["spring"])(this.state.open) }, onRest: this.onRest.bind(this) },
                    function (_ref) {
                        var x = _ref.x;


                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "div",
                            { style: {
                                    opacity: x - _this2.state.end
                                } },
                            _this2.props.children
                        );
                    }
                )
            );
        }
    }]);

    return Report;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Report);

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var AdvanceTip = function (_Component) {
    _inherits(AdvanceTip, _Component);

    function AdvanceTip() {
        _classCallCheck(this, AdvanceTip);

        return _possibleConstructorReturn(this, (AdvanceTip.__proto__ || Object.getPrototypeOf(AdvanceTip)).apply(this, arguments));
    }

    _createClass(AdvanceTip, [{
        key: "componentWillMount",
        value: function componentWillMount() {}
    }, {
        key: "render",
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                null,
                this.props.showOn ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { id: "tipContainer" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { id: "tipBox", style: this.props.tipStyle },
                        this.props.closeBtnStyle ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { onClick: this.props.cancelTip, className: "fa fa-times", style: this.props.closeBtnStyle }) : null,
                        this.props.pointerClass ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: this.props.pointerClass ? this.props.pointerClass : "tDownLeft", style: this.props.pointerStyle }) : null,
                        this.props.pointerClass ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: this.props.pointerClass ? this.props.pointerClass : "tDownLeft", style: this.props.pointerStyle }) : null,
                        this.props.children
                    )
                ) : null
            );
        }
    }]);

    return AdvanceTip;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AdvanceTip);

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var NetDetect = function (_Component) {
    _inherits(NetDetect, _Component);

    function NetDetect(props) {
        _classCallCheck(this, NetDetect);

        var _this = _possibleConstructorReturn(this, (NetDetect.__proto__ || Object.getPrototypeOf(NetDetect)).call(this, props));

        _this.state = {
            visible: !window.navigator.onLine
        };
        return _this;
    }

    _createClass(NetDetect, [{
        key: "render",
        value: function render() {
            //console.log("ooo", this.state.visible);
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { style: { position: "fixed", zIndex: 1000, left: 0, bottom: 0, width: "100%" } },
                this.state.visible ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { id: "netDetect" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "h2",
                        null,
                        "No internet connection detected !! You are now offline."
                    )
                ) : null
            );
        }
    }, {
        key: "handleOnline",
        value: function handleOnline() {
            this.setState({ visible: false });
        }
    }, {
        key: "handleOffline",
        value: function handleOffline() {
            this.setState({ visible: true });
        }
    }, {
        key: "componentDidMount",
        value: function componentDidMount() {
            // window.navigator.onli
            window.addEventListener("offline", this.handleOffline.bind(this));
            window.addEventListener("online", this.handleOnline.bind(this));
        }
    }]);

    return NetDetect;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (NetDetect);

/***/ }),
/* 192 */
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _from = Symbol();
var _to = Symbol();
var _generatedRandoms = Symbol();
var _giveRandom = Symbol();

var Xrand = function () {
    function Xrand(from, to) {
        _classCallCheck(this, Xrand);

        if (typeof from !== "number" || typeof to !== "number") {
            throw new Error("From and To must be integers.");
        }
        from = parseInt(from, 10);
        to = parseInt(to, 10);
        to += 1;
        if (from > to) throw new Error("'From' number must be less than or equla to 'To' number");
        this[_from] = from;
        this[_to] = to;
        this[_generatedRandoms] = { length: 0 };

        this[_giveRandom] = function () {
            return Math.floor(this[_from] + Math.random() * (this[_to] - this[_from]), 10);
        };
    }

    _createClass(Xrand, [{
        key: "generate",
        value: function generate() {
            var possibilities = this[_generatedRandoms].length < this[_to] - this[_from] ? true : false;

            while (possibilities) {
                var rnd = this[_giveRandom]();
                if (!this[_generatedRandoms][rnd]) {
                    this[_generatedRandoms][rnd] = true;
                    this[_generatedRandoms].length += 1;
                    possibilities = false;
                    return rnd;
                }
            }
            return false;
        }
    }, {
        key: "generateAll",
        value: function generateAll() {
            var arr = [];
            var looUntil = this[_to] - this[_from];
            for (var i = 0; i < looUntil; i++) {
                arr.push(this.generate());
            }
            return arr;
        }
    }]);

    return Xrand;
}();

module.exports = Xrand;

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_master_master1__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pages_home__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_login_page__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_password_update_page__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_edit_page__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_permission__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_page__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pages_close_shift__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_no_permmision__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pages_report__ = __webpack_require__(189);











var routes = [{
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_0__components_master_master1__["a" /* default */],
    onEnter: function onEnter(nextState, replace) {
        if (!window.localStorage.getItem("token")) {
            replace({
                pathname: "/login",
                state: { nextPathname: nextState.location.pathname }
            });
        }
    },
    indexRoute: { component: __WEBPACK_IMPORTED_MODULE_1__components_pages_home__["a" /* default */] },
    childRoutes: [{
        path: "editpage",
        component: __WEBPACK_IMPORTED_MODULE_4__components_pages_edit_page__["a" /* default */]
    }, {
        path: "/404",
        component: __WEBPACK_IMPORTED_MODULE_8__components_pages_no_permmision__["a" /* default */]
    }, {
        path: "permission/:rowId/:tableName",
        component: __WEBPACK_IMPORTED_MODULE_5__components_pages_permission__["a" /* default */]

    }, {
        path: "closeshift",
        component: __WEBPACK_IMPORTED_MODULE_7__components_pages_close_shift__["a" /* default */]

    }, {
        path: "/page",
        component: __WEBPACK_IMPORTED_MODULE_6__components_pages_page__["a" /* default */],
        childRoutes: [{
            path: "create-employee",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(47).then((function (require) {
                    callback(null, __webpack_require__(350).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "employee-advance",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(50).then((function (require) {
                    callback(null, __webpack_require__(364).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "employee-cash-collection",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(64).then((function (require) {
                    callback(null, __webpack_require__(344).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "create-creditor",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(71).then((function (require) {
                    callback(null, __webpack_require__(348).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "credit-entry",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(15).then((function (require) {
                    callback(null, __webpack_require__(360).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "creditor-payment-entry",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(51).then((function (require) {
                    callback(null, __webpack_require__(361).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "test",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(65).then((function () {
                    callback(null, __webpack_require__(412).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "create-product",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(56).then((function () {
                    callback(null, __webpack_require__(355).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "product-rate",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(36).then((function () {
                    callback(null, __webpack_require__(366).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "create-expenditure",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(58).then((function () {
                    callback(null, __webpack_require__(352).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "expenditure-detail",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(59).then((function () {
                    callback(null, __webpack_require__(351).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "create-shift",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(55).then((function () {
                    callback(null, __webpack_require__(356).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "start-shift",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(67).then((function () {
                    callback(null, __webpack_require__(410).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "create-currency",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(60).then((function () {
                    callback(null, __webpack_require__(349).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "exchange",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(49).then((function () {
                    callback(null, __webpack_require__(365).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "create-tank",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(53).then((function () {
                    callback(null, __webpack_require__(358).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "create-mpd",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(63).then((function () {
                    callback(null, __webpack_require__(345).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "create-nozzel",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(46).then((function () {
                    callback(null, __webpack_require__(353).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "create-transaction-account",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(61).then((function () {
                    callback(null, __webpack_require__(347).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "create-paymode",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(57).then((function () {
                    callback(null, __webpack_require__(354).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "create-link-tr-paymode",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(66).then((function () {
                    callback(null, __webpack_require__(411).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "create-swipe",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(62).then((function () {
                    callback(null, __webpack_require__(346).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "stock-in",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(54).then((function () {
                    callback(null, __webpack_require__(357).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "create-user",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(52).then((function () {
                    callback(null, __webpack_require__(359).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "user-edit",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(69).then((function () {
                    callback(null, __webpack_require__(363).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "mpd-nozzel-edit",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(70).then((function () {
                    callback(null, __webpack_require__(362).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "send-msg",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(37).then((function () {
                    callback(null, __webpack_require__(409).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "msg-subscription",
            getComponents: function getComponents(location, callback) {
                callback(null, __webpack_require__(179).default);
            }
        }, {
            path: "backward-stockin",
            getComponents: function getComponents(location, callback) {
                callback(null, __webpack_require__(172).default);
            }
        }, {
            path: "last-inspection-entry",
            getComponents: function getComponents(location, callback) {
                callback(null, __webpack_require__(177).default);
            }
        }, {
            path: "instant-cash-memo",
            getComponents: function getComponents(location, callback) {
                callback(null, __webpack_require__(176).default);
            }
        }]
    }, {
        path: "/report",
        component: __WEBPACK_IMPORTED_MODULE_9__components_pages_report__["a" /* default */],
        childRoutes: [{
            path: "current-shift-credit-report",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(27).then((function (require) {
                    callback(null, __webpack_require__(341).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "current-shift-detail-credit-report",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(0).then((function (require) {
                    callback(null, __webpack_require__(385).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "credit-detail-between-two-day",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(32).then((function (require) {
                    callback(null, __webpack_require__(375).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "credit-Payment-between-two-day",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(8).then((function (require) {
                    callback(null, __webpack_require__(376).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "credit-payment-by-credit-id",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(14).then((function (require) {
                    callback(null, __webpack_require__(398).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "credit-report-by-shift-with-aggreagation",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(33).then((function (require) {
                    callback(null, __webpack_require__(374).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "credit-report-unbilled",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(29).then((function (require) {
                    callback(null, __webpack_require__(380).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "credit-report-unbilled-bycreditor/:id/:firmName",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(3).then((function (require) {
                    callback(null, __webpack_require__(379).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "credit-report-billed",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(31).then((function (require) {
                    callback(null, __webpack_require__(378).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "credit-report-billed-by-id",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(12).then((function (require) {
                    callback(null, __webpack_require__(369).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "credit-report-billed-bycreditor/:id/:firmName",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(68).then((function (require) {
                    callback(null, __webpack_require__(377).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "credit-report-bybillid/:creditorId/:creditorBillId/:firmName",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(30).then((function (require) {
                    callback(null, __webpack_require__(340).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "creditor-payment-bycreditorId/:creditorId/:firmName",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(44).then((function (require) {
                    callback(null, __webpack_require__(381).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "credit-statement",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(28).then((function (require) {
                    callback(null, __webpack_require__(382).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "credit-account-details",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(34).then((function (require) {
                    callback(null, __webpack_require__(373).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "reading-report",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(21).then((function (require) {
                    callback(null, __webpack_require__(400).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "chart",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(45).then((function (require) {
                    callback(null, __webpack_require__(370).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "employee-advance-between-two-day",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(24).then((function (require) {
                    callback(null, __webpack_require__(389).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "current-shift-employee-advance",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(26).then((function (require) {
                    callback(null, __webpack_require__(386).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "salary-payment-by-date",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(20).then((function (require) {
                    callback(null, __webpack_require__(401).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "employee-attendance-shortage",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(18).then((function (require) {
                    callback(null, __webpack_require__(391).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "employee-salary-detail",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(2).then((function (require) {
                    callback(null, __webpack_require__(402).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "employee-pay-rate",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(41).then((function (require) {
                    callback(null, __webpack_require__(390).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "current-shift-expenditure",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(25).then((function (require) {
                    callback(null, __webpack_require__(387).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "expenditure-between-two-day",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(13).then((function (require) {
                    callback(null, __webpack_require__(393).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "expenditure-between-two-day-with-aggreagation",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(40).then((function (require) {
                    callback(null, __webpack_require__(392).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "sell",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(9).then((function (require) {
                    callback(null, __webpack_require__(404).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "sell-day",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(1).then((function (require) {
                    callback(null, __webpack_require__(403).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "current-shift-cash-collection",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(43).then((function (require) {
                    callback(null, __webpack_require__(383).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "swipe-ungrouped",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(19).then((function (require) {
                    callback(null, __webpack_require__(408).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "swipe-grouped",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(16).then((function (require) {
                    callback(null, __webpack_require__(407).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "product-rate-between-two-day",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(22).then((function (require) {
                    callback(null, __webpack_require__(399).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "current-shift-cash-transaction",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(42).then((function (require) {
                    callback(null, __webpack_require__(384).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "close-shift-report-between-two-day",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(11).then((function (require) {
                    callback(null, __webpack_require__(372).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "closed-shift-report/:shiftId/:shiftDate",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(48).then((function (require) {
                    callback(null, __webpack_require__(339).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "invoice-report-between-two-day",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(10).then((function (require) {
                    callback(null, __webpack_require__(395).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "invoice-shortage-report-between-two-day",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(23).then((function (require) {
                    callback(null, __webpack_require__(396).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "get-interest-report",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(39).then((function (require) {
                    callback(null, __webpack_require__(394).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "msg-subscription-report",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(7).then((function (require) {
                    callback(null, __webpack_require__(397).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "dsr",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(17).then((function (require) {
                    callback(null, __webpack_require__(388).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "small-creditor-account-statement",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(4).then((function (require) {
                    callback(null, __webpack_require__(406).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "all-small-creditor-statement",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(5).then((function (require) {
                    callback(null, __webpack_require__(368).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "all-small-creditor-report-between-two-dates",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(6).then((function (require) {
                    callback(null, __webpack_require__(367).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "close-shift-dips",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(35).then((function (require) {
                    callback(null, __webpack_require__(371).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "showall-creditors",
            getComponents: function getComponents(location, callback) {
                __webpack_require__.e/* require.ensure */(38).then((function (require) {
                    callback(null, __webpack_require__(405).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }]
    }, {
        path: "/edit-page",
        component: __WEBPACK_IMPORTED_MODULE_6__components_pages_page__["a" /* default */],
        childRoutes: [{
            path: "creditor",
            getComponents: function getComponents(location, callback) {
                new Promise(function(resolve) { resolve(); }).then((function () {
                    callback(null, __webpack_require__(94).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }, {
            path: "employee",
            getComponents: function getComponents(location, callback) {
                new Promise(function(resolve) { resolve(); }).then((function () {
                    callback(null, __webpack_require__(95).default);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }
        }]
    }]

}, {
    path: "/login",
    component: __WEBPACK_IMPORTED_MODULE_2__components_pages_login_page__["a" /* default */],
    onEnter: function onEnter(nextState, replace) {

        if (window.localStorage.getItem("token")) {
            replace({
                pathname: "/",
                state: { nextPathname: nextState.location.pathname }
            });
        }
    }
}, {
    path: "/update-password",
    component: __WEBPACK_IMPORTED_MODULE_3__components_pages_password_update_page__["a" /* default */]
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_events__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dispatcher__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_constants__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var InvoiceStore = function (_EventEmitter) {
    _inherits(InvoiceStore, _EventEmitter);

    function InvoiceStore() {
        _classCallCheck(this, InvoiceStore);

        return _possibleConstructorReturn(this, (InvoiceStore.__proto__ || Object.getPrototypeOf(InvoiceStore)).apply(this, arguments));
    }

    _createClass(InvoiceStore, [{
        key: "handleAction",
        value: function handleAction(action) {
            switch (action.type) {
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["q" /* invoiceConstant */].INVOICE_CREATED:
                    {
                        var invoice = action.invoice;

                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["q" /* invoiceConstant */].INVOICE_CREATED, "Invoice " + invoice.invoiceNumber + " created successfully.");
                        break;
                    }
                case __WEBPACK_IMPORTED_MODULE_2__constants_constants__["q" /* invoiceConstant */].INVOICE_CREATION_FAILED:
                    {
                        this.emit(__WEBPACK_IMPORTED_MODULE_2__constants_constants__["q" /* invoiceConstant */].INVOICE_CREATION_FAILED, action.msg);
                        break;
                    }
                default:
                    break;
            }
        }
    }]);

    return InvoiceStore;
}(__WEBPACK_IMPORTED_MODULE_0_events__["EventEmitter"]);

var invoiceStore = new InvoiceStore();
__WEBPACK_IMPORTED_MODULE_1__dispatcher__["a" /* default */].register(invoiceStore.handleAction.bind(invoiceStore));
//window.mpdStore = mpdStore;
//window.dispatcher = dispatcher;
/* harmony default export */ __webpack_exports__["a"] = (invoiceStore);

/***/ }),
/* 195 */
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _stockInIdDateTime = Symbol();
var _invoiceDetailId = Symbol();
var _tankId = Symbol();
var _productId = Symbol();
var _quantity = Symbol();
var _shiftId = Symbol();
var _stockInId = Symbol();
var _remaining = Symbol();
var _startDip = Symbol();
var _endDip = Symbol();
var _afterReading = Symbol();
var _beforeReding = Symbol();
var _shiftDate = Symbol();
var _endDipVolume = Symbol();
var _startDipVolume = Symbol();
var _errs = Symbol();

var StockIn = function () {
    function StockIn(_ref) {
        var remaining = _ref.remaining,
            stockInDateTime = _ref.stockInDateTime,
            invoiceDetailId = _ref.invoiceDetailId,
            tankId = _ref.tankId,
            quantity = _ref.quantity,
            shiftId = _ref.shiftId,
            productId = _ref.productId,
            stockInId = _ref.stockInId,
            startDip = _ref.startDip,
            endDip = _ref.endDip,
            startDipVolume = _ref.startDipVolume,
            endDipVolume = _ref.endDipVolume,
            beforeReading = _ref.beforeReading,
            afterReading = _ref.afterReading,
            shiftDate = _ref.shiftDate;

        _classCallCheck(this, StockIn);

        this[_errs] = {};
        Object.defineProperties(this, {
            remaining: {
                enumerable: true,
                configurable: true,
                set: function set(value) {
                    var x = parseInt(value, 10);
                    if (x) {
                        this[_remaining] = x;
                        delete this[_errs].remaining;
                    } else {
                        this[_errs].remaining = "remaining must be a valid integer";
                    }
                },
                get: function get() {
                    return this[_remaining];
                }
            },
            shiftDate: {
                enumerable: true,
                configurable: true,
                set: function set(value) {
                    var pattern = /^([0-9]{4})-([0-9]{2})-([0-9]{2})$/;
                    if (pattern.test(value) && Date.parse(value)) {
                        this[_shiftDate] = value || null;
                        delete this[_errs].shiftDate;
                    } else {
                        this[_errs].shiftDate = "please enter a valid date YYYY-MM-DD format";
                    }
                },
                get: function get() {
                    return this[_shiftDate];
                }
            },
            stockInDateTime: {
                enumerable: true,
                configurable: true,
                set: function set(value) {
                    //2018-02-24 23:22
                    var dateTime = /^([0-9]{4})-([0-9]{2})-([0-9]{2}) ([0-9]{2}):([0-9]{2})$/;
                    if (dateTime.test(value) && Date.parse(value)) {

                        this[_stockInIdDateTime] = value;
                        delete this[_errs].stockInDateTime;
                    } else {
                        this[_errs].stockInDateTime = "please enter a valid StockIn  date & time";
                    }
                },
                get: function get() {
                    return this[_stockInIdDateTime];
                }
            },
            invoiceDetailId: {
                enumerable: true,
                configurable: true,
                set: function set(value) {
                    var x = parseInt(value, 10);
                    if (x) {
                        this[_invoiceDetailId] = x;
                        delete this[_errs].invoiceDetailId;
                    } else {
                        this[_errs].invoiceDetailId = "invoiceDetailId must be a valid integer";
                    }
                },
                get: function get() {
                    return this[_invoiceDetailId];
                }
            },

            tankId: {
                enumerable: true,
                configurable: true,
                set: function set(value) {
                    var x = parseInt(value, 10);
                    if (x) {
                        this[_tankId] = x;
                        delete this[_errs].tankId;
                    } else {
                        this[_errs].tankId = "tankId must be a valid integer";
                    }
                },
                get: function get() {
                    return this[_tankId];
                }
            },

            quantity: {
                enumerable: true,
                configurable: true,
                set: function set(value) {

                    if (parseFloat(value) && parseFloat(this.remaining)) {
                        if (value <= this.remaining / 1000) {
                            this[_quantity] = parseFloat(value);
                            delete this[_errs].quantity;
                        } else {
                            this[_errs].quantity = "StockIn Quantity not more then Remaining Quantity";
                        }
                    } else {
                        this[_errs].quantity = "quantity must be a valid integer";
                    }
                },
                get: function get() {
                    return this[_quantity];
                }
            },
            shiftId: {
                enumerable: true,
                configurable: true,
                set: function set(value) {
                    var x = parseInt(value, 10);
                    if (x) {
                        this[_shiftId] = x || null;
                        delete this[_errs].shiftId;
                    } else {
                        this[_errs].shiftId = "ShiftId must be a valid integer";
                    }
                },
                get: function get() {
                    return this[_shiftId];
                }
            },
            productId: {
                enumerable: true,
                configurable: true,
                set: function set(value) {
                    var x = parseInt(value, 10);
                    if (x) {
                        this[_productId] = x;
                        delete this[_errs].productId;
                    } else {
                        this[_errs].productId = "productId must be a valid integer";
                    }
                },
                get: function get() {
                    return this[_productId];
                }
            },
            startDip: {
                enumerable: true,
                configurable: true,
                set: function set(value) {
                    var x = parseFloat(value);
                    if (x >= 0) {
                        this[_startDip] = x;
                        delete this[_errs].startDip;
                    } else {
                        this[_errs].startDip = "Start Dip must be a valid integer";
                    }
                },
                get: function get() {
                    return this[_startDip];
                }
            },
            endDip: {
                enumerable: true,
                configurable: true,
                set: function set(value) {
                    var x = parseFloat(value);
                    if (x) {
                        this[_endDip] = x;
                        delete this[_errs].endDip;
                    } else {
                        this[_errs].endDip = "End Dip must be a valid integer";
                    }
                },
                get: function get() {
                    return this[_endDip];
                }
            },
            startDipVolume: {
                enumerable: true,
                configurable: true,
                set: function set(value) {
                    var x = parseFloat(value);

                    this[_startDipVolume] = x || null;
                },
                get: function get() {
                    return this[_startDipVolume];
                }
            },
            endDipVolume: {
                enumerable: true,
                configurable: true,
                set: function set(value) {
                    var x = parseFloat(value);

                    this[_endDipVolume] = x || null;
                },
                get: function get() {
                    return this[_endDipVolume];
                }
            },

            beforeReading: {
                enumerable: true,
                configurable: true,
                set: function set(value) {
                    var x = parseFloat(value);
                    if (x) {
                        this[_beforeReding] = x;
                        delete this[_errs].beforeReading;
                    } else {
                        this[_errs].beforeReading = "Before Reding   must be a valid integer";
                    }
                },
                get: function get() {
                    return this[_beforeReding];
                }
            },
            afterReading: {
                enumerable: true,
                configurable: true,
                set: function set(value) {
                    var x = parseFloat(value);
                    if (x) {
                        this[_afterReading] = x;
                        delete this[_errs].afterReading;
                    } else {
                        this[_errs].afterReading = "After Reading  must be a valid integer";
                    }
                },
                get: function get() {
                    return this[_afterReading];
                }
            },
            stockInId: {
                enumerable: true,
                configurable: true,
                set: function set() {
                    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

                    this[_stockInId] = value;
                },
                get: function get() {
                    return this[_stockInId];
                }
            }

        });
        this.shiftDate = shiftDate;
        this.invoiceDetailId = invoiceDetailId;
        this.tankId = tankId;
        this.quantity = quantity;
        this.shiftId = shiftId;
        this.stockInId = stockInId;
        this.stockInDateTime = stockInDateTime;
        this.productId = productId;
        this.remaining = remaining;
        this.startDip = startDip;
        this.endDip = endDip;
        this.beforeReading = beforeReading;
        this.afterReading = afterReading;
        this.startDipVolume = startDipVolume;
        this.endDipVolume = endDipVolume;
    }

    _createClass(StockIn, [{
        key: "hasError",
        value: function hasError() {
            return Object.keys(this[_errs]).length > 0;
        }
    }, {
        key: "getErrors",
        value: function getErrors() {
            return this[_errs];
        }

        // checkQuantity(quantity) {
        //     if (parseFloat(quantity) && this.remaining >= quantity) {
        //         this.quantity = quantity;
        //     } else {
        //         this[_errs].quantity = "StockIn Quantity not more then Remaining Quantity";
        //     }
        // }

    }, {
        key: "checkReding",
        value: function checkReding(beforeReading, afterReading) {
            if (beforeReading > afterReading) {
                this[_errs].afterReading = "After Reading  must be greater than Before Reading ";
            } else {
                delete this[_errs].afterReading;
            }
        }
    }, {
        key: "checkAtg",
        value: function checkAtg(startDipVolume, endDipVolume, isAtg) {
            console.log(isAtg);
            if (isAtg) {
                if (startDipVolume && endDipVolume) {
                    if (startDipVolume > endDipVolume) {
                        this[_errs].endDipVolume = "End Volume must be greater than start Volume";
                    } else {
                        delete this[_errs].startDipVolume;
                        delete this[_errs].endDipVolume;
                    }
                } else {
                    !startDipVolume ? this[_errs].startDipVolume = "Start Volume must be a valid integer" : this[_errs].endDipVolume = "End Volume must be a valid integer";
                }
            } else {
                delete this[_errs].startDipVolume;
                delete this[_errs].endDipVolume;
            }
        }
    }, {
        key: "checkDip",
        value: function checkDip(startDip, endDip) {
            if (startDip > endDip) {
                this[_errs].endDip = "End dip must be greater than start dip";
            } else {
                delete this[_errs].endDip;
            }
        }
    }]);

    return StockIn;
}();

module.exports = StockIn;

/***/ }),
/* 196 */
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _invoiceId = Symbol();
var _productId = Symbol();
var _quantity = Symbol();
var _shortageQuantity = Symbol();
var _density = Symbol();
var _errs = Symbol();

var InvoiceDetail = function () {
    function InvoiceDetail(_ref) {
        var invoiceId = _ref.invoiceId,
            productId = _ref.productId,
            quantity = _ref.quantity,
            shortageQuantity = _ref.shortageQuantity,
            density = _ref.density;

        _classCallCheck(this, InvoiceDetail);

        this[_errs] = {};
        Object.defineProperties(this, {
            invoiceId: {
                enumerable: true,
                configurable: true,
                set: function set() {
                    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

                    this[_invoiceId] = value;
                },
                get: function get() {
                    return this[_invoiceId];
                }
            },
            productId: {
                enumerable: true,
                configurable: true,
                set: function set(value) {
                    var x = parseInt(value, 10);
                    if (x) {
                        this[_productId] = x;
                        delete this[_errs].productId;
                    } else {
                        this[_errs].productId = "productId must be a valid integer";
                    }
                },
                get: function get() {
                    return this[_productId];
                }
            },
            quantity: {
                enumerable: true,
                configurable: true,
                set: function set(value) {
                    var x = parseFloat(value);
                    if (x) {
                        this[_quantity] = x;
                        delete this[_errs].quantity;
                    } else {
                        this[_errs].quantity = "Enter a valid quantity";
                    }
                },
                get: function get() {
                    return this[_quantity];
                }
            },
            shortageQuantity: {
                enumerable: true,
                configurable: true,
                set: function set(value) {
                    var v = parseInt(value, 10);
                    if (v >= 0) {
                        this[_shortageQuantity] = value;
                        delete this[_errs].shortageQuantity;
                    } else {
                        this[_errs].shortageQuantity = "shortageQuantity must be a valid integer";
                    }
                },
                get: function get() {
                    return this[_shortageQuantity];
                }
            },
            density: {
                enumerable: true,
                configurable: true,
                set: function set(value) {
                    if (typeof value === "string" && value.length >= 2 && value.length <= 45) {
                        this[_density] = value.toUpperCase();
                        delete this[_errs].density;
                    } else {
                        this[_errs].density = "Please enter base density";
                    }
                },
                get: function get() {
                    return this[_density];
                }
            }
        });

        this.invoiceId = invoiceId;
        this.productId = productId;
        this.quantity = quantity;
        this.shortageQuantity = shortageQuantity;
        this.density = density;
    }

    _createClass(InvoiceDetail, [{
        key: "getErrors",
        value: function getErrors() {
            return this[_errs];
        }
    }, {
        key: "hasError",
        value: function hasError() {
            return Object.keys(this[_errs]).length > 0 ? true : false;
        }
    }]);

    return InvoiceDetail;
}();

module.exports = InvoiceDetail;

/***/ }),
/* 197 */
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _invoiceNumber = Symbol();
var _invoiceDateTime = Symbol();
var _invoiceAmount = Symbol();
var _transportName = Symbol();
var _truckNumber = Symbol();
var _document = Symbol();
var _truckDriverPhone = Symbol();
var _receiveDateTime = Symbol();
var _invoiceId = Symbol();
var _comment = Symbol();
var _errs = Symbol();

var Invoice = function () {
    function Invoice(_ref) {
        var invoiceId = _ref.invoiceId,
            invoiceNumber = _ref.invoiceNumber,
            invoiceDateTime = _ref.invoiceDateTime,
            invoiceAmount = _ref.invoiceAmount,
            transportName = _ref.transportName,
            truckNumber = _ref.truckNumber,
            comment = _ref.comment,
            document = _ref.document,
            truckDriverPhone = _ref.truckDriverPhone,
            receiveDateTime = _ref.receiveDateTime;

        _classCallCheck(this, Invoice);

        this[_errs] = {};
        Object.defineProperties(this, {
            invoiceId: {
                enumerable: true,
                configurable: true,
                set: function set() {
                    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

                    this[_invoiceId] = value;
                },
                get: function get() {
                    return this[_invoiceId];
                }
            },
            invoiceNumber: {
                enumerable: true,
                configurable: true,
                set: function set(value) {
                    if (typeof value === "string" && value.length >= 2 && value.length <= 45) {
                        this[_invoiceNumber] = value.toUpperCase();
                        delete this[_errs].invoiceNumber;
                    } else {
                        this[_errs].invoiceNumber = "Invoice number within 2 to 45 characters";
                    }
                },
                get: function get() {
                    return this[_invoiceNumber];
                }
            },
            invoiceDateTime: {
                enumerable: true,
                configurable: true,
                set: function set(value) {
                    if (value) {
                        var dateTime = value.split("T");
                        var datePattern = /^([0-9]{4})-([0-9]{2})-([0-9]{2})$/;
                        var timePatterm = /^([0-9]{2}):([0-9]{2})$/;
                        if (datePattern.test(dateTime[0]) && timePatterm.test(dateTime[1]) && Date.parse(value)) {
                            this[_invoiceDateTime] = value;
                            delete this[_errs].invoiceDateTime;
                        } else {
                            this[_errs].invoiceDateTime = "please enter a valid invoice date";
                        }
                    } else {
                        this[_errs].invoiceDateTime = "please enter a valid invoice date";
                    }
                },
                get: function get() {
                    return this[_invoiceDateTime];
                }
            },
            receiveDateTime: {
                enumerable: true,
                configurable: true,
                set: function set(value) {
                    if (value) {
                        var dateTime = value.split("T");
                        var datePattern = /^([0-9]{4})-([0-9]{2})-([0-9]{2})$/;
                        var timePatterm = /^([0-9]{2}):([0-9]{2})$/;
                        if (datePattern.test(dateTime[0]) && timePatterm.test(dateTime[1]) && Date.parse(value)) {

                            if (this.invoiceDateTime) {
                                if (new Date(this.invoiceDateTime) <= new Date(value)) {
                                    this[_receiveDateTime] = value;
                                    //this._receiveDateTime = new Date(value);
                                    delete this[_errs].receiveDateTime;
                                } else {
                                    this[_errs].receiveDateTime = "Receive date canot be less than Invoice date";
                                }
                            } else {
                                //delete this._errs.receiveDateTime;
                                this[_errs].receiveDateTime = "Enter invoice date first";
                            }
                        } else {
                            this[_errs].receiveDateTime = "please enter a valid receive date";
                        }
                    } else {
                        this[_errs].receiveDateTime = "please enter a valid receive date";
                    }
                },
                get: function get() {
                    return this[_receiveDateTime];
                }
            },

            invoiceAmount: {
                enumerable: true,
                configurable: true,
                set: function set(value) {
                    var x = parseFloat(value);
                    if (x) {
                        this[_invoiceAmount] = x;
                        delete this[_errs].invoiceAmount;
                    } else {
                        this[_errs].invoiceAmount = "invoiceAmount must be a valid number";
                    }
                },
                get: function get() {
                    return this[_invoiceAmount];
                }
            },
            truckNumber: {
                enumerable: true,
                configurable: true,
                set: function set(value) {
                    if (typeof value === "string" && value.length >= 2 && value.length <= 45) {
                        this[_truckNumber] = value.toUpperCase();
                        delete this[_errs].truckNumber;
                    } else {
                        this[_errs].truckNumber = "Lorry number must be 2 to 45 characters";
                    }
                },
                get: function get() {
                    return this[_truckNumber];
                }
            },
            transportName: {
                enumerable: true,
                configurable: true,
                set: function set() {
                    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

                    this[_transportName] = value.toUpperCase();
                },
                get: function get() {
                    return this[_transportName];
                }
            },
            comment: {
                enumerable: true,
                configurable: true,
                set: function set() {
                    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

                    this[_comment] = value;
                },
                get: function get() {
                    return this[_comment];
                }
            },
            document: {
                enumerable: true,
                configurable: true,
                set: function set() {
                    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

                    this[_document] = value;
                },
                get: function get() {
                    return this[_document];
                }

            },
            truckDriverPhone: {
                enumerable: true,
                configurable: true,
                set: function set() {
                    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

                    this[_truckDriverPhone] = value;
                },
                get: function get() {
                    return this[_truckDriverPhone];
                }
            }
        });

        this.invoiceId = invoiceId;
        this.invoiceNumber = invoiceNumber;
        this.invoiceDateTime = invoiceDateTime;
        this.invoiceAmount = invoiceAmount;
        this.transportName = transportName;
        this.truckNumber = truckNumber;
        this.comment = comment;
        this.document = document;
        this.truckDriverPhone = truckDriverPhone;
        this.receiveDateTime = receiveDateTime;
    }

    _createClass(Invoice, [{
        key: "hasError",
        value: function hasError() {
            return Object.keys(this[_errs]).length > 0 ? true : false;
        }
    }, {
        key: "getErrors",
        value: function getErrors() {
            return this[_errs];
        }
    }]);

    return Invoice;
}();

module.exports = Invoice;

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony export (immutable) */ __webpack_exports__["a"] = unregister;
// In production, we register a service worker to serve assets from local cache.

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.

// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.

function register() {
  if ("production" === 'production' && 'serviceWorker' in navigator) {
    window.addEventListener('load', function () {
      var swUrl = "" + '/service-worker.js';
      navigator.serviceWorker.register(swUrl).then(function (registration) {
        registration.onupdatefound = function () {
          var installingWorker = registration.installing;
          installingWorker.onstatechange = function () {
            if (installingWorker.state === 'installed') {
              if (navigator.serviceWorker.controller) {
                // At this point, the old content will have been purged and
                // the fresh content will have been added to the cache.
                // It's the perfect time to display a "New content is
                // available; please refresh." message in your web app.
                console.log('New content is available; please refresh.');
              } else {
                // At this point, everything has been precached.
                // It's the perfect time to display a
                // "Content is cached for offline use." message.
                console.log('Content is cached for offline use.');
              }
            }
          };
        };
      }).catch(function (error) {
        console.error('Error during service worker registration:', error);
      });
    });
  }
}

function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then(function (registration) {
      registration.unregister();
    });
  }
}

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(7);

var emptyObject = __webpack_require__(45);
var _invariant = __webpack_require__(1);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }
    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isInherited = name in Constructor;
      _invariant(
        !isInherited,
        'ReactClass: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be ' +
          'due to a mixin.',
        name
      );
      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var pSlice = Array.prototype.slice;
var objectKeys = __webpack_require__(202);
var isArguments = __webpack_require__(201);

var deepEqual = module.exports = function (actual, expected, opts) {
  if (!opts) opts = {};
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;

  } else if (actual instanceof Date && expected instanceof Date) {
    return actual.getTime() === expected.getTime();

  // 7.3. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
    return opts.strict ? actual === expected : actual == expected;

  // 7.4. For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else {
    return objEquiv(actual, expected, opts);
  }
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer (x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') return false;
  return true;
}

function objEquiv(a, b, opts) {
  var i, key;
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
    return false;
  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) return false;
  //~~~I've managed to break Object.keys through screwy arguments passing.
  //   Converting to array solves the problem.
  if (isArguments(a)) {
    if (!isArguments(b)) {
      return false;
    }
    a = pSlice.call(a);
    b = pSlice.call(b);
    return deepEqual(a, b, opts);
  }
  if (isBuffer(a)) {
    if (!isBuffer(b)) {
      return false;
    }
    if (a.length !== b.length) return false;
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }
  try {
    var ka = objectKeys(a),
        kb = objectKeys(b);
  } catch (e) {//happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length != kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) return false;
  }
  return typeof a === typeof b;
}


/***/ }),
/* 201 */
/***/ (function(module, exports) {

var supportsArgumentsClass = (function(){
  return Object.prototype.toString.call(arguments)
})() == '[object Arguments]';

exports = module.exports = supportsArgumentsClass ? supported : unsupported;

exports.supported = supported;
function supported(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
};

exports.unsupported = unsupported;
function unsupported(object){
  return object &&
    typeof object == 'object' &&
    typeof object.length == 'number' &&
    Object.prototype.hasOwnProperty.call(object, 'callee') &&
    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
    false;
};


/***/ }),
/* 202 */
/***/ (function(module, exports) {

exports = module.exports = typeof Object.keys === 'function'
  ? Object.keys : shim;

exports.shim = shim;
function shim (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
}


/***/ }),
/* 203 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



var camelize = __webpack_require__(206);

var msPattern = /^-ms-/;

/**
 * Camelcases a hyphenated CSS property name, for example:
 *
 *   > camelizeStyleName('background-color')
 *   < "backgroundColor"
 *   > camelizeStyleName('-moz-transition')
 *   < "MozTransition"
 *   > camelizeStyleName('-ms-transition')
 *   < "msTransition"
 *
 * As Andi Smith suggests
 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
 * is converted to lowercase `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function camelizeStyleName(string) {
  return camelize(string.replace(msPattern, 'ms-'));
}

module.exports = camelizeStyleName;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

var isTextNode = __webpack_require__(216);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var invariant = __webpack_require__(1);

/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */
function toArray(obj) {
  var length = obj.length;

  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
  // in old versions of Safari).
  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;

  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;

  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;

  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;

  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.
  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {
      // IE < 9 does not support Array#slice on collections objects
    }
  }

  // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.
  var ret = Array(length);
  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }
  return ret;
}

/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */
function hasArrayNature(obj) {
  return (
    // not null/false
    !!obj && (
    // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') &&
    // quacks like an array
    'length' in obj &&
    // not window
    !('setInterval' in obj) &&
    // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && (
    // a real array
    Array.isArray(obj) ||
    // arguments
    'callee' in obj ||
    // HTMLCollection/NodeList
    'item' in obj)
  );
}

/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */
function createArrayFromMixed(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray(obj);
  }
}

module.exports = createArrayFromMixed;

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/*eslint-disable fb-www/unsafe-html*/

var ExecutionEnvironment = __webpack_require__(12);

var createArrayFromMixed = __webpack_require__(209);
var getMarkupWrap = __webpack_require__(211);
var invariant = __webpack_require__(1);

/**
 * Dummy container used to render all markup.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Pattern used by `getNodeName`.
 */
var nodeNamePattern = /^\s*<(\w+)/;

/**
 * Extracts the `nodeName` of the first element in a string of markup.
 *
 * @param {string} markup String of markup.
 * @return {?string} Node name of the supplied markup.
 */
function getNodeName(markup) {
  var nodeNameMatch = markup.match(nodeNamePattern);
  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
}

/**
 * Creates an array containing the nodes rendered from the supplied markup. The
 * optionally supplied `handleScript` function will be invoked once for each
 * <script> element that is rendered. If no `handleScript` function is supplied,
 * an exception is thrown if any <script> elements are rendered.
 *
 * @param {string} markup A string of valid HTML markup.
 * @param {?function} handleScript Invoked once for each rendered <script>.
 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
 */
function createNodesFromMarkup(markup, handleScript) {
  var node = dummyNode;
  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
  var nodeName = getNodeName(markup);

  var wrap = nodeName && getMarkupWrap(nodeName);
  if (wrap) {
    node.innerHTML = wrap[1] + markup + wrap[2];

    var wrapDepth = wrap[0];
    while (wrapDepth--) {
      node = node.lastChild;
    }
  } else {
    node.innerHTML = markup;
  }

  var scripts = node.getElementsByTagName('script');
  if (scripts.length) {
    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
    createArrayFromMixed(scripts).forEach(handleScript);
  }

  var nodes = Array.from(node.childNodes);
  while (node.lastChild) {
    node.removeChild(node.lastChild);
  }
  return nodes;
}

module.exports = createNodesFromMarkup;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/*eslint-disable fb-www/unsafe-html */

var ExecutionEnvironment = __webpack_require__(12);

var invariant = __webpack_require__(1);

/**
 * Dummy container used to detect which wraps are necessary.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Some browsers cannot use `innerHTML` to render certain elements standalone,
 * so we wrap them, render the wrapped nodes, then extract the desired node.
 *
 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
 */

var shouldWrap = {};

var selectWrap = [1, '<select multiple="true">', '</select>'];
var tableWrap = [1, '<table>', '</table>'];
var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];

var markupWrap = {
  '*': [1, '?<div>', '</div>'],

  'area': [1, '<map>', '</map>'],
  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
  'legend': [1, '<fieldset>', '</fieldset>'],
  'param': [1, '<object>', '</object>'],
  'tr': [2, '<table><tbody>', '</tbody></table>'],

  'optgroup': selectWrap,
  'option': selectWrap,

  'caption': tableWrap,
  'colgroup': tableWrap,
  'tbody': tableWrap,
  'tfoot': tableWrap,
  'thead': tableWrap,

  'td': trWrap,
  'th': trWrap
};

// Initialize the SVG elements since we know they'll always need to be wrapped
// consistently. If they are created inside a <div> they will be initialized in
// the wrong namespace (and will not display).
var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
svgElements.forEach(function (nodeName) {
  markupWrap[nodeName] = svgWrap;
  shouldWrap[nodeName] = true;
});

/**
 * Gets the markup wrap configuration for the supplied `nodeName`.
 *
 * NOTE: This lazily detects which wraps are necessary for the current browser.
 *
 * @param {string} nodeName Lowercase `nodeName`.
 * @return {?array} Markup wrap configuration, if applicable.
 */
function getMarkupWrap(nodeName) {
  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
  if (!markupWrap.hasOwnProperty(nodeName)) {
    nodeName = '*';
  }
  if (!shouldWrap.hasOwnProperty(nodeName)) {
    if (nodeName === '*') {
      dummyNode.innerHTML = '<link />';
    } else {
      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
    }
    shouldWrap[nodeName] = !dummyNode.firstChild;
  }
  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
}

module.exports = getMarkupWrap;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */

function getUnboundedScrollPosition(scrollable) {
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    return {
      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
    };
  }
  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

module.exports = getUnboundedScrollPosition;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(213);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var isNode = __webpack_require__(215);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

module.exports.Dispatcher = __webpack_require__(219);


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule Dispatcher
 * 
 * @preventMunge
 */



exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var invariant = __webpack_require__(1);

var _prefix = 'ID_';

/**
 * Dispatcher is used to broadcast payloads to registered callbacks. This is
 * different from generic pub-sub systems in two ways:
 *
 *   1) Callbacks are not subscribed to particular events. Every payload is
 *      dispatched to every registered callback.
 *   2) Callbacks can be deferred in whole or part until other callbacks have
 *      been executed.
 *
 * For example, consider this hypothetical flight destination form, which
 * selects a default city when a country is selected:
 *
 *   var flightDispatcher = new Dispatcher();
 *
 *   // Keeps track of which country is selected
 *   var CountryStore = {country: null};
 *
 *   // Keeps track of which city is selected
 *   var CityStore = {city: null};
 *
 *   // Keeps track of the base flight price of the selected city
 *   var FlightPriceStore = {price: null}
 *
 * When a user changes the selected city, we dispatch the payload:
 *
 *   flightDispatcher.dispatch({
 *     actionType: 'city-update',
 *     selectedCity: 'paris'
 *   });
 *
 * This payload is digested by `CityStore`:
 *
 *   flightDispatcher.register(function(payload) {
 *     if (payload.actionType === 'city-update') {
 *       CityStore.city = payload.selectedCity;
 *     }
 *   });
 *
 * When the user selects a country, we dispatch the payload:
 *
 *   flightDispatcher.dispatch({
 *     actionType: 'country-update',
 *     selectedCountry: 'australia'
 *   });
 *
 * This payload is digested by both stores:
 *
 *   CountryStore.dispatchToken = flightDispatcher.register(function(payload) {
 *     if (payload.actionType === 'country-update') {
 *       CountryStore.country = payload.selectedCountry;
 *     }
 *   });
 *
 * When the callback to update `CountryStore` is registered, we save a reference
 * to the returned token. Using this token with `waitFor()`, we can guarantee
 * that `CountryStore` is updated before the callback that updates `CityStore`
 * needs to query its data.
 *
 *   CityStore.dispatchToken = flightDispatcher.register(function(payload) {
 *     if (payload.actionType === 'country-update') {
 *       // `CountryStore.country` may not be updated.
 *       flightDispatcher.waitFor([CountryStore.dispatchToken]);
 *       // `CountryStore.country` is now guaranteed to be updated.
 *
 *       // Select the default city for the new country
 *       CityStore.city = getDefaultCityForCountry(CountryStore.country);
 *     }
 *   });
 *
 * The usage of `waitFor()` can be chained, for example:
 *
 *   FlightPriceStore.dispatchToken =
 *     flightDispatcher.register(function(payload) {
 *       switch (payload.actionType) {
 *         case 'country-update':
 *         case 'city-update':
 *           flightDispatcher.waitFor([CityStore.dispatchToken]);
 *           FlightPriceStore.price =
 *             getFlightPriceStore(CountryStore.country, CityStore.city);
 *           break;
 *     }
 *   });
 *
 * The `country-update` payload will be guaranteed to invoke the stores'
 * registered callbacks in order: `CountryStore`, `CityStore`, then
 * `FlightPriceStore`.
 */

var Dispatcher = (function () {
  function Dispatcher() {
    _classCallCheck(this, Dispatcher);

    this._callbacks = {};
    this._isDispatching = false;
    this._isHandled = {};
    this._isPending = {};
    this._lastID = 1;
  }

  /**
   * Registers a callback to be invoked with every dispatched payload. Returns
   * a token that can be used with `waitFor()`.
   */

  Dispatcher.prototype.register = function register(callback) {
    var id = _prefix + this._lastID++;
    this._callbacks[id] = callback;
    return id;
  };

  /**
   * Removes a callback based on its token.
   */

  Dispatcher.prototype.unregister = function unregister(id) {
    !this._callbacks[id] ?  false ? invariant(false, 'Dispatcher.unregister(...): `%s` does not map to a registered callback.', id) : invariant(false) : undefined;
    delete this._callbacks[id];
  };

  /**
   * Waits for the callbacks specified to be invoked before continuing execution
   * of the current callback. This method should only be used by a callback in
   * response to a dispatched payload.
   */

  Dispatcher.prototype.waitFor = function waitFor(ids) {
    !this._isDispatching ?  false ? invariant(false, 'Dispatcher.waitFor(...): Must be invoked while dispatching.') : invariant(false) : undefined;
    for (var ii = 0; ii < ids.length; ii++) {
      var id = ids[ii];
      if (this._isPending[id]) {
        !this._isHandled[id] ?  false ? invariant(false, 'Dispatcher.waitFor(...): Circular dependency detected while ' + 'waiting for `%s`.', id) : invariant(false) : undefined;
        continue;
      }
      !this._callbacks[id] ?  false ? invariant(false, 'Dispatcher.waitFor(...): `%s` does not map to a registered callback.', id) : invariant(false) : undefined;
      this._invokeCallback(id);
    }
  };

  /**
   * Dispatches a payload to all registered callbacks.
   */

  Dispatcher.prototype.dispatch = function dispatch(payload) {
    !!this._isDispatching ?  false ? invariant(false, 'Dispatch.dispatch(...): Cannot dispatch in the middle of a dispatch.') : invariant(false) : undefined;
    this._startDispatching(payload);
    try {
      for (var id in this._callbacks) {
        if (this._isPending[id]) {
          continue;
        }
        this._invokeCallback(id);
      }
    } finally {
      this._stopDispatching();
    }
  };

  /**
   * Is this Dispatcher currently dispatching.
   */

  Dispatcher.prototype.isDispatching = function isDispatching() {
    return this._isDispatching;
  };

  /**
   * Call the callback stored with the given id. Also do some internal
   * bookkeeping.
   *
   * @internal
   */

  Dispatcher.prototype._invokeCallback = function _invokeCallback(id) {
    this._isPending[id] = true;
    this._callbacks[id](this._pendingPayload);
    this._isHandled[id] = true;
  };

  /**
   * Set up bookkeeping needed when dispatching.
   *
   * @internal
   */

  Dispatcher.prototype._startDispatching = function _startDispatching(payload) {
    for (var id in this._callbacks) {
      this._isPending[id] = false;
      this._isHandled[id] = false;
    }
    this._pendingPayload = payload;
    this._isDispatching = true;
  };

  /**
   * Clear bookkeeping used for dispatching.
   *
   * @internal
   */

  Dispatcher.prototype._stopDispatching = function _stopDispatching() {
    delete this._pendingPayload;
    this._isDispatching = false;
  };

  return Dispatcher;
})();

module.exports = Dispatcher;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var _slice = Array.prototype.slice;
exports.loopAsync = loopAsync;

function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var sync = false,
      hasNext = false,
      doneArgs = undefined;

  function done() {
    isDone = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      doneArgs = [].concat(_slice.call(arguments));
      return;
    }

    callback.apply(this, arguments);
  }

  function next() {
    if (isDone) {
      return;
    }

    hasNext = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      return;
    }

    sync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work.call(this, currentTurn++, next, done);
    }

    sync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(this, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  }

  next();
}

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _invariant = __webpack_require__(10);

var _invariant2 = _interopRequireDefault(_invariant);

var _Actions = __webpack_require__(30);

var _PathUtils = __webpack_require__(23);

var _ExecutionEnvironment = __webpack_require__(46);

var _DOMUtils = __webpack_require__(63);

var _DOMStateStorage = __webpack_require__(100);

var _createDOMHistory = __webpack_require__(101);

var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);

/**
 * Creates and returns a history object that uses HTML5's history API
 * (pushState, replaceState, and the popstate event) to manage history.
 * This is the recommended method of managing history in browsers because
 * it provides the cleanest URLs.
 *
 * Note: In browsers that do not support the HTML5 history API full
 * page reloads will be used to preserve URLs.
 */
function createBrowserHistory() {
  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Browser history needs a DOM') : _invariant2['default'](false) : undefined;

  var forceRefresh = options.forceRefresh;

  var isSupported = _DOMUtils.supportsHistory();
  var useRefresh = !isSupported || forceRefresh;

  function getCurrentLocation(historyState) {
    try {
      historyState = historyState || window.history.state || {};
    } catch (e) {
      historyState = {};
    }

    var path = _DOMUtils.getWindowPath();
    var _historyState = historyState;
    var key = _historyState.key;

    var state = undefined;
    if (key) {
      state = _DOMStateStorage.readState(key);
    } else {
      state = null;
      key = history.createKey();

      if (isSupported) window.history.replaceState(_extends({}, historyState, { key: key }), null);
    }

    var location = _PathUtils.parsePath(path);

    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
  }

  function startPopStateListener(_ref) {
    var transitionTo = _ref.transitionTo;

    function popStateListener(event) {
      if (event.state === undefined) return; // Ignore extraneous popstate events in WebKit.

      transitionTo(getCurrentLocation(event.state));
    }

    _DOMUtils.addEventListener(window, 'popstate', popStateListener);

    return function () {
      _DOMUtils.removeEventListener(window, 'popstate', popStateListener);
    };
  }

  function finishTransition(location) {
    var basename = location.basename;
    var pathname = location.pathname;
    var search = location.search;
    var hash = location.hash;
    var state = location.state;
    var action = location.action;
    var key = location.key;

    if (action === _Actions.POP) return; // Nothing to do.

    _DOMStateStorage.saveState(key, state);

    var path = (basename || '') + pathname + search + hash;
    var historyState = {
      key: key
    };

    if (action === _Actions.PUSH) {
      if (useRefresh) {
        window.location.href = path;
        return false; // Prevent location update.
      } else {
          window.history.pushState(historyState, null, path);
        }
    } else {
      // REPLACE
      if (useRefresh) {
        window.location.replace(path);
        return false; // Prevent location update.
      } else {
          window.history.replaceState(historyState, null, path);
        }
    }
  }

  var history = _createDOMHistory2['default'](_extends({}, options, {
    getCurrentLocation: getCurrentLocation,
    finishTransition: finishTransition,
    saveState: _DOMStateStorage.saveState
  }));

  var listenerCount = 0,
      stopPopStateListener = undefined;

  function listenBefore(listener) {
    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);

    var unlisten = history.listenBefore(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopPopStateListener();
    };
  }

  function listen(listener) {
    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);

    var unlisten = history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopPopStateListener();
    };
  }

  // deprecated
  function registerTransitionHook(hook) {
    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);

    history.registerTransitionHook(hook);
  }

  // deprecated
  function unregisterTransitionHook(hook) {
    history.unregisterTransitionHook(hook);

    if (--listenerCount === 0) stopPopStateListener();
  }

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen,
    registerTransitionHook: registerTransitionHook,
    unregisterTransitionHook: unregisterTransitionHook
  });
}

exports['default'] = createBrowserHistory;
module.exports = exports['default'];

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(15);

var _warning2 = _interopRequireDefault(_warning);

var _Actions = __webpack_require__(30);

var _PathUtils = __webpack_require__(23);

function createLocation() {
  var location = arguments.length <= 0 || arguments[0] === undefined ? '/' : arguments[0];
  var action = arguments.length <= 1 || arguments[1] === undefined ? _Actions.POP : arguments[1];
  var key = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];

  var _fourthArg = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];

  if (typeof location === 'string') location = _PathUtils.parsePath(location);

  if (typeof action === 'object') {
     false ? _warning2['default'](false, 'The state (2nd) argument to createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;

    location = _extends({}, location, { state: action });

    action = key || _Actions.POP;
    key = _fourthArg;
  }

  var pathname = location.pathname || '/';
  var search = location.search || '';
  var hash = location.hash || '';
  var state = location.state || null;

  return {
    pathname: pathname,
    search: search,
    hash: hash,
    state: state,
    action: action,
    key: key
  };
}

exports['default'] = createLocation;
module.exports = exports['default'];

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(15);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(10);

var _invariant2 = _interopRequireDefault(_invariant);

var _PathUtils = __webpack_require__(23);

var _Actions = __webpack_require__(30);

var _createHistory = __webpack_require__(103);

var _createHistory2 = _interopRequireDefault(_createHistory);

function createStateStorage(entries) {
  return entries.filter(function (entry) {
    return entry.state;
  }).reduce(function (memo, entry) {
    memo[entry.key] = entry.state;
    return memo;
  }, {});
}

function createMemoryHistory() {
  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  if (Array.isArray(options)) {
    options = { entries: options };
  } else if (typeof options === 'string') {
    options = { entries: [options] };
  }

  var history = _createHistory2['default'](_extends({}, options, {
    getCurrentLocation: getCurrentLocation,
    finishTransition: finishTransition,
    saveState: saveState,
    go: go
  }));

  var _options = options;
  var entries = _options.entries;
  var current = _options.current;

  if (typeof entries === 'string') {
    entries = [entries];
  } else if (!Array.isArray(entries)) {
    entries = ['/'];
  }

  entries = entries.map(function (entry) {
    var key = history.createKey();

    if (typeof entry === 'string') return { pathname: entry, key: key };

    if (typeof entry === 'object' && entry) return _extends({}, entry, { key: key });

     true ?  false ? _invariant2['default'](false, 'Unable to create history entry from %s', entry) : _invariant2['default'](false) : undefined;
  });

  if (current == null) {
    current = entries.length - 1;
  } else {
    !(current >= 0 && current < entries.length) ?  false ? _invariant2['default'](false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : _invariant2['default'](false) : undefined;
  }

  var storage = createStateStorage(entries);

  function saveState(key, state) {
    storage[key] = state;
  }

  function readState(key) {
    return storage[key];
  }

  function getCurrentLocation() {
    var entry = entries[current];
    var basename = entry.basename;
    var pathname = entry.pathname;
    var search = entry.search;

    var path = (basename || '') + pathname + (search || '');

    var key = undefined,
        state = undefined;
    if (entry.key) {
      key = entry.key;
      state = readState(key);
    } else {
      key = history.createKey();
      state = null;
      entry.key = key;
    }

    var location = _PathUtils.parsePath(path);

    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
  }

  function canGo(n) {
    var index = current + n;
    return index >= 0 && index < entries.length;
  }

  function go(n) {
    if (n) {
      if (!canGo(n)) {
         false ? _warning2['default'](false, 'Cannot go(%s) there is not enough history', n) : undefined;
        return;
      }

      current += n;

      var currentLocation = getCurrentLocation();

      // change action to POP
      history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
    }
  }

  function finishTransition(location) {
    switch (location.action) {
      case _Actions.PUSH:
        current += 1;

        // if we are not on the top of stack
        // remove rest and push new
        if (current < entries.length) entries.splice(current);

        entries.push(location);
        saveState(location.key, location.state);
        break;
      case _Actions.REPLACE:
        entries[current] = location;
        saveState(location.key, location.state);
        break;
    }
  }

  return history;
}

exports['default'] = createMemoryHistory;
module.exports = exports['default'];

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true
};

var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
        var keys = Object.getOwnPropertyNames(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(105);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._61);
  p._81 = 1;
  p._65 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._81 === 3) {
            val = val._65;
          }
          if (val._81 === 1) return res(i, val._65);
          if (val._81 === 2) reject(val._65);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(105);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._10 = null;
  Promise._97 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._10 = function (promise) {
    if (
      promise._81 === 2 && // IS REJECTED
      rejections[promise._72]
    ) {
      if (rejections[promise._72].logged) {
        onHandled(promise._72);
      } else {
        clearTimeout(rejections[promise._72].timeout);
      }
      delete rejections[promise._72];
    }
  };
  Promise._97 = function (promise, err) {
    if (promise._45 === 0) { // not yet handled
      promise._72 = id++;
      rejections[promise._72] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._72),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



if (false) {
  var invariant = require('fbjs/lib/invariant');
  var warning = require('fbjs/lib/warning');
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(13);
var invariant = __webpack_require__(1);
var ReactPropTypesSecret = __webpack_require__(107);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(13);
var invariant = __webpack_require__(1);
var warning = __webpack_require__(3);

var ReactPropTypesSecret = __webpack_require__(107);
var checkPropTypes = __webpack_require__(227);

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning(
          false,
          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(334);

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str) {
	if (typeof str !== 'string') {
		return {};
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return {};
	}

	return str.split('&').reduce(function (ret, param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		key = decodeURIComponent(key);

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		if (!ret.hasOwnProperty(key)) {
			ret[key] = val;
		} else if (Array.isArray(ret[key])) {
			ret[key].push(val);
		} else {
			ret[key] = [ret[key], val];
		}

		return ret;
	}, {});
};

exports.stringify = function (obj) {
	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return key;
		}

		if (Array.isArray(val)) {
			return val.slice().sort().map(function (val2) {
				return strictUriEncode(key) + '=' + strictUriEncode(val2);
			}).join('&');
		}

		return strictUriEncode(key) + '=' + strictUriEncode(val);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)))

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ARIADOMPropertyConfig = {
  Properties: {
    // Global States and Properties
    'aria-current': 0, // state
    'aria-details': 0,
    'aria-disabled': 0, // state
    'aria-hidden': 0, // state
    'aria-invalid': 0, // state
    'aria-keyshortcuts': 0,
    'aria-label': 0,
    'aria-roledescription': 0,
    // Widget Attributes
    'aria-autocomplete': 0,
    'aria-checked': 0,
    'aria-expanded': 0,
    'aria-haspopup': 0,
    'aria-level': 0,
    'aria-modal': 0,
    'aria-multiline': 0,
    'aria-multiselectable': 0,
    'aria-orientation': 0,
    'aria-placeholder': 0,
    'aria-pressed': 0,
    'aria-readonly': 0,
    'aria-required': 0,
    'aria-selected': 0,
    'aria-sort': 0,
    'aria-valuemax': 0,
    'aria-valuemin': 0,
    'aria-valuenow': 0,
    'aria-valuetext': 0,
    // Live Region Attributes
    'aria-atomic': 0,
    'aria-busy': 0,
    'aria-live': 0,
    'aria-relevant': 0,
    // Drag-and-Drop Attributes
    'aria-dropeffect': 0,
    'aria-grabbed': 0,
    // Relationship Attributes
    'aria-activedescendant': 0,
    'aria-colcount': 0,
    'aria-colindex': 0,
    'aria-colspan': 0,
    'aria-controls': 0,
    'aria-describedby': 0,
    'aria-errormessage': 0,
    'aria-flowto': 0,
    'aria-labelledby': 0,
    'aria-owns': 0,
    'aria-posinset': 0,
    'aria-rowcount': 0,
    'aria-rowindex': 0,
    'aria-rowspan': 0,
    'aria-setsize': 0
  },
  DOMAttributeNames: {},
  DOMPropertyNames: {}
};

module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentTree = __webpack_require__(8);

var focusNode = __webpack_require__(98);

var AutoFocusUtils = {
  focusDOMComponent: function () {
    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
  }
};

module.exports = AutoFocusUtils;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(41);
var ExecutionEnvironment = __webpack_require__(12);
var FallbackCompositionState = __webpack_require__(240);
var SyntheticCompositionEvent = __webpack_require__(277);
var SyntheticInputEvent = __webpack_require__(280);

var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
var START_KEYCODE = 229;

var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;

var documentMode = null;
if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
  documentMode = document.documentMode;
}

// Webkit offers a very useful `textInput` event that can be used to
// directly represent `beforeInput`. The IE `textinput` event is not as
// useful, so we don't use it.
var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();

// In IE9+, we have access to composition events, but the data supplied
// by the native compositionend event may be incorrect. Japanese ideographic
// spaces, for instance (\u3000) are not recorded correctly.
var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);

/**
 * Opera <= 12 includes TextEvent in window, but does not fire
 * text input events. Rely on keypress instead.
 */
function isPresto() {
  var opera = window.opera;
  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
}

var SPACEBAR_CODE = 32;
var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

// Events and their corresponding property names.
var eventTypes = {
  beforeInput: {
    phasedRegistrationNames: {
      bubbled: 'onBeforeInput',
      captured: 'onBeforeInputCapture'
    },
    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
  },
  compositionEnd: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionEnd',
      captured: 'onCompositionEndCapture'
    },
    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionStart: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionStart',
      captured: 'onCompositionStartCapture'
    },
    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionUpdate: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionUpdate',
      captured: 'onCompositionUpdateCapture'
    },
    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  }
};

// Track whether we've ever handled a keypress on the space key.
var hasSpaceKeypress = false;

/**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */
function isKeypressCommand(nativeEvent) {
  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
  !(nativeEvent.ctrlKey && nativeEvent.altKey);
}

/**
 * Translate native top level events into event types.
 *
 * @param {string} topLevelType
 * @return {object}
 */
function getCompositionEventType(topLevelType) {
  switch (topLevelType) {
    case 'topCompositionStart':
      return eventTypes.compositionStart;
    case 'topCompositionEnd':
      return eventTypes.compositionEnd;
    case 'topCompositionUpdate':
      return eventTypes.compositionUpdate;
  }
}

/**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionStart(topLevelType, nativeEvent) {
  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
}

/**
 * Does our fallback mode think that this event is the end of composition?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionEnd(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topKeyUp':
      // Command keys insert or clear IME input.
      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
    case 'topKeyDown':
      // Expect IME keyCode on each keydown. If we get any other
      // code we must have exited earlier.
      return nativeEvent.keyCode !== START_KEYCODE;
    case 'topKeyPress':
    case 'topMouseDown':
    case 'topBlur':
      // Events are not possible without cancelling IME.
      return true;
    default:
      return false;
  }
}

/**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */
function getDataFromCustomEvent(nativeEvent) {
  var detail = nativeEvent.detail;
  if (typeof detail === 'object' && 'data' in detail) {
    return detail.data;
  }
  return null;
}

// Track the current IME composition fallback object, if any.
var currentComposition = null;

/**
 * @return {?object} A SyntheticCompositionEvent.
 */
function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var eventType;
  var fallbackData;

  if (canUseCompositionEvent) {
    eventType = getCompositionEventType(topLevelType);
  } else if (!currentComposition) {
    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
      eventType = eventTypes.compositionStart;
    }
  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
    eventType = eventTypes.compositionEnd;
  }

  if (!eventType) {
    return null;
  }

  if (useFallbackCompositionData) {
    // The current composition is stored statically and must not be
    // overwritten while composition continues.
    if (!currentComposition && eventType === eventTypes.compositionStart) {
      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
    } else if (eventType === eventTypes.compositionEnd) {
      if (currentComposition) {
        fallbackData = currentComposition.getData();
      }
    }
  }

  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);

  if (fallbackData) {
    // Inject data generated from fallback path into the synthetic event.
    // This matches the property of native CompositionEventInterface.
    event.data = fallbackData;
  } else {
    var customData = getDataFromCustomEvent(nativeEvent);
    if (customData !== null) {
      event.data = customData;
    }
  }

  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The string corresponding to this `beforeInput` event.
 */
function getNativeBeforeInputChars(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topCompositionEnd':
      return getDataFromCustomEvent(nativeEvent);
    case 'topKeyPress':
      /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */
      var which = nativeEvent.which;
      if (which !== SPACEBAR_CODE) {
        return null;
      }

      hasSpaceKeypress = true;
      return SPACEBAR_CHAR;

    case 'topTextInput':
      // Record the characters to be added to the DOM.
      var chars = nativeEvent.data;

      // If it's a spacebar character, assume that we have already handled
      // it at the keypress level and bail immediately. Android Chrome
      // doesn't give us keycodes, so we need to blacklist it.
      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
        return null;
      }

      return chars;

    default:
      // For other native event types, do nothing.
      return null;
  }
}

/**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 *
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The fallback string for this `beforeInput` event.
 */
function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
  // If we are currently composing (IME) and using a fallback to do so,
  // try to extract the composed characters from the fallback object.
  // If composition event is available, we extract a string only at
  // compositionevent, otherwise extract it at fallback events.
  if (currentComposition) {
    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
      var chars = currentComposition.getData();
      FallbackCompositionState.release(currentComposition);
      currentComposition = null;
      return chars;
    }
    return null;
  }

  switch (topLevelType) {
    case 'topPaste':
      // If a paste event occurs after a keypress, throw out the input
      // chars. Paste events should not lead to BeforeInput events.
      return null;
    case 'topKeyPress':
      /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */
      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
        return String.fromCharCode(nativeEvent.which);
      }
      return null;
    case 'topCompositionEnd':
      return useFallbackCompositionData ? null : nativeEvent.data;
    default:
      return null;
  }
}

/**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */
function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var chars;

  if (canUseTextInputEvent) {
    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
  } else {
    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
  }

  // If no characters are being inserted, no BeforeInput event should
  // be fired.
  if (!chars) {
    return null;
  }

  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);

  event.data = chars;
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */
var BeforeInputEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
  }
};

module.exports = BeforeInputEventPlugin;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var CSSProperty = __webpack_require__(108);
var ExecutionEnvironment = __webpack_require__(12);
var ReactInstrumentation = __webpack_require__(14);

var camelizeStyleName = __webpack_require__(207);
var dangerousStyleValue = __webpack_require__(286);
var hyphenateStyleName = __webpack_require__(214);
var memoizeStringOnly = __webpack_require__(217);
var warning = __webpack_require__(3);

var processStyleName = memoizeStringOnly(function (styleName) {
  return hyphenateStyleName(styleName);
});

var hasShorthandPropertyBug = false;
var styleFloatAccessor = 'cssFloat';
if (ExecutionEnvironment.canUseDOM) {
  var tempStyle = document.createElement('div').style;
  try {
    // IE8 throws "Invalid argument." if resetting shorthand style properties.
    tempStyle.font = '';
  } catch (e) {
    hasShorthandPropertyBug = true;
  }
  // IE8 only supports accessing cssFloat (standard) as styleFloat
  if (document.documentElement.style.cssFloat === undefined) {
    styleFloatAccessor = 'styleFloat';
  }
}

if (false) {
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

  // style values shouldn't contain a semicolon
  var badStyleValueWithSemicolonPattern = /;\s*$/;

  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;

  var warnHyphenatedStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
  };

  var warnBadVendoredStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
  };

  var warnStyleValueWithSemicolon = function (name, value, owner) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
  };

  var warnStyleValueIsNaN = function (name, value, owner) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;
    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
  };

  var checkRenderMessage = function (owner) {
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' Check the render method of `' + name + '`.';
      }
    }
    return '';
  };

  /**
   * @param {string} name
   * @param {*} value
   * @param {ReactDOMComponent} component
   */
  var warnValidStyle = function (name, value, component) {
    var owner;
    if (component) {
      owner = component._currentElement._owner;
    }
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name, owner);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name, owner);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value, owner);
    }

    if (typeof value === 'number' && isNaN(value)) {
      warnStyleValueIsNaN(name, value, owner);
    }
  };
}

/**
 * Operations for dealing with CSS properties.
 */
var CSSPropertyOperations = {
  /**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @param {ReactDOMComponent} component
   * @return {?string}
   */
  createMarkupForStyles: function (styles, component) {
    var serialized = '';
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      var styleValue = styles[styleName];
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styleValue, component);
        }
      }
      if (styleValue != null) {
        serialized += processStyleName(styleName) + ':';
        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
      }
    }
    return serialized || null;
  },

  /**
   * Sets the value for multiple styles on a node.  If a value is specified as
   * '' (empty string), the corresponding style property will be unset.
   *
   * @param {DOMElement} node
   * @param {object} styles
   * @param {ReactDOMComponent} component
   */
  setValueForStyles: function (node, styles, component) {
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: component._debugID,
        type: 'update styles',
        payload: styles
      });
    }

    var style = node.style;
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styles[styleName], component);
        }
      }
      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
      if (styleName === 'float' || styleName === 'cssFloat') {
        styleName = styleFloatAccessor;
      }
      if (isCustomProperty) {
        style.setProperty(styleName, styleValue);
      } else if (styleValue) {
        style[styleName] = styleValue;
      } else {
        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
        if (expansion) {
          // Shorthand property that IE8 won't like unsetting, so unset each
          // component to placate it
          for (var individualStyleName in expansion) {
            style[individualStyleName] = '';
          }
        } else {
          style[styleName] = '';
        }
      }
    }
  }
};

module.exports = CSSPropertyOperations;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(40);
var EventPropagators = __webpack_require__(41);
var ExecutionEnvironment = __webpack_require__(12);
var ReactDOMComponentTree = __webpack_require__(8);
var ReactUpdates = __webpack_require__(16);
var SyntheticEvent = __webpack_require__(19);

var inputValueTracking = __webpack_require__(124);
var getEventTarget = __webpack_require__(79);
var isEventSupported = __webpack_require__(80);
var isTextInputElement = __webpack_require__(126);

var eventTypes = {
  change: {
    phasedRegistrationNames: {
      bubbled: 'onChange',
      captured: 'onChangeCapture'
    },
    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
  }
};

function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
  event.type = 'change';
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}
/**
 * For IE shims
 */
var activeElement = null;
var activeElementInst = null;

/**
 * SECTION: handle `change` event
 */
function shouldUseChangeEvent(elem) {
  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
}

var doesChangeEventBubble = false;
if (ExecutionEnvironment.canUseDOM) {
  // See `handleChange` comment below
  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
}

function manualDispatchChangeEvent(nativeEvent) {
  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));

  // If change and propertychange bubbled, we'd just bind to it like all the
  // other events and have it go through ReactBrowserEventEmitter. Since it
  // doesn't, we manually listen for the events and so we have to enqueue and
  // process the abstract event manually.
  //
  // Batching is necessary here in order to ensure that all event handlers run
  // before the next rerender (including event handlers attached to ancestor
  // elements instead of directly on the input). Without this, controlled
  // components don't work properly in conjunction with event bubbling because
  // the component is rerendered and the value reverted before all the event
  // handlers can run. See https://github.com/facebook/react/issues/708.
  ReactUpdates.batchedUpdates(runEventInBatch, event);
}

function runEventInBatch(event) {
  EventPluginHub.enqueueEvents(event);
  EventPluginHub.processEventQueue(false);
}

function startWatchingForChangeEventIE8(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
}

function stopWatchingForChangeEventIE8() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
  activeElement = null;
  activeElementInst = null;
}

function getInstIfValueChanged(targetInst, nativeEvent) {
  var updated = inputValueTracking.updateValueIfChanged(targetInst);
  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;

  if (updated || simulated) {
    return targetInst;
  }
}

function getTargetInstForChangeEvent(topLevelType, targetInst) {
  if (topLevelType === 'topChange') {
    return targetInst;
  }
}

function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForChangeEventIE8();
    startWatchingForChangeEventIE8(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForChangeEventIE8();
  }
}

/**
 * SECTION: handle `input` event
 */
var isInputEventSupported = false;
if (ExecutionEnvironment.canUseDOM) {
  // IE9 claims to support the input event but fails to trigger it when
  // deleting text, so we ignore its input events.

  isInputEventSupported = isEventSupported('input') && (!('documentMode' in document) || document.documentMode > 9);
}

/**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */
function startWatchingForValueChange(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onpropertychange', handlePropertyChange);
}

/**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */
function stopWatchingForValueChange() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onpropertychange', handlePropertyChange);

  activeElement = null;
  activeElementInst = null;
}

/**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */
function handlePropertyChange(nativeEvent) {
  if (nativeEvent.propertyName !== 'value') {
    return;
  }
  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
    manualDispatchChangeEvent(nativeEvent);
  }
}

function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // In IE8, we can capture almost all .value changes by adding a
    // propertychange handler and looking for events with propertyName
    // equal to 'value'
    // In IE9, propertychange fires for most input events but is buggy and
    // doesn't fire when text is deleted, but conveniently, selectionchange
    // appears to fire in all of the remaining cases so we catch those and
    // forward the event if the value has changed
    // In either case, we don't want to call the event handler if the value
    // is changed from JS so we redefine a setter for `.value` that updates
    // our activeElementValue variable, allowing us to ignore those changes
    //
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForValueChange();
    startWatchingForValueChange(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForValueChange();
  }
}

// For IE8 and IE9.
function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
    // On the selectionchange event, the target is just document which isn't
    // helpful for us so just check activeElement instead.
    //
    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
    // propertychange on the first input event after setting `value` from a
    // script and fires only keydown, keypress, keyup. Catching keyup usually
    // gets it and catching keydown lets us fire an event for the first
    // keystroke if user does a key repeat (it'll be a little delayed: right
    // before the second keystroke). Other input methods (e.g., paste) seem to
    // fire selectionchange normally.
    return getInstIfValueChanged(activeElementInst, nativeEvent);
  }
}

/**
 * SECTION: handle `click` event
 */
function shouldUseClickEvent(elem) {
  // Use the `click` event to detect changes to checkbox and radio inputs.
  // This approach works across all browsers, whereas `change` does not fire
  // until `blur` in IE8.
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
}

function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topClick') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function handleControlledInputBlur(inst, node) {
  // TODO: In IE, inst is occasionally null. Why?
  if (inst == null) {
    return;
  }

  // Fiber and ReactDOM keep wrapper state in separate places
  var state = inst._wrapperState || node._wrapperState;

  if (!state || !state.controlled || node.type !== 'number') {
    return;
  }

  // If controlled, assign the value attribute to the current value on blur
  var value = '' + node.value;
  if (node.getAttribute('value') !== value) {
    node.setAttribute('value', value);
  }
}

/**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */
var ChangeEventPlugin = {
  eventTypes: eventTypes,

  _allowSimulatedPassThrough: true,
  _isInputEventSupported: isInputEventSupported,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    var getTargetInstFunc, handleEventFunc;
    if (shouldUseChangeEvent(targetNode)) {
      if (doesChangeEventBubble) {
        getTargetInstFunc = getTargetInstForChangeEvent;
      } else {
        handleEventFunc = handleEventsForChangeEventIE8;
      }
    } else if (isTextInputElement(targetNode)) {
      if (isInputEventSupported) {
        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
      } else {
        getTargetInstFunc = getTargetInstForInputEventPolyfill;
        handleEventFunc = handleEventsForInputEventPolyfill;
      }
    } else if (shouldUseClickEvent(targetNode)) {
      getTargetInstFunc = getTargetInstForClickEvent;
    }

    if (getTargetInstFunc) {
      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
      if (inst) {
        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
        return event;
      }
    }

    if (handleEventFunc) {
      handleEventFunc(topLevelType, targetNode, targetInst);
    }

    // When blurring, set the value attribute for number inputs
    if (topLevelType === 'topBlur') {
      handleControlledInputBlur(targetInst, targetNode);
    }
  }
};

module.exports = ChangeEventPlugin;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(4);

var DOMLazyTree = __webpack_require__(31);
var ExecutionEnvironment = __webpack_require__(12);

var createNodesFromMarkup = __webpack_require__(210);
var emptyFunction = __webpack_require__(13);
var invariant = __webpack_require__(1);

var Danger = {
  /**
   * Replaces a node with a string of markup at its current position within its
   * parent. The markup must render into a single root node.
   *
   * @param {DOMElement} oldChild Child node to replace.
   * @param {string} markup Markup to render in place of the child node.
   * @internal
   */
  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;

    if (typeof markup === 'string') {
      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
      oldChild.parentNode.replaceChild(newChild, oldChild);
    } else {
      DOMLazyTree.replaceChildWithTree(oldChild, markup);
    }
  }
};

module.exports = Danger;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Module that is injectable into `EventPluginHub`, that specifies a
 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
 * plugins, without having to package every one of them. This is better than
 * having plugins be ordered in the same order that they are injected because
 * that ordering would be influenced by the packaging order.
 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
 */

var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];

module.exports = DefaultEventPluginOrder;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(41);
var ReactDOMComponentTree = __webpack_require__(8);
var SyntheticMouseEvent = __webpack_require__(50);

var eventTypes = {
  mouseEnter: {
    registrationName: 'onMouseEnter',
    dependencies: ['topMouseOut', 'topMouseOver']
  },
  mouseLeave: {
    registrationName: 'onMouseLeave',
    dependencies: ['topMouseOut', 'topMouseOver']
  }
};

var EnterLeaveEventPlugin = {
  eventTypes: eventTypes,

  /**
   * For almost every interaction we care about, there will be both a top-level
   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
   * we do not extract duplicate events. However, moving the mouse into the
   * browser from outside will not fire a `mouseout` event. In this case, we use
   * the `mouseover` top-level event.
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
      return null;
    }
    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
      // Must not be a mouse in or mouse out - ignoring.
      return null;
    }

    var win;
    if (nativeEventTarget.window === nativeEventTarget) {
      // `nativeEventTarget` is probably a window object.
      win = nativeEventTarget;
    } else {
      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
      var doc = nativeEventTarget.ownerDocument;
      if (doc) {
        win = doc.defaultView || doc.parentWindow;
      } else {
        win = window;
      }
    }

    var from;
    var to;
    if (topLevelType === 'topMouseOut') {
      from = targetInst;
      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
    } else {
      // Moving to a node from outside the window.
      from = null;
      to = targetInst;
    }

    if (from === to) {
      // Nothing pertains to our managed components.
      return null;
    }

    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);

    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
    leave.type = 'mouseleave';
    leave.target = fromNode;
    leave.relatedTarget = toNode;

    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
    enter.type = 'mouseenter';
    enter.target = toNode;
    enter.relatedTarget = fromNode;

    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);

    return [leave, enter];
  }
};

module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(7);

var PooledClass = __webpack_require__(24);

var getTextContentAccessor = __webpack_require__(123);

/**
 * This helper class stores information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 * @param {DOMEventTarget} root
 */
function FallbackCompositionState(root) {
  this._root = root;
  this._startText = this.getText();
  this._fallbackText = null;
}

_assign(FallbackCompositionState.prototype, {
  destructor: function () {
    this._root = null;
    this._startText = null;
    this._fallbackText = null;
  },

  /**
   * Get current text of input.
   *
   * @return {string}
   */
  getText: function () {
    if ('value' in this._root) {
      return this._root.value;
    }
    return this._root[getTextContentAccessor()];
  },

  /**
   * Determine the differing substring between the initially stored
   * text content and the current content.
   *
   * @return {string}
   */
  getData: function () {
    if (this._fallbackText) {
      return this._fallbackText;
    }

    var start;
    var startValue = this._startText;
    var startLength = startValue.length;
    var end;
    var endValue = this.getText();
    var endLength = endValue.length;

    for (start = 0; start < startLength; start++) {
      if (startValue[start] !== endValue[start]) {
        break;
      }
    }

    var minEnd = startLength - start;
    for (end = 1; end <= minEnd; end++) {
      if (startValue[startLength - end] !== endValue[endLength - end]) {
        break;
      }
    }

    var sliceTail = end > 1 ? 1 - end : undefined;
    this._fallbackText = endValue.slice(start, sliceTail);
    return this._fallbackText;
  }
});

PooledClass.addPoolingTo(FallbackCompositionState);

module.exports = FallbackCompositionState;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(32);

var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;

var HTMLDOMPropertyConfig = {
  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
  Properties: {
    /**
     * Standard Properties
     */
    accept: 0,
    acceptCharset: 0,
    accessKey: 0,
    action: 0,
    allowFullScreen: HAS_BOOLEAN_VALUE,
    allowTransparency: 0,
    alt: 0,
    // specifies target context for links with `preload` type
    as: 0,
    async: HAS_BOOLEAN_VALUE,
    autoComplete: 0,
    // autoFocus is polyfilled/normalized by AutoFocusUtils
    // autoFocus: HAS_BOOLEAN_VALUE,
    autoPlay: HAS_BOOLEAN_VALUE,
    capture: HAS_BOOLEAN_VALUE,
    cellPadding: 0,
    cellSpacing: 0,
    charSet: 0,
    challenge: 0,
    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    cite: 0,
    classID: 0,
    className: 0,
    cols: HAS_POSITIVE_NUMERIC_VALUE,
    colSpan: 0,
    content: 0,
    contentEditable: 0,
    contextMenu: 0,
    controls: HAS_BOOLEAN_VALUE,
    coords: 0,
    crossOrigin: 0,
    data: 0, // For `<object />` acts as `src`.
    dateTime: 0,
    'default': HAS_BOOLEAN_VALUE,
    defer: HAS_BOOLEAN_VALUE,
    dir: 0,
    disabled: HAS_BOOLEAN_VALUE,
    download: HAS_OVERLOADED_BOOLEAN_VALUE,
    draggable: 0,
    encType: 0,
    form: 0,
    formAction: 0,
    formEncType: 0,
    formMethod: 0,
    formNoValidate: HAS_BOOLEAN_VALUE,
    formTarget: 0,
    frameBorder: 0,
    headers: 0,
    height: 0,
    hidden: HAS_BOOLEAN_VALUE,
    high: 0,
    href: 0,
    hrefLang: 0,
    htmlFor: 0,
    httpEquiv: 0,
    icon: 0,
    id: 0,
    inputMode: 0,
    integrity: 0,
    is: 0,
    keyParams: 0,
    keyType: 0,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: HAS_BOOLEAN_VALUE,
    low: 0,
    manifest: 0,
    marginHeight: 0,
    marginWidth: 0,
    max: 0,
    maxLength: 0,
    media: 0,
    mediaGroup: 0,
    method: 0,
    min: 0,
    minLength: 0,
    // Caution; `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`.
    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    name: 0,
    nonce: 0,
    noValidate: HAS_BOOLEAN_VALUE,
    open: HAS_BOOLEAN_VALUE,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: HAS_BOOLEAN_VALUE,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 0,
    readOnly: HAS_BOOLEAN_VALUE,
    referrerPolicy: 0,
    rel: 0,
    required: HAS_BOOLEAN_VALUE,
    reversed: HAS_BOOLEAN_VALUE,
    role: 0,
    rows: HAS_POSITIVE_NUMERIC_VALUE,
    rowSpan: HAS_NUMERIC_VALUE,
    sandbox: 0,
    scope: 0,
    scoped: HAS_BOOLEAN_VALUE,
    scrolling: 0,
    seamless: HAS_BOOLEAN_VALUE,
    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    shape: 0,
    size: HAS_POSITIVE_NUMERIC_VALUE,
    sizes: 0,
    span: HAS_POSITIVE_NUMERIC_VALUE,
    spellCheck: 0,
    src: 0,
    srcDoc: 0,
    srcLang: 0,
    srcSet: 0,
    start: HAS_NUMERIC_VALUE,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 0,
    target: 0,
    title: 0,
    // Setting .type throws on non-<input> tags
    type: 0,
    useMap: 0,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,

    /**
     * RDFa Properties
     */
    about: 0,
    datatype: 0,
    inlist: 0,
    prefix: 0,
    // property is also supported for OpenGraph in meta tags.
    property: 0,
    resource: 0,
    'typeof': 0,
    vocab: 0,

    /**
     * Non-standard Properties
     */
    // autoCapitalize and autoCorrect are supported in Mobile Safari for
    // keyboard hints.
    autoCapitalize: 0,
    autoCorrect: 0,
    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
    autoSave: 0,
    // color is for Safari mask-icon link
    color: 0,
    // itemProp, itemScope, itemType are for
    // Microdata support. See http://schema.org/docs/gs.html
    itemProp: 0,
    itemScope: HAS_BOOLEAN_VALUE,
    itemType: 0,
    // itemID and itemRef are for Microdata support as well but
    // only specified in the WHATWG spec document. See
    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
    itemID: 0,
    itemRef: 0,
    // results show looking glass icon and recent searches on input
    // search fields in WebKit/Blink
    results: 0,
    // IE-only attribute that specifies security restrictions on an iframe
    // as an alternative to the sandbox attribute on IE<10
    security: 0,
    // IE-only attribute that controls focus behavior
    unselectable: 0
  },
  DOMAttributeNames: {
    acceptCharset: 'accept-charset',
    className: 'class',
    htmlFor: 'for',
    httpEquiv: 'http-equiv'
  },
  DOMPropertyNames: {},
  DOMMutationMethods: {
    value: function (node, value) {
      if (value == null) {
        return node.removeAttribute('value');
      }

      // Number inputs get special treatment due to some edge cases in
      // Chrome. Let everything else assign the value attribute as normal.
      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
      if (node.type !== 'number' || node.hasAttribute('value') === false) {
        node.setAttribute('value', '' + value);
      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
        // Don't assign an attribute if validation reports bad
        // input. Chrome will clear the value. Additionally, don't
        // operate on inputs that have focus, otherwise Chrome might
        // strip off trailing decimal places and cause the user's
        // cursor position to jump to the beginning of the input.
        //
        // In ReactDOMInput, we have an onBlur event that will trigger
        // this function again when focus is lost.
        node.setAttribute('value', '' + value);
      }
    }
  }
};

module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactReconciler = __webpack_require__(33);

var instantiateReactComponent = __webpack_require__(125);
var KeyEscapeUtils = __webpack_require__(71);
var shouldUpdateReactComponent = __webpack_require__(81);
var traverseAllChildren = __webpack_require__(128);
var warning = __webpack_require__(3);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && __webpack_require__.i({"NODE_ENV":"production","PUBLIC_URL":""}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(138);
}

function instantiateChild(childInstances, child, name, selfDebugID) {
  // We found a component instance.
  var keyUnique = childInstances[name] === undefined;
  if (false) {
    if (!ReactComponentTreeHook) {
      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
    }
    if (!keyUnique) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
    }
  }
  if (child != null && keyUnique) {
    childInstances[name] = instantiateReactComponent(child, true);
  }
}

/**
 * ReactChildReconciler provides helpers for initializing or updating a set of
 * children. Its output is suitable for passing it onto ReactMultiChild which
 * does diffed reordering and insertion.
 */
var ReactChildReconciler = {
  /**
   * Generates a "mount image" for each of the supplied children. In the case
   * of `ReactDOMComponent`, a mount image is a string of markup.
   *
   * @param {?object} nestedChildNodes Nested child maps.
   * @return {?object} A set of child instances.
   * @internal
   */
  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
  {
    if (nestedChildNodes == null) {
      return null;
    }
    var childInstances = {};

    if (false) {
      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
        return instantiateChild(childInsts, child, name, selfDebugID);
      }, childInstances);
    } else {
      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
    }
    return childInstances;
  },

  /**
   * Updates the rendered children and returns a new set of children.
   *
   * @param {?object} prevChildren Previously initialized set of children.
   * @param {?object} nextChildren Flat child element maps.
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @return {?object} A new set of child instances.
   * @internal
   */
  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
  {
    // We currently don't have a way to track moves here but if we use iterators
    // instead of for..in we can zip the iterators and check if an item has
    // moved.
    // TODO: If nothing has changed, return the prevChildren object so that we
    // can quickly bailout if nothing has changed.
    if (!nextChildren && !prevChildren) {
      return;
    }
    var name;
    var prevChild;
    for (name in nextChildren) {
      if (!nextChildren.hasOwnProperty(name)) {
        continue;
      }
      prevChild = prevChildren && prevChildren[name];
      var prevElement = prevChild && prevChild._currentElement;
      var nextElement = nextChildren[name];
      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
        nextChildren[name] = prevChild;
      } else {
        if (prevChild) {
          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
          ReactReconciler.unmountComponent(prevChild, false);
        }
        // The child must be instantiated before it's mounted.
        var nextChildInstance = instantiateReactComponent(nextElement, true);
        nextChildren[name] = nextChildInstance;
        // Creating mount image now ensures refs are resolved in right order
        // (see https://github.com/facebook/react/pull/7101 for explanation).
        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
        mountImages.push(nextChildMountImage);
      }
    }
    // Unmount children that are no longer present.
    for (name in prevChildren) {
      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
        prevChild = prevChildren[name];
        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
        ReactReconciler.unmountComponent(prevChild, false);
      }
    }
  },

  /**
   * Unmounts all rendered children. This should be used to clean up children
   * when this component is unmounted.
   *
   * @param {?object} renderedChildren Previously initialized set of children.
   * @internal
   */
  unmountChildren: function (renderedChildren, safely) {
    for (var name in renderedChildren) {
      if (renderedChildren.hasOwnProperty(name)) {
        var renderedChild = renderedChildren[name];
        ReactReconciler.unmountComponent(renderedChild, safely);
      }
    }
  }
};

module.exports = ReactChildReconciler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)))

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMChildrenOperations = __webpack_require__(67);
var ReactDOMIDOperations = __webpack_require__(250);

/**
 * Abstracts away all functionality of the reconciler that requires knowledge of
 * the browser context. TODO: These callers should be refactored to avoid the
 * need for this injection.
 */
var ReactComponentBrowserEnvironment = {
  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,

  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
};

module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(4),
    _assign = __webpack_require__(7);

var React = __webpack_require__(35);
var ReactComponentEnvironment = __webpack_require__(73);
var ReactCurrentOwner = __webpack_require__(20);
var ReactErrorUtils = __webpack_require__(74);
var ReactInstanceMap = __webpack_require__(42);
var ReactInstrumentation = __webpack_require__(14);
var ReactNodeTypes = __webpack_require__(118);
var ReactReconciler = __webpack_require__(33);

if (false) {
  var checkReactTypeSpec = require('./checkReactTypeSpec');
}

var emptyObject = __webpack_require__(45);
var invariant = __webpack_require__(1);
var shallowEqual = __webpack_require__(62);
var shouldUpdateReactComponent = __webpack_require__(81);
var warning = __webpack_require__(3);

var CompositeTypes = {
  ImpureClass: 0,
  PureClass: 1,
  StatelessFunctional: 2
};

function StatelessComponent(Component) {}
StatelessComponent.prototype.render = function () {
  var Component = ReactInstanceMap.get(this)._currentElement.type;
  var element = Component(this.props, this.context, this.updater);
  warnIfInvalidElement(Component, element);
  return element;
};

function warnIfInvalidElement(Component, element) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
  }
}

function shouldConstruct(Component) {
  return !!(Component.prototype && Component.prototype.isReactComponent);
}

function isPureComponent(Component) {
  return !!(Component.prototype && Component.prototype.isPureReactComponent);
}

// Separated into a function to contain deoptimizations caused by try/finally.
function measureLifeCyclePerf(fn, debugID, timerType) {
  if (debugID === 0) {
    // Top-level wrappers (see ReactMount) and empty components (see
    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
    // Both are implementation details that should go away in the future.
    return fn();
  }

  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
  try {
    return fn();
  } finally {
    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
  }
}

/**
 * ------------------ The Life-Cycle of a Composite Component ------------------
 *
 * - constructor: Initialization of state. The instance is now retained.
 *   - componentWillMount
 *   - render
 *   - [children's constructors]
 *     - [children's componentWillMount and render]
 *     - [children's componentDidMount]
 *     - componentDidMount
 *
 *       Update Phases:
 *       - componentWillReceiveProps (only called if parent updated)
 *       - shouldComponentUpdate
 *         - componentWillUpdate
 *           - render
 *           - [children's constructors or receive props phases]
 *         - componentDidUpdate
 *
 *     - componentWillUnmount
 *     - [children's componentWillUnmount]
 *   - [children destroyed]
 * - (destroyed): The instance is now blank, released by React and ready for GC.
 *
 * -----------------------------------------------------------------------------
 */

/**
 * An incrementing ID assigned to each component when it is mounted. This is
 * used to enforce the order in which `ReactUpdates` updates dirty components.
 *
 * @private
 */
var nextMountID = 1;

/**
 * @lends {ReactCompositeComponent.prototype}
 */
var ReactCompositeComponent = {
  /**
   * Base constructor for all composite component.
   *
   * @param {ReactElement} element
   * @final
   * @internal
   */
  construct: function (element) {
    this._currentElement = element;
    this._rootNodeID = 0;
    this._compositeType = null;
    this._instance = null;
    this._hostParent = null;
    this._hostContainerInfo = null;

    // See ReactUpdateQueue
    this._updateBatchNumber = null;
    this._pendingElement = null;
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    this._renderedNodeType = null;
    this._renderedComponent = null;
    this._context = null;
    this._mountOrder = 0;
    this._topLevelWrapper = null;

    // See ReactUpdates and ReactUpdateQueue.
    this._pendingCallbacks = null;

    // ComponentWillUnmount shall only be called once
    this._calledComponentWillUnmount = false;

    if (false) {
      this._warnedAboutRefsInRender = false;
    }
  },

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} hostParent
   * @param {?object} hostContainerInfo
   * @param {?object} context
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var _this = this;

    this._context = context;
    this._mountOrder = nextMountID++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var publicProps = this._currentElement.props;
    var publicContext = this._processContext(context);

    var Component = this._currentElement.type;

    var updateQueue = transaction.getUpdateQueue();

    // Initialize the public class
    var doConstruct = shouldConstruct(Component);
    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
    var renderedElement;

    // Support functional components
    if (!doConstruct && (inst == null || inst.render == null)) {
      renderedElement = inst;
      warnIfInvalidElement(Component, renderedElement);
      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
      inst = new StatelessComponent(Component);
      this._compositeType = CompositeTypes.StatelessFunctional;
    } else {
      if (isPureComponent(Component)) {
        this._compositeType = CompositeTypes.PureClass;
      } else {
        this._compositeType = CompositeTypes.ImpureClass;
      }
    }

    if (false) {
      // This will throw later in _renderValidatedComponent, but add an early
      // warning now to help debugging
      if (inst.render == null) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
      }

      var propsMutated = inst.props !== publicProps;
      var componentName = Component.displayName || Component.name || 'Component';

      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
    }

    // These should be set up in the constructor, but as a convenience for
    // simpler class abstractions, we set them up after the fact.
    inst.props = publicProps;
    inst.context = publicContext;
    inst.refs = emptyObject;
    inst.updater = updateQueue;

    this._instance = inst;

    // Store a reference from the instance back to the internal representation
    ReactInstanceMap.set(inst, this);

    if (false) {
      // Since plain JS classes are defined without any special initialization
      // logic, we can not catch common errors early. Therefore, we have to
      // catch them here, at initialization time, instead.
      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
    }

    var initialState = inst.state;
    if (initialState === undefined) {
      inst.state = initialState = null;
    }
    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;

    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    var markup;
    if (inst.unstable_handleError) {
      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } else {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }

    if (inst.componentDidMount) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(function () {
            return inst.componentDidMount();
          }, _this._debugID, 'componentDidMount');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
      }
    }

    return markup;
  },

  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
    if (false) {
      ReactCurrentOwner.current = this;
      try {
        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
    }
  },

  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
    var Component = this._currentElement.type;

    if (doConstruct) {
      if (false) {
        return measureLifeCyclePerf(function () {
          return new Component(publicProps, publicContext, updateQueue);
        }, this._debugID, 'ctor');
      } else {
        return new Component(publicProps, publicContext, updateQueue);
      }
    }

    // This can still be an instance in case of factory components
    // but we'll count this as time spent rendering as the more common case.
    if (false) {
      return measureLifeCyclePerf(function () {
        return Component(publicProps, publicContext, updateQueue);
      }, this._debugID, 'render');
    } else {
      return Component(publicProps, publicContext, updateQueue);
    }
  },

  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var markup;
    var checkpoint = transaction.checkpoint();
    try {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } catch (e) {
      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
      transaction.rollback(checkpoint);
      this._instance.unstable_handleError(e);
      if (this._pendingStateQueue) {
        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
      }
      checkpoint = transaction.checkpoint();

      this._renderedComponent.unmountComponent(true);
      transaction.rollback(checkpoint);

      // Try again - we've informed the component about the error, so they can render an error message this time.
      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }
    return markup;
  },

  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var inst = this._instance;

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (inst.componentWillMount) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillMount();
        }, debugID, 'componentWillMount');
      } else {
        inst.componentWillMount();
      }
      // When mounting, calls to `setState` by `componentWillMount` will set
      // `this._pendingStateQueue` without triggering a re-render.
      if (this._pendingStateQueue) {
        inst.state = this._processPendingState(inst.props, inst.context);
      }
    }

    // If not a stateless component, we now render
    if (renderedElement === undefined) {
      renderedElement = this._renderValidatedComponent();
    }

    var nodeType = ReactNodeTypes.getType(renderedElement);
    this._renderedNodeType = nodeType;
    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
    );
    this._renderedComponent = child;

    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);

    if (false) {
      if (debugID !== 0) {
        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
      }
    }

    return markup;
  },

  getHostNode: function () {
    return ReactReconciler.getHostNode(this._renderedComponent);
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (safely) {
    if (!this._renderedComponent) {
      return;
    }

    var inst = this._instance;

    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
      inst._calledComponentWillUnmount = true;

      if (safely) {
        var name = this.getName() + '.componentWillUnmount()';
        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
      } else {
        if (false) {
          measureLifeCyclePerf(function () {
            return inst.componentWillUnmount();
          }, this._debugID, 'componentWillUnmount');
        } else {
          inst.componentWillUnmount();
        }
      }
    }

    if (this._renderedComponent) {
      ReactReconciler.unmountComponent(this._renderedComponent, safely);
      this._renderedNodeType = null;
      this._renderedComponent = null;
      this._instance = null;
    }

    // Reset pending fields
    // Even if this component is scheduled for another update in ReactUpdates,
    // it would still be ignored because these fields are reset.
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;
    this._pendingCallbacks = null;
    this._pendingElement = null;

    // These fields do not really need to be reset since this object is no
    // longer accessible.
    this._context = null;
    this._rootNodeID = 0;
    this._topLevelWrapper = null;

    // Delete the reference from the instance to this internal representation
    // which allow the internals to be properly cleaned up even if the user
    // leaks a reference to the public instance.
    ReactInstanceMap.remove(inst);

    // Some existing components rely on inst.props even after they've been
    // destroyed (in event handlers).
    // TODO: inst.props = null;
    // TODO: inst.state = null;
    // TODO: inst.context = null;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _maskContext: function (context) {
    var Component = this._currentElement.type;
    var contextTypes = Component.contextTypes;
    if (!contextTypes) {
      return emptyObject;
    }
    var maskedContext = {};
    for (var contextName in contextTypes) {
      maskedContext[contextName] = context[contextName];
    }
    return maskedContext;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`, and asserts that they are valid.
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _processContext: function (context) {
    var maskedContext = this._maskContext(context);
    if (false) {
      var Component = this._currentElement.type;
      if (Component.contextTypes) {
        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
      }
    }
    return maskedContext;
  },

  /**
   * @param {object} currentContext
   * @return {object}
   * @private
   */
  _processChildContext: function (currentContext) {
    var Component = this._currentElement.type;
    var inst = this._instance;
    var childContext;

    if (inst.getChildContext) {
      if (false) {
        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
        try {
          childContext = inst.getChildContext();
        } finally {
          ReactInstrumentation.debugTool.onEndProcessingChildContext();
        }
      } else {
        childContext = inst.getChildContext();
      }
    }

    if (childContext) {
      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
      if (false) {
        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
      }
      for (var name in childContext) {
        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
      }
      return _assign({}, currentContext, childContext);
    }
    return currentContext;
  },

  /**
   * Assert that the context types are valid
   *
   * @param {object} typeSpecs Map of context field to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @private
   */
  _checkContextTypes: function (typeSpecs, values, location) {
    if (false) {
      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
    }
  },

  receiveComponent: function (nextElement, transaction, nextContext) {
    var prevElement = this._currentElement;
    var prevContext = this._context;

    this._pendingElement = null;

    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
  },

  /**
   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
   * is set, update the component.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (transaction) {
    if (this._pendingElement != null) {
      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
    } else {
      this._updateBatchNumber = null;
    }
  },

  /**
   * Perform an update to a mounted component. The componentWillReceiveProps and
   * shouldComponentUpdate methods are called, then (assuming the update isn't
   * skipped) the remaining update lifecycle methods are called and the DOM
   * representation is updated.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevParentElement
   * @param {ReactElement} nextParentElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
    var inst = this._instance;
    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;

    var willReceive = false;
    var nextContext;

    // Determine if the context has changed or not
    if (this._context === nextUnmaskedContext) {
      nextContext = inst.context;
    } else {
      nextContext = this._processContext(nextUnmaskedContext);
      willReceive = true;
    }

    var prevProps = prevParentElement.props;
    var nextProps = nextParentElement.props;

    // Not a simple state update but a props update
    if (prevParentElement !== nextParentElement) {
      willReceive = true;
    }

    // An update here will schedule an update but immediately set
    // _pendingStateQueue which will ensure that any state updates gets
    // immediately reconciled instead of waiting for the next batch.
    if (willReceive && inst.componentWillReceiveProps) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillReceiveProps(nextProps, nextContext);
        }, this._debugID, 'componentWillReceiveProps');
      } else {
        inst.componentWillReceiveProps(nextProps, nextContext);
      }
    }

    var nextState = this._processPendingState(nextProps, nextContext);
    var shouldUpdate = true;

    if (!this._pendingForceUpdate) {
      if (inst.shouldComponentUpdate) {
        if (false) {
          shouldUpdate = measureLifeCyclePerf(function () {
            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
          }, this._debugID, 'shouldComponentUpdate');
        } else {
          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
        }
      } else {
        if (this._compositeType === CompositeTypes.PureClass) {
          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
        }
      }
    }

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
    }

    this._updateBatchNumber = null;
    if (shouldUpdate) {
      this._pendingForceUpdate = false;
      // Will set `this.props`, `this.state` and `this.context`.
      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
    } else {
      // If it's determined that a component should not update, we still want
      // to set props and state but we shortcut the rest of the update.
      this._currentElement = nextParentElement;
      this._context = nextUnmaskedContext;
      inst.props = nextProps;
      inst.state = nextState;
      inst.context = nextContext;
    }
  },

  _processPendingState: function (props, context) {
    var inst = this._instance;
    var queue = this._pendingStateQueue;
    var replace = this._pendingReplaceState;
    this._pendingReplaceState = false;
    this._pendingStateQueue = null;

    if (!queue) {
      return inst.state;
    }

    if (replace && queue.length === 1) {
      return queue[0];
    }

    var nextState = _assign({}, replace ? queue[0] : inst.state);
    for (var i = replace ? 1 : 0; i < queue.length; i++) {
      var partial = queue[i];
      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
    }

    return nextState;
  },

  /**
   * Merges new props and state, notifies delegate methods of update and
   * performs update.
   *
   * @param {ReactElement} nextElement Next element
   * @param {object} nextProps Next public object to set as properties.
   * @param {?object} nextState Next object to set as state.
   * @param {?object} nextContext Next public object to set as context.
   * @param {ReactReconcileTransaction} transaction
   * @param {?object} unmaskedContext
   * @private
   */
  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
    var _this2 = this;

    var inst = this._instance;

    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
    var prevProps;
    var prevState;
    var prevContext;
    if (hasComponentDidUpdate) {
      prevProps = inst.props;
      prevState = inst.state;
      prevContext = inst.context;
    }

    if (inst.componentWillUpdate) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillUpdate(nextProps, nextState, nextContext);
        }, this._debugID, 'componentWillUpdate');
      } else {
        inst.componentWillUpdate(nextProps, nextState, nextContext);
      }
    }

    this._currentElement = nextElement;
    this._context = unmaskedContext;
    inst.props = nextProps;
    inst.state = nextState;
    inst.context = nextContext;

    this._updateRenderedComponent(transaction, unmaskedContext);

    if (hasComponentDidUpdate) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
      }
    }
  },

  /**
   * Call the component's `render` method and update the DOM accordingly.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  _updateRenderedComponent: function (transaction, context) {
    var prevComponentInstance = this._renderedComponent;
    var prevRenderedElement = prevComponentInstance._currentElement;
    var nextRenderedElement = this._renderValidatedComponent();

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
    } else {
      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
      ReactReconciler.unmountComponent(prevComponentInstance, false);

      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
      this._renderedNodeType = nodeType;
      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
      );
      this._renderedComponent = child;

      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);

      if (false) {
        if (debugID !== 0) {
          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
        }
      }

      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
    }
  },

  /**
   * Overridden in shallow rendering.
   *
   * @protected
   */
  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
  },

  /**
   * @protected
   */
  _renderValidatedComponentWithoutOwnerOrContext: function () {
    var inst = this._instance;
    var renderedElement;

    if (false) {
      renderedElement = measureLifeCyclePerf(function () {
        return inst.render();
      }, this._debugID, 'render');
    } else {
      renderedElement = inst.render();
    }

    if (false) {
      // We allow auto-mocks to proceed as if they're returning null.
      if (renderedElement === undefined && inst.render._isMockFunction) {
        // This is probably bad practice. Consider warning here and
        // deprecating this convenience.
        renderedElement = null;
      }
    }

    return renderedElement;
  },

  /**
   * @private
   */
  _renderValidatedComponent: function () {
    var renderedElement;
    if ("production" !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
      ReactCurrentOwner.current = this;
      try {
        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
    }
    !(
    // TODO: An `isValidNode` function would probably be more appropriate
    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;

    return renderedElement;
  },

  /**
   * Lazily allocates the refs object and stores `component` as `ref`.
   *
   * @param {string} ref Reference name.
   * @param {component} component Component to store as `ref`.
   * @final
   * @private
   */
  attachRef: function (ref, component) {
    var inst = this.getPublicInstance();
    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
    var publicComponentInstance = component.getPublicInstance();
    if (false) {
      var componentName = component && component.getName ? component.getName() : 'a component';
      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
    }
    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
    refs[ref] = publicComponentInstance;
  },

  /**
   * Detaches a reference name.
   *
   * @param {string} ref Name to dereference.
   * @final
   * @private
   */
  detachRef: function (ref) {
    var refs = this.getPublicInstance().refs;
    delete refs[ref];
  },

  /**
   * Get a text description of the component that can be used to identify it
   * in error messages.
   * @return {string} The name or null.
   * @internal
   */
  getName: function () {
    var type = this._currentElement.type;
    var constructor = this._instance && this._instance.constructor;
    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
  },

  /**
   * Get the publicly accessible representation of this component - i.e. what
   * is exposed by refs and returned by render. Can be null for stateless
   * components.
   *
   * @return {ReactComponent} the public component instance.
   * @internal
   */
  getPublicInstance: function () {
    var inst = this._instance;
    if (this._compositeType === CompositeTypes.StatelessFunctional) {
      return null;
    }
    return inst;
  },

  // Stub
  _instantiateReactComponent: null
};

module.exports = ReactCompositeComponent;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/



var ReactDOMComponentTree = __webpack_require__(8);
var ReactDefaultInjection = __webpack_require__(258);
var ReactMount = __webpack_require__(117);
var ReactReconciler = __webpack_require__(33);
var ReactUpdates = __webpack_require__(16);
var ReactVersion = __webpack_require__(271);

var findDOMNode = __webpack_require__(287);
var getHostComponentFromComposite = __webpack_require__(122);
var renderSubtreeIntoContainer = __webpack_require__(294);
var warning = __webpack_require__(3);

ReactDefaultInjection.inject();

var ReactDOM = {
  findDOMNode: findDOMNode,
  render: ReactMount.render,
  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
  version: ReactVersion,

  /* eslint-disable camelcase */
  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
  /* eslint-enable camelcase */
};

// Inject the runtime into a devtools global hook regardless of browser.
// Allows for debugging when the hook is injected on the page.
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
    ComponentTree: {
      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
      getNodeFromInstance: function (inst) {
        // inst is an internal instance (but could be a composite)
        if (inst._renderedComponent) {
          inst = getHostComponentFromComposite(inst);
        }
        if (inst) {
          return ReactDOMComponentTree.getNodeFromInstance(inst);
        } else {
          return null;
        }
      }
    },
    Mount: ReactMount,
    Reconciler: ReactReconciler
  });
}

if (false) {
  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
    // First check if devtools is not installed
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
      // If we're in Chrome or Firefox, provide a download link if not installed.
      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
        // Firefox does not have the issue with devtools loaded over file://
        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
      }
    }

    var testFunc = function testFn() {};
    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;

    // If we're in IE8, check to see if we are in compatibility mode and provide
    // information on preventing compatibility mode
    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;

    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;

    var expectedFeatures = [
    // shims
    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];

    for (var i = 0; i < expectedFeatures.length; i++) {
      if (!expectedFeatures[i]) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
        break;
      }
    }
  }
}

if (false) {
  var ReactInstrumentation = require('./ReactInstrumentation');
  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');

  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
}

module.exports = ReactDOM;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* global hasOwnProperty:true */



var _prodInvariant = __webpack_require__(4),
    _assign = __webpack_require__(7);

var AutoFocusUtils = __webpack_require__(233);
var CSSPropertyOperations = __webpack_require__(235);
var DOMLazyTree = __webpack_require__(31);
var DOMNamespaces = __webpack_require__(68);
var DOMProperty = __webpack_require__(32);
var DOMPropertyOperations = __webpack_require__(110);
var EventPluginHub = __webpack_require__(40);
var EventPluginRegistry = __webpack_require__(69);
var ReactBrowserEventEmitter = __webpack_require__(49);
var ReactDOMComponentFlags = __webpack_require__(111);
var ReactDOMComponentTree = __webpack_require__(8);
var ReactDOMInput = __webpack_require__(251);
var ReactDOMOption = __webpack_require__(252);
var ReactDOMSelect = __webpack_require__(112);
var ReactDOMTextarea = __webpack_require__(255);
var ReactInstrumentation = __webpack_require__(14);
var ReactMultiChild = __webpack_require__(264);
var ReactServerRenderingTransaction = __webpack_require__(269);

var emptyFunction = __webpack_require__(13);
var escapeTextContentForBrowser = __webpack_require__(52);
var invariant = __webpack_require__(1);
var isEventSupported = __webpack_require__(80);
var shallowEqual = __webpack_require__(62);
var inputValueTracking = __webpack_require__(124);
var validateDOMNesting = __webpack_require__(82);
var warning = __webpack_require__(3);

var Flags = ReactDOMComponentFlags;
var deleteListener = EventPluginHub.deleteListener;
var getNode = ReactDOMComponentTree.getNodeFromInstance;
var listenTo = ReactBrowserEventEmitter.listenTo;
var registrationNameModules = EventPluginRegistry.registrationNameModules;

// For quickly matching children type, to test if can be treated as content.
var CONTENT_TYPES = { string: true, number: true };

var STYLE = 'style';
var HTML = '__html';
var RESERVED_PROPS = {
  children: null,
  dangerouslySetInnerHTML: null,
  suppressContentEditableWarning: null
};

// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
var DOC_FRAGMENT_TYPE = 11;

function getDeclarationErrorAddendum(internalInstance) {
  if (internalInstance) {
    var owner = internalInstance._currentElement._owner || null;
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' This DOM node was rendered by `' + name + '`.';
      }
    }
  }
  return '';
}

function friendlyStringify(obj) {
  if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return '[' + obj.map(friendlyStringify).join(', ') + ']';
    } else {
      var pairs = [];
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
        }
      }
      return '{' + pairs.join(', ') + '}';
    }
  } else if (typeof obj === 'string') {
    return JSON.stringify(obj);
  } else if (typeof obj === 'function') {
    return '[function object]';
  }
  // Differs from JSON.stringify in that undefined because undefined and that
  // inf and nan don't become null
  return String(obj);
}

var styleMutationWarning = {};

function checkAndWarnForMutatedStyle(style1, style2, component) {
  if (style1 == null || style2 == null) {
    return;
  }
  if (shallowEqual(style1, style2)) {
    return;
  }

  var componentName = component._tag;
  var owner = component._currentElement._owner;
  var ownerName;
  if (owner) {
    ownerName = owner.getName();
  }

  var hash = ownerName + '|' + componentName;

  if (styleMutationWarning.hasOwnProperty(hash)) {
    return;
  }

  styleMutationWarning[hash] = true;

   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
}

/**
 * @param {object} component
 * @param {?object} props
 */
function assertValidProps(component, props) {
  if (!props) {
    return;
  }
  // Note the use of `==` which checks for null or undefined.
  if (voidElementTags[component._tag]) {
    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
  }
  if (props.dangerouslySetInnerHTML != null) {
    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
  }
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
  }
  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
}

function enqueuePutListener(inst, registrationName, listener, transaction) {
  if (transaction instanceof ReactServerRenderingTransaction) {
    return;
  }
  if (false) {
    // IE8 has no API for event capturing and the `onScroll` event doesn't
    // bubble.
    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
  }
  var containerInfo = inst._hostContainerInfo;
  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
  listenTo(registrationName, doc);
  transaction.getReactMountReady().enqueue(putListener, {
    inst: inst,
    registrationName: registrationName,
    listener: listener
  });
}

function putListener() {
  var listenerToPut = this;
  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
}

function inputPostMount() {
  var inst = this;
  ReactDOMInput.postMountWrapper(inst);
}

function textareaPostMount() {
  var inst = this;
  ReactDOMTextarea.postMountWrapper(inst);
}

function optionPostMount() {
  var inst = this;
  ReactDOMOption.postMountWrapper(inst);
}

var setAndValidateContentChildDev = emptyFunction;
if (false) {
  setAndValidateContentChildDev = function (content) {
    var hasExistingContent = this._contentDebugID != null;
    var debugID = this._debugID;
    // This ID represents the inlined child that has no backing instance:
    var contentDebugID = -debugID;

    if (content == null) {
      if (hasExistingContent) {
        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
      }
      this._contentDebugID = null;
      return;
    }

    validateDOMNesting(null, String(content), this, this._ancestorInfo);
    this._contentDebugID = contentDebugID;
    if (hasExistingContent) {
      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
    } else {
      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
    }
  };
}

// There are so many media events, it makes sense to just
// maintain a list rather than create a `trapBubbledEvent` for each
var mediaEvents = {
  topAbort: 'abort',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTimeUpdate: 'timeupdate',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting'
};

function trackInputValue() {
  inputValueTracking.track(this);
}

function trapBubbledEventsLocal() {
  var inst = this;
  // If a component renders to null or if another component fatals and causes
  // the state of the tree to be corrupted, `node` here can be null.
  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
  var node = getNode(inst);
  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;

  switch (inst._tag) {
    case 'iframe':
    case 'object':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'video':
    case 'audio':
      inst._wrapperState.listeners = [];
      // Create listener for each media event
      for (var event in mediaEvents) {
        if (mediaEvents.hasOwnProperty(event)) {
          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
        }
      }
      break;
    case 'source':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
      break;
    case 'img':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'form':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
      break;
    case 'input':
    case 'select':
    case 'textarea':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
      break;
  }
}

function postUpdateSelectWrapper() {
  ReactDOMSelect.postUpdateWrapper(this);
}

// For HTML, certain tags should omit their close tag. We keep a whitelist for
// those special-case tags.

var omittedCloseTags = {
  area: true,
  base: true,
  br: true,
  col: true,
  embed: true,
  hr: true,
  img: true,
  input: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true
  // NOTE: menuitem's close tag should be omitted, but that causes problems.
};

var newlineEatingTags = {
  listing: true,
  pre: true,
  textarea: true
};

// For HTML, certain tags cannot have children. This has the same purpose as
// `omittedCloseTags` except that `menuitem` should still have its closing tag.

var voidElementTags = _assign({
  menuitem: true
}, omittedCloseTags);

// We accept any tag to be rendered but since this gets injected into arbitrary
// HTML, we want to make sure that it's a safe tag.
// http://www.w3.org/TR/REC-xml/#NT-Name

var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
var validatedTagCache = {};
var hasOwnProperty = {}.hasOwnProperty;

function validateDangerousTag(tag) {
  if (!hasOwnProperty.call(validatedTagCache, tag)) {
    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
    validatedTagCache[tag] = true;
  }
}

function isCustomComponent(tagName, props) {
  return tagName.indexOf('-') >= 0 || props.is != null;
}

var globalIdCounter = 1;

/**
 * Creates a new React class that is idempotent and capable of containing other
 * React components. It accepts event listeners and DOM properties that are
 * valid according to `DOMProperty`.
 *
 *  - Event listeners: `onClick`, `onMouseDown`, etc.
 *  - DOM properties: `className`, `name`, `title`, etc.
 *
 * The `style` property functions differently from the DOM API. It accepts an
 * object mapping of style properties to values.
 *
 * @constructor ReactDOMComponent
 * @extends ReactMultiChild
 */
function ReactDOMComponent(element) {
  var tag = element.type;
  validateDangerousTag(tag);
  this._currentElement = element;
  this._tag = tag.toLowerCase();
  this._namespaceURI = null;
  this._renderedChildren = null;
  this._previousStyle = null;
  this._previousStyleCopy = null;
  this._hostNode = null;
  this._hostParent = null;
  this._rootNodeID = 0;
  this._domID = 0;
  this._hostContainerInfo = null;
  this._wrapperState = null;
  this._topLevelWrapper = null;
  this._flags = 0;
  if (false) {
    this._ancestorInfo = null;
    setAndValidateContentChildDev.call(this, null);
  }
}

ReactDOMComponent.displayName = 'ReactDOMComponent';

ReactDOMComponent.Mixin = {
  /**
   * Generates root tag markup then recurses. This method has side effects and
   * is not idempotent.
   *
   * @internal
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?ReactDOMComponent} the parent component instance
   * @param {?object} info about the host container
   * @param {object} context
   * @return {string} The computed markup.
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    this._rootNodeID = globalIdCounter++;
    this._domID = hostContainerInfo._idCounter++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var props = this._currentElement.props;

    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        this._wrapperState = {
          listeners: null
        };
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'input':
        ReactDOMInput.mountWrapper(this, props, hostParent);
        props = ReactDOMInput.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'option':
        ReactDOMOption.mountWrapper(this, props, hostParent);
        props = ReactDOMOption.getHostProps(this, props);
        break;
      case 'select':
        ReactDOMSelect.mountWrapper(this, props, hostParent);
        props = ReactDOMSelect.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'textarea':
        ReactDOMTextarea.mountWrapper(this, props, hostParent);
        props = ReactDOMTextarea.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
    }

    assertValidProps(this, props);

    // We create tags in the namespace of their parent container, except HTML
    // tags get no namespace.
    var namespaceURI;
    var parentTag;
    if (hostParent != null) {
      namespaceURI = hostParent._namespaceURI;
      parentTag = hostParent._tag;
    } else if (hostContainerInfo._tag) {
      namespaceURI = hostContainerInfo._namespaceURI;
      parentTag = hostContainerInfo._tag;
    }
    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
      namespaceURI = DOMNamespaces.html;
    }
    if (namespaceURI === DOMNamespaces.html) {
      if (this._tag === 'svg') {
        namespaceURI = DOMNamespaces.svg;
      } else if (this._tag === 'math') {
        namespaceURI = DOMNamespaces.mathml;
      }
    }
    this._namespaceURI = namespaceURI;

    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo._tag) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(this._tag, null, this, parentInfo);
      }
      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
    }

    var mountImage;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var el;
      if (namespaceURI === DOMNamespaces.html) {
        if (this._tag === 'script') {
          // Create the script via .innerHTML so its "parser-inserted" flag is
          // set to true and it does not execute
          var div = ownerDocument.createElement('div');
          var type = this._currentElement.type;
          div.innerHTML = '<' + type + '></' + type + '>';
          el = div.removeChild(div.firstChild);
        } else if (props.is) {
          el = ownerDocument.createElement(this._currentElement.type, props.is);
        } else {
          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
          // See discussion in https://github.com/facebook/react/pull/6896
          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
          el = ownerDocument.createElement(this._currentElement.type);
        }
      } else {
        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
      }
      ReactDOMComponentTree.precacheNode(this, el);
      this._flags |= Flags.hasCachedChildNodes;
      if (!this._hostParent) {
        DOMPropertyOperations.setAttributeForRoot(el);
      }
      this._updateDOMProperties(null, props, transaction);
      var lazyTree = DOMLazyTree(el);
      this._createInitialChildren(transaction, props, context, lazyTree);
      mountImage = lazyTree;
    } else {
      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
      var tagContent = this._createContentMarkup(transaction, props, context);
      if (!tagContent && omittedCloseTags[this._tag]) {
        mountImage = tagOpen + '/>';
      } else {
        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
      }
    }

    switch (this._tag) {
      case 'input':
        transaction.getReactMountReady().enqueue(inputPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'textarea':
        transaction.getReactMountReady().enqueue(textareaPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'select':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'button':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'option':
        transaction.getReactMountReady().enqueue(optionPostMount, this);
        break;
    }

    return mountImage;
  },

  /**
   * Creates markup for the open tag and all attributes.
   *
   * This method has side effects because events get registered.
   *
   * Iterating over object properties is faster than iterating over arrays.
   * @see http://jsperf.com/obj-vs-arr-iteration
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @return {string} Markup of opening tag.
   */
  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
    var ret = '<' + this._currentElement.type;

    for (var propKey in props) {
      if (!props.hasOwnProperty(propKey)) {
        continue;
      }
      var propValue = props[propKey];
      if (propValue == null) {
        continue;
      }
      if (registrationNameModules.hasOwnProperty(propKey)) {
        if (propValue) {
          enqueuePutListener(this, propKey, propValue, transaction);
        }
      } else {
        if (propKey === STYLE) {
          if (propValue) {
            if (false) {
              // See `_updateDOMProperties`. style block
              this._previousStyle = propValue;
            }
            propValue = this._previousStyleCopy = _assign({}, props.style);
          }
          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
        }
        var markup = null;
        if (this._tag != null && isCustomComponent(this._tag, props)) {
          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
          }
        } else {
          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
        }
        if (markup) {
          ret += ' ' + markup;
        }
      }
    }

    // For static pages, no need to put React ID and checksum. Saves lots of
    // bytes.
    if (transaction.renderToStaticMarkup) {
      return ret;
    }

    if (!this._hostParent) {
      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
    }
    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
    return ret;
  },

  /**
   * Creates markup for the content between the tags.
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @param {object} context
   * @return {string} Content markup.
   */
  _createContentMarkup: function (transaction, props, context) {
    var ret = '';

    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        ret = innerHTML.__html;
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      if (contentToUse != null) {
        // TODO: Validate that text is allowed as a child of this node
        ret = escapeTextContentForBrowser(contentToUse);
        if (false) {
          setAndValidateContentChildDev.call(this, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        ret = mountImages.join('');
      }
    }
    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
      // text/html ignores the first character in these tags if it's a newline
      // Prefer to break application/xml over text/html (for now) by adding
      // a newline specifically to get eaten by the parser. (Alternately for
      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
      // \r is normalized out by HTMLTextAreaElement#value.)
      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
      // See: Parsing of "textarea" "listing" and "pre" elements
      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
      return '\n' + ret;
    } else {
      return ret;
    }
  },

  _createInitialChildren: function (transaction, props, context, lazyTree) {
    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      // TODO: Validate that text is allowed as a child of this node
      if (contentToUse != null) {
        // Avoid setting textContent when the text is empty. In IE11 setting
        // textContent on a text area will cause the placeholder to not
        // show within the textarea until it has been focused and blurred again.
        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
        if (contentToUse !== '') {
          if (false) {
            setAndValidateContentChildDev.call(this, contentToUse);
          }
          DOMLazyTree.queueText(lazyTree, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        for (var i = 0; i < mountImages.length; i++) {
          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
        }
      }
    }
  },

  /**
   * Receives a next element and updates the component.
   *
   * @internal
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} context
   */
  receiveComponent: function (nextElement, transaction, context) {
    var prevElement = this._currentElement;
    this._currentElement = nextElement;
    this.updateComponent(transaction, prevElement, nextElement, context);
  },

  /**
   * Updates a DOM component after it has already been allocated and
   * attached to the DOM. Reconciles the root DOM node, then recurses.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevElement
   * @param {ReactElement} nextElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevElement, nextElement, context) {
    var lastProps = prevElement.props;
    var nextProps = this._currentElement.props;

    switch (this._tag) {
      case 'input':
        lastProps = ReactDOMInput.getHostProps(this, lastProps);
        nextProps = ReactDOMInput.getHostProps(this, nextProps);
        break;
      case 'option':
        lastProps = ReactDOMOption.getHostProps(this, lastProps);
        nextProps = ReactDOMOption.getHostProps(this, nextProps);
        break;
      case 'select':
        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
        break;
      case 'textarea':
        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
        break;
    }

    assertValidProps(this, nextProps);
    this._updateDOMProperties(lastProps, nextProps, transaction);
    this._updateDOMChildren(lastProps, nextProps, transaction, context);

    switch (this._tag) {
      case 'input':
        // Update the wrapper around inputs *after* updating props. This has to
        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
        // raise warnings and prevent the new value from being assigned.
        ReactDOMInput.updateWrapper(this);
        break;
      case 'textarea':
        ReactDOMTextarea.updateWrapper(this);
        break;
      case 'select':
        // <select> value update needs to occur after <option> children
        // reconciliation
        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
        break;
    }
  },

  /**
   * Reconciles the properties by detecting differences in property values and
   * updating the DOM as necessary. This function is probably the single most
   * critical path for performance optimization.
   *
   * TODO: Benchmark whether checking for changed values in memory actually
   *       improves performance (especially statically positioned elements).
   * TODO: Benchmark the effects of putting this at the top since 99% of props
   *       do not change for a given reconciliation.
   * TODO: Benchmark areas that can be improved with caching.
   *
   * @private
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {?DOMElement} node
   */
  _updateDOMProperties: function (lastProps, nextProps, transaction) {
    var propKey;
    var styleName;
    var styleUpdates;
    for (propKey in lastProps) {
      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
        continue;
      }
      if (propKey === STYLE) {
        var lastStyle = this._previousStyleCopy;
        for (styleName in lastStyle) {
          if (lastStyle.hasOwnProperty(styleName)) {
            styleUpdates = styleUpdates || {};
            styleUpdates[styleName] = '';
          }
        }
        this._previousStyleCopy = null;
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (lastProps[propKey]) {
          // Only call deleteListener if there was a listener previously or
          // else willDeleteListener gets called when there wasn't actually a
          // listener (e.g., onClick={null})
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, lastProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
      }
    }
    for (propKey in nextProps) {
      var nextProp = nextProps[propKey];
      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
        continue;
      }
      if (propKey === STYLE) {
        if (nextProp) {
          if (false) {
            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
            this._previousStyle = nextProp;
          }
          nextProp = this._previousStyleCopy = _assign({}, nextProp);
        } else {
          this._previousStyleCopy = null;
        }
        if (lastProp) {
          // Unset styles on `lastProp` but not on `nextProp`.
          for (styleName in lastProp) {
            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = '';
            }
          }
          // Update styles that changed since `lastProp`.
          for (styleName in nextProp) {
            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = nextProp[styleName];
            }
          }
        } else {
          // Relies on `updateStylesByID` not mutating `styleUpdates`.
          styleUpdates = nextProp;
        }
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (nextProp) {
          enqueuePutListener(this, propKey, nextProp, transaction);
        } else if (lastProp) {
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, nextProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        var node = getNode(this);
        // If we're updating to null or undefined, we should remove the property
        // from the DOM node instead of inadvertently setting to a string. This
        // brings us in line with the same behavior we have on initial render.
        if (nextProp != null) {
          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
        } else {
          DOMPropertyOperations.deleteValueForProperty(node, propKey);
        }
      }
    }
    if (styleUpdates) {
      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
    }
  },

  /**
   * Reconciles the children with the various properties that affect the
   * children content.
   *
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   */
  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;

    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;

    // Note the use of `!=` which checks for null or undefined.
    var lastChildren = lastContent != null ? null : lastProps.children;
    var nextChildren = nextContent != null ? null : nextProps.children;

    // If we're switching from children to content/html or vice versa, remove
    // the old content
    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
    if (lastChildren != null && nextChildren == null) {
      this.updateChildren(null, transaction, context);
    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
      this.updateTextContent('');
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    }

    if (nextContent != null) {
      if (lastContent !== nextContent) {
        this.updateTextContent('' + nextContent);
        if (false) {
          setAndValidateContentChildDev.call(this, nextContent);
        }
      }
    } else if (nextHtml != null) {
      if (lastHtml !== nextHtml) {
        this.updateMarkup('' + nextHtml);
      }
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    } else if (nextChildren != null) {
      if (false) {
        setAndValidateContentChildDev.call(this, null);
      }

      this.updateChildren(nextChildren, transaction, context);
    }
  },

  getHostNode: function () {
    return getNode(this);
  },

  /**
   * Destroys all event registrations for this instance. Does not remove from
   * the DOM. That must be done by the parent.
   *
   * @internal
   */
  unmountComponent: function (safely) {
    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        var listeners = this._wrapperState.listeners;
        if (listeners) {
          for (var i = 0; i < listeners.length; i++) {
            listeners[i].remove();
          }
        }
        break;
      case 'input':
      case 'textarea':
        inputValueTracking.stopTracking(this);
        break;
      case 'html':
      case 'head':
      case 'body':
        /**
         * Components like <html> <head> and <body> can't be removed or added
         * easily in a cross-browser way, however it's valuable to be able to
         * take advantage of React's reconciliation for styling and <title>
         * management. So we just document it and throw in dangerous cases.
         */
         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
        break;
    }

    this.unmountChildren(safely);
    ReactDOMComponentTree.uncacheNode(this);
    EventPluginHub.deleteAllListeners(this);
    this._rootNodeID = 0;
    this._domID = 0;
    this._wrapperState = null;

    if (false) {
      setAndValidateContentChildDev.call(this, null);
    }
  },

  getPublicInstance: function () {
    return getNode(this);
  }
};

_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);

module.exports = ReactDOMComponent;

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var validateDOMNesting = __webpack_require__(82);

var DOC_NODE_TYPE = 9;

function ReactDOMContainerInfo(topLevelWrapper, node) {
  var info = {
    _topLevelWrapper: topLevelWrapper,
    _idCounter: 1,
    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
    _node: node,
    _tag: node ? node.nodeName.toLowerCase() : null,
    _namespaceURI: node ? node.namespaceURI : null
  };
  if (false) {
    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
  }
  return info;
}

module.exports = ReactDOMContainerInfo;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(7);

var DOMLazyTree = __webpack_require__(31);
var ReactDOMComponentTree = __webpack_require__(8);

var ReactDOMEmptyComponent = function (instantiate) {
  // ReactCompositeComponent uses this:
  this._currentElement = null;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;
  this._hostContainerInfo = null;
  this._domID = 0;
};
_assign(ReactDOMEmptyComponent.prototype, {
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var domID = hostContainerInfo._idCounter++;
    this._domID = domID;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var nodeValue = ' react-empty: ' + this._domID + ' ';
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var node = ownerDocument.createComment(nodeValue);
      ReactDOMComponentTree.precacheNode(this, node);
      return DOMLazyTree(node);
    } else {
      if (transaction.renderToStaticMarkup) {
        // Normally we'd insert a comment node, but since this is a situation
        // where React won't take over (static pages), we can simply return
        // nothing.
        return '';
      }
      return '<!--' + nodeValue + '-->';
    }
  },
  receiveComponent: function () {},
  getHostNode: function () {
    return ReactDOMComponentTree.getNodeFromInstance(this);
  },
  unmountComponent: function () {
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMFeatureFlags = {
  useCreateElement: true,
  useFiber: false
};

module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMChildrenOperations = __webpack_require__(67);
var ReactDOMComponentTree = __webpack_require__(8);

/**
 * Operations used to process updates to DOM nodes.
 */
var ReactDOMIDOperations = {
  /**
   * Updates a component's children by processing a series of updates.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
    DOMChildrenOperations.processUpdates(node, updates);
  }
};

module.exports = ReactDOMIDOperations;

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(4),
    _assign = __webpack_require__(7);

var DOMPropertyOperations = __webpack_require__(110);
var LinkedValueUtils = __webpack_require__(72);
var ReactDOMComponentTree = __webpack_require__(8);
var ReactUpdates = __webpack_require__(16);

var invariant = __webpack_require__(1);
var warning = __webpack_require__(3);

var didWarnValueLink = false;
var didWarnCheckedLink = false;
var didWarnValueDefaultValue = false;
var didWarnCheckedDefaultChecked = false;
var didWarnControlledToUncontrolled = false;
var didWarnUncontrolledToControlled = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMInput.updateWrapper(this);
  }
}

function isControlled(props) {
  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
  return usesChecked ? props.checked != null : props.value != null;
}

/**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */
var ReactDOMInput = {
  getHostProps: function (inst, props) {
    var value = LinkedValueUtils.getValue(props);
    var checked = LinkedValueUtils.getChecked(props);

    var hostProps = _assign({
      // Make sure we set .type before any other properties (setting .value
      // before .type means .value is lost in IE11 and below)
      type: undefined,
      // Make sure we set .step before .value (setting .value before .step
      // means .value is rounded on mount, based upon step precision)
      step: undefined,
      // Make sure we set .min & .max before .value (to ensure proper order
      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
      min: undefined,
      max: undefined
    }, props, {
      defaultChecked: undefined,
      defaultValue: undefined,
      value: value != null ? value : inst._wrapperState.initialValue,
      checked: checked != null ? checked : inst._wrapperState.initialChecked,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);

      var owner = inst._currentElement._owner;

      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnCheckedLink = true;
      }
      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnCheckedDefaultChecked = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnValueDefaultValue = true;
      }
    }

    var defaultValue = props.defaultValue;
    inst._wrapperState = {
      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
      initialValue: props.value != null ? props.value : defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      controlled: isControlled(props)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    if (false) {
      var controlled = isControlled(props);
      var owner = inst._currentElement._owner;

      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnUncontrolledToControlled = true;
      }
      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnControlledToUncontrolled = true;
      }
    }

    // TODO: Shouldn't this be getChecked(props)?
    var checked = props.checked;
    if (checked != null) {
      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      if (value === 0 && node.value === '') {
        node.value = '0';
        // Note: IE9 reports a number inputs as 'text', so check props instead.
      } else if (props.type === 'number') {
        // Simulate `input.valueAsNumber`. IE9 does not support it
        var valueAsNumber = parseFloat(node.value, 10) || 0;

        if (
        // eslint-disable-next-line
        value != valueAsNumber ||
        // eslint-disable-next-line
        value == valueAsNumber && node.value != value) {
          // Cast `value` to a string to ensure the value is set correctly. While
          // browsers typically do this as necessary, jsdom doesn't.
          node.value = '' + value;
        }
      } else if (node.value !== '' + value) {
        // Cast `value` to a string to ensure the value is set correctly. While
        // browsers typically do this as necessary, jsdom doesn't.
        node.value = '' + value;
      }
    } else {
      if (props.value == null && props.defaultValue != null) {
        // In Chrome, assigning defaultValue to certain input types triggers input validation.
        // For number inputs, the display value loses trailing decimal points. For email inputs,
        // Chrome raises "The specified value <x> is not a valid email address".
        //
        // Here we check to see if the defaultValue has actually changed, avoiding these problems
        // when the user is inputting text
        //
        // https://github.com/facebook/react/issues/7253
        if (node.defaultValue !== '' + props.defaultValue) {
          node.defaultValue = '' + props.defaultValue;
        }
      }
      if (props.checked == null && props.defaultChecked != null) {
        node.defaultChecked = !!props.defaultChecked;
      }
    }
  },

  postMountWrapper: function (inst) {
    var props = inst._currentElement.props;

    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);

    // Detach value from defaultValue. We won't do anything if we're working on
    // submit or reset inputs as those values & defaultValues are linked. They
    // are not resetable nodes so this operation doesn't matter and actually
    // removes browser-default values (eg "Submit Query") when no value is
    // provided.

    switch (props.type) {
      case 'submit':
      case 'reset':
        break;
      case 'color':
      case 'date':
      case 'datetime':
      case 'datetime-local':
      case 'month':
      case 'time':
      case 'week':
        // This fixes the no-show issue on iOS Safari and Android Chrome:
        // https://github.com/facebook/react/issues/7233
        node.value = '';
        node.value = node.defaultValue;
        break;
      default:
        node.value = node.value;
        break;
    }

    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
    // this is needed to work around a chrome bug where setting defaultChecked
    // will sometimes influence the value of checked (even after detachment).
    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
    // We need to temporarily unset name to avoid disrupting radio button groups.
    var name = node.name;
    if (name !== '') {
      node.name = '';
    }
    node.defaultChecked = !node.defaultChecked;
    node.defaultChecked = !node.defaultChecked;
    if (name !== '') {
      node.name = name;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;

  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  // Here we use asap to wait until all updates have propagated, which
  // is important when using controlled components within layers:
  // https://github.com/facebook/react/issues/1698
  ReactUpdates.asap(forceUpdateIfMounted, this);

  var name = props.name;
  if (props.type === 'radio' && name != null) {
    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
    var queryRoot = rootNode;

    while (queryRoot.parentNode) {
      queryRoot = queryRoot.parentNode;
    }

    // If `rootNode.form` was non-null, then we could try `form.elements`,
    // but that sometimes behaves strangely in IE8. We could also try using
    // `form.getElementsByName`, but that will only return direct children
    // and won't include inputs that use the HTML5 `form=` attribute. Since
    // the input might not even be in a form, let's just use the global
    // `querySelectorAll` to ensure we don't miss anything.
    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

    for (var i = 0; i < group.length; i++) {
      var otherNode = group[i];
      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
        continue;
      }
      // This will throw if radio buttons rendered by different copies of React
      // and the same name are rendered into the same form (same as #1939).
      // That's probably okay; we don't support it just as we don't support
      // mixing React radio buttons with non-React ones.
      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
      // If this is a controlled radio button group, forcing the input that
      // was previously checked to update will cause it to be come re-checked
      // as appropriate.
      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
    }
  }

  return returnValue;
}

module.exports = ReactDOMInput;

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(7);

var React = __webpack_require__(35);
var ReactDOMComponentTree = __webpack_require__(8);
var ReactDOMSelect = __webpack_require__(112);

var warning = __webpack_require__(3);
var didWarnInvalidOptionChildren = false;

function flattenChildren(children) {
  var content = '';

  // Flatten children and warn if they aren't strings or numbers;
  // invalid types are ignored.
  React.Children.forEach(children, function (child) {
    if (child == null) {
      return;
    }
    if (typeof child === 'string' || typeof child === 'number') {
      content += child;
    } else if (!didWarnInvalidOptionChildren) {
      didWarnInvalidOptionChildren = true;
       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
    }
  });

  return content;
}

/**
 * Implements an <option> host component that warns when `selected` is set.
 */
var ReactDOMOption = {
  mountWrapper: function (inst, props, hostParent) {
    // TODO (yungsters): Remove support for `selected` in <option>.
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
    }

    // Look up whether this option is 'selected'
    var selectValue = null;
    if (hostParent != null) {
      var selectParent = hostParent;

      if (selectParent._tag === 'optgroup') {
        selectParent = selectParent._hostParent;
      }

      if (selectParent != null && selectParent._tag === 'select') {
        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
      }
    }

    // If the value is null (e.g., no specified value or after initial mount)
    // or missing (e.g., for <datalist>), we don't change props.selected
    var selected = null;
    if (selectValue != null) {
      var value;
      if (props.value != null) {
        value = props.value + '';
      } else {
        value = flattenChildren(props.children);
      }
      selected = false;
      if (Array.isArray(selectValue)) {
        // multiple
        for (var i = 0; i < selectValue.length; i++) {
          if ('' + selectValue[i] === value) {
            selected = true;
            break;
          }
        }
      } else {
        selected = '' + selectValue === value;
      }
    }

    inst._wrapperState = { selected: selected };
  },

  postMountWrapper: function (inst) {
    // value="" should make a value attribute (#6219)
    var props = inst._currentElement.props;
    if (props.value != null) {
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      node.setAttribute('value', props.value);
    }
  },

  getHostProps: function (inst, props) {
    var hostProps = _assign({ selected: undefined, children: undefined }, props);

    // Read state only from initial mount because <select> updates value
    // manually; we need the initial state only for server rendering
    if (inst._wrapperState.selected != null) {
      hostProps.selected = inst._wrapperState.selected;
    }

    var content = flattenChildren(props.children);

    if (content) {
      hostProps.children = content;
    }

    return hostProps;
  }
};

module.exports = ReactDOMOption;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(12);

var getNodeForCharacterOffset = __webpack_require__(291);
var getTextContentAccessor = __webpack_require__(123);

/**
 * While `isCollapsed` is available on the Selection object and `collapsed`
 * is available on the Range object, IE11 sometimes gets them wrong.
 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
 */
function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
  return anchorNode === focusNode && anchorOffset === focusOffset;
}

/**
 * Get the appropriate anchor and focus node/offset pairs for IE.
 *
 * The catch here is that IE's selection API doesn't provide information
 * about whether the selection is forward or backward, so we have to
 * behave as though it's always forward.
 *
 * IE text differs from modern selection in that it behaves as though
 * block elements end with a new line. This means character offsets will
 * differ between the two APIs.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getIEOffsets(node) {
  var selection = document.selection;
  var selectedRange = selection.createRange();
  var selectedLength = selectedRange.text.length;

  // Duplicate selection so we can move range without breaking user selection.
  var fromStart = selectedRange.duplicate();
  fromStart.moveToElementText(node);
  fromStart.setEndPoint('EndToStart', selectedRange);

  var startOffset = fromStart.text.length;
  var endOffset = startOffset + selectedLength;

  return {
    start: startOffset,
    end: endOffset
  };
}

/**
 * @param {DOMElement} node
 * @return {?object}
 */
function getModernOffsets(node) {
  var selection = window.getSelection && window.getSelection();

  if (!selection || selection.rangeCount === 0) {
    return null;
  }

  var anchorNode = selection.anchorNode;
  var anchorOffset = selection.anchorOffset;
  var focusNode = selection.focusNode;
  var focusOffset = selection.focusOffset;

  var currentRange = selection.getRangeAt(0);

  // In Firefox, range.startContainer and range.endContainer can be "anonymous
  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
  // divs do not seem to expose properties, triggering a "Permission denied
  // error" if any of its properties are accessed. The only seemingly possible
  // way to avoid erroring is to access a property that typically works for
  // non-anonymous divs and catch any error that may otherwise arise. See
  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
  try {
    /* eslint-disable no-unused-expressions */
    currentRange.startContainer.nodeType;
    currentRange.endContainer.nodeType;
    /* eslint-enable no-unused-expressions */
  } catch (e) {
    return null;
  }

  // If the node and offset values are the same, the selection is collapsed.
  // `Selection.isCollapsed` is available natively, but IE sometimes gets
  // this value wrong.
  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);

  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;

  var tempRange = currentRange.cloneRange();
  tempRange.selectNodeContents(node);
  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);

  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);

  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
  var end = start + rangeLength;

  // Detect whether the selection is backward.
  var detectionRange = document.createRange();
  detectionRange.setStart(anchorNode, anchorOffset);
  detectionRange.setEnd(focusNode, focusOffset);
  var isBackward = detectionRange.collapsed;

  return {
    start: isBackward ? end : start,
    end: isBackward ? start : end
  };
}

/**
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setIEOffsets(node, offsets) {
  var range = document.selection.createRange().duplicate();
  var start, end;

  if (offsets.end === undefined) {
    start = offsets.start;
    end = start;
  } else if (offsets.start > offsets.end) {
    start = offsets.end;
    end = offsets.start;
  } else {
    start = offsets.start;
    end = offsets.end;
  }

  range.moveToElementText(node);
  range.moveStart('character', start);
  range.setEndPoint('EndToStart', range);
  range.moveEnd('character', end - start);
  range.select();
}

/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setModernOffsets(node, offsets) {
  if (!window.getSelection) {
    return;
  }

  var selection = window.getSelection();
  var length = node[getTextContentAccessor()].length;
  var start = Math.min(offsets.start, length);
  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);

  // IE 11 uses modern selection, but doesn't support the extend method.
  // Flip backward selections, so we can set with a single range.
  if (!selection.extend && start > end) {
    var temp = end;
    end = start;
    start = temp;
  }

  var startMarker = getNodeForCharacterOffset(node, start);
  var endMarker = getNodeForCharacterOffset(node, end);

  if (startMarker && endMarker) {
    var range = document.createRange();
    range.setStart(startMarker.node, startMarker.offset);
    selection.removeAllRanges();

    if (start > end) {
      selection.addRange(range);
      selection.extend(endMarker.node, endMarker.offset);
    } else {
      range.setEnd(endMarker.node, endMarker.offset);
      selection.addRange(range);
    }
  }
}

var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);

var ReactDOMSelection = {
  /**
   * @param {DOMElement} node
   */
  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,

  /**
   * @param {DOMElement|DOMTextNode} node
   * @param {object} offsets
   */
  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
};

module.exports = ReactDOMSelection;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(4),
    _assign = __webpack_require__(7);

var DOMChildrenOperations = __webpack_require__(67);
var DOMLazyTree = __webpack_require__(31);
var ReactDOMComponentTree = __webpack_require__(8);

var escapeTextContentForBrowser = __webpack_require__(52);
var invariant = __webpack_require__(1);
var validateDOMNesting = __webpack_require__(82);

/**
 * Text nodes violate a couple assumptions that React makes about components:
 *
 *  - When mounting text into the DOM, adjacent text nodes are merged.
 *  - Text nodes cannot be assigned a React root ID.
 *
 * This component is used to wrap strings between comment nodes so that they
 * can undergo the same reconciliation that is applied to elements.
 *
 * TODO: Investigate representing React components in the DOM with text nodes.
 *
 * @class ReactDOMTextComponent
 * @extends ReactComponent
 * @internal
 */
var ReactDOMTextComponent = function (text) {
  // TODO: This is really a ReactText (ReactNode), not a ReactElement
  this._currentElement = text;
  this._stringText = '' + text;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;

  // Properties
  this._domID = 0;
  this._mountIndex = 0;
  this._closingComment = null;
  this._commentNodes = null;
};

_assign(ReactDOMTextComponent.prototype, {
  /**
   * Creates the markup for this text node. This node is not intended to have
   * any features besides containing text content.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {string} Markup for this text node.
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo != null) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(null, this._stringText, this, parentInfo);
      }
    }

    var domID = hostContainerInfo._idCounter++;
    var openingValue = ' react-text: ' + domID + ' ';
    var closingValue = ' /react-text ';
    this._domID = domID;
    this._hostParent = hostParent;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var openingComment = ownerDocument.createComment(openingValue);
      var closingComment = ownerDocument.createComment(closingValue);
      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
      if (this._stringText) {
        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
      }
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
      ReactDOMComponentTree.precacheNode(this, openingComment);
      this._closingComment = closingComment;
      return lazyTree;
    } else {
      var escapedText = escapeTextContentForBrowser(this._stringText);

      if (transaction.renderToStaticMarkup) {
        // Normally we'd wrap this between comment nodes for the reasons stated
        // above, but since this is a situation where React won't take over
        // (static pages), we can simply return the text as it is.
        return escapedText;
      }

      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
    }
  },

  /**
   * Updates this component by updating the text content.
   *
   * @param {ReactText} nextText The next text content
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  receiveComponent: function (nextText, transaction) {
    if (nextText !== this._currentElement) {
      this._currentElement = nextText;
      var nextStringText = '' + nextText;
      if (nextStringText !== this._stringText) {
        // TODO: Save this as pending props and use performUpdateIfNecessary
        // and/or updateComponent to do the actual update for consistency with
        // other component types?
        this._stringText = nextStringText;
        var commentNodes = this.getHostNode();
        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
      }
    }
  },

  getHostNode: function () {
    var hostNode = this._commentNodes;
    if (hostNode) {
      return hostNode;
    }
    if (!this._closingComment) {
      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
      var node = openingComment.nextSibling;
      while (true) {
        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
          this._closingComment = node;
          break;
        }
        node = node.nextSibling;
      }
    }
    hostNode = [this._hostNode, this._closingComment];
    this._commentNodes = hostNode;
    return hostNode;
  },

  unmountComponent: function () {
    this._closingComment = null;
    this._commentNodes = null;
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMTextComponent;

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(4),
    _assign = __webpack_require__(7);

var LinkedValueUtils = __webpack_require__(72);
var ReactDOMComponentTree = __webpack_require__(8);
var ReactUpdates = __webpack_require__(16);

var invariant = __webpack_require__(1);
var warning = __webpack_require__(3);

var didWarnValueLink = false;
var didWarnValDefaultVal = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMTextarea.updateWrapper(this);
  }
}

/**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */
var ReactDOMTextarea = {
  getHostProps: function (inst, props) {
    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;

    // Always set children to the same thing. In IE9, the selection range will
    // get reset if `textContent` is mutated.  We could add a check in setTextContent
    // to only set the value if/when the value differs from the node value (which would
    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
    // The value can be a boolean or object so that's why it's forced to be a string.
    var hostProps = _assign({}, props, {
      value: undefined,
      defaultValue: undefined,
      children: '' + inst._wrapperState.initialValue,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
        didWarnValDefaultVal = true;
      }
    }

    var value = LinkedValueUtils.getValue(props);
    var initialValue = value;

    // Only bother fetching default value if we're going to use it
    if (value == null) {
      var defaultValue = props.defaultValue;
      // TODO (yungsters): Remove support for children content in <textarea>.
      var children = props.children;
      if (children != null) {
        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
        }
        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
        if (Array.isArray(children)) {
          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
          children = children[0];
        }

        defaultValue = '' + children;
      }
      if (defaultValue == null) {
        defaultValue = '';
      }
      initialValue = defaultValue;
    }

    inst._wrapperState = {
      initialValue: '' + initialValue,
      listeners: null,
      onChange: _handleChange.bind(inst)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      // Cast `value` to a string to ensure the value is set correctly. While
      // browsers typically do this as necessary, jsdom doesn't.
      var newValue = '' + value;

      // To avoid side effects (such as losing text selection), only set value if changed
      if (newValue !== node.value) {
        node.value = newValue;
      }
      if (props.defaultValue == null) {
        node.defaultValue = newValue;
      }
    }
    if (props.defaultValue != null) {
      node.defaultValue = props.defaultValue;
    }
  },

  postMountWrapper: function (inst) {
    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var textContent = node.textContent;

    // Only set node.value if textContent is equal to the expected
    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
    // will populate textContent as well.
    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
    if (textContent === inst._wrapperState.initialValue) {
      node.value = textContent;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);
  ReactUpdates.asap(forceUpdateIfMounted, this);
  return returnValue;
}

module.exports = ReactDOMTextarea;

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(4);

var invariant = __webpack_require__(1);

/**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */
function getLowestCommonAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  var depthA = 0;
  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
    depthA++;
  }
  var depthB = 0;
  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
    depthB++;
  }

  // If A is deeper, crawl up.
  while (depthA - depthB > 0) {
    instA = instA._hostParent;
    depthA--;
  }

  // If B is deeper, crawl up.
  while (depthB - depthA > 0) {
    instB = instB._hostParent;
    depthB--;
  }

  // Walk in lockstep until we find a match.
  var depth = depthA;
  while (depth--) {
    if (instA === instB) {
      return instA;
    }
    instA = instA._hostParent;
    instB = instB._hostParent;
  }
  return null;
}

/**
 * Return if A is an ancestor of B.
 */
function isAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;

  while (instB) {
    if (instB === instA) {
      return true;
    }
    instB = instB._hostParent;
  }
  return false;
}

/**
 * Return the parent instance of the passed-in instance.
 */
function getParentInstance(inst) {
  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;

  return inst._hostParent;
}

/**
 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
 */
function traverseTwoPhase(inst, fn, arg) {
  var path = [];
  while (inst) {
    path.push(inst);
    inst = inst._hostParent;
  }
  var i;
  for (i = path.length; i-- > 0;) {
    fn(path[i], 'captured', arg);
  }
  for (i = 0; i < path.length; i++) {
    fn(path[i], 'bubbled', arg);
  }
}

/**
 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
 * should would receive a `mouseEnter` or `mouseLeave` event.
 *
 * Does not invoke the callback on the nearest common ancestor because nothing
 * "entered" or "left" that element.
 */
function traverseEnterLeave(from, to, fn, argFrom, argTo) {
  var common = from && to ? getLowestCommonAncestor(from, to) : null;
  var pathFrom = [];
  while (from && from !== common) {
    pathFrom.push(from);
    from = from._hostParent;
  }
  var pathTo = [];
  while (to && to !== common) {
    pathTo.push(to);
    to = to._hostParent;
  }
  var i;
  for (i = 0; i < pathFrom.length; i++) {
    fn(pathFrom[i], 'bubbled', argFrom);
  }
  for (i = pathTo.length; i-- > 0;) {
    fn(pathTo[i], 'captured', argTo);
  }
}

module.exports = {
  isAncestor: isAncestor,
  getLowestCommonAncestor: getLowestCommonAncestor,
  getParentInstance: getParentInstance,
  traverseTwoPhase: traverseTwoPhase,
  traverseEnterLeave: traverseEnterLeave
};

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(7);

var ReactUpdates = __webpack_require__(16);
var Transaction = __webpack_require__(51);

var emptyFunction = __webpack_require__(13);

var RESET_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: function () {
    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
  }
};

var FLUSH_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
};

var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];

function ReactDefaultBatchingStrategyTransaction() {
  this.reinitializeTransaction();
}

_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  }
});

var transaction = new ReactDefaultBatchingStrategyTransaction();

var ReactDefaultBatchingStrategy = {
  isBatchingUpdates: false,

  /**
   * Call the provided function in a context within which calls to `setState`
   * and friends are batched such that components aren't updated unnecessarily.
   */
  batchedUpdates: function (callback, a, b, c, d, e) {
    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;

    ReactDefaultBatchingStrategy.isBatchingUpdates = true;

    // The code is written this way to avoid extra allocations
    if (alreadyBatchingUpdates) {
      return callback(a, b, c, d, e);
    } else {
      return transaction.perform(callback, null, a, b, c, d, e);
    }
  }
};

module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ARIADOMPropertyConfig = __webpack_require__(232);
var BeforeInputEventPlugin = __webpack_require__(234);
var ChangeEventPlugin = __webpack_require__(236);
var DefaultEventPluginOrder = __webpack_require__(238);
var EnterLeaveEventPlugin = __webpack_require__(239);
var HTMLDOMPropertyConfig = __webpack_require__(241);
var ReactComponentBrowserEnvironment = __webpack_require__(243);
var ReactDOMComponent = __webpack_require__(246);
var ReactDOMComponentTree = __webpack_require__(8);
var ReactDOMEmptyComponent = __webpack_require__(248);
var ReactDOMTreeTraversal = __webpack_require__(256);
var ReactDOMTextComponent = __webpack_require__(254);
var ReactDefaultBatchingStrategy = __webpack_require__(257);
var ReactEventListener = __webpack_require__(261);
var ReactInjection = __webpack_require__(262);
var ReactReconcileTransaction = __webpack_require__(267);
var SVGDOMPropertyConfig = __webpack_require__(272);
var SelectEventPlugin = __webpack_require__(273);
var SimpleEventPlugin = __webpack_require__(274);

var alreadyInjected = false;

function inject() {
  if (alreadyInjected) {
    // TODO: This is currently true because these injections are shared between
    // the client and the server package. They should be built independently
    // and not share any injection state. Then this problem will be solved.
    return;
  }
  alreadyInjected = true;

  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);

  /**
   * Inject modules for resolving DOM hierarchy and plugin ordering.
   */
  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);

  /**
   * Some important event plugins included by default (without having to require
   * them).
   */
  ReactInjection.EventPluginHub.injectEventPluginsByName({
    SimpleEventPlugin: SimpleEventPlugin,
    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
    ChangeEventPlugin: ChangeEventPlugin,
    SelectEventPlugin: SelectEventPlugin,
    BeforeInputEventPlugin: BeforeInputEventPlugin
  });

  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);

  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);

  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);

  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
    return new ReactDOMEmptyComponent(instantiate);
  });

  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);

  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
}

module.exports = {
  inject: inject
};

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(40);

function runEventQueueInBatch(events) {
  EventPluginHub.enqueueEvents(events);
  EventPluginHub.processEventQueue(false);
}

var ReactEventEmitterMixin = {
  /**
   * Streams a fired top-level event to `EventPluginHub` where plugins have the
   * opportunity to create `ReactEvent`s to be dispatched.
   */
  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
    runEventQueueInBatch(events);
  }
};

module.exports = ReactEventEmitterMixin;

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(7);

var EventListener = __webpack_require__(97);
var ExecutionEnvironment = __webpack_require__(12);
var PooledClass = __webpack_require__(24);
var ReactDOMComponentTree = __webpack_require__(8);
var ReactUpdates = __webpack_require__(16);

var getEventTarget = __webpack_require__(79);
var getUnboundedScrollPosition = __webpack_require__(212);

/**
 * Find the deepest React component completely containing the root of the
 * passed-in instance (for use when entire React trees are nested within each
 * other). If React trees are not nested, returns null.
 */
function findParent(inst) {
  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
  // traversal, but caching is difficult to do correctly without using a
  // mutation observer to listen for all DOM changes.
  while (inst._hostParent) {
    inst = inst._hostParent;
  }
  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
  var container = rootNode.parentNode;
  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
}

// Used to store ancestor hierarchy in top level callback
function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
  this.topLevelType = topLevelType;
  this.nativeEvent = nativeEvent;
  this.ancestors = [];
}
_assign(TopLevelCallbackBookKeeping.prototype, {
  destructor: function () {
    this.topLevelType = null;
    this.nativeEvent = null;
    this.ancestors.length = 0;
  }
});
PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);

function handleTopLevelImpl(bookKeeping) {
  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);

  // Loop through the hierarchy, in case there's any nested components.
  // It's important that we build the array of ancestors before calling any
  // event handlers, because event handlers can modify the DOM, leading to
  // inconsistencies with ReactMount's node cache. See #1105.
  var ancestor = targetInst;
  do {
    bookKeeping.ancestors.push(ancestor);
    ancestor = ancestor && findParent(ancestor);
  } while (ancestor);

  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
    targetInst = bookKeeping.ancestors[i];
    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
  }
}

function scrollValueMonitor(cb) {
  var scrollPosition = getUnboundedScrollPosition(window);
  cb(scrollPosition);
}

var ReactEventListener = {
  _enabled: true,
  _handleTopLevel: null,

  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,

  setHandleTopLevel: function (handleTopLevel) {
    ReactEventListener._handleTopLevel = handleTopLevel;
  },

  setEnabled: function (enabled) {
    ReactEventListener._enabled = !!enabled;
  },

  isEnabled: function () {
    return ReactEventListener._enabled;
  },

  /**
   * Traps top-level events by using event bubbling.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  /**
   * Traps a top-level event by using event capturing.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  monitorScrollValue: function (refresh) {
    var callback = scrollValueMonitor.bind(null, refresh);
    EventListener.listen(window, 'scroll', callback);
  },

  dispatchEvent: function (topLevelType, nativeEvent) {
    if (!ReactEventListener._enabled) {
      return;
    }

    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
    try {
      // Event queue being processed in the same cycle allows
      // `preventDefault`.
      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
    } finally {
      TopLevelCallbackBookKeeping.release(bookKeeping);
    }
  }
};

module.exports = ReactEventListener;

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(32);
var EventPluginHub = __webpack_require__(40);
var EventPluginUtils = __webpack_require__(70);
var ReactComponentEnvironment = __webpack_require__(73);
var ReactEmptyComponent = __webpack_require__(113);
var ReactBrowserEventEmitter = __webpack_require__(49);
var ReactHostComponent = __webpack_require__(115);
var ReactUpdates = __webpack_require__(16);

var ReactInjection = {
  Component: ReactComponentEnvironment.injection,
  DOMProperty: DOMProperty.injection,
  EmptyComponent: ReactEmptyComponent.injection,
  EventPluginHub: EventPluginHub.injection,
  EventPluginUtils: EventPluginUtils.injection,
  EventEmitter: ReactBrowserEventEmitter.injection,
  HostComponent: ReactHostComponent.injection,
  Updates: ReactUpdates.injection
};

module.exports = ReactInjection;

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var adler32 = __webpack_require__(285);

var TAG_END = /\/?>/;
var COMMENT_START = /^<\!\-\-/;

var ReactMarkupChecksum = {
  CHECKSUM_ATTR_NAME: 'data-react-checksum',

  /**
   * @param {string} markup Markup string
   * @return {string} Markup string with checksum attribute attached
   */
  addChecksumToMarkup: function (markup) {
    var checksum = adler32(markup);

    // Add checksum (handle both parent tags, comments and self-closing tags)
    if (COMMENT_START.test(markup)) {
      return markup;
    } else {
      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
    }
  },

  /**
   * @param {string} markup to use
   * @param {DOMElement} element root React element
   * @returns {boolean} whether or not the markup is the same
   */
  canReuseMarkup: function (markup, element) {
    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
    var markupChecksum = adler32(markup);
    return markupChecksum === existingChecksum;
  }
};

module.exports = ReactMarkupChecksum;

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(4);

var ReactComponentEnvironment = __webpack_require__(73);
var ReactInstanceMap = __webpack_require__(42);
var ReactInstrumentation = __webpack_require__(14);

var ReactCurrentOwner = __webpack_require__(20);
var ReactReconciler = __webpack_require__(33);
var ReactChildReconciler = __webpack_require__(242);

var emptyFunction = __webpack_require__(13);
var flattenChildren = __webpack_require__(288);
var invariant = __webpack_require__(1);

/**
 * Make an update for markup to be rendered and inserted at a supplied index.
 *
 * @param {string} markup Markup that renders into an element.
 * @param {number} toIndex Destination index.
 * @private
 */
function makeInsertMarkup(markup, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'INSERT_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for moving an existing element to another index.
 *
 * @param {number} fromIndex Source index of the existing element.
 * @param {number} toIndex Destination index of the element.
 * @private
 */
function makeMove(child, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'MOVE_EXISTING',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: ReactReconciler.getHostNode(child),
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for removing an element at an index.
 *
 * @param {number} fromIndex Index of the element to remove.
 * @private
 */
function makeRemove(child, node) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'REMOVE_NODE',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: node,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the markup of a node.
 *
 * @param {string} markup Markup that renders into an element.
 * @private
 */
function makeSetMarkup(markup) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'SET_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the text content.
 *
 * @param {string} textContent Text content to set.
 * @private
 */
function makeTextContent(textContent) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'TEXT_CONTENT',
    content: textContent,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Push an update, if any, onto the queue. Creates a new queue if none is
 * passed and always returns the queue. Mutative.
 */
function enqueue(queue, update) {
  if (update) {
    queue = queue || [];
    queue.push(update);
  }
  return queue;
}

/**
 * Processes any enqueued updates.
 *
 * @private
 */
function processQueue(inst, updateQueue) {
  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
}

var setChildrenForInstrumentation = emptyFunction;
if (false) {
  var getDebugID = function (inst) {
    if (!inst._debugID) {
      // Check for ART-like instances. TODO: This is silly/gross.
      var internal;
      if (internal = ReactInstanceMap.get(inst)) {
        inst = internal;
      }
    }
    return inst._debugID;
  };
  setChildrenForInstrumentation = function (children) {
    var debugID = getDebugID(this);
    // TODO: React Native empty components are also multichild.
    // This means they still get into this method but don't have _debugID.
    if (debugID !== 0) {
      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
        return children[key]._debugID;
      }) : []);
    }
  };
}

/**
 * ReactMultiChild are capable of reconciling multiple children.
 *
 * @class ReactMultiChild
 * @internal
 */
var ReactMultiChild = {
  /**
   * Provides common functionality for components that must reconcile multiple
   * children. This is used by `ReactDOMComponent` to mount, update, and
   * unmount child components.
   *
   * @lends {ReactMultiChild.prototype}
   */
  Mixin: {
    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
      if (false) {
        var selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
        }
      }
      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
    },

    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
      var nextChildren;
      var selfDebugID = 0;
      if (false) {
        selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
          return nextChildren;
        }
      }
      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
      return nextChildren;
    },

    /**
     * Generates a "mount image" for each of the supplied children. In the case
     * of `ReactDOMComponent`, a mount image is a string of markup.
     *
     * @param {?object} nestedChildren Nested child maps.
     * @return {array} An array of mounted representations.
     * @internal
     */
    mountChildren: function (nestedChildren, transaction, context) {
      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
      this._renderedChildren = children;

      var mountImages = [];
      var index = 0;
      for (var name in children) {
        if (children.hasOwnProperty(name)) {
          var child = children[name];
          var selfDebugID = 0;
          if (false) {
            selfDebugID = getDebugID(this);
          }
          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
          child._mountIndex = index++;
          mountImages.push(mountImage);
        }
      }

      if (false) {
        setChildrenForInstrumentation.call(this, children);
      }

      return mountImages;
    },

    /**
     * Replaces any rendered children with a text content string.
     *
     * @param {string} nextContent String of content.
     * @internal
     */
    updateTextContent: function (nextContent) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      // Set new text content.
      var updates = [makeTextContent(nextContent)];
      processQueue(this, updates);
    },

    /**
     * Replaces any rendered children with a markup string.
     *
     * @param {string} nextMarkup String of markup.
     * @internal
     */
    updateMarkup: function (nextMarkup) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      var updates = [makeSetMarkup(nextMarkup)];
      processQueue(this, updates);
    },

    /**
     * Updates the rendered children with new children.
     *
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @internal
     */
    updateChildren: function (nextNestedChildrenElements, transaction, context) {
      // Hook used by React ART
      this._updateChildren(nextNestedChildrenElements, transaction, context);
    },

    /**
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @final
     * @protected
     */
    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
      var prevChildren = this._renderedChildren;
      var removedNodes = {};
      var mountImages = [];
      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
      if (!nextChildren && !prevChildren) {
        return;
      }
      var updates = null;
      var name;
      // `nextIndex` will increment for each child in `nextChildren`, but
      // `lastIndex` will be the last index visited in `prevChildren`.
      var nextIndex = 0;
      var lastIndex = 0;
      // `nextMountIndex` will increment for each newly mounted child.
      var nextMountIndex = 0;
      var lastPlacedNode = null;
      for (name in nextChildren) {
        if (!nextChildren.hasOwnProperty(name)) {
          continue;
        }
        var prevChild = prevChildren && prevChildren[name];
        var nextChild = nextChildren[name];
        if (prevChild === nextChild) {
          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
          prevChild._mountIndex = nextIndex;
        } else {
          if (prevChild) {
            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
            // The `removedNodes` loop below will actually remove the child.
          }
          // The child must be instantiated before it's mounted.
          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
          nextMountIndex++;
        }
        nextIndex++;
        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
      }
      // Remove children that are no longer present.
      for (name in removedNodes) {
        if (removedNodes.hasOwnProperty(name)) {
          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
        }
      }
      if (updates) {
        processQueue(this, updates);
      }
      this._renderedChildren = nextChildren;

      if (false) {
        setChildrenForInstrumentation.call(this, nextChildren);
      }
    },

    /**
     * Unmounts all rendered children. This should be used to clean up children
     * when this component is unmounted. It does not actually perform any
     * backend operations.
     *
     * @internal
     */
    unmountChildren: function (safely) {
      var renderedChildren = this._renderedChildren;
      ReactChildReconciler.unmountChildren(renderedChildren, safely);
      this._renderedChildren = null;
    },

    /**
     * Moves a child component to the supplied index.
     *
     * @param {ReactComponent} child Component to move.
     * @param {number} toIndex Destination index of the element.
     * @param {number} lastIndex Last index visited of the siblings of `child`.
     * @protected
     */
    moveChild: function (child, afterNode, toIndex, lastIndex) {
      // If the index of `child` is less than `lastIndex`, then it needs to
      // be moved. Otherwise, we do not need to move it because a child will be
      // inserted or moved before `child`.
      if (child._mountIndex < lastIndex) {
        return makeMove(child, afterNode, toIndex);
      }
    },

    /**
     * Creates a child component.
     *
     * @param {ReactComponent} child Component to create.
     * @param {string} mountImage Markup to insert.
     * @protected
     */
    createChild: function (child, afterNode, mountImage) {
      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
    },

    /**
     * Removes a child component.
     *
     * @param {ReactComponent} child Child to remove.
     * @protected
     */
    removeChild: function (child, node) {
      return makeRemove(child, node);
    },

    /**
     * Mounts a child with the supplied name.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to mount.
     * @param {string} name Name of the child.
     * @param {number} index Index at which to insert the child.
     * @param {ReactReconcileTransaction} transaction
     * @private
     */
    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
      child._mountIndex = index;
      return this.createChild(child, afterNode, mountImage);
    },

    /**
     * Unmounts a rendered child.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to unmount.
     * @private
     */
    _unmountChild: function (child, node) {
      var update = this.removeChild(child, node);
      child._mountIndex = null;
      return update;
    }
  }
};

module.exports = ReactMultiChild;

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(4);

var invariant = __webpack_require__(1);

/**
 * @param {?object} object
 * @return {boolean} True if `object` is a valid owner.
 * @final
 */
function isValidOwner(object) {
  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
}

/**
 * ReactOwners are capable of storing references to owned components.
 *
 * All components are capable of //being// referenced by owner components, but
 * only ReactOwner components are capable of //referencing// owned components.
 * The named reference is known as a "ref".
 *
 * Refs are available when mounted and updated during reconciliation.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return (
 *         <div onClick={this.handleClick}>
 *           <CustomComponent ref="custom" />
 *         </div>
 *       );
 *     },
 *     handleClick: function() {
 *       this.refs.custom.handleClick();
 *     },
 *     componentDidMount: function() {
 *       this.refs.custom.initialize();
 *     }
 *   });
 *
 * Refs should rarely be used. When refs are used, they should only be done to
 * control data that is not handled by React's data flow.
 *
 * @class ReactOwner
 */
var ReactOwner = {
  /**
   * Adds a component by ref to an owner component.
   *
   * @param {ReactComponent} component Component to reference.
   * @param {string} ref Name by which to refer to the component.
   * @param {ReactOwner} owner Component on which to record the ref.
   * @final
   * @internal
   */
  addComponentAsRefTo: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
    owner.attachRef(ref, component);
  },

  /**
   * Removes a component by ref from an owner component.
   *
   * @param {ReactComponent} component Component to dereference.
   * @param {string} ref Name of the ref to remove.
   * @param {ReactOwner} owner Component on which the ref is recorded.
   * @final
   * @internal
   */
  removeComponentAsRefFrom: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
    var ownerPublicInstance = owner.getPublicInstance();
    // Check that `component`'s owner is still alive and that `component` is still the current ref
    // because we do not want to detach the ref if another component stole it.
    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
      owner.detachRef(ref);
    }
  }
};

module.exports = ReactOwner;

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(7);

var CallbackQueue = __webpack_require__(109);
var PooledClass = __webpack_require__(24);
var ReactBrowserEventEmitter = __webpack_require__(49);
var ReactInputSelection = __webpack_require__(116);
var ReactInstrumentation = __webpack_require__(14);
var Transaction = __webpack_require__(51);
var ReactUpdateQueue = __webpack_require__(75);

/**
 * Ensures that, when possible, the selection range (currently selected text
 * input) is not disturbed by performing the transaction.
 */
var SELECTION_RESTORATION = {
  /**
   * @return {Selection} Selection information.
   */
  initialize: ReactInputSelection.getSelectionInformation,
  /**
   * @param {Selection} sel Selection information returned from `initialize`.
   */
  close: ReactInputSelection.restoreSelection
};

/**
 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
 * high level DOM manipulations (like temporarily removing a text input from the
 * DOM).
 */
var EVENT_SUPPRESSION = {
  /**
   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
   * the reconciliation.
   */
  initialize: function () {
    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
    ReactBrowserEventEmitter.setEnabled(false);
    return currentlyEnabled;
  },

  /**
   * @param {boolean} previouslyEnabled Enabled status of
   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
   *   restores the previous value.
   */
  close: function (previouslyEnabled) {
    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
  }
};

/**
 * Provides a queue for collecting `componentDidMount` and
 * `componentDidUpdate` callbacks during the transaction.
 */
var ON_DOM_READY_QUEUEING = {
  /**
   * Initializes the internal `onDOMReady` queue.
   */
  initialize: function () {
    this.reactMountReady.reset();
  },

  /**
   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
   */
  close: function () {
    this.reactMountReady.notifyAll();
  }
};

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

/**
 * Currently:
 * - The order that these are listed in the transaction is critical:
 * - Suppresses events.
 * - Restores selection range.
 *
 * Future:
 * - Restore document/overflow scroll positions that were unintentionally
 *   modified via DOM insertions above the top viewport boundary.
 * - Implement/integrate with customized constraint based layout system and keep
 *   track of which dimensions must be remeasured.
 *
 * @class ReactReconcileTransaction
 */
function ReactReconcileTransaction(useCreateElement) {
  this.reinitializeTransaction();
  // Only server-side rendering really needs this option (see
  // `ReactServerRendering`), but server-side uses
  // `ReactServerRenderingTransaction` instead. This option is here so that it's
  // accessible and defaults to false when `ReactDOMComponent` and
  // `ReactDOMTextComponent` checks it in `mountComponent`.`
  this.renderToStaticMarkup = false;
  this.reactMountReady = CallbackQueue.getPooled(null);
  this.useCreateElement = useCreateElement;
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array<object>} List of operation wrap procedures.
   *   TODO: convert to array<TransactionWrapper>
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return this.reactMountReady;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return ReactUpdateQueue;
  },

  /**
   * Save current transaction state -- if the return value from this method is
   * passed to `rollback`, the transaction will be reset to that state.
   */
  checkpoint: function () {
    // reactMountReady is the our only stateful wrapper
    return this.reactMountReady.checkpoint();
  },

  rollback: function (checkpoint) {
    this.reactMountReady.rollback(checkpoint);
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {
    CallbackQueue.release(this.reactMountReady);
    this.reactMountReady = null;
  }
};

_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactReconcileTransaction);

module.exports = ReactReconcileTransaction;

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactOwner = __webpack_require__(265);

var ReactRef = {};

function attachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(component.getPublicInstance());
  } else {
    // Legacy ref
    ReactOwner.addComponentAsRefTo(component, ref, owner);
  }
}

function detachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(null);
  } else {
    // Legacy ref
    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
  }
}

ReactRef.attachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    attachRef(ref, instance, element._owner);
  }
};

ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
  // If either the owner or a `ref` has changed, make sure the newest owner
  // has stored a reference to `this`, and the previous owner (if different)
  // has forgotten the reference to `this`. We use the element instead
  // of the public this.props because the post processing cannot determine
  // a ref. The ref conceptually lives on the element.

  // TODO: Should this even be possible? The owner cannot change because
  // it's forbidden by shouldUpdateReactComponent. The ref can change
  // if you swap the keys of but not the refs. Reconsider where this check
  // is made. It probably belongs where the key checking and
  // instantiateReactComponent is done.

  var prevRef = null;
  var prevOwner = null;
  if (prevElement !== null && typeof prevElement === 'object') {
    prevRef = prevElement.ref;
    prevOwner = prevElement._owner;
  }

  var nextRef = null;
  var nextOwner = null;
  if (nextElement !== null && typeof nextElement === 'object') {
    nextRef = nextElement.ref;
    nextOwner = nextElement._owner;
  }

  return prevRef !== nextRef ||
  // If owner changes but we have an unchanged function ref, don't update refs
  typeof nextRef === 'string' && nextOwner !== prevOwner;
};

ReactRef.detachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    detachRef(ref, instance, element._owner);
  }
};

module.exports = ReactRef;

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(7);

var PooledClass = __webpack_require__(24);
var Transaction = __webpack_require__(51);
var ReactInstrumentation = __webpack_require__(14);
var ReactServerUpdateQueue = __webpack_require__(270);

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

var noopCallbackQueue = {
  enqueue: function () {}
};

/**
 * @class ReactServerRenderingTransaction
 * @param {boolean} renderToStaticMarkup
 */
function ReactServerRenderingTransaction(renderToStaticMarkup) {
  this.reinitializeTransaction();
  this.renderToStaticMarkup = renderToStaticMarkup;
  this.useCreateElement = false;
  this.updateQueue = new ReactServerUpdateQueue(this);
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array} Empty list of operation wrap procedures.
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return noopCallbackQueue;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return this.updateQueue;
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {},

  checkpoint: function () {},

  rollback: function () {}
};

_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactServerRenderingTransaction);

module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReactUpdateQueue = __webpack_require__(75);

var warning = __webpack_require__(3);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the update queue used for server rendering.
 * It delegates to ReactUpdateQueue while server rendering is in progress and
 * switches to ReactNoopUpdateQueue after the transaction has completed.
 * @class ReactServerUpdateQueue
 * @param {Transaction} transaction
 */

var ReactServerUpdateQueue = function () {
  function ReactServerUpdateQueue(transaction) {
    _classCallCheck(this, ReactServerUpdateQueue);

    this.transaction = transaction;
  }

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */


  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
    return false;
  };

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
    }
  };

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
    } else {
      warnNoop(publicInstance, 'forceUpdate');
    }
  };

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} completeState Next state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
    } else {
      warnNoop(publicInstance, 'replaceState');
    }
  };

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} partialState Next partial state to be merged with state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
    } else {
      warnNoop(publicInstance, 'setState');
    }
  };

  return ReactServerUpdateQueue;
}();

module.exports = ReactServerUpdateQueue;

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



module.exports = '15.6.1';

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var NS = {
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace'
};

// We use attributes for everything SVG so let's avoid some duplication and run
// code instead.
// The following are all specified in the HTML config already so we exclude here.
// - class (as className)
// - color
// - height
// - id
// - lang
// - max
// - media
// - method
// - min
// - name
// - style
// - target
// - type
// - width
var ATTRS = {
  accentHeight: 'accent-height',
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 'alignment-baseline',
  allowReorder: 'allowReorder',
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 'arabic-form',
  ascent: 0,
  attributeName: 'attributeName',
  attributeType: 'attributeType',
  autoReverse: 'autoReverse',
  azimuth: 0,
  baseFrequency: 'baseFrequency',
  baseProfile: 'baseProfile',
  baselineShift: 'baseline-shift',
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 'calcMode',
  capHeight: 'cap-height',
  clip: 0,
  clipPath: 'clip-path',
  clipRule: 'clip-rule',
  clipPathUnits: 'clipPathUnits',
  colorInterpolation: 'color-interpolation',
  colorInterpolationFilters: 'color-interpolation-filters',
  colorProfile: 'color-profile',
  colorRendering: 'color-rendering',
  contentScriptType: 'contentScriptType',
  contentStyleType: 'contentStyleType',
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 'diffuseConstant',
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 'dominant-baseline',
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 'edgeMode',
  elevation: 0,
  enableBackground: 'enable-background',
  end: 0,
  exponent: 0,
  externalResourcesRequired: 'externalResourcesRequired',
  fill: 0,
  fillOpacity: 'fill-opacity',
  fillRule: 'fill-rule',
  filter: 0,
  filterRes: 'filterRes',
  filterUnits: 'filterUnits',
  floodColor: 'flood-color',
  floodOpacity: 'flood-opacity',
  focusable: 0,
  fontFamily: 'font-family',
  fontSize: 'font-size',
  fontSizeAdjust: 'font-size-adjust',
  fontStretch: 'font-stretch',
  fontStyle: 'font-style',
  fontVariant: 'font-variant',
  fontWeight: 'font-weight',
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 'glyph-name',
  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
  glyphOrientationVertical: 'glyph-orientation-vertical',
  glyphRef: 'glyphRef',
  gradientTransform: 'gradientTransform',
  gradientUnits: 'gradientUnits',
  hanging: 0,
  horizAdvX: 'horiz-adv-x',
  horizOriginX: 'horiz-origin-x',
  ideographic: 0,
  imageRendering: 'image-rendering',
  'in': 0,
  in2: 0,
  intercept: 0,
  k: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  kernelMatrix: 'kernelMatrix',
  kernelUnitLength: 'kernelUnitLength',
  kerning: 0,
  keyPoints: 'keyPoints',
  keySplines: 'keySplines',
  keyTimes: 'keyTimes',
  lengthAdjust: 'lengthAdjust',
  letterSpacing: 'letter-spacing',
  lightingColor: 'lighting-color',
  limitingConeAngle: 'limitingConeAngle',
  local: 0,
  markerEnd: 'marker-end',
  markerMid: 'marker-mid',
  markerStart: 'marker-start',
  markerHeight: 'markerHeight',
  markerUnits: 'markerUnits',
  markerWidth: 'markerWidth',
  mask: 0,
  maskContentUnits: 'maskContentUnits',
  maskUnits: 'maskUnits',
  mathematical: 0,
  mode: 0,
  numOctaves: 'numOctaves',
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 'overline-position',
  overlineThickness: 'overline-thickness',
  paintOrder: 'paint-order',
  panose1: 'panose-1',
  pathLength: 'pathLength',
  patternContentUnits: 'patternContentUnits',
  patternTransform: 'patternTransform',
  patternUnits: 'patternUnits',
  pointerEvents: 'pointer-events',
  points: 0,
  pointsAtX: 'pointsAtX',
  pointsAtY: 'pointsAtY',
  pointsAtZ: 'pointsAtZ',
  preserveAlpha: 'preserveAlpha',
  preserveAspectRatio: 'preserveAspectRatio',
  primitiveUnits: 'primitiveUnits',
  r: 0,
  radius: 0,
  refX: 'refX',
  refY: 'refY',
  renderingIntent: 'rendering-intent',
  repeatCount: 'repeatCount',
  repeatDur: 'repeatDur',
  requiredExtensions: 'requiredExtensions',
  requiredFeatures: 'requiredFeatures',
  restart: 0,
  result: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  seed: 0,
  shapeRendering: 'shape-rendering',
  slope: 0,
  spacing: 0,
  specularConstant: 'specularConstant',
  specularExponent: 'specularExponent',
  speed: 0,
  spreadMethod: 'spreadMethod',
  startOffset: 'startOffset',
  stdDeviation: 'stdDeviation',
  stemh: 0,
  stemv: 0,
  stitchTiles: 'stitchTiles',
  stopColor: 'stop-color',
  stopOpacity: 'stop-opacity',
  strikethroughPosition: 'strikethrough-position',
  strikethroughThickness: 'strikethrough-thickness',
  string: 0,
  stroke: 0,
  strokeDasharray: 'stroke-dasharray',
  strokeDashoffset: 'stroke-dashoffset',
  strokeLinecap: 'stroke-linecap',
  strokeLinejoin: 'stroke-linejoin',
  strokeMiterlimit: 'stroke-miterlimit',
  strokeOpacity: 'stroke-opacity',
  strokeWidth: 'stroke-width',
  surfaceScale: 'surfaceScale',
  systemLanguage: 'systemLanguage',
  tableValues: 'tableValues',
  targetX: 'targetX',
  targetY: 'targetY',
  textAnchor: 'text-anchor',
  textDecoration: 'text-decoration',
  textRendering: 'text-rendering',
  textLength: 'textLength',
  to: 0,
  transform: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 'underline-position',
  underlineThickness: 'underline-thickness',
  unicode: 0,
  unicodeBidi: 'unicode-bidi',
  unicodeRange: 'unicode-range',
  unitsPerEm: 'units-per-em',
  vAlphabetic: 'v-alphabetic',
  vHanging: 'v-hanging',
  vIdeographic: 'v-ideographic',
  vMathematical: 'v-mathematical',
  values: 0,
  vectorEffect: 'vector-effect',
  version: 0,
  vertAdvY: 'vert-adv-y',
  vertOriginX: 'vert-origin-x',
  vertOriginY: 'vert-origin-y',
  viewBox: 'viewBox',
  viewTarget: 'viewTarget',
  visibility: 0,
  widths: 0,
  wordSpacing: 'word-spacing',
  writingMode: 'writing-mode',
  x: 0,
  xHeight: 'x-height',
  x1: 0,
  x2: 0,
  xChannelSelector: 'xChannelSelector',
  xlinkActuate: 'xlink:actuate',
  xlinkArcrole: 'xlink:arcrole',
  xlinkHref: 'xlink:href',
  xlinkRole: 'xlink:role',
  xlinkShow: 'xlink:show',
  xlinkTitle: 'xlink:title',
  xlinkType: 'xlink:type',
  xmlBase: 'xml:base',
  xmlns: 0,
  xmlnsXlink: 'xmlns:xlink',
  xmlLang: 'xml:lang',
  xmlSpace: 'xml:space',
  y: 0,
  y1: 0,
  y2: 0,
  yChannelSelector: 'yChannelSelector',
  z: 0,
  zoomAndPan: 'zoomAndPan'
};

var SVGDOMPropertyConfig = {
  Properties: {},
  DOMAttributeNamespaces: {
    xlinkActuate: NS.xlink,
    xlinkArcrole: NS.xlink,
    xlinkHref: NS.xlink,
    xlinkRole: NS.xlink,
    xlinkShow: NS.xlink,
    xlinkTitle: NS.xlink,
    xlinkType: NS.xlink,
    xmlBase: NS.xml,
    xmlLang: NS.xml,
    xmlSpace: NS.xml
  },
  DOMAttributeNames: {}
};

Object.keys(ATTRS).forEach(function (key) {
  SVGDOMPropertyConfig.Properties[key] = 0;
  if (ATTRS[key]) {
    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
  }
});

module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(41);
var ExecutionEnvironment = __webpack_require__(12);
var ReactDOMComponentTree = __webpack_require__(8);
var ReactInputSelection = __webpack_require__(116);
var SyntheticEvent = __webpack_require__(19);

var getActiveElement = __webpack_require__(99);
var isTextInputElement = __webpack_require__(126);
var shallowEqual = __webpack_require__(62);

var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;

var eventTypes = {
  select: {
    phasedRegistrationNames: {
      bubbled: 'onSelect',
      captured: 'onSelectCapture'
    },
    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
  }
};

var activeElement = null;
var activeElementInst = null;
var lastSelection = null;
var mouseDown = false;

// Track whether a listener exists for this plugin. If none exist, we do
// not extract events. See #3639.
var hasListener = false;

/**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getSelection(node) {
  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
    return {
      start: node.selectionStart,
      end: node.selectionEnd
    };
  } else if (window.getSelection) {
    var selection = window.getSelection();
    return {
      anchorNode: selection.anchorNode,
      anchorOffset: selection.anchorOffset,
      focusNode: selection.focusNode,
      focusOffset: selection.focusOffset
    };
  } else if (document.selection) {
    var range = document.selection.createRange();
    return {
      parentElement: range.parentElement(),
      text: range.text,
      top: range.boundingTop,
      left: range.boundingLeft
    };
  }
}

/**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @return {?SyntheticEvent}
 */
function constructSelectEvent(nativeEvent, nativeEventTarget) {
  // Ensure we have the right element, and that the user is not dragging a
  // selection (this matches native `select` event behavior). In HTML5, select
  // fires only on input and textarea thus if there's no focused element we
  // won't dispatch.
  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
    return null;
  }

  // Only fire when selection has actually changed.
  var currentSelection = getSelection(activeElement);
  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
    lastSelection = currentSelection;

    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);

    syntheticEvent.type = 'select';
    syntheticEvent.target = activeElement;

    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);

    return syntheticEvent;
  }

  return null;
}

/**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */
var SelectEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (!hasListener) {
      return null;
    }

    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    switch (topLevelType) {
      // Track the input node that has focus.
      case 'topFocus':
        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
          activeElement = targetNode;
          activeElementInst = targetInst;
          lastSelection = null;
        }
        break;
      case 'topBlur':
        activeElement = null;
        activeElementInst = null;
        lastSelection = null;
        break;
      // Don't fire the event while the user is dragging. This matches the
      // semantics of the native select event.
      case 'topMouseDown':
        mouseDown = true;
        break;
      case 'topContextMenu':
      case 'topMouseUp':
        mouseDown = false;
        return constructSelectEvent(nativeEvent, nativeEventTarget);
      // Chrome and IE fire non-standard event when selection is changed (and
      // sometimes when it hasn't). IE's event fires out of order with respect
      // to key and input events on deletion, so we discard it.
      //
      // Firefox doesn't support selectionchange, so check selection status
      // after each key entry. The selection changes after keydown and before
      // keyup, but we check on keydown as well in the case of holding down a
      // key, when multiple keydown events are fired but only one keyup is.
      // This is also our approach for IE handling, for the reason above.
      case 'topSelectionChange':
        if (skipSelectionChangeEvent) {
          break;
        }
      // falls through
      case 'topKeyDown':
      case 'topKeyUp':
        return constructSelectEvent(nativeEvent, nativeEventTarget);
    }

    return null;
  },

  didPutListener: function (inst, registrationName, listener) {
    if (registrationName === 'onSelect') {
      hasListener = true;
    }
  }
};

module.exports = SelectEventPlugin;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(4);

var EventListener = __webpack_require__(97);
var EventPropagators = __webpack_require__(41);
var ReactDOMComponentTree = __webpack_require__(8);
var SyntheticAnimationEvent = __webpack_require__(275);
var SyntheticClipboardEvent = __webpack_require__(276);
var SyntheticEvent = __webpack_require__(19);
var SyntheticFocusEvent = __webpack_require__(279);
var SyntheticKeyboardEvent = __webpack_require__(281);
var SyntheticMouseEvent = __webpack_require__(50);
var SyntheticDragEvent = __webpack_require__(278);
var SyntheticTouchEvent = __webpack_require__(282);
var SyntheticTransitionEvent = __webpack_require__(283);
var SyntheticUIEvent = __webpack_require__(43);
var SyntheticWheelEvent = __webpack_require__(284);

var emptyFunction = __webpack_require__(13);
var getEventCharCode = __webpack_require__(77);
var invariant = __webpack_require__(1);

/**
 * Turns
 * ['abort', ...]
 * into
 * eventTypes = {
 *   'abort': {
 *     phasedRegistrationNames: {
 *       bubbled: 'onAbort',
 *       captured: 'onAbortCapture',
 *     },
 *     dependencies: ['topAbort'],
 *   },
 *   ...
 * };
 * topLevelEventsToDispatchConfig = {
 *   'topAbort': { sameConfig }
 * };
 */
var eventTypes = {};
var topLevelEventsToDispatchConfig = {};
['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
  var onEvent = 'on' + capitalizedEvent;
  var topEvent = 'top' + capitalizedEvent;

  var type = {
    phasedRegistrationNames: {
      bubbled: onEvent,
      captured: onEvent + 'Capture'
    },
    dependencies: [topEvent]
  };
  eventTypes[event] = type;
  topLevelEventsToDispatchConfig[topEvent] = type;
});

var onClickListeners = {};

function getDictionaryKey(inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
}

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

var SimpleEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
    if (!dispatchConfig) {
      return null;
    }
    var EventConstructor;
    switch (topLevelType) {
      case 'topAbort':
      case 'topCanPlay':
      case 'topCanPlayThrough':
      case 'topDurationChange':
      case 'topEmptied':
      case 'topEncrypted':
      case 'topEnded':
      case 'topError':
      case 'topInput':
      case 'topInvalid':
      case 'topLoad':
      case 'topLoadedData':
      case 'topLoadedMetadata':
      case 'topLoadStart':
      case 'topPause':
      case 'topPlay':
      case 'topPlaying':
      case 'topProgress':
      case 'topRateChange':
      case 'topReset':
      case 'topSeeked':
      case 'topSeeking':
      case 'topStalled':
      case 'topSubmit':
      case 'topSuspend':
      case 'topTimeUpdate':
      case 'topVolumeChange':
      case 'topWaiting':
        // HTML Events
        // @see http://www.w3.org/TR/html5/index.html#events-0
        EventConstructor = SyntheticEvent;
        break;
      case 'topKeyPress':
        // Firefox creates a keypress event for function keys too. This removes
        // the unwanted keypress events. Enter is however both printable and
        // non-printable. One would expect Tab to be as well (but it isn't).
        if (getEventCharCode(nativeEvent) === 0) {
          return null;
        }
      /* falls through */
      case 'topKeyDown':
      case 'topKeyUp':
        EventConstructor = SyntheticKeyboardEvent;
        break;
      case 'topBlur':
      case 'topFocus':
        EventConstructor = SyntheticFocusEvent;
        break;
      case 'topClick':
        // Firefox creates a click event on right mouse clicks. This removes the
        // unwanted click events.
        if (nativeEvent.button === 2) {
          return null;
        }
      /* falls through */
      case 'topDoubleClick':
      case 'topMouseDown':
      case 'topMouseMove':
      case 'topMouseUp':
      // TODO: Disabled elements should not respond to mouse events
      /* falls through */
      case 'topMouseOut':
      case 'topMouseOver':
      case 'topContextMenu':
        EventConstructor = SyntheticMouseEvent;
        break;
      case 'topDrag':
      case 'topDragEnd':
      case 'topDragEnter':
      case 'topDragExit':
      case 'topDragLeave':
      case 'topDragOver':
      case 'topDragStart':
      case 'topDrop':
        EventConstructor = SyntheticDragEvent;
        break;
      case 'topTouchCancel':
      case 'topTouchEnd':
      case 'topTouchMove':
      case 'topTouchStart':
        EventConstructor = SyntheticTouchEvent;
        break;
      case 'topAnimationEnd':
      case 'topAnimationIteration':
      case 'topAnimationStart':
        EventConstructor = SyntheticAnimationEvent;
        break;
      case 'topTransitionEnd':
        EventConstructor = SyntheticTransitionEvent;
        break;
      case 'topScroll':
        EventConstructor = SyntheticUIEvent;
        break;
      case 'topWheel':
        EventConstructor = SyntheticWheelEvent;
        break;
      case 'topCopy':
      case 'topCut':
      case 'topPaste':
        EventConstructor = SyntheticClipboardEvent;
        break;
    }
    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
    EventPropagators.accumulateTwoPhaseDispatches(event);
    return event;
  },

  didPutListener: function (inst, registrationName, listener) {
    // Mobile Safari does not fire properly bubble click events on
    // non-interactive elements, which means delegated click listeners do not
    // fire. The workaround for this bug involves attaching an empty click
    // listener on the target node.
    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      if (!onClickListeners[key]) {
        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
      }
    }
  },

  willDeleteListener: function (inst, registrationName) {
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      onClickListeners[key].remove();
      delete onClickListeners[key];
    }
  }
};

module.exports = SimpleEventPlugin;

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(19);

/**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */
var AnimationEventInterface = {
  animationName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);

module.exports = SyntheticAnimationEvent;

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(19);

/**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */
var ClipboardEventInterface = {
  clipboardData: function (event) {
    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);

module.exports = SyntheticClipboardEvent;

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(19);

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */
var CompositionEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);

module.exports = SyntheticCompositionEvent;

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticMouseEvent = __webpack_require__(50);

/**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var DragEventInterface = {
  dataTransfer: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);

module.exports = SyntheticDragEvent;

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(43);

/**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var FocusEventInterface = {
  relatedTarget: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);

module.exports = SyntheticFocusEvent;

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(19);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */
var InputEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);

module.exports = SyntheticInputEvent;

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(43);

var getEventCharCode = __webpack_require__(77);
var getEventKey = __webpack_require__(289);
var getEventModifierState = __webpack_require__(78);

/**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var KeyboardEventInterface = {
  key: getEventKey,
  location: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  repeat: null,
  locale: null,
  getModifierState: getEventModifierState,
  // Legacy Interface
  charCode: function (event) {
    // `charCode` is the result of a KeyPress event and represents the value of
    // the actual printable character.

    // KeyPress is deprecated, but its replacement is not yet final and not
    // implemented in any major browser. Only KeyPress has charCode.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    return 0;
  },
  keyCode: function (event) {
    // `keyCode` is the result of a KeyDown/Up event and represents the value of
    // physical keyboard key.

    // The actual meaning of the value depends on the users' keyboard layout
    // which cannot be detected. Assuming that it is a US keyboard layout
    // provides a surprisingly accurate mapping for US and European users.
    // Due to this, it is left to the user to implement at this time.
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  },
  which: function (event) {
    // `which` is an alias for either `keyCode` or `charCode` depending on the
    // type of the event.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);

module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(43);

var getEventModifierState = __webpack_require__(78);

/**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */
var TouchEventInterface = {
  touches: null,
  targetTouches: null,
  changedTouches: null,
  altKey: null,
  metaKey: null,
  ctrlKey: null,
  shiftKey: null,
  getModifierState: getEventModifierState
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);

module.exports = SyntheticTouchEvent;

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(19);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */
var TransitionEventInterface = {
  propertyName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);

module.exports = SyntheticTransitionEvent;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticMouseEvent = __webpack_require__(50);

/**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var WheelEventInterface = {
  deltaX: function (event) {
    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
  },
  deltaY: function (event) {
    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
    'wheelDelta' in event ? -event.wheelDelta : 0;
  },
  deltaZ: null,

  // Browsers without "deltaMode" is reporting in raw wheel delta where one
  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
  deltaMode: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticMouseEvent}
 */
function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);

module.exports = SyntheticWheelEvent;

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var MOD = 65521;

// adler32 is not cryptographically strong, and is only used to sanity check that
// markup generated on the server matches the markup generated on the client.
// This implementation (a modified version of the SheetJS version) has been optimized
// for our use case, at the expense of conforming to the adler32 specification
// for non-ascii inputs.
function adler32(data) {
  var a = 1;
  var b = 0;
  var i = 0;
  var l = data.length;
  var m = l & ~0x3;
  while (i < m) {
    var n = Math.min(i + 4096, m);
    for (; i < n; i += 4) {
      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
    }
    a %= MOD;
    b %= MOD;
  }
  for (; i < l; i++) {
    b += a += data.charCodeAt(i);
  }
  a %= MOD;
  b %= MOD;
  return a | b << 16;
}

module.exports = adler32;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var CSSProperty = __webpack_require__(108);
var warning = __webpack_require__(3);

var isUnitlessNumber = CSSProperty.isUnitlessNumber;
var styleWarnings = {};

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @param {ReactDOMComponent} component
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value, component, isCustomProperty) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  var isNonNumeric = isNaN(value);
  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
    return '' + value; // cast to string
  }

  if (typeof value === 'string') {
    if (false) {
      // Allow '0' to pass through without warning. 0 is already special and
      // doesn't require units, so we don't need to warn about it.
      if (component && value !== '0') {
        var owner = component._currentElement._owner;
        var ownerName = owner ? owner.getName() : null;
        if (ownerName && !styleWarnings[ownerName]) {
          styleWarnings[ownerName] = {};
        }
        var warned = false;
        if (ownerName) {
          var warnings = styleWarnings[ownerName];
          warned = warnings[name];
          if (!warned) {
            warnings[name] = true;
          }
        }
        if (!warned) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
        }
      }
    }
    value = value.trim();
  }
  return value + 'px';
}

module.exports = dangerousStyleValue;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(4);

var ReactCurrentOwner = __webpack_require__(20);
var ReactDOMComponentTree = __webpack_require__(8);
var ReactInstanceMap = __webpack_require__(42);

var getHostComponentFromComposite = __webpack_require__(122);
var invariant = __webpack_require__(1);
var warning = __webpack_require__(3);

/**
 * Returns the DOM node rendered by this element.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
 *
 * @param {ReactComponent|DOMElement} componentOrElement
 * @return {?DOMElement} The root node of this element.
 */
function findDOMNode(componentOrElement) {
  if (false) {
    var owner = ReactCurrentOwner.current;
    if (owner !== null) {
      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
      owner._warnedAboutRefsInRender = true;
    }
  }
  if (componentOrElement == null) {
    return null;
  }
  if (componentOrElement.nodeType === 1) {
    return componentOrElement;
  }

  var inst = ReactInstanceMap.get(componentOrElement);
  if (inst) {
    inst = getHostComponentFromComposite(inst);
    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
  }

  if (typeof componentOrElement.render === 'function') {
     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
  } else {
     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
  }
}

module.exports = findDOMNode;

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var KeyEscapeUtils = __webpack_require__(71);
var traverseAllChildren = __webpack_require__(128);
var warning = __webpack_require__(3);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && __webpack_require__.i({"NODE_ENV":"production","PUBLIC_URL":""}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(138);
}

/**
 * @param {function} traverseContext Context passed through traversal.
 * @param {?ReactComponent} child React child component.
 * @param {!string} name String name of key path to child.
 * @param {number=} selfDebugID Optional debugID of the current internal instance.
 */
function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
  // We found a component instance.
  if (traverseContext && typeof traverseContext === 'object') {
    var result = traverseContext;
    var keyUnique = result[name] === undefined;
    if (false) {
      if (!ReactComponentTreeHook) {
        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
      }
      if (!keyUnique) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
      }
    }
    if (keyUnique && child != null) {
      result[name] = child;
    }
  }
}

/**
 * Flattens children that are typically specified as `props.children`. Any null
 * children will not be included in the resulting object.
 * @return {!object} flattened children keyed by name.
 */
function flattenChildren(children, selfDebugID) {
  if (children == null) {
    return children;
  }
  var result = {};

  if (false) {
    traverseAllChildren(children, function (traverseContext, child, name) {
      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
    }, result);
  } else {
    traverseAllChildren(children, flattenSingleChildIntoContext, result);
  }
  return result;
}

module.exports = flattenChildren;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)))

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var getEventCharCode = __webpack_require__(77);

/**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var normalizeKey = {
  Esc: 'Escape',
  Spacebar: ' ',
  Left: 'ArrowLeft',
  Up: 'ArrowUp',
  Right: 'ArrowRight',
  Down: 'ArrowDown',
  Del: 'Delete',
  Win: 'OS',
  Menu: 'ContextMenu',
  Apps: 'ContextMenu',
  Scroll: 'ScrollLock',
  MozPrintableKey: 'Unidentified'
};

/**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var translateToKey = {
  8: 'Backspace',
  9: 'Tab',
  12: 'Clear',
  13: 'Enter',
  16: 'Shift',
  17: 'Control',
  18: 'Alt',
  19: 'Pause',
  20: 'CapsLock',
  27: 'Escape',
  32: ' ',
  33: 'PageUp',
  34: 'PageDown',
  35: 'End',
  36: 'Home',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown',
  45: 'Insert',
  46: 'Delete',
  112: 'F1',
  113: 'F2',
  114: 'F3',
  115: 'F4',
  116: 'F5',
  117: 'F6',
  118: 'F7',
  119: 'F8',
  120: 'F9',
  121: 'F10',
  122: 'F11',
  123: 'F12',
  144: 'NumLock',
  145: 'ScrollLock',
  224: 'Meta'
};

/**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */
function getEventKey(nativeEvent) {
  if (nativeEvent.key) {
    // Normalize inconsistent values reported by browsers due to
    // implementations of a working draft specification.

    // FireFox implements `key` but returns `MozPrintableKey` for all
    // printable characters (normalized to `Unidentified`), ignore it.
    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
    if (key !== 'Unidentified') {
      return key;
    }
  }

  // Browser does not implement `key`, polyfill as much of it as we can.
  if (nativeEvent.type === 'keypress') {
    var charCode = getEventCharCode(nativeEvent);

    // The enter-key is technically both printable and non-printable and can
    // thus be captured by `keypress`, no other non-printable key should.
    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
  }
  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
    // While user keyboard layout determines the actual meaning of each
    // `keyCode` value, almost all function keys have a universal value.
    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
  }
  return '';
}

module.exports = getEventKey;

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */

function getLeafNode(node) {
  while (node && node.firstChild) {
    node = node.firstChild;
  }
  return node;
}

/**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */
function getSiblingNode(node) {
  while (node) {
    if (node.nextSibling) {
      return node.nextSibling;
    }
    node = node.parentNode;
  }
}

/**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */
function getNodeForCharacterOffset(root, offset) {
  var node = getLeafNode(root);
  var nodeStart = 0;
  var nodeEnd = 0;

  while (node) {
    if (node.nodeType === 3) {
      nodeEnd = nodeStart + node.textContent.length;

      if (nodeStart <= offset && nodeEnd >= offset) {
        return {
          node: node,
          offset: offset - nodeStart
        };
      }

      nodeStart = nodeEnd;
    }

    node = getLeafNode(getSiblingNode(node));
  }
}

module.exports = getNodeForCharacterOffset;

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(12);

/**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};

  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  prefixes['ms' + styleProp] = 'MS' + eventName;
  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();

  return prefixes;
}

/**
 * A list of event names to a configurable list of vendor prefixes.
 */
var vendorPrefixes = {
  animationend: makePrefixMap('Animation', 'AnimationEnd'),
  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
  animationstart: makePrefixMap('Animation', 'AnimationStart'),
  transitionend: makePrefixMap('Transition', 'TransitionEnd')
};

/**
 * Event names that have already been detected and prefixed (if applicable).
 */
var prefixedEventNames = {};

/**
 * Element to check for prefixes on.
 */
var style = {};

/**
 * Bootstrap if a DOM exists.
 */
if (ExecutionEnvironment.canUseDOM) {
  style = document.createElement('div').style;

  // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are usable, and if not remove them from the map.
  if (!('AnimationEvent' in window)) {
    delete vendorPrefixes.animationend.animation;
    delete vendorPrefixes.animationiteration.animation;
    delete vendorPrefixes.animationstart.animation;
  }

  // Same as above
  if (!('TransitionEvent' in window)) {
    delete vendorPrefixes.transitionend.transition;
  }
}

/**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  } else if (!vendorPrefixes[eventName]) {
    return eventName;
  }

  var prefixMap = vendorPrefixes[eventName];

  for (var styleProp in prefixMap) {
    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
      return prefixedEventNames[eventName] = prefixMap[styleProp];
    }
  }

  return '';
}

module.exports = getVendorPrefixedEventName;

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var escapeTextContentForBrowser = __webpack_require__(52);

/**
 * Escapes attribute value to prevent scripting attacks.
 *
 * @param {*} value Value to escape.
 * @return {string} An escaped string.
 */
function quoteAttributeValueForBrowser(value) {
  return '"' + escapeTextContentForBrowser(value) + '"';
}

module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactMount = __webpack_require__(117);

module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _mapToZero = __webpack_require__(83);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(54);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(85);

var _stepper4 = _interopRequireDefault(_stepper3);

var _performanceNow = __webpack_require__(66);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(60);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(84);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(57);

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

var Motion = (function (_React$Component) {
  _inherits(Motion, _React$Component);

  _createClass(Motion, null, [{
    key: 'propTypes',
    value: {
      // TOOD: warn against putting a config in here
      defaultStyle: _propTypes2['default'].objectOf(_propTypes2['default'].number),
      style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired,
      children: _propTypes2['default'].func.isRequired,
      onRest: _propTypes2['default'].func
    },
    enumerable: true
  }]);

  function Motion(props) {
    var _this = this;

    _classCallCheck(this, Motion);

    _React$Component.call(this, props);
    this.wasAnimating = false;
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyle = null;

    this.clearUnreadPropStyle = function (destStyle) {
      var dirty = false;
      var _state = _this.state;
      var currentStyle = _state.currentStyle;
      var currentVelocity = _state.currentVelocity;
      var lastIdealStyle = _state.lastIdealStyle;
      var lastIdealVelocity = _state.lastIdealVelocity;

      for (var key in destStyle) {
        if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
          continue;
        }

        var styleValue = destStyle[key];
        if (typeof styleValue === 'number') {
          if (!dirty) {
            dirty = true;
            currentStyle = _extends({}, currentStyle);
            currentVelocity = _extends({}, currentVelocity);
            lastIdealStyle = _extends({}, lastIdealStyle);
            lastIdealVelocity = _extends({}, lastIdealVelocity);
          }

          currentStyle[key] = styleValue;
          currentVelocity[key] = 0;
          lastIdealStyle[key] = styleValue;
          lastIdealVelocity[key] = 0;
        }
      }

      if (dirty) {
        _this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
      }
    };

    this.startAnimationIfNecessary = function () {
      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        // check if we need to animate in the first place
        var propsStyle = _this.props.style;
        if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
          if (_this.wasAnimating && _this.props.onRest) {
            _this.props.onRest();
          }

          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.wasAnimating = false;
          _this.accumulatedTime = 0;
          return;
        }

        _this.wasAnimating = true;

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var newLastIdealStyle = {};
        var newLastIdealVelocity = {};
        var newCurrentStyle = {};
        var newCurrentVelocity = {};

        for (var key in propsStyle) {
          if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
            continue;
          }

          var styleValue = propsStyle[key];
          if (typeof styleValue === 'number') {
            newCurrentStyle[key] = styleValue;
            newCurrentVelocity[key] = 0;
            newLastIdealStyle[key] = styleValue;
            newLastIdealVelocity[key] = 0;
          } else {
            var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
            var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
            for (var i = 0; i < framesToCatchUp; i++) {
              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              newLastIdealStyleValue = _stepper[0];
              newLastIdealVelocityValue = _stepper[1];
            }

            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

            var nextIdealX = _stepper2[0];
            var nextIdealV = _stepper2[1];

            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
            newLastIdealStyle[key] = newLastIdealStyleValue;
            newLastIdealVelocity[key] = newLastIdealVelocityValue;
          }
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyle: newCurrentStyle,
          currentVelocity: newCurrentVelocity,
          lastIdealStyle: newLastIdealStyle,
          lastIdealVelocity: newLastIdealVelocity
        });

        _this.unreadPropStyle = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  Motion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyle = _props.defaultStyle;
    var style = _props.style;

    var currentStyle = defaultStyle || _stripStyle2['default'](style);
    var currentVelocity = _mapToZero2['default'](currentStyle);
    return {
      currentStyle: currentStyle,
      currentVelocity: currentVelocity,
      lastIdealStyle: currentStyle,
      lastIdealVelocity: currentVelocity
    };
  };

  // it's possible that currentStyle's value is stale: if props is immediately
  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
  // at 0 (didn't have time to tick and interpolate even once). If we naively
  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
  // In reality currentStyle should be 400

  Motion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  Motion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyle != null) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyle);
    }

    this.unreadPropStyle = props.style;
    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  Motion.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  Motion.prototype.render = function render() {
    var renderedChildren = this.props.children(this.state.currentStyle);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return Motion;
})(_react2['default'].Component);

exports['default'] = Motion;
module.exports = exports['default'];

// after checking for unreadPropStyle != null, we manually go set the
// non-interpolating values (those that are a number, without a spring
// config)

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _mapToZero = __webpack_require__(83);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(54);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(85);

var _stepper4 = _interopRequireDefault(_stepper3);

var _performanceNow = __webpack_require__(66);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(60);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(84);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(57);

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
  for (var i = 0; i < currentStyles.length; i++) {
    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
      return false;
    }
  }
  return true;
}

var StaggeredMotion = (function (_React$Component) {
  _inherits(StaggeredMotion, _React$Component);

  _createClass(StaggeredMotion, null, [{
    key: 'propTypes',
    value: {
      // TOOD: warn against putting a config in here
      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].number)),
      styles: _propTypes2['default'].func.isRequired,
      children: _propTypes2['default'].func.isRequired
    },
    enumerable: true
  }]);

  function StaggeredMotion(props) {
    var _this = this;

    _classCallCheck(this, StaggeredMotion);

    _React$Component.call(this, props);
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyles = null;

    this.clearUnreadPropStyle = function (unreadPropStyles) {
      var _state = _this.state;
      var currentStyles = _state.currentStyles;
      var currentVelocities = _state.currentVelocities;
      var lastIdealStyles = _state.lastIdealStyles;
      var lastIdealVelocities = _state.lastIdealVelocities;

      var someDirty = false;
      for (var i = 0; i < unreadPropStyles.length; i++) {
        var unreadPropStyle = unreadPropStyles[i];
        var dirty = false;

        for (var key in unreadPropStyle) {
          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
            continue;
          }

          var styleValue = unreadPropStyle[key];
          if (typeof styleValue === 'number') {
            if (!dirty) {
              dirty = true;
              someDirty = true;
              currentStyles[i] = _extends({}, currentStyles[i]);
              currentVelocities[i] = _extends({}, currentVelocities[i]);
              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
            }
            currentStyles[i][key] = styleValue;
            currentVelocities[i][key] = 0;
            lastIdealStyles[i][key] = styleValue;
            lastIdealVelocities[i][key] = 0;
          }
        }
      }

      if (someDirty) {
        _this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
      }
    };

    this.startAnimationIfNecessary = function () {
      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        var destStyles = _this.props.styles(_this.state.lastIdealStyles);

        // check if we need to animate in the first place
        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.accumulatedTime = 0;
          return;
        }

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var newLastIdealStyles = [];
        var newLastIdealVelocities = [];
        var newCurrentStyles = [];
        var newCurrentVelocities = [];

        for (var i = 0; i < destStyles.length; i++) {
          var destStyle = destStyles[i];
          var newCurrentStyle = {};
          var newCurrentVelocity = {};
          var newLastIdealStyle = {};
          var newLastIdealVelocity = {};

          for (var key in destStyle) {
            if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
              continue;
            }

            var styleValue = destStyle[key];
            if (typeof styleValue === 'number') {
              newCurrentStyle[key] = styleValue;
              newCurrentVelocity[key] = 0;
              newLastIdealStyle[key] = styleValue;
              newLastIdealVelocity[key] = 0;
            } else {
              var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
              var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
              for (var j = 0; j < framesToCatchUp; j++) {
                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

                newLastIdealStyleValue = _stepper[0];
                newLastIdealVelocityValue = _stepper[1];
              }

              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              var nextIdealX = _stepper2[0];
              var nextIdealV = _stepper2[1];

              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
              newLastIdealStyle[key] = newLastIdealStyleValue;
              newLastIdealVelocity[key] = newLastIdealVelocityValue;
            }
          }

          newCurrentStyles[i] = newCurrentStyle;
          newCurrentVelocities[i] = newCurrentVelocity;
          newLastIdealStyles[i] = newLastIdealStyle;
          newLastIdealVelocities[i] = newLastIdealVelocity;
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyles: newCurrentStyles,
          currentVelocities: newCurrentVelocities,
          lastIdealStyles: newLastIdealStyles,
          lastIdealVelocities: newLastIdealVelocities
        });

        _this.unreadPropStyles = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  StaggeredMotion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyles = _props.defaultStyles;
    var styles = _props.styles;

    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
    var currentVelocities = currentStyles.map(function (currentStyle) {
      return _mapToZero2['default'](currentStyle);
    });
    return {
      currentStyles: currentStyles,
      currentVelocities: currentVelocities,
      lastIdealStyles: currentStyles,
      lastIdealVelocities: currentVelocities
    };
  };

  StaggeredMotion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  StaggeredMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyles != null) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyles);
    }

    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  StaggeredMotion.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  StaggeredMotion.prototype.render = function render() {
    var renderedChildren = this.props.children(this.state.currentStyles);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return StaggeredMotion;
})(_react2['default'].Component);

exports['default'] = StaggeredMotion;
module.exports = exports['default'];

// it's possible that currentStyle's value is stale: if props is immediately
// changed from 0 to 400 to spring(0) again, the async currentStyle is still
// at 0 (didn't have time to tick and interpolate even once). If we naively
// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
// In reality currentStyle should be 400

// after checking for unreadPropStyles != null, we manually go set the
// non-interpolating values (those that are a number, without a spring
// config)

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _mapToZero = __webpack_require__(83);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(54);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(85);

var _stepper4 = _interopRequireDefault(_stepper3);

var _mergeDiff = __webpack_require__(298);

var _mergeDiff2 = _interopRequireDefault(_mergeDiff);

var _performanceNow = __webpack_require__(66);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(60);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(84);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(57);

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

// the children function & (potential) styles function asks as param an
// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
// {key: string, data?: any, style: PlainStyle}. However, the way we keep
// internal states doesn't contain such a data structure (check the state and
// TransitionMotionState). So when children function and others ask for such
// data we need to generate them on the fly by combining mergedPropsStyles and
// currentStyles/lastIdealStyles
function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
  // Copy the value to a `const` so that Flow understands that the const won't
  // change and will be non-nullable in the callback below.
  var cUnreadPropStyles = unreadPropStyles;
  if (cUnreadPropStyles == null) {
    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
      return {
        key: mergedPropsStyle.key,
        data: mergedPropsStyle.data,
        style: plainStyles[i]
      };
    });
  }
  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
    for (var j = 0; j < cUnreadPropStyles.length; j++) {
      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
        return {
          key: cUnreadPropStyles[j].key,
          data: cUnreadPropStyles[j].data,
          style: plainStyles[i]
        };
      }
    }
    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
  });
}

function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
  if (mergedPropsStyles.length !== destStyles.length) {
    return false;
  }

  for (var i = 0; i < mergedPropsStyles.length; i++) {
    if (mergedPropsStyles[i].key !== destStyles[i].key) {
      return false;
    }
  }

  // we have the invariant that mergedPropsStyles and
  // currentStyles/currentVelocities/last* are synced in terms of cells, see
  // mergeAndSync comment for more info
  for (var i = 0; i < mergedPropsStyles.length; i++) {
    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
      return false;
    }
  }

  return true;
}

// core key merging logic

// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
// c}, previous current (interpolating) style is {a, b}
// **invariant**: current[i] corresponds to merged[i] in terms of key

// steps:
// turn merged style into {a?, b, c}
//    add c, value of c is destStyles.c
//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
// turn current (interpolating) style from {a, b} into {a?, b, c}
//    maybe remove a
//    certainly add c, value of c is willEnter(c)
// loop over merged and construct new current
// dest doesn't change, that's owner's
function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
    var leavingStyle = willLeave(oldMergedPropsStyle);
    if (leavingStyle == null) {
      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
      return null;
    }
    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
      return null;
    }
    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
  });

  var newCurrentStyles = [];
  var newCurrentVelocities = [];
  var newLastIdealStyles = [];
  var newLastIdealVelocities = [];
  for (var i = 0; i < newMergedPropsStyles.length; i++) {
    var newMergedPropsStyleCell = newMergedPropsStyles[i];
    var foundOldIndex = null;
    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
        foundOldIndex = j;
        break;
      }
    }
    // TODO: key search code
    if (foundOldIndex == null) {
      var plainStyle = willEnter(newMergedPropsStyleCell);
      newCurrentStyles[i] = plainStyle;
      newLastIdealStyles[i] = plainStyle;

      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
      newCurrentVelocities[i] = velocity;
      newLastIdealVelocities[i] = velocity;
    } else {
      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
    }
  }

  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
}

var TransitionMotion = (function (_React$Component) {
  _inherits(TransitionMotion, _React$Component);

  _createClass(TransitionMotion, null, [{
    key: 'propTypes',
    value: {
      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
        key: _propTypes2['default'].string.isRequired,
        data: _propTypes2['default'].any,
        style: _propTypes2['default'].objectOf(_propTypes2['default'].number).isRequired
      })),
      styles: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
        key: _propTypes2['default'].string.isRequired,
        data: _propTypes2['default'].any,
        style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired
      }))]).isRequired,
      children: _propTypes2['default'].func.isRequired,
      willEnter: _propTypes2['default'].func,
      willLeave: _propTypes2['default'].func,
      didLeave: _propTypes2['default'].func
    },
    enumerable: true
  }, {
    key: 'defaultProps',
    value: {
      willEnter: function willEnter(styleThatEntered) {
        return _stripStyle2['default'](styleThatEntered.style);
      },
      // recall: returning null makes the current unmounting TransitionStyle
      // disappear immediately
      willLeave: function willLeave() {
        return null;
      },
      didLeave: function didLeave() {}
    },
    enumerable: true
  }]);

  function TransitionMotion(props) {
    var _this = this;

    _classCallCheck(this, TransitionMotion);

    _React$Component.call(this, props);
    this.unmounting = false;
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyles = null;

    this.clearUnreadPropStyle = function (unreadPropStyles) {
      var _mergeAndSync = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, unreadPropStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);

      var mergedPropsStyles = _mergeAndSync[0];
      var currentStyles = _mergeAndSync[1];
      var currentVelocities = _mergeAndSync[2];
      var lastIdealStyles = _mergeAndSync[3];
      var lastIdealVelocities = _mergeAndSync[4];

      for (var i = 0; i < unreadPropStyles.length; i++) {
        var unreadPropStyle = unreadPropStyles[i].style;
        var dirty = false;

        for (var key in unreadPropStyle) {
          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
            continue;
          }

          var styleValue = unreadPropStyle[key];
          if (typeof styleValue === 'number') {
            if (!dirty) {
              dirty = true;
              currentStyles[i] = _extends({}, currentStyles[i]);
              currentVelocities[i] = _extends({}, currentVelocities[i]);
              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
              mergedPropsStyles[i] = {
                key: mergedPropsStyles[i].key,
                data: mergedPropsStyles[i].data,
                style: _extends({}, mergedPropsStyles[i].style)
              };
            }
            currentStyles[i][key] = styleValue;
            currentVelocities[i][key] = 0;
            lastIdealStyles[i][key] = styleValue;
            lastIdealVelocities[i][key] = 0;
            mergedPropsStyles[i].style[key] = styleValue;
          }
        }
      }

      // unlike the other 2 components, we can't detect staleness and optionally
      // opt out of setState here. each style object's data might contain new
      // stuff we're not/cannot compare
      _this.setState({
        currentStyles: currentStyles,
        currentVelocities: currentVelocities,
        mergedPropsStyles: mergedPropsStyles,
        lastIdealStyles: lastIdealStyles,
        lastIdealVelocities: lastIdealVelocities
      });
    };

    this.startAnimationIfNecessary = function () {
      if (_this.unmounting) {
        return;
      }

      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        // https://github.com/chenglou/react-motion/pull/420
        // > if execution passes the conditional if (this.unmounting), then
        // executes async defaultRaf and after that component unmounts and after
        // that the callback of defaultRaf is called, then setState will be called
        // on unmounted component.
        if (_this.unmounting) {
          return;
        }

        var propStyles = _this.props.styles;
        var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;

        // check if we need to animate in the first place
        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.accumulatedTime = 0;
          return;
        }

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var _mergeAndSync2 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);

        var newMergedPropsStyles = _mergeAndSync2[0];
        var newCurrentStyles = _mergeAndSync2[1];
        var newCurrentVelocities = _mergeAndSync2[2];
        var newLastIdealStyles = _mergeAndSync2[3];
        var newLastIdealVelocities = _mergeAndSync2[4];

        for (var i = 0; i < newMergedPropsStyles.length; i++) {
          var newMergedPropsStyle = newMergedPropsStyles[i].style;
          var newCurrentStyle = {};
          var newCurrentVelocity = {};
          var newLastIdealStyle = {};
          var newLastIdealVelocity = {};

          for (var key in newMergedPropsStyle) {
            if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
              continue;
            }

            var styleValue = newMergedPropsStyle[key];
            if (typeof styleValue === 'number') {
              newCurrentStyle[key] = styleValue;
              newCurrentVelocity[key] = 0;
              newLastIdealStyle[key] = styleValue;
              newLastIdealVelocity[key] = 0;
            } else {
              var newLastIdealStyleValue = newLastIdealStyles[i][key];
              var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
              for (var j = 0; j < framesToCatchUp; j++) {
                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

                newLastIdealStyleValue = _stepper[0];
                newLastIdealVelocityValue = _stepper[1];
              }

              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              var nextIdealX = _stepper2[0];
              var nextIdealV = _stepper2[1];

              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
              newLastIdealStyle[key] = newLastIdealStyleValue;
              newLastIdealVelocity[key] = newLastIdealVelocityValue;
            }
          }

          newLastIdealStyles[i] = newLastIdealStyle;
          newLastIdealVelocities[i] = newLastIdealVelocity;
          newCurrentStyles[i] = newCurrentStyle;
          newCurrentVelocities[i] = newCurrentVelocity;
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyles: newCurrentStyles,
          currentVelocities: newCurrentVelocities,
          lastIdealStyles: newLastIdealStyles,
          lastIdealVelocities: newLastIdealVelocities,
          mergedPropsStyles: newMergedPropsStyles
        });

        _this.unreadPropStyles = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  TransitionMotion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyles = _props.defaultStyles;
    var styles = _props.styles;
    var willEnter = _props.willEnter;
    var willLeave = _props.willLeave;
    var didLeave = _props.didLeave;

    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;

    // this is special. for the first time around, we don't have a comparison
    // between last (no last) and current merged props. we'll compute last so:
    // say default is {a, b} and styles (dest style) is {b, c}, we'll
    // fabricate last as {a, b}
    var oldMergedPropsStyles = undefined;
    if (defaultStyles == null) {
      oldMergedPropsStyles = destStyles;
    } else {
      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
        // TODO: key search code
        for (var i = 0; i < destStyles.length; i++) {
          if (destStyles[i].key === defaultStyleCell.key) {
            return destStyles[i];
          }
        }
        return defaultStyleCell;
      });
    }
    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
      return _stripStyle2['default'](s.style);
    }) : defaultStyles.map(function (s) {
      return _stripStyle2['default'](s.style);
    });
    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
      return _mapToZero2['default'](s.style);
    }) : defaultStyles.map(function (s) {
      return _mapToZero2['default'](s.style);
    });

    var _mergeAndSync3 = mergeAndSync(
    // Because this is an old-style createReactClass component, Flow doesn't
    // understand that the willEnter and willLeave props have default values
    // and will always be present.
    willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
    oldCurrentVelocities);

    var mergedPropsStyles = _mergeAndSync3[0];
    var currentStyles = _mergeAndSync3[1];
    var currentVelocities = _mergeAndSync3[2];
    var lastIdealStyles = _mergeAndSync3[3];
    var lastIdealVelocities = _mergeAndSync3[4];
    // oldLastIdealVelocities really

    return {
      currentStyles: currentStyles,
      currentVelocities: currentVelocities,
      lastIdealStyles: lastIdealStyles,
      lastIdealVelocities: lastIdealVelocities,
      mergedPropsStyles: mergedPropsStyles
    };
  };

  // after checking for unreadPropStyles != null, we manually go set the
  // non-interpolating values (those that are a number, without a spring
  // config)

  TransitionMotion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  TransitionMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyles) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyles);
    }

    var styles = props.styles;
    if (typeof styles === 'function') {
      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
    } else {
      this.unreadPropStyles = styles;
    }

    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  TransitionMotion.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounting = true;
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  TransitionMotion.prototype.render = function render() {
    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
    var renderedChildren = this.props.children(hydratedStyles);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return TransitionMotion;
})(_react2['default'].Component);

exports['default'] = TransitionMotion;
module.exports = exports['default'];

// list of styles, each containing interpolating values. Part of what's passed
// to children function. Notice that this is
// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
// contains the key & data info (so that we only have a single source of truth
// for these, and to save space). Check the comment for `rehydrateStyles` to
// see how we regenerate the entirety of what's passed to children function

// the array that keeps track of currently rendered stuff! Including stuff
// that you've unmounted but that's still animating. This is where it lives

// it's possible that currentStyle's value is stale: if props is immediately
// changed from 0 to 400 to spring(0) again, the async currentStyle is still
// at 0 (didn't have time to tick and interpolate even once). If we naively
// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
// In reality currentStyle should be 400

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// core keys merging algorithm. If previous render's keys are [a, b], and the
// next render's [c, b, d], what's the final merged keys and ordering?

// - c and a must both be before b
// - b before d
// - ordering between a and c ambiguous

// this reduces to merging two partially ordered lists (e.g. lists where not
// every item has a definite ordering, like comparing a and c above). For the
// ambiguous ordering we deterministically choose to place the next render's
// item after the previous'; so c after a

// this is called a topological sorting. Except the existing algorithms don't
// work well with js bc of the amount of allocation, and isn't optimized for our
// current use-case bc the runtime is linear in terms of edges (see wiki for
// meaning), which is huge when two lists have many common elements


exports.__esModule = true;
exports['default'] = mergeDiff;

function mergeDiff(prev, next, onRemove) {
  // bookkeeping for easier access of a key's index below. This is 2 allocations +
  // potentially triggering chrome hash map mode for objs (so it might be faster

  var prevKeyIndex = {};
  for (var i = 0; i < prev.length; i++) {
    prevKeyIndex[prev[i].key] = i;
  }
  var nextKeyIndex = {};
  for (var i = 0; i < next.length; i++) {
    nextKeyIndex[next[i].key] = i;
  }

  // first, an overly elaborate way of merging prev and next, eliminating
  // duplicates (in terms of keys). If there's dupe, keep the item in next).
  // This way of writing it saves allocations
  var ret = [];
  for (var i = 0; i < next.length; i++) {
    ret[i] = next[i];
  }
  for (var i = 0; i < prev.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
      // merge in keys that the user desires to kill
      var fill = onRemove(i, prev[i]);
      if (fill != null) {
        ret.push(fill);
      }
    }
  }

  // now all the items all present. Core sorting logic to have the right order
  return ret.sort(function (a, b) {
    var nextOrderA = nextKeyIndex[a.key];
    var nextOrderB = nextKeyIndex[b.key];
    var prevOrderA = prevKeyIndex[a.key];
    var prevOrderB = prevKeyIndex[b.key];

    if (nextOrderA != null && nextOrderB != null) {
      // both keys in next
      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
    } else if (prevOrderA != null && prevOrderB != null) {
      // both keys in prev
      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
    } else if (nextOrderA != null) {
      // key a in next, key b in prev

      // how to determine the order between a and b? We find a "pivot" (term
      // abuse), a key present in both prev and next, that is sandwiched between
      // a and b. In the context of our above example, if we're comparing a and
      // d, b's (the only) pivot
      for (var i = 0; i < next.length; i++) {
        var pivot = next[i].key;
        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
          continue;
        }

        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
          return -1;
        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
          return 1;
        }
      }
      // pluggable. default to: next bigger than prev
      return 1;
    }
    // prevOrderA, nextOrderB
    for (var i = 0; i < next.length; i++) {
      var pivot = next[i].key;
      if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
        continue;
      }
      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
        return 1;
      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
        return -1;
      }
    }
    // pluggable. default to: next bigger than prev
    return -1;
  });
}

module.exports = exports['default'];
// to loop through and find a key's index each time), but I no longer care

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = reorderKeys;

var hasWarned = false;

function reorderKeys() {
  if (false) {
    if (!hasWarned) {
      hasWarned = true;
      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
    }
  }
}

module.exports = exports['default'];

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = spring;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _presets = __webpack_require__(129);

var _presets2 = _interopRequireDefault(_presets);

var defaultConfig = _extends({}, _presets2['default'].noWobble, {
  precision: 0.01
});

function spring(val, config) {
  return _extends({}, defaultConfig, config, { val: val });
}

module.exports = exports['default'];

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _routerWarning = __webpack_require__(9);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

var _InternalPropTypes = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A mixin that adds the "history" instance variable to components.
 */
var History = {

  contextTypes: {
    history: _InternalPropTypes.history
  },

  componentWillMount: function componentWillMount() {
     false ? (0, _routerWarning2.default)(false, 'the `History` mixin is deprecated, please access `context.router` with your own `contextTypes`. http://tiny.cc/router-historymixin') : void 0;
    this.history = this.context.history;
  }
};

exports.default = History;
module.exports = exports['default'];

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Link = __webpack_require__(130);

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * An <IndexLink> is used to link to an <IndexRoute>.
 */
var IndexLink = _react2.default.createClass({
  displayName: 'IndexLink',
  render: function render() {
    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
  }
});

exports.default = IndexLink;
module.exports = exports['default'];

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _routerWarning = __webpack_require__(9);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

var _invariant = __webpack_require__(10);

var _invariant2 = _interopRequireDefault(_invariant);

var _Redirect = __webpack_require__(131);

var _Redirect2 = _interopRequireDefault(_Redirect);

var _InternalPropTypes = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _React$PropTypes = _react2.default.PropTypes;
var string = _React$PropTypes.string;
var object = _React$PropTypes.object;

/**
 * An <IndexRedirect> is used to redirect from an indexRoute.
 */

var IndexRedirect = _react2.default.createClass({
  displayName: 'IndexRedirect',


  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
      } else {
         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    to: string.isRequired,
    query: object,
    state: object,
    onEnter: _InternalPropTypes.falsy,
    children: _InternalPropTypes.falsy
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
  }
});

exports.default = IndexRedirect;
module.exports = exports['default'];

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _routerWarning = __webpack_require__(9);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

var _invariant = __webpack_require__(10);

var _invariant2 = _interopRequireDefault(_invariant);

var _RouteUtils = __webpack_require__(22);

var _InternalPropTypes = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var func = _react2.default.PropTypes.func;

/**
 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
 * a JSX route config.
 */

var IndexRoute = _react2.default.createClass({
  displayName: 'IndexRoute',


  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
      } else {
         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    path: _InternalPropTypes.falsy,
    component: _InternalPropTypes.component,
    components: _InternalPropTypes.components,
    getComponent: func,
    getComponents: func
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
  }
});

exports.default = IndexRoute;
module.exports = exports['default'];

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _routerWarning = __webpack_require__(9);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _invariant = __webpack_require__(10);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var object = _react2.default.PropTypes.object;

/**
 * The Lifecycle mixin adds the routerWillLeave lifecycle method to a
 * component that may be used to cancel a transition or prompt the user
 * for confirmation.
 *
 * On standard transitions, routerWillLeave receives a single argument: the
 * location we're transitioning to. To cancel the transition, return false.
 * To prompt the user for confirmation, return a prompt message (string).
 *
 * During the beforeunload event (assuming you're using the useBeforeUnload
 * history enhancer), routerWillLeave does not receive a location object
 * because it isn't possible for us to know the location we're transitioning
 * to. In this case routerWillLeave must return a prompt message to prevent
 * the user from closing the window/tab.
 */

var Lifecycle = {

  contextTypes: {
    history: object.isRequired,
    // Nested children receive the route as context, either
    // set by the route component using the RouteContext mixin
    // or by some other ancestor.
    route: object
  },

  propTypes: {
    // Route components receive the route object as a prop.
    route: object
  },

  componentDidMount: function componentDidMount() {
     false ? (0, _routerWarning2.default)(false, 'the `Lifecycle` mixin is deprecated, please use `context.router.setRouteLeaveHook(route, hook)`. http://tiny.cc/router-lifecyclemixin') : void 0;
    !this.routerWillLeave ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin requires you to define a routerWillLeave method') : (0, _invariant2.default)(false) : void 0;

    var route = this.props.route || this.context.route;

    !route ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin must be used on either a) a <Route component> or ' + 'b) a descendant of a <Route component> that uses the RouteContext mixin') : (0, _invariant2.default)(false) : void 0;

    this._unlistenBeforeLeavingRoute = this.context.history.listenBeforeLeavingRoute(route, this.routerWillLeave);
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this._unlistenBeforeLeavingRoute) this._unlistenBeforeLeavingRoute();
  }
};

exports.default = Lifecycle;
module.exports = exports['default'];

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _invariant = __webpack_require__(10);

var _invariant2 = _interopRequireDefault(_invariant);

var _RouteUtils = __webpack_require__(22);

var _InternalPropTypes = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _React$PropTypes = _react2.default.PropTypes;
var string = _React$PropTypes.string;
var func = _React$PropTypes.func;

/**
 * A <Route> is used to declare which components are rendered to the
 * page when the URL matches a given pattern.
 *
 * Routes are arranged in a nested tree structure. When a new URL is
 * requested, the tree is searched depth-first to find a route whose
 * path matches the URL.  When one is found, all routes in the tree
 * that lead to it are considered "active" and their components are
 * rendered into the DOM, nested in the same order as in the tree.
 */

var Route = _react2.default.createClass({
  displayName: 'Route',


  statics: {
    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
  },

  propTypes: {
    path: string,
    component: _InternalPropTypes.component,
    components: _InternalPropTypes.components,
    getComponent: func,
    getComponents: func
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
  }
});

exports.default = Route;
module.exports = exports['default'];

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _routerWarning = __webpack_require__(9);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var object = _react2.default.PropTypes.object;

/**
 * The RouteContext mixin provides a convenient way for route
 * components to set the route in context. This is needed for
 * routes that render elements that want to use the Lifecycle
 * mixin to prevent transitions.
 */

var RouteContext = {

  propTypes: {
    route: object.isRequired
  },

  childContextTypes: {
    route: object.isRequired
  },

  getChildContext: function getChildContext() {
    return {
      route: this.props.route
    };
  },
  componentWillMount: function componentWillMount() {
     false ? (0, _routerWarning2.default)(false, 'The `RouteContext` mixin is deprecated. You can provide `this.props.route` on context with your own `contextTypes`. http://tiny.cc/router-routecontextmixin') : void 0;
  }
};

exports.default = RouteContext;
module.exports = exports['default'];

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createHashHistory = __webpack_require__(102);

var _createHashHistory2 = _interopRequireDefault(_createHashHistory);

var _useQueries = __webpack_require__(47);

var _useQueries2 = _interopRequireDefault(_useQueries);

var _invariant = __webpack_require__(10);

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createTransitionManager = __webpack_require__(88);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _InternalPropTypes = __webpack_require__(25);

var _RouterContext = __webpack_require__(55);

var _RouterContext2 = _interopRequireDefault(_RouterContext);

var _RouteUtils = __webpack_require__(22);

var _RouterUtils = __webpack_require__(132);

var _routerWarning = __webpack_require__(9);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function isDeprecatedHistory(history) {
  return !history || !history.__v2_compatible__;
}

/* istanbul ignore next: sanity check */
function isUnsupportedHistory(history) {
  // v3 histories expose getCurrentLocation, but aren't currently supported.
  return history && history.getCurrentLocation;
}

var _React$PropTypes = _react2.default.PropTypes;
var func = _React$PropTypes.func;
var object = _React$PropTypes.object;

/**
 * A <Router> is a high-level API for automatically setting up
 * a router that renders a <RouterContext> with all the props
 * it needs each time the URL changes.
 */

var Router = _react2.default.createClass({
  displayName: 'Router',


  propTypes: {
    history: object,
    children: _InternalPropTypes.routes,
    routes: _InternalPropTypes.routes, // alias for children
    render: func,
    createElement: func,
    onError: func,
    onUpdate: func,

    // Deprecated:
    parseQueryString: func,
    stringifyQuery: func,

    // PRIVATE: For client-side rehydration of server match.
    matchContext: object
  },

  getDefaultProps: function getDefaultProps() {
    return {
      render: function render(props) {
        return _react2.default.createElement(_RouterContext2.default, props);
      }
    };
  },
  getInitialState: function getInitialState() {
    return {
      location: null,
      routes: null,
      params: null,
      components: null
    };
  },
  handleError: function handleError(error) {
    if (this.props.onError) {
      this.props.onError.call(this, error);
    } else {
      // Throw errors by default so we don't silently swallow them!
      throw error; // This error probably occurred in getChildRoutes or getComponents.
    }
  },
  componentWillMount: function componentWillMount() {
    var _this = this;

    var _props = this.props;
    var parseQueryString = _props.parseQueryString;
    var stringifyQuery = _props.stringifyQuery;

     false ? (0, _routerWarning2.default)(!(parseQueryString || stringifyQuery), '`parseQueryString` and `stringifyQuery` are deprecated. Please create a custom history. http://tiny.cc/router-customquerystring') : void 0;

    var _createRouterObjects = this.createRouterObjects();

    var history = _createRouterObjects.history;
    var transitionManager = _createRouterObjects.transitionManager;
    var router = _createRouterObjects.router;


    this._unlisten = transitionManager.listen(function (error, state) {
      if (error) {
        _this.handleError(error);
      } else {
        _this.setState(state, _this.props.onUpdate);
      }
    });

    this.history = history;
    this.router = router;
  },
  createRouterObjects: function createRouterObjects() {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext;
    }

    var history = this.props.history;
    var _props2 = this.props;
    var routes = _props2.routes;
    var children = _props2.children;


    !!isUnsupportedHistory(history) ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v3.x. ' + 'This version of React Router is not compatible with v3 history ' + 'objects. Please use history v2.x instead.') : (0, _invariant2.default)(false) : void 0;

    if (isDeprecatedHistory(history)) {
      history = this.wrapDeprecatedHistory(history);
    }

    var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
    var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
    var routingHistory = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);

    return { history: routingHistory, transitionManager: transitionManager, router: router };
  },
  wrapDeprecatedHistory: function wrapDeprecatedHistory(history) {
    var _props3 = this.props;
    var parseQueryString = _props3.parseQueryString;
    var stringifyQuery = _props3.stringifyQuery;


    var createHistory = void 0;
    if (history) {
       false ? (0, _routerWarning2.default)(false, 'It appears you have provided a deprecated history object to `<Router/>`, please use a history provided by ' + 'React Router with `import { browserHistory } from \'react-router\'` or `import { hashHistory } from \'react-router\'`. ' + 'If you are using a custom history please create it with `useRouterHistory`, see http://tiny.cc/router-usinghistory for details.') : void 0;
      createHistory = function createHistory() {
        return history;
      };
    } else {
       false ? (0, _routerWarning2.default)(false, '`Router` no longer defaults the history prop to hash history. Please use the `hashHistory` singleton instead. http://tiny.cc/router-defaulthistory') : void 0;
      createHistory = _createHashHistory2.default;
    }

    return (0, _useQueries2.default)(createHistory)({ parseQueryString: parseQueryString, stringifyQuery: stringifyQuery });
  },


  /* istanbul ignore next: sanity check */
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;

     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this._unlisten) this._unlisten();
  },
  render: function render() {
    var _state = this.state;
    var location = _state.location;
    var routes = _state.routes;
    var params = _state.params;
    var components = _state.components;
    var _props4 = this.props;
    var createElement = _props4.createElement;
    var render = _props4.render;

    var props = _objectWithoutProperties(_props4, ['createElement', 'render']);

    if (location == null) return null; // Async match

    // Only forward non-Router-specific props to routing context, as those are
    // the only ones that might be custom routing context props.
    Object.keys(Router.propTypes).forEach(function (propType) {
      return delete props[propType];
    });

    return render(_extends({}, props, {
      history: this.history,
      router: this.router,
      location: location,
      routes: routes,
      params: params,
      components: components,
      createElement: createElement
    }));
  }
});

exports.default = Router;
module.exports = exports['default'];

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _RouterContext = __webpack_require__(55);

var _RouterContext2 = _interopRequireDefault(_RouterContext);

var _routerWarning = __webpack_require__(9);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RoutingContext = _react2.default.createClass({
  displayName: 'RoutingContext',
  componentWillMount: function componentWillMount() {
     false ? (0, _routerWarning2.default)(false, '`RoutingContext` has been renamed to `RouterContext`. Please use `import { RouterContext } from \'react-router\'`. http://tiny.cc/router-routercontext') : void 0;
  },
  render: function render() {
    return _react2.default.createElement(_RouterContext2.default, this.props);
  }
});

exports.default = RoutingContext;
module.exports = exports['default'];

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.runEnterHooks = runEnterHooks;
exports.runChangeHooks = runChangeHooks;
exports.runLeaveHooks = runLeaveHooks;

var _AsyncUtils = __webpack_require__(86);

var _routerWarning = __webpack_require__(9);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createTransitionHook(hook, route, asyncArity) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    hook.apply(route, args);

    if (hook.length < asyncArity) {
      var callback = args[args.length - 1];
      // Assume hook executes synchronously and
      // automatically call the callback.
      callback();
    }
  };
}

function getEnterHooks(routes) {
  return routes.reduce(function (hooks, route) {
    if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3));

    return hooks;
  }, []);
}

function getChangeHooks(routes) {
  return routes.reduce(function (hooks, route) {
    if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4));
    return hooks;
  }, []);
}

function runTransitionHooks(length, iter, callback) {
  if (!length) {
    callback();
    return;
  }

  var redirectInfo = void 0;
  function replace(location, deprecatedPathname, deprecatedQuery) {
    if (deprecatedPathname) {
       false ? (0, _routerWarning2.default)(false, '`replaceState(state, pathname, query) is deprecated; use `replace(location)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
      redirectInfo = {
        pathname: deprecatedPathname,
        query: deprecatedQuery,
        state: location
      };

      return;
    }

    redirectInfo = location;
  }

  (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
    iter(index, replace, function (error) {
      if (error || redirectInfo) {
        done(error, redirectInfo); // No need to continue.
      } else {
        next();
      }
    });
  }, callback);
}

/**
 * Runs all onEnter hooks in the given array of routes in order
 * with onEnter(nextState, replace, callback) and calls
 * callback(error, redirectInfo) when finished. The first hook
 * to use replace short-circuits the loop.
 *
 * If a hook needs to run asynchronously, it may use the callback
 * function. However, doing so will cause the transition to pause,
 * which could lead to a non-responsive UI if the hook is slow.
 */
function runEnterHooks(routes, nextState, callback) {
  var hooks = getEnterHooks(routes);
  return runTransitionHooks(hooks.length, function (index, replace, next) {
    hooks[index](nextState, replace, next);
  }, callback);
}

/**
 * Runs all onChange hooks in the given array of routes in order
 * with onChange(prevState, nextState, replace, callback) and calls
 * callback(error, redirectInfo) when finished. The first hook
 * to use replace short-circuits the loop.
 *
 * If a hook needs to run asynchronously, it may use the callback
 * function. However, doing so will cause the transition to pause,
 * which could lead to a non-responsive UI if the hook is slow.
 */
function runChangeHooks(routes, state, nextState, callback) {
  var hooks = getChangeHooks(routes);
  return runTransitionHooks(hooks.length, function (index, replace, next) {
    hooks[index](state, nextState, replace, next);
  }, callback);
}

/**
 * Runs all onLeave hooks in the given array of routes in order.
 */
function runLeaveHooks(routes, prevState) {
  for (var i = 0, len = routes.length; i < len; ++i) {
    if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
  }
}

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _RouterContext = __webpack_require__(55);

var _RouterContext2 = _interopRequireDefault(_RouterContext);

var _routerWarning = __webpack_require__(9);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  if (false) {
    middlewares.forEach(function (middleware, index) {
      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
    });
  }

  var withContext = middlewares.map(function (middleware) {
    return middleware.renderRouterContext;
  }).filter(Boolean);
  var withComponent = middlewares.map(function (middleware) {
    return middleware.renderRouteComponent;
  }).filter(Boolean);

  var makeCreateElement = function makeCreateElement() {
    var baseCreateElement = arguments.length <= 0 || arguments[0] === undefined ? _react.createElement : arguments[0];
    return function (Component, props) {
      return withComponent.reduceRight(function (previous, renderRouteComponent) {
        return renderRouteComponent(previous, props);
      }, baseCreateElement(Component, props));
    };
  };

  return function (renderProps) {
    return withContext.reduceRight(function (previous, renderRouterContext) {
      return renderRouterContext(previous, renderProps);
    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
      createElement: makeCreateElement(renderProps.createElement)
    })));
  };
};

module.exports = exports['default'];

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createBrowserHistory = __webpack_require__(221);

var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);

var _createRouterHistory = __webpack_require__(134);

var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
module.exports = exports['default'];

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _PatternUtils = __webpack_require__(34);

function routeParamsChanged(route, prevState, nextState) {
  if (!route.path) return false;

  var paramNames = (0, _PatternUtils.getParamNames)(route.path);

  return paramNames.some(function (paramName) {
    return prevState.params[paramName] !== nextState.params[paramName];
  });
}

/**
 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
 * the change from prevState to nextState. We leave routes if either
 * 1) they are not in the next state or 2) they are in the next state
 * but their params have changed (i.e. /users/123 => /users/456).
 *
 * leaveRoutes are ordered starting at the leaf route of the tree
 * we're leaving up to the common parent route. enterRoutes are ordered
 * from the top of the tree we're entering down to the leaf route.
 *
 * changeRoutes are any routes that didn't leave or enter during
 * the transition.
 */
function computeChangedRoutes(prevState, nextState) {
  var prevRoutes = prevState && prevState.routes;
  var nextRoutes = nextState.routes;

  var leaveRoutes = void 0,
      changeRoutes = void 0,
      enterRoutes = void 0;
  if (prevRoutes) {
    (function () {
      var parentIsLeaving = false;
      leaveRoutes = prevRoutes.filter(function (route) {
        if (parentIsLeaving) {
          return true;
        } else {
          var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
          if (isLeaving) parentIsLeaving = true;
          return isLeaving;
        }
      });

      // onLeave hooks start at the leaf route.
      leaveRoutes.reverse();

      enterRoutes = [];
      changeRoutes = [];

      nextRoutes.forEach(function (route) {
        var isNew = prevRoutes.indexOf(route) === -1;
        var paramsChanged = leaveRoutes.indexOf(route) !== -1;

        if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
      });
    })();
  } else {
    leaveRoutes = [];
    changeRoutes = [];
    enterRoutes = nextRoutes;
  }

  return {
    leaveRoutes: leaveRoutes,
    changeRoutes: changeRoutes,
    enterRoutes: enterRoutes
  };
}

exports.default = computeChangedRoutes;
module.exports = exports['default'];

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _AsyncUtils = __webpack_require__(86);

var _makeStateWithLocation = __webpack_require__(135);

var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getComponentsForRoute(nextState, route, callback) {
  if (route.component || route.components) {
    callback(null, route.component || route.components);
    return;
  }

  var getComponent = route.getComponent || route.getComponents;
  if (!getComponent) {
    callback();
    return;
  }

  var location = nextState.location;

  var nextStateWithLocation = (0, _makeStateWithLocation2.default)(nextState, location);

  getComponent.call(route, nextStateWithLocation, callback);
}

/**
 * Asynchronously fetches all components needed for the given router
 * state and calls callback(error, components) when finished.
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getComponents method.
 */
function getComponents(nextState, callback) {
  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
    getComponentsForRoute(nextState, route, callback);
  }, callback);
}

exports.default = getComponents;
module.exports = exports['default'];

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _PatternUtils = __webpack_require__(34);

/**
 * Extracts an object of params the given route cares about from
 * the given params object.
 */
function getRouteParams(route, params) {
  var routeParams = {};

  if (!route.path) return routeParams;

  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
    if (Object.prototype.hasOwnProperty.call(params, p)) {
      routeParams[p] = params[p];
    }
  });

  return routeParams;
}

exports.default = getRouteParams;
module.exports = exports['default'];

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createHashHistory = __webpack_require__(102);

var _createHashHistory2 = _interopRequireDefault(_createHashHistory);

var _createRouterHistory = __webpack_require__(134);

var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
module.exports = exports['default'];

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

exports.default = isActive;

var _PatternUtils = __webpack_require__(34);

function deepEqual(a, b) {
  if (a == b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return deepEqual(item, b[index]);
    });
  }

  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
    for (var p in a) {
      if (!Object.prototype.hasOwnProperty.call(a, p)) {
        continue;
      }

      if (a[p] === undefined) {
        if (b[p] !== undefined) {
          return false;
        }
      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
        return false;
      } else if (!deepEqual(a[p], b[p])) {
        return false;
      }
    }

    return true;
  }

  return String(a) === String(b);
}

/**
 * Returns true if the current pathname matches the supplied one, net of
 * leading and trailing slash normalization. This is sufficient for an
 * indexOnly route match.
 */
function pathIsActive(pathname, currentPathname) {
  // Normalize leading slash for consistency. Leading slash on pathname has
  // already been normalized in isActive. See caveat there.
  if (currentPathname.charAt(0) !== '/') {
    currentPathname = '/' + currentPathname;
  }

  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
  // `/foo` as active, but in this case, we would already have failed the
  // match.
  if (pathname.charAt(pathname.length - 1) !== '/') {
    pathname += '/';
  }
  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
    currentPathname += '/';
  }

  return currentPathname === pathname;
}

/**
 * Returns true if the given pathname matches the active routes and params.
 */
function routeIsActive(pathname, routes, params) {
  var remainingPathname = pathname,
      paramNames = [],
      paramValues = [];

  // for...of would work here but it's probably slower post-transpilation.
  for (var i = 0, len = routes.length; i < len; ++i) {
    var route = routes[i];
    var pattern = route.path || '';

    if (pattern.charAt(0) === '/') {
      remainingPathname = pathname;
      paramNames = [];
      paramValues = [];
    }

    if (remainingPathname !== null && pattern) {
      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }

      if (remainingPathname === '') {
        // We have an exact match on the route. Just check that all the params
        // match.
        // FIXME: This doesn't work on repeated params.
        return paramNames.every(function (paramName, index) {
          return String(paramValues[index]) === String(params[paramName]);
        });
      }
    }
  }

  return false;
}

/**
 * Returns true if all key/value pairs in the given query are
 * currently active.
 */
function queryIsActive(query, activeQuery) {
  if (activeQuery == null) return query == null;

  if (query == null) return true;

  return deepEqual(query, activeQuery);
}

/**
 * Returns true if a <Link> to the given pathname/query combination is
 * currently active.
 */
function isActive(_ref, indexOnly, currentLocation, routes, params) {
  var pathname = _ref.pathname;
  var query = _ref.query;

  if (currentLocation == null) return false;

  // TODO: This is a bit ugly. It keeps around support for treating pathnames
  // without preceding slashes as absolute paths, but possibly also works
  // around the same quirks with basenames as in matchRoutes.
  if (pathname.charAt(0) !== '/') {
    pathname = '/' + pathname;
  }

  if (!pathIsActive(pathname, currentLocation.pathname)) {
    // The path check is necessary and sufficient for indexOnly, but otherwise
    // we still need to check the routes.
    if (indexOnly || !routeIsActive(pathname, routes, params)) {
      return false;
    }
  }

  return queryIsActive(query, currentLocation.query);
}
module.exports = exports['default'];

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Actions = __webpack_require__(30);

var _invariant = __webpack_require__(10);

var _invariant2 = _interopRequireDefault(_invariant);

var _createMemoryHistory = __webpack_require__(133);

var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);

var _createTransitionManager = __webpack_require__(88);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _RouteUtils = __webpack_require__(22);

var _RouterUtils = __webpack_require__(132);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * A high-level API to be used for server-side rendering.
 *
 * This function matches a location to a set of routes and calls
 * callback(error, redirectLocation, renderProps) when finished.
 *
 * Note: You probably don't want to use this in a browser unless you're using
 * server-side rendering with async routes.
 */
function match(_ref, callback) {
  var history = _ref.history;
  var routes = _ref.routes;
  var location = _ref.location;

  var options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);

  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;

  history = history ? history : (0, _createMemoryHistory2.default)(options);
  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));

  var unlisten = void 0;

  if (location) {
    // Allow match({ location: '/the/path', ... })
    location = history.createLocation(location);
  } else {
    // Pick up the location from the history via synchronous history.listen
    // call if needed.
    unlisten = history.listen(function (historyLocation) {
      location = historyLocation;
    });
  }

  var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
  history = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);

  transitionManager.match(location, function (error, redirectLocation, nextState) {
    callback(error, redirectLocation && router.createLocation(redirectLocation, _Actions.REPLACE), nextState && _extends({}, nextState, {
      history: history,
      router: router,
      matchContext: { history: history, transitionManager: transitionManager, router: router }
    }));

    // Defer removing the listener to here to prevent DOM histories from having
    // to unwind DOM event listeners unnecessarily, in case callback renders a
    // <Router> and attaches another history listener.
    if (unlisten) {
      unlisten();
    }
  });
}

exports.default = match;
module.exports = exports['default'];

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

exports.default = matchRoutes;

var _AsyncUtils = __webpack_require__(86);

var _makeStateWithLocation = __webpack_require__(135);

var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);

var _PatternUtils = __webpack_require__(34);

var _routerWarning = __webpack_require__(9);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

var _RouteUtils = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getChildRoutes(route, location, paramNames, paramValues, callback) {
  if (route.childRoutes) {
    return [null, route.childRoutes];
  }
  if (!route.getChildRoutes) {
    return [];
  }

  var sync = true,
      result = void 0;

  var partialNextState = {
    location: location,
    params: createParams(paramNames, paramValues)
  };

  var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);

  route.getChildRoutes(partialNextStateWithLocation, function (error, childRoutes) {
    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
    if (sync) {
      result = [error, childRoutes];
      return;
    }

    callback(error, childRoutes);
  });

  sync = false;
  return result; // Might be undefined.
}

function getIndexRoute(route, location, paramNames, paramValues, callback) {
  if (route.indexRoute) {
    callback(null, route.indexRoute);
  } else if (route.getIndexRoute) {
    var partialNextState = {
      location: location,
      params: createParams(paramNames, paramValues)
    };

    var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);

    route.getIndexRoute(partialNextStateWithLocation, function (error, indexRoute) {
      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
    });
  } else if (route.childRoutes) {
    (function () {
      var pathless = route.childRoutes.filter(function (childRoute) {
        return !childRoute.path;
      });

      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
          if (error || indexRoute) {
            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
            done(error, routes);
          } else {
            next();
          }
        });
      }, function (err, routes) {
        callback(null, routes);
      });
    })();
  } else {
    callback();
  }
}

function assignParams(params, paramNames, paramValues) {
  return paramNames.reduce(function (params, paramName, index) {
    var paramValue = paramValues && paramValues[index];

    if (Array.isArray(params[paramName])) {
      params[paramName].push(paramValue);
    } else if (paramName in params) {
      params[paramName] = [params[paramName], paramValue];
    } else {
      params[paramName] = paramValue;
    }

    return params;
  }, params);
}

function createParams(paramNames, paramValues) {
  return assignParams({}, paramNames, paramValues);
}

function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
  var pattern = route.path || '';

  if (pattern.charAt(0) === '/') {
    remainingPathname = location.pathname;
    paramNames = [];
    paramValues = [];
  }

  // Only try to match the path if the route actually has a pattern, and if
  // we're not just searching for potential nested absolute paths.
  if (remainingPathname !== null && pattern) {
    try {
      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }
    } catch (error) {
      callback(error);
    }

    // By assumption, pattern is non-empty here, which is the prerequisite for
    // actually terminating a match.
    if (remainingPathname === '') {
      var _ret2 = function () {
        var match = {
          routes: [route],
          params: createParams(paramNames, paramValues)
        };

        getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
          if (error) {
            callback(error);
          } else {
            if (Array.isArray(indexRoute)) {
              var _match$routes;

               false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
                return !route.path;
              }), 'Index routes should not have paths') : void 0;
              (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
            } else if (indexRoute) {
               false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
              match.routes.push(indexRoute);
            }

            callback(null, match);
          }
        });

        return {
          v: void 0
        };
      }();

      if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
    }
  }

  if (remainingPathname != null || route.childRoutes) {
    // Either a) this route matched at least some of the path or b)
    // we don't have to load this route's children asynchronously. In
    // either case continue checking for matches in the subtree.
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
      } else if (childRoutes) {
        // Check the child routes to see if any of them match.
        matchRoutes(childRoutes, location, function (error, match) {
          if (error) {
            callback(error);
          } else if (match) {
            // A child route matched! Augment the match and pass it up the stack.
            match.routes.unshift(route);
            callback(null, match);
          } else {
            callback();
          }
        }, remainingPathname, paramNames, paramValues);
      } else {
        callback();
      }
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

/**
 * Asynchronously matches the given location to a set of routes and calls
 * callback(error, state) when finished. The state object will have the
 * following properties:
 *
 * - routes       An array of routes that matched, in hierarchical order
 * - params       An object of URL parameters
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getChildRoutes method.
 */
function matchRoutes(routes, location, callback, remainingPathname) {
  var paramNames = arguments.length <= 4 || arguments[4] === undefined ? [] : arguments[4];
  var paramValues = arguments.length <= 5 || arguments[5] === undefined ? [] : arguments[5];

  if (remainingPathname === undefined) {
    // TODO: This is a little bit ugly, but it works around a quirk in history
    // that strips the leading slash from pathnames when using basenames with
    // trailing slashes.
    if (location.pathname.charAt(0) !== '/') {
      location = _extends({}, location, {
        pathname: '/' + location.pathname
      });
    }
    remainingPathname = location.pathname;
  }

  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
      if (error || match) {
        done(error, match);
      } else {
        next();
      }
    });
  }, callback);
}
module.exports = exports['default'];

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _useQueries = __webpack_require__(47);

var _useQueries2 = _interopRequireDefault(_useQueries);

var _createTransitionManager = __webpack_require__(88);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _routerWarning = __webpack_require__(9);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Returns a new createHistory function that may be used to create
 * history objects that know about routing.
 *
 * Enhances history objects with the following methods:
 *
 * - listen((error, nextState) => {})
 * - listenBeforeLeavingRoute(route, (nextLocation) => {})
 * - match(location, (error, redirectLocation, nextState) => {})
 * - isActive(pathname, query, indexOnly=false)
 */
function useRoutes(createHistory) {
   false ? (0, _routerWarning2.default)(false, '`useRoutes` is deprecated. Please use `createTransitionManager` instead.') : void 0;

  return function () {
    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var routes = _ref.routes;

    var options = _objectWithoutProperties(_ref, ['routes']);

    var history = (0, _useQueries2.default)(createHistory)(options);
    var transitionManager = (0, _createTransitionManager2.default)(history, routes);
    return _extends({}, history, transitionManager);
  };
}

exports.default = useRoutes;
module.exports = exports['default'];

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = withRouter;

var _invariant = __webpack_require__(10);

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoistNonReactStatics = __webpack_require__(224);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _PropTypes = __webpack_require__(87);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function withRouter(WrappedComponent, options) {
  var withRef = options && options.withRef;

  var WithRouter = _react2.default.createClass({
    displayName: 'WithRouter',

    contextTypes: { router: _PropTypes.routerShape },
    propTypes: { router: _PropTypes.routerShape },

    getWrappedInstance: function getWrappedInstance() {
      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;

      return this.wrappedInstance;
    },
    render: function render() {
      var _this = this;

      var router = this.props.router || this.context.router;
      var props = _extends({}, this.props, { router: router });

      if (withRef) {
        props.ref = function (c) {
          _this.wrappedInstance = c;
        };
      }

      return _react2.default.createElement(WrappedComponent, props);
    }
  });

  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
  WithRouter.WrappedComponent = WrappedComponent;

  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
}
module.exports = exports['default'];

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(44);

var invariant = __webpack_require__(1);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var PooledClass = __webpack_require__(323);
var ReactElement = __webpack_require__(36);

var emptyFunction = __webpack_require__(13);
var traverseAllChildren = __webpack_require__(333);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactElement = __webpack_require__(36);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _require = __webpack_require__(36),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(106);

module.exports = factory(isValidElement);

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



module.exports = '15.6.1';

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _require = __webpack_require__(137),
    Component = _require.Component;

var _require2 = __webpack_require__(36),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__(140);
var factory = __webpack_require__(199);

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var nextDebugID = 1;

function getNextDebugID() {
  return nextDebugID++;
}

module.exports = getNextDebugID;

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (false) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */


var _prodInvariant = __webpack_require__(44);

var ReactElement = __webpack_require__(36);

var invariant = __webpack_require__(1);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(44);

var ReactCurrentOwner = __webpack_require__(20);
var REACT_ELEMENT_TYPE = __webpack_require__(139);

var getIteratorFn = __webpack_require__(329);
var invariant = __webpack_require__(1);
var KeyEscapeUtils = __webpack_require__(322);
var warning = __webpack_require__(3);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 335 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/sign_7.05e6afb7.png";

/***/ }),
/* 337 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(143);
module.exports = __webpack_require__(142);


/***/ }),
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		// Test for IE <= 9 as proposed by Browserhacks
		// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
		// Tests for existence of standard globals is to allow style-loader 
		// to operate correctly into non-standard environments
		// @see https://github.com/webpack-contrib/style-loader/issues/177
		return window && document && document.all && !window.atob;
	}),
	getElement = (function(fn) {
		var memo = {};
		return function(selector) {
			if (typeof memo[selector] === "undefined") {
				memo[selector] = fn.call(this, selector);
			}
			return memo[selector]
		};
	})(function (styleTarget) {
		return document.querySelector(styleTarget)
	}),
	singletonElement = null,
	singletonCounter = 0,
	styleElementsInsertedAtTop = [],
	fixUrls = __webpack_require__(335);

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (typeof options.insertInto === "undefined") options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

	var styles = listToStyles(list, options);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list, options) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function insertStyleElement(options, styleElement) {
	var styleTarget = getElement(options.insertInto)
	if (!styleTarget) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}
	var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
	if (options.insertAt === "top") {
		if(!lastStyleElementInsertedAtTop) {
			styleTarget.insertBefore(styleElement, styleTarget.firstChild);
		} else if(lastStyleElementInsertedAtTop.nextSibling) {
			styleTarget.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			styleTarget.appendChild(styleElement);
		}
		styleElementsInsertedAtTop.push(styleElement);
	} else if (options.insertAt === "bottom") {
		styleTarget.appendChild(styleElement);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(styleElement) {
	styleElement.parentNode.removeChild(styleElement);
	var idx = styleElementsInsertedAtTop.indexOf(styleElement);
	if(idx >= 0) {
		styleElementsInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var styleElement = document.createElement("style");
	options.attrs.type = "text/css";

	attachTagAttrs(styleElement, options.attrs);
	insertStyleElement(options, styleElement);
	return styleElement;
}

function createLinkElement(options) {
	var linkElement = document.createElement("link");
	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	attachTagAttrs(linkElement, options.attrs);
	insertStyleElement(options, linkElement);
	return linkElement;
}

function attachTagAttrs(element, attrs) {
	Object.keys(attrs).forEach(function (key) {
		element.setAttribute(key, attrs[key]);
	});
}

function addStyle(obj, options) {
	var styleElement, update, remove, transformResult;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    transformResult = options.transform(obj.css);
	    
	    if (transformResult) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = transformResult;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css. 
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement(options));
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else if(obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function") {
		styleElement = createLinkElement(options);
		update = updateLink.bind(null, styleElement, options);
		remove = function() {
			removeStyleElement(styleElement);
			if(styleElement.href)
				URL.revokeObjectURL(styleElement.href);
		};
	} else {
		styleElement = createStyleElement(options);
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		styleElement.setAttribute("media", media)
	}

	if(styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}

function updateLink(linkElement, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/* If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
	and there is no publicPath defined then lets turn convertToAbsoluteUrls
	on by default.  Otherwise default to the convertToAbsoluteUrls option
	directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls){
		css = fixUrls(css);
	}

	if(sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = linkElement.href;

	linkElement.href = URL.createObjectURL(blob);

	if(oldSrc)
		URL.revokeObjectURL(oldSrc);
}


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.4e464f91.js